// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"iFN5Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Nav", ()=>Nav);
parcelHelpers.export(exports, "MobileNav", ()=>MobileNav);
parcelHelpers.export(exports, "SideNav", ()=>SideNav);
parcelHelpers.export(exports, "SideNavItem", ()=>SideNavItem);
parcelHelpers.export(exports, "SideNavLink", ()=>SideNavLink);
parcelHelpers.export(exports, "OnPageNav", ()=>OnPageNav);
parcelHelpers.export(exports, "MobileOnPageNav", ()=>MobileOnPageNav);
var _jsxRuntime = require("react/jsx-runtime");
var _componentCardView = require("./ComponentCardView");
var _s2 = require("@react-spectrum/s2");
var _searchMenu = require("./SearchMenu");
var _reactAriaComponents = require("react-aria-components");
// eslint-disable-next-line monorepo/no-internal-import
var _noSearchResults = require("@react-spectrum/s2/illustrations/linear/NoSearchResults");
var _noSearchResultsDefault = parcelHelpers.interopDefault(_noSearchResults);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function Nav({ pages, currentPage }) {
    let currentLibrary = currentPage.url.match(/\/(react-aria|s2)\//)?.[1];
    let sections = new Map();
    for (let page of pages){
        let library = page.url.match(/\/(react-aria|s2)\//)?.[1];
        if (library !== currentLibrary) continue;
        let section = page.exports?.section ?? 'Components';
        let sectionPages = sections.get(section) ?? [];
        sectionPages.push(page);
        sections.set(section, sectionPages);
    }
    let [maskSize, setMaskSize] = (0, _react.useState)(0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
        onScroll: (e)=>setMaskSize(Math.min(e.currentTarget.scrollTop, 32)),
        style: {
            maskImage: maskSize > 0 ? `linear-gradient(to bottom, transparent, black ${maskSize}px)` : undefined
        },
        className: " _Pe111 WB111 FD111 KEqCbPc111 _Na111 Pa111 Se111 Re111 NcTxjid111 sk111 spb111",
        children: [
            ...sections
        ].sort((a, b)=>a[0].localeCompare(b[0])).map(([name, pages])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavSection, {
                title: name,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNav, {
                    children: pages.sort((a, b)=>title(a).localeCompare(title(b))).map((page)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavItem, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavLink, {
                                href: page.url,
                                isSelected: page.url === currentPage.url,
                                children: title(page)
                            })
                        }, page.url))
                })
            }, name))
    });
}
function MobileNav({ pages, currentPage }) {
    let [searchFocused, setSearchFocused] = (0, _react.useState)(false);
    let [searchValue, setSearchValue] = (0, _react.useState)('');
    let [selectedSection, setSelectedSection] = (0, _react.useState)(undefined);
    let prevSearchWasEmptyRef = (0, _react.useRef)(true);
    let headerRef = (0, _react.useRef)(null);
    let scrollContainerRef = (0, _react.useRef)(null);
    let tabListRef = (0, _react.useRef)(null);
    let [tabListHeight, setTabListHeight] = (0, _react.useState)(0);
    let getCurrentLibrary = (page)=>{
        if (page.url.includes('react-aria')) return 'react-aria';
        else if (page.url.includes('react-internationalized')) return 'internationalized';
        return 'react-spectrum';
    };
    let [selectedLibrary, setSelectedLibrary] = (0, _react.useState)(getCurrentLibrary(currentPage));
    let getSectionsForLibrary = (0, _react.useCallback)((libraryId)=>{
        let sectionsMap = new Map();
        let filteredPages = pages.filter((page)=>{
            let pageLibrary = 'react-spectrum';
            if (page.url.includes('react-aria')) pageLibrary = 'react-aria';
            else if (page.url.includes('react-internationalized')) pageLibrary = 'internationalized';
            return pageLibrary === libraryId;
        });
        for (let page of filteredPages){
            let section = page.exports?.section ?? 'Components';
            let sectionPages = sectionsMap.get(section) ?? [];
            sectionPages.push(page);
            sectionsMap.set(section, sectionPages);
        }
        return sectionsMap;
    }, [
        pages
    ]);
    let currentLibrarySectionArray = (0, _react.useMemo)(()=>{
        let librarySections = getSectionsForLibrary(selectedLibrary);
        let sectionArray = [
            ...librarySections.keys()
        ];
        // Ensure order matches TagGroup: 'Components' first, then alphabetical
        sectionArray.sort((a, b)=>{
            if (a === 'Components') return -1;
            if (b === 'Components') return 1;
            return a.localeCompare(b);
        });
        return sectionArray;
    }, [
        getSectionsForLibrary,
        selectedLibrary
    ]);
    (0, _react.useEffect)(()=>{
        // Auto-select first section initially or when library changes
        if (currentLibrarySectionArray.length > 0 && !selectedSection) setSelectedSection(currentLibrarySectionArray[0]);
    }, [
        currentLibrarySectionArray,
        selectedSection
    ]);
    // Auto-select first section when switching libraries (if not focused on search field)
    (0, _react.useEffect)(()=>{
        if (currentLibrarySectionArray.length > 0 && !searchFocused) setSelectedSection(currentLibrarySectionArray[0]);
    }, [
        selectedLibrary,
        currentLibrarySectionArray,
        searchFocused
    ]);
    (0, _react.useEffect)(()=>{
        let measure = ()=>{
            if (tabListRef.current) setTabListHeight(tabListRef.current.getBoundingClientRect().height);
        };
        measure();
        window.addEventListener('resize', measure);
        return ()=>window.removeEventListener('resize', measure);
    }, [
        selectedLibrary
    ]);
    let getOrderedLibraries = ()=>{
        let allLibraries = Object.keys((0, _searchMenu.TAB_DEFS)).map((id)=>({
                id,
                label: (0, _searchMenu.TAB_DEFS)[id].label
            }));
        let currentLibId = getCurrentLibrary(currentPage);
        // Move current library to first position
        let currentLibraryIndex = allLibraries.findIndex((lib)=>lib.id === currentLibId);
        if (currentLibraryIndex > 0) {
            let currentLib = allLibraries.splice(currentLibraryIndex, 1)[0];
            allLibraries.unshift(currentLib);
        }
        return allLibraries;
    };
    let libraries = getOrderedLibraries();
    let handleSearchFocus = ()=>{
        setSearchFocused(true);
    };
    let handleSearchBlur = ()=>{
        if (searchValue === '') setSearchFocused(false);
    };
    let handleSearchChange = (value)=>{
        setSearchValue(value);
        if (value === '' && !searchFocused) setSearchFocused(false);
    };
    let filterPages = (pages, searchValue)=>{
        if (!searchValue.trim()) return pages;
        let searchLower = searchValue.toLowerCase();
        return pages.filter((page)=>{
            let pageTitle = title(page).toLowerCase();
            return pageTitle.includes(searchLower);
        });
    };
    let getSectionContent = (sectionName, libraryId, searchValue = '')=>{
        let librarySections = getSectionsForLibrary(libraryId);
        let pages = librarySections.get(sectionName) ?? [];
        let filteredPages = filterPages(pages, searchValue);
        return filteredPages.sort((a, b)=>title(a).localeCompare(title(b))).map((page)=>({
                id: page.url.replace(/^\//, ''),
                name: title(page),
                href: page.url
            }));
    };
    let getAllContent = (libraryId, searchValue = '')=>{
        let librarySections = getSectionsForLibrary(libraryId);
        let allPages = Array.from(librarySections.values()).flat();
        let filteredPages = filterPages(allPages, searchValue);
        return filteredPages.sort((a, b)=>title(a).localeCompare(title(b))).map((page)=>({
                id: page.url.replace(/^\//, ''),
                name: title(page),
                href: page.url
            }));
    };
    let getItemsForSelection = (section, libraryId, searchValue = '')=>{
        if (!section) return [];
        if (section === 'all') return getAllContent(libraryId, searchValue);
        return getSectionContent(section, libraryId, searchValue);
    };
    let getSectionNamesForLibrary = (libraryId)=>{
        let librarySections = getSectionsForLibrary(libraryId);
        let sectionArray = [
            ...librarySections.keys()
        ];
        // Show 'Components' first
        sectionArray.sort((a, b)=>{
            if (a === 'Components') return -1;
            if (b === 'Components') return 1;
            return a.localeCompare(b);
        });
        return sectionArray;
    };
    let currentLibrarySections = getSectionNamesForLibrary(selectedLibrary);
    let tags = (0, _react.useMemo)(()=>{
        let base = currentLibrarySections.map((name)=>({
                id: name,
                name
            }));
        if (searchValue.trim().length > 0) return [
            {
                id: 'all',
                name: 'All'
            },
            ...base
        ];
        return base;
    }, [
        currentLibrarySections,
        searchValue
    ]);
    (0, _react.useEffect)(()=>{
        let baseIds = currentLibrarySections;
        let ids = searchValue.trim().length > 0 ? [
            'all',
            ...baseIds
        ] : baseIds;
        if (!selectedSection || !ids.includes(selectedSection)) setSelectedSection(ids[0]);
    }, [
        currentLibrarySections,
        searchValue,
        selectedSection
    ]);
    // Auto-select All when search starts
    (0, _react.useEffect)(()=>{
        let isEmpty = searchValue.trim().length === 0;
        if (prevSearchWasEmptyRef.current && !isEmpty) setSelectedSection('all');
        prevSearchWasEmptyRef.current = isEmpty;
    }, [
        searchValue
    ]);
    let handleTagSelection = (keys)=>{
        let key = [
            ...keys
        ][0];
        setSelectedSection(key);
    };
    (0, _react.useEffect)(()=>{
        if (scrollContainerRef.current) // Ensure newly selected section starts at the top of the vertical scroll area
        scrollContainerRef.current.scrollTo({
            top: 0,
            behavior: 'auto'
        });
    }, [
        selectedSection,
        selectedLibrary
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: " Ma00Qsc111 Qh111 _oa111",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Tabs), {
            "aria-label": "Libraries",
            density: "compact",
            selectedKey: selectedLibrary,
            onSelectionChange: (key)=>{
                let newLib = key;
                setSelectedLibrary(newLib);
                if (!searchFocused) {
                    let nextSections = getSectionNamesForLibrary(newLib);
                    if (nextSections.length > 0) setSelectedSection(nextSections[0]);
                }
            },
            styles: " Ix111 Hx111 Jx111",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    ref: tabListRef,
                    className: " _Pe111 Wr111 _9d111 g4hn3s111",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TabList), {
                        children: libraries.map((library)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Tab), {
                                id: library.id,
                                children: library.label
                            }, library.id))
                    })
                }),
                libraries.map((library)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.TabPanel), {
                        id: library.id,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                ref: headerRef,
                                className: " _Pe111 _9c111 g4hn3s111",
                                style: {
                                    top: tabListHeight
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SearchField), {
                                        "aria-label": "Search",
                                        value: searchValue,
                                        onChange: handleSearchChange,
                                        onFocus: handleSearchFocus,
                                        onBlur: handleSearchBlur,
                                        styles: " Jx111 Gx111"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TagGroup), {
                                        "aria-label": "Navigation sections",
                                        selectionMode: "single",
                                        selectedKeys: selectedSection ? [
                                            selectedSection
                                        ] : [],
                                        onSelectionChange: handleTagSelection,
                                        styles: " Jx111 Gx111 Ix111 Hx111",
                                        items: tags,
                                        children: (tag)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Tag), {
                                                id: tag.id,
                                                children: tag.name
                                            }, tag.id)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                ref: scrollContainerRef,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componentCardView.ComponentCardView), {
                                    items: getItemsForSelection(selectedSection, library.id, searchValue),
                                    ariaLabel: "Pages",
                                    size: "S",
                                    renderEmptyState: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.IllustratedMessage), {
                                            styles: " JG111 GG111 IG111 HG111",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noSearchResultsDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                                    children: "No results"
                                                }),
                                                searchValue.trim().length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                                                    children: [
                                                        "No results found for ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                            className: " wd111 xd111 _xa111 wX0cczbc111 xX0cczbc111 _xX0cczba111",
                                                            children: searchValue
                                                        }),
                                                        " in ",
                                                        selectedLibrary,
                                                        "."
                                                    ]
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                                                    children: [
                                                        "No results found in ",
                                                        selectedLibrary,
                                                        "."
                                                    ]
                                                })
                                            ]
                                        })
                                })
                            })
                        ]
                    }, library.id))
            ]
        })
    });
}
function title(page) {
    return page.exports?.title ?? page.tableOfContents?.[0]?.title ?? page.name;
}
function SideNavSection({ title, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: " GA111",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-b111 vx111 wb111 xb111 _xa111 _Fd111 _FezxGHba111 _FnuYUweb111 pn111 Mi111 Se111 Re111 sd111 eb111",
                children: title
            }),
            children
        ]
    });
}
const SideNavContext = /*#__PURE__*/ (0, _react.createContext)('');
function SideNav({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        className: " _Gc111 Td111 Qd111 Sd111 S6XE6sdf111 Rd111 Jy111 Gy111 Iy111 Hy111 sd111 _ta111 Ue111 qe111 Za111 _oa111",
        children: children
    });
}
function SideNavItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        children: props.children
    });
}
function SideNavLink(props) {
    let linkRef = (0, _react.useRef)(null);
    let selected = (0, _react.useContext)(SideNavContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        ref: linkRef,
        "aria-current": props.isSelected || selected === props.href ? 'page' : undefined,
        style: (0, _s2.pressScale)(linkRef),
        className: function anonymous(props) {
            let rules = " ";
            if (props.isFocusVisible) rules += ' _Lf111';
            else rules += ' _Le111';
            rules += ' Oh111';
            rules += ' _Mc111';
            rules += ' _Kd111';
            rules += ' Mi111';
            rules += ' _oa111';
            rules += ' Sp111';
            rules += ' Rp111';
            rules += ' sd111';
            rules += ' eb111';
            rules += ' UssxDec111';
            rules += ' qssxDec111';
            rules += ' uk111';
            rules += ' uch111';
            rules += ' udi111';
            rules += ' uea111';
            rules += ' ugb111';
            rules += ' uhd111';
            rules += ' uje111';
            rules += ' u2NhKxcl111';
            rules += ' uic111';
            rules += ' -_6BNtrc-c111';
            rules += ' vx111';
            if (props.isCurrent) {
                rules += ' wd111';
                rules += ' xd111';
                rules += ' _xa111';
                rules += ' wX0cczbc111';
                rules += ' xX0cczbc111';
                rules += ' _xX0cczba111';
            } else {
                rules += ' wb111';
                rules += ' xb111';
                rules += ' _xa111';
            }
            rules += ' _Fd111';
            rules += ' _FezxGHba111';
            rules += ' _FnuYUweb111';
            rules += ' pt111';
            rules += ' _Xa111';
            rules += ' ob111';
            rules += ' nb111';
            rules += ' kb111';
            rules += ' jb111';
            rules += ' Yd111';
            rules += ' Xb111';
            rules += ' _2b111';
            return rules;
        },
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' Zf111';
                            rules += ' FObNfn111';
                            rules += ' og111';
                            rules += ' ng111';
                            rules += ' kg111';
                            rules += ' jg111';
                            rules += ' Yd111';
                            rules += ' Xb111';
                            rules += ' _2b111';
                            if (props.isCurrent) rules += ' g0111';
                            else if (props.isHovered) rules += ' gw111';
                            else rules += ' g9111';
                            return rules;
                        }(renderProps)
                    }),
                    props.children
                ]
            })
    });
}
function useCurrentSection() {
    let [selected, setSelected] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        let elements = Array.from(document.querySelectorAll('article > :is(h2,h3,h4,h5)'));
        let visible = new Set();
        let observer = new IntersectionObserver((entries)=>{
            for (let entry of entries){
                if (entry.isIntersecting) visible.add(entry.target);
                else visible.delete(entry.target);
                let firstVisible = elements.find((e)=>visible.has(e));
                if (firstVisible) setSelected('#' + firstVisible.id);
            }
        }, {
            rootMargin: '0px 0px -50% 0px'
        });
        for (let element of elements)observer.observe(element);
        return ()=>observer.disconnect();
    }, []);
    return selected;
}
function OnPageNav({ children }) {
    let selected = useCurrentSection();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavContext.Provider, {
        value: selected,
        children: children
    });
}
function MobileOnPageNav({ children }) {
    let [selected, setSelected] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        let elements = Array.from(document.querySelectorAll('article > :is(h1,h2,h3,h4,h5)'));
        elements.reverse();
        let visible = new Set();
        let observer = new IntersectionObserver((entries)=>{
            for (let entry of entries)if (entry.isIntersecting) visible.add(entry.target);
            else visible.delete(entry.target);
            let lastVisible = elements.find((e)=>visible.has(e));
            if (lastVisible) setSelected('#' + lastVisible.id);
            else setSelected('#' + elements.at(-1).id);
        }, {
            rootMargin: '9999999px 0px -100% 0px',
            // @ts-ignore
            scrollMargin: '0px 0px 62px 0px',
            threshold: 0.5
        });
        for (let element of elements)observer.observe(element);
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Picker), {
        "aria-label": "Table of contents",
        selectedKey: selected,
        isQuiet: true,
        size: "L",
        children: children
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","7":"4oKuc","8":"4oKuc","9":"4oKuc","10":"4oKuc","11":"4oKuc","12":"4oKuc","13":"4oKuc","react/jsx-runtime":"2Is6Z","./ComponentCardView":"7i8km","@react-spectrum/s2":"5H6IX","./SearchMenu":"7ohac","react-aria-components":"2Emk2","@react-spectrum/s2/illustrations/linear/NoSearchResults":"fvWSv","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4oKuc":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"74WJu":[function(require,module,exports,__globalThis) {
'use strict';
var s;
s = require("8884f512c685da86");
exports.renderToReadableStream = s.renderToReadableStream;
exports.decodeReply = s.decodeReply;
exports.decodeReplyFromAsyncIterable = s.decodeReplyFromAsyncIterable;
exports.decodeAction = s.decodeAction;
exports.decodeFormState = s.decodeFormState;
exports.createClientReference = s.createClientReference;
exports.registerServerReference = s.registerServerReference;
exports.createTemporaryReferenceSet = s.createTemporaryReferenceSet;
exports.registerServerActions = s.registerServerActions;
exports.loadServerAction = s.loadServerAction;

},{"8884f512c685da86":"iGhi4"}],"iGhi4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-server.edge.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactDOM = require("2381f0f3ff03ff95"), React = require("6db66a729b66b575"), ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule$1(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.postpone");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
}, currentView = null, writtenBytes = 0;
function writeChunkAndReturn(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = currentView.length - writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
            currentView.set(chunk, writtenBytes);
            writtenBytes += chunk.byteLength;
        }
    }
    return !0;
}
var textEncoder = new TextEncoder();
function stringToChunk(content) {
    return textEncoder.encode(content);
}
function byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var CLIENT_REFERENCE_TAG$1 = Symbol.for("react.client.reference"), SERVER_REFERENCE_TAG = Symbol.for("react.server.reference"), FunctionBind = Function.prototype.bind, ArraySlice = Array.prototype.slice;
function bind() {
    var newFn = FunctionBind.apply(this, arguments);
    if (this.$$typeof === SERVER_REFERENCE_TAG) {
        var args = ArraySlice.call(arguments, 1), $$typeof = {
            value: SERVER_REFERENCE_TAG
        }, $$id = {
            value: this.$$id
        };
        args = {
            value: this.$$bound ? this.$$bound.concat(args) : args
        };
        return Object.defineProperties(newFn, {
            $$typeof: $$typeof,
            $$id: $$id,
            $$bound: args,
            bind: {
                value: bind,
                configurable: !0
            }
        });
    }
    return newFn;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function prefetchDNS(href) {
    if ("string" === typeof href && href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "D|" + href;
            hints.has(key) || (hints.add(key), emitHint(request, "D", href));
        } else previousDispatcher.D(href);
    }
}
function preconnect(href, crossOrigin) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "C|" + (null == crossOrigin ? "null" : crossOrigin) + "|" + href;
            hints.has(key) || (hints.add(key), "string" === typeof crossOrigin ? emitHint(request, "C", [
                href,
                crossOrigin
            ]) : emitHint(request, "C", href));
        } else previousDispatcher.C(href, crossOrigin);
    }
}
function preload(href, as, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "L";
            if ("image" === as && options) {
                var imageSrcSet = options.imageSrcSet, imageSizes = options.imageSizes, uniquePart = "";
                "string" === typeof imageSrcSet && "" !== imageSrcSet ? (uniquePart += "[" + imageSrcSet + "]", "string" === typeof imageSizes && (uniquePart += "[" + imageSizes + "]")) : uniquePart += "[][]" + href;
                key += "[image]" + uniquePart;
            } else key += "[" + as + "]" + href;
            hints.has(key) || (hints.add(key), (options = trimOptions(options)) ? emitHint(request, "L", [
                href,
                as,
                options
            ]) : emitHint(request, "L", [
                href,
                as
            ]));
        } else previousDispatcher.L(href, as, options);
    }
}
function preloadModule(href, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "m|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "m", [
                href,
                options
            ]) : emitHint(request, "m", href);
        }
        previousDispatcher.m(href, options);
    }
}
function preinitStyle(href, precedence, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "S|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "S", [
                href,
                "string" === typeof precedence ? precedence : 0,
                options
            ]) : "string" === typeof precedence ? emitHint(request, "S", [
                href,
                precedence
            ]) : emitHint(request, "S", href);
        }
        previousDispatcher.S(href, precedence, options);
    }
}
function preinitScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "X|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "X", [
                src,
                options
            ]) : emitHint(request, "X", src);
        }
        previousDispatcher.X(src, options);
    }
}
function preinitModuleScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "M|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "M", [
                src,
                options
            ]) : emitHint(request, "M", src);
        }
        previousDispatcher.M(src, options);
    }
}
function trimOptions(options) {
    if (null == options) return null;
    var hasProperties = !1, trimmed = {}, key;
    for(key in options)null != options[key] && (hasProperties = !0, trimmed[key] = options[key]);
    return hasProperties ? trimmed : null;
}
var supportsRequestStorage = "function" === typeof AsyncLocalStorage, requestStorage = supportsRequestStorage ? new AsyncLocalStorage() : null, TEMPORARY_REFERENCE_TAG = Symbol.for("react.temporary.reference"), proxyHandlers = {
    get: function(target, name) {
        switch(name){
            case "$$typeof":
                return target.$$typeof;
            case "name":
                return;
            case "displayName":
                return;
            case "defaultProps":
                return;
            case "_debugInfo":
                return;
            case "toJSON":
                return;
            case Symbol.toPrimitive:
                return Object.prototype[Symbol.toPrimitive];
            case Symbol.toStringTag:
                return Object.prototype[Symbol.toStringTag];
            case "Provider":
                throw Error("Cannot render a Client Context Provider on the Server. Instead, you can export a Client Component wrapper that itself renders a Client Context Provider.");
        }
        throw Error("Cannot access " + String(name) + " on the server. You cannot dot into a temporary client reference from a server component. You can only pass the value through to the client.");
    },
    set: function() {
        throw Error("Cannot assign to a temporary client reference from a server module.");
    }
};
function createTemporaryReference(temporaryReferences, id) {
    var reference = Object.defineProperties(function() {
        throw Error("Attempted to call a temporary Client Reference from the server but it is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component.");
    }, {
        $$typeof: {
            value: TEMPORARY_REFERENCE_TAG
        }
    });
    reference = new Proxy(reference, proxyHandlers);
    temporaryReferences.set(reference, id);
    return reference;
}
function noop() {}
var SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`.");
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop, noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then(noop, noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var currentRequest$1 = null, thenableIndexCounter = 0, thenableState = null;
function getThenableStateAfterSuspending() {
    var state = thenableState || [];
    thenableState = null;
    return state;
}
var HooksDispatcher = {
    readContext: unsupportedContext,
    use: use,
    useCallback: function(callback) {
        return callback;
    },
    useContext: unsupportedContext,
    useEffect: unsupportedHook,
    useImperativeHandle: unsupportedHook,
    useLayoutEffect: unsupportedHook,
    useInsertionEffect: unsupportedHook,
    useMemo: function(nextCreate) {
        return nextCreate();
    },
    useReducer: unsupportedHook,
    useRef: unsupportedHook,
    useState: unsupportedHook,
    useDebugValue: function() {},
    useDeferredValue: unsupportedHook,
    useTransition: unsupportedHook,
    useSyncExternalStore: unsupportedHook,
    useId: useId,
    useHostTransitionStatus: unsupportedHook,
    useFormState: unsupportedHook,
    useActionState: unsupportedHook,
    useOptimistic: unsupportedHook,
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return unsupportedRefresh;
    }
};
function unsupportedHook() {
    throw Error("This Hook is not supported in Server Components.");
}
function unsupportedRefresh() {
    throw Error("Refreshing the cache is not supported in Server Components.");
}
function unsupportedContext() {
    throw Error("Cannot read a Client Context from a Server Component.");
}
function useId() {
    if (null === currentRequest$1) throw Error("useId can only be used while React is rendering");
    var id = currentRequest$1.identifierCount++;
    return "_" + currentRequest$1.identifierPrefix + "S_" + id.toString(32) + "_";
}
function use(usable) {
    if (null !== usable && "object" === typeof usable || "function" === typeof usable) {
        if ("function" === typeof usable.then) {
            var index = thenableIndexCounter;
            thenableIndexCounter += 1;
            null === thenableState && (thenableState = []);
            return trackUsedThenable(thenableState, usable, index);
        }
        usable.$$typeof === REACT_CONTEXT_TYPE && unsupportedContext();
    }
    if (usable.$$typeof === CLIENT_REFERENCE_TAG$1) {
        if (null != usable.value && usable.value.$$typeof === REACT_CONTEXT_TYPE) throw Error("Cannot read a Client Context from a Server Component.");
        throw Error("Cannot use() an already resolved Client Reference.");
    }
    throw Error("An unsupported type was passed to use(): " + String(usable));
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var JSCompiler_inline_result = (JSCompiler_inline_result = resolveRequest()) ? JSCompiler_inline_result.cache : new Map();
        var entry = JSCompiler_inline_result.get(resourceType);
        void 0 === entry && (entry = resourceType(), JSCompiler_inline_result.set(resourceType, entry));
        return entry;
    },
    cacheSignal: function() {
        var request = resolveRequest();
        return request ? request.cacheController.signal : null;
    }
}, ReactSharedInternalsServer = React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
if (!ReactSharedInternalsServer) throw Error('The "react" package in this environment is not configured correctly. The "react-server" condition must be enabled in any environment that runs React Server Components.');
var isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf;
function objectName(object) {
    object = Object.prototype.toString.call(object);
    return object.slice(8, object.length - 1);
}
function describeValueForErrorMessage(value) {
    switch(typeof value){
        case "string":
            return JSON.stringify(10 >= value.length ? value : value.slice(0, 10) + "...");
        case "object":
            if (isArrayImpl(value)) return "[...]";
            if (null !== value && value.$$typeof === CLIENT_REFERENCE_TAG) return "client";
            value = objectName(value);
            return "Object" === value ? "{...}" : value;
        case "function":
            return value.$$typeof === CLIENT_REFERENCE_TAG ? "client" : (value = value.displayName || value.name) ? "function " + value : "function";
        default:
            return String(value);
    }
}
function describeElementType(type) {
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_FORWARD_REF_TYPE:
            return describeElementType(type.render);
        case REACT_MEMO_TYPE:
            return describeElementType(type.type);
        case REACT_LAZY_TYPE:
            var payload = type._payload;
            type = type._init;
            try {
                return describeElementType(type(payload));
            } catch (x) {}
    }
    return "";
}
var CLIENT_REFERENCE_TAG = Symbol.for("react.client.reference");
function describeObjectForErrorMessage(objectOrArray, expandedName) {
    var objKind = objectName(objectOrArray);
    if ("Object" !== objKind && "Array" !== objKind) return objKind;
    objKind = -1;
    var length = 0;
    if (isArrayImpl(objectOrArray)) {
        var str = "[";
        for(var i = 0; i < objectOrArray.length; i++){
            0 < i && (str += ", ");
            var value = objectOrArray[i];
            value = "object" === typeof value && null !== value ? describeObjectForErrorMessage(value) : describeValueForErrorMessage(value);
            "" + i === expandedName ? (objKind = str.length, length = value.length, str += value) : str = 10 > value.length && 40 > str.length + value.length ? str + value : str + "...";
        }
        str += "]";
    } else if (objectOrArray.$$typeof === REACT_ELEMENT_TYPE) str = "<" + describeElementType(objectOrArray.type) + "/>";
    else {
        if (objectOrArray.$$typeof === CLIENT_REFERENCE_TAG) return "client";
        str = "{";
        i = Object.keys(objectOrArray);
        for(value = 0; value < i.length; value++){
            0 < value && (str += ", ");
            var name = i[value], encodedKey = JSON.stringify(name);
            str += ('"' + name + '"' === encodedKey ? name : encodedKey) + ": ";
            encodedKey = objectOrArray[name];
            encodedKey = "object" === typeof encodedKey && null !== encodedKey ? describeObjectForErrorMessage(encodedKey) : describeValueForErrorMessage(encodedKey);
            name === expandedName ? (objKind = str.length, length = encodedKey.length, str += encodedKey) : str = 10 > encodedKey.length && 40 > str.length + encodedKey.length ? str + encodedKey : str + "...";
        }
        str += "}";
    }
    return void 0 === expandedName ? str : -1 < objKind && 0 < length ? (objectOrArray = " ".repeat(objKind) + "^".repeat(length), "\n  " + str + "\n  " + objectOrArray) : "\n  " + str;
}
var hasOwnProperty = Object.prototype.hasOwnProperty, ObjectPrototype = Object.prototype, stringify = JSON.stringify;
function defaultErrorHandler(error) {
    console.error(error);
}
function RequestInstance(type, model, bundlerConfig, onError, onPostpone, onAllReady, onFatalError, identifierPrefix, temporaryReferences) {
    if (null !== ReactSharedInternalsServer.A && ReactSharedInternalsServer.A !== DefaultAsyncDispatcher) throw Error("Currently React only supports one RSC renderer at a time.");
    ReactSharedInternalsServer.A = DefaultAsyncDispatcher;
    var abortSet = new Set(), pingedTasks = [], hints = new Set();
    this.type = type;
    this.status = 10;
    this.flushScheduled = !1;
    this.destination = this.fatalError = null;
    this.bundlerConfig = bundlerConfig;
    this.cache = new Map();
    this.cacheController = new AbortController();
    this.pendingChunks = this.nextChunkId = 0;
    this.hints = hints;
    this.abortableTasks = abortSet;
    this.pingedTasks = pingedTasks;
    this.completedImportChunks = [];
    this.completedHintChunks = [];
    this.completedRegularChunks = [];
    this.completedErrorChunks = [];
    this.writtenSymbols = new Map();
    this.writtenClientReferences = new Map();
    this.writtenServerReferences = new Map();
    this.writtenObjects = new WeakMap();
    this.temporaryReferences = temporaryReferences;
    this.identifierPrefix = identifierPrefix || "";
    this.identifierCount = 1;
    this.taintCleanupQueue = [];
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = onAllReady;
    this.onFatalError = onFatalError;
    type = createTask(this, model, null, !1, abortSet);
    pingedTasks.push(type);
}
var currentRequest = null;
function resolveRequest() {
    if (currentRequest) return currentRequest;
    if (supportsRequestStorage) {
        var store = requestStorage.getStore();
        if (store) return store;
    }
    return null;
}
function serializeThenable(request, task, thenable) {
    var newTask = createTask(request, thenable, task.keyPath, task.implicitSlot, request.abortableTasks);
    switch(thenable.status){
        case "fulfilled":
            return newTask.model = thenable.value, pingTask(request, newTask), newTask.id;
        case "rejected":
            return erroredTask(request, newTask, thenable.reason), newTask.id;
        default:
            if (12 === request.status) return request.abortableTasks.delete(newTask), task = request.fatalError, abortTask(newTask), finishAbortedTask(newTask, request, task), newTask.id;
            "string" !== typeof thenable.status && (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            }));
    }
    thenable.then(function(value) {
        newTask.model = value;
        pingTask(request, newTask);
    }, function(reason) {
        0 === newTask.status && (erroredTask(request, newTask, reason), enqueueFlush(request));
    });
    return newTask.id;
}
function serializeReadableStream(request, task, stream) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) streamTask.status = 1, entry = streamTask.id.toString(16) + ":C\n", request.completedRegularChunks.push(stringToChunk(entry)), request.abortableTasks.delete(streamTask), request.cacheController.signal.removeEventListener("abort", abortStream), enqueueFlush(request), callOnAllReadyIfReady(request);
            else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), reader.read().then(progress, error);
            } catch (x$8) {
                error(x$8);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortStream), erroredTask(request, streamTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortStream() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortStream);
            signal = signal.reason;
            erroredTask(request, streamTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var supportsBYOB = stream.supportsBYOB;
    if (void 0 === supportsBYOB) try {
        stream.getReader({
            mode: "byob"
        }).releaseLock(), supportsBYOB = !0;
    } catch (x) {
        supportsBYOB = !1;
    }
    var reader = stream.getReader(), streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (supportsBYOB ? "r" : "R") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortStream);
    reader.read().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function serializeAsyncIterable(request, task, iterable, iterator) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) {
                streamTask.status = 1;
                if (void 0 === entry.value) var endStreamRow = streamTask.id.toString(16) + ":C\n";
                else try {
                    var chunkId = outlineModel(request, entry.value);
                    endStreamRow = streamTask.id.toString(16) + ":C" + stringify(serializeByValueID(chunkId)) + "\n";
                } catch (x) {
                    error(x);
                    return;
                }
                request.completedRegularChunks.push(stringToChunk(endStreamRow));
                request.abortableTasks.delete(streamTask);
                request.cacheController.signal.removeEventListener("abort", abortIterable);
                enqueueFlush(request);
                callOnAllReadyIfReady(request);
            } else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), iterator.next().then(progress, error);
            } catch (x$9) {
                error(x$9);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortIterable), erroredTask(request, streamTask, reason), enqueueFlush(request), "function" === typeof iterator.throw && iterator.throw(reason).then(error, error));
    }
    function abortIterable() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortIterable);
            var reason = signal.reason;
            erroredTask(request, streamTask, signal.reason);
            enqueueFlush(request);
            "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
        }
    }
    iterable = iterable === iterator;
    var streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (iterable ? "x" : "X") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortIterable);
    iterator.next().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function emitHint(request, code, model) {
    model = stringify(model);
    code = stringToChunk(":H" + code + model + "\n");
    request.completedHintChunks.push(code);
    enqueueFlush(request);
}
function readThenable(thenable) {
    if ("fulfilled" === thenable.status) return thenable.value;
    if ("rejected" === thenable.status) throw thenable.reason;
    throw thenable;
}
function createLazyWrapperAroundWakeable(request, task, wakeable) {
    switch(wakeable.status){
        case "fulfilled":
            return wakeable.value;
        case "rejected":
            break;
        default:
            "string" !== typeof wakeable.status && (wakeable.status = "pending", wakeable.then(function(fulfilledValue) {
                "pending" === wakeable.status && (wakeable.status = "fulfilled", wakeable.value = fulfilledValue);
            }, function(error) {
                "pending" === wakeable.status && (wakeable.status = "rejected", wakeable.reason = error);
            }));
    }
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: wakeable,
        _init: readThenable
    };
}
function voidHandler() {}
function processServerComponentReturnValue(request, task, Component, result) {
    if ("object" !== typeof result || null === result || result.$$typeof === CLIENT_REFERENCE_TAG$1) return result;
    if ("function" === typeof result.then) return createLazyWrapperAroundWakeable(request, task, result);
    var iteratorFn = getIteratorFn(result);
    return iteratorFn ? (request = {}, request[Symbol.iterator] = function() {
        return iteratorFn.call(result);
    }, request) : "function" !== typeof result[ASYNC_ITERATOR] || "function" === typeof ReadableStream && result instanceof ReadableStream ? result : (request = {}, request[ASYNC_ITERATOR] = function() {
        return result[ASYNC_ITERATOR]();
    }, request);
}
function renderFunctionComponent(request, task, key, Component, props) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    props = Component(props, void 0);
    if (12 === request.status) throw "object" === typeof props && null !== props && "function" === typeof props.then && props.$$typeof !== CLIENT_REFERENCE_TAG$1 && props.then(voidHandler, voidHandler), null;
    props = processServerComponentReturnValue(request, task, Component, props);
    Component = task.keyPath;
    prevThenableState = task.implicitSlot;
    null !== key ? task.keyPath = null === Component ? key : Component + "," + key : null === Component && (task.implicitSlot = !0);
    request = renderModelDestructive(request, task, emptyRoot, "", props);
    task.keyPath = Component;
    task.implicitSlot = prevThenableState;
    return request;
}
function renderFragment(request, task, children) {
    return null !== task.keyPath ? (request = [
        REACT_ELEMENT_TYPE,
        REACT_FRAGMENT_TYPE,
        task.keyPath,
        {
            children: children
        }
    ], task.implicitSlot ? [
        request
    ] : request) : children;
}
var serializedSize = 0;
function deferTask(request, task) {
    task = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    pingTask(request, task);
    return "$L" + task.id.toString(16);
}
function renderElement(request, task, type, key, ref, props) {
    if (null !== ref && void 0 !== ref) throw Error("Refs cannot be used in Server Components, nor passed to Client Components.");
    if ("function" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1 && type.$$typeof !== TEMPORARY_REFERENCE_TAG) return renderFunctionComponent(request, task, key, type, props);
    if (type === REACT_FRAGMENT_TYPE && null === key) return type = task.implicitSlot, null === task.keyPath && (task.implicitSlot = !0), props = renderModelDestructive(request, task, emptyRoot, "", props.children), task.implicitSlot = type, props;
    if (null != type && "object" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1) switch(type.$$typeof){
        case REACT_LAZY_TYPE:
            var init = type._init;
            type = init(type._payload);
            if (12 === request.status) throw null;
            return renderElement(request, task, type, key, ref, props);
        case REACT_FORWARD_REF_TYPE:
            return renderFunctionComponent(request, task, key, type.render, props);
        case REACT_MEMO_TYPE:
            return renderElement(request, task, type.type, key, ref, props);
    }
    request = key;
    key = task.keyPath;
    null === request ? request = key : null !== key && (request = key + "," + request);
    props = [
        REACT_ELEMENT_TYPE,
        type,
        request,
        props
    ];
    task = task.implicitSlot && null !== request ? [
        props
    ] : props;
    return task;
}
function pingTask(request, task) {
    var pingedTasks = request.pingedTasks;
    pingedTasks.push(task);
    1 === pingedTasks.length && (request.flushScheduled = null !== request.destination, 21 === request.type || 10 === request.status ? scheduleMicrotask(function() {
        return performWork(request);
    }) : setTimeout(function() {
        return performWork(request);
    }, 0));
}
function createTask(request, model, keyPath, implicitSlot, abortSet) {
    request.pendingChunks++;
    var id = request.nextChunkId++;
    "object" !== typeof model || null === model || null !== keyPath || implicitSlot || request.writtenObjects.set(model, serializeByValueID(id));
    var task = {
        id: id,
        status: 0,
        model: model,
        keyPath: keyPath,
        implicitSlot: implicitSlot,
        ping: function() {
            return pingTask(request, task);
        },
        toJSON: function(parentPropertyName, value) {
            serializedSize += parentPropertyName.length;
            var prevKeyPath = task.keyPath, prevImplicitSlot = task.implicitSlot;
            try {
                var JSCompiler_inline_result = renderModelDestructive(request, task, this, parentPropertyName, value);
            } catch (thrownValue) {
                if (parentPropertyName = task.model, parentPropertyName = "object" === typeof parentPropertyName && null !== parentPropertyName && (parentPropertyName.$$typeof === REACT_ELEMENT_TYPE || parentPropertyName.$$typeof === REACT_LAZY_TYPE), 12 === request.status) task.status = 3, prevKeyPath = request.fatalError, JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
                else if (value = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof value && null !== value && "function" === typeof value.then) {
                    JSCompiler_inline_result = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
                    var ping = JSCompiler_inline_result.ping;
                    value.then(ping, ping);
                    JSCompiler_inline_result.thenableState = getThenableStateAfterSuspending();
                    task.keyPath = prevKeyPath;
                    task.implicitSlot = prevImplicitSlot;
                    JSCompiler_inline_result = parentPropertyName ? "$L" + JSCompiler_inline_result.id.toString(16) : serializeByValueID(JSCompiler_inline_result.id);
                } else task.keyPath = prevKeyPath, task.implicitSlot = prevImplicitSlot, request.pendingChunks++, prevKeyPath = request.nextChunkId++, prevImplicitSlot = logRecoverableError(request, value, task), emitErrorChunk(request, prevKeyPath, prevImplicitSlot), JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
            }
            return JSCompiler_inline_result;
        },
        thenableState: null
    };
    abortSet.add(task);
    return task;
}
function serializeByValueID(id) {
    return "$" + id.toString(16);
}
function encodeReferenceChunk(request, id, reference) {
    request = stringify(reference);
    id = id.toString(16) + ":" + request + "\n";
    return stringToChunk(id);
}
function serializeClientReference(request, parent, parentPropertyName, clientReference) {
    var clientReferenceKey = clientReference.$$id + "#" + clientReference.$$name, writtenClientReferences = request.writtenClientReferences, existingId = writtenClientReferences.get(clientReferenceKey);
    if (void 0 !== existingId) return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + existingId.toString(16) : serializeByValueID(existingId);
    try {
        var JSCompiler_inline_result = clientReference.$$importMap ? [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles,
            clientReference.$$importMap
        ] : [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles
        ];
        request.pendingChunks++;
        var importId = request.nextChunkId++, json = stringify(JSCompiler_inline_result), row = importId.toString(16) + ":I" + json + "\n", processedChunk = stringToChunk(row);
        request.completedImportChunks.push(processedChunk);
        writtenClientReferences.set(clientReferenceKey, importId);
        return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + importId.toString(16) : serializeByValueID(importId);
    } catch (x) {
        return request.pendingChunks++, parent = request.nextChunkId++, parentPropertyName = logRecoverableError(request, x, null), emitErrorChunk(request, parent, parentPropertyName), serializeByValueID(parent);
    }
}
function outlineModel(request, value) {
    value = createTask(request, value, null, !1, request.abortableTasks);
    retryTask(request, value);
    return value.id;
}
function serializeTypedArray(request, tag, typedArray) {
    request.pendingChunks++;
    var bufferId = request.nextChunkId++;
    emitTypedArrayChunk(request, bufferId, tag, typedArray, !1);
    return serializeByValueID(bufferId);
}
function serializeBlob(request, blob) {
    function progress(entry) {
        if (0 === newTask.status) {
            if (entry.done) request.cacheController.signal.removeEventListener("abort", abortBlob), pingTask(request, newTask);
            else return model.push(entry.value), reader.read().then(progress).catch(error);
        }
    }
    function error(reason) {
        0 === newTask.status && (request.cacheController.signal.removeEventListener("abort", abortBlob), erroredTask(request, newTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortBlob() {
        if (0 === newTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortBlob);
            signal = signal.reason;
            erroredTask(request, newTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var model = [
        blob.type
    ], newTask = createTask(request, model, null, !1, request.abortableTasks), reader = blob.stream().getReader();
    request.cacheController.signal.addEventListener("abort", abortBlob);
    reader.read().then(progress).catch(error);
    return "$B" + newTask.id.toString(16);
}
var modelRoot = !1;
function renderModelDestructive(request, task, parent, parentPropertyName, value) {
    task.model = value;
    if (value === REACT_ELEMENT_TYPE) return "$";
    if (null === value) return null;
    if ("object" === typeof value) {
        switch(value.$$typeof){
            case REACT_ELEMENT_TYPE:
                var elementReference = null, writtenObjects = request.writtenObjects;
                if (null === task.keyPath && !task.implicitSlot) {
                    var existingReference = writtenObjects.get(value);
                    if (void 0 !== existingReference) {
                        if (modelRoot === value) modelRoot = null;
                        else return existingReference;
                    } else -1 === parentPropertyName.indexOf(":") && (parent = writtenObjects.get(parent), void 0 !== parent && (elementReference = parent + ":" + parentPropertyName, writtenObjects.set(value, elementReference)));
                }
                if (3200 < serializedSize) return deferTask(request, task);
                parentPropertyName = value.props;
                parent = parentPropertyName.ref;
                request = renderElement(request, task, value.type, value.key, void 0 !== parent ? parent : null, parentPropertyName);
                "object" === typeof request && null !== request && null !== elementReference && (writtenObjects.has(request) || writtenObjects.set(request, elementReference));
                return request;
            case REACT_LAZY_TYPE:
                if (3200 < serializedSize) return deferTask(request, task);
                task.thenableState = null;
                parentPropertyName = value._init;
                value = parentPropertyName(value._payload);
                if (12 === request.status) throw null;
                return renderModelDestructive(request, task, emptyRoot, "", value);
            case REACT_LEGACY_ELEMENT_TYPE:
                throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        }
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (void 0 !== request.temporaryReferences && (elementReference = request.temporaryReferences.get(value), void 0 !== elementReference)) return "$T" + elementReference;
        elementReference = request.writtenObjects;
        writtenObjects = elementReference.get(value);
        if ("function" === typeof value.then) {
            if (void 0 !== writtenObjects) {
                if (null !== task.keyPath || task.implicitSlot) return "$@" + serializeThenable(request, task, value).toString(16);
                if (modelRoot === value) modelRoot = null;
                else return writtenObjects;
            }
            request = "$@" + serializeThenable(request, task, value).toString(16);
            elementReference.set(value, request);
            return request;
        }
        if (void 0 !== writtenObjects) {
            if (modelRoot === value) {
                if (writtenObjects !== serializeByValueID(task.id)) return writtenObjects;
                modelRoot = null;
            } else return writtenObjects;
        } else if (-1 === parentPropertyName.indexOf(":") && (writtenObjects = elementReference.get(parent), void 0 !== writtenObjects)) {
            existingReference = parentPropertyName;
            if (isArrayImpl(parent) && parent[0] === REACT_ELEMENT_TYPE) switch(parentPropertyName){
                case "1":
                    existingReference = "type";
                    break;
                case "2":
                    existingReference = "key";
                    break;
                case "3":
                    existingReference = "props";
                    break;
                case "4":
                    existingReference = "_owner";
            }
            elementReference.set(value, writtenObjects + ":" + existingReference);
        }
        if (isArrayImpl(value)) return renderFragment(request, task, value);
        if (value instanceof Map) return value = Array.from(value), "$Q" + outlineModel(request, value).toString(16);
        if (value instanceof Set) return value = Array.from(value), "$W" + outlineModel(request, value).toString(16);
        if ("function" === typeof FormData && value instanceof FormData) return value = Array.from(value.entries()), "$K" + outlineModel(request, value).toString(16);
        if (value instanceof Error) return "$Z";
        if (value instanceof ArrayBuffer) return serializeTypedArray(request, "A", new Uint8Array(value));
        if (value instanceof Int8Array) return serializeTypedArray(request, "O", value);
        if (value instanceof Uint8Array) return serializeTypedArray(request, "o", value);
        if (value instanceof Uint8ClampedArray) return serializeTypedArray(request, "U", value);
        if (value instanceof Int16Array) return serializeTypedArray(request, "S", value);
        if (value instanceof Uint16Array) return serializeTypedArray(request, "s", value);
        if (value instanceof Int32Array) return serializeTypedArray(request, "L", value);
        if (value instanceof Uint32Array) return serializeTypedArray(request, "l", value);
        if (value instanceof Float32Array) return serializeTypedArray(request, "G", value);
        if (value instanceof Float64Array) return serializeTypedArray(request, "g", value);
        if (value instanceof BigInt64Array) return serializeTypedArray(request, "M", value);
        if (value instanceof BigUint64Array) return serializeTypedArray(request, "m", value);
        if (value instanceof DataView) return serializeTypedArray(request, "V", value);
        if ("function" === typeof Blob && value instanceof Blob) return serializeBlob(request, value);
        if (elementReference = getIteratorFn(value)) return parentPropertyName = elementReference.call(value), parentPropertyName === value ? "$i" + outlineModel(request, Array.from(parentPropertyName)).toString(16) : renderFragment(request, task, Array.from(parentPropertyName));
        if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(request, task, value);
        elementReference = value[ASYNC_ITERATOR];
        if ("function" === typeof elementReference) return null !== task.keyPath ? (request = [
            REACT_ELEMENT_TYPE,
            REACT_FRAGMENT_TYPE,
            task.keyPath,
            {
                children: value
            }
        ], request = task.implicitSlot ? [
            request
        ] : request) : (parentPropertyName = elementReference.call(value), request = serializeAsyncIterable(request, task, value, parentPropertyName)), request;
        if (value instanceof Date) return "$D" + value.toJSON();
        request = getPrototypeOf(value);
        if (request !== ObjectPrototype && (null === request || null !== getPrototypeOf(request))) throw Error("Only plain objects, and a few built-ins, can be passed to Client Components from Server Components. Classes or null prototypes are not supported." + describeObjectForErrorMessage(parent, parentPropertyName));
        return value;
    }
    if ("string" === typeof value) {
        serializedSize += value.length;
        if ("Z" === value[value.length - 1] && parent[parentPropertyName] instanceof Date) return "$D" + value;
        if (1024 <= value.length && null !== byteLengthOfChunk) return request.pendingChunks++, task = request.nextChunkId++, emitTextChunk(request, task, value, !1), serializeByValueID(task);
        request = "$" === value[0] ? "$" + value : value;
        return request;
    }
    if ("boolean" === typeof value) return value;
    if ("number" === typeof value) return Number.isFinite(value) ? 0 === value && -Infinity === 1 / value ? "$-0" : value : Infinity === value ? "$Infinity" : -Infinity === value ? "$-Infinity" : "$NaN";
    if ("undefined" === typeof value) return "$undefined";
    if ("function" === typeof value) {
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (value.$$typeof === SERVER_REFERENCE_TAG) return task = request.writtenServerReferences, parentPropertyName = task.get(value), void 0 !== parentPropertyName ? request = "$F" + parentPropertyName.toString(16) : (parentPropertyName = value.$$bound, parentPropertyName = null === parentPropertyName ? null : Promise.resolve(parentPropertyName), request = outlineModel(request, {
            id: value.$$id,
            bound: parentPropertyName
        }), task.set(value, request), request = "$F" + request.toString(16)), request;
        if (void 0 !== request.temporaryReferences && (request = request.temporaryReferences.get(value), void 0 !== request)) return "$T" + request;
        if (value.$$typeof === TEMPORARY_REFERENCE_TAG) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
        if (/^on[A-Z]/.test(parentPropertyName)) throw Error("Event handlers cannot be passed to Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName) + "\nIf you need interactivity, consider converting part of this to a Client Component.");
        throw Error('Functions cannot be passed directly to Client Components unless you explicitly expose it by marking it with "use server". Or maybe you meant to call this function rather than return it.' + describeObjectForErrorMessage(parent, parentPropertyName));
    }
    if ("symbol" === typeof value) {
        task = request.writtenSymbols;
        elementReference = task.get(value);
        if (void 0 !== elementReference) return serializeByValueID(elementReference);
        elementReference = value.description;
        if (Symbol.for(elementReference) !== value) throw Error("Only global symbols received from Symbol.for(...) can be passed to Client Components. The symbol Symbol.for(" + (value.description + ") cannot be found among global symbols.") + describeObjectForErrorMessage(parent, parentPropertyName));
        request.pendingChunks++;
        parentPropertyName = request.nextChunkId++;
        parent = encodeReferenceChunk(request, parentPropertyName, "$S" + elementReference);
        request.completedImportChunks.push(parent);
        task.set(value, parentPropertyName);
        return serializeByValueID(parentPropertyName);
    }
    if ("bigint" === typeof value) return "$n" + value.toString(10);
    throw Error("Type " + typeof value + " is not supported in Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName));
}
function logRecoverableError(request, error) {
    var prevRequest = currentRequest;
    currentRequest = null;
    try {
        var onError = request.onError;
        var errorDigest = supportsRequestStorage ? requestStorage.run(void 0, onError, error) : onError(error);
    } finally{
        currentRequest = prevRequest;
    }
    if (null != errorDigest && "string" !== typeof errorDigest) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
    return errorDigest || "";
}
function fatalError(request, error) {
    var onFatalError = request.onFatalError;
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
    request.cacheController.abort(Error("The render was aborted due to a fatal error.", {
        cause: error
    }));
}
function emitErrorChunk(request, id, digest) {
    digest = {
        digest: digest
    };
    id = id.toString(16) + ":E" + stringify(digest) + "\n";
    id = stringToChunk(id);
    request.completedErrorChunks.push(id);
}
function emitModelChunk(request, id, json) {
    id = id.toString(16) + ":" + json + "\n";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id);
}
function emitTypedArrayChunk(request, id, tag, typedArray, debug) {
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    debug = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    typedArray = 2048 < typedArray.byteLength ? debug.slice() : debug;
    debug = typedArray.byteLength;
    id = id.toString(16) + ":" + tag + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, typedArray);
}
function emitTextChunk(request, id, text, debug) {
    if (null === byteLengthOfChunk) throw Error("Existence of byteLengthOfChunk should have already been checked. This is a bug in React.");
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    text = stringToChunk(text);
    debug = text.byteLength;
    id = id.toString(16) + ":T" + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, text);
}
function emitChunk(request, task, value) {
    var id = task.id;
    "string" === typeof value && null !== byteLengthOfChunk ? emitTextChunk(request, id, value, !1) : value instanceof ArrayBuffer ? emitTypedArrayChunk(request, id, "A", new Uint8Array(value), !1) : value instanceof Int8Array ? emitTypedArrayChunk(request, id, "O", value, !1) : value instanceof Uint8Array ? emitTypedArrayChunk(request, id, "o", value, !1) : value instanceof Uint8ClampedArray ? emitTypedArrayChunk(request, id, "U", value, !1) : value instanceof Int16Array ? emitTypedArrayChunk(request, id, "S", value, !1) : value instanceof Uint16Array ? emitTypedArrayChunk(request, id, "s", value, !1) : value instanceof Int32Array ? emitTypedArrayChunk(request, id, "L", value, !1) : value instanceof Uint32Array ? emitTypedArrayChunk(request, id, "l", value, !1) : value instanceof Float32Array ? emitTypedArrayChunk(request, id, "G", value, !1) : value instanceof Float64Array ? emitTypedArrayChunk(request, id, "g", value, !1) : value instanceof BigInt64Array ? emitTypedArrayChunk(request, id, "M", value, !1) : value instanceof BigUint64Array ? emitTypedArrayChunk(request, id, "m", value, !1) : value instanceof DataView ? emitTypedArrayChunk(request, id, "V", value, !1) : (value = stringify(value, task.toJSON), emitModelChunk(request, task.id, value));
}
function erroredTask(request, task, error) {
    task.status = 4;
    error = logRecoverableError(request, error, task);
    emitErrorChunk(request, task.id, error);
    request.abortableTasks.delete(task);
    callOnAllReadyIfReady(request);
}
var emptyRoot = {};
function retryTask(request, task) {
    if (0 === task.status) {
        task.status = 5;
        var parentSerializedSize = serializedSize;
        try {
            modelRoot = task.model;
            var resolvedModel = renderModelDestructive(request, task, emptyRoot, "", task.model);
            modelRoot = resolvedModel;
            task.keyPath = null;
            task.implicitSlot = !1;
            if ("object" === typeof resolvedModel && null !== resolvedModel) request.writtenObjects.set(resolvedModel, serializeByValueID(task.id)), emitChunk(request, task, resolvedModel);
            else {
                var json = stringify(resolvedModel);
                emitModelChunk(request, task.id, json);
            }
            task.status = 1;
            request.abortableTasks.delete(task);
            callOnAllReadyIfReady(request);
        } catch (thrownValue) {
            if (12 === request.status) {
                request.abortableTasks.delete(task);
                task.status = 0;
                var errorId = request.fatalError;
                abortTask(task);
                finishAbortedTask(task, request, errorId);
            } else {
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                    task.status = 0;
                    task.thenableState = getThenableStateAfterSuspending();
                    var ping = task.ping;
                    x.then(ping, ping);
                } else erroredTask(request, task, x);
            }
        } finally{
            serializedSize = parentSerializedSize;
        }
    }
}
function tryStreamTask(request, task) {
    var parentSerializedSize = serializedSize;
    try {
        emitChunk(request, task, task.model);
    } finally{
        serializedSize = parentSerializedSize;
    }
}
function performWork(request) {
    var prevDispatcher = ReactSharedInternalsServer.H;
    ReactSharedInternalsServer.H = HooksDispatcher;
    var prevRequest = currentRequest;
    currentRequest$1 = currentRequest = request;
    try {
        var pingedTasks = request.pingedTasks;
        request.pingedTasks = [];
        for(var i = 0; i < pingedTasks.length; i++)retryTask(request, pingedTasks[i]);
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    } finally{
        ReactSharedInternalsServer.H = prevDispatcher, currentRequest$1 = null, currentRequest = prevRequest;
    }
}
function abortTask(task) {
    0 === task.status && (task.status = 3);
}
function finishAbortedTask(task, request, errorId) {
    3 === task.status && (errorId = serializeByValueID(errorId), task = encodeReferenceChunk(request, task.id, errorId), request.completedErrorChunks.push(task));
}
function flushCompletedChunks(request) {
    var destination = request.destination;
    if (null !== destination) {
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        try {
            for(var importsChunks = request.completedImportChunks, i = 0; i < importsChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, importsChunks[i]);
            importsChunks.splice(0, i);
            var hintChunks = request.completedHintChunks;
            for(i = 0; i < hintChunks.length; i++)writeChunkAndReturn(destination, hintChunks[i]);
            hintChunks.splice(0, i);
            var regularChunks = request.completedRegularChunks;
            for(i = 0; i < regularChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, regularChunks[i]);
            regularChunks.splice(0, i);
            var errorChunks = request.completedErrorChunks;
            for(i = 0; i < errorChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, errorChunks[i]);
            errorChunks.splice(0, i);
        } finally{
            request.flushScheduled = !1, currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
        }
    }
    0 === request.pendingChunks && (12 > request.status && request.cacheController.abort(Error("This render completed successfully. All cacheSignals are now aborted to allow clean up of any unused resources.")), null !== request.destination && (request.status = 14, request.destination.close(), request.destination = null));
}
function startWork(request) {
    request.flushScheduled = null !== request.destination;
    supportsRequestStorage ? scheduleMicrotask(function() {
        requestStorage.run(request, performWork, request);
    }) : scheduleMicrotask(function() {
        return performWork(request);
    });
    setTimeout(function() {
        10 === request.status && (request.status = 11);
    }, 0);
}
function enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, setTimeout(function() {
        request.flushScheduled = !1;
        flushCompletedChunks(request);
    }, 0));
}
function callOnAllReadyIfReady(request) {
    0 === request.abortableTasks.size && (request = request.onAllReady, request());
}
function startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            flushCompletedChunks(request);
        } catch (error) {
            logRecoverableError(request, error, null), fatalError(request, error);
        }
    }
}
function finishAbort(request, abortedTasks, errorId) {
    try {
        abortedTasks.forEach(function(task) {
            return finishAbortedTask(task, request, errorId);
        });
        var onAllReady = request.onAllReady;
        onAllReady();
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    }
}
function abort(request, reason) {
    if (!(11 < request.status)) try {
        request.status = 12;
        request.cacheController.abort(reason);
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error("The render was aborted by the server without a reason.") : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error("The render was aborted by the server with a promise.") : reason, digest = logRecoverableError(request, error, null), errorId = request.nextChunkId++;
            request.fatalError = errorId;
            request.pendingChunks++;
            emitErrorChunk(request, errorId, digest, error, !1);
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, errorId);
            });
            setTimeout(function() {
                return finishAbort(request, abortableTasks, errorId);
            }, 0);
        } else {
            var onAllReady = request.onAllReady;
            onAllReady();
            flushCompletedChunks(request);
        }
    } catch (error$23) {
        logRecoverableError(request, error$23, null), fatalError(request, error$23);
    }
}
function Chunk(status, value, reason, response) {
    this.status = status;
    this.value = value;
    this.reason = reason;
    this._response = response;
}
Chunk.prototype = Object.create(Promise.prototype);
Chunk.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            resolve(this.value);
            break;
        case "pending":
        case "blocked":
        case "cyclic":
            resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        default:
            reject(this.reason);
    }
};
function createPendingChunk(response) {
    return new Chunk("pending", null, null, response);
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++)(0, listeners[i])(value);
}
function triggerErrorOnChunk(chunk, error) {
    if ("pending" !== chunk.status && "blocked" !== chunk.status) chunk.reason.error(error);
    else {
        var listeners = chunk.reason;
        chunk.status = "rejected";
        chunk.reason = error;
        null !== listeners && wakeChunk(listeners, error);
    }
}
function resolveModelChunk(chunk, value, id) {
    if ("pending" !== chunk.status) chunk = chunk.reason, "C" === value[0] ? chunk.close("C" === value ? '"$undefined"' : value.slice(1)) : chunk.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = id;
        if (null !== resolveListeners) switch(initializeModelChunk(chunk), chunk.status){
            case "fulfilled":
                wakeChunk(resolveListeners, chunk.value);
                break;
            case "pending":
            case "blocked":
            case "cyclic":
                if (chunk.value) for(value = 0; value < resolveListeners.length; value++)chunk.value.push(resolveListeners[value]);
                else chunk.value = resolveListeners;
                if (chunk.reason) {
                    if (rejectListeners) for(value = 0; value < rejectListeners.length; value++)chunk.reason.push(rejectListeners[value]);
                } else chunk.reason = rejectListeners;
                break;
            case "rejected":
                rejectListeners && wakeChunk(rejectListeners, chunk.reason);
        }
    }
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new Chunk("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1, response);
}
function resolveIteratorResultChunk(chunk, value, done) {
    resolveModelChunk(chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1);
}
function loadServerReference$1(response, id, bound, parentChunk, parentObject, key) {
    var serverReference = resolveServerReference(response._bundlerConfig, id);
    id = preloadModule$1(serverReference);
    if (bound) bound = Promise.all([
        bound,
        id
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    });
    else if (id) bound = Promise.resolve(id).then(function() {
        return requireModule(serverReference);
    });
    else return requireModule(serverReference);
    bound.then(createModelResolver(parentChunk, parentObject, key, !1, response, createModel, []), createModelReject(parentChunk));
    return null;
}
function reviveModel(response, parentObj, parentKey, value, reference) {
    if ("string" === typeof value) return parseModelString(response, parentObj, parentKey, value, reference);
    if ("object" === typeof value && null !== value) {
        if (void 0 !== reference && void 0 !== response._temporaryReferences && response._temporaryReferences.set(value, reference), Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = reviveModel(response, value, "" + i, value[i], void 0 !== reference ? reference + ":" + i : void 0);
        else for(i in value)hasOwnProperty.call(value, i) && (parentObj = void 0 !== reference && -1 === i.indexOf(":") ? reference + ":" + i : void 0, parentObj = reviveModel(response, value, i, value[i], parentObj), void 0 !== parentObj ? value[i] = parentObj : delete value[i]);
    }
    return value;
}
var initializingChunk = null, initializingChunkBlockedModel = null;
function initializeModelChunk(chunk) {
    var prevChunk = initializingChunk, prevBlocked = initializingChunkBlockedModel;
    initializingChunk = chunk;
    initializingChunkBlockedModel = null;
    var rootReference = -1 === chunk.reason ? void 0 : chunk.reason.toString(16), resolvedModel = chunk.value;
    chunk.status = "cyclic";
    chunk.value = null;
    chunk.reason = null;
    try {
        var rawModel = JSON.parse(resolvedModel), value = reviveModel(chunk._response, {
            "": rawModel
        }, "", rawModel, rootReference);
        if (null !== initializingChunkBlockedModel && 0 < initializingChunkBlockedModel.deps) initializingChunkBlockedModel.value = value, chunk.status = "blocked";
        else {
            var resolveListeners = chunk.value;
            chunk.status = "fulfilled";
            chunk.value = value;
            null !== resolveListeners && wakeChunk(resolveListeners, value);
        }
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingChunk = prevChunk, initializingChunkBlockedModel = prevBlocked;
    }
}
function reportGlobalError(response, error) {
    response._closed = !0;
    response._closedReason = error;
    response._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(chunk, error);
    });
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._formData.get(response._prefix + id), chunk = null != chunk ? new Chunk("resolved_model", chunk, id, response) : response._closed ? new Chunk("rejected", null, response._closedReason, response) : createPendingChunk(response), chunks.set(id, chunk));
    return chunk;
}
function createModelResolver(chunk, parentObject, key, cyclic, response, map, path) {
    if (initializingChunkBlockedModel) {
        var blocked = initializingChunkBlockedModel;
        cyclic || blocked.deps++;
    } else blocked = initializingChunkBlockedModel = {
        deps: cyclic ? 0 : 1,
        value: null
    };
    return function(value) {
        for(var i = 1; i < path.length; i++)value = value[path[i]];
        parentObject[key] = map(response, value);
        "" === key && null === blocked.value && (blocked.value = parentObject[key]);
        blocked.deps--;
        0 === blocked.deps && "blocked" === chunk.status && (value = chunk.value, chunk.status = "fulfilled", chunk.value = blocked.value, null !== value && wakeChunk(value, blocked.value));
    };
}
function createModelReject(chunk) {
    return function(error) {
        return triggerErrorOnChunk(chunk, error);
    };
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            parentObject = id.value;
            for(key = 1; key < reference.length; key++)parentObject = parentObject[reference[key]];
            return map(response, parentObject);
        case "pending":
        case "blocked":
        case "cyclic":
            var parentChunk = initializingChunk;
            id.then(createModelResolver(parentChunk, parentObject, key, "cyclic" === id.status, response, map, reference), createModelReject(parentChunk));
            return null;
        default:
            throw id.reason;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseTypedArray(response, reference, constructor, bytesPerElement, parentObject, parentKey) {
    reference = parseInt(reference.slice(2), 16);
    reference = response._formData.get(response._prefix + reference);
    reference = constructor === ArrayBuffer ? reference.arrayBuffer() : reference.arrayBuffer().then(function(buffer) {
        return new constructor(buffer);
    });
    bytesPerElement = initializingChunk;
    reference.then(createModelResolver(bytesPerElement, parentObject, parentKey, !1, response, createModel, []), createModelReject(bytesPerElement));
    return null;
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    stream = new Chunk("fulfilled", stream, controller, response);
    chunks.set(id, stream);
    response = response._formData.getAll(response._prefix + id);
    for(id = 0; id < response.length; id++)chunks = response[id], "C" === chunks[0] ? controller.close("C" === chunks ? '"$undefined"' : chunks.slice(1)) : controller.enqueueModel(chunks);
}
function parseReadableStream(response, reference, type) {
    reference = parseInt(reference.slice(2), 16);
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, reference, type, {
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new Chunk("resolved_model", json, -1, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$26 = createPendingChunk(response);
                chunk$26.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$26;
                chunk.then(function() {
                    previousBlockedChunk === chunk$26 && (previousBlockedChunk = null);
                    resolveModelChunk(chunk$26, json, -1);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
    return type;
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function parseAsyncIterable(response, reference, iterator) {
    reference = parseInt(reference.slice(2), 16);
    var buffer = [], closed = !1, nextWriteIndex = 0, $jscomp$compprop2 = {};
    $jscomp$compprop2 = ($jscomp$compprop2[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new Chunk("fulfilled", {
                    done: !0,
                    value: void 0
                }, null, response);
                buffer[nextReadIndex] = createPendingChunk(response);
            }
            return buffer[nextReadIndex++];
        });
    }, $jscomp$compprop2);
    iterator = iterator ? $jscomp$compprop2[ASYNC_ITERATOR]() : $jscomp$compprop2;
    resolveStream(response, reference, iterator, {
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = createPendingChunk(response)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(buffer[nextWriteIndex++], error);
        }
    });
    return iterator;
}
function parseModelString(response, obj, key, value, reference) {
    if ("$" === value[0]) {
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "@":
                return obj = parseInt(value.slice(2), 16), getChunk(response, obj);
            case "F":
                return value = value.slice(2), value = getOutlinedModel(response, value, obj, key, createModel), loadServerReference$1(response, value.id, value.bound, initializingChunk, obj, key);
            case "T":
                if (void 0 === reference || void 0 === response._temporaryReferences) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
                return createTemporaryReference(response._temporaryReferences, reference);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createSet);
            case "K":
                obj = value.slice(2);
                var formPrefix = response._prefix + obj + "_", data = new FormData();
                response._formData.forEach(function(entry, entryKey) {
                    entryKey.startsWith(formPrefix) && data.append(entryKey.slice(formPrefix.length), entry);
                });
                return data;
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
        }
        switch(value[1]){
            case "A":
                return parseTypedArray(response, value, ArrayBuffer, 1, obj, key);
            case "O":
                return parseTypedArray(response, value, Int8Array, 1, obj, key);
            case "o":
                return parseTypedArray(response, value, Uint8Array, 1, obj, key);
            case "U":
                return parseTypedArray(response, value, Uint8ClampedArray, 1, obj, key);
            case "S":
                return parseTypedArray(response, value, Int16Array, 2, obj, key);
            case "s":
                return parseTypedArray(response, value, Uint16Array, 2, obj, key);
            case "L":
                return parseTypedArray(response, value, Int32Array, 4, obj, key);
            case "l":
                return parseTypedArray(response, value, Uint32Array, 4, obj, key);
            case "G":
                return parseTypedArray(response, value, Float32Array, 4, obj, key);
            case "g":
                return parseTypedArray(response, value, Float64Array, 8, obj, key);
            case "M":
                return parseTypedArray(response, value, BigInt64Array, 8, obj, key);
            case "m":
                return parseTypedArray(response, value, BigUint64Array, 8, obj, key);
            case "V":
                return parseTypedArray(response, value, DataView, 1, obj, key);
            case "B":
                return obj = parseInt(value.slice(2), 16), response._formData.get(response._prefix + obj);
        }
        switch(value[1]){
            case "R":
                return parseReadableStream(response, value, void 0);
            case "r":
                return parseReadableStream(response, value, "bytes");
            case "X":
                return parseAsyncIterable(response, value, !1);
            case "x":
                return parseAsyncIterable(response, value, !0);
        }
        value = value.slice(1);
        return getOutlinedModel(response, value, obj, key, createModel);
    }
    return value;
}
function createResponse(bundlerConfig, formFieldPrefix, temporaryReferences) {
    var backingFormData = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : new FormData(), chunks = new Map();
    return {
        _bundlerConfig: bundlerConfig,
        _prefix: formFieldPrefix,
        _formData: backingFormData,
        _chunks: chunks,
        _closed: !1,
        _closedReason: null,
        _temporaryReferences: temporaryReferences
    };
}
function close(response) {
    reportGlobalError(response, Error("Connection closed."));
}
function loadServerReference(bundlerConfig, id, bound) {
    var serverReference = resolveServerReference(bundlerConfig, id);
    bundlerConfig = preloadModule$1(serverReference);
    return bound ? Promise.all([
        bound,
        bundlerConfig
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    }) : bundlerConfig ? Promise.resolve(bundlerConfig).then(function() {
        return requireModule(serverReference);
    }) : Promise.resolve(requireModule(serverReference));
}
function decodeBoundActionMetaData(body, serverManifest, formFieldPrefix) {
    body = createResponse(serverManifest, formFieldPrefix, void 0, body);
    close(body);
    body = getChunk(body, 0);
    body.then(function() {});
    if ("fulfilled" !== body.status) throw body.reason;
    return body.value;
}
function decodeAction$1(body, serverManifest) {
    var formData = new FormData(), action = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_") ? key.startsWith("$ACTION_REF_") ? (value = "$ACTION_" + key.slice(12) + ":", value = decodeBoundActionMetaData(body, serverManifest, value), action = loadServerReference(serverManifest, value.id, value.bound)) : key.startsWith("$ACTION_ID_") && (value = key.slice(11), action = loadServerReference(serverManifest, value, null)) : formData.append(key, value);
    });
    return null === action ? null : action.then(function(fn) {
        return fn.bind(null, formData);
    });
}
function decodeFormState$1(actionResult, body, serverManifest) {
    var keyPath = body.get("$ACTION_KEY");
    if ("string" !== typeof keyPath) return Promise.resolve(null);
    var metaData = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_REF_") && (value = "$ACTION_" + key.slice(12) + ":", metaData = decodeBoundActionMetaData(body, serverManifest, value));
    });
    if (null === metaData) return Promise.resolve(null);
    var referenceId = metaData.id;
    return Promise.resolve(metaData.bound).then(function(bound) {
        return null === bound ? null : [
            actionResult,
            keyPath,
            referenceId,
            bound.length - 1
        ];
    });
}
var serverManifest = {};
exports.createClientReference = function(id, exportName, bundles, importMap) {
    return {
        $$typeof: CLIENT_REFERENCE_TAG$1,
        $$id: id,
        $$name: exportName,
        $$bundles: bundles,
        $$importMap: importMap
    };
};
exports.createTemporaryReferenceSet = function() {
    return new WeakMap();
};
exports.decodeAction = function(body) {
    return decodeAction$1(body, serverManifest);
};
exports.decodeFormState = function(actionResult, body) {
    return decodeFormState$1(actionResult, body, serverManifest);
};
exports.decodeReply = function(body, options) {
    if ("string" === typeof body) {
        var form = new FormData();
        form.append("0", body);
        body = form;
    }
    body = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0, body);
    options = getChunk(body, 0);
    close(body);
    return options;
};
exports.decodeReplyFromAsyncIterable = function(iterable, options) {
    function progress(entry) {
        if (entry.done) close(response);
        else {
            entry = entry.value;
            var name = entry[0];
            entry = entry[1];
            if ("string" === typeof entry) {
                response._formData.append(name, entry);
                var prefix = response._prefix;
                if (name.startsWith(prefix)) {
                    var chunks = response._chunks;
                    name = +name.slice(prefix.length);
                    (chunks = chunks.get(name)) && resolveModelChunk(chunks, entry, name);
                }
            } else response._formData.append(name, entry);
            iterator.next().then(progress, error);
        }
    }
    function error(reason) {
        reportGlobalError(response, reason);
        "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
    }
    var iterator = iterable[ASYNC_ITERATOR](), response = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0);
    iterator.next().then(progress, error);
    return getChunk(response, 0);
};
exports.loadServerAction = function(id) {
    var reference = resolveServerReference(serverManifest, id);
    return Promise.resolve(reference).then(function() {
        return preloadModule$1(reference);
    }).then(function() {
        var fn = requireModule(reference);
        if ("function" !== typeof fn) throw Error("Server actions must be functions");
        return fn;
    });
};
exports.registerServerActions = function(manifest) {
    serverManifest = manifest;
};
exports.registerServerReference = function(reference, id, exportName) {
    return Object.defineProperties(reference, {
        $$typeof: {
            value: SERVER_REFERENCE_TAG
        },
        $$id: {
            value: id + "#" + exportName,
            configurable: !0
        },
        $$bound: {
            value: null,
            configurable: !0
        },
        bind: {
            value: bind,
            configurable: !0
        }
    });
};
exports.renderToReadableStream = function(model, options) {
    var request = new RequestInstance(20, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, noop, noop, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
    if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
            var listener = function() {
                abort(request, signal.reason);
                signal.removeEventListener("abort", listener);
            };
            signal.addEventListener("abort", listener);
        }
    }
    return new ReadableStream({
        type: "bytes",
        start: function() {
            startWork(request);
        },
        pull: function(controller) {
            startFlowing(request, controller);
        },
        cancel: function(reason) {
            request.destination = null;
            abort(request, reason);
        }
    }, {
        highWaterMark: 0
    });
};
exports.unstable_prerender = function(model, options) {
    return new Promise(function(resolve, reject) {
        var request = new RequestInstance(21, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            resolve({
                prelude: stream
            });
        }, reject, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(request, signal.reason);
            else {
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        startWork(request);
    });
};

},{"2381f0f3ff03ff95":"gC2PC","6db66a729b66b575":"a1TxN"}],"gC2PC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"c4Fud"}],"c4Fud":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.0";

},{"6a05e75e64e4f862":"a1TxN"}],"a1TxN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"4tF2f"}],"4tF2f":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.0";

},{}],"2Is6Z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"6vHrA"}],"6vHrA":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"7i8km":[function(require,module,exports,__globalThis) {
/* eslint-disable rulesdir/imports */ /* eslint-disable monorepo/no-internal-import */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponentCardView", ()=>ComponentCardView);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ActionButton.svg");
var _actionButtonSvgDefault = parcelHelpers.interopDefault(_actionButtonSvg);
var _actionGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ActionGroup.svg");
var _actionGroupSvgDefault = parcelHelpers.interopDefault(_actionGroupSvg);
var _badgeSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Badge.svg");
var _badgeSvgDefault = parcelHelpers.interopDefault(_badgeSvg);
var _breadcrumbsSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Breadcrumbs.svg");
var _breadcrumbsSvgDefault = parcelHelpers.interopDefault(_breadcrumbsSvg);
var _buttonGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ButtonGroup.svg");
var _buttonGroupSvgDefault = parcelHelpers.interopDefault(_buttonGroupSvg);
var _buttonSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Button.svg");
var _buttonSvgDefault = parcelHelpers.interopDefault(_buttonSvg);
var _calendarSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Calendar.svg");
var _calendarSvgDefault = parcelHelpers.interopDefault(_calendarSvg);
var _s2 = require("@react-spectrum/s2");
var _checkboxGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/CheckboxGroup.svg");
var _checkboxGroupSvgDefault = parcelHelpers.interopDefault(_checkboxGroupSvg);
var _checkboxSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Checkbox.svg");
var _checkboxSvgDefault = parcelHelpers.interopDefault(_checkboxSvg);
var _collectionsSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Collections.svg");
var _collectionsSvgDefault = parcelHelpers.interopDefault(_collectionsSvg);
var _colorAreaSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorArea.svg");
var _colorAreaSvgDefault = parcelHelpers.interopDefault(_colorAreaSvg);
var _colorFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorField.svg");
var _colorFieldSvgDefault = parcelHelpers.interopDefault(_colorFieldSvg);
var _colorPickerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorPicker.svg");
var _colorPickerSvgDefault = parcelHelpers.interopDefault(_colorPickerSvg);
var _colorSliderSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorSlider.svg");
var _colorSliderSvgDefault = parcelHelpers.interopDefault(_colorSliderSvg);
var _colorSwatchPickerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatchPicker.svg");
var _colorSwatchPickerSvgDefault = parcelHelpers.interopDefault(_colorSwatchPickerSvg);
var _colorSwatchSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatch.svg");
var _colorSwatchSvgDefault = parcelHelpers.interopDefault(_colorSwatchSvg);
var _colorWheelSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorWheel.svg");
var _colorWheelSvgDefault = parcelHelpers.interopDefault(_colorWheelSvg);
var _comboBoxSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ComboBox.svg");
var _comboBoxSvgDefault = parcelHelpers.interopDefault(_comboBoxSvg);
var _comingSoonSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ComingSoon.svg");
var _comingSoonSvgDefault = parcelHelpers.interopDefault(_comingSoonSvg);
var _contextualHelpSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ContextualHelp.svg");
var _contextualHelpSvgDefault = parcelHelpers.interopDefault(_contextualHelpSvg);
var _dateFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DateField.svg");
var _dateFieldSvgDefault = parcelHelpers.interopDefault(_dateFieldSvg);
var _datePickerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DatePicker.svg");
var _datePickerSvgDefault = parcelHelpers.interopDefault(_datePickerSvg);
var _dateRangePickerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DateRangePicker.svg");
var _dateRangePickerSvgDefault = parcelHelpers.interopDefault(_dateRangePickerSvg);
var _dialogSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Dialog.svg");
var _dialogSvgDefault = parcelHelpers.interopDefault(_dialogSvg);
var _disclosureGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DisclosureGroup.svg");
var _disclosureGroupSvgDefault = parcelHelpers.interopDefault(_disclosureGroupSvg);
var _disclosureSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Disclosure.svg");
var _disclosureSvgDefault = parcelHelpers.interopDefault(_disclosureSvg);
var _dragAndDropSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DragAndDrop.svg");
var _dragAndDropSvgDefault = parcelHelpers.interopDefault(_dragAndDropSvg);
var _dropZoneSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DropZone.svg");
var _dropZoneSvgDefault = parcelHelpers.interopDefault(_dropZoneSvg);
var _fileTriggerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/FileTrigger.svg");
var _fileTriggerSvgDefault = parcelHelpers.interopDefault(_fileTriggerSvg);
var _focusScopeSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/FocusScope.svg");
var _focusScopeSvgDefault = parcelHelpers.interopDefault(_focusScopeSvg);
var _formSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Form.svg");
var _formSvgDefault = parcelHelpers.interopDefault(_formSvg);
var _inputSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Input.svg");
var _inputSvgDefault = parcelHelpers.interopDefault(_inputSvg);
var _internationalizedDateSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/InternationalizedDate.svg");
var _internationalizedDateSvgDefault = parcelHelpers.interopDefault(_internationalizedDateSvg);
var _labeledValueSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/LabeledValue.svg");
var _labeledValueSvgDefault = parcelHelpers.interopDefault(_labeledValueSvg);
var _labelSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Label.svg");
var _labelSvgDefault = parcelHelpers.interopDefault(_labelSvg);
var _linkSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Link.svg");
var _linkSvgDefault = parcelHelpers.interopDefault(_linkSvg);
var _listBoxSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ListBox.svg");
var _listBoxSvgDefault = parcelHelpers.interopDefault(_listBoxSvg);
var _listViewSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ListView.svg");
var _listViewSvgDefault = parcelHelpers.interopDefault(_listViewSvg);
var _menuSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Menu.svg");
var _menuSvgDefault = parcelHelpers.interopDefault(_menuSvg);
var _meterSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Meter.svg");
var _meterSvgDefault = parcelHelpers.interopDefault(_meterSvg);
var _numberFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/NumberField.svg");
var _numberFieldSvgDefault = parcelHelpers.interopDefault(_numberFieldSvg);
var _pickerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Picker.svg");
var _pickerSvgDefault = parcelHelpers.interopDefault(_pickerSvg);
var _popoverSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Popover.svg");
var _popoverSvgDefault = parcelHelpers.interopDefault(_popoverSvg);
var _progressBarSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ProgressBar.svg");
var _progressBarSvgDefault = parcelHelpers.interopDefault(_progressBarSvg);
var _progressCircleSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ProgressCircle.svg");
var _progressCircleSvgDefault = parcelHelpers.interopDefault(_progressCircleSvg);
var _radioGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/RadioGroup.svg");
var _radioGroupSvgDefault = parcelHelpers.interopDefault(_radioGroupSvg);
var _rangeCalendarSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/RangeCalendar.svg");
var _rangeCalendarSvgDefault = parcelHelpers.interopDefault(_rangeCalendarSvg);
var _rangeSliderSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/RangeSlider.svg");
var _rangeSliderSvgDefault = parcelHelpers.interopDefault(_rangeSliderSvg);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/SearchField.svg");
var _searchFieldSvgDefault = parcelHelpers.interopDefault(_searchFieldSvg);
var _selectionSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Selection.svg");
var _selectionSvgDefault = parcelHelpers.interopDefault(_selectionSvg);
var _sliderSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Slider.svg");
var _sliderSvgDefault = parcelHelpers.interopDefault(_sliderSvg);
var _statusLightSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/StatusLight.svg");
var _statusLightSvgDefault = parcelHelpers.interopDefault(_statusLightSvg);
var _switchSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Switch.svg");
var _switchSvgDefault = parcelHelpers.interopDefault(_switchSvg);
var _tableSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Table.svg");
var _tableSvgDefault = parcelHelpers.interopDefault(_tableSvg);
var _tabsSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Tabs.svg");
var _tabsSvgDefault = parcelHelpers.interopDefault(_tabsSvg);
var _tagGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/TagGroup.svg");
var _tagGroupSvgDefault = parcelHelpers.interopDefault(_tagGroupSvg);
var _textAreaSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/TextArea.svg");
var _textAreaSvgDefault = parcelHelpers.interopDefault(_textAreaSvg);
var _textFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/TextField.svg");
var _textFieldSvgDefault = parcelHelpers.interopDefault(_textFieldSvg);
var _timeFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/TimeField.svg");
var _timeFieldSvgDefault = parcelHelpers.interopDefault(_timeFieldSvg);
var _toastSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Toast.svg");
var _toastSvgDefault = parcelHelpers.interopDefault(_toastSvg);
var _toggleButtonSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ToggleButton.svg");
var _toggleButtonSvgDefault = parcelHelpers.interopDefault(_toggleButtonSvg);
var _tooltipSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Tooltip.svg");
var _tooltipSvgDefault = parcelHelpers.interopDefault(_tooltipSvg);
var _treeSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Tree.svg");
var _treeSvgDefault = parcelHelpers.interopDefault(_treeSvg);
var _useFocusRingSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useFocusRing.svg");
var _useFocusRingSvgDefault = parcelHelpers.interopDefault(_useFocusRingSvg);
var _useFocusSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useFocus.svg");
var _useFocusSvgDefault = parcelHelpers.interopDefault(_useFocusSvg);
var _useFocusWithinSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useFocusWithin.svg");
var _useFocusWithinSvgDefault = parcelHelpers.interopDefault(_useFocusWithinSvg);
var _useHoverSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useHover.svg");
var _useHoverSvgDefault = parcelHelpers.interopDefault(_useHoverSvg);
var _useKeyboardSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useKeyboard.svg");
var _useKeyboardSvgDefault = parcelHelpers.interopDefault(_useKeyboardSvg);
var _useLongPressSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useLongPress.svg");
var _useLongPressSvgDefault = parcelHelpers.interopDefault(_useLongPressSvg);
var _useMoveSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useMove.svg");
var _useMoveSvgDefault = parcelHelpers.interopDefault(_useMoveSvg);
var _usePressSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/usePress.svg");
var _usePressSvgDefault = parcelHelpers.interopDefault(_usePressSvg);
'use client';
const componentIllustrations = {
    'ActionButton': (0, _actionButtonSvgDefault.default),
    'ActionGroup': (0, _actionGroupSvgDefault.default),
    'Badge': (0, _badgeSvgDefault.default),
    'Breadcrumbs': (0, _breadcrumbsSvgDefault.default),
    'Button': (0, _buttonSvgDefault.default),
    'ButtonGroup': (0, _buttonGroupSvgDefault.default),
    'Calendar': (0, _calendarSvgDefault.default),
    'Checkbox': (0, _checkboxSvgDefault.default),
    'CheckboxGroup': (0, _checkboxGroupSvgDefault.default),
    'Collections': (0, _collectionsSvgDefault.default),
    'ColorArea': (0, _colorAreaSvgDefault.default),
    'ColorField': (0, _colorFieldSvgDefault.default),
    'ColorPicker': (0, _colorPickerSvgDefault.default),
    'ColorSlider': (0, _colorSliderSvgDefault.default),
    'ColorSwatch': (0, _colorSwatchSvgDefault.default),
    'ColorSwatchPicker': (0, _colorSwatchPickerSvgDefault.default),
    'ColorWheel': (0, _colorWheelSvgDefault.default),
    'ComboBox': (0, _comboBoxSvgDefault.default),
    'ContextualHelp': (0, _contextualHelpSvgDefault.default),
    'DateField': (0, _dateFieldSvgDefault.default),
    'DatePicker': (0, _datePickerSvgDefault.default),
    'DateRangePicker': (0, _dateRangePickerSvgDefault.default),
    'Dialog': (0, _dialogSvgDefault.default),
    'Disclosure': (0, _disclosureSvgDefault.default),
    'DisclosureGroup': (0, _disclosureGroupSvgDefault.default),
    'Drag and Drop': (0, _dragAndDropSvgDefault.default),
    'DropZone': (0, _dropZoneSvgDefault.default),
    'FileTrigger': (0, _fileTriggerSvgDefault.default),
    'FocusScope': (0, _focusScopeSvgDefault.default),
    'Form': (0, _formSvgDefault.default),
    'GridList': (0, _listViewSvgDefault.default),
    'Input': (0, _inputSvgDefault.default),
    'InternationalizedDate': (0, _internationalizedDateSvgDefault.default),
    'Label': (0, _labelSvgDefault.default),
    'LabeledValue': (0, _labeledValueSvgDefault.default),
    'Link': (0, _linkSvgDefault.default),
    'ListBox': (0, _listBoxSvgDefault.default),
    'ListView': (0, _listViewSvgDefault.default),
    'Menu': (0, _menuSvgDefault.default),
    'Meter': (0, _meterSvgDefault.default),
    'NumberField': (0, _numberFieldSvgDefault.default),
    'Picker': (0, _pickerSvgDefault.default),
    'Popover': (0, _popoverSvgDefault.default),
    'ProgressBar': (0, _progressBarSvgDefault.default),
    'ProgressCircle': (0, _progressCircleSvgDefault.default),
    'RadioGroup': (0, _radioGroupSvgDefault.default),
    'RangeCalendar': (0, _rangeCalendarSvgDefault.default),
    'RangeSlider': (0, _rangeSliderSvgDefault.default),
    'SearchField': (0, _searchFieldSvgDefault.default),
    'Select': (0, _pickerSvgDefault.default),
    'Selection': (0, _selectionSvgDefault.default),
    'Slider': (0, _sliderSvgDefault.default),
    'StatusLight': (0, _statusLightSvgDefault.default),
    'Switch': (0, _switchSvgDefault.default),
    'Table': (0, _tableSvgDefault.default),
    'Tabs': (0, _tabsSvgDefault.default),
    'TagGroup': (0, _tagGroupSvgDefault.default),
    'TextArea': (0, _textAreaSvgDefault.default),
    'TextField': (0, _textFieldSvgDefault.default),
    'TimeField': (0, _timeFieldSvgDefault.default),
    'Toast': (0, _toastSvgDefault.default),
    'ToggleButton': (0, _toggleButtonSvgDefault.default),
    'ToggleButtonGroup': (0, _actionGroupSvgDefault.default),
    'Tooltip': (0, _tooltipSvgDefault.default),
    'Tree': (0, _treeSvgDefault.default),
    'useFocus': (0, _useFocusSvgDefault.default),
    'useFocusRing': (0, _useFocusRingSvgDefault.default),
    'useFocusWithin': (0, _useFocusWithinSvgDefault.default),
    'useHover': (0, _useHoverSvgDefault.default),
    'useKeyboard': (0, _useKeyboardSvgDefault.default),
    'useLongPress': (0, _useLongPressSvgDefault.default),
    'useMove': (0, _useMoveSvgDefault.default),
    'usePress': (0, _usePressSvgDefault.default)
};
const illustrationStyles = " Za111 fc111 _Hb111 _4c111 _Ob111";
function ComponentCardView({ items, ariaLabel = 'Items', size = 'S', onAction, styles, renderEmptyState }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CardView), {
        "aria-label": ariaLabel,
        onAction: onAction,
        styles: styles,
        renderEmptyState: renderEmptyState,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Collection), {
            items: items,
            children: (item)=>{
                let IllustrationComponent = componentIllustrations[item.name] || (0, _comingSoonSvgDefault.default);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Card), {
                    id: item.id,
                    href: item.href,
                    size: size,
                    textValue: item.name,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CardPreview), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IllustrationComponent, {
                                "aria-hidden": "true",
                                // @ts-ignore
                                className: illustrationStyles
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Content), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                slot: "title",
                                children: item.name
                            })
                        })
                    ]
                }, item.id);
            }
        })
    });
}

},{"0":"54QRr","react/jsx-runtime":"2Is6Z","@react-spectrum/docs/pages/assets/component-illustrations/ActionButton.svg":"32Qb1","@react-spectrum/docs/pages/assets/component-illustrations/ActionGroup.svg":"749IL","@react-spectrum/docs/pages/assets/component-illustrations/Badge.svg":"d7JsK","@react-spectrum/docs/pages/assets/component-illustrations/Breadcrumbs.svg":"9ln6U","@react-spectrum/docs/pages/assets/component-illustrations/ButtonGroup.svg":"8pq6F","@react-spectrum/docs/pages/assets/component-illustrations/Button.svg":"a6qxN","@react-spectrum/docs/pages/assets/component-illustrations/Calendar.svg":"2DS4y","@react-spectrum/s2":"5H6IX","@react-spectrum/docs/pages/assets/component-illustrations/CheckboxGroup.svg":"jrm4a","@react-spectrum/docs/pages/assets/component-illustrations/Checkbox.svg":"9wByF","@react-spectrum/docs/pages/assets/component-illustrations/Collections.svg":"jj4o5","@react-spectrum/docs/pages/assets/component-illustrations/ColorArea.svg":"eJLkP","@react-spectrum/docs/pages/assets/component-illustrations/ColorField.svg":"12joK","@react-spectrum/docs/pages/assets/component-illustrations/ColorPicker.svg":"1BR1d","@react-spectrum/docs/pages/assets/component-illustrations/ColorSlider.svg":"dfoTB","@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatchPicker.svg":"30UMi","@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatch.svg":"N8yCP","@react-spectrum/docs/pages/assets/component-illustrations/ColorWheel.svg":"35Nt5","@react-spectrum/docs/pages/assets/component-illustrations/ComboBox.svg":"kjTat","@react-spectrum/docs/pages/assets/component-illustrations/ComingSoon.svg":"bC9JX","@react-spectrum/docs/pages/assets/component-illustrations/ContextualHelp.svg":"krLkr","@react-spectrum/docs/pages/assets/component-illustrations/DateField.svg":"csR8J","@react-spectrum/docs/pages/assets/component-illustrations/DatePicker.svg":"8umtV","@react-spectrum/docs/pages/assets/component-illustrations/DateRangePicker.svg":"77fJM","@react-spectrum/docs/pages/assets/component-illustrations/Dialog.svg":"6xupb","@react-spectrum/docs/pages/assets/component-illustrations/DisclosureGroup.svg":"8qSw5","@react-spectrum/docs/pages/assets/component-illustrations/Disclosure.svg":"ZkpS9","@react-spectrum/docs/pages/assets/component-illustrations/DragAndDrop.svg":"8C03J","@react-spectrum/docs/pages/assets/component-illustrations/DropZone.svg":"enjcP","@react-spectrum/docs/pages/assets/component-illustrations/FileTrigger.svg":"fw3EC","@react-spectrum/docs/pages/assets/component-illustrations/FocusScope.svg":"ejGAP","@react-spectrum/docs/pages/assets/component-illustrations/Form.svg":"9IhhB","@react-spectrum/docs/pages/assets/component-illustrations/Input.svg":"klfEz","@react-spectrum/docs/pages/assets/component-illustrations/InternationalizedDate.svg":"fOc8v","@react-spectrum/docs/pages/assets/component-illustrations/LabeledValue.svg":"a9loY","@react-spectrum/docs/pages/assets/component-illustrations/Label.svg":"6zU7Z","@react-spectrum/docs/pages/assets/component-illustrations/Link.svg":"awi79","@react-spectrum/docs/pages/assets/component-illustrations/ListBox.svg":"g2KkD","@react-spectrum/docs/pages/assets/component-illustrations/ListView.svg":"8p8fn","@react-spectrum/docs/pages/assets/component-illustrations/Menu.svg":"8ru7h","@react-spectrum/docs/pages/assets/component-illustrations/Meter.svg":"lkbAG","@react-spectrum/docs/pages/assets/component-illustrations/NumberField.svg":"flFdy","@react-spectrum/docs/pages/assets/component-illustrations/Picker.svg":"5TMfC","@react-spectrum/docs/pages/assets/component-illustrations/Popover.svg":"2P2zw","@react-spectrum/docs/pages/assets/component-illustrations/ProgressBar.svg":"1rojz","@react-spectrum/docs/pages/assets/component-illustrations/ProgressCircle.svg":"4067p","@react-spectrum/docs/pages/assets/component-illustrations/RadioGroup.svg":"lj97x","@react-spectrum/docs/pages/assets/component-illustrations/RangeCalendar.svg":"kkyyl","@react-spectrum/docs/pages/assets/component-illustrations/RangeSlider.svg":"exnCX","react":"a1TxN","@react-spectrum/docs/pages/assets/component-illustrations/SearchField.svg":"7ohvF","@react-spectrum/docs/pages/assets/component-illustrations/Selection.svg":"l7OQE","@react-spectrum/docs/pages/assets/component-illustrations/Slider.svg":"rQclf","@react-spectrum/docs/pages/assets/component-illustrations/StatusLight.svg":"fFIzk","@react-spectrum/docs/pages/assets/component-illustrations/Switch.svg":"cpk35","@react-spectrum/docs/pages/assets/component-illustrations/Table.svg":"bnlGy","@react-spectrum/docs/pages/assets/component-illustrations/Tabs.svg":"blsK2","@react-spectrum/docs/pages/assets/component-illustrations/TagGroup.svg":"k8kpp","@react-spectrum/docs/pages/assets/component-illustrations/TextArea.svg":"aIwiG","@react-spectrum/docs/pages/assets/component-illustrations/TextField.svg":"40HrI","@react-spectrum/docs/pages/assets/component-illustrations/TimeField.svg":"bc9cR","@react-spectrum/docs/pages/assets/component-illustrations/Toast.svg":"4qrBC","@react-spectrum/docs/pages/assets/component-illustrations/ToggleButton.svg":"ljWCz","@react-spectrum/docs/pages/assets/component-illustrations/Tooltip.svg":"i9JRq","@react-spectrum/docs/pages/assets/component-illustrations/Tree.svg":"2jbL9","@react-spectrum/docs/pages/assets/component-illustrations/useFocusRing.svg":"atBPa","@react-spectrum/docs/pages/assets/component-illustrations/useFocus.svg":"bKLu9","@react-spectrum/docs/pages/assets/component-illustrations/useFocusWithin.svg":"6rzJ2","@react-spectrum/docs/pages/assets/component-illustrations/useHover.svg":"fdavU","@react-spectrum/docs/pages/assets/component-illustrations/useKeyboard.svg":"d2wmU","@react-spectrum/docs/pages/assets/component-illustrations/useLongPress.svg":"6sD3B","@react-spectrum/docs/pages/assets/component-illustrations/useMove.svg":"6ZHMO","@react-spectrum/docs/pages/assets/component-illustrations/usePress.svg":"9O6bO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"54QRr":[function() {},{}],"32Qb1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgActionButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 70 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-75)",
                stroke: "var(--anatomy-gray-400)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 69,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-700)",
                d: "M26.784 11.1 23.9 8.216a.6.6 0 0 0-.433-.176h-.017a.69.69 0 0 0-.464.2L12.542 18.686a.5.5 0 0 0-.126.211l-1.388 4.653c-.057.188.229.426.391.426h.031c.138-.031 3.933-1.172 4.656-1.389a.5.5 0 0 0 .207-.125l10.444-10.448a.7.7 0 0 0 .2-.441.6.6 0 0 0-.173-.473M15.7 21.658c-1.081.325-2.431.733-3.365 1.011l1-3.365Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(36 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Edit"
                })
            })
        ]
    });
exports.default = SvgActionButton;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3OmcS":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"749IL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgActionGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 94 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-700)",
                        d: "M4 0h28v32H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-700)",
                        d: "M4 0h28v32H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 1a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h28a1 1 0 0 0-1 1V0a1 1 0 0 0 1 1Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(9 21)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 15,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(9 9)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(9 13)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 15,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(9 17)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-75)",
                        d: "M31 0h32v32H31Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-400)",
                        d: "M31 0h32v32H31Zm0 1a1 1 0 0 0 1-1v32a1 1 0 0 0-1-1h32a1 1 0 0 0-1 1V0a1 1 0 0 0 1 1Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-700)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 10,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(42 21)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 16,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(39 17)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 16,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(39 9)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 10,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(42 13)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-75)",
                        d: "M62 0h28a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H62Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-400)",
                        d: "M62 0h28a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H62Zm0 1a1 1 0 0 0 1-1v32a1 1 0 0 0-1-1h28a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-700)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(73 21)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 15,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(70 9)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(73 13)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 15,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(70 17)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgActionGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d7JsK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBadge = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 30,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 30px)/2) 10px"
        },
        viewBox: "0 0 82 30",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 82,
                height: 30,
                fill: "var(--anatomy-gray-700)",
                rx: 5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-50)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 15,
                transform: "translate(11 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Approved"
                })
            })
        ]
    });
exports.default = SvgBadge;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9ln6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBreadcrumbs = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 20,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 20px)/2) 10px"
        },
        viewBox: "0 0 173 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-600)",
                    d: "M53.466 11.108a.8.8 0 0 1-.234.563l-3.192 3.19a.8.8 0 1 1-1.148-1.108l.02-.02 2.627-2.625-2.627-2.627a.8.8 0 0 1 1.108-1.147l.02.02 3.191 3.19a.8.8 0 0 1 .234.564Z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-600)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Home"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-600)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                transform: "translate(62 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Assets"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                fontWeight: 700,
                transform: "translate(125 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Photos"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M116.466 11.108a.8.8 0 0 1-.234.563l-3.192 3.19a.8.8 0 1 1-1.148-1.108l.02-.02 2.627-2.625-2.627-2.627a.8.8 0 0 1 1.108-1.147l.02.02 3.191 3.19a.8.8 0 0 1 .234.564Z"
                    })
                })
            })
        ]
    });
exports.default = SvgBreadcrumbs;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8pq6F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgButtonGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 162 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "rgba(0,0,0,0)",
                stroke: "var(--anatomy-gray-400)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 72,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 30,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 700,
                transform: "translate(17 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Cancel"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(0,0,0,0)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 2,
                        transform: "translate(88)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 74,
                                height: 32,
                                stroke: "none",
                                rx: 16
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 72,
                                height: 30,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 15
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        transform: "translate(104 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Submit"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgButtonGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a6qxN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 72 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-600)",
                stroke: "rgba(0,0,0,0)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 72,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 71,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 15.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 700,
                transform: "translate(22 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Save"
                })
            })
        ]
    });
exports.default = SvgButton;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2DS4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCalendar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            padding: 10,
            maxHeight: 153,
            boxSizing: "border-box"
        },
        viewBox: "102 0 300 182",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-236 -34)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 18,
                    fontWeight: 700,
                    transform: "translate(489 52)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -60.426,
                        y: 0,
                        children: "September 2021"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(369 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.976,
                        y: 0,
                        children: "S"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(411 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -4.986,
                        y: 0,
                        children: "M"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(449 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.24,
                        y: 0,
                        children: "T"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(490 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.13,
                        y: 0,
                        children: "W"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(529 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.24,
                        y: 0,
                        children: "T"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(568 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.048,
                        y: 0,
                        children: "F"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.36,
                        y: 0,
                        children: "5"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.045,
                        y: 0,
                        children: "7"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.57,
                        y: 0,
                        children: "8"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.633,
                        y: 0,
                        children: "9"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.349,
                        y: 0,
                        children: "10"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.048,
                        y: 0,
                        children: "13"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.174,
                        y: 0,
                        children: "14"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.971,
                        y: 0,
                        children: "15"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.349,
                        y: 0,
                        children: "16"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.23,
                        y: 0,
                        children: "19"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.378,
                        y: 0,
                        children: "20"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.013,
                        y: 0,
                        children: "21"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.203,
                        y: 0,
                        children: "22"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.231,
                        y: 0,
                        children: "23"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.147,
                        y: 0,
                        children: "24"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.24,
                        y: 0,
                        children: "1"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.304,
                        y: 0,
                        children: "2"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.388,
                        y: 0,
                        children: "3"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-700)",
                    d: "m365.562 46.329 3.535-3.535a1 1 0 0 1 1.415 0 1 1 0 0 1 0 1.414l-2.829 2.828 2.829 2.828a1 1 0 0 1 0 1.415 1 1 0 0 1-1.415 0l-3.535-3.536a1 1 0 0 1-.293-.707 1 1 0 0 1 .293-.707"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.343,
                        y: 0,
                        children: "26"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.832,
                        y: 0,
                        children: "27"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.329,
                        y: 0,
                        children: "29"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.455,
                        y: 0,
                        children: "30"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(408 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.836,
                        y: 0,
                        children: "6"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.252,
                        y: 0,
                        children: "28"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M408 144a16 16 0 1 1-16 16 16 16 0 0 1 16-16"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(608 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.976,
                        y: 0,
                        children: "S"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -4.9,
                        y: 0,
                        children: "11"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.195,
                        y: 0,
                        children: "18"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.154,
                        y: 0,
                        children: "25"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.514,
                        y: 0,
                        children: "4"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-700)",
                    d: "m610.243 47.742-3.535 3.535a1 1 0 0 1-1.415 0 1 1 0 0 1 0-1.414l2.829-2.828-2.829-2.828a1 1 0 0 1 0-1.415 1 1 0 0 1 1.415 0l3.535 3.536a1 1 0 0 1 .293.707 1 1 0 0 1-.293.707"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.985,
                        y: 0,
                        children: "12"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.733,
                        y: 0,
                        children: "17"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-700)",
                    rx: 16,
                    transform: "translate(392 144)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-50)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.689,
                        y: 0,
                        children: "6"
                    })
                })
            ]
        })
    });
exports.default = SvgCalendar;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jrm4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckboxGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 120,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 120px)/2) 10px"
        },
        viewBox: "0 0 78 120",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        fill: "var(--anatomy-gray-700)",
                        rx: 2,
                        transform: "translate(0 9)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-75)",
                        d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Travel"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(0 56)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        fill: "var(--anatomy-gray-700)",
                        rx: 2,
                        transform: "translate(0 9)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-75)",
                            d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Music"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-700)",
                        strokeWidth: 2,
                        transform: "translate(0 97)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 14,
                                height: 14,
                                stroke: "none",
                                rx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 12,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 108)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Shopping"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-700)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    transform: "translate(0 16)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 0,
                        children: "Interests"
                    })
                })
            })
        ]
    });
exports.default = SvgCheckboxGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9wByF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckbox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 79 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                stroke: "rgba(0,0,0,0)",
                transform: "translate(0 9)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        stroke: "none",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 13,
                        height: 13,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 1.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-75)",
                d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(24 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Subscribe"
                })
            })
        ]
    });
exports.default = SvgCheckbox;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jj4o5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCollections = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 108,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 108px)/2) 10px"
        },
        viewBox: "0 0 231 108",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-1347 -1745)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-400)",
                    transform: "translate(1347 1803)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 231,
                            height: 50,
                            stroke: "none",
                            rx: 6
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 230,
                            height: 49,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 5.5
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 167,
                    height: 17,
                    fill: "var(--anatomy-gray-200)",
                    rx: 3,
                    transform: "translate(1399 1811)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-200)",
                    rx: 4,
                    transform: "translate(1359 1812)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 167,
                    height: 11,
                    fill: "var(--anatomy-gray-200)",
                    rx: 3,
                    transform: "translate(1399 1834)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-400)",
                    transform: "translate(1347 1745)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 231,
                            height: 50,
                            stroke: "none",
                            rx: 6
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 230,
                            height: 49,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 5.5
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 167,
                    height: 17,
                    fill: "var(--anatomy-gray-200)",
                    rx: 3,
                    transform: "translate(1399 1753)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-200)",
                    rx: 4,
                    transform: "translate(1359 1754)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 167,
                    height: 11,
                    fill: "var(--anatomy-gray-200)",
                    rx: 3,
                    transform: "translate(1399 1776)"
                })
            ]
        })
    });
exports.default = SvgCollections;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eJLkP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorArea = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 142,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "5px 0"
        },
        viewBox: "0 0 142 142",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "ColorArea_svg__a",
                    x2: 1,
                    y2: 1,
                    gradientUnits: "objectBoundingBox",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0,
                            stopColor: "var(--anatomy-gray-300)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "var(--anatomy-gray-500)"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "url(#ColorArea_svg__a)",
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.1,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 142,
                        height: 142,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 141,
                        height: 141,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-50)",
                strokeWidth: 2,
                transform: "translate(100 47)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 8,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 7
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.42,
                transform: "translate(99 46)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 9,
                        cy: 9,
                        r: 9,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 9,
                        cy: 9,
                        r: 8.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 6,
                cy: 6,
                r: 6,
                fill: "var(--anatomy-gray-400)",
                transform: "translate(102 49)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.42,
                transform: "translate(102 49)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 6,
                        cy: 6,
                        r: 6,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 6,
                        cy: 6,
                        r: 5.5
                    })
                ]
            })
        ]
    });
exports.default = SvgColorArea;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"12joK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 56,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 56px)/2) 10px"
        },
        viewBox: "0 0 176 56",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Background"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 44)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "#ABCDEF"
                })
            })
        ]
    });
exports.default = SvgColorField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1BR1d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorPicker = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 152,
        style: {
            background: "var(--anatomy-gray-100)",
            width: "100%"
        },
        viewBox: "0 0 185.999 160.002",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ColorPicker_svg__c",
                        x2: 0,
                        y1: 1,
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0,
                                stopColor: "var(--anatomy-gray-500)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "var(--anatomy-gray-300)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ColorPicker_svg__b",
                        x1: 1,
                        x2: 0,
                        y1: 1,
                        y2: 0,
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0,
                                stopColor: "var(--anatomy-gray-500)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "var(--anatomy-gray-300)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorPicker_svg__d",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M0 0h20v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "ColorPicker_svg__a",
                        width: 168,
                        height: 160.002,
                        x: 0,
                        y: 0,
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                dy: 1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                result: "blur",
                                stdDeviation: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0.149
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "blur",
                                operator: "in"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in: "SourceGraphic"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        filter: "url(#ColorPicker_svg__a)",
                        transform: "translate(-.001 .001)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M150 152.501H10c-1.93 0-3.5-1.57-3.5-3.501V9C6.5 7.07 8.07 5.5 10 5.5h140c1.93 0 3.5 1.57 3.5 3.501v62.208l.147.146 7.646 7.645-7.646 7.647-.147.146V149c0 1.93-1.57 3.501-3.5 3.501"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "var(--anatomy-gray-400)",
                                    d: "M150 152.001a3.005 3.005 0 0 0 3-3.001V86.585L160.586 79 153 71.415V9A3.005 3.005 0 0 0 150 6H10C8.346 5.999 7 7.346 7 9v140A3.004 3.004 0 0 0 10 152zm0 1H10A4 4 0 0 1 6 149V9A4 4 0 0 1 10 5h140A4 4 0 0 1 154 9v62L162 79l-8 8v62a4 4 0 0 1-4 4.002"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "url(#ColorPicker_svg__b)",
                                stroke: "var(--anatomy-gray-900)",
                                strokeOpacity: 0.1,
                                transform: "translate(13.999 13.001)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 102,
                                        height: 102,
                                        stroke: "none",
                                        rx: 4
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 101,
                                        height: 101,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 3.5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                transform: "translate(13.999 13.001)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-50)",
                                        strokeWidth: 2,
                                        transform: "translate(70 32)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 8,
                                                cy: 8,
                                                r: 8,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 8,
                                                cy: 8,
                                                r: 7
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-900)",
                                        strokeOpacity: 0.42,
                                        transform: "translate(69 31)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 9,
                                                cy: 9,
                                                r: 9,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 9,
                                                cy: 9,
                                                r: 8.5
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 6,
                                        cy: 6,
                                        r: 6,
                                        fill: "var(--anatomy-gray-400)",
                                        transform: "translate(72 34)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-900)",
                                        strokeOpacity: 0.42,
                                        transform: "translate(72 34)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 6,
                                                cy: 6,
                                                r: 6,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 6,
                                                cy: 6,
                                                r: 5.5
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        transform: "translate(121.999 13.001)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 24,
                                height: 102,
                                fill: "var(--anatomy-gray-50)",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "url(#ColorPicker_svg__c)",
                                stroke: "var(--anatomy-gray-900)",
                                strokeOpacity: 0.1,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 24,
                                        height: 102,
                                        stroke: "none",
                                        rx: 4
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 23,
                                        height: 101,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 3.5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-50)",
                                        strokeWidth: 2,
                                        transform: "translate(4 58)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 8,
                                                cy: 8,
                                                r: 8,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 8,
                                                cy: 8,
                                                r: 7
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-900)",
                                        strokeOpacity: 0.42,
                                        transform: "translate(3 57)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 9,
                                                cy: 9,
                                                r: 9,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 9,
                                                cy: 9,
                                                r: 8.5
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 6,
                                        cy: 6,
                                        r: 6,
                                        fill: "var(--anatomy-gray-400)",
                                        transform: "translate(6 60)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-900)",
                                        strokeOpacity: 0.42,
                                        transform: "translate(6 60)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 6,
                                                cy: 6,
                                                r: 6,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 6,
                                                cy: 6,
                                                r: 5.5
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        clipPath: "url(#ColorPicker_svg__d)",
                        transform: "translate(165.999 69.001)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 20,
                                height: 20,
                                fill: "var(--anatomy-gray-400)",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                opacity: 0.51,
                                transform: "translate(.417 .417)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 19.167,
                                    height: 19.167,
                                    fill: "none",
                                    stroke: "var(--anatomy-gray-900)",
                                    rx: 3.5
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "var(--anatomy-gray-50)",
                                stroke: "var(--anatomy-gray-400)",
                                transform: "translate(13.999 121.001)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 132,
                                        height: 24,
                                        stroke: "none",
                                        rx: 4
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 131,
                                        height: 23,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 3.5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(20.999 137.001)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "#ABCDEF"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgColorPicker;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dfoTB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorSlider = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 24,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 24px)/2) 10px"
        },
        viewBox: "0 0 200 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "ColorSlider_svg__a",
                    x2: 1,
                    gradientUnits: "objectBoundingBox",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0,
                            stopColor: "var(--anatomy-gray-300)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "var(--anatomy-gray-500)"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 200,
                height: 24,
                fill: "var(--anatomy-gray-50)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "url(#ColorSlider_svg__a)",
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.1,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 200,
                        height: 24,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 199,
                        height: 23,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-50)",
                strokeWidth: 2,
                transform: "translate(122 4)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 8,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 7
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.42,
                transform: "translate(121 3)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 9,
                        cy: 9,
                        r: 9,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 9,
                        cy: 9,
                        r: 8.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 6,
                cy: 6,
                r: 6,
                fill: "var(--anatomy-gray-400)",
                transform: "translate(124 6)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.42,
                transform: "translate(124 6)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 6,
                        cy: 6,
                        r: 6,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 6,
                        cy: 6,
                        r: 5.5
                    })
                ]
            })
        ]
    });
exports.default = SvgColorSlider;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"30UMi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorSwatchPicker = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        fill: "none",
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2)0",
            width: "100%"
        },
        viewBox: "0 0 236 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-600)",
                    rx: 16
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__b)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 31,
                        height: 31,
                        x: 34.5,
                        y: 0.5,
                        fill: "var(--anatomy-gray-600)",
                        rx: 15.5
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 31,
                        height: 31,
                        x: 34.5,
                        y: 0.5,
                        stroke: "var(--anatomy-gray-800)",
                        rx: 15.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__c)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    x: 68,
                    fill: "var(--anatomy-gray-500)",
                    rx: 16
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__d)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 32,
                        height: 32,
                        x: 102,
                        fill: "var(--anatomy-gray-500)",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 26,
                        height: 26,
                        x: 105,
                        y: 3,
                        stroke: "var(--anatomy-gray-50)",
                        strokeWidth: 2,
                        rx: 13
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 30,
                        height: 30,
                        x: 103,
                        y: 1,
                        stroke: "var(--anatomy-gray-900)",
                        strokeWidth: 2,
                        rx: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__e)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 32,
                        height: 32,
                        x: 136,
                        fill: "var(--anatomy-gray-400)",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 31,
                        height: 31,
                        x: 136.5,
                        y: 0.5,
                        stroke: "var(--anatomy-gray-50)",
                        opacity: 0.2,
                        rx: 15.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__f)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 32,
                        height: 32,
                        x: 170,
                        fill: "var(--anatomy-gray-500)",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 31,
                        height: 31,
                        x: 170.5,
                        y: 0.5,
                        stroke: "var(--anatomy-gray-50)",
                        opacity: 0.2,
                        rx: 15.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__g)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    x: 204,
                    fill: "var(--anatomy-gray-600)",
                    rx: 16
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M0 0h32v32H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M34 0h32v32H34z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__c",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M68 0h32v32H68z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__d",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M102 0h32v32h-32z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__e",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M136 0h32v32h-32z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__f",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M170 0h32v32h-32z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__g",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M204 0h32v32h-32z"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgColorSwatchPicker;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"N8yCP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorSwatch = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        fill: "none",
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2)0",
            width: "100%"
        },
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#ColorSwatch_svg__a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 32,
                        height: 32,
                        fill: "var(--anatomy-gray-500)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 31,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        stroke: "#000",
                        opacity: 0.51,
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "ColorSwatch_svg__a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h32v32H0z"
                    })
                })
            })
        ]
    });
exports.default = SvgColorSwatch;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"35Nt5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorWheel = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 152,
        style: {
            background: "var(--anatomy-gray-100)"
        },
        viewBox: "0 0 192.002 192",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "ColorWheel_svg__a",
                    x2: 1,
                    gradientUnits: "objectBoundingBox",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0,
                            stopColor: "var(--anatomy-gray-300)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "var(--anatomy-gray-500)"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "url(#ColorWheel_svg__a)",
                        d: "M96 192a96.7 96.7 0 0 1-19.347-1.95 95.97 95.97 0 0 1-74.7-74.7 96.9 96.9 0 0 1 0-38.7 95.97 95.97 0 0 1 74.7-74.7 96.9 96.9 0 0 1 38.7 0 95.98 95.98 0 0 1 74.7 74.707 96.9 96.9 0 0 1 0 38.695 95.97 95.97 0 0 1-74.7 74.7A96.7 96.7 0 0 1 96 192m0-168a71.881 71.881 0 1 0 28.022 5.658A71.7 71.7 0 0 0 96 24",
                        transform: "matrix(.95 0 0 .95 4.75 4.75)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "none",
                        fillOpacity: 0,
                        stroke: "var(--anatomy-gray-900)",
                        strokeOpacity: 0.1,
                        transform: "matrix(.95 0 0 .95 4.75 4.75)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 96.001,
                                cy: 96.001,
                                r: 96.001,
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 96.001,
                                cy: 96.001,
                                r: 95.501
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "none",
                        fillOpacity: 0,
                        stroke: "var(--anatomy-gray-900)",
                        strokeOpacity: 0.1,
                        transform: "matrix(.95 0 0 .95 26.6 26.599)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 73.001,
                                cy: 73.001,
                                r: 73.001,
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 73.001,
                                cy: 73.001,
                                r: 72.501
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        transform: "matrix(.95 0 0 .95 4.75 4.75)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "none",
                                fillOpacity: 0,
                                stroke: "var(--anatomy-gray-50)",
                                strokeWidth: 2,
                                transform: "translate(147.398 28.603)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 8,
                                        cy: 8,
                                        r: 8,
                                        stroke: "none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 8,
                                        cy: 8,
                                        r: 7
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "none",
                                fillOpacity: 0,
                                stroke: "var(--anatomy-gray-900)",
                                strokeOpacity: 0.42,
                                transform: "translate(146.398 27.603)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 9,
                                        cy: 9,
                                        r: 9,
                                        stroke: "none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 9,
                                        cy: 9,
                                        r: 8.5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 6,
                                cy: 6,
                                r: 6,
                                fill: "var(--anatomy-gray-500)",
                                transform: "translate(149.398 30.603)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "none",
                                fillOpacity: 0,
                                stroke: "var(--anatomy-gray-900)",
                                strokeOpacity: 0.42,
                                transform: "translate(149.398 30.603)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 6,
                                        cy: 6,
                                        r: 6,
                                        stroke: "none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 6,
                                        cy: 6,
                                        r: 5.5
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgColorWheel;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kjTat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgComboBox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 188 205",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "ComboBox_svg__a",
                    width: 188,
                    height: 148,
                    x: 0,
                    y: 57,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(6 16)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Favorite animal"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        transform: "translate(6 24)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 176,
                                height: 32,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 175,
                                height: 31,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-200)",
                        d: "M148 24h30a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4h-30Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M148 24h30a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4h-30Zm0 1a1 1 0 0 0 1-1v32a1 1 0 0 0-1-1h30a3 3 0 0 0 3-3V28a3 3 0 0 0-3-3Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 44)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Ca"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M169.99 38.01a1 1 0 0 0-1.707-.71L165 40.586l-3.283-3.286a1.002 1.002 0 1 0-1.417 1.417l3.993 3.983a1 1 0 0 0 1.414 0l3.993-3.983a1 1 0 0 0 .29-.707"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(0,0,0,0)",
                        stroke: "var(--anatomy-gray-600)",
                        transform: "translate(6 24)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 176,
                                height: 32,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 175,
                                height: 31,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        filter: "url(#ComboBox_svg__a)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-400)",
                            transform: "translate(6 62)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 176,
                                    height: 136,
                                    stroke: "none",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 175,
                                    height: 135,
                                    x: 0.5,
                                    y: 0.5,
                                    fill: "none",
                                    rx: 3.5
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-900)",
                        stroke: "rgba(0,0,0,0)",
                        opacity: 0.04,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M8 130h172v32H8z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M8.5 130.5h171v31H8.5z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(255,0,0,0)",
                        stroke: "rgba(0,0,0,0)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M18 66h60v32H18z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M18.5 66.5h59v31h-59z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 86)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Camel"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(255,0,0,0)",
                        stroke: "rgba(0,0,0,0)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M18 98h78v32H18z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M18.5 98.5h77v31h-77z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 118)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Capybara"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(255,0,0,0)",
                        stroke: "rgba(0,0,0,0)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M18 130h68v32H18z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M18.5 130.5h67v31h-67z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 150)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Caribou"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(255,0,0,0)",
                        stroke: "rgba(0,0,0,0)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M18 162h42v32H18z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M18.5 162.5h41v31h-41z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 182)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Cat"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                stroke: "var(--anatomy-gray-600)",
                d: "M34.5 31.5v16"
            })
        ]
    });
exports.default = SvgComboBox;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bC9JX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgComingSoon = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 17,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 17px)/2) 10px"
        },
        viewBox: "0 0 135 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
            fill: "var(--anatomy-gray-700)",
            fontFamily: "var(--anatomy-font)",
            fontSize: 14,
            transform: "translate(0 14)",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                x: 0,
                y: 0,
                children: "Image Coming Soon"
            })
        })
    });
exports.default = SvgComingSoon;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"krLkr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgContextualHelp = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 140,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 140px)/2) 10px"
        },
        viewBox: "0 0 252 140",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "ContextualHelp_svg__a",
                    width: 252,
                    height: 115,
                    x: 0,
                    y: 25,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#ContextualHelp_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M242 132.5H10c-1.93 0-3.5-1.57-3.5-3.5V34c0-1.93 1.57-3.5 3.5-3.5h232c1.93 0 3.5 1.57 3.5 3.5v95c0 1.93-1.57 3.5-3.5 3.5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-400)",
                            d: "M10 31c-1.654 0-3 1.346-3 3v95c0 1.654 1.346 3 3 3h232c1.654 0 3-1.346 3-3V34c0-1.654-1.346-3-3-3zm0-1h232a4 4 0 0 1 4 4v95a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V34a4 4 0 0 1 4-4"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                fontWeight: 700,
                transform: "translate(18 41)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 16,
                    children: "Permission required"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-200)",
                        stroke: "var(--anatomy-gray-500)",
                        transform: "translate(6)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 24,
                                height: 24,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 23,
                                height: 23,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M18.955 9.333a.956.956 0 1 1-.956-.956.956.956 0 0 1 .956.956m.082 5.333h-.149v-3.378a.18.18 0 0 0-.178-.178h-1.748s-.518.014-.518.444.518.444.518.444h.148v2.667h-.148s-.518.014-.518.444.518.444.518.444h2.075s.518-.015.518-.444-.518-.443-.518-.443M18 4.444A7.556 7.556 0 1 0 25.556 12 7.556 7.556 0 0 0 18 4.444m0 13.489A5.933 5.933 0 1 1 23.933 12 5.933 5.933 0 0 1 18 17.933"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 13,
                transform: "translate(18 63)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 13,
                        children: "Your admin must grant you permission "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 31.2,
                        children: "before you can create a segment."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 13,
                textDecoration: "underline",
                transform: "translate(18 120)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Learn about permissions"
                })
            })
        ]
    });
exports.default = SvgContextualHelp;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"csR8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDateField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "10px calc((100% - 176px)/2)",
            height: "calc(152px - 20px)",
            width: 176
        },
        viewBox: "8 53 264 52",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-341 -39)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-400)",
                            strokeWidth: 1.5,
                            transform: "translate(349 104)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 264,
                                    height: 48,
                                    stroke: "none",
                                    rx: 6
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 262.5,
                                    height: 46.5,
                                    x: 0.75,
                                    y: 0.75,
                                    fill: "none",
                                    rx: 5.25
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-700)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 18,
                            transform: "translate(349 92)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Event date"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 23,
                    height: 26,
                    fill: "var(--anatomy-gray-700)",
                    rx: 2,
                    transform: "translate(366 115)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                    fill: "var(--anatomy-gray-50)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 21,
                    transform: "translate(367 134)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            xmlSpace: "preserve",
                            x: 8,
                            y: 0,
                            children: "8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            xmlSpace: "preserve",
                            y: 0,
                            fill: "var(--anatomy-gray-700)",
                            children: " / 15 / 2022"
                        })
                    ]
                })
            ]
        })
    });
exports.default = SvgDateField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8umtV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDatePicker = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            maxHeight: 153,
            background: "var(--anatomy-gray-100)",
            padding: "10px 10px 0",
            boxSizing: "border-box"
        },
        viewBox: "69 40 376 280",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "DatePicker_svg__a",
                    width: 441,
                    height: 427,
                    x: 58,
                    y: 114,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 3
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(-280 -39)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 1.5,
                        transform: "translate(349 104)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 264,
                                height: 48,
                                stroke: "none",
                                rx: 6
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 262.5,
                                height: 46.5,
                                x: 0.75,
                                y: 0.75,
                                fill: "none",
                                rx: 5.25
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 18,
                        transform: "translate(349 92)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Event date"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 23,
                        height: 26,
                        fill: "var(--anatomy-gray-700)",
                        rx: 2,
                        transform: "translate(366 115)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 21,
                        transform: "translate(367 134)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                xmlSpace: "preserve",
                                x: 8,
                                y: 0,
                                children: "9"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                xmlSpace: "preserve",
                                y: 0,
                                fill: "var(--anatomy-gray-800)",
                                children: " / 10 / 2021"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-200)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M607 151.25h-44.25v-46.5H607a5.256 5.256 0 0 1 5.25 5.25v36a5.256 5.256 0 0 1-5.25 5.25"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-600)",
                                d: "M563.5 105.5v45H607c2.481 0 4.5-2.019 4.5-4.5v-36c0-2.481-2.019-4.5-4.5-4.5zM562 104h45a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6h-45z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-700)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(581.798 124.707)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(585.289 124.707)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(588.78 124.707)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(592.271 124.707)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(581.798 128.198)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(585.289 128.198)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(588.78 128.198)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(592.271 128.198)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(581.798 131.69)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(585.289 131.69)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(588.78 131.69)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(592.271 131.69)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M598.091 119.471h-3.492v-1.746a.58.58 0 0 0-.582-.582h-1.163a.58.58 0 0 0-.582.582v1.746h-8.147v-1.746a.58.58 0 0 0-.581-.582h-1.164a.58.58 0 0 0-.582.582v1.746h-3.491a.58.58 0 0 0-.582.581v17.457a.58.58 0 0 0 .582.582h19.784a.58.58 0 0 0 .582-.582v-17.457a.58.58 0 0 0-.582-.581m-1.166 16.872h-17.454v-15.127h2.327v1.164a.58.58 0 0 0 .582.582h1.164a.58.58 0 0 0 .581-.582v-1.164h8.146v1.164a.58.58 0 0 0 .582.582h1.164a.58.58 0 0 0 .582-.582v-1.164h2.326Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                filter: "url(#DatePicker_svg__a)",
                                transform: "translate(280 39)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-50)",
                                    stroke: "rgba(0,0,0,0)",
                                    transform: "translate(69 121)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 376,
                                            height: 364,
                                            stroke: "none",
                                            rx: 5
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 375,
                                            height: 363,
                                            x: 0.5,
                                            y: 0.5,
                                            fill: "none",
                                            rx: 4.5
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "rgba(0,0,0,0)",
                                stroke: "var(--anatomy-gray-400)",
                                transform: "translate(349 160)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 376,
                                        height: 364,
                                        stroke: "none",
                                        rx: 5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 375,
                                        height: 363,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 4.5
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 20,
                        fontWeight: 700,
                        transform: "translate(538 216)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -67.14,
                            y: 0,
                            children: "September 2021"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(403 260)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.472,
                            y: 0,
                            children: "S"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 13,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(450 259)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.402,
                            y: 0,
                            children: "M"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(493 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.24,
                            y: 0,
                            children: "T"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(539 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.13,
                            y: 0,
                            children: "W"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(583 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.24,
                            y: 0,
                            children: "T"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 13,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(626 259)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.302,
                            y: 0,
                            children: "F"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(402 340)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.36,
                            y: 0,
                            children: "5"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.263,
                            y: 0,
                            children: "7"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.825,
                            y: 0,
                            children: "8"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(581 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.892,
                            y: 0,
                            children: "9"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(626 340)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.349,
                            y: 0,
                            children: "10"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.48,
                            y: 0,
                            children: "13"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(492 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.174,
                            y: 0,
                            children: "14"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(536 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.398,
                            y: 0,
                            children: "15"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(581 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.349,
                            y: 0,
                            children: "16"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(402 429)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.23,
                            y: 0,
                            children: "19"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(448 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.905,
                            y: 0,
                            children: "20"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.443,
                            y: 0,
                            children: "21"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.717,
                            y: 0,
                            children: "22"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(582 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.747,
                            y: 0,
                            children: "23"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(627 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.657,
                            y: 0,
                            children: "24"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 296)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -2.4,
                            y: 0,
                            children: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(581 295)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.304,
                            y: 0,
                            children: "2"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(626 295)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.388,
                            y: 0,
                            children: "3"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M399.658 210.397a1.11 1.11 0 0 1 .328-.791l3.956-3.956a1.119 1.119 0 0 1 1.582 1.582l-3.165 3.165 3.165 3.165a1.119 1.119 0 0 1-1.582 1.583l-3.956-3.957a1.11 1.11 0 0 1-.328-.791"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(403 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.867,
                            y: 0,
                            children: "26"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.32,
                            y: 0,
                            children: "27"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.852,
                            y: 0,
                            children: "29"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(582 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.987,
                            y: 0,
                            children: "30"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.953,
                            y: 0,
                            children: "6"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.77,
                            y: 0,
                            children: "28"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(671 260)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.472,
                            y: 0,
                            children: "S"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.25,
                            y: 0,
                            children: "11"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(671 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.195,
                            y: 0,
                            children: "18"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.665,
                            y: 0,
                            children: "25"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 296)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.765,
                            y: 0,
                            children: "4"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M674.123 210.397a1.11 1.11 0 0 1-.328.791l-3.956 3.956a1.119 1.119 0 0 1-1.582-1.582l3.165-3.165-3.165-3.165a1.119 1.119 0 0 1 1.582-1.583l3.956 3.957a1.11 1.11 0 0 1 .328.791"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(402 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.412,
                            y: 0,
                            children: "12"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 35,
                        height: 35,
                        fill: "var(--anatomy-gray-700)",
                        rx: 17.5,
                        transform: "translate(609 318)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(626 340)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.142,
                            y: 0,
                            children: "10"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgDatePicker;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"77fJM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDateRangePicker = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            maxHeight: 152,
            background: "var(--anatomy-gray-100)",
            padding: "10px 10px 0",
            boxSizing: "border-box"
        },
        viewBox: "69 40 376 280",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "DateRangePicker_svg__a",
                    width: 394,
                    height: 382,
                    x: 60,
                    y: 114,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 3
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(-280 -39)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                filter: "url(#DateRangePicker_svg__a)",
                                transform: "translate(280 39)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-50)",
                                    stroke: "rgba(0,0,0,0)",
                                    transform: "translate(69 121)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 376,
                                            height: 364,
                                            stroke: "none",
                                            rx: 5
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 375,
                                            height: 363,
                                            x: 0.5,
                                            y: 0.5,
                                            fill: "none",
                                            rx: 4.5
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "rgba(0,0,0,0)",
                                stroke: "var(--anatomy-gray-400)",
                                transform: "translate(349 160)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 376,
                                        height: 364,
                                        stroke: "none",
                                        rx: 5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 375,
                                        height: 363,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 4.5
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M671.281 273a17.9 17.9 0 1 1-17.9 17.9 17.9 17.9 0 0 1 17.9-17.9"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M403.828 318a17.9 17.9 0 1 1-17.9 17.9 17.9 17.9 0 0 1 17.9-17.9"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M622 273h50v36h-50z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M404 318h132v36H404z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 36,
                        height: 36,
                        fill: "var(--anatomy-gray-700)",
                        rx: 17.5,
                        transform: "translate(609 273)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 36,
                        height: 36,
                        fill: "var(--anatomy-gray-700)",
                        rx: 17.5,
                        transform: "translate(518 318)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 20,
                        fontWeight: 700,
                        transform: "translate(538 216)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -67.14,
                            y: 0,
                            children: "September 2021"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(403 260)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.472,
                            y: 0,
                            children: "S"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 13,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(450 259)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.402,
                            y: 0,
                            children: "M"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(493 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.24,
                            y: 0,
                            children: "T"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(539 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.13,
                            y: 0,
                            children: "W"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(583 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.24,
                            y: 0,
                            children: "T"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 13,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(626 259)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.302,
                            y: 0,
                            children: "F"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(402 340)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.36,
                            y: 0,
                            children: "5"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.263,
                            y: 0,
                            children: "7"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.825,
                            y: 0,
                            children: "8"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(581 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.892,
                            y: 0,
                            children: "9"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(626 340)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.349,
                            y: 0,
                            children: "10"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.48,
                            y: 0,
                            children: "13"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(492 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.174,
                            y: 0,
                            children: "14"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(536 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.398,
                            y: 0,
                            children: "15"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(581 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.349,
                            y: 0,
                            children: "16"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(402 429)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.23,
                            y: 0,
                            children: "19"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(448 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.905,
                            y: 0,
                            children: "20"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.443,
                            y: 0,
                            children: "21"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.717,
                            y: 0,
                            children: "22"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(582 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.747,
                            y: 0,
                            children: "23"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(627 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.657,
                            y: 0,
                            children: "24"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 296)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -2.4,
                            y: 0,
                            children: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(581 295)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.304,
                            y: 0,
                            children: "2"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(626 295)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.388,
                            y: 0,
                            children: "3"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M399.658 210.397a1.11 1.11 0 0 1 .328-.791l3.956-3.956a1.119 1.119 0 0 1 1.582 1.582l-3.165 3.165 3.165 3.165a1.119 1.119 0 0 1-1.582 1.583l-3.956-3.957a1.11 1.11 0 0 1-.328-.791"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(403 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.867,
                            y: 0,
                            children: "26"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.32,
                            y: 0,
                            children: "27"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.852,
                            y: 0,
                            children: "29"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(582 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.987,
                            y: 0,
                            children: "30"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -4.11,
                            y: 0,
                            children: "6"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.77,
                            y: 0,
                            children: "28"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(671 260)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.472,
                            y: 0,
                            children: "S"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.25,
                            y: 0,
                            children: "11"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(671 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.195,
                            y: 0,
                            children: "18"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.665,
                            y: 0,
                            children: "25"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 296)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.765,
                            y: 0,
                            children: "4"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M674.123 210.397a1.11 1.11 0 0 1-.328.791l-3.956 3.956a1.119 1.119 0 0 1-1.582-1.582l3.165-3.165-3.165-3.165a1.119 1.119 0 0 1 1.582-1.583l3.956 3.957a1.11 1.11 0 0 1 .328.791"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(402 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.412,
                            y: 0,
                            children: "12"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(626 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.142,
                            y: 0,
                            children: "17"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.953,
                            y: 0,
                            children: "6"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 1.5,
                        transform: "translate(349 104)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 376,
                                height: 48,
                                stroke: "none",
                                rx: 6
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 374.5,
                                height: 46.5,
                                x: 0.75,
                                y: 0.75,
                                fill: "none",
                                rx: 5.25
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-700)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 18,
                            transform: "translate(349 92)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Event date"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-200)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M719 151.25h-44.25v-46.5H719a5.256 5.256 0 0 1 5.25 5.25v36a5.256 5.256 0 0 1-5.25 5.25"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "var(--anatomy-gray-600)",
                                            d: "M675.5 105.5v45H719c2.481 0 4.5-2.019 4.5-4.5v-36c0-2.481-2.019-4.5-4.5-4.5zM674 104h45a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6h-45z"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-700)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(693.798 124.707)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(697.289 124.707)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(700.78 124.707)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(704.271 124.707)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(693.798 128.198)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(697.289 128.198)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(700.78 128.198)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(704.271 128.198)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(693.798 131.69)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(697.289 131.69)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(700.78 131.69)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(704.271 131.69)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M710.091 119.471h-3.492v-1.746a.58.58 0 0 0-.582-.582h-1.163a.58.58 0 0 0-.582.582v1.746h-8.147v-1.746a.58.58 0 0 0-.581-.582h-1.164a.58.58 0 0 0-.582.582v1.746h-3.491a.58.58 0 0 0-.582.581v17.457a.58.58 0 0 0 .582.582h19.784a.58.58 0 0 0 .582-.582v-17.457a.58.58 0 0 0-.582-.581m-1.166 16.872h-17.454v-15.127h2.327v1.164a.58.58 0 0 0 .582.582h1.164a.58.58 0 0 0 .581-.582v-1.164h8.146v1.164a.58.58 0 0 0 .582.582h1.164a.58.58 0 0 0 .582-.582v-1.164h2.326Z"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-50)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 21,
                            transform: "translate(523 134)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                xmlSpace: "preserve",
                                x: 8,
                                y: 0,
                                fill: "var(--anatomy-gray-800)",
                                children: "9 / 8 / 2021"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 23,
                                height: 26,
                                fill: "var(--anatomy-gray-700)",
                                rx: 2,
                                transform: "translate(366 115)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                                fill: "var(--anatomy-gray-50)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 21,
                                transform: "translate(367 134)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        xmlSpace: "preserve",
                                        x: 8,
                                        y: 0,
                                        children: "9"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        xmlSpace: "preserve",
                                        y: 0,
                                        fill: "var(--anatomy-gray-800)",
                                        children: " /   3 / 2021   \u2013  "
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgDateRangePicker;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6xupb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDialog = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 229,
        style: {
            background: "var(--anatomy-gray-400)",
            padding: 10,
            boxSizing: "border-box",
            maxHeight: 153
        },
        viewBox: "0 0 480 229",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 480,
                height: 229,
                fill: "var(--anatomy-gray-100)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 18,
                fontWeight: 700,
                transform: "translate(40 40)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 18,
                    children: "Delete file"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 400,
                height: 2,
                fill: "var(--anatomy-gray-300)",
                rx: 1,
                transform: "translate(40 74)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(40 92)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 14,
                    children: "Are you sure you want to delete \"budget.xls\"? It cannot be recovered."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(0,0,0,0)",
                        stroke: "var(--anatomy-gray-300)",
                        strokeWidth: 2,
                        transform: "translate(280 157)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 72,
                                height: 32,
                                stroke: "none",
                                rx: 16
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 70,
                                height: 30,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 15
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        transform: "translate(297 177)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "rgba(0,0,0,0)",
                                stroke: "var(--anatomy-gray-800)",
                                strokeWidth: 2,
                                transform: "translate(368 157)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 72,
                                        height: 32,
                                        stroke: "none",
                                        rx: 16
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 70,
                                        height: 30,
                                        x: 1,
                                        y: 1,
                                        fill: "none",
                                        rx: 15
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                fontWeight: 700,
                                transform: "translate(385 177)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Delete"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-700)",
                d: "M430.563 41.29 422.2 56.255a.5.5 0 0 0 .436.745h16.728a.5.5 0 0 0 .436-.744l-8.364-14.966a.5.5 0 0 0-.872 0ZM432 54.75a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25Zm0-3a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-6a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25Z"
            })
        ]
    });
exports.default = SvgDialog;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8qSw5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDisclosureGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 266 163",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-100)",
                d: "M0 0h266v163H0z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-300)",
                d: "M48 36h164v1H48z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-300)",
                d: "M48 85h164v1H48zM48 134h164v1H48z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M72 61a.9.9 0 0 0-.3-.7l-4-4a.967.967 0 0 0-1.4 0 .967.967 0 0 0 0 1.4l3.2 3.3-3.3 3.3a.97.97 0 0 0-.1 1.4.97.97 0 0 0 1.4.1l.1-.1 4-4a1.01 1.01 0 0 0 .4-.7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M72 110a.9.9 0 0 0-.3-.7l-4-4a.967.967 0 0 0-1.4 0 .967.967 0 0 0 0 1.4l3.2 3.3-3.3 3.3a.97.97 0 0 0-.1 1.4.97.97 0 0 0 1.4.1l.1-.1 4-4a1.01 1.01 0 0 0 .4-.7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 18,
                fontWeight: 700,
                transform: "translate(82 67)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Recent"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 18,
                fontWeight: 700,
                transform: "translate(82 116)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Abstract"
                })
            })
        ]
    });
exports.default = SvgDisclosureGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ZkpS9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDisclosure = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 266 163",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-100)",
                d: "M0 0h266v163H0z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M96.092 84.198a.9.9 0 0 0-.3-.7l-4-4a.967.967 0 0 0-1.4 0 .967.967 0 0 0 0 1.4l3.2 3.3-3.3 3.3a.97.97 0 0 0-.1 1.4.97.97 0 0 0 1.4.1l.1-.1 4-4a1.01 1.01 0 0 0 .4-.7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 18,
                fontWeight: 700,
                transform: "translate(107.015 88.67)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Recent"
                })
            })
        ]
    });
exports.default = SvgDisclosure;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8C03J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDragAndDrop = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 129,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 129px)/2) 3px calc((152px - 129px)/2) 17px"
        },
        viewBox: "0 0 215 129",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "DragAndDrop_svg__a",
                    width: 198,
                    height: 44,
                    x: 17,
                    y: 15,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                        fill: "var(--anatomy-gray-800)",
                                        fontFamily: "var(--anatomy-font)",
                                        fontSize: 14,
                                        transform: "translate(39 71)",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                            x: 0,
                                            y: 14,
                                            children: "Applications"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "var(--anatomy-gray-700)",
                                            d: "M29.5 76h-7.166l-1.652-1.7a1 1 0 0 0-.717-.3H15a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M15 75h4.965l1.943 2H15Z"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                        fill: "var(--anatomy-gray-800)",
                                        fontFamily: "var(--anatomy-font)",
                                        fontSize: 14,
                                        transform: "translate(39 39)",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                            x: 0,
                                            y: 14,
                                            children: "Pictures"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "var(--anatomy-gray-700)",
                                            d: "M29.5 44h-7.166l-1.652-1.7a1 1 0 0 0-.717-.3H15a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M15 43h4.965l1.943 2H15Z"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                        fill: "var(--anatomy-gray-800)",
                                        fontFamily: "var(--anatomy-font)",
                                        fontSize: 14,
                                        transform: "translate(39 103)",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                            x: 0,
                                            y: 14,
                                            children: "Downloads"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "var(--anatomy-gray-700)",
                                            d: "M29.5 108h-7.166l-1.652-1.7a1 1 0 0 0-.717-.3H15a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M15 107h4.965l1.943 2H15Z"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        transform: "translate(-2746 -366)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 194,
                                                height: 32,
                                                fill: "var(--anatomy-gray-100)",
                                                stroke: "var(--anatomy-gray-900)",
                                                strokeWidth: 2,
                                                rx: 4,
                                                transform: "translate(2747 367)"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "var(--anatomy-gray-600)",
                                                fillOpacity: 0.15,
                                                d: "M2751 367h185.812a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H2751a4 4 0 0 1-4-4v-24a4 4 0 0 1 4-4"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                fill: "var(--anatomy-gray-800)",
                                                fontFamily: "var(--anatomy-font)",
                                                fontSize: 14,
                                                transform: "translate(2785 373)",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                                    x: 0,
                                                    y: 14,
                                                    children: "Shared"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "var(--anatomy-gray-700)",
                                                    d: "M2775.5 378h-7.166l-1.652-1.7a1 1 0 0 0-.717-.3H2761a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5m-14.5-1h4.965l1.943 2H2761Z"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                            filter: "url(#DragAndDrop_svg__a)",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                fill: "var(--anatomy-gray-100)",
                                                stroke: "var(--anatomy-gray-700)",
                                                transform: "translate(23 20)",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                        width: 186,
                                                        height: 32,
                                                        stroke: "none",
                                                        rx: 4
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                        width: 185,
                                                        height: 31,
                                                        x: 0.5,
                                                        y: 0.5,
                                                        fill: "none",
                                                        rx: 3.5
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            transform: "translate(19 16)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                    fill: "var(--anatomy-gray-75)",
                                                    stroke: "var(--anatomy-gray-700)",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                            width: 186,
                                                            height: 32,
                                                            stroke: "none",
                                                            rx: 4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                            width: 185,
                                                            height: 31,
                                                            x: 0.5,
                                                            y: 0.5,
                                                            fill: "none",
                                                            rx: 3.5
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 185.812,
                                                    height: 32,
                                                    fill: "none",
                                                    rx: 4
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                    fill: "var(--anatomy-gray-800)",
                                                    fontFamily: "var(--anatomy-font)",
                                                    fontSize: 14,
                                                    transform: "translate(38 6)",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                                        x: 0,
                                                        y: 14,
                                                        children: "Music"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "var(--anatomy-gray-700)",
                                                        d: "M28.5 11h-7.166l-1.652-1.7a1 1 0 0 0-.717-.3H14a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M14 10h4.965l1.943 2H14Z"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        transform: "translate(179 23)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 18,
                                                height: 18,
                                                fill: "var(--anatomy-gray-800)",
                                                rx: 4
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                fill: "var(--anatomy-gray-50)",
                                                fontFamily: "var(--anatomy-font)",
                                                fontSize: 12,
                                                transform: "translate(2 1)",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                                    x: 4.168,
                                                    y: 12,
                                                    children: "2"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fillRule: "evenodd",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "#fff",
                                        d: "M136 44.422V28.407l11.591 11.619h-6.781l-.411.124Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "#fff",
                                        d: "m145.084 45.1-3.6 1.535-4.684-11.093 3.686-1.553Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "m143.751 44.416-1.844.774-3.1-7.374 1.841-.775Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M137 30.814V42l2.969-2.866.431-.134h4.768Z"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgDragAndDrop;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"enjcP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDropZone = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            padding: 10,
            maxHeight: 152,
            boxSizing: "border-box"
        },
        viewBox: "30 0 230 220",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "DropZone_svg__a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "none",
                            d: "M0 0h271v2H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "DropZone_svg__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "none",
                            d: "M0 0h2v195H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#DropZone_svg__a)",
                transform: "translate(10.001 .001)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M0 0h8v2H0z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M12 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M24 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M36 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M48 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M60 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M72 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M84 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M96 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M108 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M120 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M132 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M144 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M156 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M168 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M180 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M192 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M204 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M216 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M228 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M240 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M252 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M264 0h8v2h-8z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#DropZone_svg__a)",
                transform: "translate(10.001 212.001)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 0h8v2H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M12 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M24 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M36 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M48 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M60 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M72 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M84 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M96 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M108 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M120 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M132 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M144 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M156 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M168 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M180 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M192 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M204 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M216 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M228 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M240 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M252 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M264 0h8v2h-8z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#DropZone_svg__b)",
                transform: "translate(.001 9.001)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 0h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 12h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 24h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 36h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 48h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 60h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 72h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 84h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 96h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 108h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 120h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 132h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 144h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 156h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 168h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 180h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 192h2v8H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#DropZone_svg__b)",
                transform: "translate(288.001 9.001)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 0h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 12h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 24h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 36h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 48h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 60h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 72h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 84h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 96h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 108h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 120h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 132h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 144h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 156h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 168h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 180h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 192h2v8H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-300)",
                d: "M2.001 6.001h-2a6.007 6.007 0 0 1 6-6v2a4.006 4.006 0 0 0-4 4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-300)",
                d: "M284.001 2.001v-2a6.007 6.007 0 0 1 6 6h-2a4.006 4.006 0 0 0-4-4M6.001 212.001v2a6.007 6.007 0 0 1-6-6h2a4.006 4.006 0 0 0 4 4M288.001 209.001h2a6.007 6.007 0 0 1-6 6v-2a4.006 4.006 0 0 0 4-4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 22,
                fontWeight: 700,
                transform: "translate(145.001 158.001)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: -106.854,
                    y: 0,
                    children: "Drag and drop your file"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-500)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M98.268 74.749H56.726a2.967 2.967 0 0 0-3.029 2.821v28.206a2.967 2.967 0 0 0 3.029 2.821h41.542a2.967 2.967 0 0 0 3.029-2.821V77.57a2.967 2.967 0 0 0-3.029-2.821m-41.542 2.418h41.542a.4.4 0 0 1 .433.4v24.66l-9.953-9.429a2.64 2.64 0 0 0-1.9-.725 2.8 2.8 0 0 0-1.9.725l-4.068 4.029-10.22-9.667a2.64 2.64 0 0 0-1.9-.725 2.8 2.8 0 0 0-1.9.725l-10.563 9.989V77.57a.4.4 0 0 1 .429-.403m-.429 28.609V99.49L68.15 88.368a.97.97 0 0 1 .606-.242.81.81 0 0 1 .606.242l19.126 17.811H56.726a.4.4 0 0 1-.429-.403m41.975.4h-7.447c0-.081-.087-.081-.087-.161l-8.568-8.056 4.068-4.029a.81.81 0 0 1 .606-.242.7.7 0 0 1 .606.242l11.247 10.637v1.209a.4.4 0 0 1-.429.403Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M91.797 88.876a3.95 3.95 0 0 0 2.9-1.239 4.307 4.307 0 0 0-2.9-7.288 4.07 4.07 0 0 0-2.9 1.239 4.32 4.32 0 0 0-1.2 2.988 4.19 4.19 0 0 0 4.1 4.3m-1.911-6.195a2.7 2.7 0 0 1 1.911-.8 2.73 2.73 0 0 1 2.694 2.768 2.86 2.86 0 0 1-.778 1.968 2.7 2.7 0 0 1-1.911.8 2.73 2.73 0 0 1-2.69-2.768 2.86 2.86 0 0 1 .779-1.968Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M232.962 75.532h-23.311l-6.428-5.765a4.06 4.06 0 0 0-2.571-1.018H187.54a2.693 2.693 0 0 0-2.743 2.713v34a3.147 3.147 0 0 0 3.171 3.137h45.166a3.147 3.147 0 0 0 3.171-3.137V78.668a3.355 3.355 0 0 0-3.343-3.136m-45.509-4.239h13.113a1.1 1.1 0 0 1 .857.339l4.371 3.9h-18.512v-4.07a.183.183 0 0 1 .172-.17Zm46.109 34.166a.583.583 0 0 1-.6.593h-45.165a.583.583 0 0 1-.6-.593V78.075h45.68a.583.583 0 0 1 .6.593v26.791Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m149.714 118.776-5 5.312V97.026a1.016 1.016 0 1 0-2.028 0v27.062l-5-5.312a.94.94 0 0 0-1.419 0 1.16 1.16 0 0 0 0 1.507l6.016 6.389a1.9 1.9 0 0 0 1.42.646 1.8 1.8 0 0 0 1.419-.646l6.016-6.389a1.085 1.085 0 0 0 0-1.507.94.94 0 0 0-1.424 0"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M168.523 60.205a1.4 1.4 0 0 0-1.2 1.481v43.157a.78.78 0 0 1-.641.79h-15.785a1.514 1.514 0 0 0 0 2.963h15.782c1.682 0 3.044-1.679 3.044-3.753V61.686a1.4 1.4 0 0 0-1.2-1.481"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M169.725 60.823a.66.66 0 0 0-.091-.446c-.091-.178-.183-.267-.274-.446l-19.168-17.825a2 2 0 0 0-.456-.267 1.4 1.4 0 0 0-.548-.09h-28.022a3.427 3.427 0 0 0-3.469 3.387v60.073a3.427 3.427 0 0 0 3.469 3.387h16.156a1.337 1.337 0 1 0 0-2.674h-16.156a.776.776 0 0 1-.73-.713V45.136a.776.776 0 0 1 .73-.713h26.652v14.439a3.427 3.427 0 0 0 3.469 3.387h17.343c.091 0 .183 0 .183-.089h.091c.091 0 .183-.089.274-.089l.091-.089c.091 0 .091-.089.183-.089a2 2 0 0 0 .274-.446v-.624Zm-19.168-1.961V46.205l14.33 13.37h-13.69a.77.77 0 0 1-.64-.713"
                    })
                ]
            })
        ]
    });
exports.default = SvgDropZone;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fw3EC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFileTrigger = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        "aria-hidden": "true",
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 102 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-600)",
                stroke: "rgba(0,0,0,0)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 102,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 101,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 15.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 700,
                transform: "translate(18 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Select a file"
                })
            })
        ]
    });
exports.default = SvgFileTrigger;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ejGAP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFocusScope = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 104,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 104px)/2) 10px"
        },
        viewBox: "0 0 230 104",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "FocusScope_svg__a",
                    width: 230,
                    height: 104,
                    x: 0,
                    y: 0,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#FocusScope_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M220 96.5H10c-1.93 0-3.5-1.57-3.5-3.5V9c0-1.93 1.57-3.5 3.5-3.5h210c1.93 0 3.5 1.57 3.5 3.5v84c0 1.93-1.57 3.5-3.5 3.5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-400)",
                            d: "M10 6C8.346 6 7 7.346 7 9v84c0 1.654 1.346 3 3 3h210c1.654 0 3-1.346 3-3V9c0-1.654-1.346-3-3-3zm0-1h210a4 4 0 0 1 4 4v84a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 2,
                        transform: "translate(18 17)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 194,
                                height: 30,
                                stroke: "none",
                                rx: 5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 192,
                                height: 28,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-900)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 10,
                        transform: "translate(29 37)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M29 22h1v19h-1z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-400)",
                        transform: "translate(18 55)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 194,
                                height: 30,
                                stroke: "none",
                                rx: 5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 193,
                                height: 29,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 4.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 10,
                        transform: "translate(29 75)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgFocusScope;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9IhhB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgForm = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 132,
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 152
        },
        viewBox: "0 0 220 132",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-800)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(19 16)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Email"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-600)",
                            transform: "translate(54)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 166,
                                    height: 24,
                                    stroke: "none",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 165,
                                    height: 23,
                                    x: 0.5,
                                    y: 0.5,
                                    fill: "none",
                                    rx: 3.5
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-800)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(63 16)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "someone@example.com"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-700)",
                            d: "m202.612 5.147-7.434 13.302a.444.444 0 0 0 .388.662h14.869a.444.444 0 0 0 .388-.661l-7.438-13.303a.444.444 0 0 0-.775 0Zm1.273 11.964a.22.22 0 0 1-.222.222h-1.33a.22.22 0 0 1-.222-.222v-1.333a.22.22 0 0 1 .222-.222h1.334a.22.22 0 0 1 .222.222Zm0-2.667a.22.22 0 0 1-.222.222h-1.33a.22.22 0 0 1-.222-.222V9.111a.22.22 0 0 1 .222-.226h1.334a.22.22 0 0 1 .222.222Z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(0 68)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Password"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-400)",
                            transform: "translate(54 52)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 166,
                                    height: 24,
                                    stroke: "none",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 165,
                                    height: 23,
                                    x: 0.5,
                                    y: 0.5,
                                    fill: "none",
                                    rx: 3.5
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-800)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(63 68)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    transform: "translate(54 80)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 12,
                            height: 12,
                            fill: "var(--anatomy-gray-800)",
                            rx: 2,
                            transform: "translate(0 6)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-75)",
                            d: "M9.648 8.613a.92.92 0 0 0-1.294.156L4.794 13.3l-1.162-1.394a.922.922 0 0 0-1.416 1.18l1.89 2.269a1 1 0 0 0 .07.052 1 1 0 0 0 .07.083 1 1 0 0 0 .128.07 1 1 0 0 0 .095.051.9.9 0 0 0 .345.076.9.9 0 0 0 .357-.08 1 1 0 0 0 .1-.057 1 1 0 0 0 .129-.077 1 1 0 0 0 .069-.086c.02-.021.047-.03.066-.053L9.8 9.907a.92.92 0 0 0-.156-1.294Z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-800)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(21 16)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Remember me"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(54 40)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "This account does not exist."
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-400)",
                            transform: "translate(54 108)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 51,
                                    height: 24,
                                    stroke: "none",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 50,
                                    height: 23,
                                    x: 0.5,
                                    y: 0.5,
                                    fill: "none",
                                    rx: 3.5
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-800)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(63 124)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Sign In"
                            })
                        })
                    ]
                })
            ]
        })
    });
exports.default = SvgForm;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"klfEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInput = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2) 10px"
        },
        viewBox: "0 0 176 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "123 Any St."
                })
            })
        ]
    });
exports.default = SvgInput;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fOc8v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInternationalizedDate = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 38.739,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 38.739px)/2) 10px"
        },
        viewBox: "0 0 38 38.739",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-5 -2.761)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(11.957 17.393)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(18.48 17.393)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(25.002 17.393)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(31.524 17.393)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(11.957 23.915)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(18.48 23.915)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(25.002 23.915)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(31.524 23.915)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(11.957 30.437)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(18.48 30.437)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(25.002 30.437)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(31.524 30.437)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "none",
                    stroke: "var(--anatomy-gray-400)",
                    strokeWidth: 2.1,
                    transform: "translate(5 7.5)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 38,
                            height: 34,
                            stroke: "none",
                            rx: 4
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 35.9,
                            height: 31.9,
                            x: 1.05,
                            y: 1.05,
                            rx: 2.95
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-600)",
                    d: "M35.872 7.609V4.348a1.087 1.087 0 0 0-1.087-1.087h-2.174a1.087 1.087 0 0 0-1.087 1.087v3.261H16.305V4.348a1.087 1.087 0 0 0-1.087-1.087h-2.17a1.087 1.087 0 0 0-1.091 1.087v3.261zM11.957 10.87v2.174a1.087 1.087 0 0 0 1.091 1.087h2.17a1.087 1.087 0 0 0 1.087-1.087V10.87h15.219v2.174a1.087 1.087 0 0 0 1.087 1.087h2.174a1.087 1.087 0 0 0 1.087-1.087V10.87"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-600)",
                    d: "M11.957 7.455h4.348v3.459h-4.348Z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-600)",
                    d: "M31.524 7.455h4.348v3.459h-4.348Z"
                })
            ]
        })
    });
exports.default = SvgInternationalizedDate;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a9loY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLabeledValue = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 45,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 45px)/2) 10px"
        },
        viewBox: "0 0 55 45",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 15,
                transform: "translate(0 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Aperture"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 17,
                transform: "translate(0 41)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "f/1.5"
                })
            })
        ]
    });
exports.default = SvgLabeledValue;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6zU7Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLabel = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 24,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 24px)/2) 10px"
        },
        viewBox: "0 0 39 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
            fill: "var(--anatomy-gray-700)",
            fontFamily: "var(--anatomy-font)",
            fontSize: 12,
            transform: "translate(0 16)",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                x: 0,
                y: 0,
                children: "Address"
            })
        })
    });
exports.default = SvgLabel;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"awi79":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLink = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 17,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 17px)/2) 10px"
        },
        viewBox: "0 0 35 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
            fill: "var(--anatomy-gray-700)",
            fontFamily: "var(--anatomy-font)",
            fontSize: 14,
            textDecoration: "underline",
            transform: "translate(0 14)",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                x: 0,
                y: 0,
                children: "About"
            })
        })
    });
exports.default = SvgLink;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g2KkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgListBox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 239,
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 152
        },
        viewBox: "0 0 214 239",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                strokeWidth: 1.5,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 214,
                        height: 239,
                        stroke: "none",
                        rx: 6
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 212.5,
                        height: 237.5,
                        x: 0.75,
                        y: 0.75,
                        fill: "none",
                        rx: 5.25
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-900)",
                opacity: 0.04,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M1 31h212v64H1Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        d: "M2 32v62h210V32zm-1-1h212v64H1z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 20,
                transform: "translate(18 58)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Option 1"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 20,
                transform: "translate(18 127)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Option 2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M187.007 55.33a1.37 1.37 0 0 1-1.072-.513l-3.321-4a1.34 1.34 0 0 1 2.109-1.651l2.284 2.66 6.29-8a1.335 1.335 0 1 1 2.1 1.642l-7.353 9.348a1.3 1.3 0 0 1-1.037.514"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fillOpacity: 0.75,
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                transform: "translate(18 83)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Description"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fillOpacity: 0.75,
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                transform: "translate(18 152)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Description"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 20,
                transform: "translate(18 195)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Option 3"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fillOpacity: 0.75,
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                transform: "translate(18 220)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Description"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 700,
                letterSpacing: ".06em",
                transform: "translate(18 22)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "SECTION TITLE"
                })
            })
        ]
    });
exports.default = SvgListBox;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8p8fn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgListView = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 152,
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10
        },
        viewBox: "0 0 364 232",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-400)",
                        strokeWidth: 1.5,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 364,
                                height: 232,
                                stroke: "none",
                                rx: 6
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 362.5,
                                height: 230.5,
                                x: 0.75,
                                y: 0.75,
                                fill: "none",
                                rx: 5.25
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        fillOpacity: 0.1,
                        d: "M0 116h364v58H0z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 19,
                        transform: "translate(105 28)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Documents"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        stroke: "var(--anatomy-gray-400)",
                        strokeWidth: 1.5,
                        d: "M.5 58.5h363.252"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        stroke: "var(--anatomy-gray-400)",
                        strokeWidth: 1.5,
                        d: "M.5 116.522h363.252"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        stroke: "var(--anatomy-gray-400)",
                        strokeWidth: 1.5,
                        d: "M.5 174.522h363.252"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            transform: "translate(276.252 63)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 48,
                                    height: 48,
                                    fill: "none",
                                    rx: 4,
                                    transform: "translate(-.252)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "var(--anatomy-gray-700)",
                                    d: "M25.612 19.5A1.612 1.612 0 1 1 24 17.888a1.613 1.613 0 0 1 1.613 1.612Zm.138 9h-.25v-5.7a.3.3 0 0 0-.3-.3h-2.95s-.875.024-.875.75.875.75.875.75h.25v4.5h-.25s-.875.024-.875.75.875.75.875.75h3.5s.875-.025.875-.75-.875-.75-.875-.75M24 11.25A12.75 12.75 0 1 0 36.75 24 12.75 12.75 0 0 0 24 11.25m0 22.762A10.012 10.012 0 1 1 34.012 24 10.01 10.01 0 0 1 24 34.012"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M331.252 21.5h15v15h-15z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-700)",
                                d: "M335.752 36.425a1.312 1.312 0 0 1-.922-2.246L340.072 29l-5.242-5.175a1.314 1.314 0 1 1 1.845-1.872l6.188 6.113a1.314 1.314 0 0 1 0 1.868l-6.188 6.113a1.3 1.3 0 0 1-.923.378"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 3,
                        transform: "translate(18 18.5)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 21,
                                height: 21,
                                stroke: "none",
                                rx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 18,
                                height: 18,
                                x: 1.5,
                                y: 1.5,
                                fill: "none",
                                rx: 0.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            strokeWidth: 3,
                            transform: "translate(18 76.5)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 21,
                                    height: 21,
                                    stroke: "none",
                                    rx: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 18,
                                    height: 18,
                                    x: 1.5,
                                    y: 1.5,
                                    fill: "none",
                                    rx: 0.5
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "var(--anatomy-gray-700)",
                                stroke: "none",
                                strokeOpacity: 0,
                                transform: "translate(18 134.5)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 21,
                                        height: 21,
                                        rx: 2
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 20,
                                        height: 20,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 1.5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-75)",
                                d: "M26.682 151a1.5 1.5 0 0 1-1.182-.578l-3.432-4.499a1.5 1.5 0 1 1 2.364-1.845l2.25 2.986 5.886-7.486a1.5 1.5 0 1 1 2.364 1.845l-7.068 9a1.5 1.5 0 0 1-1.182.577"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            strokeWidth: 3,
                            transform: "translate(18 192.5)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 21,
                                    height: 21,
                                    stroke: "none",
                                    rx: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 18,
                                    height: 18,
                                    x: 1.5,
                                    y: 1.5,
                                    fill: "none",
                                    rx: 0.5
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            transform: "translate(276.252 122)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 48,
                                    height: 48,
                                    fill: "none",
                                    rx: 4,
                                    transform: "translate(-.252)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-700)",
                                        d: "M25.612 19.5A1.612 1.612 0 1 1 24 17.888a1.613 1.613 0 0 1 1.613 1.612Zm.138 9h-.25v-5.7a.3.3 0 0 0-.3-.3h-2.95s-.875.024-.875.75.875.75.875.75h.25v4.5h-.25s-.875.024-.875.75.875.75.875.75h3.5s.875-.025.875-.75-.875-.75-.875-.75M24 11.25A12.75 12.75 0 1 0 36.75 24 12.75 12.75 0 0 0 24 11.25m0 22.762A10.012 10.012 0 1 1 34.012 24 10.01 10.01 0 0 1 24 34.012"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            transform: "translate(276.252 179)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 48,
                                    height: 48,
                                    fill: "none",
                                    rx: 4,
                                    transform: "translate(-.252)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-700)",
                                        d: "M25.612 19.5A1.612 1.612 0 1 1 24 17.888a1.613 1.613 0 0 1 1.613 1.612Zm.138 9h-.25v-5.7a.3.3 0 0 0-.3-.3h-2.95s-.875.024-.875.75.875.75.875.75h.25v4.5h-.25s-.875.024-.875.75.875.75.875.75h3.5s.875-.025.875-.75-.875-.75-.875-.75M24 11.25A12.75 12.75 0 1 0 36.75 24 12.75 12.75 0 0 0 24 11.25m0 22.762A10.012 10.012 0 1 1 34.012 24 10.01 10.01 0 0 1 24 34.012"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            transform: "translate(276.252 5)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 48,
                                    height: 48,
                                    fill: "none",
                                    rx: 4,
                                    transform: "translate(-.252)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-700)",
                                        d: "M25.612 19.5A1.612 1.612 0 1 1 24 17.888a1.613 1.613 0 0 1 1.613 1.612Zm.138 9h-.25v-5.7a.3.3 0 0 0-.3-.3h-2.95s-.875.024-.875.75.875.75.875.75h.25v4.5h-.25s-.875.024-.875.75.875.75.875.75h3.5s.875-.025.875-.75-.875-.75-.875-.75M24 11.25A12.75 12.75 0 1 0 36.75 24 12.75 12.75 0 0 0 24 11.25m0 22.762A10.012 10.012 0 1 1 34.012 24 10.01 10.01 0 0 1 24 34.012"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        transform: "translate(105 47)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "12 items"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 19,
                        transform: "translate(105 85)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Onboarding"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        transform: "translate(105 105)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "PDF"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 19,
                        transform: "translate(105 143)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Budget"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        transform: "translate(105 163)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "XLS"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 19,
                        transform: "translate(105 201)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Sales Pitch"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        transform: "translate(105 221)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "PPT"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-200)",
                d: "M58.11 47.086a2.98 2.98 0 0 1-3.008-3.007V17.61a2.98 2.98 0 0 1 3.008-3.008h12.151a2.38 2.38 0 0 1 1.684.722l3.73 3.73a1.1 1.1 0 0 0 .842.361h12.874a2.98 2.98 0 0 1 3.011 3.007v21.657a2.98 2.98 0 0 1-3.008 3.008Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-500)",
                d: "M89.391 18.813H76.517c-.12 0-.241 0-.481-.241l-3.73-3.73A2.9 2.9 0 0 0 70.261 14H58.109a3.545 3.545 0 0 0-3.609 3.609v26.469a3.62 3.62 0 0 0 3.609 3.609h31.282A3.62 3.62 0 0 0 93 44.078V22.422a3.545 3.545 0 0 0-3.609-3.609M91.8 44.078a2.413 2.413 0 0 1-2.406 2.406H58.109a2.413 2.413 0 0 1-2.409-2.406V20.016h33.691a2.413 2.413 0 0 1 2.409 2.406Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-50)",
                d: "M60.907 107.033a3.26 3.26 0 0 1-3.256-3.256V69.911a3.26 3.26 0 0 1 3.256-3.259H80.94a2.6 2.6 0 0 1 1.838.759l6.673 6.649a2.63 2.63 0 0 1 .767 1.845v27.872a3.26 3.26 0 0 1-3.256 3.256Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-500)",
                d: "m89.9 73.594-6.667-6.643A3.2 3.2 0 0 0 80.94 66H60.908A3.92 3.92 0 0 0 57 69.908v33.865a3.91 3.91 0 0 0 3.908 3.908h26.05a3.91 3.91 0 0 0 3.908-3.908V75.9a3.28 3.28 0 0 0-.966-2.306m-7.5-5.64 6.539 6.513h-5.888a.653.653 0 0 1-.651-.651Zm7.164 35.819a2.6 2.6 0 0 1-2.605 2.605H60.908a2.6 2.6 0 0 1-2.608-2.605V69.908a2.613 2.613 0 0 1 2.608-2.608H80.94a.6.6 0 0 1 .156.013v6.5a1.96 1.96 0 0 0 1.954 1.954h6.5a.4.4 0 0 1 .013.13Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-50)",
                        d: "M60.907 166.026a3.26 3.26 0 0 1-3.256-3.256v-33.866a3.26 3.26 0 0 1 3.256-3.259H80.94a2.6 2.6 0 0 1 1.838.759l6.673 6.649a2.63 2.63 0 0 1 .767 1.845v27.872a3.26 3.26 0 0 1-3.256 3.256Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-500)",
                        d: "m89.9 132.587-6.667-6.643a3.2 3.2 0 0 0-2.293-.951H60.908A3.92 3.92 0 0 0 57 128.901v33.865a3.91 3.91 0 0 0 3.908 3.908h26.05a3.91 3.91 0 0 0 3.908-3.908v-27.873a3.28 3.28 0 0 0-.966-2.306m-7.5-5.64 6.539 6.513h-5.888a.653.653 0 0 1-.651-.651Zm7.164 35.819a2.6 2.6 0 0 1-2.605 2.605H60.908a2.6 2.6 0 0 1-2.608-2.605v-33.865a2.613 2.613 0 0 1 2.608-2.608H80.94a.6.6 0 0 1 .156.013v6.5a1.96 1.96 0 0 0 1.954 1.954h6.5a.4.4 0 0 1 .013.13Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-50)",
                        d: "M60.907 223.033a3.26 3.26 0 0 1-3.256-3.256v-33.866a3.26 3.26 0 0 1 3.256-3.259H80.94a2.6 2.6 0 0 1 1.838.759l6.673 6.649a2.63 2.63 0 0 1 .767 1.845v27.872a3.26 3.26 0 0 1-3.256 3.256Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-500)",
                        d: "m89.9 189.594-6.667-6.643A3.2 3.2 0 0 0 80.94 182H60.908A3.92 3.92 0 0 0 57 185.908v33.865a3.91 3.91 0 0 0 3.908 3.908h26.05a3.91 3.91 0 0 0 3.908-3.908V191.9a3.28 3.28 0 0 0-.966-2.306m-7.5-5.64 6.539 6.513h-5.888a.653.653 0 0 1-.651-.651Zm7.164 35.819a2.6 2.6 0 0 1-2.605 2.605H60.908a2.6 2.6 0 0 1-2.608-2.605v-33.865a2.613 2.613 0 0 1 2.608-2.608H80.94a.6.6 0 0 1 .156.013v6.5a1.96 1.96 0 0 0 1.954 1.954h6.5a.4.4 0 0 1 .013.13Z"
                    })
                ]
            })
        ]
    });
exports.default = SvgListView;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8ru7h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMenu = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 151,
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 156 151",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "Menu_svg__a",
                    width: 156,
                    height: 116,
                    x: 0,
                    y: 35,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-200)",
                        stroke: "var(--anatomy-gray-500)",
                        transform: "translate(6)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 32,
                                height: 32,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 31,
                                height: 31,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-900)",
                        transform: "translate(6)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 1.7,
                                cy: 1.7,
                                r: 1.7,
                                transform: "translate(14.2 14.4)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 1.7,
                                cy: 1.7,
                                r: 1.7,
                                transform: "translate(20.05 14.4)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 1.7,
                                cy: 1.7,
                                r: 1.7,
                                transform: "translate(8.35 14.4)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        filter: "url(#Menu_svg__a)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-400)",
                            transform: "translate(6 40)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 144,
                                    height: 104,
                                    stroke: "none",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 143,
                                    height: 103,
                                    x: 0.5,
                                    y: 0.5,
                                    fill: "none",
                                    rx: 3.5
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        fillOpacity: 0.04,
                        d: "M7 44h142v32H7z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        d: "M18 44h57v32H18z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 64)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Edit\u2026"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        d: "M18 76h82v32H18z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 96)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Rename\u2026"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        d: "M18 108h72v32H18z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 128)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Delete\u2026"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgMenu;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lkbAG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMeter = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 34,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 34px)/2) 10px"
        },
        viewBox: "0 0 160 34",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 160,
                height: 6,
                fill: "var(--anatomy-gray-300)",
                rx: 3,
                transform: "translate(0 28)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M3 28h45v6H3a3 3 0 0 1-3-3 3 3 0 0 1 3-3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Storage space"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(160 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: -21.852,
                    y: 0,
                    children: "30%"
                })
            })
        ]
    });
exports.default = SvgMeter;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"flFdy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNumberField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 56,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 56px)/2) 10px"
        },
        viewBox: "0 0 176 56",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Width"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 44)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "4 in"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-400)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M152 24h20a4 4 0 0 1 4 4v12.5h-24z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M152.5 24.5H172a3.5 3.5 0 0 1 3.5 3.5v12h-23V24.5Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-400)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M152 39.5h24V52a4 4 0 0 1-4 4h-20z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M152.5 40h23v12a3.5 3.5 0 0 1-3.5 3.5h-19.5V40Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-800)",
                        d: "M164 30.5a.76.76 0 0 0-.5.2l-3.3 3.3a.76.76 0 0 0-.2.5.713.713 0 0 0 .8.7.55.55 0 0 0 .5-.2l2.7-2.7 2.7 2.7a.55.55 0 0 0 .5.2.713.713 0 0 0 .8-.7.76.76 0 0 0-.2-.5l-3.2-3.2a.86.86 0 0 0-.6-.3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-800)",
                        d: "M164 49.5a.76.76 0 0 0 .5-.2l3.3-3.3a.76.76 0 0 0 .2-.5.713.713 0 0 0-.8-.7.55.55 0 0 0-.5.2l-2.7 2.7-2.7-2.7a.55.55 0 0 0-.5-.2.713.713 0 0 0-.8.7.76.76 0 0 0 .2.5l3.2 3.2a.86.86 0 0 0 .6.3"
                    })
                ]
            })
        ]
    });
exports.default = SvgNumberField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5TMfC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPicker = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 188 205",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "Picker_svg__a",
                    width: 188,
                    height: 148,
                    x: 0,
                    y: 57,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(6 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Favorite color"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-200)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(6 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 44)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Orange"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-900)",
                d: "M169.99 38.01a1 1 0 0 0-1.707-.71L165 40.586l-3.283-3.286a1.002 1.002 0 1 0-1.417 1.417l3.993 3.983a1 1 0 0 0 1.414 0l3.993-3.983a1 1 0 0 0 .29-.707"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#Picker_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-400)",
                    transform: "translate(6 62)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 176,
                            height: 136,
                            stroke: "none",
                            rx: 4
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 175,
                            height: 135,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 3.5
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-900)",
                fillOpacity: 0.04,
                d: "M7 98h174v32H7z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M18 66h46v32H18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 86)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Red"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M18 98h66v32H18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 118)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Orange"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M18 130h61v32H18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 150)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Yellow"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M18 162h59v32H18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 182)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Green"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M164.5 118a1.02 1.02 0 0 1-.8-.384l-2.488-3a1 1 0 0 1 1.577-1.233l1.711 1.993 4.712-5.991a1 1 0 1 1 1.576 1.23l-5.511 7a.98.98 0 0 1-.777.385"
            })
        ]
    });
exports.default = SvgPicker;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2P2zw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPopover = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 148,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 148px)/2) 10px"
        },
        viewBox: "0 0 251.999 148",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "Popover_svg__a",
                    width: 251.999,
                    height: 123.001,
                    x: 0,
                    y: 0,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#Popover_svg__a)",
                transform: "translate(-.001)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "m94 115.293-7.646-7.647-.147-.146H10c-1.93 0-3.5-1.57-3.5-3.5V8.999c0-1.93 1.57-3.5 3.5-3.5h232c1.93 0 3.5 1.57 3.5 3.5v95c0 1.93-1.57 3.5-3.5 3.5H101.794l-.147.147z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-400)",
                            d: "m94 114.586 7.587-7.586H242c1.654 0 3-1.346 3-3V8.999c0-1.654-1.346-3-3-3H10C8.346 6 7 7.346 7 9v95c0 1.655 1.346 3 3 3h76.415zM94 116l-8-8H10a4 4 0 0 1-4-4V8.999a4 4 0 0 1 4-4h232a4 4 0 0 1 4 4v95a4 4 0 0 1-4 4H102z"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 15,
                fontWeight: 700,
                transform: "translate(17.999 13)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 16,
                    children: "Properties"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-200)",
                        stroke: "var(--anatomy-gray-500)",
                        transform: "translate(81.999 124)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 24,
                                height: 24,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 23,
                                height: 23,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-900)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M100.888 130.666h-7.822a2.222 2.222 0 0 0-4.356 0h-1.6a.22.22 0 0 0-.222.223v.444a.22.22 0 0 0 .222.222h1.6a2.222 2.222 0 0 0 4.356 0h7.822a.22.22 0 0 0 .222-.222v-.444a.22.22 0 0 0-.222-.223m-10 1.778a1.333 1.333 0 1 1 1.333-1.333 1.333 1.333 0 0 1-1.333 1.333"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M100.888 139.555h-6.044a2.222 2.222 0 0 0-4.356 0H87.11a.22.22 0 0 0-.222.223v.444a.22.22 0 0 0 .222.222h3.378a2.222 2.222 0 0 0 4.356 0h6.044a.22.22 0 0 0 .222-.222v-.444a.22.22 0 0 0-.222-.223m-8.222 1.778A1.333 1.333 0 1 1 93.999 140a1.333 1.333 0 0 1-1.333 1.333"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M86.888 135.334v.444a.22.22 0 0 0 .222.222h7.822a2.222 2.222 0 0 0 4.356 0h1.6a.22.22 0 0 0 .222-.222v-.444a.22.22 0 0 0-.222-.223h-1.6a2.222 2.222 0 0 0-4.356 0H87.11a.22.22 0 0 0-.222.223m8.889.222a1.333 1.333 0 1 1 1.333 1.333 1.333 1.333 0 0 1-1.333-1.333"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(17.999 57)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Width"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-400)",
                        transform: "translate(60.999 41)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 173,
                                height: 24,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 172,
                                height: 23,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(67.999 57)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "250 px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-700)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(17.999 87)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Height"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-400)",
                        transform: "translate(60.999 71)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 173,
                                height: 24,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 172,
                                height: 23,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(67.999 87)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "100 px"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgPopover;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1rojz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgressBar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 34,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 34px)/2) 10px"
        },
        viewBox: "0 0 160 34",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 160,
                height: 6,
                fill: "var(--anatomy-gray-300)",
                rx: 3,
                transform: "translate(0 28)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M3 28h93v6H3a3 3 0 0 1-3-3 3 3 0 0 1 3-3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Loading..."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(160 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: -22.476,
                    y: 0,
                    children: "60%"
                })
            })
        ]
    });
exports.default = SvgProgressBar;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4067p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgressCircle = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2) 10px"
        },
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "rgba(255,0,0,0)",
                stroke: "var(--anatomy-gray-300)",
                strokeWidth: 3,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 16,
                        cy: 16,
                        r: 16,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 16,
                        cy: 16,
                        r: 14.5,
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M16 0a16 16 0 0 1 13.772 7.855 16 16 0 0 1 .249 15.853l-2.629-1.445a13 13 0 0 0-.2-12.88A13 13 0 0 0 16 3Z"
            })
        ]
    });
exports.default = SvgProgressCircle;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lj97x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRadioGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 120,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 120px)/2) 10px"
        },
        viewBox: "0 0 72 120",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-700)",
                        strokeWidth: 5,
                        transform: "translate(0 33)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 7,
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 4.5,
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 44)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-700)",
                        strokeWidth: 2,
                        transform: "translate(0 65)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 7,
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 6,
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 76)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Medium"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-700)",
                        strokeWidth: 2,
                        transform: "translate(0 97)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 7,
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 6,
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 108)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Large"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-700)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    transform: "translate(0 16)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 0,
                        children: "Size"
                    })
                })
            })
        ]
    });
exports.default = SvgRadioGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kkyyl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRangeCalendar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            padding: 10,
            maxHeight: 152,
            boxSizing: "border-box"
        },
        viewBox: "102 0 300 182",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-236 -34)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M608 144a16 16 0 1 1-16 16 16 16 0 0 1 16-16"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M568 183a16 16 0 1 1-16 16 16 16 0 0 1 16-16"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M369 183a16 16 0 1 1-16 16 16 16 0 0 1 16-16"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M408 144h200v32H408z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M369 183h199v32H369z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 18,
                    fontWeight: 700,
                    transform: "translate(489 52)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -60.426,
                        y: 0,
                        children: "September 2021"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(369 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.976,
                        y: 0,
                        children: "S"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(411 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -4.986,
                        y: 0,
                        children: "M"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(449 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.24,
                        y: 0,
                        children: "T"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(490 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.13,
                        y: 0,
                        children: "W"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(529 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.24,
                        y: 0,
                        children: "T"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(568 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.048,
                        y: 0,
                        children: "F"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.36,
                        y: 0,
                        children: "5"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.045,
                        y: 0,
                        children: "7"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.57,
                        y: 0,
                        children: "8"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.633,
                        y: 0,
                        children: "9"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.349,
                        y: 0,
                        children: "10"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.048,
                        y: 0,
                        children: "13"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.174,
                        y: 0,
                        children: "14"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.971,
                        y: 0,
                        children: "15"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.349,
                        y: 0,
                        children: "16"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.23,
                        y: 0,
                        children: "19"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.378,
                        y: 0,
                        children: "20"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.013,
                        y: 0,
                        children: "21"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.203,
                        y: 0,
                        children: "22"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.231,
                        y: 0,
                        children: "23"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.147,
                        y: 0,
                        children: "24"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.24,
                        y: 0,
                        children: "1"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.304,
                        y: 0,
                        children: "2"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.388,
                        y: 0,
                        children: "3"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-700)",
                    d: "m365.562 46.329 3.535-3.535a1 1 0 0 1 1.415 0 1 1 0 0 1 0 1.414l-2.829 2.828 2.829 2.828a1 1 0 0 1 0 1.415 1 1 0 0 1-1.415 0l-3.535-3.536a1 1 0 0 1-.293-.707 1 1 0 0 1 .293-.707"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.343,
                        y: 0,
                        children: "26"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.832,
                        y: 0,
                        children: "27"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.329,
                        y: 0,
                        children: "29"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.455,
                        y: 0,
                        children: "30"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(408 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.836,
                        y: 0,
                        children: "6"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.252,
                        y: 0,
                        children: "28"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M408 144a16 16 0 1 1-16 16 16 16 0 0 1 16-16"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(608 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.976,
                        y: 0,
                        children: "S"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -4.9,
                        y: 0,
                        children: "11"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.195,
                        y: 0,
                        children: "18"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.154,
                        y: 0,
                        children: "25"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.514,
                        y: 0,
                        children: "4"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-700)",
                    d: "m610.243 47.742-3.535 3.535a1 1 0 0 1-1.415 0 1 1 0 0 1 0-1.414l2.829-2.828-2.829-2.828a1 1 0 0 1 0-1.415 1 1 0 0 1 1.415 0l3.535 3.536a1 1 0 0 1 .293.707 1 1 0 0 1-.293.707"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.985,
                        y: 0,
                        children: "12"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-700)",
                    rx: 16,
                    transform: "translate(552 183)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-50)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.733,
                        y: 0,
                        children: "17"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-700)",
                    rx: 16,
                    transform: "translate(392 144)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-50)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.689,
                        y: 0,
                        children: "6"
                    })
                })
            ]
        })
    });
exports.default = SvgRangeCalendar;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"exnCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRangeSlider = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 48,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 48px)/2) 10px"
        },
        viewBox: "0 0 200 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Price range"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M1 31h47v2H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M149 31h50a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-50z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-700)",
                d: "M72 31h53v2H72z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "rgba(255,255,255,0)",
                stroke: "var(--anatomy-gray-700)",
                strokeWidth: 2,
                transform: "translate(129 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 8,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 7,
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(200 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: -68.656,
                    y: 0,
                    children: "$100 \u2013 $300"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "rgba(255,255,255,0)",
                stroke: "var(--anatomy-gray-700)",
                strokeWidth: 2,
                transform: "translate(52 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 8,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 7,
                        fill: "none"
                    })
                ]
            })
        ]
    });
exports.default = SvgRangeSlider;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7ohvF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSearchField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 56,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 56px)/2) 10px"
        },
        viewBox: "0 0 176 56",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Search"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(31 44)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Hawaii"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(144 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 16,
                        cy: 16,
                        r: 16,
                        fill: "rgba(0,0,0,0)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-700)",
                        d: "m17.238 16 2.456-2.456a.875.875 0 0 0-1.237-1.238L16 14.762l-2.457-2.456a.875.875 0 0 0-1.237 1.238L14.762 16l-2.456 2.456a.875.875 0 1 0 1.237 1.238L16 17.238l2.457 2.456a.875.875 0 1 0 1.237-1.238Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-700)",
                        d: "m22.744 45.429-3.455-3.454a5.7 5.7 0 1 0-1.314 1.314l3.454 3.454a.933.933 0 0 0 1.315-1.315Zm-12.077-6.762a4 4 0 1 1 4 4 4 4 0 0 1-4-4"
                    })
                })
            })
        ]
    });
exports.default = SvgSearchField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l7OQE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSelection = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 108,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 108px)/2) 10px"
        },
        viewBox: "0 0 231 108",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-1610 -1745)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-800)",
                    transform: "translate(1610 1745)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 231,
                            height: 50,
                            stroke: "none",
                            rx: 6
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 230,
                            height: 49,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 5.5
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-400)",
                    transform: "translate(1610 1803)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 231,
                            height: 50,
                            stroke: "none",
                            rx: 6
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 230,
                            height: 49,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 5.5
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    transform: "translate(1622 1754)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 14,
                            height: 14,
                            fill: "var(--anatomy-gray-800)",
                            rx: 2,
                            transform: "translate(0 9)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-75)",
                            d: "M11.1 12.19a.96.96 0 0 0-1.347.162l-4.108 5.233-1.417-1.7a.96.96 0 0 0-1.475 1.228l2.177 2.613c.02.024.049.032.07.054a1 1 0 0 0 .074.086 1 1 0 0 0 .134.072 1 1 0 0 0 .1.054 1 1 0 0 0 .358.079 1 1 0 0 0 .372-.084 1 1 0 0 0 .1-.059 1 1 0 0 0 .14-.08 1 1 0 0 0 .072-.09c.02-.02.049-.03.068-.054l4.849-6.166a.96.96 0 0 0-.167-1.348"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 179,
                    height: 20,
                    fill: "var(--anatomy-gray-300)",
                    rx: 4,
                    transform: "translate(1648 1760)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 179,
                    height: 20,
                    fill: "var(--anatomy-gray-200)",
                    rx: 4,
                    transform: "translate(1648 1818)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 2,
                        transform: "translate(1622 1821)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 14,
                                height: 14,
                                stroke: "none",
                                rx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 12,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 1
                            })
                        ]
                    })
                })
            ]
        })
    });
exports.default = SvgSelection;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"rQclf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSlider = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 48,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 48px)/2) 10px"
        },
        viewBox: "0 0 200 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Exposure"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M1 31h142v2H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M167 31h32a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-32z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-700)",
                d: "M100 31h43v2h-43z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "rgba(255,255,255,0)",
                stroke: "var(--anatomy-gray-700)",
                strokeWidth: 2,
                transform: "translate(147 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 8,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 7,
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(200 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: -21.7,
                    y: 0,
                    children: "+20"
                })
            })
        ]
    });
exports.default = SvgSlider;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fFIzk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStatusLight = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2) 10px"
        },
        viewBox: "0 0 46 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4,
                cy: 4,
                r: 4,
                fill: "var(--anatomy-gray-600)",
                transform: "translate(0 12)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Draft"
                })
            })
        ]
    });
exports.default = SvgStatusLight;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cpk35":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSwitch = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 137 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 26,
                height: 14,
                fill: "var(--anatomy-gray-700)",
                rx: 7,
                transform: "translate(0 9)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-75)",
                stroke: "var(--anatomy-gray-700)",
                strokeWidth: 2,
                transform: "translate(12 9)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 7,
                        cy: 7,
                        r: 7,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 7,
                        cy: 7,
                        r: 6,
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(36 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Low power mode"
                })
            })
        ]
    });
exports.default = SvgSwitch;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bnlGy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTable = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 173,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: 10,
            minHeight: 152,
            boxSizing: "border-box"
        },
        viewBox: "0 0 300 173",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-600)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 11,
                        fontWeight: 600,
                        letterSpacing: ".06em",
                        transform: "translate(264.996 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -21.791,
                            y: 0,
                            children: "SIZE"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M296 172.5H4c-1.93 0-3.5-1.124-3.5-2.505V34.005C.5 32.624 2.07 31.5 4 31.5h292c1.93 0 3.5 1.124 3.5 2.505v135.99c0 1.381-1.57 2.505-3.5 2.505"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-300)",
                                d: "M4 32c-1.626 0-3 .918-3 2.005v135.99C1 171.082 2.374 172 4 172h292c1.626 0 3-.918 3-2.005V34.005c0-1.087-1.374-2.005-3-2.005zm0-1h292c2.21 0 4 1.346 4 3.005v135.99c0 1.66-1.79 3.005-4 3.005H4c-2.21 0-4-1.346-4-3.005V34.005C0 32.345 1.79 31 4 31"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(281 59)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -37.1,
                            y: 0,
                            children: "214 KB"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M1 78h298v1H1z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M1 125h298v1H1zM1 172h298v1H1z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(281 106)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -37.324,
                            y: 0,
                            children: "120 KB"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(281 153)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -37.156,
                            y: 0,
                            children: "139 KB"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(53 60)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Proposal"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(53 107)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Budget"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(53 154)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Onboarding"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-600)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 11,
                        fontWeight: 600,
                        letterSpacing: ".06em",
                        transform: "translate(50.996 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "FILE NAME"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M278 17a1 1 0 0 0-1.71-.71l-1.29 1.3V12a1 1 0 1 0-2 0v5.59l-1.29-1.3a1.004 1.004 0 0 0-1.42 1.42l3 3a1 1 0 0 0 1.41 0l3-3a1 1 0 0 0 .3-.71"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 2,
                        transform: "translate(17 48)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 14,
                                height: 14,
                                stroke: "none",
                                rx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 12,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            strokeWidth: 2,
                            transform: "translate(17 142)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 14,
                                    height: 14,
                                    stroke: "none",
                                    rx: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 12,
                                    height: 12,
                                    x: 1,
                                    y: 1,
                                    fill: "none",
                                    rx: 1
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            strokeWidth: 2,
                            transform: "translate(17 95)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 14,
                                    height: 14,
                                    stroke: "none",
                                    rx: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 12,
                                    height: 12,
                                    x: 1,
                                    y: 1,
                                    fill: "none",
                                    rx: 1
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            strokeWidth: 2,
                            transform: "translate(17 48)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 14,
                                    height: 14,
                                    stroke: "none",
                                    rx: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 12,
                                    height: 12,
                                    x: 1,
                                    y: 1,
                                    fill: "none",
                                    rx: 1
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M222 31h1v142h-1z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        transform: "translate(17)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 14,
                                height: 14,
                                fill: "var(--anatomy-gray-700)",
                                rx: 2,
                                transform: "translate(0 9)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-75)",
                                d: "M10 15H4a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(17 39)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        fill: "var(--anatomy-gray-700)",
                        rx: 2,
                        transform: "translate(0 9)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-75)",
                            d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgTable;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"blsK2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTabs = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2) 10px"
        },
        viewBox: "0 0 270 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 270,
                height: 2,
                fill: "var(--anatomy-gray-300)",
                rx: 1,
                transform: "translate(0 30)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 66,
                height: 2,
                fill: "var(--anatomy-gray-900)",
                rx: 1,
                transform: "translate(0 30)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-900)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(26 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Photos"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9 13a3 3 0 1 0 3 3 3 3 0 0 0-3-3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M16.5 11h-3.025L11.8 9.163A.5.5 0 0 0 11.429 9H6.57a.5.5 0 0 0-.37.163L4.525 11H1.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M9 20.1a4.1 4.1 0 1 1 4.1-4.1A4.1 4.1 0 0 1 9 20.1"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(116 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Videos"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-700)",
                            d: "m106.2 12.1-4.2 3.15v-3.341a.91.91 0 0 0-.909-.909h-8.182a.91.91 0 0 0-.909.909v8.182a.91.91 0 0 0 .909.909h8.182a.91.91 0 0 0 .909-.909V16.75l4.2 3.15a.5.5 0 0 0 .8-.4v-7a.5.5 0 0 0-.8-.4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(204 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Documents"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M188 12.5V8h-6.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V13h-4.5a.5.5 0 0 1-.5-.5"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M189 8h.043a.5.5 0 0 1 .353.146l3.458 3.454a.5.5 0 0 1 .146.357V12h-4Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgTabs;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k8kpp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTagGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            height: 150,
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 130px)/2) 10px",
            width: "calc(100% - 20px)",
            borderRadius: 4
        },
        viewBox: "0 -20 415 220",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-75)",
                stroke: "var(--anatomy-gray-600)",
                transform: "translate(67.653 85.595)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 148.873,
                        height: 45.807,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 147.873,
                        height: 44.807,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 21,
                transform: "translate(86.739 114.23)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Traveling"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "m199.953 113.142-4.644-4.644 4.644-4.644a1.193 1.193 0 0 0-1.687-1.687l-4.644 4.644-4.643-4.644a1.194 1.194 0 1 0-1.688 1.688l4.644 4.643-4.644 4.644a1.193 1.193 0 0 0 1.687 1.687l4.644-4.644 4.644 4.644a1.193 1.193 0 0 0 1.687-1.687"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-600)",
                        transform: "translate(220.343 85.595)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 124.061,
                                height: 45.807,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 123.061,
                                height: 44.807,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 21,
                        transform: "translate(239.429 114.23)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Hiking"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-600)",
                            d: "m327.421 113.142-4.644-4.644 4.644-4.644a1.193 1.193 0 0 0-1.687-1.687l-4.644 4.644-4.643-4.644a1.194 1.194 0 1 0-1.688 1.688l4.644 4.643-4.644 4.644a1.193 1.193 0 0 0 1.687 1.687l4.644-4.644 4.644 4.644a1.193 1.193 0 0 0 1.687-1.687"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 21,
                transform: "translate(66.763 64.372)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Categories"
                })
            })
        ]
    });
exports.default = SvgTagGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aIwiG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTextArea = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 80,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 80px)/2) 10px"
        },
        viewBox: "0 0 176 80",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Comment"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 56,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 55,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 30)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 14,
                        children: "Lorem ipsum dolor sit "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 32,
                        children: "amet, consectetur "
                    })
                ]
            })
        ]
    });
exports.default = SvgTextArea;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"40HrI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTextField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 56,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 56px)/2) 10px"
        },
        viewBox: "0 0 176 56",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Address"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 44)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "123 Any St."
                })
            })
        ]
    });
exports.default = SvgTextField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bc9cR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTimeField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "10px calc((100% - 176px)/2)",
            height: "calc(151px - 20px)",
            width: 176
        },
        viewBox: "8 53 264 52",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-341 -39)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-400)",
                            strokeWidth: 1.5,
                            transform: "translate(349 104)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 264,
                                    height: 48,
                                    stroke: "none",
                                    rx: 6
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 262.5,
                                    height: 46.5,
                                    x: 0.75,
                                    y: 0.75,
                                    fill: "none",
                                    rx: 5.25
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-700)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 18,
                            transform: "translate(349 92)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Appointment time"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 23,
                    height: 26,
                    fill: "var(--anatomy-gray-700)",
                    rx: 2,
                    transform: "translate(366 115)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                    fill: "var(--anatomy-gray-50)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 21,
                    transform: "translate(367 134)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            xmlSpace: "preserve",
                            x: 3,
                            y: 0,
                            children: "12"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            xmlSpace: "preserve",
                            y: 0,
                            fill: "var(--anatomy-gray-700)",
                            children: " : 45 PM"
                        })
                    ]
                })
            ]
        })
    });
exports.default = SvgTimeField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4qrBC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgToast = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 48,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 48px)/2) 10px"
        },
        viewBox: "0 0 214 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 214,
                height: 48,
                fill: "var(--anatomy-gray-600)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "none",
                transform: "translate(174 8)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "m191.343 24 3.4-3.4a.95.95 0 1 0-1.343-1.338l-3.4 3.395-3.4-3.4a.95.95 0 1 0-1.338 1.343l3.396 3.4-3.4 3.4a.95.95 0 1 0 1.342 1.338l3.4-3.395 3.4 3.395a.95.95 0 1 0 1.339-1.338Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M184 18h12v12h-12z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1,
                height: 32,
                fill: "#fff",
                fillOpacity: 0.25,
                rx: 0.5,
                transform: "translate(165 8)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(42 14)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 14,
                    children: "Analysis complete!"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "M25 16a8 8 0 1 0 8 8 8 8 0 0 0-8-8m5.333 4.54-6.324 8.13a.6.6 0 0 1-.438.231h-.036a.6.6 0 0 1-.424-.175l-3.893-3.9a.6.6 0 0 1 0-.849l.663-.662a.6.6 0 0 1 .849 0l2.67 2.675 5.257-6.755a.6.6 0 0 1 .842-.1l.728.569a.6.6 0 0 1 .105.84Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M16 15h18v18H16z"
            })
        ]
    });
exports.default = SvgToast;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ljWCz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgToggleButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 62 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-200)",
                stroke: "rgba(0,0,0,0)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 62,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 61,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M4 0h54a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 1a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h54a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m12.823 18 1.189 1.19-5.05 5.01L7 25l.822-1.987Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M18.977 20.16 19 17.144 23.146 13l1.135-.011a.726.726 0 0 0 .5-1.24l-2.26-2.269-2.271-2.238a.723.723 0 0 0-1.234.505L19 8.854 14.853 13l-3.012.022a.723.723 0 0 0-.554 1.233l3.229 3.229 3.229 3.229a.721.721 0 0 0 1.231-.554Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(32 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Pin"
                })
            })
        ]
    });
exports.default = SvgToggleButton;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i9JRq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTooltip = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 66,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 66px)/2) 10px"
        },
        viewBox: "0 0 39 66",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 39,
                        height: 24,
                        fill: "var(--anatomy-gray-700)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-700)",
                        d: "M16 24h8l-4 4Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(10 4)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 12,
                            children: "Edit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-500)",
                        transform: "translate(3 34)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 32,
                                height: 32,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 31,
                                height: 31,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M26.784 45.1 23.9 42.216a.6.6 0 0 0-.433-.176h-.017a.69.69 0 0 0-.464.2L12.542 52.686a.5.5 0 0 0-.126.211l-1.388 4.653c-.057.188.229.426.391.426h.031c.138-.031 3.933-1.172 4.656-1.389a.5.5 0 0 0 .207-.125l10.444-10.448a.7.7 0 0 0 .2-.441.6.6 0 0 0-.173-.473M15.7 55.658c-1.081.325-2.431.733-3.365 1.011l1-3.365Z"
                    })
                ]
            })
        ]
    });
exports.default = SvgTooltip;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2jbL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTree = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 173,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: 10,
            minHeight: 152,
            boxSizing: "border-box"
        },
        viewBox: "0 0 301 188",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "Tree_svg__a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M0 0h301v188H0z"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#Tree_svg__a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-100)",
                        d: "M0 0h301v188H0z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "var(--anatomy-gray-50)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M296 186.5H4c-1.93 0-3.5-1.551-3.5-3.458V3.958C.5 2.05 2.07.5 4 .5h292c1.93 0 3.5 1.551 3.5 3.458v179.084c0 1.907-1.57 3.458-3.5 3.458"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-300)",
                                        d: "M4 1C2.346 1 1 2.327 1 3.958v179.084C1 184.673 2.346 186 4 186h292c1.654 0 3-1.327 3-2.958V3.958C299 2.327 297.654 1 296 1zm0-1h292c2.21 0 4 1.772 4 3.958v179.084c0 2.186-1.79 3.958-4 3.958H4c-2.21 0-4-1.772-4-3.958V3.958C0 1.772 1.79 0 4 0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-900)",
                                d: "M1 94h298v46H1z",
                                opacity: 0.1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-300)",
                                d: "M1 46h298v1H1z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(110 21)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Documents"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "var(--anatomy-gray-75)",
                                stroke: "var(--anatomy-gray-600)",
                                strokeWidth: 2,
                                transform: "translate(44 16)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 14,
                                        height: 14,
                                        stroke: "none",
                                        rx: 2
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 12,
                                        height: 12,
                                        x: 1,
                                        y: 1,
                                        fill: "none",
                                        rx: 1
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                transform: "translate(64 101)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 14,
                                        height: 14,
                                        fill: "var(--anatomy-gray-700)",
                                        rx: 2,
                                        transform: "translate(0 9)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-75)",
                                        d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-75)",
                                    stroke: "var(--anatomy-gray-600)",
                                    strokeWidth: 2,
                                    transform: "translate(64 63)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 14,
                                            height: 14,
                                            stroke: "none",
                                            rx: 2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 12,
                                            height: 12,
                                            x: 1,
                                            y: 1,
                                            fill: "none",
                                            rx: 1
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-75)",
                                    stroke: "var(--anatomy-gray-600)",
                                    strokeWidth: 2,
                                    transform: "translate(64 157)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 14,
                                            height: 14,
                                            stroke: "none",
                                            rx: 2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 12,
                                            height: 12,
                                            x: 1,
                                            y: 1,
                                            fill: "none",
                                            rx: 1
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-600)",
                                d: "M1 140h298v1H1zM1 93h298v1H1z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-200)",
                                        d: "M73.02 36.481a2.47 2.47 0 0 1-2.5-2.5V12.02a2.47 2.47 0 0 1 2.5-2.5h10.084a1.97 1.97 0 0 1 1.4.6l3.1 3.1a.9.9 0 0 0 .7.3h10.68a2.47 2.47 0 0 1 2.5 2.5v17.965a2.47 2.47 0 0 1-2.5 2.5Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "M99 13H88.3c-.1 0-.2 0-.4-.2l-3.1-3.1a2.41 2.41 0 0 0-1.7-.7H73a2.946 2.946 0 0 0-3 3v22a3.01 3.01 0 0 0 3 3h26a3.01 3.01 0 0 0 3-3V16a2.946 2.946 0 0 0-3-3m2 21a2.006 2.006 0 0 1-2 2H73a2.006 2.006 0 0 1-2-2V14h28a2.006 2.006 0 0 1 2 2Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(110 36)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "12 items"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-50)",
                                d: "M97.421 83.352a2.15 2.15 0 0 1-2.145-2.153V58.807a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-500)",
                                d: "m116.725 61.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H97.25a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 97.25 84h17.5a2.627 2.627 0 0 0 2.625-2.625V62.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H97.25a1.75 1.75 0 0 1-1.75-1.75V58.625a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(130 68)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Onboarding"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(130 83)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "PDF"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-50)",
                                        d: "M97.421 130.352a2.15 2.15 0 0 1-2.145-2.153v-22.392a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "m116.725 108.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H97.25a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 97.25 131h17.5a2.627 2.627 0 0 0 2.625-2.625V109.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H97.25a1.75 1.75 0 0 1-1.75-1.75v-22.748a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(130 115)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Budget"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(130 130)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "XLS"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-50)",
                                        d: "M99.109 177.352a2.15 2.15 0 0 1-2.145-2.153v-22.392a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "m118.413 155.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H98.938a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 98.938 178h17.5a2.627 2.627 0 0 0 2.625-2.625V156.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H98.938a1.75 1.75 0 0 1-1.75-1.75v-22.748a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(131.688 162)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Sales Pitch"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(131.688 177)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "PPT"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "var(--anatomy-gray-75)",
                                        stroke: "var(--anatomy-gray-400)",
                                        transform: "translate(265 11)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 24,
                                                height: 24,
                                                stroke: "none",
                                                rx: 4
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 23,
                                                height: 23,
                                                x: 0.5,
                                                y: 0.5,
                                                fill: "none",
                                                rx: 3.5
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "var(--anatomy-gray-800)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M275.533 27c0-2.511 1.315-3.4 2.065-4.284a4.9 4.9 0 0 0 1.111-3.049c0-2.311-1.225-3.6-3.075-3.6s-3.111 1.339-3.111 3.6a4.94 4.94 0 0 0 1.165 3.049.64.64 0 0 1 .163.413v.922a.636.636 0 0 1-.555.642c-3.715.324-4.296 2.867-4.296 3.874 0 .111.013 1.439.021 1.548h7.487a5.44 5.44 0 0 1-.975-3.111Z"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M279.35 21.788a5.5 5.5 0 0 1 1.65-.255c.057 0 .113.007.17.008a5.7 5.7 0 0 0 .449-2.12c-.001-1.935-1.141-3.354-2.867-3.354-.1 0-.2.019-.3.028a4.86 4.86 0 0 1 1.325 3.572 5.9 5.9 0 0 1-.428 2.121Z"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M281 23.044A3.956 3.956 0 1 0 284.956 27 3.956 3.956 0 0 0 281 23.044m2.222 4.178a.22.22 0 0 1-.222.222h-1.556V29a.22.22 0 0 1-.222.222h-.444a.22.22 0 0 1-.222-.222v-1.556H279a.22.22 0 0 1-.222-.222v-.444a.22.22 0 0 1 .222-.222h1.556V25a.22.22 0 0 1 .222-.222h.444a.22.22 0 0 1 .222.222v1.556H283a.22.22 0 0 1 .222.222Z"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-700)",
                                d: "M25.99 21.01a1 1 0 0 0-1.707-.71L21 23.586 17.717 20.3a1.002 1.002 0 1 0-1.417 1.417l3.993 3.983a1 1 0 0 0 1.414 0l3.993-3.983a1 1 0 0 0 .29-.707"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "var(--anatomy-gray-50)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M296 186.5H4c-1.93 0-3.5-1.551-3.5-3.458V3.958C.5 2.05 2.07.5 4 .5h292c1.93 0 3.5 1.551 3.5 3.458v179.084c0 1.907-1.57 3.458-3.5 3.458"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-300)",
                                        d: "M4 1C2.346 1 1 2.327 1 3.958v179.084C1 184.673 2.346 186 4 186h292c1.654 0 3-1.327 3-2.958V3.958C299 2.327 297.654 1 296 1zm0-1h292c2.21 0 4 1.772 4 3.958v179.084c0 2.186-1.79 3.958-4 3.958H4c-2.21 0-4-1.772-4-3.958V3.958C0 1.772 1.79 0 4 0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-900)",
                                d: "M1 94h298v46H1z",
                                opacity: 0.1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-300)",
                                d: "M1 46h298v1H1z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(110 21)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Documents"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-75)",
                                    stroke: "var(--anatomy-gray-600)",
                                    strokeWidth: 2,
                                    transform: "translate(44 16)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 14,
                                            height: 14,
                                            stroke: "none",
                                            rx: 2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 12,
                                            height: 12,
                                            x: 1,
                                            y: 1,
                                            fill: "none",
                                            rx: 1
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                transform: "translate(64 101)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 14,
                                        height: 14,
                                        fill: "var(--anatomy-gray-700)",
                                        rx: 2,
                                        transform: "translate(0 9)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "var(--anatomy-gray-75)",
                                            d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-75)",
                                    stroke: "var(--anatomy-gray-600)",
                                    strokeWidth: 2,
                                    transform: "translate(64 63)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 14,
                                            height: 14,
                                            stroke: "none",
                                            rx: 2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 12,
                                            height: 12,
                                            x: 1,
                                            y: 1,
                                            fill: "none",
                                            rx: 1
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-75)",
                                    stroke: "var(--anatomy-gray-600)",
                                    strokeWidth: 2,
                                    transform: "translate(64 157)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 14,
                                            height: 14,
                                            stroke: "none",
                                            rx: 2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 12,
                                            height: 12,
                                            x: 1,
                                            y: 1,
                                            fill: "none",
                                            rx: 1
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-600)",
                                d: "M1 140h298v1H1zM1 93h298v1H1z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-200)",
                                        d: "M73.02 36.481a2.47 2.47 0 0 1-2.5-2.5V12.02a2.47 2.47 0 0 1 2.5-2.5h10.084a1.97 1.97 0 0 1 1.4.6l3.1 3.1a.9.9 0 0 0 .7.3h10.68a2.47 2.47 0 0 1 2.5 2.5v17.965a2.47 2.47 0 0 1-2.5 2.5Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "M99 13H88.3c-.1 0-.2 0-.4-.2l-3.1-3.1a2.41 2.41 0 0 0-1.7-.7H73a2.946 2.946 0 0 0-3 3v22a3.01 3.01 0 0 0 3 3h26a3.01 3.01 0 0 0 3-3V16a2.946 2.946 0 0 0-3-3m2 21a2.006 2.006 0 0 1-2 2H73a2.006 2.006 0 0 1-2-2V14h28a2.006 2.006 0 0 1 2 2Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(110 36)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "12 items"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-50)",
                                        d: "M97.421 83.352a2.15 2.15 0 0 1-2.145-2.153V58.807a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "m116.725 61.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H97.25a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 97.25 84h17.5a2.627 2.627 0 0 0 2.625-2.625V62.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H97.25a1.75 1.75 0 0 1-1.75-1.75V58.625a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(130 68)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Onboarding"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(130 83)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "PDF"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-50)",
                                        d: "M97.421 130.352a2.15 2.15 0 0 1-2.145-2.153v-22.392a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "m116.725 108.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H97.25a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 97.25 131h17.5a2.627 2.627 0 0 0 2.625-2.625V109.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H97.25a1.75 1.75 0 0 1-1.75-1.75v-22.748a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(130 115)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Budget"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(130 130)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "XLS"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-50)",
                                        d: "M99.109 177.352a2.15 2.15 0 0 1-2.145-2.153v-22.392a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "m118.413 155.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H98.938a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 98.938 178h17.5a2.627 2.627 0 0 0 2.625-2.625V156.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H98.938a1.75 1.75 0 0 1-1.75-1.75v-22.748a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(131.688 162)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Sales Pitch"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(131.688 177)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "PPT"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "var(--anatomy-gray-75)",
                                        stroke: "var(--anatomy-gray-400)",
                                        transform: "translate(265 11)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 24,
                                                height: 24,
                                                stroke: "none",
                                                rx: 4
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 23,
                                                height: 23,
                                                x: 0.5,
                                                y: 0.5,
                                                fill: "none",
                                                rx: 3.5
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "var(--anatomy-gray-800)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M275.533 27c0-2.511 1.315-3.4 2.065-4.284a4.9 4.9 0 0 0 1.111-3.049c0-2.311-1.225-3.6-3.075-3.6s-3.111 1.339-3.111 3.6a4.94 4.94 0 0 0 1.165 3.049.64.64 0 0 1 .163.413v.922a.636.636 0 0 1-.555.642c-3.715.324-4.296 2.867-4.296 3.874 0 .111.013 1.439.021 1.548h7.487a5.44 5.44 0 0 1-.975-3.111Z"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M279.35 21.788a5.5 5.5 0 0 1 1.65-.255c.057 0 .113.007.17.008a5.7 5.7 0 0 0 .449-2.12c-.001-1.935-1.141-3.354-2.867-3.354-.1 0-.2.019-.3.028a4.86 4.86 0 0 1 1.325 3.572 5.9 5.9 0 0 1-.428 2.121Z"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M281 23.044A3.956 3.956 0 1 0 284.956 27 3.956 3.956 0 0 0 281 23.044m2.222 4.178a.22.22 0 0 1-.222.222h-1.556V29a.22.22 0 0 1-.222.222h-.444a.22.22 0 0 1-.222-.222v-1.556H279a.22.22 0 0 1-.222-.222v-.444a.22.22 0 0 1 .222-.222h1.556V25a.22.22 0 0 1 .222-.222h.444a.22.22 0 0 1 .222.222v1.556H283a.22.22 0 0 1 .222.222Z"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "var(--anatomy-gray-700)",
                                    d: "M25.99 21.01a1 1 0 0 0-1.707-.71L21 23.586 17.717 20.3a1.002 1.002 0 1 0-1.417 1.417l3.993 3.983a1 1 0 0 0 1.414 0l3.993-3.983a1 1 0 0 0 .29-.707"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgTree;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"atBPa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseFocusRing = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 40,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 40px)/2) 10px"
        },
        viewBox: "0 0 80 40",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(4 4)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 72,
                    height: 32,
                    fill: "var(--anatomy-gray-900)",
                    rx: 16
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "rgba(0,0,0,0)",
                    stroke: "var(--anatomy-gray-600)",
                    strokeWidth: 2,
                    transform: "translate(-4 -4)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 80,
                            height: 40,
                            stroke: "none",
                            rx: 20
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 78,
                            height: 38,
                            x: 1,
                            y: 1,
                            fill: "none",
                            rx: 19
                        })
                    ]
                })
            ]
        })
    });
exports.default = SvgUseFocusRing;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bKLu9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseFocus = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 30,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 30px)/2) 10px"
        },
        viewBox: "0 0 200 30",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-600)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 200,
                        height: 30,
                        stroke: "none",
                        rx: 5
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 198,
                        height: 28,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 4
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 10,
                transform: "translate(11 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-900)",
                d: "M11 5h1v19h-1z"
            })
        ]
    });
exports.default = SvgUseFocus;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6rzJ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseFocusWithin = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 108,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 108px)/2) 10px"
        },
        viewBox: "0 0 231 108",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "useFocusWithin_svg__a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "none",
                            d: "M0 0h136v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "useFocusWithin_svg__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "none",
                            d: "M0 0h207v20H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-600)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 231,
                        height: 50,
                        stroke: "none",
                        rx: 6
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 229,
                        height: 48,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        transform: "translate(12 10)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 63,
                                height: 30,
                                stroke: "none",
                                rx: 5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 62,
                                height: 29,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 4.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-900)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 10,
                        transform: "translate(23 30)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M23 15h1v19h-1z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#useFocusWithin_svg__a)",
                transform: "translate(83 15)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 63,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 63,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4,
                        transform: "translate(71)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-300)",
                transform: "translate(0 58)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 231,
                        height: 50,
                        stroke: "none",
                        rx: 6
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 230,
                        height: 49,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 5.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#useFocusWithin_svg__b)",
                transform: "translate(12 73)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 63,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 63,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4,
                        transform: "translate(71)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 63,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4,
                        transform: "translate(142)"
                    })
                ]
            })
        ]
    });
exports.default = SvgUseFocusWithin;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fdavU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseHover = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 43.5,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 43.5px)/2) 10px"
        },
        viewBox: "0 0 72 43.5",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-300)",
                stroke: "var(--anatomy-gray-400)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 72,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 30,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M53.214 17.635v24.032a.366.366 0 0 0 .626.259l6.7-6.7h9.374a.366.366 0 0 0 .259-.626Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-50)",
                        d: "M71.164 33.511 54.249 16.598a1.47 1.47 0 0 0-1.035-.429h-.365a1.1 1.1 0 0 0-1.1 1.1v24.286a1.91 1.91 0 0 0 1.6 1.93 1.82 1.82 0 0 0 1.526-.523l6.274-6.274h8.768a1.83 1.83 0 0 0 1.817-1.58 1.9 1.9 0 0 0-.57-1.597m-1.246 1.712h-9.375l-6.7 6.7a.36.36 0 0 1-.256.108.366.366 0 0 1-.369-.367V17.635l16.959 16.962a.366.366 0 0 1-.259.626",
                        opacity: 0.65
                    })
                ]
            })
        ]
    });
exports.default = SvgUseHover;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d2wmU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseKeyboard = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 81,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 81px)/2) 10px"
        },
        viewBox: "0 0 191 81",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-1747 -1604)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 190,
                    height: 80,
                    fill: "var(--anatomy-gray-200)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 4,
                    transform: "translate(1747.5 1604.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 17,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1749.5 1606.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1768.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1781.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1794.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1807.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1820.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1833.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1846.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1859.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1872.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1885.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1898.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1911.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1924.5 1606.5)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 20.5,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1749.5 1645.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 27,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1749.5 1658.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 13,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1769.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 18,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1784.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 76,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1804.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 18,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1749.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 13,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1902.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 18,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1917.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 18,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1882.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1749.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1762.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1775.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1788.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1801.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1814.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1827.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1840.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1853.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1866.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1879.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1892.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1905.5 1619.5)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 17,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1918.5 1619.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 17,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1749.5 1632.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1768.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1781.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1794.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1807.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1820.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1833.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1846.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1859.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1872.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1885.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1898.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1911.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1924.5 1632.5)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1772 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1785 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1798 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1811 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1824 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1837 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1850 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1863 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1876 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1889 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1902 1645.5)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 20.5,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1915 1645.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1778.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1791.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1804.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1817.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1830.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1843.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1856.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1869.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1882.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1895.5 1658.5)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 27,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1908.5 1658.5)"
                })
            ]
        })
    });
exports.default = SvgUseKeyboard;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6sD3B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseLongPress = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 89.088,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 89px)/2) 10px"
        },
        viewBox: "-17 0 106.868 89.088",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-400)",
                stroke: "var(--anatomy-gray-500)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 72,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 30,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-900)",
                                d: "M54.261 39.495c-1.569-2.528-9.981-10.294-11.747-13.412-1.572-3.115.758-5.854 2.322-4.882 1.37 1.163 6.063 5.046 10.755 8.735a79 79 0 0 1 3.91 3.745 95 95 0 0 1 9.246 12.22.416.416 0 0 0 .706-.439 98 98 0 0 0-8.821-11.768 7.6 7.6 0 0 1 5.5-.864 3.95 3.95 0 0 1 2.061 1.309 50.7 50.7 0 0 1 7.553 10.708.416.416 0 0 0 .744-.372 52 52 0 0 0-7.324-10.516 4.17 4.17 0 0 1 4.178-.774 9.54 9.54 0 0 1 3.4 2.848 59.6 59.6 0 0 1 5.417 7.649.416.416 0 1 0 .736-.389 53 53 0 0 0-4.591-6.619 4.62 4.62 0 0 1 3.826-.6c3.171 1.757 4.591 2.625 6.851 5.761a37.8 37.8 0 0 1 4.8 9.139c2.92 7.977 6.091 17.177 13.069 24.95 0 0 .271 1.429-1.308 4.068-2.281 3.809-10.883 10.279-16.596 8.909l-5.282-5.245a8.15 8.15 0 0 0-3.517-2.132 120 120 0 0 1-14.26-6.97c-5.86-3.1-14.678-15.35-16.249-18.271s-5.307-11.482-4.92-12.464 2.923-.986 4.875-.017 4.068 6 6.275 8.888c.926 1.212 5.027 3.931 6.284 4.8a34.6 34.6 0 0 0-2.593-8.456 51 51 0 0 0-5.3-9.535"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-700)",
                        strokeLinejoin: "round",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "m59.422 23.362-5.245.629a.42.42 0 0 1-.452-.38l-.148-1.236a.417.417 0 0 1 .35-.474l5.247-.628a.42.42 0 0 1 .452.379l.148 1.236a.417.417 0 0 1-.352.474m-23.208 3.535-5.244.628a.417.417 0 0 1-.453-.378l-.148-1.237a.417.417 0 0 1 .35-.474l5.246-.631a.417.417 0 0 1 .452.378l.148 1.236a.417.417 0 0 1-.35.478m20.322-11.73-3.875 3.589a.42.42 0 0 1-.588-.04l-.848-.911a.417.417 0 0 1 .003-.59l3.879-3.594a.42.42 0 0 1 .588.04l.847.914a.417.417 0 0 1-.006.593M39.452 31.504l-3.875 3.59a.42.42 0 0 1-.588-.04l-.846-.913a.417.417 0 0 1 .002-.59l3.875-3.591a.42.42 0 0 1 .588.04l.847.914a.416.416 0 0 1-.003.589Zm9.506-21.052-1.024 5.181a.417.417 0 0 1-.5.314l-1.221-.241a.42.42 0 0 1-.34-.478l1.02-5.185a.417.417 0 0 1 .5-.314l1.222.241a.42.42 0 0 1 .34.48Zm-4.213 23.202-1.023 5.184a.42.42 0 0 1-.5.314l-1.221-.242a.416.416 0 0 1-.34-.477l1.023-5.182a.417.417 0 0 1 .5-.314l1.22.234a.42.42 0 0 1 .34.479Zm-5.008-22.682 2.218 4.795a.42.42 0 0 1-.22.548l-1.13.522a.42.42 0 0 1-.56-.185l-2.216-4.8a.42.42 0 0 1 .22-.548l1.13-.523a.42.42 0 0 1 .56.187Zm-6.445 5.834 4.613 2.576a.417.417 0 0 1 .144.571l-.608 1.087a.416.416 0 0 1-.561.178l-4.612-2.575a.417.417 0 0 1-.148-.572l.609-1.086a.416.416 0 0 1 .561-.178Z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-50)",
                                fillOpacity: 0.6,
                                d: "M59.746 23.113a.4.4 0 0 0 .028-.225l-.148-1.236a.42.42 0 0 0-.453-.38l-5.245.628a.417.417 0 0 0-.35.475l.148 1.237c.02.23.223.399.452.379l5.246-.629a.42.42 0 0 0 .322-.25m-3.118-8.08a.42.42 0 0 0-.087-.457l-.847-.914a.42.42 0 0 0-.588-.04l-3.877 3.59a.417.417 0 0 0-.003.59l.847.915c.152.173.415.19.589.04l3.875-3.59q.06-.061.091-.134m-12.93 23.874a.4.4 0 0 0 .023-.07l1.024-5.182a.42.42 0 0 0-.343-.48l-1.222-.241a.417.417 0 0 0-.5.313l-1.024 5.184a.416.416 0 0 0 .344.478l1.221.242c.2.046.4-.06.477-.244m4.213-23.203a.4.4 0 0 0 .022-.07l1.024-5.183a.42.42 0 0 0-.342-.48l-1.222-.242a.417.417 0 0 0-.5.314l-1.025 5.183a.42.42 0 0 0 .344.48l1.221.24c.2.047.4-.06.478-.242m-8.366 15.666a.42.42 0 0 0-.087-.456l-.847-.914a.42.42 0 0 0-.588-.04l-3.879 3.594a.417.417 0 0 0-.002.59l.845.914c.152.173.415.191.589.04l3.88-3.595q.059-.06.09-.133m2.41-15.28a.42.42 0 0 0 0-.327l-2.217-4.795a.42.42 0 0 0-.56-.187l-1.13.523a.42.42 0 0 0-.22.548l2.217 4.795a.42.42 0 0 0 .56.186l1.13-.522a.42.42 0 0 0 .22-.22m-5.42 10.556a.4.4 0 0 0 .029-.224l-.148-1.237a.417.417 0 0 0-.453-.378l-5.245.627a.417.417 0 0 0-.35.475l.147 1.237c.021.229.224.398.453.378l5.245-.628a.42.42 0 0 0 .322-.25m1.536-6.746a.42.42 0 0 0-.169-.52l-4.614-2.577a.416.416 0 0 0-.561.179l-.61 1.088a.417.417 0 0 0 .147.571l4.613 2.576a.416.416 0 0 0 .561-.178l.607-1.087a.4.4 0 0 0 .026-.052m22.595 3.604a1.41 1.41 0 0 1-1.124.852l-5.246.628-.033.004c-.77.066-1.454-.501-1.533-1.268l-.145-1.215a1.417 1.417 0 0 1 1.223-1.598l5.245-.628.033-.003c.77-.066 1.454.5 1.533 1.267l.146 1.215c.035.253 0 .51-.1.746m-3.118-8.081a1.4 1.4 0 0 1-.332.476l-3.875 3.59-.025.023c-.583.506-1.47.45-1.984-.123l-.833-.899a1.413 1.413 0 0 1 .025-1.99l.007-.006.021-.02 3.873-3.587.024-.022a1.42 1.42 0 0 1 1.985.123l.833.9c.393.41.504 1.01.281 1.535m-12.93 23.874a1.42 1.42 0 0 1-1.602.833l-1.2-.238a1.42 1.42 0 0 1-1.142-1.658l1.024-5.182.006-.029q.029-.122.077-.238a1.416 1.416 0 0 1 1.604-.832l1.2.237a1.42 1.42 0 0 1 1.14 1.658l-1.023 5.183-.007.031q-.029.121-.077.235m4.213-23.203a1.416 1.416 0 0 1-1.604.831l-1.2-.237a1.42 1.42 0 0 1-1.141-1.657l1.024-5.183.006-.03q.03-.12.078-.238a1.416 1.416 0 0 1 1.604-.831l1.2.237a1.42 1.42 0 0 1 1.14 1.658l-1.024 5.182-.006.03a1.4 1.4 0 0 1-.077.238M40.466 31.76a1.4 1.4 0 0 1-.307.452l-.004.005-.005.004-.02.019-3.874 3.591-.024.022c-.584.506-1.47.45-1.985-.123l-.832-.898a1.413 1.413 0 0 1 .03-1.994l.003-.003.02-.02 3.875-3.59.024-.022a1.42 1.42 0 0 1 1.985.123l.832.898c.394.41.505 1.01.282 1.536m2.411-15.28c-.14.333-.4.596-.73.742l-1.112.514a1.424 1.424 0 0 1-1.897-.67l-2.218-4.795-.012-.028a1.43 1.43 0 0 1 0-1.11c.14-.332.4-.595.729-.742l1.113-.515a1.42 1.42 0 0 1 1.897.671l2.217 4.795.013.028c.15.353.15.757 0 1.11m-5.42 10.557a1.41 1.41 0 0 1-1.124.853l-5.245.627-.03.003a1.42 1.42 0 0 1-1.536-1.266l-.146-1.215A1.416 1.416 0 0 1 30.6 24.44l5.245-.628.03-.003a1.42 1.42 0 0 1 1.537 1.267l.145 1.215c.034.253 0 .51-.1.745m1.536-6.746q-.034.08-.078.157l-.597 1.069a1.42 1.42 0 0 1-1.9.59l-.005-.004-.024-.013-4.612-2.575-.02-.012a1.42 1.42 0 0 1-.507-1.933l.6-1.067a1.42 1.42 0 0 1 1.899-.588l.005.003.024.013 4.613 2.575.028.016c.602.363.849 1.123.574 1.769"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.072 48.072a8 8 0 1 0 8 8 8 8 0 0 0-8-8m0 15a7 7 0 1 1 7-7 7 7 0 0 1-7 7"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M27.072 55.115v-4.543a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v5.293a.5.5 0 0 0 .146.353l2.8 2.8a.5.5 0 0 0 .707 0l.668-.668a.5.5 0 0 0 0-.707l-2.175-2.171a.5.5 0 0 1-.146-.357"
                    })
                ]
            })
        ]
    });
exports.default = SvgUseLongPress;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6ZHMO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseMove = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 57,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 57px)/2) 10px"
        },
        viewBox: "0 0 57 57",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-300)",
                stroke: "var(--anatomy-gray-400)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 28.5,
                        cy: 28.5,
                        r: 28.5,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 28.5,
                        cy: 28.5,
                        r: 28,
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-50)",
                        d: "m38.748 26.588 4.028 4.531a.317.317 0 0 1-.224.541h-2.536v5.072h5.072v-2.536a.317.317 0 0 1 .319-.318.3.3 0 0 1 .222.093l4.531 4.028-4.531 4.028a.3.3 0 0 1-.222.093.317.317 0 0 1-.319-.318v-2.534h-5.072v5.072h2.537a.317.317 0 0 1 .224.541l-4.028 4.531-4.028-4.531a.317.317 0 0 1 .224-.541h2.536v-5.072h-5.073v2.537a.317.317 0 0 1-.319.318.3.3 0 0 1-.222-.093L27.336 38l4.531-4.028a.3.3 0 0 1 .222-.093.317.317 0 0 1 .319.318v2.536h5.072V31.66h-2.536a.317.317 0 0 1-.224-.541Zm.474-1.375a.634.634 0 0 0-.948 0l-4.486 5.046a1.586 1.586 0 0 0-.1 2.054 1.63 1.63 0 0 0 1.312.615h1.212v2.536h-2.536v-1.177a1.65 1.65 0 0 0-1.359-1.661 1.58 1.58 0 0 0-1.31.414l-5.046 4.486a.634.634 0 0 0 0 .948l5.046 4.486a1.58 1.58 0 0 0 1.31.414 1.65 1.65 0 0 0 1.359-1.66v-1.178h2.536v2.536H35a1.63 1.63 0 0 0-1.312.615 1.586 1.586 0 0 0 .1 2.054l4.486 5.046a.634.634 0 0 0 .948 0l4.486-5.046a1.586 1.586 0 0 0 .1-2.054 1.63 1.63 0 0 0-1.312-.615h-1.212v-2.536h2.536v1.177a1.65 1.65 0 0 0 1.359 1.66 1.58 1.58 0 0 0 1.31-.414l5.046-4.486a.634.634 0 0 0 0-.948l-5.046-4.485a1.585 1.585 0 0 0-2.669 1.156v1.268h-2.536v-2.536h1.212a1.63 1.63 0 0 0 1.312-.615 1.586 1.586 0 0 0-.1-2.054Z",
                        opacity: 0.65
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M40.016 31.66h2.536a.317.317 0 0 0 .224-.541l-4.028-4.531-4.028 4.531a.317.317 0 0 0 .224.541h2.536v5.072h-5.072v-2.536a.317.317 0 0 0-.541-.224L27.336 38l4.531 4.028a.317.317 0 0 0 .541-.224v-2.536h5.072v5.072h-2.536a.317.317 0 0 0-.224.541l4.028 4.531 4.028-4.531a.317.317 0 0 0-.224-.541h-2.536v-5.072h5.072v2.536a.317.317 0 0 0 .541.224L50.16 38l-4.531-4.028a.317.317 0 0 0-.541.224v2.536h-5.072Z"
                    })
                ]
            })
        ]
    });
exports.default = SvgUseMove;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9O6bO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUsePress = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 89.088,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 89px)/2) 10px"
        },
        viewBox: "17 0 105.856 89.088",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-400)",
                stroke: "var(--anatomy-gray-500)",
                strokeWidth: 2,
                transform: "translate(33.856)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 72,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 30,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M52.607 39.494c1.569-2.528 9.981-10.294 11.747-13.412 1.571-3.115-.758-5.854-2.322-4.882-1.368 1.163-6.063 5.046-10.755 8.735a79 79 0 0 0-3.91 3.745 95 95 0 0 0-9.246 12.22.416.416 0 0 1-.706-.439 98 98 0 0 1 8.821-11.768 7.6 7.6 0 0 0-5.5-.864 3.95 3.95 0 0 0-2.061 1.309 50.7 50.7 0 0 0-7.551 10.703.416.416 0 0 1-.744-.372 52 52 0 0 1 7.322-10.511 4.17 4.17 0 0 0-4.178-.774 9.54 9.54 0 0 0-3.4 2.848 59.6 59.6 0 0 0-5.417 7.649.416.416 0 1 1-.736-.389 53 53 0 0 1 4.591-6.621 4.62 4.62 0 0 0-3.826-.6c-3.171 1.757-4.591 2.625-6.851 5.761a37.8 37.8 0 0 0-4.8 9.139c-2.92 7.977-6.091 17.177-13.069 24.95 0 0-.271 1.429 1.308 4.068C3.605 83.8 12.207 90.27 17.92 88.9l5.282-5.245a8.15 8.15 0 0 1 3.517-2.132 120 120 0 0 0 14.26-6.97c5.86-3.1 14.678-15.35 16.249-18.271s5.307-11.486 4.92-12.463-2.923-.986-4.875-.017-4.068 6-6.275 8.888c-.926 1.212-5.027 3.931-6.284 4.8a34.6 34.6 0 0 1 2.593-8.456 51 51 0 0 1 5.3-9.535"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                strokeLinejoin: "round",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m47.432 23.37 5.246.63a.42.42 0 0 0 .452-.38l.148-1.236a.417.417 0 0 0-.35-.475l-5.245-.627a.42.42 0 0 0-.453.379l-.148 1.235a.417.417 0 0 0 .35.474m23.209 3.534 5.245.628a.417.417 0 0 0 .452-.378l.148-1.237a.417.417 0 0 0-.35-.474l-5.245-.628a.417.417 0 0 0-.453.378l-.147 1.237a.417.417 0 0 0 .35.474m-20.322-11.73 3.874 3.59a.42.42 0 0 0 .589-.04l.847-.914a.417.417 0 0 0-.003-.59L51.75 13.63a.42.42 0 0 0-.588.04l-.847.914a.417.417 0 0 0 .004.59ZM67.4 31.515l3.874 3.59a.42.42 0 0 0 .589-.04l.846-.913a.417.417 0 0 0-.003-.59l-3.873-3.593a.42.42 0 0 0-.589.04l-.847.914a.416.416 0 0 0 .004.589Zm-9.507-21.057 1.028 5.181a.417.417 0 0 0 .5.314l1.221-.24a.42.42 0 0 0 .34-.48l-1.02-5.184a.417.417 0 0 0-.5-.314l-1.222.241a.42.42 0 0 0-.34.48Zm4.216 23.202 1.025 5.183a.42.42 0 0 0 .5.314l1.22-.242a.416.416 0 0 0 .341-.477l-1.022-5.186a.417.417 0 0 0-.5-.314l-1.219.242a.42.42 0 0 0-.34.478Zm5.007-22.685-2.218 4.794a.42.42 0 0 0 .22.549l1.13.522a.42.42 0 0 0 .56-.186l2.218-4.796a.42.42 0 0 0-.22-.548l-1.131-.524a.42.42 0 0 0-.56.187Zm6.448 5.836-4.613 2.576a.417.417 0 0 0-.143.572l.607 1.086a.416.416 0 0 0 .56.178l4.615-2.575a.417.417 0 0 0 .149-.571l-.612-1.088a.416.416 0 0 0-.562-.178Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-50)",
                        fillOpacity: 0.6,
                        d: "M47.11 23.12c.054.13.173.228.322.25l5.245.629c.23.02.432-.15.453-.38l.148-1.236a.417.417 0 0 0-.35-.475l-5.246-.627a.42.42 0 0 0-.452.379l-.149 1.236a.4.4 0 0 0 .029.224m3.117-8.08q.031.073.091.133l3.876 3.59c.174.152.437.134.588-.04l.847-.913a.417.417 0 0 0-.003-.59l-.004-.004-3.873-3.587a.42.42 0 0 0-.588.04l-.847.914a.42.42 0 0 0-.087.456m12.93 23.875c.078.183.277.29.477.244l1.222-.242a.416.416 0 0 0 .343-.478v-.002l-1.024-5.182a.417.417 0 0 0-.5-.314l-1.222.242a.42.42 0 0 0-.343.48l1.024 5.183a.4.4 0 0 0 .023.07M58.945 15.71a.42.42 0 0 0 .477.243l1.222-.242a.42.42 0 0 0 .343-.48l-1.024-5.182a.417.417 0 0 0-.5-.314l-1.222.241a.42.42 0 0 0-.343.481l1.024 5.182a.4.4 0 0 0 .023.07m8.365 15.667q.03.072.09.133l.005.004 3.875 3.591c.173.151.436.133.588-.04l.846-.914a.417.417 0 0 0-.003-.59l-.004-.003-3.874-3.591a.42.42 0 0 0-.589.04l-.846.914a.42.42 0 0 0-.088.456m-2.41-15.28c.04.096.116.177.219.22l1.13.523a.42.42 0 0 0 .56-.186l2.218-4.795a.42.42 0 0 0-.22-.548l-1.13-.523a.42.42 0 0 0-.56.187l-2.218 4.795a.42.42 0 0 0 0 .327m5.42 10.557c.055.13.173.228.322.25l5.245.628c.23.02.432-.149.453-.378l.148-1.237a.417.417 0 0 0-.35-.475l-5.246-.627a.417.417 0 0 0-.452.378l-.148 1.237a.4.4 0 0 0 .028.224m-1.536-6.746.026.051.607 1.088a.416.416 0 0 0 .561.178h.002l4.612-2.576a.417.417 0 0 0 .147-.571v-.002l-.61-1.086a.416.416 0 0 0-.561-.179l-.002.001-4.613 2.576a.42.42 0 0 0-.169.52M46.19 23.51a1.4 1.4 0 0 1-.1-.745l.146-1.215a1.42 1.42 0 0 1 1.566-1.264l5.245.628.03.004a1.417 1.417 0 0 1 1.194 1.594l-.145 1.215a1.42 1.42 0 0 1-1.567 1.264l-5.245-.628-.03-.004a1.41 1.41 0 0 1-1.094-.849m3.117-8.08a1.41 1.41 0 0 1 .282-1.536l.833-.9a1.42 1.42 0 0 1 2.008-.1l3.873 3.587.021.02.004.004a1.416 1.416 0 0 1 .028 1.992l-.832.899a1.42 1.42 0 0 1-2.01.1l-3.875-3.59-.023-.022a1.4 1.4 0 0 1-.309-.455m12.93 23.874a1.4 1.4 0 0 1-.083-.266l-1.024-5.184-.006-.032a1.42 1.42 0 0 1 1.146-1.625l1.2-.237a1.416 1.416 0 0 1 1.688 1.1l1.024 5.181.006.033a1.42 1.42 0 0 1-1.148 1.625l-1.2.238a1.42 1.42 0 0 1-1.603-.833m-4.212-23.203a1.4 1.4 0 0 1-.084-.268l-1.024-5.182-.005-.03a1.42 1.42 0 0 1 1.146-1.628l1.2-.237a1.416 1.416 0 0 1 1.687 1.099l1.024 5.183q.005.016.006.033a1.42 1.42 0 0 1-1.146 1.624l-1.2.237a1.416 1.416 0 0 1-1.604-.831m8.365 15.666a1.41 1.41 0 0 1 .283-1.536l.832-.899a1.42 1.42 0 0 1 2.009-.1l3.874 3.59.02.02.004.003.004.004q.199.196.307.454a1.41 1.41 0 0 1-.282 1.536l-.832.898a1.42 1.42 0 0 1-2.009.101l-3.874-3.591-.02-.019-.005-.004-.004-.005a1.4 1.4 0 0 1-.307-.452m-2.41-15.28a1.43 1.43 0 0 1 .012-1.138l2.217-4.795.014-.029a1.42 1.42 0 0 1 1.884-.642l1.112.515c.33.147.589.41.73.742a1.43 1.43 0 0 1-.013 1.138l-2.217 4.795-.016.032a1.424 1.424 0 0 1-1.881.638l-1.113-.514a1.4 1.4 0 0 1-.73-.742m5.419 10.557a1.4 1.4 0 0 1-.1-.745l.146-1.216a1.42 1.42 0 0 1 1.566-1.263l5.245.628.03.004a1.417 1.417 0 0 1 1.194 1.594l-.145 1.215a1.42 1.42 0 0 1-1.567 1.263l-5.245-.627-.03-.004a1.41 1.41 0 0 1-1.094-.849M67.862 20.3a1.426 1.426 0 0 1 .603-1.785l4.612-2.576.024-.013.006-.002a1.42 1.42 0 0 1 1.9.588l.598 1.067q.044.077.08.158a1.42 1.42 0 0 1-.606 1.787l-4.613 2.575-.023.013-.006.003a1.42 1.42 0 0 1-1.9-.59l-.597-1.068a1.4 1.4 0 0 1-.078-.157"
                    })
                ]
            })
        ]
    });
exports.default = SvgUsePress;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7ohac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAB_DEFS", ()=>TAB_DEFS);
parcelHelpers.export(exports, "default", ()=>SearchMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _adobeLogo = require("./icons/AdobeLogo");
var _reactAriaComponents = require("react-aria-components");
var _close = require("@react-spectrum/s2/icons/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _componentCardView = require("./ComponentCardView");
var _fakeSearchFieldButton = require("./FakeSearchFieldButton");
var _fakeSearchFieldButtonDefault = parcelHelpers.interopDefault(_fakeSearchFieldButton);
var _internationalizedLogo = require("./icons/InternationalizedLogo");
// eslint-disable-next-line monorepo/no-internal-import
var _noSearchResults = require("@react-spectrum/s2/illustrations/linear/NoSearchResults");
var _noSearchResultsDefault = parcelHelpers.interopDefault(_noSearchResults);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// @ts-ignore
var _docsReactAriaComponents = require("docs:react-aria-components");
var _docsReactAriaComponentsDefault = parcelHelpers.interopDefault(_docsReactAriaComponents);
var _reactAriaLogo = require("./icons/ReactAriaLogo");
// @ts-ignore
var _s21 = require("docs:@react-spectrum/s2");
var _s2Default = parcelHelpers.interopDefault(_s21);
var _context = require("../../../react-aria-components/src/context");
var _tabs = require("./Tabs");
'use client';
function CloseButton({ closeSearchMenu }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            position: 'absolute',
            top: 8,
            right: 8
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _reactAriaComponents.OverlayTriggerStateContext),
                    null
                ]
            ],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                isQuiet: true,
                onPress: closeSearchMenu,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
            })
        })
    });
}
let modalStyle = " _Pa111 WJ111 Za111 LykyMMb111 g_g111 Sf111 Rf111 Tt111 Qt111 _9G1Ky111 _kb111 hb111 mb111 lb111 iq111 _jf111 oe111 ne111 ke111 je111 _nb111 _Er111 _Rr111 JM111 GM111 IM111 HM111 FGMCvrc111";
const TAB_DEFS = {
    'react-spectrum': {
        label: 'React Spectrum',
        description: "Components for Adobe's Spectrum design system",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {})
    },
    'react-aria': {
        label: 'React Aria',
        description: 'Style-free components and hooks for building accessible UIs',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {})
    },
    'internationalized': {
        label: 'Internationalized',
        description: 'Framework-agnostic internationalization utilities',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _internationalizedLogo.InternationalizedLogo), {})
    }
};
const getCurrentLibrary = (currentPage)=>{
    if (currentPage.url.includes('react-aria')) return 'react-aria';
    else if (currentPage.url.includes('react-internationalized')) return 'internationalized';
    return 'react-spectrum';
};
const getLibraryFromUrl = (url)=>{
    if (url.includes('react-aria')) return 'react-aria';
    if (url.includes('react-internationalized')) return 'internationalized';
    return 'react-spectrum';
};
function SearchMenu(props) {
    let { pages, currentPage, toggleShowSearchMenu, closeSearchMenu, isSearchOpen, overlayId } = props;
    const currentLibrary = getCurrentLibrary(currentPage);
    let [selectedLibrary, setSelectedLibrary] = (0, _react.useState)(currentLibrary);
    let [searchValue, setSearchValue] = (0, _react.useState)('');
    const orderedTabs = (0, _react.useMemo)(()=>{
        const allTabs = Object.keys(TAB_DEFS).map((id)=>({
                id,
                ...TAB_DEFS[id]
            }));
        const currentTabIndex = allTabs.findIndex((tab)=>tab.id === currentLibrary);
        if (currentTabIndex > 0) {
            const currentTab = allTabs.splice(currentTabIndex, 1)[0];
            allTabs.unshift(currentTab);
        }
        return allTabs;
    }, [
        currentLibrary
    ]);
    const searchRef = (0, _react.useRef)(null);
    // Transform pages data into component data structure
    const transformedComponents = (0, _react.useMemo)(()=>{
        if (!pages || !Array.isArray(pages)) return [];
        const components = pages.filter((page)=>page.url && page.url.endsWith('.html') && getLibraryFromUrl(page.url) === selectedLibrary).map((page)=>{
            const name = page.url.replace(/^\//, '').replace(/\.html$/, '');
            const title = page.tableOfContents?.[0]?.title || name;
            const lib = getLibraryFromUrl(page.url);
            // get description from docs metadata
            const componentKey = title.replace(/\s+/g, '');
            let description = undefined;
            if (lib === 'react-aria') description = (0, _docsReactAriaComponentsDefault.default)?.exports?.[componentKey]?.description;
            else if (lib === 'react-spectrum') description = (0, _s2Default.default)?.exports?.[componentKey]?.description;
            const section = page.exports?.section || 'Components';
            return {
                id: name,
                name: title,
                href: page.url,
                description,
                section
            };
        });
        return components;
    }, [
        pages,
        selectedLibrary
    ]);
    // Build sections for the selected library
    const sections = (0, _react.useMemo)(()=>{
        const sectionNames = Array.from(new Set(transformedComponents.map((c)=>c.section || 'Components')));
        return sectionNames.map((sectionName)=>({
                id: sectionName.toLowerCase(),
                name: sectionName,
                children: transformedComponents.filter((c)=>(c.section || 'Components') === sectionName)
            })).sort((a, b)=>{
            if (a.id === 'components') return -1;
            if (b.id === 'components') return 1;
            return 0;
        });
    }, [
        transformedComponents
    ]);
    const [selectedSectionId, setSelectedSectionId] = (0, _react.useState)('components');
    const prevSearchWasEmptyRef = (0, _react.useRef)(true);
    // Ensure selected section is valid for the current library
    (0, _react.useEffect)(()=>{
        const baseIds = sections.map((s)=>s.id);
        const sectionIds = searchValue.trim().length > 0 ? [
            'all',
            ...baseIds
        ] : baseIds;
        if (!selectedSectionId || !sectionIds.includes(selectedSectionId)) setSelectedSectionId(sectionIds[0] || 'components');
    }, [
        selectedLibrary,
        sections,
        selectedSectionId,
        searchValue
    ]);
    // When search starts, auto-select the All tag.
    (0, _react.useEffect)(()=>{
        const isEmpty = searchValue.trim().length === 0;
        if (prevSearchWasEmptyRef.current && !isEmpty) setSelectedSectionId('all');
        prevSearchWasEmptyRef.current = isEmpty;
    }, [
        searchValue
    ]);
    (0, _react.useEffect)(()=>{
        let isMac = /Mac/.test(navigator.platform);
        const isTextInputLike = (el)=>{
            if (!el) return false;
            let h = el;
            return h.isContentEditable || !!el.closest('input, textarea, [contenteditable], [role="textbox"]');
        };
        const handleKeyDown = (e)=>{
            if (e.isComposing) // avoid intercepting IME input
            return;
            if (e.key === 'Escape') {
                e.preventDefault();
                closeSearchMenu();
            } else if (e.key === 'k' && (isMac ? e.metaKey : e.ctrlKey)) {
                e.preventDefault();
                toggleShowSearchMenu();
            } else if (e.key === '/' && !(isTextInputLike(e.target) || isTextInputLike(document.activeElement))) {
                e.preventDefault();
                toggleShowSearchMenu();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, [
        closeSearchMenu,
        toggleShowSearchMenu
    ]);
    let onFocusSearch = (0, _reactDefault.default).useCallback(()=>{
        toggleShowSearchMenu();
        if (isSearchOpen) setTimeout(()=>searchRef.current?.focus(), 10);
    }, [
        isSearchOpen,
        toggleShowSearchMenu
    ]);
    (0, _react.useEffect)(()=>{
        if (isSearchOpen) setTimeout(()=>{
            // Focus the search field of the currently selected library
            if (searchRef.current) searchRef.current.focus();
        }, 10);
    }, [
        isSearchOpen,
        selectedLibrary
    ]);
    (0, _react.useEffect)(()=>{
        if (!isSearchOpen) {
            if (searchValue.trim() === '') setSelectedLibrary(currentLibrary);
        }
    }, [
        currentLibrary,
        isSearchOpen,
        searchValue
    ]);
    let { contains } = (0, _reactAriaComponents.useFilter)({
        sensitivity: 'base'
    });
    const filter = (0, _reactDefault.default).useCallback((textValue, inputValue)=>{
        return textValue != null && contains(textValue, inputValue);
    }, [
        contains
    ]);
    let filteredComponents = (0, _react.useMemo)(()=>{
        if (!searchValue) return sections;
        return sections.map((section)=>({
                ...section,
                children: section.children.filter((item)=>contains(item.name, searchValue))
            })).filter((section)=>section.children.length > 0);
    }, [
        sections,
        searchValue,
        contains
    ]);
    const tags = (0, _react.useMemo)(()=>{
        if (searchValue.trim().length > 0) // When searching, prepend an All tag
        return [
            {
                id: 'all',
                name: 'All'
            },
            ...sections
        ];
        return sections;
    }, [
        searchValue,
        sections
    ]);
    // Type to search handler
    const handleButtonKeyDown = (0, _reactDefault.default).useCallback((e)=>{
        // Ignore modifier keys, navigation keys, Enter, Escape, etc.
        if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey && e.key !== ' ') {
            e.preventDefault();
            onFocusSearch(); // Open the search overlay
            setSearchValue(e.key); // Set the initial search value
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            toggleShowSearchMenu();
        }
    }, [
        onFocusSearch,
        toggleShowSearchMenu
    ]);
    let handleButtonPress = (0, _reactDefault.default).useCallback(()=>{
        toggleShowSearchMenu();
    }, [
        toggleShowSearchMenu
    ]);
    let handleSearchFieldKeyDown = (0, _reactDefault.default).useCallback((e)=>{
        if (e.key === 'Escape' && !searchValue.trim()) {
            e.preventDefault();
            closeSearchMenu();
        }
    }, [
        closeSearchMenu,
        searchValue
    ]);
    const handleTabSelectionChange = (0, _reactDefault.default).useCallback((key)=>{
        if (searchValue) setSearchValue('');
        setSelectedLibrary(key);
        // Focus main search field of the newly selected tab
        setTimeout(()=>{
            const lib = key;
            const expectedLabel = `Search ${TAB_DEFS[lib].label}`;
            if (searchRef.current && searchRef.current.getInputElement()?.getAttribute('aria-label') === expectedLabel) searchRef.current.focus();
        }, 10);
    }, [
        searchValue
    ]);
    const handleSectionSelectionChange = (0, _reactDefault.default).useCallback((keys)=>{
        const firstKey = Array.from(keys)[0];
        if (firstKey) setSelectedSectionId(firstKey);
    }, []);
    const selectedItems = (0, _react.useMemo)(()=>{
        if (searchValue.trim().length > 0 && selectedSectionId === 'all') return filteredComponents.flatMap((s)=>s.children) || [];
        return filteredComponents.find((s)=>s.id === selectedSectionId)?.children || [];
    }, [
        filteredComponents,
        selectedSectionId,
        searchValue
    ]);
    const selectedSectionName = (0, _react.useMemo)(()=>{
        if (searchValue.trim().length > 0 && selectedSectionId === 'all') return 'All';
        return filteredComponents.find((s)=>s.id === selectedSectionId)?.name || sections.find((s)=>s.id === selectedSectionId)?.name || 'Items';
    }, [
        filteredComponents,
        sections,
        selectedSectionId,
        searchValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " se111 DPlN5qb111 eb111 Ul111 ql111",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fakeSearchFieldButtonDefault.default), {
                onKeyDown: handleButtonKeyDown,
                onPress: handleButtonPress,
                isSearchOpen: isSearchOpen,
                overlayId: overlayId
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Modal), {
                isDismissable: true,
                isOpen: isSearchOpen,
                onOpenChange: (isOpen)=>{
                    if (!isOpen) closeSearchMenu();
                },
                className: modalStyle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Dialog), {
                    id: overlayId,
                    className: " Fb111",
                    "aria-label": "Search menu",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.Tabs), {
                        "aria-label": "Libraries",
                        keyboardActivation: "manual",
                        orientation: "vertical",
                        selectedKey: selectedLibrary,
                        onSelectionChange: handleTabSelectionChange,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.TabList), {
                                "aria-label": "Library",
                                children: orderedTabs.map((tab, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.Tab), {
                                        id: tab.id,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: " sd111 Ug111 qg111 Js111",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    style: {
                                                        viewTransitionName: i === 0 ? 'search-menu-icon' : 'none'
                                                    },
                                                    children: tab.icon
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            style: {
                                                                viewTransitionName: i === 0 ? 'search-menu-label' : 'none'
                                                            },
                                                            className: " uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-f111 vx111 wb111 xb111 _xa111 _Fd111 _FezxGHba111 _FnuYUweb111 pt111",
                                                            children: tab.label
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: " -_6BNtrc-b111 vx111",
                                                            children: tab.description
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, tab.id))
                            }),
                            orderedTabs.map((tab, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.TabPanel), {
                                    id: tab.id,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Autocomplete), {
                                        filter: filter,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: " JM111 GM111 IM111 HM111 ZJ111 Qp111",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SearchField), {
                                                    onKeyDown: handleSearchFieldKeyDown,
                                                    value: searchValue,
                                                    onChange: setSearchValue,
                                                    ref: searchRef,
                                                    size: "L",
                                                    "aria-label": `Search ${tab.label}`,
                                                    UNSAFE_style: {
                                                        marginInlineEnd: 296,
                                                        viewTransitionName: i === 0 ? 'search-menu-search-field' : 'none'
                                                    },
                                                    styles: " ZOLfCn111"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseButton, {
                                                closeSearchMenu: closeSearchMenu
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: " Fb111 _Na111 Pa111 Sf111 Rf111 Qf111",
                                                children: [
                                                    sections.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: " _Pe111 Wr111 _9c111 g4hn3s111 Tt111 Qt111",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.SelectableCollectionContext).Provider, {
                                                            value: null,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TagGroup), {
                                                                selectionMode: "single",
                                                                disallowEmptySelection: true,
                                                                selectedKeys: selectedSectionId ? [
                                                                    selectedSectionId
                                                                ] : [],
                                                                onSelectionChange: handleSectionSelectionChange,
                                                                "aria-label": "Select section",
                                                                items: tags,
                                                                styles: " Ix111 Hx111",
                                                                children: (tag)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Tag), {
                                                                        id: tag.id,
                                                                        children: tag.name
                                                                    }, tag.id)
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componentCardView.ComponentCardView), {
                                                        onAction: ()=>{
                                                            setSearchValue('');
                                                            closeSearchMenu();
                                                        },
                                                        items: selectedItems.map((item)=>({
                                                                id: item.id,
                                                                name: item.name,
                                                                href: item.href ?? `/${tab.id}/${item.name}.html`
                                                            })),
                                                        ariaLabel: selectedSectionName,
                                                        renderEmptyState: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.IllustratedMessage), {
                                                                styles: " JG111 GG111 IG111 HG111",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noSearchResultsDefault.default), {}),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                                                        children: "No results"
                                                                    }),
                                                                    searchValue.trim().length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                                                                        children: [
                                                                            "No results found for ",
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                                className: " wd111 xd111 _xa111 wX0cczbc111 xX0cczbc111 _xX0cczba111",
                                                                                children: searchValue
                                                                            }),
                                                                            " in ",
                                                                            tab.label,
                                                                            "."
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                                                                        children: [
                                                                            "No results found in ",
                                                                            tab.label,
                                                                            "."
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, tab.id))
                        ]
                    })
                })
            })
        ]
    });
}

},{"0":"8QWMz","1":"6dcs1","2":"feneJ","3":"jLdos","4":"9Acyn","5":"1m1tx","6":"1QbV1","7":"c1f6M","8":"c3iwE","9":"89z3H","10":"1vm65","11":"hUkfe","12":"dTnNb","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","./icons/AdobeLogo":"5Bj5G","react-aria-components":"2Emk2","@react-spectrum/s2/icons/Close":"aI18O","./ComponentCardView":"7i8km","./FakeSearchFieldButton":"FVlQ4","./icons/InternationalizedLogo":"ge2ja","@react-spectrum/s2/illustrations/linear/NoSearchResults":"fvWSv","react":"a1TxN","docs:react-aria-components":"7tBJX","./icons/ReactAriaLogo":"iQPne","docs:@react-spectrum/s2":"lTyTL","../../../react-aria-components/src/context":"bNiEF","./Tabs":"cMkES","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8QWMz":[function() {},{}],"6dcs1":[function() {},{}],"feneJ":[function() {},{}],"jLdos":[function() {},{}],"9Acyn":[function() {},{}],"1m1tx":[function() {},{}],"1QbV1":[function() {},{}],"c1f6M":[function() {},{}],"c3iwE":[function() {},{}],"89z3H":[function() {},{}],"1vm65":[function() {},{}],"hUkfe":[function() {},{}],"dTnNb":[function() {},{}],"5Bj5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdobeLogo", ()=>AdobeLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AdobeLogo = ({ className = '', size = 32 })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: className,
        style: {
            width: size,
            height: size
        },
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "Layer 2",
        viewBox: "0 0 501.71 444.05",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m297.58 444.05-36.45-101.4h-91.46l76.87-193.53 116.65 294.93h138.52L316.8 0H186.23L0 444.05h297.58z",
            "data-name": "Layer 1",
            className: " t4u0Crc111 _Va111"
        })
    });
};

},{"0":"7PUbU","react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7PUbU":[function() {},{}],"FVlQ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FakeSearchFieldButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _search = require("@react-spectrum/s2/icons/Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
'use client';
function FakeSearchFieldButton({ onPress, onKeyDown, isSearchOpen, overlayId, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
        ...props,
        "aria-label": "Open search and menu",
        "aria-expanded": isSearchOpen,
        "aria-controls": isSearchOpen ? overlayId : undefined,
        onPress: onPress,
        onKeyDown: onKeyDown,
        className: ({ isHovered, isFocusVisible })=>(function anonymous(props) {
                let rules = " ";
                rules += ' FRuFGYc111';
                rules += ' _oa111';
                rules += ' Sv111';
                rules += ' Rv111';
                rules += ' -_6BNtrc-d111';
                rules += ' vx111';
                rules += ' og111';
                rules += ' ng111';
                rules += ' kg111';
                rules += ' jg111';
                rules += ' _kc111';
                rules += ' hc111';
                rules += ' mc111';
                rules += ' lc111';
                rules += ' _jf111';
                rules += ' Yd111';
                rules += ' Xb111';
                rules += ' _2b111';
                if (props.isFocusVisible) rules += ' in111';
                else if (props.isHovered) rules += ' io111';
                else rules += ' iq111';
                rules += ' gX111';
                rules += ' pv111';
                rules += ' rD111';
                rules += ' ZOLfCn111';
                rules += ' sd111';
                rules += ' eb111';
                rules += ' Uc111';
                rules += ' Usd111';
                rules += ' qc111';
                rules += ' qsd111';
                if (props.isFocusVisible) rules += ' _Lf111';
                else rules += ' _Le111';
                rules += ' _Kd111';
                if (props.isFocusVisible) rules += ' Oh111';
                else rules += ' Oj111';
                if (props.isFocusVisible) rules += ' _Mc111';
                else rules += ' _Ma111';
                rules += ' -F_-Fv111';
                return rules;
            })({
                isHovered,
                isFocusVisible
            }),
        style: {
            viewTransitionName: !isSearchOpen ? 'search-menu-search-field' : 'none'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {
                UNSAFE_className: String(" ZuUmpre111 FuUmpre111 -_8sjo0b-t5ZbAob111 _va111")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("kbd", {
                className: " IM111 uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-c111 vx111 wc111 xc111 _xa111 wezxGHbtN5kwb111 xezxGHbg111 _xezxGHba111 wfd111 xfd111 _xfa111 wfX0cczbc111 xfX0cczbc111 _xfX0cczba111 _Fd111 _FezxGHba111 _FnuYUweb111 pn111 gqlRAZb111 Tj111 Qj111 St111 Rt111 oe111 ne111 ke111 je111 _kb111 hb111 mb111 lb111 iq111 _jf111 _Ob111 _dc111",
                children: "\u2318K"
            })
        ]
    });
}

},{"0":"joNVj","1":"5U05E","2":"hXYeu","react/jsx-runtime":"2Is6Z","react-aria-components":"2Emk2","react":"a1TxN","@react-spectrum/s2/icons/Search":"cSREm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"joNVj":[function() {},{}],"5U05E":[function() {},{}],"hXYeu":[function() {},{}],"ge2ja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternationalizedLogo", ()=>InternationalizedLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const InternationalizedLogo = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "Layer_1",
        viewBox: "0 0 160 160",
        className: " Jy111 Gy111 Iy111 Hy111 Fv111 Zw111",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "clippath",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M23.98 79.99c0-17.01 7.58-32.25 19.54-42.52.92 2.02 2.32 4.67 4 7.13 1.05 1.54 2.28 3.1 3.65 4.41 1.33 1.27 3.04 2.55 5.08 3.13 3.29.94 7.1.8 9.98.7l.88-.03c1.63-.05 2.94-.07 4.03.05 1.11.11 1.57.33 1.71.42.31.2.39.37.41.43.03.08.07.22.03.46-.09.52-.53 1.28-1.4 1.76-2.07 1.15-4.14 2.6-5.69 4.59-1.63 2.09-2.54 4.6-2.54 7.55 0 .86-.07 1.4-.15 1.72v.03c-.28.06-.81.1-1.7.03-.27-.02-.55-.05-.86-.07-2.32-.21-5.69-.5-8.87-.17-3.54.37-8.1 1.64-10.56 5.96-1.08 1.89-2.33 5.04-2.03 8.8.31 3.92 2.27 7.99 6.71 11.55 5.12 4.1 10.75 4.98 18.12 5.8 4.2.47 6.58 1.37 7.94 2.33 1.19.84 1.85 1.9 2.18 3.55.58 2.88-.4 7.19-2.43 12.45-.97 2.52-2.11 5.05-3.24 7.52-.25.54-.5 1.08-.74 1.61-.81 1.76-1.61 3.47-2.27 5.03C41.73 127.9 24 106.03 24 80.02Zm26.36-46.91c-.07-.17-.15-.33-.24-.49a55.64 55.64 0 0 1 12.37-5.84c.05.3.14.6.26.89 2.06 4.9 8.3 10.94 16.68 10.94 4.33 0 7.8-1.86 10.35-3.97 2.53-2.1 4.34-4.6 5.47-6.33.41-.63.62-1.34.65-2.04.69.2 1.37.42 2.05.65-.06.18-.1.37-.13.57-.67 4.46-1.44 10.7-.74 16.34.69 5.54 3.01 11.91 9.76 14.25 5.36 1.86 10.66.94 14.8-.9 2.74-1.22 5.23-2.96 7.07-4.9 2.11 3.7 3.81 7.65 5.04 11.81l-1.75-.36c-3.01-.59-7.06-1.26-11.28-1.54-4.16-.28-8.77-.19-12.78.91-4.02 1.1-8.1 3.44-9.84 8.13-4.86 13.11 1.7 21.06 3.39 22.75 2.55 2.55 5.17 3.75 7.1 4.62.23.11.46.21.67.31 1.86.87 3.19 1.63 4.54 3.58.47.67.94 1.89 1.3 3.74.34 1.8.52 3.89.58 6.11.07 2.2.02 4.41-.04 6.43l-.06 1.63c-.04 1.08-.07 2.1-.09 2.95a55.775 55.775 0 0 1-35.48 12.67c-2.09 0-4.15-.11-6.18-.34.44-.97.91-1.99 1.41-3.08.26-.55.52-1.12.79-1.71 1.15-2.49 2.37-5.21 3.44-7.97 2.05-5.28 3.89-11.54 2.82-16.9-.67-3.35-2.3-6.32-5.41-8.51-2.94-2.07-6.85-3.21-11.67-3.74-7.46-.83-10.89-1.6-14.01-4.09-2.9-2.32-3.62-4.43-3.74-5.93-.13-1.67.44-3.21 1-4.2.51-.9 1.72-1.68 4.44-1.97 2.35-.25 4.9-.03 7.3.18.31.03.62.05.93.08 2.86.24 5.98-.1 8.18-2.42 2.06-2.18 2.33-5.13 2.33-7.33 0-1.17.32-1.95.86-2.64.61-.79 1.63-1.6 3.26-2.51 2.83-1.57 4.87-4.32 5.4-7.4.56-3.26-.64-6.73-3.89-8.9-1.72-1.14-3.68-1.55-5.33-1.72-1.68-.17-3.48-.13-5.1-.08-.22 0-.44.01-.65.02-3.22.11-5.75.19-7.75-.38-.27-.08-.86-.38-1.74-1.22-.84-.8-1.72-1.89-2.58-3.15-1.73-2.53-3.12-5.37-3.79-7Zm73.36 81.97a55.79 55.79 0 0 0 12.32-35.06c0-2.49-.16-4.94-.48-7.34-.05 0-.09-.02-.12-.02-.14-.03-.29-.06-.42-.09-.2-.04-.45-.1-.74-.16l-.35-.08c-.87-.2-2.06-.46-3.47-.73-2.84-.56-6.52-1.16-10.27-1.41-3.81-.25-7.38-.11-10.13.64-2.73.75-3.97 1.89-4.45 3.2-3.38 9.13 1.14 13.91 1.55 14.32 1.49 1.49 2.84 2.11 4.77 3 .23.11.47.22.73.34 2.42 1.13 5.22 2.64 7.73 6.27 1.39 2 2.14 4.47 2.58 6.79.46 2.38.65 4.94.72 7.37.03 1 .04 1.99.03 2.96Zm.28-69.78a56.276 56.276 0 0 0-18.47-15.18c-.57 4.1-.99 8.75-.5 12.73.56 4.56 2.1 6.86 4.44 7.68 2.96 1.03 6.11.6 8.92-.65 2.91-1.3 4.85-3.21 5.46-4.32.05-.09.1-.18.16-.26ZM80 23.96c2.75 0 5.46.2 8.11.58-.9 1.31-2.06 2.75-3.46 3.91-1.61 1.33-3.33 2.13-5.24 2.13-4.39 0-7.99-3.27-9.19-5.78 3.17-.56 6.44-.85 9.78-.85Z",
                            className: "st0"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "clippath-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M23.98 80c0-17.01 7.58-32.25 19.54-42.52.92 2.02 2.32 4.67 4 7.13 1.05 1.54 2.28 3.1 3.65 4.41 1.33 1.27 3.04 2.55 5.08 3.13 3.29.94 7.1.8 9.98.7l.88-.03c1.63-.05 2.94-.07 4.03.05 1.11.11 1.57.33 1.71.42.31.2.39.37.41.43.03.08.07.22.03.46-.09.52-.53 1.28-1.4 1.76-2.07 1.15-4.14 2.6-5.69 4.59-1.63 2.09-2.54 4.6-2.54 7.55 0 .86-.07 1.4-.15 1.72v.03c-.28.06-.81.1-1.7.03-.27-.02-.55-.05-.86-.07-2.32-.21-5.69-.5-8.87-.17-3.54.37-8.1 1.64-10.56 5.96-1.08 1.89-2.33 5.04-2.03 8.8.31 3.92 2.27 7.99 6.71 11.55 5.12 4.1 10.75 4.98 18.12 5.8 4.2.47 6.58 1.37 7.94 2.33 1.19.84 1.85 1.9 2.18 3.55.58 2.88-.4 7.19-2.43 12.45-.97 2.52-2.11 5.05-3.24 7.52-.25.54-.5 1.08-.74 1.61-.81 1.76-1.61 3.47-2.27 5.03C41.73 127.91 24 106.04 24 80.03Zm99.72 35.06A55.79 55.79 0 0 0 136.02 80c0-2.49-.16-4.94-.48-7.34-.05 0-.09-.02-.12-.02-.14-.03-.29-.06-.42-.09-.2-.04-.45-.1-.74-.16l-.35-.08c-.87-.2-2.06-.46-3.47-.73-2.84-.56-6.52-1.16-10.27-1.41-3.81-.25-7.38-.11-10.13.64-2.73.75-3.97 1.89-4.45 3.2-3.38 9.13 1.14 13.91 1.55 14.32 1.49 1.49 2.84 2.11 4.77 3 .23.11.47.22.73.34 2.42 1.13 5.22 2.64 7.73 6.27 1.39 2 2.14 4.47 2.58 6.79.46 2.38.65 4.94.72 7.37.03 1 .04 1.99.03 2.96Zm.28-69.77a56.276 56.276 0 0 0-18.47-15.18c-.57 4.1-.99 8.75-.5 12.73.56 4.56 2.1 6.86 4.44 7.68 2.96 1.03 6.11.6 8.92-.65 2.91-1.3 4.85-3.21 5.46-4.32.05-.09.1-.18.16-.26ZM80 23.98c2.75 0 5.46.2 8.11.58-.9 1.31-2.06 2.75-3.46 3.91-1.61 1.33-3.33 2.13-5.24 2.13-4.39 0-7.99-3.27-9.19-5.78 3.17-.56 6.44-.85 9.78-.85Z",
                            className: "st0"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
                        children: '.st0{fill:none}'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                style: {
                    clipPath: 'url(#clippath)'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M15 17h135v128H15z",
                    style: {
                        fill: '#6995fe'
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                style: {
                    clipPath: 'url(#clippath-1)'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M15 17.01h135v128H15z",
                    style: {
                        fill: '#099d59'
                    }
                })
            })
        ]
    });
};

},{"0":"9R6SU","react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9R6SU":[function() {},{}],"fvWSv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NoSearchResults);
var _jsxRuntime = require("react/jsx-runtime");
var _s2LinNoSearchResults160Svg = require("illustration:./S2_lin_noSearchResults_160.svg");
var _s2LinNoSearchResults160SvgDefault = parcelHelpers.interopDefault(_s2LinNoSearchResults160Svg);
var _s2LinNoSearchResults96Svg = require("illustration:./S2_lin_noSearchResults_96.svg");
var _s2LinNoSearchResults96SvgDefault = parcelHelpers.interopDefault(_s2LinNoSearchResults96Svg);
var _s2LinNoSearchResults48Svg = require("illustration:./S2_lin_noSearchResults_48.svg");
var _s2LinNoSearchResults48SvgDefault = parcelHelpers.interopDefault(_s2LinNoSearchResults48Svg);
var _icon = require("../../src/Icon");
var _reactAriaComponents = require("react-aria-components");
function NoSearchResults(props) {
    [props] = (0, _reactAriaComponents.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinNoSearchResults160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinNoSearchResults48SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinNoSearchResults96SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_lin_noSearchResults_160.svg":"15HTq","illustration:./S2_lin_noSearchResults_96.svg":"9QkrK","illustration:./S2_lin_noSearchResults_48.svg":"g8XLC","../../src/Icon":"jQAJE","react-aria-components":"2Emk2","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"15HTq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M24 63.576c0-20.71 16.79-37.5 37.5-37.5S99 42.866 99 63.576s-16.79 37.5-37.5 37.5S24 84.286 24 63.576m37.5-45.5c-25.129 0-45.5 20.371-45.5 45.5s20.371 45.5 45.5 45.5c11.124 0 21.316-3.992 29.221-10.622l3.983 3.983-2.302 2.302c-1.562 1.562-1.562 4.095 0 5.657l29.507 29.507c4.372 4.372 11.46 4.372 15.832 0s4.372-11.46 0-15.832l-29.507-29.507c-1.562-1.562-4.095-1.562-5.657 0l-2.216 2.216-3.983-3.983C103.008 84.892 107 74.701 107 63.577c0-25.13-20.371-45.5-45.5-45.5m43.905 84.973-4.518 4.519 26.679 26.678c1.248 1.248 3.271 1.248 4.518 0 1.248-1.247 1.248-3.27 0-4.518zM46.815 48.89c1.562-1.562 4.094-1.562 5.656 0l9.371 9.371 9.37-9.37c1.563-1.563 4.096-1.563 5.658 0 1.562 1.561 1.562 4.094 0 5.656l-9.371 9.371 9.37 9.37c1.563 1.563 1.563 4.096 0 5.658-1.561 1.562-4.094 1.562-5.656 0l-9.37-9.371-9.372 9.37c-1.562 1.563-4.094 1.563-5.657 0-1.562-1.561-1.562-4.094 0-5.656l9.371-9.371-9.37-9.37c-1.563-1.563-1.563-4.096 0-5.658"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9QkrK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M18 39.076c0-11.598 9.402-21 21-21s21 9.402 21 21-9.402 21-21 21-21-9.402-21-21m21-25c-13.807 0-25 11.193-25 25s11.193 25 25 25c6.184 0 11.843-2.245 16.207-5.964l1.491 1.491-1.421 1.421c-.781.782-.781 2.048 0 2.829l17.129 17.129c2.33 2.33 6.108 2.33 8.439 0 2.33-2.33 2.33-6.109 0-8.44l-17.13-17.128c-.78-.781-2.047-.781-2.828 0l-1.36 1.36-1.491-1.49C61.755 50.918 64 45.26 64 39.075c0-13.807-11.193-25-25-25m23.302 45.58L59.52 62.44l15.714 15.714c.769.769 2.014.769 2.782 0 .769-.768.769-2.014 0-2.782zm-12.888-30.07c-.78-.781-2.047-.781-2.828 0L39.5 36.672l-7.086-7.086c-.78-.781-2.047-.781-2.828 0-.781.78-.781 2.047 0 2.828l7.086 7.086-7.086 7.086c-.781.78-.781 2.047 0 2.828.78.781 2.047.781 2.828 0l7.086-7.086 7.086 7.086c.78.781 2.047.781 2.828 0 .781-.78.781-2.047 0-2.828L42.328 39.5l7.086-7.086c.781-.78.781-2.047 0-2.828"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g8XLC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M8.813 19.037c0-5.66 4.589-10.25 10.25-10.25s10.25 4.59 10.25 10.25-4.59 10.25-10.25 10.25-10.25-4.589-10.25-10.25m10.25-12.75c-7.042 0-12.75 5.709-12.75 12.75s5.708 12.75 12.75 12.75c3.054 0 5.858-1.074 8.054-2.865l.88.879-.535.534c-.488.489-.488 1.28 0 1.768l8.564 8.565c1.263 1.263 3.31 1.263 4.573 0s1.263-3.31 0-4.573l-8.564-8.565c-.488-.488-1.28-.488-1.768 0l-.503.503-.873-.873c1.825-2.206 2.922-5.036 2.922-8.123 0-7.041-5.709-12.75-12.75-12.75M31.15 30.182l-1.038 1.037 7.681 7.68c.287.287.751.287 1.038 0 .286-.286.286-.75 0-1.037zm-6.955-16.279c-.488-.488-1.28-.488-1.767 0l-3.366 3.366-3.367-3.366c-.488-.488-1.28-.488-1.767 0-.489.488-.489 1.28 0 1.768l3.366 3.366-3.366 3.366c-.489.488-.489 1.28 0 1.768.488.488 1.28.488 1.767 0l3.367-3.366 3.366 3.366c.488.488 1.28.488 1.767 0 .488-.488.488-1.28 0-1.768l-3.366-3.366 3.366-3.366c.488-.488.488-1.28 0-1.768"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7tBJX":[function(require,module,exports,__globalThis) {
module.exports = {
  "exports": {
    "CheckboxContext": {
      "type": "any"
    },
    "ColorAreaContext": {
      "type": "any"
    },
    "ColorFieldContext": {
      "type": "any"
    },
    "ColorSliderContext": {
      "type": "any"
    },
    "ColorWheelContext": {
      "type": "any"
    },
    "HeadingContext": {
      "type": "any"
    },
    "Autocomplete": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Autocomplete.tsx:Autocomplete",
      "name": "Autocomplete",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Autocomplete.tsx:AutocompleteProps",
        "name": "AutocompleteProps",
        "properties": {
          "filter": {
            "type": "property",
            "name": "filter",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "textValue",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                },
                {
                  "type": "parameter",
                  "name": "inputValue",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                },
                {
                  "type": "parameter",
                  "name": "node",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                    },
                    "typeParameters": [
                      {
                        "type": "object",
                        "properties": null
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "An optional filter function used to determine if a option should be included in the autocomplete list.\nInclude this if the items you are providing to your wrapped collection aren't filtered by default.",
            "default": null
          },
          "disableAutoFocusFirst": {
            "type": "property",
            "name": "disableAutoFocusFirst",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether or not to focus the first item in the collection after a filter is performed. Note this is only applicable\nif virtual focus behavior is not turned off via `disableVirtualFocus`.",
            "default": "false"
          },
          "disableVirtualFocus": {
            "type": "property",
            "name": "disableVirtualFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the autocomplete should disable virtual focus, instead making the wrapped collection directly tabbable.",
            "default": "false"
          },
          "inputValue": {
            "type": "property",
            "name": "inputValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value of the autocomplete input (controlled).",
            "default": null
          },
          "defaultInputValue": {
            "type": "property",
            "name": "defaultInputValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The default value of the autocomplete input (uncontrolled).",
            "default": null
          },
          "onInputChange": {
            "type": "property",
            "name": "onInputChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the autocomplete input value changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The children wrapped by the autocomplete. Consists of at least an input element and a collection element to filter.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": {
              "type": "object",
              "properties": null
            }
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": null,
      "description": "An autocomplete combines a TextField or SearchField with a Menu or ListBox, allowing users to search or filter a list of suggestions."
    },
    "AutocompleteContext": {
      "type": "any"
    },
    "AutocompleteStateContext": {
      "type": "any"
    },
    "Breadcrumbs": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:Breadcrumbs",
      "name": "Breadcrumbs",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbsProps",
        "name": "BreadcrumbsProps",
        "properties": {
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the breadcrumbs are disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a breadcrumb is clicked.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLOListElement"
          }
        ]
      },
      "description": "Breadcrumbs display a hierarchy of links to the current page or resource in an application."
    },
    "BreadcrumbsContext": {
      "type": "any"
    },
    "Breadcrumb": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:Breadcrumb",
      "name": "Breadcrumb",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbProps",
        "name": "BreadcrumbProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "A unique id for the breadcrumb, which will be passed to `onAction` when the breadcrumb is pressed.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLLIElement"
          }
        ]
      },
      "description": "A Breadcrumb represents an individual item in a `<Breadcrumbs>` list."
    },
    "Button": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:Button",
      "name": "Button",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonProps",
        "name": "ButtonProps",
        "properties": {
          "isPending": {
            "type": "property",
            "name": "isPending",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button is in a pending state. This disables press and hover events\nwhile retaining focusability, and announces the pending state to screen readers.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button is disabled.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "aria-disabled": {
            "type": "property",
            "name": "aria-disabled",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether the element is disabled to users of assistive technology.",
            "default": null
          },
          "aria-expanded": {
            "type": "property",
            "name": "aria-expanded",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
            "default": null
          },
          "aria-haspopup": {
            "type": "property",
            "name": "aria-haspopup",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "menu"
                },
                {
                  "type": "string",
                  "value": "listbox"
                },
                {
                  "type": "string",
                  "value": "tree"
                },
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "dialog"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "aria-pressed": {
            "type": "property",
            "name": "aria-pressed",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "mixed"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the current \"pressed\" state of toggle buttons.",
            "default": null
          },
          "aria-current": {
            "type": "property",
            "name": "aria-current",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "page"
                },
                {
                  "type": "string",
                  "value": "step"
                },
                {
                  "type": "string",
                  "value": "location"
                },
                {
                  "type": "string",
                  "value": "date"
                },
                {
                  "type": "string",
                  "value": "time"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether this element represents the current item within a container or set of related elements.",
            "default": null
          },
          "type": {
            "type": "property",
            "name": "type",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "button"
                },
                {
                  "type": "string",
                  "value": "submit"
                },
                {
                  "type": "string",
                  "value": "reset"
                }
              ]
            },
            "optional": true,
            "description": "The behavior of the button when used in an HTML form.",
            "default": "'button'"
          },
          "preventFocusOnPress": {
            "type": "property",
            "name": "preventFocusOnPress",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/button#form).",
            "default": null
          },
          "formAction": {
            "type": "property",
            "name": "formAction",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
            "default": null
          },
          "formEncType": {
            "type": "property",
            "name": "formEncType",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Indicates how to encode the form data that is submitted.",
            "default": null
          },
          "formMethod": {
            "type": "property",
            "name": "formMethod",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Indicates the HTTP method used to submit the form.",
            "default": null
          },
          "formNoValidate": {
            "type": "property",
            "name": "formNoValidate",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Indicates that the form is not to be validated when it is submitted.",
            "default": null
          },
          "formTarget": {
            "type": "property",
            "name": "formTarget",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Overrides the target attribute of the button's form owner.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Submitted as a pair with the button's value as part of the form data.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value associated with the button's name when it's submitted with the form data.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLButtonElement"
          }
        ]
      },
      "description": "A button allows a user to perform an action, with mouse, touch, and keyboard interactions."
    },
    "ButtonContext": {
      "type": "any"
    },
    "Calendar": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:Calendar",
      "name": "Calendar",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarProps",
        "name": "CalendarProps",
        "properties": {
          "visibleDuration": {
            "type": "property",
            "name": "visibleDuration",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:DateDuration"
            },
            "optional": true,
            "description": "The amount of days that will be displayed at once. This affects how pagination works.",
            "default": "{months: 1}"
          },
          "createCalendar": {
            "type": "property",
            "name": "createCalendar",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "identifier",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function to create a new [Calendar](https://react-spectrum.adobe.com/internationalized/date/Calendar.html)\nobject for a given calendar identifier. If not provided, the `createCalendar` function\nfrom `@internationalized/date` will be used.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed date that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed date that a user may select.",
            "default": null
          },
          "isDateUnavailable": {
            "type": "property",
            "name": "isDateUnavailable",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the calendar is disabled.",
            "default": "false"
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the calendar value is immutable.",
            "default": "false"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to automatically focus the calendar when it mounts.",
            "default": "false"
          },
          "focusedValue": {
            "type": "property",
            "name": "focusedValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "Controls the currently focused date within the calendar.",
            "default": null
          },
          "defaultFocusedValue": {
            "type": "property",
            "name": "defaultFocusedValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The date that is focused when the calendar first mounts (uncountrolled).",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the focused date changes.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the current selection is invalid according to application logic.",
            "default": null
          },
          "pageBehavior": {
            "type": "property",
            "name": "pageBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
            },
            "optional": true,
            "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
            "default": "visible"
          },
          "firstDayOfWeek": {
            "type": "property",
            "name": "firstDayOfWeek",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "sun"
                },
                {
                  "type": "string",
                  "value": "mon"
                },
                {
                  "type": "string",
                  "value": "tue"
                },
                {
                  "type": "string",
                  "value": "wed"
                },
                {
                  "type": "string",
                  "value": "thu"
                },
                {
                  "type": "string",
                  "value": "fri"
                },
                {
                  "type": "string",
                  "value": "sat"
                }
              ]
            },
            "optional": true,
            "description": "The day that starts the week.",
            "default": null
          },
          "selectionAlignment": {
            "type": "property",
            "name": "selectionAlignment",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "center"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "Determines the alignment of the visible months on initial render based on the current selection or current date if there is no selection.",
            "default": "'center'"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A calendar displays one or more date grids and allows users to select a single date."
    },
    "CalendarGrid": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarGrid",
      "name": "CalendarGrid",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarGridProps",
        "name": "CalendarGridProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                {
                  "type": "array",
                  "elementType": {
                    "type": "identifier",
                    "name": "ReactElement"
                  }
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "date",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Either a function to render calendar cells for each date in the month,\nor children containing a `<CalendarGridHeader>`` and `<CalendarGridBody>`\nwhen additional customization is needed.",
            "default": null
          },
          "offset": {
            "type": "property",
            "name": "offset",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:DateDuration"
            },
            "optional": true,
            "description": "An offset from the beginning of the visible date range that this\nCalendarGrid should display. Useful when displaying more than one\nmonth at a time.",
            "default": null
          },
          "weekdayStyle": {
            "type": "property",
            "name": "weekdayStyle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "narrow"
                },
                {
                  "type": "string",
                  "value": "short"
                },
                {
                  "type": "string",
                  "value": "long"
                }
              ]
            },
            "optional": true,
            "description": "The style of weekday names to display in the calendar grid header,\ne.g. single letter, abbreviation, or full day name.",
            "default": "\"narrow\""
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLTableElement"
          }
        ]
      },
      "description": "A calendar grid displays a single grid of days within a calendar or range calendar which\ncan be keyboard navigated and selected by the user."
    },
    "CalendarGridHeader": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarGridHeaderForwardRef",
      "name": "CalendarGridHeader",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarGridHeaderProps",
        "name": "CalendarGridHeaderProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "day",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactElement"
              },
              "typeParameters": []
            },
            "optional": false,
            "description": "A function to render a `<CalendarHeaderCell>` for a weekday name.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLTableSectionElement"
          }
        ]
      },
      "description": "A calendar grid header displays a row of week day names at the top of a month."
    },
    "CalendarGridBody": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarGridBodyForwardRef",
      "name": "CalendarGridBody",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarGridBodyProps",
        "name": "CalendarGridBodyProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactElement"
              },
              "typeParameters": []
            },
            "optional": false,
            "description": "A function to render a `<CalendarCell>` for a given date.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLTableSectionElement"
          }
        ]
      },
      "description": "A calendar grid body displays a grid of calendar cells within a month."
    },
    "CalendarHeaderCell": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarHeaderCellForwardRef",
      "name": "CalendarHeaderCell",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarHeaderCellProps",
        "name": "CalendarHeaderCellProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The children of the component.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLTableCellElement"
          }
        ]
      },
      "description": "A calendar header cell displays a week day name at the top of a column within a calendar."
    },
    "CalendarCell": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCell",
      "name": "CalendarCell",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellProps",
        "name": "CalendarCellProps",
        "properties": {
          "date": {
            "type": "property",
            "name": "date",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "optional": false,
            "description": "The date to render in the cell.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLTableCellElement"
          }
        ]
      },
      "description": "A calendar cell displays a date cell within a calendar grid which can be selected by the user."
    },
    "RangeCalendar": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendar",
      "name": "RangeCalendar",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarProps",
        "name": "RangeCalendarProps",
        "properties": {
          "visibleDuration": {
            "type": "property",
            "name": "visibleDuration",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:DateDuration"
            },
            "optional": true,
            "description": "The amount of days that will be displayed at once. This affects how pagination works.",
            "default": "{months: 1}"
          },
          "createCalendar": {
            "type": "property",
            "name": "createCalendar",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "identifier",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function to create a new [Calendar](https://react-spectrum.adobe.com/internationalized/date/Calendar.html)\nobject for a given calendar identifier. If not provided, the `createCalendar` function\nfrom `@internationalized/date` will be used.",
            "default": null
          },
          "allowsNonContiguousRanges": {
            "type": "property",
            "name": "allowsNonContiguousRanges",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "When combined with `isDateUnavailable`, determines whether non-contiguous ranges,\ni.e. ranges containing unavailable dates, may be selected.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed date that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed date that a user may select.",
            "default": null
          },
          "isDateUnavailable": {
            "type": "property",
            "name": "isDateUnavailable",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the calendar is disabled.",
            "default": "false"
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the calendar value is immutable.",
            "default": "false"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to automatically focus the calendar when it mounts.",
            "default": "false"
          },
          "focusedValue": {
            "type": "property",
            "name": "focusedValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "Controls the currently focused date within the calendar.",
            "default": null
          },
          "defaultFocusedValue": {
            "type": "property",
            "name": "defaultFocusedValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The date that is focused when the calendar first mounts (uncountrolled).",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the focused date changes.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the current selection is invalid according to application logic.",
            "default": null
          },
          "pageBehavior": {
            "type": "property",
            "name": "pageBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
            },
            "optional": true,
            "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
            "default": "visible"
          },
          "firstDayOfWeek": {
            "type": "property",
            "name": "firstDayOfWeek",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "sun"
                },
                {
                  "type": "string",
                  "value": "mon"
                },
                {
                  "type": "string",
                  "value": "tue"
                },
                {
                  "type": "string",
                  "value": "wed"
                },
                {
                  "type": "string",
                  "value": "thu"
                },
                {
                  "type": "string",
                  "value": "fri"
                },
                {
                  "type": "string",
                  "value": "sat"
                }
              ]
            },
            "optional": true,
            "description": "The day that starts the week.",
            "default": null
          },
          "selectionAlignment": {
            "type": "property",
            "name": "selectionAlignment",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "center"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "Determines the alignment of the visible months on initial render based on the current selection or current date if there is no selection.",
            "default": "'center'"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                    },
                    "typeParameters": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                          }
                        ]
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A range calendar displays one or more date grids and allows users to select a contiguous range of dates."
    },
    "CalendarContext": {
      "type": "any"
    },
    "RangeCalendarContext": {
      "type": "any"
    },
    "CalendarStateContext": {
      "type": "any"
    },
    "RangeCalendarStateContext": {
      "type": "any"
    },
    "Checkbox": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:Checkbox",
      "name": "Checkbox",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxProps",
        "name": "CheckboxProps",
        "properties": {
          "inputRef": {
            "type": "property",
            "name": "inputRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "A ref for the HTML input element.",
            "default": null
          },
          "isIndeterminate": {
            "type": "property",
            "name": "isIndeterminate",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Indeterminism is presentational only.\nThe indeterminate visual representation remains regardless of user interaction.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
            "default": null
          },
          "defaultSelected": {
            "type": "property",
            "name": "defaultSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should be selected (uncontrolled).",
            "default": null
          },
          "isSelected": {
            "type": "property",
            "name": "isSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should be selected (controlled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isSelected",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's selection state changes.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLLabelElement"
          }
        ]
      },
      "description": "A checkbox allows a user to select multiple items from a list of individual items, or\nto mark one individual item as selected."
    },
    "CheckboxGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroup",
      "name": "CheckboxGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupProps",
        "name": "CheckboxGroupProps",
        "properties": {
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "array",
              "elementType": {
                "type": "string"
              }
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "array",
              "elementType": {
                "type": "string"
              }
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "array",
                    "elementType": {
                      "type": "string"
                    }
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A checkbox group allows a user to select multiple items from a list of options."
    },
    "CheckboxGroupContext": {
      "type": "any"
    },
    "CheckboxGroupStateContext": {
      "type": "any"
    },
    "ColorArea": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorArea",
      "name": "ColorArea",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaProps",
        "name": "ColorAreaProps",
        "properties": {
          "xName": {
            "type": "property",
            "name": "xName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the x channel input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "yName": {
            "type": "property",
            "name": "yName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the y channel input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the ColorArea with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "colorSpace": {
            "type": "property",
            "name": "colorSpace",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
            },
            "optional": true,
            "description": "The color space that the color area operates in. The `xChannel` and `yChannel` must be in this color space.\nIf not provided, this defaults to the color space of the `color` or `defaultColor` value.",
            "default": null
          },
          "xChannel": {
            "type": "property",
            "name": "xChannel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": true,
            "description": "Color channel for the horizontal axis.",
            "default": null
          },
          "yChannel": {
            "type": "property",
            "name": "yChannel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": true,
            "description": "Color channel for the vertical axis.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the ColorArea is disabled.",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes, as the user drags.",
            "default": null
          },
          "onChangeEnd": {
            "type": "property",
            "name": "onChangeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the user stops dragging.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A color area allows users to adjust two channels of an RGB, HSL or HSB color value against a two-dimensional gradient background."
    },
    "ColorAreaStateContext": {
      "type": "any"
    },
    "ColorField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorField",
      "name": "ColorField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldProps",
        "name": "ColorFieldProps",
        "properties": {
          "channel": {
            "type": "property",
            "name": "channel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": true,
            "description": "The color channel that this field edits. If not provided, \nthe color is edited as a hex value.",
            "default": null
          },
          "colorSpace": {
            "type": "property",
            "name": "colorSpace",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
            },
            "optional": true,
            "description": "The color space that the color field operates in if a `channel` prop is provided.\nIf no `channel` is provided, the color field always displays the color as an RGB hex value.",
            "default": null
          },
          "isWheelDisabled": {
            "type": "property",
            "name": "isWheelDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Enables or disables changing the value with scroll.",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "color",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "onCopy": {
            "type": "property",
            "name": "onCopy",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
            "default": null
          },
          "onCut": {
            "type": "property",
            "name": "onCut",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
            "default": null
          },
          "onPaste": {
            "type": "property",
            "name": "onPaste",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
            "default": null
          },
          "onCompositionStart": {
            "type": "property",
            "name": "onCompositionStart",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
            "default": null
          },
          "onCompositionEnd": {
            "type": "property",
            "name": "onCompositionEnd",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
            "default": null
          },
          "onCompositionUpdate": {
            "type": "property",
            "name": "onCompositionUpdate",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
            "default": null
          },
          "onBeforeInput": {
            "type": "property",
            "name": "onBeforeInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
            "default": null
          },
          "onInput": {
            "type": "property",
            "name": "onInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A color field allows users to edit a hex color or individual color channel value."
    },
    "ColorFieldStateContext": {
      "type": "any"
    },
    "ColorPicker": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorPicker.tsx:ColorPicker",
      "name": "ColorPicker",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorPicker.tsx:ColorPickerProps",
        "name": "ColorPickerProps",
        "properties": {
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "A ColorPicker synchronizes a color value between multiple React Aria color components.\nIt simplifies building color pickers with customizable layouts via composition."
    },
    "ColorPickerContext": {
      "type": "any"
    },
    "ColorPickerStateContext": {
      "type": "any"
    },
    "ColorSlider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSlider",
      "name": "ColorSlider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderProps",
        "name": "ColorSliderProps",
        "properties": {
          "colorSpace": {
            "type": "property",
            "name": "colorSpace",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
            },
            "optional": true,
            "description": "The color space that the slider operates in. The `channel` must be in this color space.\nIf not provided, this defaults to the color space of the `color` or `defaultColor` value.",
            "default": null
          },
          "channel": {
            "type": "property",
            "name": "channel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": false,
            "description": "The color channel that the slider manipulates.",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes, as the user drags.",
            "default": null
          },
          "onChangeEnd": {
            "type": "property",
            "name": "onChangeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the user stops dragging.",
            "default": null
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The orientation of the Slider.",
            "default": "'horizontal'"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the whole Slider is disabled.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A color slider allows users to adjust an individual channel of a color value."
    },
    "ColorSliderStateContext": {
      "type": "any"
    },
    "ColorSwatch": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatch.tsx:ColorSwatch",
      "name": "ColorSwatch",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatch.tsx:ColorSwatchProps",
        "name": "ColorSwatchProps",
        "properties": {
          "color": {
            "type": "property",
            "name": "color",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": true,
            "description": "The color value to display in the swatch.",
            "default": null
          },
          "colorName": {
            "type": "property",
            "name": "colorName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A localized accessible name for the color.\nBy default, a description is generated from the color value,\nbut this can be overridden if you have a more specific color\nname (e.g. Pantone colors).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatch.tsx:ColorSwatchRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatch.tsx:ColorSwatchRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ColorSwatch displays a preview of a selected color."
    },
    "ColorSwatchContext": {
      "type": "any"
    },
    "ColorSwatchPicker": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPicker",
      "name": "ColorSwatchPicker",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerProps",
        "name": "ColorSwatchPickerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The children of the ColorSwatchPicker.",
            "default": null
          },
          "layout": {
            "type": "property",
            "name": "layout",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "stack"
                }
              ]
            },
            "optional": true,
            "description": "Whether the items are arranged in a stack or grid.",
            "default": "'grid'"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ColorSwatchPicker displays a list of color swatches and allows a user to select one of them."
    },
    "ColorSwatchPickerItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItem",
      "name": "ColorSwatchPickerItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemProps",
        "name": "ColorSwatchPickerItemProps",
        "properties": {
          "color": {
            "type": "property",
            "name": "color",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": false,
            "description": "The color of the swatch.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the color swatch is disabled.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "ColorSwatchPickerContext": {
      "type": "any"
    },
    "ColorThumb": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumb",
      "name": "ColorThumb",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbProps",
        "name": "ColorThumbProps",
        "properties": {
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A color thumb appears within a ColorArea, ColorSlider, or ColorWheel and allows a user to drag to adjust the color value."
    },
    "ColorWheel": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheel",
      "name": "ColorWheel",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelProps",
        "name": "ColorWheelProps",
        "properties": {
          "outerRadius": {
            "type": "property",
            "name": "outerRadius",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": false,
            "description": "The outer radius of the color wheel.",
            "default": null
          },
          "innerRadius": {
            "type": "property",
            "name": "innerRadius",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": false,
            "description": "The inner radius of the color wheel.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the ColorWheel is disabled.",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes, as the user drags.",
            "default": null
          },
          "onChangeEnd": {
            "type": "property",
            "name": "onChangeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the user stops dragging.",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": "'hsl(0, 100%, 50%)'"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A color wheel allows users to adjust the hue of an HSL or HSB color value on a circular track."
    },
    "ColorWheelTrack": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelTrack",
      "name": "ColorWheelTrack",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelTrackProps",
        "name": "ColorWheelTrackProps",
        "properties": {
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelTrackRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelTrackRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A color wheel track renders a circular gradient track."
    },
    "ColorWheelTrackContext": {
      "type": "any"
    },
    "ColorWheelStateContext": {
      "type": "any"
    },
    "ComboBox": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBox",
      "name": "ComboBox",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxProps",
        "name": "ComboBoxProps",
        "properties": {
          "defaultFilter": {
            "type": "property",
            "name": "defaultFilter",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "textValue",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                },
                {
                  "type": "parameter",
                  "name": "inputValue",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "The filter function used to determine if a option should be included in the combo box list.",
            "default": null
          },
          "formValue": {
            "type": "property",
            "name": "formValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "key"
                }
              ]
            },
            "optional": true,
            "description": "Whether the text or key of the selected item is submitted as part of an HTML form.\nWhen `allowsCustomValue` is `true`, this option does not apply and the text is always submitted.",
            "default": "'key'"
          },
          "allowsEmptyCollection": {
            "type": "property",
            "name": "allowsEmptyCollection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the combo box allows the menu to be open when the collection is empty.",
            "default": null
          },
          "shouldFocusWrap": {
            "type": "property",
            "name": "shouldFocusWrap",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether keyboard navigation is circular.",
            "default": null
          },
          "defaultItems": {
            "type": "property",
            "name": "defaultItems",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "The list of ComboBox items (uncontrolled).",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "The list of ComboBox items (controlled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                },
                {
                  "type": "parameter",
                  "name": "menuTrigger",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction"
                  },
                  "optional": true,
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Method that is called when the open state of the menu changes. Returns the new open state and the action that caused the opening of the menu.",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "inputValue": {
            "type": "property",
            "name": "inputValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value of the ComboBox input (controlled).",
            "default": null
          },
          "defaultInputValue": {
            "type": "property",
            "name": "defaultInputValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The default value of the ComboBox input (uncontrolled).",
            "default": null
          },
          "onInputChange": {
            "type": "property",
            "name": "onInputChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the ComboBox input value changes.",
            "default": null
          },
          "allowsCustomValue": {
            "type": "property",
            "name": "allowsCustomValue",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the ComboBox allows a non-item matching input value to be set.",
            "default": null
          },
          "menuTrigger": {
            "type": "property",
            "name": "menuTrigger",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction"
            },
            "optional": true,
            "description": "The interaction required to display the ComboBox menu.",
            "default": "'input'"
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectedKey": {
            "type": "property",
            "name": "selectedKey",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The currently selected key in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKey": {
            "type": "property",
            "name": "defaultSelectedKey",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Key"
            },
            "optional": true,
            "description": "The initial selected key in the collection (uncontrolled).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:ComboBoxValidationValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLInputElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLInputElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "object",
              "properties": null
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A combo box combines a text input with a listbox, allowing users to filter a list of options to items matching a query."
    },
    "ComboBoxContext": {
      "type": "any"
    },
    "ComboBoxStateContext": {
      "type": "any"
    },
    "composeRenderProps": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:composeRenderProps",
      "name": "composeRenderProps",
      "parameters": [
        {
          "type": "parameter",
          "name": "value",
          "value": {
            "type": "conditional",
            "checkType": {
              "type": "identifier",
              "name": "T"
            },
            "extendsType": {
              "id": null,
              "name": null,
              "type": "any"
            },
            "trueType": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "T"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "renderProps",
                      "value": {
                        "type": "identifier",
                        "name": "U"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "V"
                  },
                  "typeParameters": []
                }
              ]
            },
            "falseType": {
              "type": "never"
            }
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "wrap",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "prevValue",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false
              },
              {
                "type": "parameter",
                "name": "renderProps",
                "value": {
                  "type": "identifier",
                  "name": "U"
                },
                "rest": false
              }
            ],
            "return": {
              "type": "identifier",
              "name": "V"
            },
            "typeParameters": []
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "function",
        "parameters": [
          {
            "type": "parameter",
            "name": "renderProps",
            "value": {
              "type": "identifier",
              "name": "U"
            },
            "rest": false
          }
        ],
        "return": {
          "type": "identifier",
          "name": "V"
        },
        "typeParameters": [],
        "description": null
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "U",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "V",
          "constraint": {
            "type": "identifier",
            "name": "T"
          },
          "default": null
        }
      ],
      "description": "A helper function that accepts a user-provided render prop value (either a static value or a function),\nand combines it with another value to create a final result."
    },
    "DEFAULT_SLOT": {
      "type": "any"
    },
    "Provider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:Provider",
      "name": "Provider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderProps",
        "name": "ProviderProps",
        "properties": {
          "values": {
            "type": "property",
            "name": "values",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValues"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "A"
                },
                {
                  "type": "identifier",
                  "name": "B"
                },
                {
                  "type": "identifier",
                  "name": "C"
                },
                {
                  "type": "identifier",
                  "name": "D"
                },
                {
                  "type": "identifier",
                  "name": "E"
                },
                {
                  "type": "identifier",
                  "name": "F"
                },
                {
                  "type": "identifier",
                  "name": "G"
                },
                {
                  "type": "identifier",
                  "name": "H"
                },
                {
                  "type": "identifier",
                  "name": "I"
                },
                {
                  "type": "identifier",
                  "name": "J"
                },
                {
                  "type": "identifier",
                  "name": "K"
                }
              ]
            },
            "optional": false,
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "A",
            "constraint": null,
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "B",
            "constraint": null,
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "C",
            "constraint": null,
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "D",
            "constraint": null,
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "E",
            "constraint": null,
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "F",
            "constraint": null,
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "G",
            "constraint": null,
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "H",
            "constraint": null,
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "I",
            "constraint": null,
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "J",
            "constraint": null,
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "K",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "A",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "B",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "C",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "D",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "E",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "F",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "G",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "H",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "I",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "J",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "K",
          "constraint": null,
          "default": null
        }
      ],
      "ref": null,
      "description": null
    },
    "useContextProps": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:useContextProps",
      "name": "useContextProps",
      "parameters": [
        {
          "type": "parameter",
          "name": "props",
          "value": {
            "type": "intersection",
            "types": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlotProps"
              }
            ]
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "ref",
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "ForwardedRef"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "E"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "context",
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Context"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ContextValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "U"
                  },
                  {
                    "type": "identifier",
                    "name": "E"
                  }
                ]
              }
            ]
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "tuple",
        "elements": [
          {
            "type": "identifier",
            "name": "T"
          },
          {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "E"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "U",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlotProps"
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "E",
          "constraint": {
            "type": "identifier",
            "name": "Element"
          },
          "default": null
        }
      ]
    },
    "useRenderProps": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:useRenderProps",
      "name": "useRenderProps",
      "parameters": [
        {
          "type": "parameter",
          "name": "props",
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:RenderPropsHookOptions"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:RenderPropsHookRetVal"
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ]
    },
    "useSlottedContext": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:useSlottedContext",
      "name": "useSlottedContext",
      "parameters": [
        {
          "type": "parameter",
          "name": "context",
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Context"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedContextValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "slot",
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "union",
        "elements": [
          {
            "type": "identifier",
            "name": "T"
          },
          {
            "type": "null"
          },
          {
            "type": "undefined"
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ]
    },
    "DateField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateField",
      "name": "DateField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldProps",
        "name": "DateFieldProps",
        "properties": {
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed date that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed date that a user may select.",
            "default": null
          },
          "isDateUnavailable": {
            "type": "property",
            "name": "isDateUnavailable",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
            "default": null
          },
          "placeholderValue": {
            "type": "property",
            "name": "placeholderValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
            "default": null
          },
          "hourCycle": {
            "type": "property",
            "name": "hourCycle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number",
                  "value": 12
                },
                {
                  "type": "number",
                  "value": 24
                }
              ]
            },
            "optional": true,
            "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
            "default": null
          },
          "granularity": {
            "type": "property",
            "name": "granularity",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
            },
            "optional": true,
            "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
            "default": null
          },
          "hideTimeZone": {
            "type": "property",
            "name": "hideTimeZone",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to hide the time zone abbreviation.",
            "default": "false"
          },
          "shouldForceLeadingZeros": {
            "type": "property",
            "name": "shouldForceLeadingZeros",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                          }
                        ]
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A date field allows users to enter and edit date and time values using a keyboard.\nEach part of a date value is displayed in an individually editable segment."
    },
    "DateInput": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateInput",
      "name": "DateInput",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateInputProps",
        "name": "DateInputProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "segment",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateSegment"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactElement"
              },
              "typeParameters": []
            },
            "optional": false,
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateInputRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateInputRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A date input groups the editable date segments within a date field."
    },
    "DateSegment": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegment",
      "name": "DateSegment",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentProps",
        "name": "DateSegmentProps",
        "properties": {
          "segment": {
            "type": "property",
            "name": "segment",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateSegment"
            },
            "optional": false,
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLSpanElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLSpanElement"
          }
        ]
      },
      "description": "A date segment displays an individual unit of a date and time, and allows users to edit\nthe value by typing or using the arrow keys to increment and decrement."
    },
    "TimeField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:TimeField",
      "name": "TimeField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:TimeFieldProps",
        "name": "TimeFieldProps",
        "properties": {
          "hourCycle": {
            "type": "property",
            "name": "hourCycle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number",
                  "value": 12
                },
                {
                  "type": "number",
                  "value": 24
                }
              ]
            },
            "optional": true,
            "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
            "default": null
          },
          "granularity": {
            "type": "property",
            "name": "granularity",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "hour"
                },
                {
                  "type": "string",
                  "value": "minute"
                },
                {
                  "type": "string",
                  "value": "second"
                }
              ]
            },
            "optional": true,
            "description": "Determines the smallest unit that is displayed in the time picker.",
            "default": "'minute'"
          },
          "hideTimeZone": {
            "type": "property",
            "name": "hideTimeZone",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to hide the time zone abbreviation.",
            "default": null
          },
          "shouldForceLeadingZeros": {
            "type": "property",
            "name": "shouldForceLeadingZeros",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to always show leading zeros in the hour field.\nBy default, this is determined by the user's locale.",
            "default": null
          },
          "placeholderValue": {
            "type": "property",
            "name": "placeholderValue",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
            },
            "optional": true,
            "description": "A placeholder time that influences the format of the placeholder shown when no value is selected.\nDefaults to 12:00 AM or 00:00 depending on the hour cycle.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed time that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed time that a user may select.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                          }
                        ]
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A time field allows users to enter and edit time values using a keyboard.\nEach part of a time value is displayed in an individually editable segment."
    },
    "DateFieldContext": {
      "type": "any"
    },
    "TimeFieldContext": {
      "type": "any"
    },
    "DateFieldStateContext": {
      "type": "any"
    },
    "TimeFieldStateContext": {
      "type": "any"
    },
    "DatePicker": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePicker",
      "name": "DatePicker",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerProps",
        "name": "DatePickerProps",
        "properties": {
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "pageBehavior": {
            "type": "property",
            "name": "pageBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
            },
            "optional": true,
            "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
            "default": "visible"
          },
          "firstDayOfWeek": {
            "type": "property",
            "name": "firstDayOfWeek",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "sun"
                },
                {
                  "type": "string",
                  "value": "mon"
                },
                {
                  "type": "string",
                  "value": "tue"
                },
                {
                  "type": "string",
                  "value": "wed"
                },
                {
                  "type": "string",
                  "value": "thu"
                },
                {
                  "type": "string",
                  "value": "fri"
                },
                {
                  "type": "string",
                  "value": "sat"
                }
              ]
            },
            "optional": true,
            "description": "The day that starts the week.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed date that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed date that a user may select.",
            "default": null
          },
          "isDateUnavailable": {
            "type": "property",
            "name": "isDateUnavailable",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
            "default": null
          },
          "placeholderValue": {
            "type": "property",
            "name": "placeholderValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
            "default": null
          },
          "hourCycle": {
            "type": "property",
            "name": "hourCycle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number",
                  "value": 12
                },
                {
                  "type": "number",
                  "value": 24
                }
              ]
            },
            "optional": true,
            "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
            "default": null
          },
          "granularity": {
            "type": "property",
            "name": "granularity",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
            },
            "optional": true,
            "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
            "default": null
          },
          "hideTimeZone": {
            "type": "property",
            "name": "hideTimeZone",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to hide the time zone abbreviation.",
            "default": "false"
          },
          "shouldForceLeadingZeros": {
            "type": "property",
            "name": "shouldForceLeadingZeros",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                          }
                        ]
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "shouldCloseOnSelect": {
            "type": "property",
            "name": "shouldCloseOnSelect",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Determines whether the date picker popover should close automatically when a date is selected.",
            "default": "true"
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A date picker combines a DateField and a Calendar popover to allow users to enter or select a date and time value."
    },
    "DateRangePicker": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePicker",
      "name": "DateRangePicker",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerProps",
        "name": "DateRangePickerProps",
        "properties": {
          "pageBehavior": {
            "type": "property",
            "name": "pageBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
            },
            "optional": true,
            "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
            "default": "visible"
          },
          "firstDayOfWeek": {
            "type": "property",
            "name": "firstDayOfWeek",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "sun"
                },
                {
                  "type": "string",
                  "value": "mon"
                },
                {
                  "type": "string",
                  "value": "tue"
                },
                {
                  "type": "string",
                  "value": "wed"
                },
                {
                  "type": "string",
                  "value": "thu"
                },
                {
                  "type": "string",
                  "value": "fri"
                },
                {
                  "type": "string",
                  "value": "sat"
                }
              ]
            },
            "optional": true,
            "description": "The day that starts the week.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed date that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed date that a user may select.",
            "default": null
          },
          "isDateUnavailable": {
            "type": "property",
            "name": "isDateUnavailable",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
            "default": null
          },
          "placeholderValue": {
            "type": "property",
            "name": "placeholderValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
            "default": null
          },
          "hourCycle": {
            "type": "property",
            "name": "hourCycle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number",
                  "value": 12
                },
                {
                  "type": "number",
                  "value": 24
                }
              ]
            },
            "optional": true,
            "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
            "default": null
          },
          "granularity": {
            "type": "property",
            "name": "granularity",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
            },
            "optional": true,
            "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
            "default": null
          },
          "hideTimeZone": {
            "type": "property",
            "name": "hideTimeZone",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to hide the time zone abbreviation.",
            "default": "false"
          },
          "shouldForceLeadingZeros": {
            "type": "property",
            "name": "shouldForceLeadingZeros",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "allowsNonContiguousRanges": {
            "type": "property",
            "name": "allowsNonContiguousRanges",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "When combined with `isDateUnavailable`, determines whether non-contiguous ranges,\ni.e. ranges containing unavailable dates, may be selected.",
            "default": null
          },
          "startName": {
            "type": "property",
            "name": "startName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the start date input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "endName": {
            "type": "property",
            "name": "endName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the end date input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                    },
                    "typeParameters": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                          }
                        ]
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                        },
                        "typeParameters": [
                          {
                            "type": "application",
                            "base": {
                              "type": "link",
                              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                            },
                            "typeParameters": [
                              {
                                "type": "link",
                                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "shouldCloseOnSelect": {
            "type": "property",
            "name": "shouldCloseOnSelect",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Determines whether the date picker popover should close automatically when a date is selected.",
            "default": "true"
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A date range picker combines two DateFields and a RangeCalendar popover to allow\nusers to enter or select a date and time range."
    },
    "DatePickerContext": {
      "type": "any"
    },
    "DateRangePickerContext": {
      "type": "any"
    },
    "DatePickerStateContext": {
      "type": "any"
    },
    "DateRangePickerStateContext": {
      "type": "any"
    },
    "DialogTrigger": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogTrigger",
      "name": "DialogTrigger",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogTriggerProps",
        "name": "DialogTriggerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "A DialogTrigger opens a dialog when a trigger element is pressed."
    },
    "Dialog": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:Dialog",
      "name": "Dialog",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogProps",
        "name": "DialogProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "opts",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "dialog"
                },
                {
                  "type": "string",
                  "value": "alertdialog"
                }
              ]
            },
            "optional": true,
            "description": "The accessibility role for the dialog.",
            "default": "'dialog'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": "A dialog is an overlay shown above other content in an application."
    },
    "DialogContext": {
      "type": "any"
    },
    "OverlayTriggerStateContext": {
      "type": "any"
    },
    "Disclosure": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:Disclosure",
      "name": "Disclosure",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureProps",
        "name": "DisclosureProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "An id for the disclosure when used within a DisclosureGroup, matching the id used in `expandedKeys`.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the disclosure is disabled.",
            "default": null
          },
          "onExpandedChange": {
            "type": "property",
            "name": "onExpandedChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isExpanded",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the disclosure's expanded state changes.",
            "default": null
          },
          "isExpanded": {
            "type": "property",
            "name": "isExpanded",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the disclosure is expanded (controlled).",
            "default": null
          },
          "defaultExpanded": {
            "type": "property",
            "name": "defaultExpanded",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the disclosure is expanded by default (uncontrolled).",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A disclosure is a collapsible section of content. It is composed of a a header with a heading and trigger button, and a panel that contains the content."
    },
    "DisclosureGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroup",
      "name": "DisclosureGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupProps",
        "name": "DisclosureGroupProps",
        "properties": {
          "allowsMultipleExpanded": {
            "type": "property",
            "name": "allowsMultipleExpanded",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether multiple items can be expanded at the same time.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether all items are disabled.",
            "default": null
          },
          "expandedKeys": {
            "type": "property",
            "name": "expandedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "optional": true,
            "description": "The currently expanded keys in the group (controlled).",
            "default": null
          },
          "defaultExpandedKeys": {
            "type": "property",
            "name": "defaultExpandedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "optional": true,
            "description": "The initial expanded keys in the group (uncontrolled).",
            "default": null
          },
          "onExpandedChange": {
            "type": "property",
            "name": "onExpandedChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Set"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when items are expanded or collapsed.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A DisclosureGroup is a grouping of related disclosures, sometimes called an accordion.\nIt supports both single and multiple expanded items."
    },
    "DisclosureGroupStateContext": {
      "type": "any"
    },
    "DisclosurePanel": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosurePanel",
      "name": "DisclosurePanel",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosurePanelProps",
        "name": "DisclosurePanelProps",
        "properties": {
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "group"
                },
                {
                  "type": "string",
                  "value": "region"
                }
              ]
            },
            "optional": true,
            "description": "The accessibility role for the disclosure's panel.",
            "default": "'group'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The children of the component.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosurePanelRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosurePanelRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A DisclosurePanel provides the content for a disclosure."
    },
    "DisclosureStateContext": {
      "type": "any"
    },
    "DisclosureContext": {
      "type": "any"
    },
    "DropZone": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZone",
      "name": "DropZone",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneProps",
        "name": "DropZoneProps",
        "properties": {
          "getDropOperation": {
            "type": "property",
            "name": "getDropOperation",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "types",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                  },
                  "rest": false,
                  "description": null
                },
                {
                  "type": "parameter",
                  "name": "allowedOperations",
                  "value": {
                    "type": "array",
                    "elementType": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                    }
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
            "default": null
          },
          "onDropEnter": {
            "type": "property",
            "name": "onDropEnter",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEnterEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a valid drag enters the drop target.",
            "default": null
          },
          "onDropMove": {
            "type": "property",
            "name": "onDropMove",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropMoveEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a valid drag is moved within the drop target.",
            "default": null
          },
          "onDropActivate": {
            "type": "property",
            "name": "onDropActivate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropActivateEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called after a valid drag is held over the drop target for a period of time.\nThis typically opens the item so that the user can drop within it.",
            "default": null
          },
          "onDropExit": {
            "type": "property",
            "name": "onDropExit",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropExitEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a valid drag exits the drop target.",
            "default": null
          },
          "onDrop": {
            "type": "property",
            "name": "onDrop",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a valid drag is dropped on the drop target.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the drop target is disabled. If true, the drop target will not accept any drops.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A drop zone is an area into which one or multiple objects can be dragged and dropped."
    },
    "DropZoneContext": {
      "type": "any"
    },
    "FieldError": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldError",
      "name": "FieldError",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorProps",
        "name": "FieldErrorProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": "A FieldError displays validation errors for a form field."
    },
    "FieldErrorContext": {
      "type": "any"
    },
    "FileTrigger": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FileTrigger.tsx:FileTrigger",
      "name": "FileTrigger",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FileTrigger.tsx:FileTriggerProps",
        "name": "FileTriggerProps",
        "properties": {
          "acceptedFileTypes": {
            "type": "property",
            "name": "acceptedFileTypes",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Specifies what mime type of files are allowed.",
            "default": null
          },
          "allowsMultiple": {
            "type": "property",
            "name": "allowsMultiple",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether multiple files can be selected.",
            "default": null
          },
          "defaultCamera": {
            "type": "property",
            "name": "defaultCamera",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "user"
                },
                {
                  "type": "string",
                  "value": "environment"
                }
              ]
            },
            "optional": true,
            "description": "Specifies the use of a media capture mechanism to capture the media on the spot.",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "files",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "identifier",
                        "name": "FileList"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler when a user selects a file.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The children of the component.",
            "default": null
          },
          "acceptDirectory": {
            "type": "property",
            "name": "acceptDirectory",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Enables the selection of directories instead of individual files.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLInputElement"
          }
        ]
      },
      "description": "A FileTrigger allows a user to access the file system with any pressable React Aria or React Spectrum component, or custom components built with usePress."
    },
    "Form": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Form.tsx:Form",
      "name": "Form",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Form.tsx:FormProps",
        "name": "FormProps",
        "properties": {
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "aria"
                },
                {
                  "type": "string",
                  "value": "native"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen a field value is missing or invalid, or mark fields as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "validationErrors": {
            "type": "property",
            "name": "validationErrors",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationErrors"
            },
            "optional": true,
            "description": "Validation errors for the form, typically returned by a server.\nThis should be set to an object mapping from input names to errors.",
            "default": null
          },
          "action": {
            "type": "property",
            "name": "action",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "indexedAccess",
                  "objectType": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FormHTMLAttributes"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLFormElement"
                      }
                    ]
                  },
                  "indexType": {
                    "type": "string",
                    "value": "action"
                  }
                }
              ]
            },
            "optional": true,
            "description": "Where to send the form-data when the form is submitted.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#action).",
            "default": null
          },
          "encType": {
            "type": "property",
            "name": "encType",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "application/x-www-form-urlencoded"
                },
                {
                  "type": "string",
                  "value": "multipart/form-data"
                },
                {
                  "type": "string",
                  "value": "text/plain"
                }
              ]
            },
            "optional": true,
            "description": "The enctype attribute specifies how the form-data should be encoded when submitting it to the server.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#enctype).",
            "default": null
          },
          "method": {
            "type": "property",
            "name": "method",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "get"
                },
                {
                  "type": "string",
                  "value": "post"
                },
                {
                  "type": "string",
                  "value": "dialog"
                }
              ]
            },
            "optional": true,
            "description": "The HTTP method to submit the form with.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#method).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "_blank"
                },
                {
                  "type": "string",
                  "value": "_self"
                },
                {
                  "type": "string",
                  "value": "_parent"
                },
                {
                  "type": "string",
                  "value": "_top"
                }
              ]
            },
            "optional": true,
            "description": "The target attribute specifies a name or a keyword that indicates where to display the response that is received after submitting the form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#target).",
            "default": null
          },
          "onSubmit": {
            "type": "property",
            "name": "onSubmit",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "event",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FormEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLFormElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Triggered when a user submits the form.",
            "default": null
          },
          "onReset": {
            "type": "property",
            "name": "onReset",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "event",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FormEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLFormElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Triggered when a user resets the form.",
            "default": null
          },
          "onInvalid": {
            "type": "property",
            "name": "onInvalid",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "event",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FormEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLFormElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Triggered for each invalid field when a user submits the form.",
            "default": null
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "off"
                },
                {
                  "type": "string",
                  "value": "on"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether input elements can by default have their values automatically completed by the browser.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#autocomplete).",
            "default": null
          },
          "autoCapitalize": {
            "type": "property",
            "name": "autoCapitalize",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "off"
                },
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "on"
                },
                {
                  "type": "string",
                  "value": "sentences"
                },
                {
                  "type": "string",
                  "value": "words"
                },
                {
                  "type": "string",
                  "value": "characters"
                }
              ]
            },
            "optional": true,
            "description": "Controls whether inputted text is automatically capitalized and, if so, in what manner. \nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/autocapitalize).",
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "presentation"
                }
              ]
            },
            "optional": true,
            "description": "An ARIA role override to apply to the form element.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The children of the component.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLFormElement"
          }
        ]
      },
      "description": "A form is a group of inputs that allows users to submit data to a server,\nwith support for providing field validation errors."
    },
    "FormContext": {
      "type": "any"
    },
    "GridListLoadMoreItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListLoadMoreItem",
      "name": "GridListLoadMoreItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListLoadMoreItemProps",
        "name": "GridListLoadMoreItemProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The load more spinner to render when loading additional items.",
            "default": null
          },
          "isLoading": {
            "type": "property",
            "name": "isLoading",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether or not the loading spinner should be rendered or not.",
            "default": null
          },
          "scrollOffset": {
            "type": "property",
            "name": "scrollOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The amount of offset from the bottom of your scrollable region that should trigger load more.\nUses a percentage value relative to the scroll body's client height. Load more is then triggered\nwhen your current scroll position's distance from the bottom of the currently loaded list of items is less than\nor equal to the provided value. (e.g. 1 = 100% of the scroll region's height).",
            "default": "1"
          },
          "onLoadMore": {
            "type": "property",
            "name": "onLoadMore",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "GridList": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridList",
      "name": "GridList",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListProps",
        "name": "GridListProps",
        "properties": {
          "disallowTypeAhead": {
            "type": "property",
            "name": "disallowTypeAhead",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether typeahead navigation is disabled.",
            "default": "false"
          },
          "selectionBehavior": {
            "type": "property",
            "name": "selectionBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
            },
            "optional": true,
            "description": "How multiple selection should behave in the collection.",
            "default": "\"toggle\""
          },
          "dragAndDropHooks": {
            "type": "property",
            "name": "dragAndDropHooks",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "NoInfer"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the GridList.",
            "default": null
          },
          "renderEmptyState": {
            "type": "property",
            "name": "renderEmptyState",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "props",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides content to display when there are no items in the list.",
            "default": null
          },
          "layout": {
            "type": "property",
            "name": "layout",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "stack"
                },
                {
                  "type": "string",
                  "value": "grid"
                }
              ]
            },
            "optional": true,
            "description": "Whether the items are arranged in a stack or grid.",
            "default": "'stack'"
          },
          "keyboardNavigationBehavior": {
            "type": "property",
            "name": "keyboardNavigationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "arrow"
                },
                {
                  "type": "string",
                  "value": "tab"
                }
              ]
            },
            "optional": true,
            "description": "Whether keyboard navigation to focusable elements within grid list items is\nvia the left/right arrow keys or the tab key.",
            "default": "'arrow'"
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the grid list or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                }
              ]
            },
            "optional": true,
            "description": "Whether to auto focus the gridlist or an option.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "disabledBehavior": {
            "type": "property",
            "name": "disabledBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
            },
            "optional": true,
            "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
            "default": "\"all\""
          },
          "shouldSelectOnPressUp": {
            "type": "property",
            "name": "shouldSelectOnPressUp",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether selection should occur on press up instead of press down.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A grid list displays a list of interactive items, with support for keyboard navigation,\nsingle or multiple selection, and row actions."
    },
    "GridListItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItem",
      "name": "GridListItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemProps",
        "name": "GridListItemProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the item.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "object",
              "properties": null
            },
            "optional": true,
            "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the item's contents, used for features like typeahead.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": {
              "type": "object",
              "properties": null
            }
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A GridListItem represents an individual item in a GridList."
    },
    "GridListContext": {
      "type": "any"
    },
    "GridListHeader": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListHeader",
      "name": "GridListHeader",
      "props": {
        "type": "identifier",
        "name": "HTMLAttributes"
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": null
    },
    "GridListSection": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListSection",
      "name": "GridListSection",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListSectionProps",
        "name": "GridListSectionProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the section.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "object",
              "properties": null
            },
            "optional": true,
            "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Static child items or a function to render children.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for the section.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the section.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": "A GridListSection represents a section within a GridList."
    },
    "Group": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:Group",
      "name": "Group",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupProps",
        "name": "GroupProps",
        "properties": {
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the group is disabled.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the group is invalid.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the group is read only.",
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "group"
                },
                {
                  "type": "string",
                  "value": "region"
                },
                {
                  "type": "string",
                  "value": "presentation"
                }
              ]
            },
            "optional": true,
            "description": "An accessibility role for the group. By default, this is set to `'group'`.\nUse `'region'` when the contents of the group is important enough to be\nincluded in the page table of contents. Use `'presentation'` if the group\nis visual only and does not represent a semantic grouping of controls.",
            "default": "'group'"
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": [
          {
            "type": "identifier",
            "name": "HTMLAttributes"
          }
        ]
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A group represents a set of related UI controls, and supports interactive states for styling."
    },
    "GroupContext": {
      "type": "any"
    },
    "Header": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Header.tsx:Header",
      "name": "Header",
      "props": {
        "type": "identifier",
        "name": "HTMLAttributes"
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": null
    },
    "HeaderContext": {
      "type": "any"
    },
    "Heading": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Heading.tsx:Heading",
      "name": "Heading",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Heading.tsx:HeadingProps",
        "name": "HeadingProps",
        "properties": {
          "level": {
            "type": "property",
            "name": "level",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "default": null
          }
        },
        "typeParameters": [],
        "extends": [
          {
            "type": "identifier",
            "name": "HTMLAttributes"
          }
        ]
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLHeadingElement"
          }
        ]
      },
      "description": null
    },
    "Input": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:Input",
      "name": "Input",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputProps",
        "name": "InputProps",
        "properties": {
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": [
          {
            "type": "identifier",
            "name": "InputHTMLAttributes"
          }
        ]
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLInputElement"
          }
        ]
      },
      "description": "An input allows a user to input text."
    },
    "InputContext": {
      "type": "any"
    },
    "Section": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:Section",
      "name": "Section",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:SectionProps",
        "name": "SectionProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the section.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "object",
              "properties": null
            },
            "optional": true,
            "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Static child items or a function to render children.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for the section.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the section.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": null,
      "access": "private"
    },
    "CollectionRendererContext": {
      "type": "any"
    },
    "DefaultCollectionRenderer": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:DefaultCollectionRenderer",
      "name": "DefaultCollectionRenderer",
      "properties": {
        "CollectionRoot": {
          "type": "method",
          "name": "CollectionRoot",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null
        },
        "CollectionBranch": {
          "type": "method",
          "name": "CollectionBranch",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "Collection": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/CollectionBuilder.tsx:Collection",
      "name": "Collection",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/CollectionBuilder.tsx:CollectionProps",
        "name": "CollectionProps",
        "properties": {
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "idScope": {
            "type": "property",
            "name": "idScope",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "A scope to prepend to all child item ids to ensure they are unique.",
            "default": null
          },
          "addIdAndValue": {
            "type": "property",
            "name": "addIdAndValue",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to add `id` and `value` props to all child items.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": null,
      "description": "A Collection renders a list of items, automatically managing caching and keys."
    },
    "UNSTABLE_createLeafComponent": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/CollectionBuilder.tsx:createLeafComponent",
      "name": "UNSTABLE_createLeafComponent",
      "parameters": [
        {
          "type": "parameter",
          "name": "CollectionNodeClass",
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {},
                "typeParameters": [
                  {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                ]
              },
              {
                "type": "string"
              }
            ]
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "render",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "identifier",
                  "name": "P"
                },
                "rest": false
              },
              {
                "type": "parameter",
                "name": "ref",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "ForwardedRef"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "E"
                    }
                  ]
                },
                "rest": false
              },
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "id": null,
                  "name": null,
                  "type": "any"
                },
                "optional": true,
                "rest": false
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "function",
        "parameters": [
          {
            "type": "parameter",
            "name": "props",
            "value": {
              "type": "intersection",
              "types": [
                {
                  "type": "identifier",
                  "name": "P"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "React.RefAttributes"
                  },
                  "typeParameters": [
                    {
                      "id": null,
                      "name": null,
                      "type": "any"
                    }
                  ]
                }
              ]
            },
            "rest": false
          }
        ],
        "return": {
          "type": "union",
          "elements": [
            {
              "type": "identifier",
              "name": "ReactElement"
            },
            {
              "type": "null"
            }
          ]
        },
        "typeParameters": [],
        "description": null
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "P",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "E",
          "constraint": {
            "type": "identifier",
            "name": "Element"
          },
          "default": null
        }
      ]
    },
    "UNSTABLE_createBranchComponent": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/CollectionBuilder.tsx:createBranchComponent",
      "name": "UNSTABLE_createBranchComponent",
      "parameters": [
        {
          "type": "parameter",
          "name": "CollectionNodeClass",
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {},
                "typeParameters": [
                  {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                ]
              },
              {
                "type": "string"
              }
            ]
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "render",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "identifier",
                  "name": "P"
                },
                "rest": false
              },
              {
                "type": "parameter",
                "name": "ref",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "ForwardedRef"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "E"
                    }
                  ]
                },
                "rest": false
              },
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "useChildren",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "identifier",
                  "name": "P"
                },
                "rest": false
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "function",
        "parameters": [
          {
            "type": "parameter",
            "name": "props",
            "value": {
              "type": "intersection",
              "types": [
                {
                  "type": "identifier",
                  "name": "P"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "React.RefAttributes"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "E"
                    }
                  ]
                }
              ]
            },
            "rest": false
          }
        ],
        "return": {
          "type": "union",
          "elements": [
            {
              "type": "identifier",
              "name": "ReactElement"
            },
            {
              "type": "null"
            }
          ]
        },
        "typeParameters": [],
        "description": null
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "P",
          "constraint": {
            "type": "object",
            "properties": {
              "children": {
                "type": "property",
                "name": "children",
                "indexType": null,
                "value": {
                  "id": null,
                  "name": null,
                  "type": "any"
                },
                "optional": true,
                "default": null
              }
            }
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "E",
          "constraint": {
            "type": "identifier",
            "name": "Element"
          },
          "default": null
        }
      ]
    },
    "UNSTABLE_CollectionBuilder": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/CollectionBuilder.tsx:CollectionBuilder",
      "name": "UNSTABLE_CollectionBuilder",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/CollectionBuilder.tsx:CollectionBuilderProps",
        "name": "CollectionBuilderProps",
        "properties": {
          "content": {
            "type": "property",
            "name": "content",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "collection",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:BaseCollection"
                    },
                    "typeParameters": [
                      {
                        "type": "object",
                        "properties": null
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": false,
            "default": null
          },
          "createCollection": {
            "type": "property",
            "name": "createCollection",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:BaseCollection"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "C",
            "constraint": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:BaseCollection"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                }
              ]
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "C",
          "constraint": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:BaseCollection"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              }
            ]
          },
          "default": null
        }
      ],
      "ref": null,
      "description": "Builds a `Collection` from the children provided to the `content` prop, and passes it to the child render prop function."
    },
    "Keyboard": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Keyboard.tsx:Keyboard",
      "name": "Keyboard",
      "props": {
        "type": "identifier",
        "name": "HTMLAttributes"
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": null
    },
    "KeyboardContext": {
      "type": "any"
    },
    "Label": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Label.tsx:Label",
      "name": "Label",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Label.tsx:LabelProps",
        "name": "LabelProps",
        "properties": {
          "elementType": {
            "type": "property",
            "name": "elementType",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "default": null
          }
        },
        "typeParameters": [],
        "extends": [
          {
            "type": "identifier",
            "name": "LabelHTMLAttributes"
          }
        ]
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLLabelElement"
          }
        ]
      },
      "description": null
    },
    "LabelContext": {
      "type": "any"
    },
    "Link": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:Link",
      "name": "Link",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkProps",
        "name": "LinkProps",
        "properties": {
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the link is disabled.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLAnchorElement"
          }
        ]
      },
      "description": "A link allows a user to navigate to another page or resource within a web page\nor application."
    },
    "LinkContext": {
      "type": "any"
    },
    "ListBoxLoadMoreItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxLoadMoreItem",
      "name": "ListBoxLoadMoreItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxLoadMoreItemProps",
        "name": "ListBoxLoadMoreItemProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The load more spinner to render when loading additional items.",
            "default": null
          },
          "isLoading": {
            "type": "property",
            "name": "isLoading",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether or not the loading spinner should be rendered or not.",
            "default": null
          },
          "scrollOffset": {
            "type": "property",
            "name": "scrollOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The amount of offset from the bottom of your scrollable region that should trigger load more.\nUses a percentage value relative to the scroll body's client height. Load more is then triggered\nwhen your current scroll position's distance from the bottom of the currently loaded list of items is less than\nor equal to the provided value. (e.g. 1 = 100% of the scroll region's height).",
            "default": "1"
          },
          "onLoadMore": {
            "type": "property",
            "name": "onLoadMore",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "ListBox": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBox",
      "name": "ListBox",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxProps",
        "name": "ListBoxProps",
        "properties": {
          "selectionBehavior": {
            "type": "property",
            "name": "selectionBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
            },
            "optional": true,
            "description": "How multiple selection should behave in the collection.",
            "default": "\"toggle\""
          },
          "dragAndDropHooks": {
            "type": "property",
            "name": "dragAndDropHooks",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "NoInfer"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the ListBox.",
            "default": null
          },
          "renderEmptyState": {
            "type": "property",
            "name": "renderEmptyState",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "props",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxRenderProps"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides content to display when there are no items in the list.",
            "default": null
          },
          "layout": {
            "type": "property",
            "name": "layout",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "stack"
                },
                {
                  "type": "string",
                  "value": "grid"
                }
              ]
            },
            "optional": true,
            "description": "Whether the items are arranged in a stack or grid.",
            "default": "'stack'"
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The primary orientation of the items. Usually this is the\ndirection that the collection scrolls.",
            "default": "'vertical'"
          },
          "shouldSelectOnPressUp": {
            "type": "property",
            "name": "shouldSelectOnPressUp",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether selection should occur on press up instead of press down.",
            "default": null
          },
          "shouldFocusOnHover": {
            "type": "property",
            "name": "shouldFocusOnHover",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether options should be focused when the user hovers over them.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the listbox or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                }
              ]
            },
            "optional": true,
            "description": "Whether to auto focus the listbox or an option.",
            "default": null
          },
          "shouldFocusWrap": {
            "type": "property",
            "name": "shouldFocusWrap",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether focus should wrap around when the end/start is reached.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A listbox displays a list of options and allows a user to select one or more of them."
    },
    "ListBoxItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItem",
      "name": "ListBoxItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemProps",
        "name": "ListBoxItemProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the item.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "object",
              "properties": null
            },
            "optional": true,
            "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the item's contents, used for features like typeahead.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for this item.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": {
              "type": "object",
              "properties": null
            }
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ListBoxItem represents an individual option in a ListBox."
    },
    "ListBoxSection": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxSection",
      "name": "ListBoxSection",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxSectionProps",
        "name": "ListBoxSectionProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the section.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "object",
              "properties": null
            },
            "optional": true,
            "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Static child items or a function to render children.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for the section.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the section.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": "A ListBoxSection represents a section within a ListBox."
    },
    "ListBoxContext": {
      "type": "any"
    },
    "ListStateContext": {
      "type": "any"
    },
    "Menu": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:Menu",
      "name": "Menu",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuProps",
        "name": "MenuProps",
        "properties": {
          "renderEmptyState": {
            "type": "property",
            "name": "renderEmptyState",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides content to display when there are no items in the list.",
            "default": null
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the menu or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                }
              ]
            },
            "optional": true,
            "description": "Where the focus should be set.",
            "default": null
          },
          "shouldFocusWrap": {
            "type": "property",
            "name": "shouldFocusWrap",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether keyboard navigation is circular.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when an item is selected.",
            "default": null
          },
          "onClose": {
            "type": "property",
            "name": "onClose",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the menu should close after selecting an item.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A menu displays a list of actions or options that a user can choose."
    },
    "MenuItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItem",
      "name": "MenuItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemProps",
        "name": "MenuItemProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the item.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "object",
              "properties": null
            },
            "optional": true,
            "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the item's contents, used for features like typeahead.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for this item.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the item is selected.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": {
              "type": "object",
              "properties": null
            }
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A MenuItem represents an individual action in a Menu."
    },
    "MenuTrigger": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuTrigger",
      "name": "MenuTrigger",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuTriggerProps",
        "name": "MenuTriggerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "trigger": {
            "type": "property",
            "name": "trigger",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/menu/src/index.d.ts:MenuTriggerType"
            },
            "optional": true,
            "description": "How the menu is triggered.",
            "default": "'press'"
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "MenuSection": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuSection",
      "name": "MenuSection",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuSectionProps",
        "name": "MenuSectionProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the section.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "object",
              "properties": null
            },
            "optional": true,
            "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Static child items or a function to render children.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for the section.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the section.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The currently disabled keys in the collection (controlled).",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": "A MenuSection represents a section within a Menu."
    },
    "MenuContext": {
      "type": "any"
    },
    "MenuStateContext": {
      "type": "any"
    },
    "RootMenuTriggerStateContext": {
      "type": "any"
    },
    "SubmenuTrigger": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:SubmenuTrigger",
      "name": "SubmenuTrigger",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:SubmenuTriggerProps",
        "name": "SubmenuTriggerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "array",
              "elementType": {
                "type": "identifier",
                "name": "ReactElement"
              }
            },
            "optional": false,
            "description": "The contents of the SubmenuTrigger. The first child should be an Item (the trigger) and the second child should be the Popover (for the submenu).",
            "default": null
          },
          "delay": {
            "type": "property",
            "name": "delay",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The delay time in milliseconds for the submenu to appear after hovering over the trigger.",
            "default": "200"
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A submenu trigger is used to wrap a submenu's trigger item and the submenu itself."
    },
    "Meter": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:Meter",
      "name": "Meter",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterProps",
        "name": "MeterProps",
        "properties": {
          "formatOptions": {
            "type": "property",
            "name": "formatOptions",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions"
            },
            "optional": true,
            "description": "The display format of the value label.",
            "default": "{style: 'percent'}"
          },
          "valueLabel": {
            "type": "property",
            "name": "valueLabel",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the value's label (e.g. 1 of 4).",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": "0"
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The smallest value allowed for the input.",
            "default": "0"
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The largest value allowed for the input.",
            "default": "100"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A meter represents a quantity within a known range, or a fractional value."
    },
    "MeterContext": {
      "type": "any"
    },
    "Modal": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:Modal",
      "name": "Modal",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalOverlayProps",
        "name": "ModalOverlayProps",
        "properties": {
          "isEntering": {
            "type": "property",
            "name": "isEntering",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the modal is currently performing an entry animation.",
            "default": null
          },
          "isExiting": {
            "type": "property",
            "name": "isExiting",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the modal is currently performing an exit animation.",
            "default": null
          },
          "UNSTABLE_portalContainer": {
            "type": "property",
            "name": "UNSTABLE_portalContainer",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Element"
            },
            "optional": true,
            "description": "The container element in which the overlay portal will be placed. This may have unknown behavior depending on where it is portalled to.",
            "access": "private",
            "default": "document.body"
          },
          "isDismissable": {
            "type": "property",
            "name": "isDismissable",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to close the modal when the user interacts outside it.",
            "default": "false"
          },
          "isKeyboardDismissDisabled": {
            "type": "property",
            "name": "isKeyboardDismissDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether pressing the escape key to close the modal should be disabled.",
            "default": "false"
          },
          "shouldCloseOnInteractOutside": {
            "type": "property",
            "name": "shouldCloseOnInteractOutside",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "element",
                  "value": {
                    "type": "identifier",
                    "name": "Element"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "When user interacts with the argument element outside of the overlay ref,\nreturn true if onClose should be called.  This gives you a chance to filter\nout interaction with elements that should not dismiss the overlay.\nBy default, onClose will always be called on interaction outside the overlay ref.",
            "default": null
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A modal is an overlay element which blocks interaction with elements outside it."
    },
    "ModalOverlay": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalOverlay",
      "name": "ModalOverlay",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalOverlayProps",
        "name": "ModalOverlayProps",
        "properties": {
          "isEntering": {
            "type": "property",
            "name": "isEntering",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the modal is currently performing an entry animation.",
            "default": null
          },
          "isExiting": {
            "type": "property",
            "name": "isExiting",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the modal is currently performing an exit animation.",
            "default": null
          },
          "UNSTABLE_portalContainer": {
            "type": "property",
            "name": "UNSTABLE_portalContainer",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Element"
            },
            "optional": true,
            "description": "The container element in which the overlay portal will be placed. This may have unknown behavior depending on where it is portalled to.",
            "access": "private",
            "default": "document.body"
          },
          "isDismissable": {
            "type": "property",
            "name": "isDismissable",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to close the modal when the user interacts outside it.",
            "default": "false"
          },
          "isKeyboardDismissDisabled": {
            "type": "property",
            "name": "isKeyboardDismissDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether pressing the escape key to close the modal should be disabled.",
            "default": "false"
          },
          "shouldCloseOnInteractOutside": {
            "type": "property",
            "name": "shouldCloseOnInteractOutside",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "element",
                  "value": {
                    "type": "identifier",
                    "name": "Element"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "When user interacts with the argument element outside of the overlay ref,\nreturn true if onClose should be called.  This gives you a chance to filter\nout interaction with elements that should not dismiss the overlay.\nBy default, onClose will always be called on interaction outside the overlay ref.",
            "default": null
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ModalOverlay is a wrapper for a Modal which allows customizing the backdrop element."
    },
    "ModalContext": {
      "type": "any"
    },
    "NumberField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberField",
      "name": "NumberField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldProps",
        "name": "NumberFieldProps",
        "properties": {
          "decrementAriaLabel": {
            "type": "property",
            "name": "decrementAriaLabel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A custom aria-label for the decrement button. If not provided, the localized string \"Decrement\" is used.",
            "default": null
          },
          "incrementAriaLabel": {
            "type": "property",
            "name": "incrementAriaLabel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A custom aria-label for the increment button. If not provided, the localized string \"Increment\" is used.",
            "default": null
          },
          "isWheelDisabled": {
            "type": "property",
            "name": "isWheelDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Enables or disables changing the value with scroll.",
            "default": null
          },
          "formatOptions": {
            "type": "property",
            "name": "formatOptions",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions"
            },
            "optional": true,
            "description": "Formatting options for the value displayed in the number field.\nThis also affects what characters are allowed to be typed by the user.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "number"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The smallest value allowed for the input.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The largest value allowed for the input.",
            "default": null
          },
          "step": {
            "type": "property",
            "name": "step",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The amount that the input value changes with each increment or decrement \"tick\".",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "onCopy": {
            "type": "property",
            "name": "onCopy",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
            "default": null
          },
          "onCut": {
            "type": "property",
            "name": "onCut",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
            "default": null
          },
          "onPaste": {
            "type": "property",
            "name": "onPaste",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
            "default": null
          },
          "onCompositionStart": {
            "type": "property",
            "name": "onCompositionStart",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
            "default": null
          },
          "onCompositionEnd": {
            "type": "property",
            "name": "onCompositionEnd",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
            "default": null
          },
          "onCompositionUpdate": {
            "type": "property",
            "name": "onCompositionUpdate",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
            "default": null
          },
          "onBeforeInput": {
            "type": "property",
            "name": "onBeforeInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
            "default": null
          },
          "onInput": {
            "type": "property",
            "name": "onInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A number field allows a user to enter a number, and increment or decrement the value using stepper buttons."
    },
    "NumberFieldContext": {
      "type": "any"
    },
    "NumberFieldStateContext": {
      "type": "any"
    },
    "OverlayArrow": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrow",
      "name": "OverlayArrow",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowProps",
        "name": "OverlayArrowProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": [
          {
            "type": "identifier",
            "name": "HTMLAttributes"
          }
        ]
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "An OverlayArrow renders a custom arrow element relative to an overlay element\nsuch as a popover or tooltip such that it aligns with a trigger element."
    },
    "Popover": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:Popover",
      "name": "Popover",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverProps",
        "name": "PopoverProps",
        "properties": {
          "trigger": {
            "type": "property",
            "name": "trigger",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the component that triggered the popover. This is reflected on the element\nas the `data-trigger` attribute, and can be used to provide specific\nstyles for the popover depending on which element triggered it.",
            "default": null
          },
          "triggerRef": {
            "type": "property",
            "name": "triggerRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Element"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The ref for the element which the popover positions itself with respect to.\n\nWhen used within a trigger component such as DialogTrigger, MenuTrigger, Select, etc.,\nthis is set automatically. It is only required when used standalone.",
            "default": null
          },
          "isEntering": {
            "type": "property",
            "name": "isEntering",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the popover is currently performing an entry animation.",
            "default": null
          },
          "isExiting": {
            "type": "property",
            "name": "isExiting",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the popover is currently performing an exit animation.",
            "default": null
          },
          "UNSTABLE_portalContainer": {
            "type": "property",
            "name": "UNSTABLE_portalContainer",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Element"
            },
            "optional": true,
            "description": "The container element in which the overlay portal will be placed. This may have unknown behavior depending on where it is portalled to.",
            "access": "private",
            "default": "document.body"
          },
          "offset": {
            "type": "property",
            "name": "offset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
            "default": "8"
          },
          "placement": {
            "type": "property",
            "name": "placement",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement"
            },
            "optional": true,
            "description": "The placement of the element with respect to its anchor element.",
            "default": "'bottom'"
          },
          "containerPadding": {
            "type": "property",
            "name": "containerPadding",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
            "default": "12"
          },
          "crossOffset": {
            "type": "property",
            "name": "crossOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
            "default": "0"
          },
          "shouldFlip": {
            "type": "property",
            "name": "shouldFlip",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
            "default": "true"
          },
          "arrowRef": {
            "type": "property",
            "name": "arrowRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Element"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "A ref for the popover arrow element.",
            "default": null
          },
          "isNonModal": {
            "type": "property",
            "name": "isNonModal",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the popover is non-modal, i.e. elements outside the popover may be\ninteracted with by assistive technologies.\n\nMost popovers should not use this option as it may negatively impact the screen\nreader experience. Only use with components such as combobox, which are designed\nto handle this situation carefully.",
            "default": null
          },
          "isKeyboardDismissDisabled": {
            "type": "property",
            "name": "isKeyboardDismissDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether pressing the escape key to close the popover should be disabled.\n\nMost popovers should not use this option. When set to true, an alternative\nway to close the popover with a keyboard must be provided.",
            "default": "false"
          },
          "shouldCloseOnInteractOutside": {
            "type": "property",
            "name": "shouldCloseOnInteractOutside",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "element",
                  "value": {
                    "type": "identifier",
                    "name": "Element"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "When user interacts with the argument element outside of the popover ref,\nreturn true if onClose should be called. This gives you a chance to filter\nout interaction with elements that should not dismiss the popover.\nBy default, onClose will always be called on interaction outside the popover ref.",
            "default": null
          },
          "boundaryElement": {
            "type": "property",
            "name": "boundaryElement",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Element"
            },
            "optional": true,
            "description": "Element that that serves as the positioning boundary.",
            "default": "document.body"
          },
          "scrollRef": {
            "type": "property",
            "name": "scrollRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Element"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "A ref for the scrollable region within the overlay.",
            "default": "overlayRef"
          },
          "shouldUpdatePosition": {
            "type": "property",
            "name": "shouldUpdatePosition",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay should update its position automatically.",
            "default": "true"
          },
          "maxHeight": {
            "type": "property",
            "name": "maxHeight",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The maxHeight specified for the overlay element.\nBy default, it will take all space up to the current viewport height.",
            "default": null
          },
          "arrowBoundaryOffset": {
            "type": "property",
            "name": "arrowBoundaryOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The minimum distance the arrow's edge should be from the edge of the overlay element.",
            "default": "0"
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": "A popover is an overlay element positioned relative to a trigger."
    },
    "PopoverContext": {
      "type": "any"
    },
    "ProgressBar": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBar",
      "name": "ProgressBar",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarProps",
        "name": "ProgressBarProps",
        "properties": {
          "isIndeterminate": {
            "type": "property",
            "name": "isIndeterminate",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether presentation is indeterminate when progress isn't known.",
            "default": null
          },
          "formatOptions": {
            "type": "property",
            "name": "formatOptions",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions"
            },
            "optional": true,
            "description": "The display format of the value label.",
            "default": "{style: 'percent'}"
          },
          "valueLabel": {
            "type": "property",
            "name": "valueLabel",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the value's label (e.g. 1 of 4).",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": "0"
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The smallest value allowed for the input.",
            "default": "0"
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The largest value allowed for the input.",
            "default": "100"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Progress bars show either determinate or indeterminate progress of an operation\nover time."
    },
    "ProgressBarContext": {
      "type": "any"
    },
    "RadioGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroup",
      "name": "RadioGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupProps",
        "name": "RadioGroupProps",
        "properties": {
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The axis the Radio Button(s) should align with.",
            "default": "'vertical'"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A radio group allows a user to select a single item from a list of mutually exclusive options."
    },
    "Radio": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:Radio",
      "name": "Radio",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioProps",
        "name": "RadioProps",
        "properties": {
          "inputRef": {
            "type": "property",
            "name": "inputRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "A ref for the HTML input element.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": false,
            "description": "The value of the radio button, used when submitting an HTML form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio#Value).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the radio button is disabled or not.\nShows that a selection exists, but is not available in that circumstance.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLLabelElement"
          }
        ]
      },
      "description": "A radio represents an individual option within a radio group."
    },
    "RadioGroupContext": {
      "type": "any"
    },
    "RadioContext": {
      "type": "any"
    },
    "RadioGroupStateContext": {
      "type": "any"
    },
    "SearchField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchField",
      "name": "SearchField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldProps",
        "name": "SearchFieldProps",
        "properties": {
          "enterKeyHint": {
            "type": "property",
            "name": "enterKeyHint",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "enter"
                },
                {
                  "type": "string",
                  "value": "done"
                },
                {
                  "type": "string",
                  "value": "go"
                },
                {
                  "type": "string",
                  "value": "next"
                },
                {
                  "type": "string",
                  "value": "previous"
                },
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "send"
                }
              ]
            },
            "optional": true,
            "description": "An enumerated attribute that defines what action label or icon to preset for the enter key on virtual keyboards. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint).",
            "default": null
          },
          "type": {
            "type": "property",
            "name": "type",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "url"
                },
                {
                  "type": "string",
                  "value": "tel"
                },
                {
                  "type": "string",
                  "value": "email"
                },
                {
                  "type": "string",
                  "value": "password"
                },
                {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "object",
                      "properties": {}
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
            "default": "'search'"
          },
          "onSubmit": {
            "type": "property",
            "name": "onSubmit",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the SearchField is submitted.",
            "default": null
          },
          "onClear": {
            "type": "property",
            "name": "onClear",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the clear button is pressed.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-activedescendant": {
            "type": "property",
            "name": "aria-activedescendant",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
            "default": null
          },
          "aria-autocomplete": {
            "type": "property",
            "name": "aria-autocomplete",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "inline"
                },
                {
                  "type": "string",
                  "value": "list"
                },
                {
                  "type": "string",
                  "value": "both"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
            "default": null
          },
          "aria-haspopup": {
            "type": "property",
            "name": "aria-haspopup",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "menu"
                },
                {
                  "type": "string",
                  "value": "listbox"
                },
                {
                  "type": "string",
                  "value": "tree"
                },
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "dialog"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "maxLength": {
            "type": "property",
            "name": "maxLength",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
            "default": null
          },
          "minLength": {
            "type": "property",
            "name": "minLength",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
            "default": null
          },
          "pattern": {
            "type": "property",
            "name": "pattern",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
            "default": null
          },
          "inputMode": {
            "type": "property",
            "name": "inputMode",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "tel"
                },
                {
                  "type": "string",
                  "value": "url"
                },
                {
                  "type": "string",
                  "value": "email"
                },
                {
                  "type": "string",
                  "value": "numeric"
                },
                {
                  "type": "string",
                  "value": "decimal"
                },
                {
                  "type": "string",
                  "value": "search"
                }
              ]
            },
            "optional": true,
            "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
            "default": null
          },
          "autoCorrect": {
            "type": "property",
            "name": "autoCorrect",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An attribute that takes as its value a space-separated string that describes what, if any, type of autocomplete functionality the input should provide. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#autocomplete).",
            "default": null
          },
          "spellCheck": {
            "type": "property",
            "name": "spellCheck",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An enumerated attribute that defines whether the element may be checked for spelling errors. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "onCopy": {
            "type": "property",
            "name": "onCopy",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
            "default": null
          },
          "onCut": {
            "type": "property",
            "name": "onCut",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
            "default": null
          },
          "onPaste": {
            "type": "property",
            "name": "onPaste",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
            "default": null
          },
          "onCompositionStart": {
            "type": "property",
            "name": "onCompositionStart",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
            "default": null
          },
          "onCompositionEnd": {
            "type": "property",
            "name": "onCompositionEnd",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
            "default": null
          },
          "onCompositionUpdate": {
            "type": "property",
            "name": "onCompositionUpdate",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
            "default": null
          },
          "onBeforeInput": {
            "type": "property",
            "name": "onBeforeInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
            "default": null
          },
          "onInput": {
            "type": "property",
            "name": "onInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A search field allows a user to enter and clear a search query."
    },
    "SearchFieldContext": {
      "type": "any"
    },
    "Select": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:Select",
      "name": "Select",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectProps",
        "name": "SelectProps",
        "properties": {
          "placeholder": {
            "type": "property",
            "name": "placeholder",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Temporary text that occupies the select when it is empty.",
            "default": "'Select an item' (localized)"
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input, used when submitting an HTML form.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "Whether single or multiple selection is enabled.",
            "default": "'single'"
          },
          "selectedKey": {
            "type": "property",
            "name": "selectedKey",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The currently selected key in the collection (controlled).",
            "access": "private",
            "default": null
          },
          "defaultSelectedKey": {
            "type": "property",
            "name": "defaultSelectedKey",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The initial selected key in the collection (uncontrolled).",
            "access": "private",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "access": "private",
            "default": null
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Sets the open state of the menu.",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Sets the default open state of the menu.",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Method that is called when the open state of the menu changes.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValidationType"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "object",
              "properties": null
            },
            "default": {
              "type": "object",
              "properties": {}
            }
          },
          {
            "type": "typeParameter",
            "name": "M",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectionMode"
            },
            "default": {
              "type": "string",
              "value": "single"
            }
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": {
            "type": "object",
            "properties": {}
          }
        },
        {
          "type": "typeParameter",
          "name": "M",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectionMode"
          },
          "default": {
            "type": "string",
            "value": "single"
          }
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A select displays a collapsible list of options and allows a user to select one of them."
    },
    "SelectValue": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValue",
      "name": "SelectValue",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueProps",
        "name": "SelectValueProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "object",
              "properties": null
            },
            "default": null
          }
        ],
        "extends": [
          {
            "type": "identifier",
            "name": "HTMLAttributes"
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLSpanElement"
          }
        ]
      },
      "description": "SelectValue renders the current value of a Select, or a placeholder if no value is selected.\nIt is usually placed within the button element."
    },
    "SelectContext": {
      "type": "any"
    },
    "SelectValueContext": {
      "type": "any"
    },
    "SelectStateContext": {
      "type": "any"
    },
    "Separator": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Separator.tsx:Separator",
      "name": "Separator",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Separator.tsx:SeparatorProps",
        "name": "SeparatorProps",
        "properties": {
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The orientation of the separator.",
            "default": "'horizontal'"
          },
          "elementType": {
            "type": "property",
            "name": "elementType",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The HTML element type that will be used to render the separator.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": null
    },
    "SeparatorContext": {
      "type": "any"
    },
    "Slider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:Slider",
      "name": "Slider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderProps",
        "name": "SliderProps",
        "properties": {
          "formatOptions": {
            "type": "property",
            "name": "formatOptions",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions"
            },
            "optional": true,
            "description": "The display format of the value label.",
            "default": null
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The orientation of the Slider.",
            "default": "'horizontal'"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the whole Slider is disabled.",
            "default": null
          },
          "onChangeEnd": {
            "type": "property",
            "name": "onChangeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Fired when the slider stops moving, due to being let go.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The slider's minimum value.",
            "default": "0"
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The slider's maximum value.",
            "default": "100"
          },
          "step": {
            "type": "property",
            "name": "step",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The slider's step value.",
            "default": "1"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": {
              "type": "union",
              "elements": [
                {
                  "type": "number"
                },
                {
                  "type": "array",
                  "elementType": {
                    "type": "number"
                  }
                }
              ]
            }
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "array",
                "elementType": {
                  "type": "number"
                }
              }
            ]
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A slider allows a user to select one or more values within a range."
    },
    "SliderOutput": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderOutput",
      "name": "SliderOutput",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderOutputProps",
        "name": "SliderOutputProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOutputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLOutputElement"
          }
        ]
      },
      "description": "A slider output displays the current value of a slider as text."
    },
    "SliderTrack": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrack",
      "name": "SliderTrack",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackProps",
        "name": "SliderTrackProps",
        "properties": {
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A slider track is a container for one or more slider thumbs."
    },
    "SliderThumb": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumb",
      "name": "SliderThumb",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbProps",
        "name": "SliderThumbProps",
        "properties": {
          "inputRef": {
            "type": "property",
            "name": "inputRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "A ref for the HTML input element.",
            "default": null
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The orientation of the Slider.",
            "access": "private",
            "default": "'horizontal'"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Thumb is disabled.",
            "default": null
          },
          "index": {
            "type": "property",
            "name": "index",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "Index of the thumb within the slider.",
            "default": "0"
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A slider thumb represents an individual value that the user can adjust within a slider track."
    },
    "SliderContext": {
      "type": "any"
    },
    "SliderOutputContext": {
      "type": "any"
    },
    "SliderTrackContext": {
      "type": "any"
    },
    "SliderStateContext": {
      "type": "any"
    },
    "Switch": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:Switch",
      "name": "Switch",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchProps",
        "name": "SwitchProps",
        "properties": {
          "inputRef": {
            "type": "property",
            "name": "inputRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "A ref for the HTML input element.",
            "default": null
          },
          "defaultSelected": {
            "type": "property",
            "name": "defaultSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Switch should be selected (uncontrolled).",
            "default": null
          },
          "isSelected": {
            "type": "property",
            "name": "isSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Switch should be selected (controlled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isSelected",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the Switch's selection state changes.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLLabelElement"
          }
        ]
      },
      "description": "A switch allows a user to turn a setting on or off."
    },
    "SwitchContext": {
      "type": "any"
    },
    "TableLoadMoreItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableLoadMoreItem",
      "name": "TableLoadMoreItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableLoadMoreItemProps",
        "name": "TableLoadMoreItemProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The load more spinner to render when loading additional items.",
            "default": null
          },
          "isLoading": {
            "type": "property",
            "name": "isLoading",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether or not the loading spinner should be rendered or not.",
            "default": null
          },
          "scrollOffset": {
            "type": "property",
            "name": "scrollOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The amount of offset from the bottom of your scrollable region that should trigger load more.\nUses a percentage value relative to the scroll body's client height. Load more is then triggered\nwhen your current scroll position's distance from the bottom of the currently loaded list of items is less than\nor equal to the provided value. (e.g. 1 = 100% of the scroll region's height).",
            "default": "1"
          },
          "onLoadMore": {
            "type": "property",
            "name": "onLoadMore",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableRowElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLTableRowElement"
          }
        ]
      },
      "description": null
    },
    "Table": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:Table",
      "name": "Table",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableProps",
        "name": "TableProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The elements that make up the table. Includes the TableHeader, TableBody, Columns, and Rows.",
            "default": null
          },
          "selectionBehavior": {
            "type": "property",
            "name": "selectionBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
            },
            "optional": true,
            "description": "How multiple selection should behave in the collection.",
            "default": "\"toggle\""
          },
          "disabledBehavior": {
            "type": "property",
            "name": "disabledBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
            },
            "optional": true,
            "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
            "default": "\"selection\""
          },
          "onRowAction": {
            "type": "property",
            "name": "onRowAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on the row.",
            "default": null
          },
          "dragAndDropHooks": {
            "type": "property",
            "name": "dragAndDropHooks",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
            },
            "optional": true,
            "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the Table.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "optional": true,
            "description": "A list of row keys to disable.",
            "default": null
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the table or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "shouldSelectOnPressUp": {
            "type": "property",
            "name": "shouldSelectOnPressUp",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether selection should occur on press up instead of press down.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "sortDescriptor": {
            "type": "property",
            "name": "sortDescriptor",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor"
            },
            "optional": true,
            "description": "The current sorted column and direction.",
            "default": null
          },
          "onSortChange": {
            "type": "property",
            "name": "onSortChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "descriptor",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the sorted column or direction changes.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "HTMLTableElement"
              },
              {
                "type": "identifier",
                "name": "HTMLDivElement"
              }
            ]
          }
        ]
      },
      "description": "A table displays data in rows and columns and enables a user to navigate its contents via directional navigation keys,\nand optionally supports row selection and sorting."
    },
    "Row": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:Row",
      "name": "Row",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:RowProps",
        "name": "RowProps",
        "properties": {
          "columns": {
            "type": "property",
            "name": "columns",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                }
              ]
            },
            "optional": true,
            "description": "A list of columns used when dynamically rendering cells.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The cells within the row. Supports static items or a function for dynamic rendering.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "object",
              "properties": null
            },
            "optional": true,
            "description": "The object value that this row represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the cell cache when using dynamic collections.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the row's contents, used for features like typeahead.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the row is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on the row. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the row.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:RowRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:RowRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "HTMLTableRowElement"
              },
              {
                "type": "identifier",
                "name": "HTMLDivElement"
              }
            ]
          }
        ]
      },
      "description": "A row within a `<Table>`."
    },
    "Cell": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:Cell",
      "name": "Cell",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellProps",
        "name": "CellProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the cell.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the cell's contents, used for features like typeahead.",
            "default": null
          },
          "colSpan": {
            "type": "property",
            "name": "colSpan",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "Indicates how many columns the data cell spans.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "HTMLTableCellElement"
              },
              {
                "type": "identifier",
                "name": "HTMLDivElement"
              }
            ]
          }
        ]
      },
      "description": "A cell within a table row."
    },
    "Column": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:Column",
      "name": "Column",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnProps",
        "name": "ColumnProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the column.",
            "default": null
          },
          "allowsSorting": {
            "type": "property",
            "name": "allowsSorting",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the column allows sorting.",
            "default": null
          },
          "isRowHeader": {
            "type": "property",
            "name": "isRowHeader",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether a column is a [row header](https://www.w3.org/TR/wai-aria-1.1/#rowheader) and should be announced by assistive technology during row navigation.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the column's contents, used for accessibility announcements.",
            "default": null
          },
          "width": {
            "type": "property",
            "name": "width",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
            "default": null
          },
          "defaultWidth": {
            "type": "property",
            "name": "defaultWidth",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
            "default": null
          },
          "minWidth": {
            "type": "property",
            "name": "minWidth",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
            "default": null
          },
          "maxWidth": {
            "type": "property",
            "name": "maxWidth",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "HTMLTableCellElement"
              },
              {
                "type": "identifier",
                "name": "HTMLDivElement"
              }
            ]
          }
        ]
      },
      "description": "A column within a `<Table>`."
    },
    "ColumnResizer": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizer",
      "name": "ColumnResizer",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerProps",
        "name": "ColumnResizerProps",
        "properties": {
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A custom accessibility label for the resizer.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "TableHeader": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableHeader",
      "name": "TableHeader",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableHeaderProps",
        "name": "TableHeaderProps",
        "properties": {
          "columns": {
            "type": "property",
            "name": "columns",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                }
              ]
            },
            "optional": true,
            "description": "A list of table columns.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "A list of `Column(s)` or a function. If the latter, a list of columns must be provided using the `columns` prop.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the column cache when using dynamic collections.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableHeaderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableHeaderRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "HTMLTableSectionElement"
              },
              {
                "type": "identifier",
                "name": "HTMLDivElement"
              }
            ]
          }
        ]
      },
      "description": "A header within a `<Table>`, containing the table columns."
    },
    "TableBody": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBody",
      "name": "TableBody",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyProps",
        "name": "TableBodyProps",
        "properties": {
          "renderEmptyState": {
            "type": "property",
            "name": "renderEmptyState",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "props",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides content to display when there are no rows in the table.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "HTMLTableSectionElement"
              },
              {
                "type": "identifier",
                "name": "HTMLDivElement"
              }
            ]
          }
        ]
      },
      "description": "The body of a `<Table>`, containing the table rows."
    },
    "TableContext": {
      "type": "any"
    },
    "ResizableTableContainer": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ResizableTableContainer",
      "name": "ResizableTableContainer",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ResizableTableContainerProps",
        "name": "ResizableTableContainerProps",
        "properties": {
          "onResizeStart": {
            "type": "property",
            "name": "onResizeStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "widths",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Map"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      },
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user starts a column resize.",
            "default": null
          },
          "onResize": {
            "type": "property",
            "name": "onResize",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "widths",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Map"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      },
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs a column resize.\nCan be used with the width property on columns to put the column widths into\na controlled state.",
            "default": null
          },
          "onResizeEnd": {
            "type": "property",
            "name": "onResizeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "widths",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Map"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      },
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called after a user performs a column resize.\nCan be used to store the widths of columns for another future session.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The children of the component.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "useTableOptions": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:useTableOptions",
      "name": "useTableOptions",
      "parameters": [],
      "return": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableOptionsContextValue"
      },
      "typeParameters": [],
      "description": "Returns options from the parent `<Table>` component."
    },
    "TableStateContext": {
      "type": "any"
    },
    "TableColumnResizeStateContext": {
      "type": "any"
    },
    "TableLayout": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TableLayout.ts:TableLayout",
      "name": "TableLayout",
      "properties": {
        "useLayoutOptions": {
          "type": "method",
          "name": "useLayoutOptions",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/TableLayout.ts:TableLayoutProps"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "lastCollection": {
          "type": "property",
          "name": "lastCollection",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:TableCollection"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "columnWidths": {
          "type": "property",
          "name": "columnWidths",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "number"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "stickyColumnIndices": {
          "type": "property",
          "name": "stickyColumnIndices",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "number"
            }
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "lastPersistedKeys": {
          "type": "property",
          "name": "lastPersistedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Set"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "persistedIndices": {
          "type": "property",
          "name": "persistedIndices",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "array",
                "elementType": {
                  "type": "number"
                }
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:TableCollection"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "access": "protected",
          "default": null
        },
        "columnsChanged": {
          "type": "method",
          "name": "columnsChanged",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newCollection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:TableCollection"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldCollection",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:TableCollection"
                      },
                      "typeParameters": [
                        {
                          "type": "identifier",
                          "name": "T"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "shouldInvalidateLayoutOptions": {
          "type": "method",
          "name": "shouldInvalidateLayoutOptions",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/TableLayout.ts:TableLayoutProps"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/TableLayout.ts:TableLayoutProps"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "update": {
          "type": "method",
          "name": "update",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "invalidationContext",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/types.ts:InvalidationContext"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/TableLayout.ts:TableLayoutProps"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "buildCollection": {
          "type": "method",
          "name": "buildCollection",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
              }
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildTableHeader": {
          "type": "method",
          "name": "buildTableHeader",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildHeaderRow": {
          "type": "method",
          "name": "buildHeaderRow",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "headerRow",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "setChildHeights": {
          "type": "method",
          "name": "setChildHeights",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "children",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
                  }
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "height",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getRenderedColumnWidth": {
          "type": "method",
          "name": "getRenderedColumnWidth",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getEstimatedHeight": {
          "type": "method",
          "name": "getEstimatedHeight",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "width",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "height",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "number"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "estimatedHeight",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "number"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getEstimatedRowHeight": {
          "type": "method",
          "name": "getEstimatedRowHeight",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildColumn": {
          "type": "method",
          "name": "buildColumn",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "isStickyColumn": {
          "type": "method",
          "name": "isStickyColumn",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildBody": {
          "type": "method",
          "name": "buildBody",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildNode": {
          "type": "method",
          "name": "buildNode",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildRow": {
          "type": "method",
          "name": "buildRow",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildCell": {
          "type": "method",
          "name": "buildCell",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "getVisibleLayoutInfos": {
          "type": "method",
          "name": "getVisibleLayoutInfos",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
              }
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "addVisibleLayoutInfos": {
          "type": "method",
          "name": "addVisibleLayoutInfos",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "res",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                  }
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "binarySearch": {
          "type": "method",
          "name": "binarySearch",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "items",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
                  }
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "point",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "axis",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "x"
                    },
                    {
                      "type": "string",
                      "value": "y"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "buildPersistedIndices": {
          "type": "method",
          "name": "buildPersistedIndices",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getDropTargetFromPoint": {
          "type": "method",
          "name": "getDropTargetFromPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "isValidDropTarget",
                "value": {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "target",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getDropTargetLayoutInfo": {
          "type": "method",
          "name": "getDropTargetLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "rowHeight": {
          "type": "property",
          "name": "rowHeight",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "estimatedRowHeight": {
          "type": "property",
          "name": "estimatedRowHeight",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "headingHeight": {
          "type": "property",
          "name": "headingHeight",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "estimatedHeadingHeight": {
          "type": "property",
          "name": "estimatedHeadingHeight",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "loaderHeight": {
          "type": "property",
          "name": "loaderHeight",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "gap": {
          "type": "property",
          "name": "gap",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "padding": {
          "type": "property",
          "name": "padding",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "layoutNodes": {
          "type": "property",
          "name": "layoutNodes",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "contentSize": {
          "type": "property",
          "name": "contentSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "rootNodes": {
          "type": "property",
          "name": "rootNodes",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            }
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "invalidateEverything": {
          "type": "property",
          "name": "invalidateEverything",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "validRect": {
          "type": "property",
          "name": "validRect",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
          },
          "optional": false,
          "description": "The rectangle containing currently valid layout infos.",
          "access": "protected",
          "default": null
        },
        "requestedRect": {
          "type": "property",
          "name": "requestedRect",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
          },
          "optional": false,
          "description": "The rectangle of requested layout infos so far.",
          "access": "protected",
          "default": null
        },
        "getLayoutInfo": {
          "type": "method",
          "name": "getLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "layoutIfNeeded": {
          "type": "method",
          "name": "layoutIfNeeded",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "ensureLayoutInfo": {
          "type": "method",
          "name": "ensureLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "isVisible": {
          "type": "method",
          "name": "isVisible",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "shouldInvalidateEverything": {
          "type": "method",
          "name": "shouldInvalidateEverything",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "invalidationContext",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/types.ts:InvalidationContext"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "isValid": {
          "type": "method",
          "name": "isValid",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildChild": {
          "type": "method",
          "name": "buildChild",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "parentKey",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildLoader": {
          "type": "method",
          "name": "buildLoader",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildSection": {
          "type": "method",
          "name": "buildSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildSectionHeader": {
          "type": "method",
          "name": "buildSectionHeader",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildItem": {
          "type": "method",
          "name": "buildItem",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "updateItemSize": {
          "type": "method",
          "name": "updateItemSize",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "size",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "updateLayoutNode": {
          "type": "method",
          "name": "updateLayoutNode",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldLayoutInfo",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "newLayoutInfo",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getContentSize": {
          "type": "method",
          "name": "getContentSize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "virtualizer": {
          "type": "property",
          "name": "virtualizer",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:Virtualizer"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  },
                  {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The Virtualizer the layout is currently attached to.",
          "default": null
        },
        "shouldInvalidate": {
          "type": "method",
          "name": "shouldInvalidate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the layout should invalidate in response to\nvisible rectangle changes. By default, it only invalidates\nwhen the virtualizer's size changes. Return true always\nto make the layout invalidate while scrolling (e.g. sticky headers).",
          "default": null,
          "static": false
        },
        "getItemRect": {
          "type": "method",
          "name": "getItemRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getVisibleRect": {
          "type": "method",
          "name": "getVisibleRect",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "O",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/TableLayout.ts:TableLayoutProps"
          },
          "default": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/TableLayout.ts:TableLayoutProps"
          }
        }
      ],
      "extends": []
    },
    "Tabs": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:Tabs",
      "name": "Tabs",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsProps",
        "name": "TabsProps",
        "properties": {
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the TabList is disabled.\nShows that a selection exists, but is not available in that circumstance.",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectedKey": {
            "type": "property",
            "name": "selectedKey",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The currently selected key in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKey": {
            "type": "property",
            "name": "defaultSelectedKey",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Key"
            },
            "optional": true,
            "description": "The initial selected key in the collection (uncontrolled).",
            "default": null
          },
          "keyboardActivation": {
            "type": "property",
            "name": "keyboardActivation",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "automatic"
                },
                {
                  "type": "string",
                  "value": "manual"
                }
              ]
            },
            "optional": true,
            "description": "Whether tabs are activated automatically on focus or manually.",
            "default": "'automatic'"
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The orientation of the tabs.",
            "default": "'horizontal'"
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Tabs organize content into multiple sections and allow users to navigate between them."
    },
    "TabList": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabList",
      "name": "TabList",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabListProps",
        "name": "TabListProps",
        "properties": {
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabListRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabListRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A TabList is used within Tabs to group tabs that a user can switch between.\nThe ids of the items within the <TabList> must match up with a corresponding item inside the <TabPanels>."
    },
    "TabPanel": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanel",
      "name": "TabPanel",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelProps",
        "name": "TabPanelProps",
        "properties": {
          "shouldForceMount": {
            "type": "property",
            "name": "shouldForceMount",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to mount the tab panel in the DOM even when it is not currently selected.\nInactive tab panels are inert and cannot be interacted with. They must be styled appropriately so this is clear to the user visually.",
            "default": "false"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the tab.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A TabPanel provides the content for a tab."
    },
    "Tab": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:Tab",
      "name": "Tab",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabProps",
        "name": "TabProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the tab.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tab is disabled.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A Tab provides a title for an individual item within a TabList."
    },
    "TabsContext": {
      "type": "any"
    },
    "TabListStateContext": {
      "type": "any"
    },
    "TagGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagGroup",
      "name": "TagGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagGroupProps",
        "name": "TagGroupProps",
        "properties": {
          "selectionBehavior": {
            "type": "property",
            "name": "selectionBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
            },
            "optional": true,
            "description": "How multiple selection should behave in the collection.",
            "default": null
          },
          "shouldSelectOnPressUp": {
            "type": "property",
            "name": "shouldSelectOnPressUp",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether selection should occur on press up instead of press down.",
            "default": null
          },
          "onRemove": {
            "type": "property",
            "name": "onRemove",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Set"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user deletes a tag.",
            "default": null
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the TagGroup or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The children of the component.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A tag group is a focusable list of labels, categories, keywords, filters, or other items, with support for keyboard navigation, selection, and removal."
    },
    "TagGroupContext": {
      "type": "any"
    },
    "TagList": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagList",
      "name": "TagList",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListProps",
        "name": "TagListProps",
        "properties": {
          "renderEmptyState": {
            "type": "property",
            "name": "renderEmptyState",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "props",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListRenderProps"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides content to display when there are no items in the tag list.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A tag list is a container for tags within a TagGroup."
    },
    "TagListContext": {
      "type": "any"
    },
    "Tag": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:Tag",
      "name": "Tag",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagProps",
        "name": "TagProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "A unique id for the tag.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the tags's contents, used for accessibility.\nRequired if children is not a plain text string.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tag is disabled.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A Tag is an individual item within a TagList."
    },
    "Text": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Text.tsx:Text",
      "name": "Text",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Text.tsx:TextProps",
        "name": "TextProps",
        "properties": {
          "elementType": {
            "type": "property",
            "name": "elementType",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "default": null
          }
        },
        "typeParameters": [],
        "extends": [
          {
            "type": "identifier",
            "name": "HTMLAttributes"
          }
        ]
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": null
    },
    "TextContext": {
      "type": "any"
    },
    "TextArea": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextArea.tsx:TextArea",
      "name": "TextArea",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextArea.tsx:TextAreaProps",
        "name": "TextAreaProps",
        "properties": {
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": [
          {
            "type": "identifier",
            "name": "TextareaHTMLAttributes"
          }
        ]
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLTextAreaElement"
          }
        ]
      },
      "description": "A textarea allows a user to input mult-line text."
    },
    "TextAreaContext": {
      "type": "any"
    },
    "TextField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextField",
      "name": "TextField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldProps",
        "name": "TextFieldProps",
        "properties": {
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the value is invalid.",
            "default": null
          },
          "aria-activedescendant": {
            "type": "property",
            "name": "aria-activedescendant",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
            "default": null
          },
          "aria-autocomplete": {
            "type": "property",
            "name": "aria-autocomplete",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "inline"
                },
                {
                  "type": "string",
                  "value": "list"
                },
                {
                  "type": "string",
                  "value": "both"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
            "default": null
          },
          "aria-haspopup": {
            "type": "property",
            "name": "aria-haspopup",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "menu"
                },
                {
                  "type": "string",
                  "value": "listbox"
                },
                {
                  "type": "string",
                  "value": "tree"
                },
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "dialog"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "enterKeyHint": {
            "type": "property",
            "name": "enterKeyHint",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "enter"
                },
                {
                  "type": "string",
                  "value": "done"
                },
                {
                  "type": "string",
                  "value": "go"
                },
                {
                  "type": "string",
                  "value": "next"
                },
                {
                  "type": "string",
                  "value": "previous"
                },
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "send"
                }
              ]
            },
            "optional": true,
            "description": "An enumerated attribute that defines what action label or icon to preset for the enter key on virtual keyboards. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "maxLength": {
            "type": "property",
            "name": "maxLength",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
            "default": null
          },
          "minLength": {
            "type": "property",
            "name": "minLength",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
            "default": null
          },
          "pattern": {
            "type": "property",
            "name": "pattern",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
            "default": null
          },
          "type": {
            "type": "property",
            "name": "type",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "url"
                },
                {
                  "type": "string",
                  "value": "tel"
                },
                {
                  "type": "string",
                  "value": "email"
                },
                {
                  "type": "string",
                  "value": "password"
                },
                {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "object",
                      "properties": {}
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
            "default": "'text'"
          },
          "inputMode": {
            "type": "property",
            "name": "inputMode",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "tel"
                },
                {
                  "type": "string",
                  "value": "url"
                },
                {
                  "type": "string",
                  "value": "email"
                },
                {
                  "type": "string",
                  "value": "numeric"
                },
                {
                  "type": "string",
                  "value": "decimal"
                },
                {
                  "type": "string",
                  "value": "search"
                }
              ]
            },
            "optional": true,
            "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
            "default": null
          },
          "autoCorrect": {
            "type": "property",
            "name": "autoCorrect",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An attribute that takes as its value a space-separated string that describes what, if any, type of autocomplete functionality the input should provide. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#autocomplete).",
            "default": null
          },
          "spellCheck": {
            "type": "property",
            "name": "spellCheck",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An enumerated attribute that defines whether the element may be checked for spelling errors. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "onCopy": {
            "type": "property",
            "name": "onCopy",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
            "default": null
          },
          "onCut": {
            "type": "property",
            "name": "onCut",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
            "default": null
          },
          "onPaste": {
            "type": "property",
            "name": "onPaste",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
            "default": null
          },
          "onCompositionStart": {
            "type": "property",
            "name": "onCompositionStart",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
            "default": null
          },
          "onCompositionEnd": {
            "type": "property",
            "name": "onCompositionEnd",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
            "default": null
          },
          "onCompositionUpdate": {
            "type": "property",
            "name": "onCompositionUpdate",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
            "default": null
          },
          "onBeforeInput": {
            "type": "property",
            "name": "onBeforeInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
            "default": null
          },
          "onInput": {
            "type": "property",
            "name": "onInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A text field allows a user to enter a plain text value with a keyboard."
    },
    "TextFieldContext": {
      "type": "any"
    },
    "UNSTABLE_Toast": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:Toast",
      "name": "UNSTABLE_Toast",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastProps",
        "name": "ToastProps",
        "properties": {
          "toast": {
            "type": "property",
            "name": "toast",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": false,
            "description": "The toast object.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A Toast displays a brief, temporary notification of actions, errors, or other events in an application."
    },
    "UNSTABLE_ToastList": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastList",
      "name": "UNSTABLE_ToastList",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastListProps",
        "name": "ToastListProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "renderProps",
                  "value": {
                    "type": "object",
                    "properties": {
                      "toast": {
                        "type": "property",
                        "name": "toast",
                        "indexType": null,
                        "value": {
                          "type": "application",
                          "base": {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
                          },
                          "typeParameters": [
                            {
                              "type": "identifier",
                              "name": "T"
                            }
                          ]
                        },
                        "optional": false,
                        "default": null
                      }
                    }
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactElement"
              },
              "typeParameters": []
            },
            "optional": false,
            "description": "A function to render each toast.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for the toast region.",
            "default": "\"Notifications\""
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLOListElement"
          }
        ]
      },
      "description": null
    },
    "UNSTABLE_ToastRegion": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegion",
      "name": "UNSTABLE_ToastRegion",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionProps",
        "name": "ToastRegionProps",
        "properties": {
          "queue": {
            "type": "property",
            "name": "queue",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastQueue"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": false,
            "description": "The queue of toasts to display.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "renderProps",
                      "value": {
                        "type": "object",
                        "properties": {
                          "toast": {
                            "type": "property",
                            "name": "toast",
                            "indexType": null,
                            "value": {
                              "type": "application",
                              "base": {
                                "type": "link",
                                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
                              },
                              "typeParameters": [
                                {
                                  "type": "identifier",
                                  "name": "T"
                                }
                              ]
                            },
                            "optional": false,
                            "default": null
                          }
                        }
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": false,
            "description": "A function to render each toast, or children containing a `<ToastList>`.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for the toast region.",
            "default": "\"Notifications\""
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ToastRegion displays one or more toast notifications."
    },
    "UNSTABLE_ToastContent": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastContent",
      "name": "UNSTABLE_ToastContent",
      "props": {
        "type": "identifier",
        "name": "HTMLAttributes"
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "ToastContent wraps the main content of a toast notification."
    },
    "UNSTABLE_ToastStateContext": {
      "type": "any",
      "name": "UNSTABLE_ToastStateContext"
    },
    "ToggleButton": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButton",
      "name": "ToggleButton",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonProps",
        "name": "ToggleButtonProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "When used in a ToggleButtonGroup, an identifier for the item in `selectedKeys`. When used standalone, a DOM id.",
            "default": null
          },
          "isSelected": {
            "type": "property",
            "name": "isSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should be selected (controlled).",
            "default": null
          },
          "defaultSelected": {
            "type": "property",
            "name": "defaultSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should be selected (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isSelected",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's selection state changes.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button is disabled.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "aria-disabled": {
            "type": "property",
            "name": "aria-disabled",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether the element is disabled to users of assistive technology.",
            "default": null
          },
          "aria-expanded": {
            "type": "property",
            "name": "aria-expanded",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
            "default": null
          },
          "aria-haspopup": {
            "type": "property",
            "name": "aria-haspopup",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "menu"
                },
                {
                  "type": "string",
                  "value": "listbox"
                },
                {
                  "type": "string",
                  "value": "tree"
                },
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "dialog"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "aria-pressed": {
            "type": "property",
            "name": "aria-pressed",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "mixed"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the current \"pressed\" state of toggle buttons.",
            "default": null
          },
          "preventFocusOnPress": {
            "type": "property",
            "name": "preventFocusOnPress",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLButtonElement"
          }
        ]
      },
      "description": "A toggle button allows a user to toggle a selection on or off, for example switching between two states or modes."
    },
    "ToggleButtonContext": {
      "type": "any"
    },
    "ToggleButtonGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroup",
      "name": "ToggleButtonGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupProps",
        "name": "ToggleButtonGroupProps",
        "properties": {
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The orientation of the the toggle button group.",
            "default": "'horizontal'"
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "single"
                },
                {
                  "type": "string",
                  "value": "multiple"
                }
              ]
            },
            "optional": true,
            "description": "Whether single or multiple selection is enabled.",
            "default": "'single'"
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Set"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether all items are disabled.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A toggle button group allows a user to toggle multiple options, with single or multiple selection."
    },
    "ToggleButtonGroupContext": {
      "type": "any"
    },
    "ToggleGroupStateContext": {
      "type": "any"
    },
    "Toolbar": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:Toolbar",
      "name": "Toolbar",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarProps",
        "name": "ToolbarProps",
        "properties": {
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The orientation of the entire toolbar.",
            "default": "'horizontal'"
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A toolbar is a container for a set of interactive controls, such as buttons, dropdown menus, or checkboxes,\nwith arrow key navigation."
    },
    "ToolbarContext": {
      "type": "any"
    },
    "TooltipTrigger": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipTrigger",
      "name": "TooltipTrigger",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipTriggerComponentProps",
        "name": "TooltipTriggerComponentProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tooltip should be disabled, independent from the trigger.",
            "default": null
          },
          "delay": {
            "type": "property",
            "name": "delay",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The delay time for the tooltip to show up. [See guidelines](https://spectrum.adobe.com/page/tooltip/#Immediate-or-delayed-appearance).",
            "default": "1500"
          },
          "closeDelay": {
            "type": "property",
            "name": "closeDelay",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The delay time for the tooltip to close. [See guidelines](https://spectrum.adobe.com/page/tooltip/#Warmup-and-cooldown).",
            "default": "500"
          },
          "trigger": {
            "type": "property",
            "name": "trigger",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "hover"
                },
                {
                  "type": "string",
                  "value": "focus"
                }
              ]
            },
            "optional": true,
            "description": "By default, opens for both focus and hover. Can be made to open only for focus.",
            "default": "'hover'"
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing\nthe Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip\nrelative to the trigger."
    },
    "Tooltip": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:Tooltip",
      "name": "Tooltip",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipProps",
        "name": "TooltipProps",
        "properties": {
          "triggerRef": {
            "type": "property",
            "name": "triggerRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Element"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The ref for the element which the tooltip positions itself with respect to.\n\nWhen used within a TooltipTrigger this is set automatically. It is only required when used standalone.",
            "default": null
          },
          "isEntering": {
            "type": "property",
            "name": "isEntering",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tooltip is currently performing an entry animation.",
            "default": null
          },
          "isExiting": {
            "type": "property",
            "name": "isExiting",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tooltip is currently performing an exit animation.",
            "default": null
          },
          "UNSTABLE_portalContainer": {
            "type": "property",
            "name": "UNSTABLE_portalContainer",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Element"
            },
            "optional": true,
            "description": "The container element in which the overlay portal will be placed. This may have unknown behavior depending on where it is portalled to.",
            "access": "private",
            "default": "document.body"
          },
          "placement": {
            "type": "property",
            "name": "placement",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement"
            },
            "optional": true,
            "description": "The placement of the tooltip with respect to the trigger.",
            "default": "'top'"
          },
          "containerPadding": {
            "type": "property",
            "name": "containerPadding",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
            "default": "12"
          },
          "offset": {
            "type": "property",
            "name": "offset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
            "default": "0"
          },
          "crossOffset": {
            "type": "property",
            "name": "crossOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
            "default": "0"
          },
          "shouldFlip": {
            "type": "property",
            "name": "shouldFlip",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
            "default": "true"
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element is rendered.",
            "default": null
          },
          "arrowBoundaryOffset": {
            "type": "property",
            "name": "arrowBoundaryOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The minimum distance the arrow's edge should be from the edge of the overlay element.",
            "default": "0"
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A tooltip displays a description of an element on hover or focus."
    },
    "TooltipTriggerStateContext": {
      "type": "any"
    },
    "TooltipContext": {
      "type": "any"
    },
    "TreeLoadMoreItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItem",
      "name": "TreeLoadMoreItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemProps",
        "name": "TreeLoadMoreItemProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The load more spinner to render when loading additional items.",
            "default": null
          },
          "isLoading": {
            "type": "property",
            "name": "isLoading",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether or not the loading spinner should be rendered or not.",
            "default": null
          },
          "scrollOffset": {
            "type": "property",
            "name": "scrollOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The amount of offset from the bottom of your scrollable region that should trigger load more.\nUses a percentage value relative to the scroll body's client height. Load more is then triggered\nwhen your current scroll position's distance from the bottom of the currently loaded list of items is less than\nor equal to the provided value. (e.g. 1 = 100% of the scroll region's height).",
            "default": "1"
          },
          "onLoadMore": {
            "type": "property",
            "name": "onLoadMore",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "Tree": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:Tree",
      "name": "Tree",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeProps",
        "name": "TreeProps",
        "properties": {
          "selectionBehavior": {
            "type": "property",
            "name": "selectionBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
            },
            "optional": true,
            "description": "How multiple selection should behave in the tree.",
            "default": "\"toggle\""
          },
          "renderEmptyState": {
            "type": "property",
            "name": "renderEmptyState",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "props",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeEmptyStateRenderProps"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides content to display when there are no items in the list.",
            "default": null
          },
          "disabledBehavior": {
            "type": "property",
            "name": "disabledBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
            },
            "optional": true,
            "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
            "default": "'all'"
          },
          "dragAndDropHooks": {
            "type": "property",
            "name": "dragAndDropHooks",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "NoInfer"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the Tree.",
            "default": null
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the grid list or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                }
              ]
            },
            "optional": true,
            "description": "Whether to auto focus the gridlist or an option.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "shouldSelectOnPressUp": {
            "type": "property",
            "name": "shouldSelectOnPressUp",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether selection should occur on press up instead of press down.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "expandedKeys": {
            "type": "property",
            "name": "expandedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The currently expanded keys in the collection (controlled).",
            "default": null
          },
          "defaultExpandedKeys": {
            "type": "property",
            "name": "defaultExpandedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The initial expanded keys in the collection (uncontrolled).",
            "default": null
          },
          "onExpandedChange": {
            "type": "property",
            "name": "onExpandedChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Set"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Key"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when items are expanded or collapsed.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A tree provides users with a way to navigate nested hierarchical information, with support for keyboard navigation\nand selection."
    },
    "TreeItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItem",
      "name": "TreeItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemProps",
        "name": "TreeItemProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the tree row.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "object",
              "properties": null
            },
            "optional": true,
            "description": "The object value that this tree item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": false,
            "description": "A string representation of the tree item's contents, used for features like typeahead.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for this tree item.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content of the tree item along with any nested children. Supports static nested tree items or use of a Collection to dynamically render nested tree items.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on this tree item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          },
          "hasChildItems": {
            "type": "property",
            "name": "hasChildItems",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether this item has children, even if not loaded yet.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": {
              "type": "object",
              "properties": null
            }
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A TreeItem represents an individual item in a Tree."
    },
    "TreeContext": {
      "type": "any"
    },
    "TreeItemContent": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemContent",
      "name": "TreeItemContent",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemContentProps",
        "name": "TreeItemContentProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "TreeStateContext": {
      "type": "any"
    },
    "useDrag": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrag.ts:useDrag",
      "name": "useDrag",
      "parameters": [
        {
          "type": "parameter",
          "name": "options",
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrag.ts:DragOptions"
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrag.ts:DragResult"
      },
      "typeParameters": [],
      "description": "Handles drag interactions for an element, with support for traditional mouse and touch\nbased drag and drop, in addition to full parity for keyboard and screen reader users."
    },
    "useDrop": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrop.ts:useDrop",
      "name": "useDrop",
      "parameters": [
        {
          "type": "parameter",
          "name": "options",
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrop.ts:DropOptions"
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrop.ts:DropResult"
      },
      "typeParameters": [],
      "description": "Handles drop interactions for an element, with support for traditional mouse and touch\nbased drag and drop, in addition to full parity for keyboard and screen reader users."
    },
    "useDragAndDrop": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:useDragAndDrop",
      "name": "useDragAndDrop",
      "parameters": [
        {
          "type": "parameter",
          "name": "options",
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropOptions"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDrop"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "T"
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "description": "Provides the hooks required to enable drag and drop behavior for a drag and drop compatible collection component."
    },
    "DropIndicator": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicator",
      "name": "DropIndicator",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorProps",
        "name": "DropIndicatorProps",
        "properties": {
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
            },
            "optional": false,
            "description": "The drop target that the drop indicator represents.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLElement"
          }
        ]
      },
      "description": "A DropIndicator is rendered between items in a collection to indicate where dropped data will be inserted."
    },
    "DropIndicatorContext": {
      "type": "any"
    },
    "DragAndDropContext": {
      "type": "any"
    },
    "Virtualizer": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:Virtualizer",
      "name": "Virtualizer",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:VirtualizerProps",
        "name": "VirtualizerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The child collection to virtualize (e.g. ListBox, GridList, or Table).",
            "default": null
          },
          "layout": {
            "type": "property",
            "name": "layout",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:LayoutClass"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "O"
                    }
                  ]
                },
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:ILayout"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "O"
                    }
                  ]
                }
              ]
            },
            "optional": false,
            "description": "The layout object that determines the position and size of the visible elements.",
            "default": null
          },
          "layoutOptions": {
            "type": "property",
            "name": "layoutOptions",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "O"
            },
            "optional": true,
            "description": "Options for the layout.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "O",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "O",
          "constraint": null,
          "default": null
        }
      ],
      "ref": null,
      "description": "A Virtualizer renders a scrollable collection of data using customizable layouts.\nIt supports very large collections by only rendering visible items to the DOM, reusing\nthem as the user scrolls."
    },
    "DIRECTORY_DRAG_TYPE": {
      "type": "any"
    },
    "isDirectoryDropItem": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/utils.ts:isDirectoryDropItem",
      "name": "isDirectoryDropItem",
      "parameters": [
        {
          "type": "parameter",
          "name": "dropItem",
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "any",
        "description": null
      },
      "typeParameters": [],
      "description": "Returns whether a drop item is a directory."
    },
    "isFileDropItem": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/utils.ts:isFileDropItem",
      "name": "isFileDropItem",
      "parameters": [
        {
          "type": "parameter",
          "name": "dropItem",
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "any",
        "description": null
      },
      "typeParameters": [],
      "description": "Returns whether a drop item is a file."
    },
    "isTextDropItem": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/utils.ts:isTextDropItem",
      "name": "isTextDropItem",
      "parameters": [
        {
          "type": "parameter",
          "name": "dropItem",
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "any",
        "description": null
      },
      "typeParameters": [],
      "description": "Returns whether a drop item contains text data."
    },
    "SSRProvider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/ssr/src/SSRProvider.tsx:SSRProvider",
      "name": "SSRProvider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/ssr/src/SSRProvider.tsx:SSRProviderProps",
        "name": "SSRProviderProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "Your application here.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "When using SSR with React Aria in React 16 or 17, applications must be wrapped in an SSRProvider.\nThis ensures that auto generated ids are consistent between the client and server."
    },
    "RouterProvider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/utils/src/openLink.tsx:RouterProvider",
      "name": "RouterProvider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/utils/src/openLink.tsx:RouterProviderProps",
        "name": "RouterProviderProps",
        "properties": {
          "navigate": {
            "type": "property",
            "name": "navigate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "path",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
                  },
                  "rest": false,
                  "description": null
                },
                {
                  "type": "parameter",
                  "name": "routerOptions",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
                      },
                      {
                        "type": "undefined"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": false,
            "default": null
          },
          "useHref": {
            "type": "property",
            "name": "useHref",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "href",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "string",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "A RouterProvider accepts a `navigate` function from a framework or client side router,\nand provides it to all nested React Aria links to enable client side navigation."
    },
    "I18nProvider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/i18n/src/context.tsx:I18nProvider",
      "name": "I18nProvider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/i18n/src/context.tsx:I18nProviderProps",
        "name": "I18nProviderProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "Contents that should have the locale applied.",
            "default": null
          },
          "locale": {
            "type": "property",
            "name": "locale",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The locale to apply to the children.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "Provides the locale for the application to all child components."
    },
    "useLocale": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/i18n/src/context.tsx:useLocale",
      "name": "useLocale",
      "parameters": [],
      "return": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/i18n/src/useDefaultLocale.ts:Locale"
      },
      "typeParameters": [],
      "description": "Returns the current locale and layout direction."
    },
    "useFilter": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/i18n/src/useFilter.ts:useFilter",
      "name": "useFilter",
      "parameters": [
        {
          "type": "parameter",
          "name": "options",
          "value": {
            "type": "identifier",
            "name": "Intl.CollatorOptions"
          },
          "optional": true,
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/i18n/src/useFilter.ts:Filter"
      },
      "typeParameters": [],
      "description": "Provides localized string search functionality that is useful for filtering or matching items\nin a list. Options can be provided to adjust the sensitivity to case, diacritics, and other parameters."
    },
    "Pressable": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/interactions/src/Pressable.tsx:Pressable",
      "name": "Pressable",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/interactions/src/Pressable.tsx:PressableProps",
        "name": "PressableProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactElement"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:DOMAttributes"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": false,
            "default": null
          },
          "isPressed": {
            "type": "property",
            "name": "isPressed",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the target is in a controlled press state (e.g. an overlay it triggers is open).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the press events should be disabled.",
            "default": null
          },
          "preventFocusOnPress": {
            "type": "property",
            "name": "preventFocusOnPress",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the target should not receive focus on press.",
            "default": null
          },
          "shouldCancelOnPointerExit": {
            "type": "property",
            "name": "shouldCancelOnPointerExit",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether press events should be canceled when the pointer leaves the target while pressed.\nBy default, this is `false`, which means if the pointer returns back over the target while\nstill pressed, onPressStart will be fired again. If set to `true`, the press is canceled\nwhen the pointer leaves the target and onPressStart will not be fired if the pointer returns.",
            "default": null
          },
          "allowTextSelectionOnPress": {
            "type": "property",
            "name": "allowTextSelectionOnPress",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether text selection should be enabled on the pressable element.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "MouseEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
          }
        ]
      },
      "description": null
    },
    "Focusable": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/interactions/src/useFocusable.tsx:Focusable",
      "name": "Focusable",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/interactions/src/useFocusable.tsx:FocusableComponentProps",
        "name": "FocusableComponentProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactElement"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:DOMAttributes"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": false,
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether focus should be disabled.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
          }
        ]
      },
      "description": null
    },
    "VisuallyHidden": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/visually-hidden/src/VisuallyHidden.tsx:VisuallyHidden",
      "name": "VisuallyHidden",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/visually-hidden/src/VisuallyHidden.tsx:VisuallyHiddenProps",
        "name": "VisuallyHiddenProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to visually hide.",
            "default": null
          },
          "elementType": {
            "type": "property",
            "name": "elementType",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "JSXElementConstructor"
                  },
                  "typeParameters": [
                    {
                      "id": null,
                      "name": null,
                      "type": "any"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The element type for the container.",
            "default": "'div'"
          },
          "isFocusable": {
            "type": "property",
            "name": "isFocusable",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should become visible on focus, for example skip links.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "AriaRole"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "default": null
          },
          "tabIndex": {
            "type": "property",
            "name": "tabIndex",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "CSSProperties"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "VisuallyHidden hides its children visually, while keeping content visible\nto screen readers."
    },
    "FormValidationContext": {
      "type": "any"
    },
    "parseColor": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/Color.ts:parseColor",
      "name": "parseColor",
      "parameters": [
        {
          "type": "parameter",
          "name": "value",
          "value": {
            "type": "string"
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
      },
      "typeParameters": [],
      "description": "Parses a color from a string value. Throws an error if the string could not be parsed."
    },
    "getColorChannels": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/Color.ts:getColorChannels",
      "name": "getColorChannels",
      "parameters": [
        {
          "type": "parameter",
          "name": "colorSpace",
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "tuple",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          }
        ]
      },
      "typeParameters": [],
      "description": "Returns a list of color channels for a given color space."
    },
    "UNSTABLE_ToastQueue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastQueue",
      "name": "UNSTABLE_ToastQueue",
      "properties": {
        "queue": {
          "type": "property",
          "name": "queue",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "subscriptions": {
          "type": "property",
          "name": "subscriptions",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "function",
                "parameters": [],
                "return": {
                  "type": "void"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "maxVisibleToasts": {
          "type": "property",
          "name": "maxVisibleToasts",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "wrapUpdate": {
          "type": "property",
          "name": "wrapUpdate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fn",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "action",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastAction"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "visibleToasts": {
          "type": "property",
          "name": "visibleToasts",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "The currently visible toasts.",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastStateProps"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "runWithWrapUpdate": {
          "type": "method",
          "name": "runWithWrapUpdate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fn",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "action",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastAction"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "subscribe": {
          "type": "method",
          "name": "subscribe",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fn",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void"
              },
              "typeParameters": [],
              "description": null
            },
            "typeParameters": []
          },
          "description": "Subscribes to updates to the visible toasts.",
          "default": null,
          "static": false
        },
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "content",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Adds a new toast to the queue.",
          "default": null,
          "static": false
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes a toast.",
          "default": null,
          "static": false
        },
        "updateVisibleToasts": {
          "type": "method",
          "name": "updateVisibleToasts",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "action",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastAction"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "pauseAll": {
          "type": "method",
          "name": "pauseAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Pauses the timers for all visible toasts.",
          "default": null,
          "static": false
        },
        "resumeAll": {
          "type": "method",
          "name": "resumeAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resumes the timers for all visible toasts.",
          "default": null,
          "static": false
        },
        "clear": {
          "type": "method",
          "name": "clear",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": [],
      "description": "A ToastQueue manages the order of toasts."
    },
    "ListLayout": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayout",
      "name": "ListLayout",
      "properties": {
        "rowHeight": {
          "type": "property",
          "name": "rowHeight",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "estimatedRowHeight": {
          "type": "property",
          "name": "estimatedRowHeight",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "headingHeight": {
          "type": "property",
          "name": "headingHeight",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "estimatedHeadingHeight": {
          "type": "property",
          "name": "estimatedHeadingHeight",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "loaderHeight": {
          "type": "property",
          "name": "loaderHeight",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "gap": {
          "type": "property",
          "name": "gap",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "padding": {
          "type": "property",
          "name": "padding",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "layoutNodes": {
          "type": "property",
          "name": "layoutNodes",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "contentSize": {
          "type": "property",
          "name": "contentSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "lastCollection": {
          "type": "property",
          "name": "lastCollection",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
                },
                "typeParameters": [
                  {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "rootNodes": {
          "type": "property",
          "name": "rootNodes",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            }
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "invalidateEverything": {
          "type": "property",
          "name": "invalidateEverything",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "validRect": {
          "type": "property",
          "name": "validRect",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
          },
          "optional": false,
          "description": "The rectangle containing currently valid layout infos.",
          "access": "protected",
          "default": null
        },
        "requestedRect": {
          "type": "property",
          "name": "requestedRect",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
          },
          "optional": false,
          "description": "The rectangle of requested layout infos so far.",
          "access": "protected",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Creates a new ListLayout with options. See the list of properties below for a description\nof the options that can be provided.",
          "default": null,
          "static": false
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "access": "protected",
          "default": null
        },
        "getLayoutInfo": {
          "type": "method",
          "name": "getLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getVisibleLayoutInfos": {
          "type": "method",
          "name": "getVisibleLayoutInfos",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
              }
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "layoutIfNeeded": {
          "type": "method",
          "name": "layoutIfNeeded",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "ensureLayoutInfo": {
          "type": "method",
          "name": "ensureLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "isVisible": {
          "type": "method",
          "name": "isVisible",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "shouldInvalidateEverything": {
          "type": "method",
          "name": "shouldInvalidateEverything",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "invalidationContext",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/types.ts:InvalidationContext"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "shouldInvalidateLayoutOptions": {
          "type": "method",
          "name": "shouldInvalidateLayoutOptions",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "update": {
          "type": "method",
          "name": "update",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "invalidationContext",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/types.ts:InvalidationContext"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "buildCollection": {
          "type": "method",
          "name": "buildCollection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
              }
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "isValid": {
          "type": "method",
          "name": "isValid",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildChild": {
          "type": "method",
          "name": "buildChild",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "parentKey",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildNode": {
          "type": "method",
          "name": "buildNode",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildLoader": {
          "type": "method",
          "name": "buildLoader",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildSection": {
          "type": "method",
          "name": "buildSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildSectionHeader": {
          "type": "method",
          "name": "buildSectionHeader",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "buildItem": {
          "type": "method",
          "name": "buildItem",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            },
            "typeParameters": []
          },
          "access": "protected",
          "default": null,
          "static": false
        },
        "updateItemSize": {
          "type": "method",
          "name": "updateItemSize",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "size",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "updateLayoutNode": {
          "type": "method",
          "name": "updateLayoutNode",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldLayoutInfo",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "newLayoutInfo",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getContentSize": {
          "type": "method",
          "name": "getContentSize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getDropTargetFromPoint": {
          "type": "method",
          "name": "getDropTargetFromPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "isValidDropTarget",
                "value": {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "target",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getDropTargetLayoutInfo": {
          "type": "method",
          "name": "getDropTargetLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "virtualizer": {
          "type": "property",
          "name": "virtualizer",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:Virtualizer"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  },
                  {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The Virtualizer the layout is currently attached to.",
          "default": null
        },
        "shouldInvalidate": {
          "type": "method",
          "name": "shouldInvalidate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the layout should invalidate in response to\nvisible rectangle changes. By default, it only invalidates\nwhen the virtualizer's size changes. Return true always\nto make the layout invalidate while scrolling (e.g. sticky headers).",
          "default": null,
          "static": false
        },
        "getItemRect": {
          "type": "method",
          "name": "getItemRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getVisibleRect": {
          "type": "method",
          "name": "getVisibleRect",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "O",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions"
          },
          "default": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions"
          }
        }
      ],
      "extends": [],
      "description": "ListLayout is a virtualizer Layout implementation\nthat arranges its items in a vertical stack. It supports both fixed\nand variable height items."
    },
    "GridLayout": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/GridLayout.ts:GridLayout",
      "name": "GridLayout",
      "properties": {
        "gap": {
          "type": "property",
          "name": "gap",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "numColumns": {
          "type": "property",
          "name": "numColumns",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "contentSize": {
          "type": "property",
          "name": "contentSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "layoutInfos": {
          "type": "property",
          "name": "layoutInfos",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "margin": {
          "type": "property",
          "name": "margin",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "shouldInvalidateLayoutOptions": {
          "type": "method",
          "name": "shouldInvalidateLayoutOptions",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/GridLayout.ts:GridLayoutOptions"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/GridLayout.ts:GridLayoutOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "update": {
          "type": "method",
          "name": "update",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "invalidationContext",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/types.ts:InvalidationContext"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/GridLayout.ts:GridLayoutOptions"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getLayoutInfo": {
          "type": "method",
          "name": "getLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getContentSize": {
          "type": "method",
          "name": "getContentSize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getVisibleLayoutInfos": {
          "type": "method",
          "name": "getVisibleLayoutInfos",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
              }
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "updateItemSize": {
          "type": "method",
          "name": "updateItemSize",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "size",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getDropTargetFromPoint": {
          "type": "method",
          "name": "getDropTargetFromPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "isValidDropTarget",
                "value": {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "target",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getDropTargetLayoutInfo": {
          "type": "method",
          "name": "getDropTargetLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "virtualizer": {
          "type": "property",
          "name": "virtualizer",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:Virtualizer"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  },
                  {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The Virtualizer the layout is currently attached to.",
          "default": null
        },
        "shouldInvalidate": {
          "type": "method",
          "name": "shouldInvalidate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the layout should invalidate in response to\nvisible rectangle changes. By default, it only invalidates\nwhen the virtualizer's size changes. Return true always\nto make the layout invalidate while scrolling (e.g. sticky headers).",
          "default": null,
          "static": false
        },
        "getItemRect": {
          "type": "method",
          "name": "getItemRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getVisibleRect": {
          "type": "method",
          "name": "getVisibleRect",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "O",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/GridLayout.ts:GridLayoutOptions"
          },
          "default": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/GridLayout.ts:GridLayoutOptions"
          }
        }
      ],
      "extends": [],
      "description": "GridLayout is a virtualizer Layout implementation\nthat arranges its items in a grid.\nThe items are sized between a minimum and maximum size\ndepending on the width of the container."
    },
    "WaterfallLayout": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayout",
      "name": "WaterfallLayout",
      "properties": {
        "contentSize": {
          "type": "property",
          "name": "contentSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "layoutInfos": {
          "type": "property",
          "name": "layoutInfos",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutInfo"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "numColumns": {
          "type": "property",
          "name": "numColumns",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "access": "protected",
          "default": null
        },
        "margin": {
          "type": "property",
          "name": "margin",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "shouldInvalidateLayoutOptions": {
          "type": "method",
          "name": "shouldInvalidateLayoutOptions",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutOptions"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "update": {
          "type": "method",
          "name": "update",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "invalidationContext",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/types.ts:InvalidationContext"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutOptions"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getLayoutInfo": {
          "type": "method",
          "name": "getLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getContentSize": {
          "type": "method",
          "name": "getContentSize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getVisibleLayoutInfos": {
          "type": "method",
          "name": "getVisibleLayoutInfos",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
              }
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "updateItemSize": {
          "type": "method",
          "name": "updateItemSize",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "size",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getKeyRightOf": {
          "type": "method",
          "name": "getKeyRightOf",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getKeyLeftOf": {
          "type": "method",
          "name": "getKeyLeftOf",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getKeyRange": {
          "type": "method",
          "name": "getKeyRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "from",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "to",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getDropTargetFromPoint": {
          "type": "method",
          "name": "getDropTargetFromPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "virtualizer": {
          "type": "property",
          "name": "virtualizer",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:Virtualizer"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  },
                  {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The Virtualizer the layout is currently attached to.",
          "default": null
        },
        "shouldInvalidate": {
          "type": "method",
          "name": "shouldInvalidate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the layout should invalidate in response to\nvisible rectangle changes. By default, it only invalidates\nwhen the virtualizer's size changes. Return true always\nto make the layout invalidate while scrolling (e.g. sticky headers).",
          "default": null,
          "static": false
        },
        "getDropTargetLayoutInfo": {
          "type": "method",
          "name": "getDropTargetLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
            },
            "typeParameters": []
          },
          "description": "Returns a `LayoutInfo` for the given drop target.",
          "default": null,
          "static": false
        },
        "getItemRect": {
          "type": "method",
          "name": "getItemRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getVisibleRect": {
          "type": "method",
          "name": "getVisibleRect",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "O",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutOptions"
          },
          "default": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutOptions"
          }
        }
      ],
      "extends": []
    },
    "Layout": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Layout.ts:Layout",
      "name": "Layout",
      "properties": {
        "virtualizer": {
          "type": "property",
          "name": "virtualizer",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:Virtualizer"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  },
                  {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The Virtualizer the layout is currently attached to.",
          "default": null
        },
        "getVisibleLayoutInfos": {
          "type": "method",
          "name": "getVisibleLayoutInfos",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle that should contain the returned LayoutInfo objects."
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
              }
            },
            "typeParameters": []
          },
          "description": "Returns an array of `LayoutInfo` objects which are inside the given rectangle.\nShould be implemented by subclasses.",
          "default": null,
          "static": false,
          "abstract": true
        },
        "getLayoutInfo": {
          "type": "method",
          "name": "getLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": "The key of the LayoutInfo to retrieve."
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns a `LayoutInfo` for the given key.\nShould be implemented by subclasses.",
          "default": null,
          "static": false,
          "abstract": true
        },
        "getContentSize": {
          "type": "method",
          "name": "getContentSize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
            },
            "typeParameters": []
          },
          "description": "Returns size of the content. By default, it returns virtualizer's size.",
          "default": null,
          "static": false,
          "abstract": true
        },
        "shouldInvalidate": {
          "type": "method",
          "name": "shouldInvalidate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the layout should invalidate in response to\nvisible rectangle changes. By default, it only invalidates\nwhen the virtualizer's size changes. Return true always\nto make the layout invalidate while scrolling (e.g. sticky headers).",
          "default": null,
          "static": false
        },
        "shouldInvalidateLayoutOptions": {
          "type": "method",
          "name": "shouldInvalidateLayoutOptions",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newOptions",
                "value": {
                  "type": "identifier",
                  "name": "O"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldOptions",
                "value": {
                  "type": "identifier",
                  "name": "O"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the layout should invalidate when the layout options change.\nBy default it invalidates when the object identity changes. Override this\nmethod to optimize layout updates based on specific option changes.",
          "default": null,
          "static": false
        },
        "update": {
          "type": "method",
          "name": "update",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "invalidationContext",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "InvalidationContext"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "O"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "This method allows the layout to perform any pre-computation\nit needs to in order to prepare LayoutInfos for retrieval.\nCalled by the virtualizer before `getVisibleLayoutInfos`\nor `getLayoutInfo` are called.",
          "default": null,
          "static": false
        },
        "updateItemSize": {
          "type": "method",
          "name": "updateItemSize",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "size",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the size of the given item.",
          "default": null,
          "static": false
        },
        "getDropTargetLayoutInfo": {
          "type": "method",
          "name": "getDropTargetLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
            },
            "typeParameters": []
          },
          "description": "Returns a `LayoutInfo` for the given drop target.",
          "default": null,
          "static": false
        },
        "getItemRect": {
          "type": "method",
          "name": "getItemRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getVisibleRect": {
          "type": "method",
          "name": "getVisibleRect",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          }
        },
        {
          "type": "typeParameter",
          "name": "O",
          "constraint": null,
          "default": {
            "id": null,
            "name": null,
            "type": "any"
          }
        }
      ],
      "extends": [],
      "description": "Virtualizer supports arbitrary layout objects, which compute what items are visible, and how\nto position and style them. However, layouts do not render items directly. Instead,\nlayouts produce lightweight LayoutInfo objects which describe various properties of an item,\nsuch as its position and size. The Virtualizer is then responsible for creating the actual\nviews as needed, based on this layout information.\n\nEvery layout extends from the Layout abstract base class. Layouts must implement the `getVisibleLayoutInfos`,\n`getLayoutInfo`, and `getContentSize` methods. All other methods can be optionally overridden to implement custom behavior."
    },
    "LayoutInfo": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo",
      "name": "LayoutInfo",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The type of element represented by this LayoutInfo. Should match the `type` of the corresponding collection node.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "description": "A unique key for this LayoutInfo. Should match the `key` of the corresponding collection node.",
          "default": null
        },
        "parentKey": {
          "type": "property",
          "name": "parentKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The key for a parent LayoutInfo, if any.",
          "default": null
        },
        "content": {
          "type": "property",
          "name": "content",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "id": null,
                "name": null,
                "type": "any"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Content for this item if it was generated by the layout rather than coming from the Collection.",
          "default": null
        },
        "rect": {
          "type": "property",
          "name": "rect",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
          },
          "optional": false,
          "description": "The rectangle describing the size and position of this element.",
          "default": null
        },
        "estimatedSize": {
          "type": "property",
          "name": "estimatedSize",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the size is estimated. `false` by default.\nItems with estimated sizes will be measured the first time they are added to the DOM.\nThe estimated size is used to calculate the size and position of the scrollbar.",
          "default": "false"
        },
        "isSticky": {
          "type": "property",
          "name": "isSticky",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the layout info sticks to the viewport when scrolling.",
          "default": "false"
        },
        "opacity": {
          "type": "property",
          "name": "opacity",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The element's opacity.",
          "default": "1"
        },
        "transform": {
          "type": "property",
          "name": "transform",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "A CSS transform string to apply to the element. `null` by default.",
          "default": null
        },
        "zIndex": {
          "type": "property",
          "name": "zIndex",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The z-index of the element. 0 by default.",
          "default": null
        },
        "allowOverflow": {
          "type": "property",
          "name": "allowOverflow",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the element allows its contents to overflow its container.",
          "default": "false"
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": "The type of element represented by this LayoutInfo. Should match the `type` of the corresponding collection node."
              },
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": "A unique key for this LayoutInfo. Should match the `key` of the corresponding collection node."
              },
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle describing the size and position of this element."
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of the LayoutInfo.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "Instances of this lightweight class are created by `Layout` subclasses\nto represent each item in the `Virtualizer`. LayoutInfo objects describe\nvarious properties of an item, such as its position and size, and style information.\nThe virtualizer uses this information when creating actual DOM elements to display."
    },
    "Size": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size",
      "name": "Size",
      "properties": {
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "height": {
          "type": "property",
          "name": "height",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "width",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "height",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this size.",
          "default": null,
          "static": false
        },
        "equals": {
          "type": "method",
          "name": "equals",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "other",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether this size is equal to another one.",
          "default": null,
          "static": false
        },
        "area": {
          "type": "property",
          "name": "area",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "description": "The total area of the Size.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "Rect": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect",
      "name": "Rect",
      "properties": {
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x-coordinate of the rectangle.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y-coordinate of the rectangle.",
          "default": null
        },
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The width of the rectangle.",
          "default": null
        },
        "height": {
          "type": "property",
          "name": "height",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The height of the rectangle.",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "width",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "height",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "maxX": {
          "type": "property",
          "name": "maxX",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "description": "The maximum x-coordinate in the rectangle.",
          "default": null
        },
        "maxY": {
          "type": "property",
          "name": "maxY",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "description": "The maximum y-coordinate in the rectangle.",
          "default": null
        },
        "area": {
          "type": "property",
          "name": "area",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "description": "The area of the rectangle.",
          "default": null
        },
        "topLeft": {
          "type": "property",
          "name": "topLeft",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
          },
          "description": "The top left corner of the rectangle.",
          "default": null
        },
        "topRight": {
          "type": "property",
          "name": "topRight",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
          },
          "description": "The top right corner of the rectangle.",
          "default": null
        },
        "bottomLeft": {
          "type": "property",
          "name": "bottomLeft",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
          },
          "description": "The bottom left corner of the rectangle.",
          "default": null
        },
        "bottomRight": {
          "type": "property",
          "name": "bottomRight",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
          },
          "description": "The bottom right corner of the rectangle.",
          "default": null
        },
        "intersects": {
          "type": "method",
          "name": "intersects",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle to check."
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether this rectangle intersects another rectangle.",
          "default": null,
          "static": false
        },
        "containsRect": {
          "type": "method",
          "name": "containsRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle to check."
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether this rectangle fully contains another rectangle.",
          "default": null,
          "static": false
        },
        "containsPoint": {
          "type": "method",
          "name": "containsPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "point",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
                },
                "rest": false,
                "description": "The point to check."
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the rectangle contains the given point.",
          "default": null,
          "static": false
        },
        "getCornerInRect": {
          "type": "method",
          "name": "getCornerInRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle to check."
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:RectCorner"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the first corner of this rectangle (from top to bottom, left to right)\nthat is contained in the given rectangle, or null of the rectangles do not intersect.",
          "default": null,
          "static": false
        },
        "equals": {
          "type": "method",
          "name": "equals",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "pointEquals": {
          "type": "method",
          "name": "pointEquals",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "point",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "sizeEquals": {
          "type": "method",
          "name": "sizeEquals",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "size",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "union": {
          "type": "method",
          "name": "union",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "other",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "description": "Returns the union of this Rect and another.",
          "default": null,
          "static": false
        },
        "intersection": {
          "type": "method",
          "name": "intersection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "other",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "description": "Returns the intersection of this Rect with another.\nIf the rectangles do not intersect, an all zero Rect is returned.",
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this rectangle.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "Represents a rectangle."
    },
    "Point": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point",
      "name": "Point",
      "properties": {
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x-coordinate of the point.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y-coordinate of the point.",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this point.",
          "default": null,
          "static": false
        },
        "equals": {
          "type": "method",
          "name": "equals",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "point",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Checks if two points are equal.",
          "default": null,
          "static": false
        },
        "isOrigin": {
          "type": "method",
          "name": "isOrigin",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns true if this point is the origin.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "AutocompleteProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Autocomplete.tsx:AutocompleteProps",
      "name": "AutocompleteProps",
      "properties": {
        "filter": {
          "type": "property",
          "name": "filter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "textValue",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "inputValue",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "An optional filter function used to determine if a option should be included in the autocomplete list.\nInclude this if the items you are providing to your wrapped collection aren't filtered by default.",
          "default": null
        },
        "disableAutoFocusFirst": {
          "type": "property",
          "name": "disableAutoFocusFirst",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether or not to focus the first item in the collection after a filter is performed. Note this is only applicable\nif virtual focus behavior is not turned off via `disableVirtualFocus`.",
          "default": "false"
        },
        "disableVirtualFocus": {
          "type": "property",
          "name": "disableVirtualFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the autocomplete should disable virtual focus, instead making the wrapped collection directly tabbable.",
          "default": "false"
        },
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value of the autocomplete input (controlled).",
          "default": null
        },
        "defaultInputValue": {
          "type": "property",
          "name": "defaultInputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The default value of the autocomplete input (uncontrolled).",
          "default": null
        },
        "onInputChange": {
          "type": "property",
          "name": "onInputChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the autocomplete input value changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The children wrapped by the autocomplete. Consists of at least an input element and a collection element to filter.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "BreadcrumbsProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbsProps",
      "name": "BreadcrumbsProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the breadcrumbs are disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a breadcrumb is clicked.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "BreadcrumbProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbProps",
      "name": "BreadcrumbProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "A unique id for the breadcrumb, which will be passed to `onAction` when the breadcrumb is pressed.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "BreadcrumbRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbRenderProps",
      "name": "BreadcrumbRenderProps",
      "properties": {
        "isCurrent": {
          "type": "property",
          "name": "isCurrent",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the breadcrumb is for the current page.",
          "selector": "[data-current]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the breadcrumb is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ButtonProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonProps",
      "name": "ButtonProps",
      "properties": {
        "isPending": {
          "type": "property",
          "name": "isPending",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is in a pending state. This disables press and hover events\nwhile retaining focusability, and announces the pending state to screen readers.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is disabled.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "aria-disabled": {
          "type": "property",
          "name": "aria-disabled",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element is disabled to users of assistive technology.",
          "default": null
        },
        "aria-expanded": {
          "type": "property",
          "name": "aria-expanded",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "aria-pressed": {
          "type": "property",
          "name": "aria-pressed",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "mixed"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the current \"pressed\" state of toggle buttons.",
          "default": null
        },
        "aria-current": {
          "type": "property",
          "name": "aria-current",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "page"
              },
              {
                "type": "string",
                "value": "step"
              },
              {
                "type": "string",
                "value": "location"
              },
              {
                "type": "string",
                "value": "date"
              },
              {
                "type": "string",
                "value": "time"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether this element represents the current item within a container or set of related elements.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "button"
              },
              {
                "type": "string",
                "value": "submit"
              },
              {
                "type": "string",
                "value": "reset"
              }
            ]
          },
          "optional": true,
          "description": "The behavior of the button when used in an HTML form.",
          "default": "'button'"
        },
        "preventFocusOnPress": {
          "type": "property",
          "name": "preventFocusOnPress",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/button#form).",
          "default": null
        },
        "formAction": {
          "type": "property",
          "name": "formAction",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
          "default": null
        },
        "formEncType": {
          "type": "property",
          "name": "formEncType",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Indicates how to encode the form data that is submitted.",
          "default": null
        },
        "formMethod": {
          "type": "property",
          "name": "formMethod",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Indicates the HTTP method used to submit the form.",
          "default": null
        },
        "formNoValidate": {
          "type": "property",
          "name": "formNoValidate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Indicates that the form is not to be validated when it is submitted.",
          "default": null
        },
        "formTarget": {
          "type": "property",
          "name": "formTarget",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Overrides the target attribute of the button's form owner.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Submitted as a pair with the button's value as part of the form data.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value associated with the button's name when it's submitted with the form data.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ButtonRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonRenderProps",
      "name": "ButtonRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isPending": {
          "type": "property",
          "name": "isPending",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently in a pending state.",
          "selector": "[data-pending]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CalendarCellProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellProps",
      "name": "CalendarCellProps",
      "properties": {
        "date": {
          "type": "property",
          "name": "date",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          "optional": false,
          "description": "The date to render in the cell.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CalendarProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarProps",
      "name": "CalendarProps",
      "properties": {
        "visibleDuration": {
          "type": "property",
          "name": "visibleDuration",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:DateDuration"
          },
          "optional": true,
          "description": "The amount of days that will be displayed at once. This affects how pagination works.",
          "default": "{months: 1}"
        },
        "createCalendar": {
          "type": "property",
          "name": "createCalendar",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "identifier",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function to create a new [Calendar](https://react-spectrum.adobe.com/internationalized/date/Calendar.html)\nobject for a given calendar identifier. If not provided, the `createCalendar` function\nfrom `@internationalized/date` will be used.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the calendar is disabled.",
          "default": "false"
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the calendar value is immutable.",
          "default": "false"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to automatically focus the calendar when it mounts.",
          "default": "false"
        },
        "focusedValue": {
          "type": "property",
          "name": "focusedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "Controls the currently focused date within the calendar.",
          "default": null
        },
        "defaultFocusedValue": {
          "type": "property",
          "name": "defaultFocusedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The date that is focused when the calendar first mounts (uncountrolled).",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the focused date changes.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the current selection is invalid according to application logic.",
          "default": null
        },
        "pageBehavior": {
          "type": "property",
          "name": "pageBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
          },
          "optional": true,
          "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
          "default": "visible"
        },
        "firstDayOfWeek": {
          "type": "property",
          "name": "firstDayOfWeek",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "sun"
              },
              {
                "type": "string",
                "value": "mon"
              },
              {
                "type": "string",
                "value": "tue"
              },
              {
                "type": "string",
                "value": "wed"
              },
              {
                "type": "string",
                "value": "thu"
              },
              {
                "type": "string",
                "value": "fri"
              },
              {
                "type": "string",
                "value": "sat"
              }
            ]
          },
          "optional": true,
          "description": "The day that starts the week.",
          "default": null
        },
        "selectionAlignment": {
          "type": "property",
          "name": "selectionAlignment",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "center"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "Determines the alignment of the visible months on initial render based on the current selection or current date if there is no selection.",
          "default": "'center'"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "CalendarRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps",
      "name": "CalendarRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:CalendarState"
          },
          "optional": false,
          "description": "State of the calendar.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CalendarGridProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarGridProps",
      "name": "CalendarGridProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactElement"
              },
              {
                "type": "array",
                "elementType": {
                  "type": "identifier",
                  "name": "ReactElement"
                }
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "date",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Either a function to render calendar cells for each date in the month,\nor children containing a `<CalendarGridHeader>`` and `<CalendarGridBody>`\nwhen additional customization is needed.",
          "default": null
        },
        "offset": {
          "type": "property",
          "name": "offset",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:DateDuration"
          },
          "optional": true,
          "description": "An offset from the beginning of the visible date range that this\nCalendarGrid should display. Useful when displaying more than one\nmonth at a time.",
          "default": null
        },
        "weekdayStyle": {
          "type": "property",
          "name": "weekdayStyle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "narrow"
              },
              {
                "type": "string",
                "value": "short"
              },
              {
                "type": "string",
                "value": "long"
              }
            ]
          },
          "optional": true,
          "description": "The style of weekday names to display in the calendar grid header,\ne.g. single letter, abbreviation, or full day name.",
          "default": "\"narrow\""
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CalendarGridHeaderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarGridHeaderProps",
      "name": "CalendarGridHeaderProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "day",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "A function to render a `<CalendarHeaderCell>` for a weekday name.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CalendarGridBodyProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarGridBodyProps",
      "name": "CalendarGridBodyProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "A function to render a `<CalendarCell>` for a given date.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CalendarHeaderCellProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarHeaderCellProps",
      "name": "CalendarHeaderCellProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The children of the component.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CalendarCellRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellRenderProps",
      "name": "CalendarCellRenderProps",
      "properties": {
        "date": {
          "type": "property",
          "name": "date",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          "optional": false,
          "description": "The date that the cell represents.",
          "default": null
        },
        "formattedDate": {
          "type": "property",
          "name": "formattedDate",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The day number formatted according to the current locale.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently being pressed.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isSelectionStart": {
          "type": "property",
          "name": "isSelectionStart",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is the first date in a range selection.",
          "selector": "[data-selection-start]",
          "default": null
        },
        "isSelectionEnd": {
          "type": "property",
          "name": "isSelectionEnd",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is the last date in a range selection.",
          "selector": "[data-selection-end]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is disabled, according to the calendar's `minValue`, `maxValue`, and `isDisabled` props.\nDisabled dates are not focusable, and cannot be selected by the user. They are typically\ndisplayed with a dimmed appearance.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isOutsideVisibleRange": {
          "type": "property",
          "name": "isOutsideVisibleRange",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is outside the visible range of the calendar.\nFor example, dates before the first day of a month in the same week.",
          "selector": "[data-outside-visible-range]",
          "default": null
        },
        "isOutsideMonth": {
          "type": "property",
          "name": "isOutsideMonth",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is outside the current month.",
          "selector": "[data-outside-month]",
          "default": null
        },
        "isUnavailable": {
          "type": "property",
          "name": "isUnavailable",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is unavailable, according to the calendar's `isDateUnavailable` prop. Unavailable dates remain\nfocusable, but cannot be selected by the user. They should be displayed with a visual affordance to indicate they\nare unavailable, such as a different color or a strikethrough.\n\nNote that because they are focusable, unavailable dates must meet a 4.5:1 color contrast ratio,\n[as defined by WCAG](https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html).",
          "selector": "[data-unavailable]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is part of an invalid selection.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isToday": {
          "type": "property",
          "name": "isToday",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is today.",
          "selector": "[data-today]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RangeCalendarProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarProps",
      "name": "RangeCalendarProps",
      "properties": {
        "visibleDuration": {
          "type": "property",
          "name": "visibleDuration",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:DateDuration"
          },
          "optional": true,
          "description": "The amount of days that will be displayed at once. This affects how pagination works.",
          "default": "{months: 1}"
        },
        "createCalendar": {
          "type": "property",
          "name": "createCalendar",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "identifier",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function to create a new [Calendar](https://react-spectrum.adobe.com/internationalized/date/Calendar.html)\nobject for a given calendar identifier. If not provided, the `createCalendar` function\nfrom `@internationalized/date` will be used.",
          "default": null
        },
        "allowsNonContiguousRanges": {
          "type": "property",
          "name": "allowsNonContiguousRanges",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "When combined with `isDateUnavailable`, determines whether non-contiguous ranges,\ni.e. ranges containing unavailable dates, may be selected.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the calendar is disabled.",
          "default": "false"
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the calendar value is immutable.",
          "default": "false"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to automatically focus the calendar when it mounts.",
          "default": "false"
        },
        "focusedValue": {
          "type": "property",
          "name": "focusedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "Controls the currently focused date within the calendar.",
          "default": null
        },
        "defaultFocusedValue": {
          "type": "property",
          "name": "defaultFocusedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The date that is focused when the calendar first mounts (uncountrolled).",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the focused date changes.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the current selection is invalid according to application logic.",
          "default": null
        },
        "pageBehavior": {
          "type": "property",
          "name": "pageBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
          },
          "optional": true,
          "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
          "default": "visible"
        },
        "firstDayOfWeek": {
          "type": "property",
          "name": "firstDayOfWeek",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "sun"
              },
              {
                "type": "string",
                "value": "mon"
              },
              {
                "type": "string",
                "value": "tue"
              },
              {
                "type": "string",
                "value": "wed"
              },
              {
                "type": "string",
                "value": "thu"
              },
              {
                "type": "string",
                "value": "fri"
              },
              {
                "type": "string",
                "value": "sat"
              }
            ]
          },
          "optional": true,
          "description": "The day that starts the week.",
          "default": null
        },
        "selectionAlignment": {
          "type": "property",
          "name": "selectionAlignment",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "center"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "Determines the alignment of the visible months on initial render based on the current selection or current date if there is no selection.",
          "default": "'center'"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "RangeCalendarRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps",
      "name": "RangeCalendarRenderProps",
      "properties": {
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:RangeCalendarState"
          },
          "optional": false,
          "description": "State of the range calendar.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CheckboxGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupProps",
      "name": "CheckboxGroupProps",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "string"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CheckboxGroupRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupRenderProps",
      "name": "CheckboxGroupRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is required.",
          "selector": "[data-required]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/checkbox/src/useCheckboxGroupState.ts:CheckboxGroupState"
          },
          "optional": false,
          "description": "State of the checkbox group.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CheckboxRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxRenderProps",
      "name": "CheckboxRenderProps",
      "properties": {
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isIndeterminate": {
          "type": "property",
          "name": "isIndeterminate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is indeterminate.",
          "selector": "[data-indeterminate]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is required.",
          "selector": "[data-required]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CheckboxProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxProps",
      "name": "CheckboxProps",
      "properties": {
        "inputRef": {
          "type": "property",
          "name": "inputRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the HTML input element.",
          "default": null
        },
        "isIndeterminate": {
          "type": "property",
          "name": "isIndeterminate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Indeterminism is presentational only.\nThe indeterminate visual representation remains regardless of user interaction.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
          "default": null
        },
        "defaultSelected": {
          "type": "property",
          "name": "defaultSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should be selected (uncontrolled).",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should be selected (controlled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isSelected",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's selection state changes.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorAreaProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaProps",
      "name": "ColorAreaProps",
      "properties": {
        "xName": {
          "type": "property",
          "name": "xName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the x channel input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "yName": {
          "type": "property",
          "name": "yName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the y channel input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the ColorArea with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "colorSpace": {
          "type": "property",
          "name": "colorSpace",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
          },
          "optional": true,
          "description": "The color space that the color area operates in. The `xChannel` and `yChannel` must be in this color space.\nIf not provided, this defaults to the color space of the `color` or `defaultColor` value.",
          "default": null
        },
        "xChannel": {
          "type": "property",
          "name": "xChannel",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          },
          "optional": true,
          "description": "Color channel for the horizontal axis.",
          "default": null
        },
        "yChannel": {
          "type": "property",
          "name": "yChannel",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          },
          "optional": true,
          "description": "Color channel for the vertical axis.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the ColorArea is disabled.",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes, as the user drags.",
          "default": null
        },
        "onChangeEnd": {
          "type": "property",
          "name": "onChangeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the user stops dragging.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorAreaRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaRenderProps",
      "name": "ColorAreaRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color area is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorAreaState.ts:ColorAreaState"
          },
          "optional": false,
          "description": "State of the color area.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldProps",
      "name": "ColorFieldProps",
      "properties": {
        "channel": {
          "type": "property",
          "name": "channel",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          },
          "optional": true,
          "description": "The color channel that this field edits. If not provided, \nthe color is edited as a hex value.",
          "default": null
        },
        "colorSpace": {
          "type": "property",
          "name": "colorSpace",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
          },
          "optional": true,
          "description": "The color space that the color field operates in if a `channel` prop is provided.\nIf no `channel` is provided, the color field always displays the color as an RGB hex value.",
          "default": null
        },
        "isWheelDisabled": {
          "type": "property",
          "name": "isWheelDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Enables or disables changing the value with scroll.",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "color",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "onCopy": {
          "type": "property",
          "name": "onCopy",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
          "default": null
        },
        "onCut": {
          "type": "property",
          "name": "onCut",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
          "default": null
        },
        "onPaste": {
          "type": "property",
          "name": "onPaste",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
          "default": null
        },
        "onCompositionStart": {
          "type": "property",
          "name": "onCompositionStart",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
          "default": null
        },
        "onCompositionEnd": {
          "type": "property",
          "name": "onCompositionEnd",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
          "default": null
        },
        "onCompositionUpdate": {
          "type": "property",
          "name": "onCompositionUpdate",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
          "default": null
        },
        "onSelect": {
          "type": "property",
          "name": "onSelect",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReactEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
          "default": null
        },
        "onBeforeInput": {
          "type": "property",
          "name": "onBeforeInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
          "default": null
        },
        "onInput": {
          "type": "property",
          "name": "onInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorFieldRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldRenderProps",
      "name": "ColorFieldRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color field is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "channel": {
          "type": "property",
          "name": "channel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
              },
              {
                "type": "string",
                "value": "hex"
              }
            ]
          },
          "optional": false,
          "description": "The color channel that this field edits, or \"hex\" if no `channel` prop is set.",
          "selector": "[data-channel=\"hex | hue | saturation | ...\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorFieldState.ts:ColorFieldState"
          },
          "optional": false,
          "description": "State of the color field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSliderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderProps",
      "name": "ColorSliderProps",
      "properties": {
        "colorSpace": {
          "type": "property",
          "name": "colorSpace",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
          },
          "optional": true,
          "description": "The color space that the slider operates in. The `channel` must be in this color space.\nIf not provided, this defaults to the color space of the `color` or `defaultColor` value.",
          "default": null
        },
        "channel": {
          "type": "property",
          "name": "channel",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          },
          "optional": false,
          "description": "The color channel that the slider manipulates.",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes, as the user drags.",
          "default": null
        },
        "onChangeEnd": {
          "type": "property",
          "name": "onChangeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the user stops dragging.",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The orientation of the Slider.",
          "default": "'horizontal'"
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the whole Slider is disabled.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSliderRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderRenderProps",
      "name": "ColorSliderRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the color slider.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color slider is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorSliderState.ts:ColorSliderState"
          },
          "optional": false,
          "description": "State of the color slider.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSwatchProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatch.tsx:ColorSwatchProps",
      "name": "ColorSwatchProps",
      "properties": {
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": true,
          "description": "The color value to display in the swatch.",
          "default": null
        },
        "colorName": {
          "type": "property",
          "name": "colorName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A localized accessible name for the color.\nBy default, a description is generated from the color value,\nbut this can be overridden if you have a more specific color\nname (e.g. Pantone colors).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatch.tsx:ColorSwatchRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatch.tsx:ColorSwatchRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSwatchRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatch.tsx:ColorSwatchRenderProps",
      "name": "ColorSwatchRenderProps",
      "properties": {
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The color of the swatch.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSwatchPickerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerProps",
      "name": "ColorSwatchPickerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The children of the ColorSwatchPicker.",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "stack"
              }
            ]
          },
          "optional": true,
          "description": "Whether the items are arranged in a stack or grid.",
          "default": "'grid'"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSwatchPickerRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerRenderProps",
      "name": "ColorSwatchPickerRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "stack"
              },
              {
                "type": "string",
                "value": "grid"
              }
            ]
          },
          "optional": false,
          "description": "Whether the items are arranged in a stack or grid.",
          "selector": "[data-layout=\"stack | grid\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the listbox.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSwatchPickerItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemProps",
      "name": "ColorSwatchPickerItemProps",
      "properties": {
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": false,
          "description": "The color of the swatch.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the color swatch is disabled.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSwatchPickerItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemRenderProps",
      "name": "ColorSwatchPickerItemRenderProps",
      "properties": {
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The color of the swatch.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorThumbProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbProps",
      "name": "ColorThumbProps",
      "properties": {
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorThumbRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbRenderProps",
      "name": "ColorThumbRenderProps",
      "properties": {
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The selected color, excluding the alpha channel.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether this thumb is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorPickerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorPicker.tsx:ColorPickerProps",
      "name": "ColorPickerProps",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorPickerRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorPicker.tsx:ColorPickerRenderProps",
      "name": "ColorPickerRenderProps",
      "properties": {
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The currently selected color.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorWheelProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelProps",
      "name": "ColorWheelProps",
      "properties": {
        "outerRadius": {
          "type": "property",
          "name": "outerRadius",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The outer radius of the color wheel.",
          "default": null
        },
        "innerRadius": {
          "type": "property",
          "name": "innerRadius",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The inner radius of the color wheel.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the ColorWheel is disabled.",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes, as the user drags.",
          "default": null
        },
        "onChangeEnd": {
          "type": "property",
          "name": "onChangeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the user stops dragging.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": "'hsl(0, 100%, 50%)'"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorWheelRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelRenderProps",
      "name": "ColorWheelRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color wheel is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorWheelState.ts:ColorWheelState"
          },
          "optional": false,
          "description": "State of the color wheel.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorWheelTrackProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelTrackProps",
      "name": "ColorWheelTrackProps",
      "properties": {
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelTrackRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelTrackRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorWheelTrackRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelTrackRenderProps",
      "name": "ColorWheelTrackRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color wheel is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorWheelState.ts:ColorWheelState"
          },
          "optional": false,
          "description": "State of the color wheel.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ComboBoxProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxProps",
      "name": "ComboBoxProps",
      "properties": {
        "defaultFilter": {
          "type": "property",
          "name": "defaultFilter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "textValue",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "inputValue",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "The filter function used to determine if a option should be included in the combo box list.",
          "default": null
        },
        "formValue": {
          "type": "property",
          "name": "formValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "key"
              }
            ]
          },
          "optional": true,
          "description": "Whether the text or key of the selected item is submitted as part of an HTML form.\nWhen `allowsCustomValue` is `true`, this option does not apply and the text is always submitted.",
          "default": "'key'"
        },
        "allowsEmptyCollection": {
          "type": "property",
          "name": "allowsEmptyCollection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the combo box allows the menu to be open when the collection is empty.",
          "default": null
        },
        "shouldFocusWrap": {
          "type": "property",
          "name": "shouldFocusWrap",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether keyboard navigation is circular.",
          "default": null
        },
        "defaultItems": {
          "type": "property",
          "name": "defaultItems",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The list of ComboBox items (uncontrolled).",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The list of ComboBox items (controlled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "menuTrigger",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Method that is called when the open state of the menu changes. Returns the new open state and the action that caused the opening of the menu.",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value of the ComboBox input (controlled).",
          "default": null
        },
        "defaultInputValue": {
          "type": "property",
          "name": "defaultInputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The default value of the ComboBox input (uncontrolled).",
          "default": null
        },
        "onInputChange": {
          "type": "property",
          "name": "onInputChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the ComboBox input value changes.",
          "default": null
        },
        "allowsCustomValue": {
          "type": "property",
          "name": "allowsCustomValue",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the ComboBox allows a non-item matching input value to be set.",
          "default": null
        },
        "menuTrigger": {
          "type": "property",
          "name": "menuTrigger",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction"
          },
          "optional": true,
          "description": "The interaction required to display the ComboBox menu.",
          "default": "'input'"
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The currently selected key in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKey": {
          "type": "property",
          "name": "defaultSelectedKey",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": true,
          "description": "The initial selected key in the collection (uncontrolled).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:ComboBoxValidationValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "extends": []
    },
    "ComboBoxRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxRenderProps",
      "name": "ComboBoxRenderProps",
      "properties": {
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the combobox is currently open.",
          "selector": "[data-open]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the combobox is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the combobox is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the combobox is required.",
          "selector": "[data-required]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DateFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldProps",
      "name": "DateFieldProps",
      "properties": {
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "placeholderValue": {
          "type": "property",
          "name": "placeholderValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
          "default": null
        },
        "hourCycle": {
          "type": "property",
          "name": "hourCycle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 12
              },
              {
                "type": "number",
                "value": 24
              }
            ]
          },
          "optional": true,
          "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": true,
          "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
          "default": null
        },
        "hideTimeZone": {
          "type": "property",
          "name": "hideTimeZone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to hide the time zone abbreviation.",
          "default": "false"
        },
        "shouldForceLeadingZeros": {
          "type": "property",
          "name": "shouldForceLeadingZeros",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "DateFieldRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps",
      "name": "DateFieldRenderProps",
      "properties": {
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateFieldState"
          },
          "optional": false,
          "description": "State of the date field.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is read only.",
          "selector": "[data-readonly]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DateInputProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateInputProps",
      "name": "DateInputProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "segment",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateSegment"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": false,
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateInputRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateInputRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DateInputRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateInputRenderProps",
      "name": "DateInputRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date input is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocusWithin": {
          "type": "property",
          "name": "isFocusWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date input is focused, either via a mouse or keyboard.",
          "selector": "[data-focus-within]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date input is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date input is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date input is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DateSegmentProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentProps",
      "name": "DateSegmentProps",
      "properties": {
        "segment": {
          "type": "property",
          "name": "segment",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateSegment"
          },
          "optional": false,
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLSpanElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DateSegmentRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentRenderProps",
      "name": "DateSegmentRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the segment is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the segment is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the segment is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isPlaceholder": {
          "type": "property",
          "name": "isPlaceholder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the value is a placeholder.",
          "selector": "[data-placeholder]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the segment is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is in an invalid state.",
          "selector": "[data-invalid]",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType",
            "name": "DateSegmentType"
          },
          "optional": false,
          "description": "The type of segment. Values include `literal`, `year`, `month`, `day`, etc.",
          "selector": "[data-type=\"...\"]",
          "default": null
        },
        "text": {
          "type": "property",
          "name": "text",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The formatted text for the segment.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The numeric value for the segment, if applicable.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum numeric value for the segment, if applicable.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum numeric value for the segment, if applicable.",
          "default": null
        },
        "placeholder": {
          "type": "property",
          "name": "placeholder",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A placeholder string for the segment.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TimeFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:TimeFieldProps",
      "name": "TimeFieldProps",
      "properties": {
        "hourCycle": {
          "type": "property",
          "name": "hourCycle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 12
              },
              {
                "type": "number",
                "value": 24
              }
            ]
          },
          "optional": true,
          "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "hour"
              },
              {
                "type": "string",
                "value": "minute"
              },
              {
                "type": "string",
                "value": "second"
              }
            ]
          },
          "optional": true,
          "description": "Determines the smallest unit that is displayed in the time picker.",
          "default": "'minute'"
        },
        "hideTimeZone": {
          "type": "property",
          "name": "hideTimeZone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to hide the time zone abbreviation.",
          "default": null
        },
        "shouldForceLeadingZeros": {
          "type": "property",
          "name": "shouldForceLeadingZeros",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to always show leading zeros in the hour field.\nBy default, this is determined by the user's locale.",
          "default": null
        },
        "placeholderValue": {
          "type": "property",
          "name": "placeholderValue",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
          },
          "optional": true,
          "description": "A placeholder time that influences the format of the placeholder shown when no value is selected.\nDefaults to 12:00 AM or 00:00 depending on the hour cycle.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed time that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed time that a user may select.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "DatePickerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerProps",
      "name": "DatePickerProps",
      "properties": {
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "pageBehavior": {
          "type": "property",
          "name": "pageBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
          },
          "optional": true,
          "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
          "default": "visible"
        },
        "firstDayOfWeek": {
          "type": "property",
          "name": "firstDayOfWeek",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "sun"
              },
              {
                "type": "string",
                "value": "mon"
              },
              {
                "type": "string",
                "value": "tue"
              },
              {
                "type": "string",
                "value": "wed"
              },
              {
                "type": "string",
                "value": "thu"
              },
              {
                "type": "string",
                "value": "fri"
              },
              {
                "type": "string",
                "value": "sat"
              }
            ]
          },
          "optional": true,
          "description": "The day that starts the week.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "placeholderValue": {
          "type": "property",
          "name": "placeholderValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
          "default": null
        },
        "hourCycle": {
          "type": "property",
          "name": "hourCycle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 12
              },
              {
                "type": "number",
                "value": 24
              }
            ]
          },
          "optional": true,
          "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": true,
          "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
          "default": null
        },
        "hideTimeZone": {
          "type": "property",
          "name": "hideTimeZone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to hide the time zone abbreviation.",
          "default": "false"
        },
        "shouldForceLeadingZeros": {
          "type": "property",
          "name": "shouldForceLeadingZeros",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "shouldCloseOnSelect": {
          "type": "property",
          "name": "shouldCloseOnSelect",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "function",
                "parameters": [],
                "return": {
                  "type": "boolean"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Determines whether the date picker popover should close automatically when a date is selected.",
          "default": "true"
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "DatePickerRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerRenderProps",
      "name": "DatePickerRenderProps",
      "properties": {
        "isFocusWithin": {
          "type": "property",
          "name": "isFocusWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date picker is focused, either via a mouse or keyboard.",
          "selector": "[data-focus-within]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date picker is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker's popover is currently open.",
          "selector": "[data-open]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDatePickerState.ts:DatePickerState"
          },
          "optional": false,
          "description": "State of the date picker.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DateRangePickerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerProps",
      "name": "DateRangePickerProps",
      "properties": {
        "pageBehavior": {
          "type": "property",
          "name": "pageBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
          },
          "optional": true,
          "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
          "default": "visible"
        },
        "firstDayOfWeek": {
          "type": "property",
          "name": "firstDayOfWeek",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "sun"
              },
              {
                "type": "string",
                "value": "mon"
              },
              {
                "type": "string",
                "value": "tue"
              },
              {
                "type": "string",
                "value": "wed"
              },
              {
                "type": "string",
                "value": "thu"
              },
              {
                "type": "string",
                "value": "fri"
              },
              {
                "type": "string",
                "value": "sat"
              }
            ]
          },
          "optional": true,
          "description": "The day that starts the week.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "placeholderValue": {
          "type": "property",
          "name": "placeholderValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
          "default": null
        },
        "hourCycle": {
          "type": "property",
          "name": "hourCycle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 12
              },
              {
                "type": "number",
                "value": 24
              }
            ]
          },
          "optional": true,
          "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": true,
          "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
          "default": null
        },
        "hideTimeZone": {
          "type": "property",
          "name": "hideTimeZone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to hide the time zone abbreviation.",
          "default": "false"
        },
        "shouldForceLeadingZeros": {
          "type": "property",
          "name": "shouldForceLeadingZeros",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "allowsNonContiguousRanges": {
          "type": "property",
          "name": "allowsNonContiguousRanges",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "When combined with `isDateUnavailable`, determines whether non-contiguous ranges,\ni.e. ranges containing unavailable dates, may be selected.",
          "default": null
        },
        "startName": {
          "type": "property",
          "name": "startName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the start date input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "endName": {
          "type": "property",
          "name": "endName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the end date input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                      },
                      "typeParameters": [
                        {
                          "type": "application",
                          "base": {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                          },
                          "typeParameters": [
                            {
                              "type": "link",
                              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "shouldCloseOnSelect": {
          "type": "property",
          "name": "shouldCloseOnSelect",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "function",
                "parameters": [],
                "return": {
                  "type": "boolean"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Determines whether the date picker popover should close automatically when a date is selected.",
          "default": "true"
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "DateRangePickerRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerRenderProps",
      "name": "DateRangePickerRenderProps",
      "properties": {
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateRangePickerState.ts:DateRangePickerState"
          },
          "optional": false,
          "description": "State of the date range picker.",
          "default": null
        },
        "isFocusWithin": {
          "type": "property",
          "name": "isFocusWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date picker is focused, either via a mouse or keyboard.",
          "selector": "[data-focus-within]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date picker is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker's popover is currently open.",
          "selector": "[data-open]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DialogProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogProps",
      "name": "DialogProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "opts",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
          "default": null
        },
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "alertdialog"
              }
            ]
          },
          "optional": true,
          "description": "The accessibility role for the dialog.",
          "default": "'dialog'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DialogTriggerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogTriggerProps",
      "name": "DialogTriggerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DialogRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps",
      "name": "DialogRenderProps",
      "properties": {
        "close": {
          "type": "property",
          "name": "close",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DisclosureProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureProps",
      "name": "DisclosureProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "An id for the disclosure when used within a DisclosureGroup, matching the id used in `expandedKeys`.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the disclosure is disabled.",
          "default": null
        },
        "onExpandedChange": {
          "type": "property",
          "name": "onExpandedChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isExpanded",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the disclosure's expanded state changes.",
          "default": null
        },
        "isExpanded": {
          "type": "property",
          "name": "isExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the disclosure is expanded (controlled).",
          "default": null
        },
        "defaultExpanded": {
          "type": "property",
          "name": "defaultExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the disclosure is expanded by default (uncontrolled).",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DisclosureRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureRenderProps",
      "name": "DisclosureRenderProps",
      "properties": {
        "isExpanded": {
          "type": "property",
          "name": "isExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the disclosure is expanded.",
          "selector": "[data-expanded]",
          "default": null
        },
        "isFocusVisibleWithin": {
          "type": "property",
          "name": "isFocusVisibleWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the disclosure has keyboard focus.",
          "selector": "[data-focus-visible-within]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the disclosure is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/disclosure/src/useDisclosureState.ts:DisclosureState"
          },
          "optional": false,
          "description": "State of the disclosure.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DisclosurePanelProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosurePanelProps",
      "name": "DisclosurePanelProps",
      "properties": {
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "group"
              },
              {
                "type": "string",
                "value": "region"
              }
            ]
          },
          "optional": true,
          "description": "The accessibility role for the disclosure's panel.",
          "default": "'group'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The children of the component.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosurePanelRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosurePanelRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DisclosurePanelRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosurePanelRenderProps",
      "name": "DisclosurePanelRenderProps",
      "properties": {
        "isFocusVisibleWithin": {
          "type": "property",
          "name": "isFocusVisibleWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether keyboard focus is within the disclosure panel.",
          "selector": "[data-focus-visible-within]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DisclosureGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupProps",
      "name": "DisclosureGroupProps",
      "properties": {
        "allowsMultipleExpanded": {
          "type": "property",
          "name": "allowsMultipleExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether multiple items can be expanded at the same time.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether all items are disabled.",
          "default": null
        },
        "expandedKeys": {
          "type": "property",
          "name": "expandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": true,
          "description": "The currently expanded keys in the group (controlled).",
          "default": null
        },
        "defaultExpandedKeys": {
          "type": "property",
          "name": "defaultExpandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": true,
          "description": "The initial expanded keys in the group (uncontrolled).",
          "default": null
        },
        "onExpandedChange": {
          "type": "property",
          "name": "onExpandedChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are expanded or collapsed.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DisclosureGroupRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupRenderProps",
      "name": "DisclosureGroupRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the disclosure group is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/disclosure/src/useDisclosureGroupState.ts:DisclosureGroupState"
          },
          "optional": false,
          "description": "State of the disclosure group.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DropZoneProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneProps",
      "name": "DropZoneProps",
      "properties": {
        "getDropOperation": {
          "type": "property",
          "name": "getDropOperation",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "allowedOperations",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
          "default": null
        },
        "onDropEnter": {
          "type": "property",
          "name": "onDropEnter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEnterEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag enters the drop target.",
          "default": null
        },
        "onDropMove": {
          "type": "property",
          "name": "onDropMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is moved within the drop target.",
          "default": null
        },
        "onDropActivate": {
          "type": "property",
          "name": "onDropActivate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropActivateEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called after a valid drag is held over the drop target for a period of time.\nThis typically opens the item so that the user can drop within it.",
          "default": null
        },
        "onDropExit": {
          "type": "property",
          "name": "onDropExit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropExitEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag exits the drop target.",
          "default": null
        },
        "onDrop": {
          "type": "property",
          "name": "onDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is dropped on the drop target.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drop target is disabled. If true, the drop target will not accept any drops.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DropZoneRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneRenderProps",
      "name": "DropZoneRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the dropzone is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the dropzone is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the dropzone is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the dropzone is the drop target.",
          "selector": "[data-drop-target]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the dropzone is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "FieldErrorProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorProps",
      "name": "FieldErrorProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "FieldErrorRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorRenderProps",
      "name": "FieldErrorRenderProps",
      "properties": {
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validationErrors": {
          "type": "property",
          "name": "validationErrors",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          },
          "optional": false,
          "description": "The current error messages for the input if it is invalid, otherwise an empty array.",
          "default": null
        },
        "validationDetails": {
          "type": "property",
          "name": "validationDetails",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ValidityState"
          },
          "optional": false,
          "description": "The native validation details for the input.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "FileTriggerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FileTrigger.tsx:FileTriggerProps",
      "name": "FileTriggerProps",
      "properties": {
        "acceptedFileTypes": {
          "type": "property",
          "name": "acceptedFileTypes",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Specifies what mime type of files are allowed.",
          "default": null
        },
        "allowsMultiple": {
          "type": "property",
          "name": "allowsMultiple",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether multiple files can be selected.",
          "default": null
        },
        "defaultCamera": {
          "type": "property",
          "name": "defaultCamera",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "user"
              },
              {
                "type": "string",
                "value": "environment"
              }
            ]
          },
          "optional": true,
          "description": "Specifies the use of a media capture mechanism to capture the media on the spot.",
          "default": null
        },
        "onSelect": {
          "type": "property",
          "name": "onSelect",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "files",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "FileList"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler when a user selects a file.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The children of the component.",
          "default": null
        },
        "acceptDirectory": {
          "type": "property",
          "name": "acceptDirectory",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Enables the selection of directories instead of individual files.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "FormProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Form.tsx:FormProps",
      "name": "FormProps",
      "properties": {
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "aria"
              },
              {
                "type": "string",
                "value": "native"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen a field value is missing or invalid, or mark fields as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "validationErrors": {
          "type": "property",
          "name": "validationErrors",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationErrors"
          },
          "optional": true,
          "description": "Validation errors for the form, typically returned by a server.\nThis should be set to an object mapping from input names to errors.",
          "default": null
        },
        "action": {
          "type": "property",
          "name": "action",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "indexedAccess",
                "objectType": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FormHTMLAttributes"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                "indexType": {
                  "type": "string",
                  "value": "action"
                }
              }
            ]
          },
          "optional": true,
          "description": "Where to send the form-data when the form is submitted.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#action).",
          "default": null
        },
        "encType": {
          "type": "property",
          "name": "encType",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "application/x-www-form-urlencoded"
              },
              {
                "type": "string",
                "value": "multipart/form-data"
              },
              {
                "type": "string",
                "value": "text/plain"
              }
            ]
          },
          "optional": true,
          "description": "The enctype attribute specifies how the form-data should be encoded when submitting it to the server.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#enctype).",
          "default": null
        },
        "method": {
          "type": "property",
          "name": "method",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "get"
              },
              {
                "type": "string",
                "value": "post"
              },
              {
                "type": "string",
                "value": "dialog"
              }
            ]
          },
          "optional": true,
          "description": "The HTTP method to submit the form with.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#method).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "_blank"
              },
              {
                "type": "string",
                "value": "_self"
              },
              {
                "type": "string",
                "value": "_parent"
              },
              {
                "type": "string",
                "value": "_top"
              }
            ]
          },
          "optional": true,
          "description": "The target attribute specifies a name or a keyword that indicates where to display the response that is received after submitting the form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#target).",
          "default": null
        },
        "onSubmit": {
          "type": "property",
          "name": "onSubmit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FormEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Triggered when a user submits the form.",
          "default": null
        },
        "onReset": {
          "type": "property",
          "name": "onReset",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FormEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Triggered when a user resets the form.",
          "default": null
        },
        "onInvalid": {
          "type": "property",
          "name": "onInvalid",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FormEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Triggered for each invalid field when a user submits the form.",
          "default": null
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "off"
              },
              {
                "type": "string",
                "value": "on"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether input elements can by default have their values automatically completed by the browser.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#autocomplete).",
          "default": null
        },
        "autoCapitalize": {
          "type": "property",
          "name": "autoCapitalize",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "off"
              },
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "on"
              },
              {
                "type": "string",
                "value": "sentences"
              },
              {
                "type": "string",
                "value": "words"
              },
              {
                "type": "string",
                "value": "characters"
              }
            ]
          },
          "optional": true,
          "description": "Controls whether inputted text is automatically capitalized and, if so, in what manner. \nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/autocapitalize).",
          "default": null
        },
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "presentation"
              }
            ]
          },
          "optional": true,
          "description": "An ARIA role override to apply to the form element.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The children of the component.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "GridListProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListProps",
      "name": "GridListProps",
      "properties": {
        "disallowTypeAhead": {
          "type": "property",
          "name": "disallowTypeAhead",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether typeahead navigation is disabled.",
          "default": "false"
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": true,
          "description": "How multiple selection should behave in the collection.",
          "default": "\"toggle\""
        },
        "dragAndDropHooks": {
          "type": "property",
          "name": "dragAndDropHooks",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "NoInfer"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the GridList.",
          "default": null
        },
        "renderEmptyState": {
          "type": "property",
          "name": "renderEmptyState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides content to display when there are no items in the list.",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "stack"
              },
              {
                "type": "string",
                "value": "grid"
              }
            ]
          },
          "optional": true,
          "description": "Whether the items are arranged in a stack or grid.",
          "default": "'stack'"
        },
        "keyboardNavigationBehavior": {
          "type": "property",
          "name": "keyboardNavigationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "arrow"
              },
              {
                "type": "string",
                "value": "tab"
              }
            ]
          },
          "optional": true,
          "description": "Whether keyboard navigation to focusable elements within grid list items is\nvia the left/right arrow keys or the tab key.",
          "default": "'arrow'"
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the grid list or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              }
            ]
          },
          "optional": true,
          "description": "Whether to auto focus the gridlist or an option.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "optional": true,
          "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
          "default": "\"all\""
        },
        "shouldSelectOnPressUp": {
          "type": "property",
          "name": "shouldSelectOnPressUp",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether selection should occur on press up instead of press down.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "GridListRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps",
      "name": "GridListRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the list has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the grid list is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the grid list is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the grid list is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "stack"
              },
              {
                "type": "string",
                "value": "grid"
              }
            ]
          },
          "optional": false,
          "description": "Whether the items are arranged in a stack or grid.",
          "selector": "[data-layout=\"stack | grid\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the grid list.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "GridListItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemProps",
      "name": "GridListItemProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the item.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the item's contents, used for features like typeahead.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "GridListItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemRenderProps",
      "name": "GridListItemRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "GridListLoadMoreItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListLoadMoreItemProps",
      "name": "GridListLoadMoreItemProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The load more spinner to render when loading additional items.",
          "default": null
        },
        "isLoading": {
          "type": "property",
          "name": "isLoading",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether or not the loading spinner should be rendered or not.",
          "default": null
        },
        "scrollOffset": {
          "type": "property",
          "name": "scrollOffset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The amount of offset from the bottom of your scrollable region that should trigger load more.\nUses a percentage value relative to the scroll body's client height. Load more is then triggered\nwhen your current scroll position's distance from the bottom of the currently loaded list of items is less than\nor equal to the provided value. (e.g. 1 = 100% of the scroll region's height).",
          "default": "1"
        },
        "onLoadMore": {
          "type": "property",
          "name": "onLoadMore",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "GroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupProps",
      "name": "GroupProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the group is disabled.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the group is invalid.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the group is read only.",
          "default": null
        },
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "group"
              },
              {
                "type": "string",
                "value": "region"
              },
              {
                "type": "string",
                "value": "presentation"
              }
            ]
          },
          "optional": true,
          "description": "An accessibility role for the group. By default, this is set to `'group'`.\nUse `'region'` when the contents of the group is important enough to be\nincluded in the page table of contents. Use `'presentation'` if the group\nis visual only and does not represent a semantic grouping of controls.",
          "default": "'group'"
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "HTMLAttributes"
        }
      ]
    },
    "GroupRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupRenderProps",
      "name": "GroupRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the group is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocusWithin": {
          "type": "property",
          "name": "isFocusWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the group is focused, either via a mouse or keyboard.",
          "selector": "[data-focus-within]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the group is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the group is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the group is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "HeadingProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Heading.tsx:HeadingProps",
      "name": "HeadingProps",
      "properties": {
        "level": {
          "type": "property",
          "name": "level",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "HTMLAttributes"
        }
      ]
    },
    "InputProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputProps",
      "name": "InputProps",
      "properties": {
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "InputHTMLAttributes"
        }
      ]
    },
    "InputRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps",
      "name": "InputRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SectionProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:SectionProps",
      "name": "SectionProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the section.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Static child items or a function to render children.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for the section.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the section.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "CollectionRenderer": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:CollectionRenderer",
      "name": "CollectionRenderer",
      "properties": {
        "isVirtualized": {
          "type": "property",
          "name": "isVirtualized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether this is a virtualized collection.",
          "default": null
        },
        "layoutDelegate": {
          "type": "property",
          "name": "layoutDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LayoutDelegate"
          },
          "optional": true,
          "description": "A delegate object that provides layout information for items in the collection.",
          "default": null
        },
        "dropTargetDelegate": {
          "type": "property",
          "name": "dropTargetDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate"
          },
          "optional": true,
          "description": "A delegate object that provides drop targets for pointer coordinates within the collection.",
          "default": null
        },
        "CollectionRoot": {
          "type": "property",
          "name": "CollectionRoot",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "React.ComponentType"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:CollectionRootProps"
              }
            ]
          },
          "optional": false,
          "description": "A component that renders the root collection items.",
          "default": null
        },
        "CollectionBranch": {
          "type": "property",
          "name": "CollectionBranch",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "React.ComponentType"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:CollectionBranchProps"
              }
            ]
          },
          "optional": false,
          "description": "A component that renders the child collection items.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "LabelProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Label.tsx:LabelProps",
      "name": "LabelProps",
      "properties": {
        "elementType": {
          "type": "property",
          "name": "elementType",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "LabelHTMLAttributes"
        }
      ]
    },
    "LinkProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkProps",
      "name": "LinkProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the link is disabled.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "LinkRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkRenderProps",
      "name": "LinkRenderProps",
      "properties": {
        "isCurrent": {
          "type": "property",
          "name": "isCurrent",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is the current item within a list.",
          "selector": "[data-current]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ListBoxProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxProps",
      "name": "ListBoxProps",
      "properties": {
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": true,
          "description": "How multiple selection should behave in the collection.",
          "default": "\"toggle\""
        },
        "dragAndDropHooks": {
          "type": "property",
          "name": "dragAndDropHooks",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "NoInfer"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the ListBox.",
          "default": null
        },
        "renderEmptyState": {
          "type": "property",
          "name": "renderEmptyState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxRenderProps"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides content to display when there are no items in the list.",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "stack"
              },
              {
                "type": "string",
                "value": "grid"
              }
            ]
          },
          "optional": true,
          "description": "Whether the items are arranged in a stack or grid.",
          "default": "'stack'"
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The primary orientation of the items. Usually this is the\ndirection that the collection scrolls.",
          "default": "'vertical'"
        },
        "shouldSelectOnPressUp": {
          "type": "property",
          "name": "shouldSelectOnPressUp",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether selection should occur on press up instead of press down.",
          "default": null
        },
        "shouldFocusOnHover": {
          "type": "property",
          "name": "shouldFocusOnHover",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether options should be focused when the user hovers over them.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the listbox or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              }
            ]
          },
          "optional": true,
          "description": "Whether to auto focus the listbox or an option.",
          "default": null
        },
        "shouldFocusWrap": {
          "type": "property",
          "name": "shouldFocusWrap",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether focus should wrap around when the end/start is reached.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "ListBoxRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxRenderProps",
      "name": "ListBoxRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "stack"
              },
              {
                "type": "string",
                "value": "grid"
              }
            ]
          },
          "optional": false,
          "description": "Whether the items are arranged in a stack or grid.",
          "selector": "[data-layout=\"stack | grid\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the listbox.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ListBoxItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemProps",
      "name": "ListBoxItemProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the item.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the item's contents, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this item.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "ListBoxItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemRenderProps",
      "name": "ListBoxItemRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ListBoxSectionProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxSectionProps",
      "name": "ListBoxSectionProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the section.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Static child items or a function to render children.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for the section.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the section.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "ListBoxLoadMoreItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxLoadMoreItemProps",
      "name": "ListBoxLoadMoreItemProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The load more spinner to render when loading additional items.",
          "default": null
        },
        "isLoading": {
          "type": "property",
          "name": "isLoading",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether or not the loading spinner should be rendered or not.",
          "default": null
        },
        "scrollOffset": {
          "type": "property",
          "name": "scrollOffset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The amount of offset from the bottom of your scrollable region that should trigger load more.\nUses a percentage value relative to the scroll body's client height. Load more is then triggered\nwhen your current scroll position's distance from the bottom of the currently loaded list of items is less than\nor equal to the provided value. (e.g. 1 = 100% of the scroll region's height).",
          "default": "1"
        },
        "onLoadMore": {
          "type": "property",
          "name": "onLoadMore",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "MenuProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuProps",
      "name": "MenuProps",
      "properties": {
        "renderEmptyState": {
          "type": "property",
          "name": "renderEmptyState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides content to display when there are no items in the list.",
          "default": null
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the menu or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              }
            ]
          },
          "optional": true,
          "description": "Where the focus should be set.",
          "default": null
        },
        "shouldFocusWrap": {
          "type": "property",
          "name": "shouldFocusWrap",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether keyboard navigation is circular.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when an item is selected.",
          "default": null
        },
        "onClose": {
          "type": "property",
          "name": "onClose",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the menu should close after selecting an item.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "MenuItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemProps",
      "name": "MenuItemProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the item.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the item's contents, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this item.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the item is selected.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "MenuItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemRenderProps",
      "name": "MenuItemRenderProps",
      "properties": {
        "hasSubmenu": {
          "type": "property",
          "name": "hasSubmenu",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item has a submenu.",
          "selector": "[data-has-submenu]",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item's submenu is open.",
          "selector": "[data-open]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "MenuTriggerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuTriggerProps",
      "name": "MenuTriggerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "trigger": {
          "type": "property",
          "name": "trigger",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/menu/src/index.d.ts:MenuTriggerType"
          },
          "optional": true,
          "description": "How the menu is triggered.",
          "default": "'press'"
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SubmenuTriggerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:SubmenuTriggerProps",
      "name": "SubmenuTriggerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "identifier",
              "name": "ReactElement"
            }
          },
          "optional": false,
          "description": "The contents of the SubmenuTrigger. The first child should be an Item (the trigger) and the second child should be the Popover (for the submenu).",
          "default": null
        },
        "delay": {
          "type": "property",
          "name": "delay",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The delay time in milliseconds for the submenu to appear after hovering over the trigger.",
          "default": "200"
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "MenuSectionProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuSectionProps",
      "name": "MenuSectionProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the section.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Static child items or a function to render children.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for the section.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the section.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The currently disabled keys in the collection (controlled).",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "MeterProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterProps",
      "name": "MeterProps",
      "properties": {
        "formatOptions": {
          "type": "property",
          "name": "formatOptions",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Intl.NumberFormatOptions"
          },
          "optional": true,
          "description": "The display format of the value label.",
          "default": "{style: 'percent'}"
        },
        "valueLabel": {
          "type": "property",
          "name": "valueLabel",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the value's label (e.g. 1 of 4).",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": "0"
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The smallest value allowed for the input.",
          "default": "0"
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The largest value allowed for the input.",
          "default": "100"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "MeterRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterRenderProps",
      "name": "MeterRenderProps",
      "properties": {
        "percentage": {
          "type": "property",
          "name": "percentage",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The value as a percentage between the minimum and maximum.",
          "default": null
        },
        "valueText": {
          "type": "property",
          "name": "valueText",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "A formatted version of the value.",
          "selector": "[aria-valuetext]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ModalOverlayProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalOverlayProps",
      "name": "ModalOverlayProps",
      "properties": {
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the modal is currently performing an entry animation.",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the modal is currently performing an exit animation.",
          "default": null
        },
        "UNSTABLE_portalContainer": {
          "type": "property",
          "name": "UNSTABLE_portalContainer",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": true,
          "description": "The container element in which the overlay portal will be placed. This may have unknown behavior depending on where it is portalled to.",
          "access": "private",
          "default": "document.body"
        },
        "isDismissable": {
          "type": "property",
          "name": "isDismissable",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to close the modal when the user interacts outside it.",
          "default": "false"
        },
        "isKeyboardDismissDisabled": {
          "type": "property",
          "name": "isKeyboardDismissDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether pressing the escape key to close the modal should be disabled.",
          "default": "false"
        },
        "shouldCloseOnInteractOutside": {
          "type": "property",
          "name": "shouldCloseOnInteractOutside",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "element",
                "value": {
                  "type": "identifier",
                  "name": "Element"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "When user interacts with the argument element outside of the overlay ref,\nreturn true if onClose should be called.  This gives you a chance to filter\nout interaction with elements that should not dismiss the overlay.\nBy default, onClose will always be called on interaction outside the overlay ref.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ModalRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps",
      "name": "ModalRenderProps",
      "properties": {
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the modal is currently entering. Use this to apply animations.",
          "selector": "[data-entering]",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the modal is currently exiting. Use this to apply animations.",
          "selector": "[data-exiting]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/overlays/src/useOverlayTriggerState.ts:OverlayTriggerState"
          },
          "optional": false,
          "description": "State of the modal.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "NumberFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldProps",
      "name": "NumberFieldProps",
      "properties": {
        "decrementAriaLabel": {
          "type": "property",
          "name": "decrementAriaLabel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A custom aria-label for the decrement button. If not provided, the localized string \"Decrement\" is used.",
          "default": null
        },
        "incrementAriaLabel": {
          "type": "property",
          "name": "incrementAriaLabel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A custom aria-label for the increment button. If not provided, the localized string \"Increment\" is used.",
          "default": null
        },
        "isWheelDisabled": {
          "type": "property",
          "name": "isWheelDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Enables or disables changing the value with scroll.",
          "default": null
        },
        "formatOptions": {
          "type": "property",
          "name": "formatOptions",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Intl.NumberFormatOptions"
          },
          "optional": true,
          "description": "Formatting options for the value displayed in the number field.\nThis also affects what characters are allowed to be typed by the user.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The smallest value allowed for the input.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The largest value allowed for the input.",
          "default": null
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The amount that the input value changes with each increment or decrement \"tick\".",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "onCopy": {
          "type": "property",
          "name": "onCopy",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
          "default": null
        },
        "onCut": {
          "type": "property",
          "name": "onCut",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
          "default": null
        },
        "onPaste": {
          "type": "property",
          "name": "onPaste",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
          "default": null
        },
        "onCompositionStart": {
          "type": "property",
          "name": "onCompositionStart",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
          "default": null
        },
        "onCompositionEnd": {
          "type": "property",
          "name": "onCompositionEnd",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
          "default": null
        },
        "onCompositionUpdate": {
          "type": "property",
          "name": "onCompositionUpdate",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
          "default": null
        },
        "onSelect": {
          "type": "property",
          "name": "onSelect",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReactEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
          "default": null
        },
        "onBeforeInput": {
          "type": "property",
          "name": "onBeforeInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
          "default": null
        },
        "onInput": {
          "type": "property",
          "name": "onInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "NumberFieldRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldRenderProps",
      "name": "NumberFieldRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the number field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the number field is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the number field is required.",
          "selector": "[data-required]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/numberfield/src/useNumberFieldState.ts:NumberFieldState"
          },
          "optional": false,
          "description": "State of the number field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "OverlayArrowProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowProps",
      "name": "OverlayArrowProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "HTMLAttributes"
        }
      ]
    },
    "OverlayArrowRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowRenderProps",
      "name": "OverlayArrowRenderProps",
      "properties": {
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The placement of the overlay relative to the trigger.",
          "selector": "[data-placement=\"left | right | top | bottom\"]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "PopoverProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverProps",
      "name": "PopoverProps",
      "properties": {
        "trigger": {
          "type": "property",
          "name": "trigger",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the component that triggered the popover. This is reflected on the element\nas the `data-trigger` attribute, and can be used to provide specific\nstyles for the popover depending on which element triggered it.",
          "default": null
        },
        "triggerRef": {
          "type": "property",
          "name": "triggerRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "Element"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref for the element which the popover positions itself with respect to.\n\nWhen used within a trigger component such as DialogTrigger, MenuTrigger, Select, etc.,\nthis is set automatically. It is only required when used standalone.",
          "default": null
        },
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the popover is currently performing an entry animation.",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the popover is currently performing an exit animation.",
          "default": null
        },
        "UNSTABLE_portalContainer": {
          "type": "property",
          "name": "UNSTABLE_portalContainer",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": true,
          "description": "The container element in which the overlay portal will be placed. This may have unknown behavior depending on where it is portalled to.",
          "access": "private",
          "default": "document.body"
        },
        "offset": {
          "type": "property",
          "name": "offset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
          "default": "8"
        },
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement"
          },
          "optional": true,
          "description": "The placement of the element with respect to its anchor element.",
          "default": "'bottom'"
        },
        "containerPadding": {
          "type": "property",
          "name": "containerPadding",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
          "default": "12"
        },
        "crossOffset": {
          "type": "property",
          "name": "crossOffset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
          "default": "0"
        },
        "shouldFlip": {
          "type": "property",
          "name": "shouldFlip",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
          "default": "true"
        },
        "arrowRef": {
          "type": "property",
          "name": "arrowRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "Element"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the popover arrow element.",
          "default": null
        },
        "isNonModal": {
          "type": "property",
          "name": "isNonModal",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the popover is non-modal, i.e. elements outside the popover may be\ninteracted with by assistive technologies.\n\nMost popovers should not use this option as it may negatively impact the screen\nreader experience. Only use with components such as combobox, which are designed\nto handle this situation carefully.",
          "default": null
        },
        "isKeyboardDismissDisabled": {
          "type": "property",
          "name": "isKeyboardDismissDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether pressing the escape key to close the popover should be disabled.\n\nMost popovers should not use this option. When set to true, an alternative\nway to close the popover with a keyboard must be provided.",
          "default": "false"
        },
        "shouldCloseOnInteractOutside": {
          "type": "property",
          "name": "shouldCloseOnInteractOutside",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "element",
                "value": {
                  "type": "identifier",
                  "name": "Element"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "When user interacts with the argument element outside of the popover ref,\nreturn true if onClose should be called. This gives you a chance to filter\nout interaction with elements that should not dismiss the popover.\nBy default, onClose will always be called on interaction outside the popover ref.",
          "default": null
        },
        "boundaryElement": {
          "type": "property",
          "name": "boundaryElement",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": true,
          "description": "Element that that serves as the positioning boundary.",
          "default": "document.body"
        },
        "scrollRef": {
          "type": "property",
          "name": "scrollRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "Element"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the scrollable region within the overlay.",
          "default": "overlayRef"
        },
        "shouldUpdatePosition": {
          "type": "property",
          "name": "shouldUpdatePosition",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay should update its position automatically.",
          "default": "true"
        },
        "maxHeight": {
          "type": "property",
          "name": "maxHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maxHeight specified for the overlay element.\nBy default, it will take all space up to the current viewport height.",
          "default": null
        },
        "arrowBoundaryOffset": {
          "type": "property",
          "name": "arrowBoundaryOffset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum distance the arrow's edge should be from the edge of the overlay element.",
          "default": "0"
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "PopoverRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps",
      "name": "PopoverRenderProps",
      "properties": {
        "trigger": {
          "type": "property",
          "name": "trigger",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The name of the component that triggered the popover, e.g. \"DialogTrigger\" or \"ComboBox\".",
          "selector": "[data-trigger=\"...\"]",
          "default": null
        },
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The placement of the popover relative to the trigger.",
          "selector": "[data-placement=\"left | right | top | bottom\"]",
          "default": null
        },
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the popover is currently entering. Use this to apply animations.",
          "selector": "[data-entering]",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the popover is currently exiting. Use this to apply animations.",
          "selector": "[data-exiting]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ProgressBarProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarProps",
      "name": "ProgressBarProps",
      "properties": {
        "isIndeterminate": {
          "type": "property",
          "name": "isIndeterminate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether presentation is indeterminate when progress isn't known.",
          "default": null
        },
        "formatOptions": {
          "type": "property",
          "name": "formatOptions",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Intl.NumberFormatOptions"
          },
          "optional": true,
          "description": "The display format of the value label.",
          "default": "{style: 'percent'}"
        },
        "valueLabel": {
          "type": "property",
          "name": "valueLabel",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the value's label (e.g. 1 of 4).",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": "0"
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The smallest value allowed for the input.",
          "default": "0"
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The largest value allowed for the input.",
          "default": "100"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ProgressBarRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarRenderProps",
      "name": "ProgressBarRenderProps",
      "properties": {
        "percentage": {
          "type": "property",
          "name": "percentage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "The value as a percentage between the minimum and maximum.",
          "default": null
        },
        "valueText": {
          "type": "property",
          "name": "valueText",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "A formatted version of the value.",
          "selector": "[aria-valuetext]",
          "default": null
        },
        "isIndeterminate": {
          "type": "property",
          "name": "isIndeterminate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the progress bar is indeterminate.",
          "selector": ":not([aria-valuenow])",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RadioGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupProps",
      "name": "RadioGroupProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The axis the Radio Button(s) should align with.",
          "default": "'vertical'"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RadioGroupRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupRenderProps",
      "name": "RadioGroupRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the radio group.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is required.",
          "selector": "[data-required]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/radio/src/useRadioGroupState.ts:RadioGroupState"
          },
          "optional": false,
          "description": "State of the radio group.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RadioProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioProps",
      "name": "RadioProps",
      "properties": {
        "inputRef": {
          "type": "property",
          "name": "inputRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the HTML input element.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The value of the radio button, used when submitting an HTML form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio#Value).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the radio button is disabled or not.\nShows that a selection exists, but is not available in that circumstance.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RadioRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioRenderProps",
      "name": "RadioRenderProps",
      "properties": {
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is required.",
          "selector": "[data-required]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SearchFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldProps",
      "name": "SearchFieldProps",
      "properties": {
        "enterKeyHint": {
          "type": "property",
          "name": "enterKeyHint",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "enter"
              },
              {
                "type": "string",
                "value": "done"
              },
              {
                "type": "string",
                "value": "go"
              },
              {
                "type": "string",
                "value": "next"
              },
              {
                "type": "string",
                "value": "previous"
              },
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "send"
              }
            ]
          },
          "optional": true,
          "description": "An enumerated attribute that defines what action label or icon to preset for the enter key on virtual keyboards. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint).",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "url"
              },
              {
                "type": "string",
                "value": "tel"
              },
              {
                "type": "string",
                "value": "email"
              },
              {
                "type": "string",
                "value": "password"
              },
              {
                "type": "intersection",
                "types": [
                  {
                    "type": "string"
                  },
                  {
                    "type": "object",
                    "properties": {}
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
          "default": "'search'"
        },
        "onSubmit": {
          "type": "property",
          "name": "onSubmit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the SearchField is submitted.",
          "default": null
        },
        "onClear": {
          "type": "property",
          "name": "onClear",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the clear button is pressed.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-activedescendant": {
          "type": "property",
          "name": "aria-activedescendant",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
          "default": null
        },
        "aria-autocomplete": {
          "type": "property",
          "name": "aria-autocomplete",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "inline"
              },
              {
                "type": "string",
                "value": "list"
              },
              {
                "type": "string",
                "value": "both"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "maxLength": {
          "type": "property",
          "name": "maxLength",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
          "default": null
        },
        "minLength": {
          "type": "property",
          "name": "minLength",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
          "default": null
        },
        "pattern": {
          "type": "property",
          "name": "pattern",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
          "default": null
        },
        "inputMode": {
          "type": "property",
          "name": "inputMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "tel"
              },
              {
                "type": "string",
                "value": "url"
              },
              {
                "type": "string",
                "value": "email"
              },
              {
                "type": "string",
                "value": "numeric"
              },
              {
                "type": "string",
                "value": "decimal"
              },
              {
                "type": "string",
                "value": "search"
              }
            ]
          },
          "optional": true,
          "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
          "default": null
        },
        "autoCorrect": {
          "type": "property",
          "name": "autoCorrect",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An attribute that takes as its value a space-separated string that describes what, if any, type of autocomplete functionality the input should provide. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#autocomplete).",
          "default": null
        },
        "spellCheck": {
          "type": "property",
          "name": "spellCheck",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An enumerated attribute that defines whether the element may be checked for spelling errors. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "onCopy": {
          "type": "property",
          "name": "onCopy",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
          "default": null
        },
        "onCut": {
          "type": "property",
          "name": "onCut",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
          "default": null
        },
        "onPaste": {
          "type": "property",
          "name": "onPaste",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
          "default": null
        },
        "onCompositionStart": {
          "type": "property",
          "name": "onCompositionStart",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
          "default": null
        },
        "onCompositionEnd": {
          "type": "property",
          "name": "onCompositionEnd",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
          "default": null
        },
        "onCompositionUpdate": {
          "type": "property",
          "name": "onCompositionUpdate",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
          "default": null
        },
        "onSelect": {
          "type": "property",
          "name": "onSelect",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReactEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
          "default": null
        },
        "onBeforeInput": {
          "type": "property",
          "name": "onBeforeInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
          "default": null
        },
        "onInput": {
          "type": "property",
          "name": "onInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SearchFieldRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldRenderProps",
      "name": "SearchFieldRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the search field is empty.",
          "selector": "[data-empty]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the search field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the search field is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/searchfield/src/useSearchFieldState.ts:SearchFieldState"
          },
          "optional": false,
          "description": "State of the search field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SelectProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectProps",
      "name": "SelectProps",
      "properties": {
        "placeholder": {
          "type": "property",
          "name": "placeholder",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Temporary text that occupies the select when it is empty.",
          "default": "'Select an item' (localized)"
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input, used when submitting an HTML form.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "Whether single or multiple selection is enabled.",
          "default": "'single'"
        },
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The currently selected key in the collection (controlled).",
          "access": "private",
          "default": null
        },
        "defaultSelectedKey": {
          "type": "property",
          "name": "defaultSelectedKey",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The initial selected key in the collection (uncontrolled).",
          "access": "private",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "access": "private",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Sets the open state of the menu.",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Sets the default open state of the menu.",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Method that is called when the open state of the menu changes.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValidationType"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": {
            "type": "object",
            "properties": {}
          }
        },
        {
          "type": "typeParameter",
          "name": "M",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectionMode"
          },
          "default": {
            "type": "string",
            "value": "single"
          }
        }
      ],
      "extends": []
    },
    "SelectValueProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueProps",
      "name": "SelectValueProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "extends": [
        {
          "type": "identifier",
          "name": "HTMLAttributes"
        }
      ]
    },
    "SelectValueRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueRenderProps",
      "name": "SelectValueRenderProps",
      "properties": {
        "isPlaceholder": {
          "type": "property",
          "name": "isPlaceholder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the value is a placeholder.",
          "selector": "[data-placeholder]",
          "default": null
        },
        "selectedItem": {
          "type": "property",
          "name": "selectedItem",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The object value of the first selected item.",
          "access": "private",
          "default": null
        },
        "selectedItems": {
          "type": "property",
          "name": "selectedItems",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "T"
                },
                {
                  "type": "null"
                }
              ]
            }
          },
          "optional": false,
          "description": "The object values of the currently selected items.",
          "default": null
        },
        "selectedText": {
          "type": "property",
          "name": "selectedText",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The textValue of the currently selected items.",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/select/src/useSelectState.ts:SelectState"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "union",
                "elements": [
                  {
                    "type": "string",
                    "value": "single"
                  },
                  {
                    "type": "string",
                    "value": "multiple"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The state of the select.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "SelectRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectRenderProps",
      "name": "SelectRenderProps",
      "properties": {
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is currently open.",
          "selector": "[data-open]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is required.",
          "selector": "[data-required]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SeparatorProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Separator.tsx:SeparatorProps",
      "name": "SeparatorProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The orientation of the separator.",
          "default": "'horizontal'"
        },
        "elementType": {
          "type": "property",
          "name": "elementType",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The HTML element type that will be used to render the separator.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SliderOutputProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderOutputProps",
      "name": "SliderOutputProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOutputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SliderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderProps",
      "name": "SliderProps",
      "properties": {
        "formatOptions": {
          "type": "property",
          "name": "formatOptions",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Intl.NumberFormatOptions"
          },
          "optional": true,
          "description": "The display format of the value label.",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The orientation of the Slider.",
          "default": "'horizontal'"
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the whole Slider is disabled.",
          "default": null
        },
        "onChangeEnd": {
          "type": "property",
          "name": "onChangeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Fired when the slider stops moving, due to being let go.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The slider's minimum value.",
          "default": "0"
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The slider's maximum value.",
          "default": "100"
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The slider's step value.",
          "default": "1"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "array",
                "elementType": {
                  "type": "number"
                }
              }
            ]
          }
        }
      ],
      "extends": []
    },
    "SliderRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps",
      "name": "SliderRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the slider.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the slider is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/slider/src/useSliderState.ts:SliderState"
          },
          "optional": false,
          "description": "State of the slider.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SliderThumbProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbProps",
      "name": "SliderThumbProps",
      "properties": {
        "inputRef": {
          "type": "property",
          "name": "inputRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the HTML input element.",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The orientation of the Slider.",
          "access": "private",
          "default": "'horizontal'"
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Thumb is disabled.",
          "default": null
        },
        "index": {
          "type": "property",
          "name": "index",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "Index of the thumb within the slider.",
          "default": "0"
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SliderTrackProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackProps",
      "name": "SliderTrackProps",
      "properties": {
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SliderTrackRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackRenderProps",
      "name": "SliderTrackRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the slider track is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the slider.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the slider is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/slider/src/useSliderState.ts:SliderState"
          },
          "optional": false,
          "description": "State of the slider.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SliderThumbRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbRenderProps",
      "name": "SliderThumbRenderProps",
      "properties": {
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/slider/src/useSliderState.ts:SliderState"
          },
          "optional": false,
          "description": "State of the slider.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether this thumb is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SwitchProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchProps",
      "name": "SwitchProps",
      "properties": {
        "inputRef": {
          "type": "property",
          "name": "inputRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the HTML input element.",
          "default": null
        },
        "defaultSelected": {
          "type": "property",
          "name": "defaultSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Switch should be selected (uncontrolled).",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Switch should be selected (controlled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isSelected",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the Switch's selection state changes.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SwitchRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchRenderProps",
      "name": "SwitchRenderProps",
      "properties": {
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleState.ts:ToggleState"
          },
          "optional": false,
          "description": "State of the switch.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TableProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableProps",
      "name": "TableProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The elements that make up the table. Includes the TableHeader, TableBody, Columns, and Rows.",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": true,
          "description": "How multiple selection should behave in the collection.",
          "default": "\"toggle\""
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "optional": true,
          "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
          "default": "\"selection\""
        },
        "onRowAction": {
          "type": "property",
          "name": "onRowAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on the row.",
          "default": null
        },
        "dragAndDropHooks": {
          "type": "property",
          "name": "dragAndDropHooks",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
          },
          "optional": true,
          "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the Table.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": true,
          "description": "A list of row keys to disable.",
          "default": null
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the table or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "shouldSelectOnPressUp": {
          "type": "property",
          "name": "shouldSelectOnPressUp",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether selection should occur on press up instead of press down.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "sortDescriptor": {
          "type": "property",
          "name": "sortDescriptor",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor"
          },
          "optional": true,
          "description": "The current sorted column and direction.",
          "default": null
        },
        "onSortChange": {
          "type": "property",
          "name": "onSortChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "descriptor",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the sorted column or direction changes.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TableRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableRenderProps",
      "name": "TableRenderProps",
      "properties": {
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/table/src/useTableState.ts:TableState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the table.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TableHeaderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableHeaderProps",
      "name": "TableHeaderProps",
      "properties": {
        "columns": {
          "type": "property",
          "name": "columns",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "A list of table columns.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "A list of `Column(s)` or a function. If the latter, a list of columns must be provided using the `columns` prop.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the column cache when using dynamic collections.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableHeaderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableHeaderRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TableBodyProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyProps",
      "name": "TableBodyProps",
      "properties": {
        "renderEmptyState": {
          "type": "property",
          "name": "renderEmptyState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides content to display when there are no rows in the table.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TableBodyRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps",
      "name": "TableBodyRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table body has no rows and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the Table is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ResizableTableContainerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ResizableTableContainerProps",
      "name": "ResizableTableContainerProps",
      "properties": {
        "onResizeStart": {
          "type": "property",
          "name": "onResizeStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "widths",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Map"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user starts a column resize.",
          "default": null
        },
        "onResize": {
          "type": "property",
          "name": "onResize",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "widths",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Map"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs a column resize.\nCan be used with the width property on columns to put the column widths into\na controlled state.",
          "default": null
        },
        "onResizeEnd": {
          "type": "property",
          "name": "onResizeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "widths",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Map"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called after a user performs a column resize.\nCan be used to store the widths of columns for another future session.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The children of the component.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColumnProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnProps",
      "name": "ColumnProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the column.",
          "default": null
        },
        "allowsSorting": {
          "type": "property",
          "name": "allowsSorting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the column allows sorting.",
          "default": null
        },
        "isRowHeader": {
          "type": "property",
          "name": "isRowHeader",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether a column is a [row header](https://www.w3.org/TR/wai-aria-1.1/#rowheader) and should be announced by assistive technology during row navigation.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the column's contents, used for accessibility announcements.",
          "default": null
        },
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
          "default": null
        },
        "defaultWidth": {
          "type": "property",
          "name": "defaultWidth",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
          "default": null
        },
        "minWidth": {
          "type": "property",
          "name": "minWidth",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
          "default": null
        },
        "maxWidth": {
          "type": "property",
          "name": "maxWidth",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColumnRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps",
      "name": "ColumnRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "allowsSorting": {
          "type": "property",
          "name": "allowsSorting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the column allows sorting.",
          "selector": "[data-allows-sorting]",
          "default": null
        },
        "sortDirection": {
          "type": "property",
          "name": "sortDirection",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "The current sort direction.",
          "selector": "[data-sort-direction=\"ascending | descending\"]",
          "default": null
        },
        "isResizing": {
          "type": "property",
          "name": "isResizing",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the column is currently being resized.",
          "selector": "[data-resizing]",
          "default": null
        },
        "sort": {
          "type": "method",
          "name": "sort",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "direction",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Triggers sorting for this column in the given direction.",
          "default": null
        },
        "startResize": {
          "type": "method",
          "name": "startResize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Starts column resizing if the table is contained in a `<ResizableTableContainer>` element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColumnResizerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerProps",
      "name": "ColumnResizerProps",
      "properties": {
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A custom accessibility label for the resizer.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColumnResizerRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerRenderProps",
      "name": "ColumnResizerRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the resizer is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the resizer is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the resizer is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isResizing": {
          "type": "property",
          "name": "isResizing",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the resizer is currently being resized.",
          "selector": "[data-resizing]",
          "default": null
        },
        "resizableDirection": {
          "type": "property",
          "name": "resizableDirection",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "right"
              },
              {
                "type": "string",
                "value": "left"
              },
              {
                "type": "string",
                "value": "both"
              }
            ]
          },
          "optional": false,
          "description": "The direction that the column is currently resizable.",
          "selector": "[data-resizable-direction=\"right | left | both\"]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RowProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:RowProps",
      "name": "RowProps",
      "properties": {
        "columns": {
          "type": "property",
          "name": "columns",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "A list of columns used when dynamically rendering cells.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The cells within the row. Supports static items or a function for dynamic rendering.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this row represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the cell cache when using dynamic collections.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the row's contents, used for features like typeahead.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the row is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on the row. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the row.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:RowRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:RowRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "RowRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:RowRenderProps",
      "name": "RowRenderProps",
      "properties": {
        "isFocusVisibleWithin": {
          "type": "property",
          "name": "isFocusVisibleWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the row's children have keyboard focus.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the row.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CellProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellProps",
      "name": "CellProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the cell.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the cell's contents, used for features like typeahead.",
          "default": null
        },
        "colSpan": {
          "type": "property",
          "name": "colSpan",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "Indicates how many columns the data cell spans.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CellRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps",
      "name": "CellRenderProps",
      "properties": {
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the cell.\n*",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TableLoadMoreItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableLoadMoreItemProps",
      "name": "TableLoadMoreItemProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The load more spinner to render when loading additional items.",
          "default": null
        },
        "isLoading": {
          "type": "property",
          "name": "isLoading",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether or not the loading spinner should be rendered or not.",
          "default": null
        },
        "scrollOffset": {
          "type": "property",
          "name": "scrollOffset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The amount of offset from the bottom of your scrollable region that should trigger load more.\nUses a percentage value relative to the scroll body's client height. Load more is then triggered\nwhen your current scroll position's distance from the bottom of the currently loaded list of items is less than\nor equal to the provided value. (e.g. 1 = 100% of the scroll region's height).",
          "default": "1"
        },
        "onLoadMore": {
          "type": "property",
          "name": "onLoadMore",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableRowElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TabListProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabListProps",
      "name": "TabListProps",
      "properties": {
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabListRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabListRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TabListRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabListRenderProps",
      "name": "TabListRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the tab list.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tabs/src/useTabListState.ts:TabListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the tab list.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TabPanelProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelProps",
      "name": "TabPanelProps",
      "properties": {
        "shouldForceMount": {
          "type": "property",
          "name": "shouldForceMount",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to mount the tab panel in the DOM even when it is not currently selected.\nInactive tab panels are inert and cannot be interacted with. They must be styled appropriately so this is clear to the user visually.",
          "default": "false"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the tab.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TabPanelRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelRenderProps",
      "name": "TabPanelRenderProps",
      "properties": {
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab panel is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab panel is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isInert": {
          "type": "property",
          "name": "isInert",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab panel is currently non-interactive. This occurs when the\n`shouldForceMount` prop is true, and the corresponding tab is not selected.",
          "selector": "[data-inert]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tabs/src/useTabListState.ts:TabListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the tab list.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TabProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabProps",
      "name": "TabProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the tab.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tab is disabled.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TabsProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsProps",
      "name": "TabsProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the TabList is disabled.\nShows that a selection exists, but is not available in that circumstance.",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The currently selected key in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKey": {
          "type": "property",
          "name": "defaultSelectedKey",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": true,
          "description": "The initial selected key in the collection (uncontrolled).",
          "default": null
        },
        "keyboardActivation": {
          "type": "property",
          "name": "keyboardActivation",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "automatic"
              },
              {
                "type": "string",
                "value": "manual"
              }
            ]
          },
          "optional": true,
          "description": "Whether tabs are activated automatically on focus or manually.",
          "default": "'automatic'"
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The orientation of the tabs.",
          "default": "'horizontal'"
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TabRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabRenderProps",
      "name": "TabRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TabsRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsRenderProps",
      "name": "TabsRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the tabs.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TagGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagGroupProps",
      "name": "TagGroupProps",
      "properties": {
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": true,
          "description": "How multiple selection should behave in the collection.",
          "default": null
        },
        "shouldSelectOnPressUp": {
          "type": "property",
          "name": "shouldSelectOnPressUp",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether selection should occur on press up instead of press down.",
          "default": null
        },
        "onRemove": {
          "type": "property",
          "name": "onRemove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user deletes a tag.",
          "default": null
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the TagGroup or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The children of the component.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TagListProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListProps",
      "name": "TagListProps",
      "properties": {
        "renderEmptyState": {
          "type": "property",
          "name": "renderEmptyState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListRenderProps"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides content to display when there are no items in the tag list.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TagListRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListRenderProps",
      "name": "TagListRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tag list has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tag list is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tag list is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the TagGroup.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TagProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagProps",
      "name": "TagProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "A unique id for the tag.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the tags's contents, used for accessibility.\nRequired if children is not a plain text string.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tag is disabled.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TagRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagRenderProps",
      "name": "TagRenderProps",
      "properties": {
        "allowsRemoving": {
          "type": "property",
          "name": "allowsRemoving",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tag group allows items to be removed.",
          "selector": "[data-allows-removing]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TextAreaProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextArea.tsx:TextAreaProps",
      "name": "TextAreaProps",
      "properties": {
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "TextareaHTMLAttributes"
        }
      ]
    },
    "TextFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldProps",
      "name": "TextFieldProps",
      "properties": {
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the value is invalid.",
          "default": null
        },
        "aria-activedescendant": {
          "type": "property",
          "name": "aria-activedescendant",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
          "default": null
        },
        "aria-autocomplete": {
          "type": "property",
          "name": "aria-autocomplete",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "inline"
              },
              {
                "type": "string",
                "value": "list"
              },
              {
                "type": "string",
                "value": "both"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "enterKeyHint": {
          "type": "property",
          "name": "enterKeyHint",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "enter"
              },
              {
                "type": "string",
                "value": "done"
              },
              {
                "type": "string",
                "value": "go"
              },
              {
                "type": "string",
                "value": "next"
              },
              {
                "type": "string",
                "value": "previous"
              },
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "send"
              }
            ]
          },
          "optional": true,
          "description": "An enumerated attribute that defines what action label or icon to preset for the enter key on virtual keyboards. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "maxLength": {
          "type": "property",
          "name": "maxLength",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
          "default": null
        },
        "minLength": {
          "type": "property",
          "name": "minLength",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
          "default": null
        },
        "pattern": {
          "type": "property",
          "name": "pattern",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "url"
              },
              {
                "type": "string",
                "value": "tel"
              },
              {
                "type": "string",
                "value": "email"
              },
              {
                "type": "string",
                "value": "password"
              },
              {
                "type": "intersection",
                "types": [
                  {
                    "type": "string"
                  },
                  {
                    "type": "object",
                    "properties": {}
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
          "default": "'text'"
        },
        "inputMode": {
          "type": "property",
          "name": "inputMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "tel"
              },
              {
                "type": "string",
                "value": "url"
              },
              {
                "type": "string",
                "value": "email"
              },
              {
                "type": "string",
                "value": "numeric"
              },
              {
                "type": "string",
                "value": "decimal"
              },
              {
                "type": "string",
                "value": "search"
              }
            ]
          },
          "optional": true,
          "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
          "default": null
        },
        "autoCorrect": {
          "type": "property",
          "name": "autoCorrect",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An attribute that takes as its value a space-separated string that describes what, if any, type of autocomplete functionality the input should provide. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#autocomplete).",
          "default": null
        },
        "spellCheck": {
          "type": "property",
          "name": "spellCheck",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An enumerated attribute that defines whether the element may be checked for spelling errors. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "onCopy": {
          "type": "property",
          "name": "onCopy",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
          "default": null
        },
        "onCut": {
          "type": "property",
          "name": "onCut",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
          "default": null
        },
        "onPaste": {
          "type": "property",
          "name": "onPaste",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
          "default": null
        },
        "onCompositionStart": {
          "type": "property",
          "name": "onCompositionStart",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
          "default": null
        },
        "onCompositionEnd": {
          "type": "property",
          "name": "onCompositionEnd",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
          "default": null
        },
        "onCompositionUpdate": {
          "type": "property",
          "name": "onCompositionUpdate",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
          "default": null
        },
        "onSelect": {
          "type": "property",
          "name": "onSelect",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReactEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
          "default": null
        },
        "onBeforeInput": {
          "type": "property",
          "name": "onBeforeInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
          "default": null
        },
        "onInput": {
          "type": "property",
          "name": "onInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TextFieldRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldRenderProps",
      "name": "TextFieldRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the text field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the value is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the text field is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the text field is required.",
          "selector": "[data-required]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TextProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Text.tsx:TextProps",
      "name": "TextProps",
      "properties": {
        "elementType": {
          "type": "property",
          "name": "elementType",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "HTMLAttributes"
        }
      ]
    },
    "ToastRegionProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionProps",
      "name": "ToastRegionProps",
      "properties": {
        "queue": {
          "type": "property",
          "name": "queue",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastQueue"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": false,
          "description": "The queue of toasts to display.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "renderProps",
                    "value": {
                      "type": "object",
                      "properties": {
                        "toast": {
                          "type": "property",
                          "name": "toast",
                          "indexType": null,
                          "value": {
                            "type": "application",
                            "base": {
                              "type": "link",
                              "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
                            },
                            "typeParameters": [
                              {
                                "type": "identifier",
                                "name": "T"
                              }
                            ]
                          },
                          "optional": false,
                          "default": null
                        }
                      }
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "description": "A function to render each toast, or children containing a `<ToastList>`.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for the toast region.",
          "default": "\"Notifications\""
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "ToastListProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastListProps",
      "name": "ToastListProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "renderProps",
                "value": {
                  "type": "object",
                  "properties": {
                    "toast": {
                      "type": "property",
                      "name": "toast",
                      "indexType": null,
                      "value": {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
                        },
                        "typeParameters": [
                          {
                            "type": "identifier",
                            "name": "T"
                          }
                        ]
                      },
                      "optional": false,
                      "default": null
                    }
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "A function to render each toast.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for the toast region.",
          "default": "\"Notifications\""
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "ToastRegionRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps",
      "name": "ToastRegionRenderProps",
      "properties": {
        "visibleToasts": {
          "type": "property",
          "name": "visibleToasts",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "A list of all currently visible toasts.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast region is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast region is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast region is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "ToastProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastProps",
      "name": "ToastProps",
      "properties": {
        "toast": {
          "type": "property",
          "name": "toast",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": false,
          "description": "The toast object.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "ToastRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRenderProps",
      "name": "ToastRenderProps",
      "properties": {
        "toast": {
          "type": "property",
          "name": "toast",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": false,
          "description": "The toast object to display.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "ToggleButtonProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonProps",
      "name": "ToggleButtonProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "When used in a ToggleButtonGroup, an identifier for the item in `selectedKeys`. When used standalone, a DOM id.",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should be selected (controlled).",
          "default": null
        },
        "defaultSelected": {
          "type": "property",
          "name": "defaultSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should be selected (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isSelected",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's selection state changes.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is disabled.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "aria-disabled": {
          "type": "property",
          "name": "aria-disabled",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element is disabled to users of assistive technology.",
          "default": null
        },
        "aria-expanded": {
          "type": "property",
          "name": "aria-expanded",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "aria-pressed": {
          "type": "property",
          "name": "aria-pressed",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "mixed"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the current \"pressed\" state of toggle buttons.",
          "default": null
        },
        "preventFocusOnPress": {
          "type": "property",
          "name": "preventFocusOnPress",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ToggleButtonRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonRenderProps",
      "name": "ToggleButtonRenderProps",
      "properties": {
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleState.ts:ToggleState"
          },
          "optional": false,
          "description": "State of the toggle button.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ToggleButtonGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupProps",
      "name": "ToggleButtonGroupProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The orientation of the the toggle button group.",
          "default": "'horizontal'"
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "single"
              },
              {
                "type": "string",
                "value": "multiple"
              }
            ]
          },
          "optional": true,
          "description": "Whether single or multiple selection is enabled.",
          "default": "'single'"
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether all items are disabled.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ToggleButtonGroupRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupRenderProps",
      "name": "ToggleButtonGroupRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toggle button group is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleGroupState.ts:ToggleGroupState"
          },
          "optional": false,
          "description": "State of the toggle button group.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ToolbarProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarProps",
      "name": "ToolbarProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The orientation of the entire toolbar.",
          "default": "'horizontal'"
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ToolbarRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarRenderProps",
      "name": "ToolbarRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The current orientation of the toolbar.",
          "selector": "[data-orientation]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TooltipProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipProps",
      "name": "TooltipProps",
      "properties": {
        "triggerRef": {
          "type": "property",
          "name": "triggerRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "Element"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref for the element which the tooltip positions itself with respect to.\n\nWhen used within a TooltipTrigger this is set automatically. It is only required when used standalone.",
          "default": null
        },
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tooltip is currently performing an entry animation.",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tooltip is currently performing an exit animation.",
          "default": null
        },
        "UNSTABLE_portalContainer": {
          "type": "property",
          "name": "UNSTABLE_portalContainer",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": true,
          "description": "The container element in which the overlay portal will be placed. This may have unknown behavior depending on where it is portalled to.",
          "access": "private",
          "default": "document.body"
        },
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement"
          },
          "optional": true,
          "description": "The placement of the tooltip with respect to the trigger.",
          "default": "'top'"
        },
        "containerPadding": {
          "type": "property",
          "name": "containerPadding",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
          "default": "12"
        },
        "offset": {
          "type": "property",
          "name": "offset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
          "default": "0"
        },
        "crossOffset": {
          "type": "property",
          "name": "crossOffset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
          "default": "0"
        },
        "shouldFlip": {
          "type": "property",
          "name": "shouldFlip",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
          "default": "true"
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element is rendered.",
          "default": null
        },
        "arrowBoundaryOffset": {
          "type": "property",
          "name": "arrowBoundaryOffset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum distance the arrow's edge should be from the edge of the overlay element.",
          "default": "0"
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TooltipRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipRenderProps",
      "name": "TooltipRenderProps",
      "properties": {
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The placement of the tooltip relative to the trigger.",
          "selector": "[data-placement=\"left | right | top | bottom\"]",
          "default": null
        },
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tooltip is currently entering. Use this to apply animations.",
          "selector": "[data-entering]",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tooltip is currently exiting. Use this to apply animations.",
          "selector": "[data-exiting]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/tooltip/src/useTooltipTriggerState.ts:TooltipTriggerState"
          },
          "optional": false,
          "description": "State of the tooltip.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TooltipTriggerComponentProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipTriggerComponentProps",
      "name": "TooltipTriggerComponentProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tooltip should be disabled, independent from the trigger.",
          "default": null
        },
        "delay": {
          "type": "property",
          "name": "delay",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The delay time for the tooltip to show up. [See guidelines](https://spectrum.adobe.com/page/tooltip/#Immediate-or-delayed-appearance).",
          "default": "1500"
        },
        "closeDelay": {
          "type": "property",
          "name": "closeDelay",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The delay time for the tooltip to close. [See guidelines](https://spectrum.adobe.com/page/tooltip/#Warmup-and-cooldown).",
          "default": "500"
        },
        "trigger": {
          "type": "property",
          "name": "trigger",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "hover"
              },
              {
                "type": "string",
                "value": "focus"
              }
            ]
          },
          "optional": true,
          "description": "By default, opens for both focus and hover. Can be made to open only for focus.",
          "default": "'hover'"
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TreeProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeProps",
      "name": "TreeProps",
      "properties": {
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": true,
          "description": "How multiple selection should behave in the tree.",
          "default": "\"toggle\""
        },
        "renderEmptyState": {
          "type": "property",
          "name": "renderEmptyState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeEmptyStateRenderProps"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides content to display when there are no items in the list.",
          "default": null
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "optional": true,
          "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
          "default": "'all'"
        },
        "dragAndDropHooks": {
          "type": "property",
          "name": "dragAndDropHooks",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "NoInfer"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the Tree.",
          "default": null
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the grid list or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              }
            ]
          },
          "optional": true,
          "description": "Whether to auto focus the gridlist or an option.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "shouldSelectOnPressUp": {
          "type": "property",
          "name": "shouldSelectOnPressUp",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether selection should occur on press up instead of press down.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "expandedKeys": {
          "type": "property",
          "name": "expandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The currently expanded keys in the collection (controlled).",
          "default": null
        },
        "defaultExpandedKeys": {
          "type": "property",
          "name": "defaultExpandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The initial expanded keys in the collection (uncontrolled).",
          "default": null
        },
        "onExpandedChange": {
          "type": "property",
          "name": "onExpandedChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are expanded or collapsed.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TreeRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeRenderProps",
      "name": "TreeRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the tree.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TreeItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemProps",
      "name": "TreeItemProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the tree row.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this tree item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A string representation of the tree item's contents, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this tree item.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content of the tree item along with any nested children. Supports static nested tree items or use of a Collection to dynamically render nested tree items.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on this tree item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "hasChildItems": {
          "type": "property",
          "name": "hasChildItems",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether this item has children, even if not loaded yet.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "TreeItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemRenderProps",
      "name": "TreeItemRenderProps",
      "properties": {
        "isExpanded": {
          "type": "property",
          "name": "isExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree item is expanded.",
          "selector": "[data-expanded]",
          "default": null
        },
        "hasChildItems": {
          "type": "property",
          "name": "hasChildItems",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree item has child tree items.",
          "selector": "[data-has-child-items]",
          "default": null
        },
        "level": {
          "type": "property",
          "name": "level",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "What level the tree item has within the tree.",
          "selector": "[data-level=\"number\"]",
          "default": null
        },
        "isFocusVisibleWithin": {
          "type": "property",
          "name": "isFocusVisibleWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree item's children have keyboard focus.",
          "selector": "[data-focus-visible-within]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "The state of the tree.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "description": "The unique id of the tree row.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TreeItemContentProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemContentProps",
      "name": "TreeItemContentProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TreeItemContentRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemContentRenderProps",
      "name": "TreeItemContentRenderProps",
      "properties": {
        "isExpanded": {
          "type": "property",
          "name": "isExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree item is expanded.",
          "selector": "[data-expanded]",
          "default": null
        },
        "hasChildItems": {
          "type": "property",
          "name": "hasChildItems",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree item has child tree items.",
          "selector": "[data-has-child-items]",
          "default": null
        },
        "level": {
          "type": "property",
          "name": "level",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "What level the tree item has within the tree.",
          "selector": "[data-level=\"number\"]",
          "default": null
        },
        "isFocusVisibleWithin": {
          "type": "property",
          "name": "isFocusVisibleWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree item's children have keyboard focus.",
          "selector": "[data-focus-visible-within]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "The state of the tree.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "description": "The unique id of the tree row.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TreeLoadMoreItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemProps",
      "name": "TreeLoadMoreItemProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The load more spinner to render when loading additional items.",
          "default": null
        },
        "isLoading": {
          "type": "property",
          "name": "isLoading",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether or not the loading spinner should be rendered or not.",
          "default": null
        },
        "scrollOffset": {
          "type": "property",
          "name": "scrollOffset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The amount of offset from the bottom of your scrollable region that should trigger load more.\nUses a percentage value relative to the scroll body's client height. Load more is then triggered\nwhen your current scroll position's distance from the bottom of the currently loaded list of items is less than\nor equal to the provided value. (e.g. 1 = 100% of the scroll region's height).",
          "default": "1"
        },
        "onLoadMore": {
          "type": "property",
          "name": "onLoadMore",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TreeLoadMoreItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemRenderProps",
      "name": "TreeLoadMoreItemRenderProps",
      "properties": {
        "level": {
          "type": "property",
          "name": "level",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "What level the tree item has within the tree.",
          "selector": "[data-level]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DragOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrag.ts:DragOptions",
      "name": "DragOptions",
      "properties": {
        "onDragStart": {
          "type": "property",
          "name": "onDragStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragStartEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a drag operation is started.",
          "default": null
        },
        "onDragMove": {
          "type": "property",
          "name": "onDragMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag is moved.",
          "default": null
        },
        "onDragEnd": {
          "type": "property",
          "name": "onDragEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragEndEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag operation is ended, either as a result of a drop or a cancellation.",
          "default": null
        },
        "getItems": {
          "type": "property",
          "name": "getItems",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
              }
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "A function that returns the items being dragged.",
          "default": null
        },
        "preview": {
          "type": "property",
          "name": "preview",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref of the element that will be rendered as the drag preview while dragging.",
          "default": null
        },
        "getAllowedDropOperations": {
          "type": "property",
          "name": "getAllowedDropOperations",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
              }
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Function that returns the drop operations that are allowed for the dragged items. If not provided, all drop operations are allowed.",
          "default": null
        },
        "hasDragButton": {
          "type": "property",
          "name": "hasDragButton",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item has an explicit focusable drag affordance to initiate accessible drag and drop mode.\nIf true, the dragProps will omit these event handlers, and they will be applied to dragButtonProps instead.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drag operation is disabled. If true, the element will not be draggable.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DragResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrag.ts:DragResult",
      "name": "DragResult",
      "properties": {
        "dragProps": {
          "type": "property",
          "name": "dragProps",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "HTMLAttributes"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          },
          "optional": false,
          "description": "Props for the draggable element.",
          "default": null
        },
        "dragButtonProps": {
          "type": "property",
          "name": "dragButtonProps",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/button/src/index.d.ts:AriaButtonProps"
          },
          "optional": false,
          "description": "Props for the explicit drag button affordance, if any.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the element is currently being dragged.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "DragAndDropHooks": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
    },
    "DragAndDropOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropOptions",
      "name": "DragAndDropOptions",
      "properties": {
        "getItems": {
          "type": "property",
          "name": "getItems",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "items",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "identifier",
                    "name": "T"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
              }
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns the items being dragged. If not specified, we assume that the collection is not draggable.",
          "default": "() => []"
        },
        "renderDragPreview": {
          "type": "property",
          "name": "renderDragPreview",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "items",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "JSX.Element"
                },
                {
                  "type": "object",
                  "properties": {
                    "element": {
                      "type": "property",
                      "name": "element",
                      "indexType": null,
                      "value": {
                        "type": "identifier",
                        "name": "JSX.Element"
                      },
                      "optional": false,
                      "default": null
                    },
                    "x": {
                      "type": "property",
                      "name": "x",
                      "indexType": null,
                      "value": {
                        "type": "number"
                      },
                      "optional": false,
                      "default": null
                    },
                    "y": {
                      "type": "property",
                      "name": "y",
                      "indexType": null,
                      "value": {
                        "type": "number"
                      },
                      "optional": false,
                      "default": null
                    }
                  }
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that renders a drag preview, which is shown under the user's cursor while dragging.\nBy default, a copy of the dragged element is rendered.",
          "default": null
        },
        "renderDropIndicator": {
          "type": "property",
          "name": "renderDropIndicator",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "JSX.Element",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that renders a drop indicator element between two items in a collection.\nThis should render a `<DropIndicator>` element. If this function is not provided, a\ndefault DropIndicator is provided.",
          "default": null
        },
        "dropTargetDelegate": {
          "type": "property",
          "name": "dropTargetDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate"
          },
          "optional": true,
          "description": "A custom delegate object that provides drop targets for pointer coordinates within the collection.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drag and drop events should be disabled.",
          "default": null
        },
        "onDragStart": {
          "type": "property",
          "name": "onDragStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionStartEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a drag operation is started.",
          "default": null
        },
        "onDragMove": {
          "type": "property",
          "name": "onDragMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag is moved.",
          "default": null
        },
        "onDragEnd": {
          "type": "property",
          "name": "onDragEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag operation is ended, either as a result of a drop or a cancellation.",
          "default": null
        },
        "getAllowedDropOperations": {
          "type": "property",
          "name": "getAllowedDropOperations",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
              }
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Function that returns the drop operations that are allowed for the dragged items. If not provided, all drop operations are allowed.",
          "default": null
        },
        "acceptedDragTypes": {
          "type": "property",
          "name": "acceptedDragTypes",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Array"
                },
                "typeParameters": [
                  {
                    "type": "union",
                    "elements": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "symbol"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The drag types that the droppable collection accepts. If the collection accepts directories, include `DIRECTORY_DRAG_TYPE` in your array of allowed types.",
          "default": "'all'"
        },
        "onInsert": {
          "type": "property",
          "name": "onInsert",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped \"between\" items.",
          "default": null
        },
        "onRootDrop": {
          "type": "property",
          "name": "onRootDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped on the droppable collection's root.",
          "default": null
        },
        "onItemDrop": {
          "type": "property",
          "name": "onItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are dropped \"on\" an item.",
          "default": null
        },
        "onReorder": {
          "type": "property",
          "name": "onReorder",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are reordered within the collection.\nThis handler only allows dropping between items, not on items.\nIt does not allow moving items to a different parent item within a tree.",
          "default": null
        },
        "onMove": {
          "type": "property",
          "name": "onMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are moved within the source collection.\nThis handler allows dropping both on or between items, and items may be\nmoved to a different parent item within a tree.",
          "default": null
        },
        "shouldAcceptItemDrop": {
          "type": "property",
          "name": "shouldAcceptItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning whether a given target in the droppable collection is a valid \"on\" drop target for the current drag types.",
          "default": null
        },
        "onDropEnter": {
          "type": "property",
          "name": "onDropEnter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag enters a drop target.",
          "default": null
        },
        "onDropActivate": {
          "type": "property",
          "name": "onDropActivate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionActivateEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called after a valid drag is held over a drop target for a period of time.",
          "default": null
        },
        "onDropExit": {
          "type": "property",
          "name": "onDropExit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag exits a drop target.",
          "default": null
        },
        "onDrop": {
          "type": "property",
          "name": "onDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is dropped on a drop target. When defined, this overrides other\ndrop handlers such as `onInsert`, and `onItemDrop`.",
          "default": null
        },
        "getDropOperation": {
          "type": "property",
          "name": "getDropOperation",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "allowedOperations",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "DropIndicatorProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorProps",
      "name": "DropIndicatorProps",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target that the drop indicator represents.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DropIndicatorRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorRenderProps",
      "name": "DropIndicatorRenderProps",
      "properties": {
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drop indicator is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ContextValue": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ContextValue"
    },
    "RenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:RenderProps",
      "name": "RenderProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "SlotProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlotProps",
      "name": "SlotProps",
      "properties": {
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "StyleRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleRenderProps",
      "name": "StyleRenderProps",
      "properties": {
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "VirtualizerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:VirtualizerProps",
      "name": "VirtualizerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The child collection to virtualize (e.g. ListBox, GridList, or Table).",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:LayoutClass"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "O"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:ILayout"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "O"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The layout object that determines the position and size of the visible elements.",
          "default": null
        },
        "layoutOptions": {
          "type": "property",
          "name": "layoutOptions",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "O"
          },
          "optional": true,
          "description": "Options for the layout.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "O",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "DateValue": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
    },
    "DateRange": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateRange"
    },
    "TimeValue": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
    },
    "DirectoryDropItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DirectoryDropItem",
      "name": "DirectoryDropItem",
      "properties": {
        "kind": {
          "type": "property",
          "name": "kind",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "directory"
          },
          "optional": false,
          "description": "The item kind.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The directory name.",
          "default": null
        },
        "getEntries": {
          "type": "method",
          "name": "getEntries",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "AsyncIterable"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:FileDropItem"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DirectoryDropItem"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the entries contained within the directory.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DraggableCollectionEndEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent",
      "name": "DraggableCollectionEndEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were dragged.",
          "default": null
        },
        "isInternal": {
          "type": "property",
          "name": "isInternal",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drop ended within the same collection as it originated.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragend"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that occurred.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DraggableCollectionMoveEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionMoveEvent",
      "name": "DraggableCollectionMoveEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were dragged.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragmove"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DraggableCollectionStartEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionStartEvent",
      "name": "DraggableCollectionStartEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were dragged.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragstart"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DragPreviewRenderer": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer"
    },
    "DragTypes": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes",
      "name": "DragTypes",
      "properties": {
        "has": {
          "type": "method",
          "name": "has",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "symbol"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the drag contains data of the given type.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DropItem": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
    },
    "DropOperation": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
    },
    "DroppableCollectionDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent",
      "name": "DroppableCollectionDropEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "drop"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DroppableCollectionEnterEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent",
      "name": "DroppableCollectionEnterEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropenter"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DroppableCollectionExitEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent",
      "name": "DroppableCollectionExitEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropexit"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DroppableCollectionInsertDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent",
      "name": "DroppableCollectionInsertDropEvent",
      "properties": {
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DroppableCollectionMoveEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionMoveEvent",
      "name": "DroppableCollectionMoveEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropmove"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DroppableCollectionOnItemDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent",
      "name": "DroppableCollectionOnItemDropEvent",
      "properties": {
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "isInternal": {
          "type": "property",
          "name": "isInternal",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drag originated within the same collection as the drop.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DroppableCollectionReorderEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent",
      "name": "DroppableCollectionReorderEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were reordered.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DroppableCollectionRootDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent",
      "name": "DroppableCollectionRootDropEvent",
      "properties": {
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DropPosition": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropPosition"
    },
    "DropTarget": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
    },
    "FileDropItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:FileDropItem",
      "name": "FileDropItem",
      "properties": {
        "kind": {
          "type": "property",
          "name": "kind",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "file"
          },
          "optional": false,
          "description": "The item kind.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The file type (usually a mime type).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The file name.",
          "default": null
        },
        "getFile": {
          "type": "method",
          "name": "getFile",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Promise"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "File"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the contents of the file as a blob.",
          "default": null
        },
        "getText": {
          "type": "method",
          "name": "getText",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Promise"
              },
              "typeParameters": [
                {
                  "type": "string"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the contents of the file as a string.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ItemDropTarget": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget",
      "name": "ItemDropTarget",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "item"
          },
          "optional": false,
          "description": "The drop target type.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": false,
          "description": "The item key.",
          "default": null
        },
        "dropPosition": {
          "type": "property",
          "name": "dropPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropPosition"
          },
          "optional": false,
          "description": "The drop position relative to the item.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RootDropTarget": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:RootDropTarget",
      "name": "RootDropTarget",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "root"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TextDropItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:TextDropItem",
      "name": "TextDropItem",
      "properties": {
        "kind": {
          "type": "property",
          "name": "kind",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "text"
          },
          "optional": false,
          "description": "The item kind.",
          "default": null
        },
        "types": {
          "type": "property",
          "name": "types",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "string"
              }
            ]
          },
          "optional": false,
          "description": "The drag types available for this item.\nThese are often mime types, but may be custom app-specific types.",
          "default": null
        },
        "getText": {
          "type": "method",
          "name": "getText",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Promise"
              },
              "typeParameters": [
                {
                  "type": "string"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the data for the given type as a string.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "PressEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent",
      "name": "PressEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "pressstart"
              },
              {
                "type": "string",
                "value": "pressend"
              },
              {
                "type": "string",
                "value": "pressup"
              },
              {
                "type": "string",
                "value": "press"
              }
            ]
          },
          "optional": false,
          "description": "The type of press event being fired.",
          "default": null
        },
        "pointerType": {
          "type": "property",
          "name": "pointerType",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PointerType"
          },
          "optional": false,
          "description": "The pointer type that triggered the press event.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": false,
          "description": "The target element of the press event.",
          "default": null
        },
        "shiftKey": {
          "type": "property",
          "name": "shiftKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the shift keyboard modifier was held during the press event.",
          "default": null
        },
        "ctrlKey": {
          "type": "property",
          "name": "ctrlKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the ctrl keyboard modifier was held during the press event.",
          "default": null
        },
        "metaKey": {
          "type": "property",
          "name": "metaKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the meta keyboard modifier was held during the press event.",
          "default": null
        },
        "altKey": {
          "type": "property",
          "name": "altKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the alt keyboard modifier was held during the press event.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "X position relative to the target.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "Y position relative to the target.",
          "default": null
        },
        "continuePropagation": {
          "type": "method",
          "name": "continuePropagation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "By default, press events stop propagation to parent elements.\nIn cases where a handler decides not to handle a specific event,\nit can call `continuePropagation()` to allow a parent to handle it.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CalendarState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:CalendarState",
      "name": "CalendarState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected date.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the currently selected date.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is in a read only state.",
          "default": null
        },
        "visibleRange": {
          "type": "property",
          "name": "visibleRange",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              }
            ]
          },
          "optional": false,
          "description": "The date range that is currently visible in the calendar.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "timeZone": {
          "type": "property",
          "name": "timeZone",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The time zone of the dates currently being displayed.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the selected value.",
          "access": "private",
          "default": null
        },
        "isValueInvalid": {
          "type": "property",
          "name": "isValueInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "default": null
        },
        "focusedDate": {
          "type": "property",
          "name": "focusedDate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          "optional": false,
          "description": "The currently focused date.",
          "default": null
        },
        "setFocusedDate": {
          "type": "method",
          "name": "setFocusedDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused date.",
          "default": null
        },
        "focusNextDay": {
          "type": "method",
          "name": "focusNextDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next calendar date.",
          "default": null
        },
        "focusPreviousDay": {
          "type": "method",
          "name": "focusPreviousDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous calendar date.",
          "default": null
        },
        "focusNextRow": {
          "type": "method",
          "name": "focusNextRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next row of dates, e.g. the next week.",
          "default": null
        },
        "focusPreviousRow": {
          "type": "method",
          "name": "focusPreviousRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous row of dates, e.g. the previous work.",
          "default": null
        },
        "focusNextPage": {
          "type": "method",
          "name": "focusNextPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next page of dates, e.g. the next month if one month is visible.",
          "default": null
        },
        "focusPreviousPage": {
          "type": "method",
          "name": "focusPreviousPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous page of dates, e.g. the previous month if one month is visible.",
          "default": null
        },
        "focusSectionStart": {
          "type": "method",
          "name": "focusSectionStart",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the start of the current section of dates, e.g. the start of the current month.",
          "default": null
        },
        "focusSectionEnd": {
          "type": "method",
          "name": "focusSectionEnd",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the end of the current section of dates, e.g. the end of the current month month.",
          "default": null
        },
        "focusNextSection": {
          "type": "method",
          "name": "focusNextSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved forward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the next year.",
          "default": null
        },
        "focusPreviousSection": {
          "type": "method",
          "name": "focusPreviousSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved backward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the previous year.",
          "default": null
        },
        "selectFocusedDate": {
          "type": "method",
          "name": "selectFocusedDate",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the currently focused date.",
          "default": null
        },
        "selectDate": {
          "type": "method",
          "name": "selectDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the given date.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether focus is currently within the calendar.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether focus is currently within the calendar.",
          "default": null
        },
        "isInvalid": {
          "type": "method",
          "name": "isInvalid",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is invalid according to the `minValue` and `maxValue` props.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently selected.",
          "default": null
        },
        "isCellFocused": {
          "type": "method",
          "name": "isCellFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently focused.",
          "default": null
        },
        "isCellDisabled": {
          "type": "method",
          "name": "isCellDisabled",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is disabled according to the `minValue, `maxValue`, and `isDisabled` props.",
          "default": null
        },
        "isCellUnavailable": {
          "type": "method",
          "name": "isCellUnavailable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is unavailable according to the `isDateUnavailable` prop.",
          "default": null
        },
        "isPreviousVisibleRangeInvalid": {
          "type": "method",
          "name": "isPreviousVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the previous visible date range is allowed to be selected according to the `minValue` prop.",
          "default": null
        },
        "isNextVisibleRangeInvalid": {
          "type": "method",
          "name": "isNextVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the next visible date range is allowed to be selected according to the `maxValue` prop.",
          "default": null
        },
        "getDatesInWeek": {
          "type": "method",
          "name": "getDatesInWeek",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "weekIndex",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "startDate",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Array"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns an array of dates in the week index counted from the provided start date, or the first visible date if not given.\nThe returned array always has 7 elements, but may include null if the date does not exist according to the calendar system.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CheckboxGroupState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/checkbox/src/useCheckboxGroupState.ts:CheckboxGroupState",
      "name": "CheckboxGroupState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "typeOperator",
            "operator": "readonly",
            "value": {
              "type": "array",
              "elementType": {
                "type": "string"
              }
            }
          },
          "optional": false,
          "description": "Current selected values.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "typeOperator",
            "operator": "readonly",
            "value": {
              "type": "array",
              "elementType": {
                "type": "string"
              }
            }
          },
          "optional": false,
          "description": "Default selected values.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is read only.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the checkbox group.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is invalid.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkboxes in the group are required.\nThis changes to false once at least one item is selected.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given value is selected.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "string"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected values.",
          "default": null
        },
        "addValue": {
          "type": "method",
          "name": "addValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Adds a value to the set of selected values.",
          "default": null
        },
        "removeValue": {
          "type": "method",
          "name": "removeValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Removes a value from the set of selected values.",
          "default": null
        },
        "toggleValue": {
          "type": "method",
          "name": "toggleValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles a value in the set of selected values.",
          "default": null
        },
        "setInvalid": {
          "type": "method",
          "name": "setInvalid",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "validation",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether one of the checkboxes is invalid.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "Color": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color",
      "name": "Color",
      "properties": {
        "toFormat": {
          "type": "method",
          "name": "toFormat",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "format",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Converts the color to the given color format, and returns a new Color object.",
          "default": null
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "format",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat"
                    },
                    {
                      "type": "string",
                      "value": "css"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the color to a string in the given format.",
          "default": null
        },
        "clone": {
          "type": "method",
          "name": "clone",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Returns a duplicate of the color value.",
          "default": null
        },
        "toHexInt": {
          "type": "method",
          "name": "toHexInt",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the color to hex, and returns an integer representation.",
          "default": null
        },
        "getChannelValue": {
          "type": "method",
          "name": "getChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the numeric value for a given channel.\nThrows an error if the channel is unsupported in the current color format.",
          "default": null
        },
        "withChannelValue": {
          "type": "method",
          "name": "withChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Sets the numeric value for a given channel, and returns a new Color object.\nThrows an error if the channel is unsupported in the current color format.",
          "default": null
        },
        "getChannelRange": {
          "type": "method",
          "name": "getChannelRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannelRange"
            },
            "typeParameters": []
          },
          "description": "Returns the minimum, maximum, and step values for a given channel.",
          "default": null
        },
        "getChannelName": {
          "type": "method",
          "name": "getChannelName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized color channel name for a given channel and locale,\nfor use in visual or accessibility labels.",
          "default": null
        },
        "getChannelFormatOptions": {
          "type": "method",
          "name": "getChannelFormatOptions",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the number formatting options for the given channel.",
          "default": null
        },
        "formatChannelValue": {
          "type": "method",
          "name": "formatChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats the numeric value for a given channel for display according to the provided locale.",
          "default": null
        },
        "getColorSpace": {
          "type": "method",
          "name": "getColorSpace",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
            },
            "typeParameters": []
          },
          "description": "Returns the color space, 'rgb', 'hsb' or 'hsl', for the current color.",
          "default": null
        },
        "getColorSpaceAxes": {
          "type": "method",
          "name": "getColorSpaceAxes",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "xyChannels",
                "value": {
                  "type": "object",
                  "properties": {
                    "xChannel": {
                      "type": "property",
                      "name": "xChannel",
                      "indexType": null,
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                      },
                      "optional": true,
                      "default": null
                    },
                    "yChannel": {
                      "type": "property",
                      "name": "yChannel",
                      "indexType": null,
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                      },
                      "optional": true,
                      "default": null
                    }
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorAxes"
            },
            "typeParameters": []
          },
          "description": "Returns the color space axes, xChannel, yChannel, zChannel.",
          "default": null
        },
        "getColorChannels": {
          "type": "method",
          "name": "getColorChannels",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "tuple",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns an array of the color channels within the current color space space.",
          "default": null
        },
        "getColorName": {
          "type": "method",
          "name": "getColorName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized name for the color, for use in visual or accessibility labels.",
          "default": null
        },
        "getHueName": {
          "type": "method",
          "name": "getHueName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized name for the hue, for use in visual or accessibility labels.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "Represents a color value."
    },
    "ColorAreaState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorAreaState.ts:ColorAreaState",
      "name": "ColorAreaState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The current color value displayed by the color area.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The default value of the color area.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current color value. If a string is passed, it will be parsed to a Color.",
          "default": null
        },
        "xValue": {
          "type": "property",
          "name": "xValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The current value of the horizontal axis channel displayed by the color area.",
          "default": null
        },
        "setXValue": {
          "type": "method",
          "name": "setXValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value for the horizontal axis channel displayed by the color area, and triggers `onChange`.",
          "default": null
        },
        "yValue": {
          "type": "property",
          "name": "yValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The current value of the vertical axis channel displayed by the color area.",
          "default": null
        },
        "setYValue": {
          "type": "method",
          "name": "setYValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value for the vertical axis channel displayed by the color area, and triggers `onChange`.",
          "default": null
        },
        "setColorFromPoint": {
          "type": "method",
          "name": "setColorFromPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the x and y channels of the current color value based on a percentage of the width and height of the color area, and triggers `onChange`.",
          "default": null
        },
        "getThumbPosition": {
          "type": "method",
          "name": "getThumbPosition",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "property",
                  "name": "x",
                  "indexType": null,
                  "value": {
                    "type": "number"
                  },
                  "optional": false,
                  "default": null
                },
                "y": {
                  "type": "property",
                  "name": "y",
                  "indexType": null,
                  "value": {
                    "type": "number"
                  },
                  "optional": false,
                  "default": null
                }
              },
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the coordinates of the thumb relative to the upper left corner of the color area as a percentage.",
          "default": null
        },
        "incrementX": {
          "type": "method",
          "name": "incrementX",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the value of the horizontal axis channel by the channel step or page amount.",
          "default": null
        },
        "decrementX": {
          "type": "method",
          "name": "decrementX",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the value of the horizontal axis channel by the channel step or page amount.",
          "default": null
        },
        "incrementY": {
          "type": "method",
          "name": "incrementY",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the value of the vertical axis channel by the channel step or page amount.",
          "default": null
        },
        "decrementY": {
          "type": "method",
          "name": "decrementY",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the value of the vertical axis channel by the channel step or page amount.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color area is currently being dragged.",
          "default": null
        },
        "setDragging": {
          "type": "method",
          "name": "setDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the color area is being dragged.",
          "default": null
        },
        "channels": {
          "type": "property",
          "name": "channels",
          "indexType": null,
          "value": {
            "type": "object",
            "properties": {
              "xChannel": {
                "type": "property",
                "name": "xChannel",
                "indexType": null,
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "optional": false,
                "default": null
              },
              "yChannel": {
                "type": "property",
                "name": "yChannel",
                "indexType": null,
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "optional": false,
                "default": null
              },
              "zChannel": {
                "type": "property",
                "name": "zChannel",
                "indexType": null,
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "optional": false,
                "default": null
              }
            }
          },
          "optional": false,
          "description": "Returns the xChannel, yChannel and zChannel names based on the color value.",
          "default": null
        },
        "xChannelStep": {
          "type": "property",
          "name": "xChannelStep",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step value of the xChannel, used when incrementing and decrementing.",
          "default": null
        },
        "yChannelStep": {
          "type": "property",
          "name": "yChannelStep",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step value of the yChannel, used when incrementing and decrementing.",
          "default": null
        },
        "xChannelPageStep": {
          "type": "property",
          "name": "xChannelPageStep",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page step value of the xChannel, used when incrementing and decrementing.",
          "default": null
        },
        "yChannelPageStep": {
          "type": "property",
          "name": "yChannelPageStep",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page step value of the yChannel, used when incrementing and decrementing.",
          "default": null
        },
        "getDisplayColor": {
          "type": "method",
          "name": "getDisplayColor",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Returns the color that should be displayed in the color area thumb instead of `value`.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "ColorFieldState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorFieldState.ts:ColorFieldState",
      "name": "ColorFieldState",
      "properties": {
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The current text value of the input. Updated as the user types,\nand formatted according to `formatOptions` on blur.",
          "default": null
        },
        "colorValue": {
          "type": "property",
          "name": "colorValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently parsed color value, or null if the field is empty.\nUpdated based on the `inputValue` as the user types.",
          "default": null
        },
        "defaultColorValue": {
          "type": "property",
          "name": "defaultColorValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default value of the color field.",
          "default": null
        },
        "setColorValue": {
          "type": "method",
          "name": "setColorValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the color value of the field.",
          "default": null
        },
        "setInputValue": {
          "type": "method",
          "name": "setInputValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current text value of the input.",
          "default": null
        },
        "commit": {
          "type": "method",
          "name": "commit",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the input value based on the currently parsed color value.\nTypically this is called when the field is blurred.",
          "default": null
        },
        "increment": {
          "type": "method",
          "name": "increment",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the current input value to the next step boundary, and fires `onChange`.",
          "default": null
        },
        "decrement": {
          "type": "method",
          "name": "decrement",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the current input value to the next step boundary, and fires `onChange`.",
          "default": null
        },
        "incrementToMax": {
          "type": "method",
          "name": "incrementToMax",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current value to the maximum color value, and fires `onChange`.",
          "default": null
        },
        "decrementToMin": {
          "type": "method",
          "name": "decrementToMin",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current value to the minimum color value, and fires `onChange`.",
          "default": null
        },
        "validate": {
          "type": "method",
          "name": "validate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Validates a user input string.\nValues can be partially entered, and may be valid even if they cannot currently be parsed to a color.\nCan be used to implement validation as a user types.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "ColorFormat": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat"
    },
    "ColorPickerState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorPickerState.ts:ColorPickerState",
      "name": "ColorPickerState",
      "properties": {
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The current color value of the color picker.",
          "default": null
        },
        "setColor": {
          "type": "method",
          "name": "setColor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "color",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current color value of the color picker.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "ColorSliderState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorSliderState.ts:ColorSliderState",
      "name": "ColorSliderState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The current color value represented by the color slider.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current color value. If a string is passed, it will be parsed to a Color.",
          "default": null
        },
        "getDisplayColor": {
          "type": "method",
          "name": "getDisplayColor",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Returns the color that should be displayed in the slider instead of `value` or the optional parameter.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color slider is currently being dragged.",
          "default": null
        },
        "values": {
          "type": "property",
          "name": "values",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "number"
            }
          },
          "optional": false,
          "description": "Values managed by the slider by thumb index.",
          "default": null
        },
        "defaultValues": {
          "type": "property",
          "name": "defaultValues",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "number"
            }
          },
          "optional": false,
          "description": "The default values for each thumb.",
          "default": null
        },
        "getThumbValue": {
          "type": "method",
          "name": "getThumbValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Get the value for the specified thumb.",
          "default": null
        },
        "setThumbValue": {
          "type": "method",
          "name": "setThumbValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value for the specified thumb.\nThe actual value set will be clamped and rounded according to min/max/step.",
          "default": null
        },
        "setThumbPercent": {
          "type": "method",
          "name": "setThumbPercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "percent",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets value for the specified thumb by percent offset (between 0 and 1).",
          "default": null
        },
        "isThumbDragging": {
          "type": "method",
          "name": "isThumbDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Whether the specific thumb is being dragged.",
          "default": null
        },
        "setThumbDragging": {
          "type": "method",
          "name": "setThumbDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "dragging",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set is dragging on the specified thumb.",
          "default": null
        },
        "focusedThumb": {
          "type": "property",
          "name": "focusedThumb",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "Currently-focused thumb index.",
          "default": null
        },
        "setFocusedThumb": {
          "type": "method",
          "name": "setFocusedThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "number"
                    },
                    {
                      "type": "undefined"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set focused true on specified thumb. This will remove focus from\nany thumb that had it before.",
          "default": null
        },
        "getThumbPercent": {
          "type": "method",
          "name": "getThumbPercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the specified thumb's value as a percentage from 0 to 1.",
          "default": null
        },
        "getValuePercent": {
          "type": "method",
          "name": "getValuePercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the value as a percent between the min and max of the slider.",
          "default": null
        },
        "getThumbValueLabel": {
          "type": "method",
          "name": "getThumbValueLabel",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the string label for the specified thumb's value, per props.formatOptions.",
          "default": null
        },
        "getFormattedValue": {
          "type": "method",
          "name": "getFormattedValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the string label for the value, per props.formatOptions.",
          "default": null
        },
        "getThumbMinValue": {
          "type": "method",
          "name": "getThumbMinValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the min allowed value for the specified thumb.",
          "default": null
        },
        "getThumbMaxValue": {
          "type": "method",
          "name": "getThumbMaxValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the max allowed value for the specified thumb.",
          "default": null
        },
        "getPercentValue": {
          "type": "method",
          "name": "getPercentValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "percent",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts a percent along track (between 0 and 1) to the corresponding value.",
          "default": null
        },
        "isThumbEditable": {
          "type": "method",
          "name": "isThumbEditable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns if the specified thumb is editable.",
          "default": null
        },
        "setThumbEditable": {
          "type": "method",
          "name": "setThumbEditable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "editable",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set the specified thumb's editable state.",
          "default": null
        },
        "incrementThumb": {
          "type": "method",
          "name": "incrementThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the value of the thumb by the step or page amount.",
          "default": null
        },
        "decrementThumb": {
          "type": "method",
          "name": "decrementThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the value of the thumb by the step or page amount.",
          "default": null
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step amount for the slider.",
          "default": null
        },
        "pageSize": {
          "type": "property",
          "name": "pageSize",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page size for the slider, used to do a bigger step.",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the slider.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the slider is disabled.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "ColorSpace": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
    },
    "ColorWheelState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorWheelState.ts:ColorWheelState",
      "name": "ColorWheelState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The current color value represented by the color wheel.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The default color value.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the color value represented by the color wheel, and triggers `onChange`.",
          "default": null
        },
        "hue": {
          "type": "property",
          "name": "hue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The current value of the hue channel displayed by the color wheel.",
          "default": null
        },
        "setHue": {
          "type": "method",
          "name": "setHue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the hue channel of the current color value and triggers `onChange`.",
          "default": null
        },
        "setHueFromPoint": {
          "type": "method",
          "name": "setHueFromPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "radius",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the hue channel of the current color value based on the given coordinates and radius of the color wheel, and triggers `onChange`.",
          "default": null
        },
        "getThumbPosition": {
          "type": "method",
          "name": "getThumbPosition",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "radius",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "property",
                  "name": "x",
                  "indexType": null,
                  "value": {
                    "type": "number"
                  },
                  "optional": false,
                  "default": null
                },
                "y": {
                  "type": "property",
                  "name": "y",
                  "indexType": null,
                  "value": {
                    "type": "number"
                  },
                  "optional": false,
                  "default": null
                }
              },
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the coordinates of the thumb relative to the center point of the color wheel.",
          "default": null
        },
        "increment": {
          "type": "method",
          "name": "increment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the hue by the given amount (defaults to 1).",
          "default": null
        },
        "decrement": {
          "type": "method",
          "name": "decrement",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the hue by the given amount (defaults to 1).",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color wheel is currently being dragged.",
          "default": null
        },
        "setDragging": {
          "type": "method",
          "name": "setDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the color wheel is being dragged.",
          "default": null
        },
        "getDisplayColor": {
          "type": "method",
          "name": "getDisplayColor",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Returns the color that should be displayed in the color wheel instead of `value`.",
          "default": null
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step value of the hue channel, used when incrementing and decrementing.",
          "default": null
        },
        "pageStep": {
          "type": "property",
          "name": "pageStep",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page step value of the hue channel, used when incrementing and decrementing.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color wheel is disabled.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "ComboBoxState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/combobox/src/useComboBoxState.ts:ComboBoxState",
      "name": "ComboBoxState",
      "properties": {
        "defaultSelectedKey": {
          "type": "property",
          "name": "defaultSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default selected key.",
          "default": null
        },
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The current value of the combo box input.",
          "default": null
        },
        "defaultInputValue": {
          "type": "property",
          "name": "defaultInputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The default value of the combo box input.",
          "default": null
        },
        "setInputValue": {
          "type": "method",
          "name": "setInputValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value of the combo box input.",
          "default": null
        },
        "commit": {
          "type": "method",
          "name": "commit",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the currently focused item and updates the input value.",
          "default": null
        },
        "focusStrategy": {
          "type": "property",
          "name": "focusStrategy",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Controls which item will be auto focused when the menu opens.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is currently focused.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the select is focused.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "focusStrategy",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "trigger",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Opens the menu.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "focusStrategy",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "trigger",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the menu.",
          "default": null
        },
        "revert": {
          "type": "method",
          "name": "revert",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the input value to the previously selected item's text if any and closes the menu.",
          "default": null
        },
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The key for the currently selected item.",
          "default": null
        },
        "setSelectedKey": {
          "type": "method",
          "name": "setSelectedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected key.",
          "default": null
        },
        "selectedItem": {
          "type": "property",
          "name": "selectedItem",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The value of the currently selected item.",
          "default": null
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the list.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of items that are disabled.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the overlay is currently open.",
          "default": null
        },
        "setOpen": {
          "type": "method",
          "name": "setOpen",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the overlay is open.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes the overlay.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "DateFieldState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateFieldState",
      "name": "DateFieldState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current field value.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default field value.",
          "default": null
        },
        "dateValue": {
          "type": "property",
          "name": "dateValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Date"
          },
          "optional": false,
          "description": "The current value, converted to a native JavaScript `Date` object.",
          "default": null
        },
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
          },
          "optional": false,
          "description": "The calendar system currently in use.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the field's value.",
          "default": null
        },
        "segments": {
          "type": "property",
          "name": "segments",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateSegment"
            }
          },
          "optional": false,
          "description": "A list of segments for the current value.",
          "default": null
        },
        "dateFormatter": {
          "type": "property",
          "name": "dateFormatter",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter"
          },
          "optional": false,
          "description": "A date formatter configured for the current locale and format.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the date field, based on the `validationState`, `minValue`, and `maxValue` props.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is invalid, based on the `isInvalid`, `minValue`, and `maxValue` props.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": false,
          "description": "The granularity for the field, based on the `granularity` prop and current value.",
          "default": null
        },
        "maxGranularity": {
          "type": "property",
          "name": "maxGranularity",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "year"
              },
              {
                "type": "string",
                "value": "month"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
              }
            ]
          },
          "optional": false,
          "description": "The maximum date or time unit that is displayed in the field.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the field is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the field is read only.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the field is required.",
          "default": null
        },
        "increment": {
          "type": "method",
          "name": "increment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the given segment. Upon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "decrement": {
          "type": "method",
          "name": "decrement",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the given segment. Upon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "incrementPage": {
          "type": "method",
          "name": "incrementPage",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the given segment by a larger amount, rounding it to the nearest increment.\nThe amount to increment by depends on the field, for example 15 minutes, 7 days, and 5 years.\nUpon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "decrementPage": {
          "type": "method",
          "name": "decrementPage",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the given segment by a larger amount, rounding it to the nearest increment.\nThe amount to decrement by depends on the field, for example 15 minutes, 7 days, and 5 years.\nUpon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "setSegment": {
          "type": "method",
          "name": "setSegment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value of the given segment.",
          "default": null
        },
        "confirmPlaceholder": {
          "type": "method",
          "name": "confirmPlaceholder",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the remaining unfilled segments with the placeholder value.",
          "default": null
        },
        "clearSegment": {
          "type": "method",
          "name": "clearSegment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Clears the value of the given segment, reverting it to the placeholder.",
          "default": null
        },
        "formatValue": {
          "type": "method",
          "name": "formatValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fieldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FieldOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats the current date value using the given options.",
          "default": null
        },
        "getDateFormatter": {
          "type": "method",
          "name": "getDateFormatter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "formatOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FormatterOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter"
            },
            "typeParameters": []
          },
          "description": "Gets a formatter based on state's props.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "DatePickerState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDatePickerState.ts:DatePickerState",
      "name": "DatePickerState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected date.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default date.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected date.",
          "default": null
        },
        "dateValue": {
          "type": "property",
          "name": "dateValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The date portion of the value. This may be set prior to `value` if the user has\nselected a date but has not yet selected a time.",
          "default": null
        },
        "setDateValue": {
          "type": "method",
          "name": "setDateValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the date portion of the value.",
          "default": null
        },
        "timeValue": {
          "type": "property",
          "name": "timeValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The time portion of the value. This may be set prior to `value` if the user has\nselected a time but has not yet selected a date.",
          "default": null
        },
        "setTimeValue": {
          "type": "method",
          "name": "setTimeValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the time portion of the value.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": false,
          "description": "The granularity for the field, based on the `granularity` prop and current value.",
          "default": null
        },
        "hasTime": {
          "type": "property",
          "name": "hasTime",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker supports selecting a time, according to the `granularity` prop and current value.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar popover is currently open.",
          "default": null
        },
        "setOpen": {
          "type": "method",
          "name": "setOpen",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the calendar popover is open.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the date picker, based on the `validationState`, `minValue`, and `maxValue` props.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is invalid, based on the `isInvalid`, `minValue`, and `maxValue` props.",
          "default": null
        },
        "formatValue": {
          "type": "method",
          "name": "formatValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "fieldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FieldOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats the selected value using the given options.",
          "default": null
        },
        "getDateFormatter": {
          "type": "method",
          "name": "getDateFormatter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "formatOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FormatterOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter"
            },
            "typeParameters": []
          },
          "description": "Gets a formatter based on state's props.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Opens the overlay.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes the overlay.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the overlay's visibility.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "DateRangePickerState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateRangePickerState.ts:DateRangePickerState",
      "name": "DateRangePickerState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The currently selected date range.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateRange"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default selected date range.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateRange"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected date range.",
          "default": null
        },
        "dateRange": {
          "type": "property",
          "name": "dateRange",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The date portion of the selected range. This may be set prior to `value` if the user has\nselected a date range but has not yet selected a time range.",
          "default": null
        },
        "setDateRange": {
          "type": "method",
          "name": "setDateRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateRange"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the date portion of the selected range.",
          "default": null
        },
        "timeRange": {
          "type": "property",
          "name": "timeRange",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The time portion of the selected range. This may be set prior to `value` if the user has\nselected a time range but has not yet selected a date range.",
          "default": null
        },
        "setTimeRange": {
          "type": "method",
          "name": "setTimeRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateRangePickerState.ts:TimeRange"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the time portion of the selected range.",
          "default": null
        },
        "setDate": {
          "type": "method",
          "name": "setDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "part",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "start"
                    },
                    {
                      "type": "string",
                      "value": "end"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the date portion of either the start or end of the selected range.",
          "default": null
        },
        "setTime": {
          "type": "method",
          "name": "setTime",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "part",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "start"
                    },
                    {
                      "type": "string",
                      "value": "end"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the time portion of either the start or end of the selected range.",
          "default": null
        },
        "setDateTime": {
          "type": "method",
          "name": "setDateTime",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "part",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "start"
                    },
                    {
                      "type": "string",
                      "value": "end"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the date and time of either the start or end of the selected range.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": false,
          "description": "The granularity for the field, based on the `granularity` prop and current value.",
          "default": null
        },
        "hasTime": {
          "type": "property",
          "name": "hasTime",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date range picker supports selecting times, according to the `granularity` prop and current value.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar popover is currently open.",
          "default": null
        },
        "setOpen": {
          "type": "method",
          "name": "setOpen",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the calendar popover is open.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the date range picker, based on the `validationState`, `minValue`, and `maxValue` props.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date range picker is invalid, based on the `isInvalid`, `minValue`, and `maxValue` props.",
          "default": null
        },
        "formatValue": {
          "type": "method",
          "name": "formatValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "fieldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FieldOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "object",
                  "properties": {
                    "start": {
                      "type": "property",
                      "name": "start",
                      "indexType": null,
                      "value": {
                        "type": "string"
                      },
                      "optional": false,
                      "default": null
                    },
                    "end": {
                      "type": "property",
                      "name": "end",
                      "indexType": null,
                      "value": {
                        "type": "string"
                      },
                      "optional": false,
                      "default": null
                    }
                  }
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Formats the selected range using the given options.",
          "default": null
        },
        "getDateFormatter": {
          "type": "method",
          "name": "getDateFormatter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "formatOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FormatterOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter"
            },
            "typeParameters": []
          },
          "description": "Gets a formatter based on state's props.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Opens the overlay.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes the overlay.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the overlay's visibility.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "DisclosureState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/disclosure/src/useDisclosureState.ts:DisclosureState",
      "name": "DisclosureState",
      "properties": {
        "isExpanded": {
          "type": "property",
          "name": "isExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the disclosure is currently expanded.",
          "default": null
        },
        "setExpanded": {
          "type": "method",
          "name": "setExpanded",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isExpanded",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the disclosure is expanded.",
          "default": null
        },
        "expand": {
          "type": "method",
          "name": "expand",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Expand the disclosure.",
          "default": null
        },
        "collapse": {
          "type": "method",
          "name": "collapse",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Collapse the disclosure.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the disclosure's visibility.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "DisclosureGroupState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/disclosure/src/useDisclosureGroupState.ts:DisclosureGroupState",
      "name": "DisclosureGroupState",
      "properties": {
        "allowsMultipleExpanded": {
          "type": "property",
          "name": "allowsMultipleExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether multiple items can be expanded at the same time.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether all items are disabled.",
          "default": null
        },
        "expandedKeys": {
          "type": "property",
          "name": "expandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for items that are expanded.",
          "default": null
        },
        "toggleKey": {
          "type": "method",
          "name": "toggleKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the expanded state for an item by its key.",
          "default": null
        },
        "setExpandedKeys": {
          "type": "method",
          "name": "setExpandedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the set of expanded keys.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "Key": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
    },
    "ListState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState",
      "name": "ListState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the list.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of items that are disabled.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "NumberFieldState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/numberfield/src/useNumberFieldState.ts:NumberFieldState",
      "name": "NumberFieldState",
      "properties": {
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The current text value of the input. Updated as the user types,\nand formatted according to `formatOptions` on blur.",
          "default": null
        },
        "numberValue": {
          "type": "property",
          "name": "numberValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The currently parsed number value, or NaN if a valid number could not be parsed.\nUpdated based on the `inputValue` as the user types.",
          "default": null
        },
        "defaultNumberValue": {
          "type": "property",
          "name": "defaultNumberValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The default value of the input.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum value of the number field.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum value of the number field.",
          "default": null
        },
        "canIncrement": {
          "type": "property",
          "name": "canIncrement",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the current value can be incremented according to the maximum value and step.",
          "default": null
        },
        "canDecrement": {
          "type": "property",
          "name": "canDecrement",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the current value can be decremented according to the minimum value and step.",
          "default": null
        },
        "validate": {
          "type": "method",
          "name": "validate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Validates a user input string according to the current locale and format options.\nValues can be partially entered, and may be valid even if they cannot currently be parsed to a number.\nCan be used to implement validation as a user types.",
          "default": null
        },
        "setInputValue": {
          "type": "method",
          "name": "setInputValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "val",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current text value of the input.",
          "default": null
        },
        "setNumberValue": {
          "type": "method",
          "name": "setNumberValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "val",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the number value.",
          "default": null
        },
        "commit": {
          "type": "method",
          "name": "commit",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the current input value. The value is parsed to a number, clamped according\nto the minimum and maximum values of the field, and snapped to the nearest step value.\nThis will fire the `onChange` prop with the new value, and if uncontrolled, update the `numberValue`.\nTypically this is called when the field is blurred.",
          "default": null
        },
        "increment": {
          "type": "method",
          "name": "increment",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the current input value to the next step boundary, and fires `onChange`.",
          "default": null
        },
        "decrement": {
          "type": "method",
          "name": "decrement",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the current input value to the next step boundary, and fires `onChange`.",
          "default": null
        },
        "incrementToMax": {
          "type": "method",
          "name": "incrementToMax",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current value to the `maxValue` if any, and fires `onChange`.",
          "default": null
        },
        "decrementToMin": {
          "type": "method",
          "name": "decrementToMin",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current value to the `minValue` if any, and fires `onChange`.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "OverlayTriggerState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/overlays/src/useOverlayTriggerState.ts:OverlayTriggerState",
      "name": "OverlayTriggerState",
      "properties": {
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the overlay is currently open.",
          "default": null
        },
        "setOpen": {
          "type": "method",
          "name": "setOpen",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the overlay is open.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Opens the overlay.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes the overlay.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the overlay's visibility.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "QueuedToast": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast",
      "name": "QueuedToast",
      "properties": {
        "content": {
          "type": "property",
          "name": "content",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": false,
          "description": "The content of the toast.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A unique key for the toast.",
          "default": null
        },
        "timer": {
          "type": "property",
          "name": "timer",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:Timer"
          },
          "optional": true,
          "description": "A timer for the toast, if a timeout was set.",
          "default": null
        },
        "onClose": {
          "type": "property",
          "name": "onClose",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the toast is closed, either by the user or after a timeout.",
          "default": null
        },
        "timeout": {
          "type": "property",
          "name": "timeout",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "A timeout to automatically close the toast after, in milliseconds.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "RadioGroupState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/radio/src/useRadioGroupState.ts:RadioGroupState",
      "name": "RadioGroupState",
      "properties": {
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The name for the group, used for native form submission.",
          "access": "private",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is read only.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is required.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Whether the radio group is valid or invalid.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is invalid.",
          "default": null
        },
        "selectedValue": {
          "type": "property",
          "name": "selectedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected value.",
          "default": null
        },
        "defaultSelectedValue": {
          "type": "property",
          "name": "defaultSelectedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default selected value.",
          "default": null
        },
        "setSelectedValue": {
          "type": "method",
          "name": "setSelectedValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected value.",
          "default": null
        },
        "lastFocusedValue": {
          "type": "property",
          "name": "lastFocusedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The value of the last focused radio.",
          "default": null
        },
        "setLastFocusedValue": {
          "type": "method",
          "name": "setLastFocusedValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the last focused value.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "RangeCalendarState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:RangeCalendarState",
      "name": "RangeCalendarState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected date range.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the currently selected date range.",
          "default": null
        },
        "highlightDate": {
          "type": "method",
          "name": "highlightDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Highlights the given date during selection, e.g. by hovering or dragging.",
          "default": null
        },
        "anchorDate": {
          "type": "property",
          "name": "anchorDate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current anchor date that the user clicked on to begin range selection.",
          "default": null
        },
        "setAnchorDate": {
          "type": "method",
          "name": "setAnchorDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the anchor date that the user clicked on to begin range selection.",
          "default": null
        },
        "highlightedRange": {
          "type": "property",
          "name": "highlightedRange",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently highlighted date range.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the user is currently dragging over the calendar.",
          "default": null
        },
        "setDragging": {
          "type": "method",
          "name": "setDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isDragging",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the user is dragging over the calendar.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is in a read only state.",
          "default": null
        },
        "visibleRange": {
          "type": "property",
          "name": "visibleRange",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              }
            ]
          },
          "optional": false,
          "description": "The date range that is currently visible in the calendar.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "timeZone": {
          "type": "property",
          "name": "timeZone",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The time zone of the dates currently being displayed.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the selected value.",
          "access": "private",
          "default": null
        },
        "isValueInvalid": {
          "type": "property",
          "name": "isValueInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "default": null
        },
        "focusedDate": {
          "type": "property",
          "name": "focusedDate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          "optional": false,
          "description": "The currently focused date.",
          "default": null
        },
        "setFocusedDate": {
          "type": "method",
          "name": "setFocusedDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused date.",
          "default": null
        },
        "focusNextDay": {
          "type": "method",
          "name": "focusNextDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next calendar date.",
          "default": null
        },
        "focusPreviousDay": {
          "type": "method",
          "name": "focusPreviousDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous calendar date.",
          "default": null
        },
        "focusNextRow": {
          "type": "method",
          "name": "focusNextRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next row of dates, e.g. the next week.",
          "default": null
        },
        "focusPreviousRow": {
          "type": "method",
          "name": "focusPreviousRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous row of dates, e.g. the previous work.",
          "default": null
        },
        "focusNextPage": {
          "type": "method",
          "name": "focusNextPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next page of dates, e.g. the next month if one month is visible.",
          "default": null
        },
        "focusPreviousPage": {
          "type": "method",
          "name": "focusPreviousPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous page of dates, e.g. the previous month if one month is visible.",
          "default": null
        },
        "focusSectionStart": {
          "type": "method",
          "name": "focusSectionStart",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the start of the current section of dates, e.g. the start of the current month.",
          "default": null
        },
        "focusSectionEnd": {
          "type": "method",
          "name": "focusSectionEnd",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the end of the current section of dates, e.g. the end of the current month month.",
          "default": null
        },
        "focusNextSection": {
          "type": "method",
          "name": "focusNextSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved forward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the next year.",
          "default": null
        },
        "focusPreviousSection": {
          "type": "method",
          "name": "focusPreviousSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved backward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the previous year.",
          "default": null
        },
        "selectFocusedDate": {
          "type": "method",
          "name": "selectFocusedDate",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the currently focused date.",
          "default": null
        },
        "selectDate": {
          "type": "method",
          "name": "selectDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the given date.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether focus is currently within the calendar.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether focus is currently within the calendar.",
          "default": null
        },
        "isInvalid": {
          "type": "method",
          "name": "isInvalid",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is invalid according to the `minValue` and `maxValue` props.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently selected.",
          "default": null
        },
        "isCellFocused": {
          "type": "method",
          "name": "isCellFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently focused.",
          "default": null
        },
        "isCellDisabled": {
          "type": "method",
          "name": "isCellDisabled",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is disabled according to the `minValue, `maxValue`, and `isDisabled` props.",
          "default": null
        },
        "isCellUnavailable": {
          "type": "method",
          "name": "isCellUnavailable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is unavailable according to the `isDateUnavailable` prop.",
          "default": null
        },
        "isPreviousVisibleRangeInvalid": {
          "type": "method",
          "name": "isPreviousVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the previous visible date range is allowed to be selected according to the `minValue` prop.",
          "default": null
        },
        "isNextVisibleRangeInvalid": {
          "type": "method",
          "name": "isNextVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the next visible date range is allowed to be selected according to the `maxValue` prop.",
          "default": null
        },
        "getDatesInWeek": {
          "type": "method",
          "name": "getDatesInWeek",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "weekIndex",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "startDate",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Array"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns an array of dates in the week index counted from the provided start date, or the first visible date if not given.\nThe returned array always has 7 elements, but may include null if the date does not exist according to the calendar system.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RootMenuTriggerState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/menu/src/useMenuTriggerState.ts:RootMenuTriggerState",
      "name": "RootMenuTriggerState",
      "properties": {
        "openSubmenu": {
          "type": "property",
          "name": "openSubmenu",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "triggerKey",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "level",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "Opens a specific submenu tied to a specific menu item at a specific level.",
          "default": null
        },
        "closeSubmenu": {
          "type": "property",
          "name": "closeSubmenu",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "triggerKey",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "level",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "Closes a specific submenu tied to a specific menu item at a specific level.",
          "default": null
        },
        "expandedKeysStack": {
          "type": "property",
          "name": "expandedKeysStack",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            }
          },
          "optional": false,
          "description": "An array of open submenu trigger keys within the menu tree.\nThe index of key within array matches the submenu level in the tree.",
          "default": null
        },
        "close": {
          "type": "property",
          "name": "close",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "Closes the menu and all submenus in the menu tree.",
          "default": null
        },
        "focusStrategy": {
          "type": "property",
          "name": "focusStrategy",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Controls which item will be auto focused when the menu opens.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "focusStrategy",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Opens the menu.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "focusStrategy",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the menu.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the overlay is currently open.",
          "default": null
        },
        "setOpen": {
          "type": "method",
          "name": "setOpen",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the overlay is open.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "SearchFieldState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/searchfield/src/useSearchFieldState.ts:SearchFieldState",
      "name": "SearchFieldState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The current value of the search field.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value of the search field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "Selection": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
    },
    "SelectState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/select/src/useSelectState.ts:SelectState",
      "name": "SelectState",
      "properties": {
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The key for the first selected item.",
          "access": "private",
          "default": null
        },
        "defaultSelectedKey": {
          "type": "property",
          "name": "defaultSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default selected key.",
          "access": "private",
          "default": null
        },
        "setSelectedKey": {
          "type": "method",
          "name": "setSelectedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "description": "Sets the selected key.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
              }
            ]
          },
          "optional": false,
          "description": "The current select value.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
              }
            ]
          },
          "optional": false,
          "description": "The default select value.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "array",
                      "elementType": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      }
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the select value.",
          "default": null
        },
        "selectedItem": {
          "type": "property",
          "name": "selectedItem",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The value of the first selected item.",
          "access": "private",
          "default": null
        },
        "selectedItems": {
          "type": "property",
          "name": "selectedItems",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "The value of the selected items.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is currently focused.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the select is focused.",
          "default": null
        },
        "focusStrategy": {
          "type": "property",
          "name": "focusStrategy",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Controls which item will be auto focused when the menu opens.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "focusStrategy",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Opens the menu.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "focusStrategy",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the menu.",
          "default": null
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the list.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of items that are disabled.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the overlay is currently open.",
          "default": null
        },
        "setOpen": {
          "type": "method",
          "name": "setOpen",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the overlay is open.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes the overlay.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "M",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
          },
          "default": {
            "type": "string",
            "value": "single"
          }
        }
      ],
      "extends": []
    },
    "SliderState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/slider/src/useSliderState.ts:SliderState",
      "name": "SliderState",
      "properties": {
        "values": {
          "type": "property",
          "name": "values",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "number"
            }
          },
          "optional": false,
          "description": "Values managed by the slider by thumb index.",
          "default": null
        },
        "defaultValues": {
          "type": "property",
          "name": "defaultValues",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "number"
            }
          },
          "optional": false,
          "description": "The default values for each thumb.",
          "default": null
        },
        "getThumbValue": {
          "type": "method",
          "name": "getThumbValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Get the value for the specified thumb.",
          "default": null
        },
        "setThumbValue": {
          "type": "method",
          "name": "setThumbValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value for the specified thumb.\nThe actual value set will be clamped and rounded according to min/max/step.",
          "default": null
        },
        "setThumbPercent": {
          "type": "method",
          "name": "setThumbPercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "percent",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets value for the specified thumb by percent offset (between 0 and 1).",
          "default": null
        },
        "isThumbDragging": {
          "type": "method",
          "name": "isThumbDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Whether the specific thumb is being dragged.",
          "default": null
        },
        "setThumbDragging": {
          "type": "method",
          "name": "setThumbDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "dragging",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set is dragging on the specified thumb.",
          "default": null
        },
        "focusedThumb": {
          "type": "property",
          "name": "focusedThumb",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "Currently-focused thumb index.",
          "default": null
        },
        "setFocusedThumb": {
          "type": "method",
          "name": "setFocusedThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "number"
                    },
                    {
                      "type": "undefined"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set focused true on specified thumb. This will remove focus from\nany thumb that had it before.",
          "default": null
        },
        "getThumbPercent": {
          "type": "method",
          "name": "getThumbPercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the specified thumb's value as a percentage from 0 to 1.",
          "default": null
        },
        "getValuePercent": {
          "type": "method",
          "name": "getValuePercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the value as a percent between the min and max of the slider.",
          "default": null
        },
        "getThumbValueLabel": {
          "type": "method",
          "name": "getThumbValueLabel",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the string label for the specified thumb's value, per props.formatOptions.",
          "default": null
        },
        "getFormattedValue": {
          "type": "method",
          "name": "getFormattedValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the string label for the value, per props.formatOptions.",
          "default": null
        },
        "getThumbMinValue": {
          "type": "method",
          "name": "getThumbMinValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the min allowed value for the specified thumb.",
          "default": null
        },
        "getThumbMaxValue": {
          "type": "method",
          "name": "getThumbMaxValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the max allowed value for the specified thumb.",
          "default": null
        },
        "getPercentValue": {
          "type": "method",
          "name": "getPercentValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "percent",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts a percent along track (between 0 and 1) to the corresponding value.",
          "default": null
        },
        "isThumbEditable": {
          "type": "method",
          "name": "isThumbEditable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns if the specified thumb is editable.",
          "default": null
        },
        "setThumbEditable": {
          "type": "method",
          "name": "setThumbEditable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "editable",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set the specified thumb's editable state.",
          "default": null
        },
        "incrementThumb": {
          "type": "method",
          "name": "incrementThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the value of the thumb by the step or page amount.",
          "default": null
        },
        "decrementThumb": {
          "type": "method",
          "name": "decrementThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the value of the thumb by the step or page amount.",
          "default": null
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step amount for the slider.",
          "default": null
        },
        "pageSize": {
          "type": "property",
          "name": "pageSize",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page size for the slider, used to do a bigger step.",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the slider.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the slider is disabled.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "SortDescriptor": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor",
      "name": "SortDescriptor",
      "properties": {
        "column": {
          "type": "property",
          "name": "column",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": false,
          "description": "The key of the column to sort by.",
          "default": null
        },
        "direction": {
          "type": "property",
          "name": "direction",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
          },
          "optional": false,
          "description": "The direction to sort by.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SortDirection": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
    },
    "SelectionMode": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
    },
    "TableState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/table/src/useTableState.ts:TableState",
      "name": "TableState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:TableCollection"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": false,
          "description": "A collection of rows and columns in the table.",
          "default": null
        },
        "showSelectionCheckboxes": {
          "type": "property",
          "name": "showSelectionCheckboxes",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the row selection checkboxes should be displayed.",
          "default": null
        },
        "sortDescriptor": {
          "type": "property",
          "name": "sortDescriptor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current sorted column and direction.",
          "default": null
        },
        "sort": {
          "type": "method",
          "name": "sort",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "columnKey",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "direction",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "ascending"
                    },
                    {
                      "type": "string",
                      "value": "descending"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Calls the provided onSortChange handler with the provided column key and sort direction.",
          "default": null
        },
        "isKeyboardNavigationDisabled": {
          "type": "property",
          "name": "isKeyboardNavigationDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether keyboard navigation is disabled, such as when the arrow keys should be handled by a component within a cell.",
          "default": null
        },
        "setKeyboardNavigationDisabled": {
          "type": "property",
          "name": "setKeyboardNavigationDisabled",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "val",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "Set whether keyboard navigation is disabled, such as when the arrow keys should be handled by a component within a cell.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for rows that are disabled.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update row selection state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TabListState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/tabs/src/useTabListState.ts:TabListState",
      "name": "TabListState",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab list is disabled.",
          "default": null
        },
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The key for the currently selected item.",
          "default": null
        },
        "setSelectedKey": {
          "type": "method",
          "name": "setSelectedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected key.",
          "default": null
        },
        "selectedItem": {
          "type": "property",
          "name": "selectedItem",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The value of the currently selected item.",
          "default": null
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the list.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of items that are disabled.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TimeFieldState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useTimeFieldState.ts:TimeFieldState",
      "name": "TimeFieldState",
      "properties": {
        "timeValue": {
          "type": "property",
          "name": "timeValue",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
          },
          "optional": false,
          "description": "The current time value.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current field value.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default field value.",
          "default": null
        },
        "dateValue": {
          "type": "property",
          "name": "dateValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Date"
          },
          "optional": false,
          "description": "The current value, converted to a native JavaScript `Date` object.",
          "default": null
        },
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
          },
          "optional": false,
          "description": "The calendar system currently in use.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the field's value.",
          "default": null
        },
        "segments": {
          "type": "property",
          "name": "segments",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateSegment"
            }
          },
          "optional": false,
          "description": "A list of segments for the current value.",
          "default": null
        },
        "dateFormatter": {
          "type": "property",
          "name": "dateFormatter",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter"
          },
          "optional": false,
          "description": "A date formatter configured for the current locale and format.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the date field, based on the `validationState`, `minValue`, and `maxValue` props.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is invalid, based on the `isInvalid`, `minValue`, and `maxValue` props.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": false,
          "description": "The granularity for the field, based on the `granularity` prop and current value.",
          "default": null
        },
        "maxGranularity": {
          "type": "property",
          "name": "maxGranularity",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "year"
              },
              {
                "type": "string",
                "value": "month"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
              }
            ]
          },
          "optional": false,
          "description": "The maximum date or time unit that is displayed in the field.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the field is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the field is read only.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the field is required.",
          "default": null
        },
        "increment": {
          "type": "method",
          "name": "increment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the given segment. Upon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "decrement": {
          "type": "method",
          "name": "decrement",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the given segment. Upon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "incrementPage": {
          "type": "method",
          "name": "incrementPage",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the given segment by a larger amount, rounding it to the nearest increment.\nThe amount to increment by depends on the field, for example 15 minutes, 7 days, and 5 years.\nUpon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "decrementPage": {
          "type": "method",
          "name": "decrementPage",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the given segment by a larger amount, rounding it to the nearest increment.\nThe amount to decrement by depends on the field, for example 15 minutes, 7 days, and 5 years.\nUpon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "setSegment": {
          "type": "method",
          "name": "setSegment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value of the given segment.",
          "default": null
        },
        "confirmPlaceholder": {
          "type": "method",
          "name": "confirmPlaceholder",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the remaining unfilled segments with the placeholder value.",
          "default": null
        },
        "clearSegment": {
          "type": "method",
          "name": "clearSegment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Clears the value of the given segment, reverting it to the placeholder.",
          "default": null
        },
        "formatValue": {
          "type": "method",
          "name": "formatValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fieldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FieldOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats the current date value using the given options.",
          "default": null
        },
        "getDateFormatter": {
          "type": "method",
          "name": "getDateFormatter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "formatOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FormatterOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter"
            },
            "typeParameters": []
          },
          "description": "Gets a formatter based on state's props.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "ToastOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastOptions",
      "name": "ToastOptions",
      "properties": {
        "onClose": {
          "type": "property",
          "name": "onClose",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the toast is closed, either by the user or after a timeout.",
          "default": null
        },
        "timeout": {
          "type": "property",
          "name": "timeout",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "A timeout to automatically close the toast after, in milliseconds.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ToastState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastState",
      "name": "ToastState",
      "properties": {
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "content",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Adds a new toast to the queue.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes a toast.",
          "default": null
        },
        "pauseAll": {
          "type": "method",
          "name": "pauseAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Pauses the timers for all visible toasts.",
          "default": null
        },
        "resumeAll": {
          "type": "method",
          "name": "resumeAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resumes the timers for all visible toasts.",
          "default": null
        },
        "visibleToasts": {
          "type": "property",
          "name": "visibleToasts",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "The visible toasts.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "ToggleGroupState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleGroupState.ts:ToggleGroupState",
      "name": "ToggleGroupState",
      "properties": {
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "single"
              },
              {
                "type": "string",
                "value": "multiple"
              }
            ]
          },
          "optional": false,
          "description": "Whether single or multiple selection is enabled.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether all items are disabled.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for items that are selected.",
          "default": null
        },
        "toggleKey": {
          "type": "method",
          "name": "toggleKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the selected state for an item by its key.",
          "default": null
        },
        "setSelected": {
          "type": "method",
          "name": "setSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "isSelected",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the given key is selected.",
          "default": null
        },
        "setSelectedKeys": {
          "type": "method",
          "name": "setSelectedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the set of selected keys.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "ToggleState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleState.ts:ToggleState",
      "name": "ToggleState",
      "properties": {
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toggle is selected.",
          "default": null
        },
        "defaultSelected": {
          "type": "property",
          "name": "defaultSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toggle is selected by default.",
          "default": null
        },
        "setSelected": {
          "type": "method",
          "name": "setSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isSelected",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates selection state.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggle the selection state.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "TooltipTriggerState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/tooltip/src/useTooltipTriggerState.ts:TooltipTriggerState",
      "name": "TooltipTriggerState",
      "properties": {
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tooltip is currently showing.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "immediate",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Shows the tooltip. By default, the tooltip becomes visible after a delay\ndepending on a global warmup timer. The `immediate` option shows the\ntooltip immediately instead.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "immediate",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Hides the tooltip.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "TreeState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState",
      "name": "TreeState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the tree.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for items that are disabled.",
          "default": null
        },
        "expandedKeys": {
          "type": "property",
          "name": "expandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for items that are expanded.",
          "default": null
        },
        "toggleKey": {
          "type": "method",
          "name": "toggleKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the expanded state for an item by its key.",
          "default": null
        },
        "setExpandedKeys": {
          "type": "method",
          "name": "setExpandedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the set of expanded keys.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "AutocompleteState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/autocomplete/src/useAutocompleteState.ts:AutocompleteState",
      "name": "AutocompleteState",
      "properties": {
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The current value of the autocomplete input.",
          "default": null
        },
        "setInputValue": {
          "type": "method",
          "name": "setInputValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value of the autocomplete input.",
          "default": null
        },
        "focusedNodeId": {
          "type": "property",
          "name": "focusedNodeId",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The id of the current aria-activedescendant of the autocomplete input.",
          "default": null
        },
        "setFocusedNodeId": {
          "type": "method",
          "name": "setFocusedNodeId",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the id of the current aria-activedescendant of the autocomplete input.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "ListLayoutOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions",
      "name": "ListLayoutOptions",
      "properties": {
        "rowHeight": {
          "type": "property",
          "name": "rowHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The fixed height of a row in px.",
          "default": "48"
        },
        "estimatedRowHeight": {
          "type": "property",
          "name": "estimatedRowHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The estimated height of a row, when row heights are variable.",
          "default": null
        },
        "headingHeight": {
          "type": "property",
          "name": "headingHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The fixed height of a section header in px.",
          "default": "48"
        },
        "estimatedHeadingHeight": {
          "type": "property",
          "name": "estimatedHeadingHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The estimated height of a section header, when the height is variable.",
          "default": null
        },
        "loaderHeight": {
          "type": "property",
          "name": "loaderHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The fixed height of a loader element in px. This loader is specifically for\n\"load more\" elements rendered when loading more rows at the root level or inside nested row/sections.",
          "default": "48"
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The thickness of the drop indicator.",
          "default": "2"
        },
        "gap": {
          "type": "property",
          "name": "gap",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The gap between items.",
          "default": "0"
        },
        "padding": {
          "type": "property",
          "name": "padding",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The padding around the list.",
          "default": "0"
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "GridLayoutOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/GridLayout.ts:GridLayoutOptions",
      "name": "GridLayoutOptions",
      "properties": {
        "minItemSize": {
          "type": "property",
          "name": "minItemSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The minimum item size.",
          "default": "200 x 200"
        },
        "maxItemSize": {
          "type": "property",
          "name": "maxItemSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The maximum item size.",
          "default": "Infinity"
        },
        "preserveAspectRatio": {
          "type": "property",
          "name": "preserveAspectRatio",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to preserve the aspect ratio of the `minItemSize`.\nBy default, grid rows may have variable heights. When `preserveAspectRatio`\nis true, all rows will have equal heights.",
          "default": "false"
        },
        "minSpace": {
          "type": "property",
          "name": "minSpace",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The minimum space required between items.",
          "default": "18 x 18"
        },
        "maxHorizontalSpace": {
          "type": "property",
          "name": "maxHorizontalSpace",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum allowed horizontal space between items.",
          "default": "Infinity"
        },
        "maxColumns": {
          "type": "property",
          "name": "maxColumns",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of columns.",
          "default": "Infinity"
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The thickness of the drop indicator.",
          "default": "2"
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "WaterfallLayoutOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutOptions",
      "name": "WaterfallLayoutOptions",
      "properties": {
        "minItemSize": {
          "type": "property",
          "name": "minItemSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The minimum item size.",
          "default": "200 x 200"
        },
        "maxItemSize": {
          "type": "property",
          "name": "maxItemSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The maximum item size.",
          "default": "Infinity"
        },
        "minSpace": {
          "type": "property",
          "name": "minSpace",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The minimum space required between items.",
          "default": "18 x 18"
        },
        "maxHorizontalSpace": {
          "type": "property",
          "name": "maxHorizontalSpace",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum allowed horizontal space between items.",
          "default": "Infinity"
        },
        "maxColumns": {
          "type": "property",
          "name": "maxColumns",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of columns.",
          "default": "Infinity"
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The thickness of the drop indicator.",
          "default": "2"
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ValidationResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult",
      "name": "ValidationResult",
      "properties": {
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validationErrors": {
          "type": "property",
          "name": "validationErrors",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          },
          "optional": false,
          "description": "The current error messages for the input if it is invalid, otherwise an empty array.",
          "default": null
        },
        "validationDetails": {
          "type": "property",
          "name": "validationDetails",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ValidityState"
          },
          "optional": false,
          "description": "The native validation details for the input.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RouterConfig": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterConfig",
      "name": "RouterConfig",
      "properties": {},
      "typeParameters": [],
      "extends": [],
      "description": "This type allows configuring link props with router options and type-safe URLs via TS module augmentation.\nBy default, this is an empty type. Extend with `href` and `routerOptions` properties to configure your router."
    }
  },
  "links": {
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node",
      "name": "Node",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The type of item this node represents.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": false,
          "description": "A unique key for the node.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The object value the node was created from.",
          "default": null
        },
        "level": {
          "type": "property",
          "name": "level",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The level of depth this node is at in the hierarchy.",
          "default": null
        },
        "hasChildNodes": {
          "type": "property",
          "name": "hasChildNodes",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether this item has children, even if not loaded yet.",
          "default": null
        },
        "childNodes": {
          "type": "property",
          "name": "childNodes",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The loaded children of this node.",
          "access": "private",
          "default": null
        },
        "rendered": {
          "type": "property",
          "name": "rendered",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The rendered contents of this node (e.g. JSX).",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A string value for this node, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this node.",
          "default": null
        },
        "index": {
          "type": "property",
          "name": "index",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The index of this node within its parent.",
          "default": null
        },
        "wrapper": {
          "type": "property",
          "name": "wrapper",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "element",
                "value": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that should be called to wrap the rendered node.",
          "default": null
        },
        "parentKey": {
          "type": "property",
          "name": "parentKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The key of the parent node.",
          "default": null
        },
        "prevKey": {
          "type": "property",
          "name": "prevKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The key of the node before this node.",
          "default": null
        },
        "nextKey": {
          "type": "property",
          "name": "nextKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The key of the node after this node.",
          "default": null
        },
        "props": {
          "type": "property",
          "name": "props",
          "indexType": null,
          "value": {
            "id": null,
            "name": null,
            "type": "any"
          },
          "optional": true,
          "description": "Additional properties specific to a particular node type.",
          "default": null
        },
        "shouldInvalidate": {
          "type": "property",
          "name": "shouldInvalidate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "context",
                "value": {
                  "id": null,
                  "name": null,
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "render": {
          "type": "property",
          "name": "render",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "id": null,
                      "name": null,
                      "type": "any"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that renders this node to a React Element in the DOM.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key",
      "name": "Key",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string"
          },
          {
            "type": "number"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction",
      "name": "ChildrenOrFunction",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "identifier",
            "name": "ReactNode"
          },
          {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "values",
                "value": {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "identifier",
                      "name": "T"
                    },
                    {
                      "type": "object",
                      "properties": {
                        "defaultChildren": {
                          "type": "property",
                          "name": "defaultChildren",
                          "indexType": null,
                          "value": {
                            "type": "union",
                            "elements": [
                              {
                                "type": "identifier",
                                "name": "ReactNode"
                              },
                              {
                                "type": "undefined"
                              }
                            ]
                          },
                          "optional": false,
                          "default": null
                        }
                      }
                    }
                  ]
                },
                "rest": false
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Breadcrumbs.tsx:BreadcrumbRenderProps",
      "name": "BreadcrumbRenderProps",
      "properties": {
        "isCurrent": {
          "type": "property",
          "name": "isCurrent",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the breadcrumb is for the current page.",
          "selector": "[data-current]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the breadcrumb is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction",
      "name": "ClassNameOrFunction",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string"
          },
          {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "values",
                "value": {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "identifier",
                      "name": "T"
                    },
                    {
                      "type": "object",
                      "properties": {
                        "defaultClassName": {
                          "type": "property",
                          "name": "defaultClassName",
                          "indexType": null,
                          "value": {
                            "type": "union",
                            "elements": [
                              {
                                "type": "string"
                              },
                              {
                                "type": "undefined"
                              }
                            ]
                          },
                          "optional": false,
                          "default": null
                        }
                      }
                    }
                  ]
                },
                "rest": false
              }
            ],
            "return": {
              "type": "string"
            },
            "typeParameters": []
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction",
      "name": "StyleOrFunction",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "identifier",
            "name": "CSSProperties"
          },
          {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "values",
                "value": {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "identifier",
                      "name": "T"
                    },
                    {
                      "type": "object",
                      "properties": {
                        "defaultStyle": {
                          "type": "property",
                          "name": "defaultStyle",
                          "indexType": null,
                          "value": {
                            "type": "identifier",
                            "name": "CSSProperties"
                          },
                          "optional": false,
                          "default": null
                        }
                      }
                    }
                  ]
                },
                "rest": false
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "CSSProperties"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent",
      "name": "PressEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "pressstart"
              },
              {
                "type": "string",
                "value": "pressend"
              },
              {
                "type": "string",
                "value": "pressup"
              },
              {
                "type": "string",
                "value": "press"
              }
            ]
          },
          "optional": false,
          "description": "The type of press event being fired.",
          "default": null
        },
        "pointerType": {
          "type": "property",
          "name": "pointerType",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PointerType"
          },
          "optional": false,
          "description": "The pointer type that triggered the press event.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": false,
          "description": "The target element of the press event.",
          "default": null
        },
        "shiftKey": {
          "type": "property",
          "name": "shiftKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the shift keyboard modifier was held during the press event.",
          "default": null
        },
        "ctrlKey": {
          "type": "property",
          "name": "ctrlKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the ctrl keyboard modifier was held during the press event.",
          "default": null
        },
        "metaKey": {
          "type": "property",
          "name": "metaKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the meta keyboard modifier was held during the press event.",
          "default": null
        },
        "altKey": {
          "type": "property",
          "name": "altKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the alt keyboard modifier was held during the press event.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "X position relative to the target.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "Y position relative to the target.",
          "default": null
        },
        "continuePropagation": {
          "type": "method",
          "name": "continuePropagation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "By default, press events stop propagation to parent elements.\nIn cases where a handler decides not to handle a specific event,\nit can call `continuePropagation()` to allow a parent to handle it.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PointerType": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PointerType",
      "name": "PointerType",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "mouse"
          },
          {
            "type": "string",
            "value": "pen"
          },
          {
            "type": "string",
            "value": "touch"
          },
          {
            "type": "string",
            "value": "keyboard"
          },
          {
            "type": "string",
            "value": "virtual"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement",
      "name": "FocusableElement",
      "properties": {},
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "Element"
        },
        {
          "type": "identifier",
          "name": "HTMLOrSVGElement"
        }
      ],
      "description": "Any focusable element, including both HTML and SVG elements."
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent",
      "name": "KeyboardEvent",
      "value": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:BaseEvent"
        },
        "typeParameters": [
          {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReactKeyboardEvent"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:BaseEvent": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:BaseEvent",
      "name": "BaseEvent",
      "value": {
        "type": "intersection",
        "types": [
          {
            "type": "identifier",
            "name": "SyntheticEvent"
          },
          {
            "type": "object",
            "properties": {
              "stopPropagation": {
                "type": "method",
                "name": "stopPropagation",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void",
                    "description": null
                  },
                  "typeParameters": []
                },
                "access": "private",
                "description": "Use continuePropagation.",
                "default": null
              },
              "continuePropagation": {
                "type": "method",
                "name": "continuePropagation",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void",
                    "description": null
                  },
                  "typeParameters": []
                },
                "default": null
              }
            }
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "identifier",
            "name": "SyntheticEvent"
          },
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent",
      "name": "HoverEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "hoverstart"
              },
              {
                "type": "string",
                "value": "hoverend"
              }
            ]
          },
          "optional": false,
          "description": "The type of hover event being fired.",
          "default": null
        },
        "pointerType": {
          "type": "property",
          "name": "pointerType",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "mouse"
              },
              {
                "type": "string",
                "value": "pen"
              }
            ]
          },
          "optional": false,
          "description": "The pointer type that triggered the hover event.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLElement"
          },
          "optional": false,
          "description": "The target element of the hover event.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Button.tsx:ButtonRenderProps",
      "name": "ButtonRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isPending": {
          "type": "property",
          "name": "isPending",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently in a pending state.",
          "selector": "[data-pending]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:DateDuration": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:DateDuration",
      "name": "DateDuration",
      "properties": {
        "years": {
          "type": "property",
          "name": "years",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The number of years to add or subtract.",
          "default": null
        },
        "months": {
          "type": "property",
          "name": "months",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The number of months to add or subtract.",
          "default": null
        },
        "weeks": {
          "type": "property",
          "name": "weeks",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The number of weeks to add or subtract.",
          "default": null
        },
        "days": {
          "type": "property",
          "name": "days",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The number of days to add or subtract.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "Represents an amount of time in calendar-specific units, for use when performing arithmetic."
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier",
      "name": "CalendarIdentifier",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "gregory"
          },
          {
            "type": "string",
            "value": "buddhist"
          },
          {
            "type": "string",
            "value": "chinese"
          },
          {
            "type": "string",
            "value": "coptic"
          },
          {
            "type": "string",
            "value": "dangi"
          },
          {
            "type": "string",
            "value": "ethioaa"
          },
          {
            "type": "string",
            "value": "ethiopic"
          },
          {
            "type": "string",
            "value": "hebrew"
          },
          {
            "type": "string",
            "value": "indian"
          },
          {
            "type": "string",
            "value": "islamic"
          },
          {
            "type": "string",
            "value": "islamic-umalqura"
          },
          {
            "type": "string",
            "value": "islamic-tbla"
          },
          {
            "type": "string",
            "value": "islamic-civil"
          },
          {
            "type": "string",
            "value": "islamic-rgsa"
          },
          {
            "type": "string",
            "value": "iso8601"
          },
          {
            "type": "string",
            "value": "japanese"
          },
          {
            "type": "string",
            "value": "persian"
          },
          {
            "type": "string",
            "value": "roc"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar",
      "name": "Calendar",
      "properties": {
        "identifier": {
          "type": "property",
          "name": "identifier",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
          },
          "optional": false,
          "description": "A string identifier for the calendar, as defined by Unicode CLDR.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/supportedValuesOf#supported_calendar_types).",
          "default": null
        },
        "fromJulianDay": {
          "type": "method",
          "name": "fromJulianDay",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "jd",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Creates a CalendarDate in this calendar from the given Julian day number.",
          "default": null
        },
        "toJulianDay": {
          "type": "method",
          "name": "toJulianDay",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts a date in this calendar to a Julian day number.",
          "default": null
        },
        "getDaysInMonth": {
          "type": "method",
          "name": "getDaysInMonth",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the number of days in the month of the given date.",
          "default": null
        },
        "getMonthsInYear": {
          "type": "method",
          "name": "getMonthsInYear",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the number of months in the year of the given date.",
          "default": null
        },
        "getYearsInEra": {
          "type": "method",
          "name": "getYearsInEra",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the number of years in the era of the given date.",
          "default": null
        },
        "getEras": {
          "type": "method",
          "name": "getEras",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "string"
              }
            },
            "typeParameters": []
          },
          "description": "Returns a list of era identifiers for the calendar.",
          "default": null
        },
        "getMinimumMonthInYear": {
          "type": "method",
          "name": "getMinimumMonthInYear",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the minimum month number of the given date's year.\nNormally, this is 1, but in some calendars such as the Japanese,\neras may begin in the middle of a year.",
          "default": null
        },
        "getMinimumDayInMonth": {
          "type": "method",
          "name": "getMinimumDayInMonth",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the minimum day number of the given date's month.\nNormally, this is 1, but in some calendars such as the Japanese,\neras may begin in the middle of a month.",
          "default": null
        },
        "getFormattableMonth": {
          "type": "method",
          "name": "getFormattableMonth",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a date that is the first day of the month for the given date.\nThis is used to determine the month that the given date falls in, if\nthe calendar has months that do not align with the standard calendar months \n(e.g. fiscal calendars).",
          "default": null
        },
        "isEqual": {
          "type": "method",
          "name": "isEqual",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "calendar",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given calendar is the same as this calendar.",
          "default": null
        },
        "balanceDate": {
          "type": "method",
          "name": "balanceDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null
        },
        "balanceYearMonth": {
          "type": "method",
          "name": "balanceYearMonth",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "previousDate",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null
        },
        "constrainDate": {
          "type": "method",
          "name": "constrainDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null
        },
        "isInverseEra": {
          "type": "method",
          "name": "isInverseEra",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "The Calendar interface represents a calendar system, including information\nabout how days, months, years, and eras are organized, and methods to perform\narithmetic on dates."
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate",
      "name": "CalendarDate",
      "properties": {
        "undefined": {
          "type": "any"
        },
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Calendar"
          },
          "optional": false,
          "description": "The calendar system associated with this date, e.g. Gregorian.",
          "access": "public",
          "default": null
        },
        "era": {
          "type": "property",
          "name": "era",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The calendar era for this date, e.g. \"BC\" or \"AD\".",
          "access": "public",
          "default": null
        },
        "year": {
          "type": "property",
          "name": "year",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The year of this date within the era.",
          "access": "public",
          "default": null
        },
        "month": {
          "type": "property",
          "name": "month",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The month number within the year. Note that some calendar systems such as Hebrew\nmay have a variable number of months per year. Therefore, month numbers may not\nalways correspond to the same month names in different years.",
          "access": "public",
          "default": null
        },
        "day": {
          "type": "property",
          "name": "day",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The day number within the month.",
          "access": "public",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "args",
                "value": {
                  "type": "array",
                  "elementType": {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                },
                "rest": true,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this date.",
          "default": null,
          "static": false
        },
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDate` with the given duration added to it.",
          "default": null,
          "static": false
        },
        "subtract": {
          "type": "method",
          "name": "subtract",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDate` with the given duration subtracted from it.",
          "default": null,
          "static": false
        },
        "set": {
          "type": "method",
          "name": "set",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fields",
                "value": {
                  "type": "identifier",
                  "name": "DateFields"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly.",
          "default": null,
          "static": false
        },
        "cycle": {
          "type": "method",
          "name": "cycle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "field",
                "value": {
                  "type": "identifier",
                  "name": "DateField"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "amount",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "identifier",
                  "name": "CycleOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDate` with the given field adjusted by a specified amount.\nWhen the resulting value reaches the limits of the field, it wraps around.",
          "default": null,
          "static": false
        },
        "toDate": {
          "type": "method",
          "name": "toDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "timeZone",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "Date",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone.",
          "default": null,
          "static": false
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to an ISO 8601 formatted string.",
          "default": null,
          "static": false
        },
        "compare": {
          "type": "method",
          "name": "compare",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "b",
                "value": {
                  "type": "identifier",
                  "name": "AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A CalendarDate represents a date without any time components in a specific calendar system."
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate",
      "name": "AnyCalendarDate",
      "properties": {
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
          },
          "optional": false,
          "default": null
        },
        "era": {
          "type": "property",
          "name": "era",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "default": null
        },
        "year": {
          "type": "property",
          "name": "year",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "month": {
          "type": "property",
          "name": "month",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "day": {
          "type": "property",
          "name": "day",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "this",
              "description": null
            },
            "typeParameters": []
          },
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "An interface that is compatible with any object with date fields."
    },
    "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue",
      "name": "DateValue",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime",
      "name": "CalendarDateTime",
      "properties": {
        "undefined": {
          "type": "any"
        },
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Calendar"
          },
          "optional": false,
          "description": "The calendar system associated with this date, e.g. Gregorian.",
          "access": "public",
          "default": null
        },
        "era": {
          "type": "property",
          "name": "era",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The calendar era for this date, e.g. \"BC\" or \"AD\".",
          "access": "public",
          "default": null
        },
        "year": {
          "type": "property",
          "name": "year",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The year of this date within the era.",
          "access": "public",
          "default": null
        },
        "month": {
          "type": "property",
          "name": "month",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The month number within the year. Note that some calendar systems such as Hebrew\nmay have a variable number of months per year. Therefore, month numbers may not\nalways correspond to the same month names in different years.",
          "access": "public",
          "default": null
        },
        "day": {
          "type": "property",
          "name": "day",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The day number within the month.",
          "access": "public",
          "default": null
        },
        "hour": {
          "type": "property",
          "name": "hour",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The hour in the day, numbered from 0 to 23.",
          "access": "public",
          "default": null
        },
        "minute": {
          "type": "property",
          "name": "minute",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The minute in the hour.",
          "access": "public",
          "default": null
        },
        "second": {
          "type": "property",
          "name": "second",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The second in the minute.",
          "access": "public",
          "default": null
        },
        "millisecond": {
          "type": "property",
          "name": "millisecond",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The millisecond in the second.",
          "access": "public",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "args",
                "value": {
                  "type": "array",
                  "elementType": {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                },
                "rest": true,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this date.",
          "default": null,
          "static": false
        },
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateTimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDateTime` with the given duration added to it.",
          "default": null,
          "static": false
        },
        "subtract": {
          "type": "method",
          "name": "subtract",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateTimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDateTime` with the given duration subtracted from it.",
          "default": null,
          "static": false
        },
        "set": {
          "type": "method",
          "name": "set",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fields",
                "value": {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "identifier",
                      "name": "DateFields"
                    },
                    {
                      "type": "identifier",
                      "name": "TimeFields"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly.",
          "default": null,
          "static": false
        },
        "cycle": {
          "type": "method",
          "name": "cycle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "field",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "DateField"
                    },
                    {
                      "type": "identifier",
                      "name": "TimeField"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "amount",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "identifier",
                  "name": "CycleTimeOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.\nWhen the resulting value reaches the limits of the field, it wraps around.",
          "default": null,
          "static": false
        },
        "toDate": {
          "type": "method",
          "name": "toDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "timeZone",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "disambiguation",
                "value": {
                  "type": "identifier",
                  "name": "Disambiguation"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "Date",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to a native JavaScript Date object in the given time zone.",
          "default": null,
          "static": false
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to an ISO 8601 formatted string.",
          "default": null,
          "static": false
        },
        "compare": {
          "type": "method",
          "name": "compare",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "b",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A CalendarDateTime represents a date and time without a time zone, in a specific calendar system."
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime",
      "name": "ZonedDateTime",
      "properties": {
        "undefined": {
          "type": "any"
        },
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Calendar"
          },
          "optional": false,
          "description": "The calendar system associated with this date, e.g. Gregorian.",
          "access": "public",
          "default": null
        },
        "era": {
          "type": "property",
          "name": "era",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The calendar era for this date, e.g. \"BC\" or \"AD\".",
          "access": "public",
          "default": null
        },
        "year": {
          "type": "property",
          "name": "year",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The year of this date within the era.",
          "access": "public",
          "default": null
        },
        "month": {
          "type": "property",
          "name": "month",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The month number within the year. Note that some calendar systems such as Hebrew\nmay have a variable number of months per year. Therefore, month numbers may not\nalways correspond to the same month names in different years.",
          "access": "public",
          "default": null
        },
        "day": {
          "type": "property",
          "name": "day",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The day number within the month.",
          "access": "public",
          "default": null
        },
        "hour": {
          "type": "property",
          "name": "hour",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The hour in the day, numbered from 0 to 23.",
          "access": "public",
          "default": null
        },
        "minute": {
          "type": "property",
          "name": "minute",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The minute in the hour.",
          "access": "public",
          "default": null
        },
        "second": {
          "type": "property",
          "name": "second",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The second in the minute.",
          "access": "public",
          "default": null
        },
        "millisecond": {
          "type": "property",
          "name": "millisecond",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The millisecond in the second.",
          "access": "public",
          "default": null
        },
        "timeZone": {
          "type": "property",
          "name": "timeZone",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The IANA time zone identifier that this date and time is represented in.",
          "access": "public",
          "default": null
        },
        "offset": {
          "type": "property",
          "name": "offset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The UTC offset for this time, in milliseconds.",
          "access": "public",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "args",
                "value": {
                  "type": "array",
                  "elementType": {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                },
                "rest": true,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this date.",
          "default": null,
          "static": false
        },
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateTimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `ZonedDateTime` with the given duration added to it.",
          "default": null,
          "static": false
        },
        "subtract": {
          "type": "method",
          "name": "subtract",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateTimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `ZonedDateTime` with the given duration subtracted from it.",
          "default": null,
          "static": false
        },
        "set": {
          "type": "method",
          "name": "set",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fields",
                "value": {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "identifier",
                      "name": "DateFields"
                    },
                    {
                      "type": "identifier",
                      "name": "TimeFields"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "disambiguation",
                "value": {
                  "type": "identifier",
                  "name": "Disambiguation"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly.",
          "default": null,
          "static": false
        },
        "cycle": {
          "type": "method",
          "name": "cycle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "field",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "DateField"
                    },
                    {
                      "type": "identifier",
                      "name": "TimeField"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "amount",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "identifier",
                  "name": "CycleTimeOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.\nWhen the resulting value reaches the limits of the field, it wraps around.",
          "default": null,
          "static": false
        },
        "toDate": {
          "type": "method",
          "name": "toDate",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "identifier",
              "name": "Date",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to a native JavaScript Date object.",
          "default": null,
          "static": false
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier.",
          "default": null,
          "static": false
        },
        "toAbsoluteString": {
          "type": "method",
          "name": "toAbsoluteString",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to an ISO 8601 formatted string in UTC.",
          "default": null,
          "static": false
        },
        "compare": {
          "type": "method",
          "name": "compare",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "b",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A ZonedDateTime represents a date and time in a specific time zone and calendar system."
    },
    "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior",
      "name": "PageBehavior",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "single"
          },
          {
            "type": "string",
            "value": "visible"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue",
      "name": "MappedDateValue",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
        },
        "extendsType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "trueType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "falseType": {
          "type": "conditional",
          "checkType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
          },
          "extendsType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "trueType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "falseType": {
            "type": "conditional",
            "checkType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
            },
            "extendsType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "trueType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "falseType": {
              "type": "never"
            }
          }
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps",
      "name": "CalendarRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:CalendarState"
          },
          "optional": false,
          "description": "State of the calendar.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:CalendarState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:CalendarState",
      "name": "CalendarState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected date.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the currently selected date.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is in a read only state.",
          "default": null
        },
        "visibleRange": {
          "type": "property",
          "name": "visibleRange",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              }
            ]
          },
          "optional": false,
          "description": "The date range that is currently visible in the calendar.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "timeZone": {
          "type": "property",
          "name": "timeZone",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The time zone of the dates currently being displayed.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the selected value.",
          "access": "private",
          "default": null
        },
        "isValueInvalid": {
          "type": "property",
          "name": "isValueInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "default": null
        },
        "focusedDate": {
          "type": "property",
          "name": "focusedDate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          "optional": false,
          "description": "The currently focused date.",
          "default": null
        },
        "setFocusedDate": {
          "type": "method",
          "name": "setFocusedDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused date.",
          "default": null
        },
        "focusNextDay": {
          "type": "method",
          "name": "focusNextDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next calendar date.",
          "default": null
        },
        "focusPreviousDay": {
          "type": "method",
          "name": "focusPreviousDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous calendar date.",
          "default": null
        },
        "focusNextRow": {
          "type": "method",
          "name": "focusNextRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next row of dates, e.g. the next week.",
          "default": null
        },
        "focusPreviousRow": {
          "type": "method",
          "name": "focusPreviousRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous row of dates, e.g. the previous work.",
          "default": null
        },
        "focusNextPage": {
          "type": "method",
          "name": "focusNextPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next page of dates, e.g. the next month if one month is visible.",
          "default": null
        },
        "focusPreviousPage": {
          "type": "method",
          "name": "focusPreviousPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous page of dates, e.g. the previous month if one month is visible.",
          "default": null
        },
        "focusSectionStart": {
          "type": "method",
          "name": "focusSectionStart",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the start of the current section of dates, e.g. the start of the current month.",
          "default": null
        },
        "focusSectionEnd": {
          "type": "method",
          "name": "focusSectionEnd",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the end of the current section of dates, e.g. the end of the current month month.",
          "default": null
        },
        "focusNextSection": {
          "type": "method",
          "name": "focusNextSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved forward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the next year.",
          "default": null
        },
        "focusPreviousSection": {
          "type": "method",
          "name": "focusPreviousSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved backward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the previous year.",
          "default": null
        },
        "selectFocusedDate": {
          "type": "method",
          "name": "selectFocusedDate",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the currently focused date.",
          "default": null
        },
        "selectDate": {
          "type": "method",
          "name": "selectDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the given date.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether focus is currently within the calendar.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether focus is currently within the calendar.",
          "default": null
        },
        "isInvalid": {
          "type": "method",
          "name": "isInvalid",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is invalid according to the `minValue` and `maxValue` props.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently selected.",
          "default": null
        },
        "isCellFocused": {
          "type": "method",
          "name": "isCellFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently focused.",
          "default": null
        },
        "isCellDisabled": {
          "type": "method",
          "name": "isCellDisabled",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is disabled according to the `minValue, `maxValue`, and `isDisabled` props.",
          "default": null
        },
        "isCellUnavailable": {
          "type": "method",
          "name": "isCellUnavailable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is unavailable according to the `isDateUnavailable` prop.",
          "default": null
        },
        "isPreviousVisibleRangeInvalid": {
          "type": "method",
          "name": "isPreviousVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the previous visible date range is allowed to be selected according to the `minValue` prop.",
          "default": null
        },
        "isNextVisibleRangeInvalid": {
          "type": "method",
          "name": "isNextVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the next visible date range is allowed to be selected according to the `maxValue` prop.",
          "default": null
        },
        "getDatesInWeek": {
          "type": "method",
          "name": "getDatesInWeek",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "weekIndex",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "startDate",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Array"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns an array of dates in the week index counted from the provided start date, or the first visible date if not given.\nThe returned array always has 7 elements, but may include null if the date does not exist according to the calendar system.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue",
      "name": "RangeValue",
      "properties": {
        "start": {
          "type": "property",
          "name": "start",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": false,
          "description": "The start value of the range.",
          "default": null
        },
        "end": {
          "type": "property",
          "name": "end",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": false,
          "description": "The end value of the range.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState",
      "name": "ValidationState",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "valid"
          },
          {
            "type": "string",
            "value": "invalid"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue",
      "name": "DateValue",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarCellRenderProps",
      "name": "CalendarCellRenderProps",
      "properties": {
        "date": {
          "type": "property",
          "name": "date",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          "optional": false,
          "description": "The date that the cell represents.",
          "default": null
        },
        "formattedDate": {
          "type": "property",
          "name": "formattedDate",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The day number formatted according to the current locale.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently being pressed.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isSelectionStart": {
          "type": "property",
          "name": "isSelectionStart",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is the first date in a range selection.",
          "selector": "[data-selection-start]",
          "default": null
        },
        "isSelectionEnd": {
          "type": "property",
          "name": "isSelectionEnd",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is the last date in a range selection.",
          "selector": "[data-selection-end]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is disabled, according to the calendar's `minValue`, `maxValue`, and `isDisabled` props.\nDisabled dates are not focusable, and cannot be selected by the user. They are typically\ndisplayed with a dimmed appearance.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isOutsideVisibleRange": {
          "type": "property",
          "name": "isOutsideVisibleRange",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is outside the visible range of the calendar.\nFor example, dates before the first day of a month in the same week.",
          "selector": "[data-outside-visible-range]",
          "default": null
        },
        "isOutsideMonth": {
          "type": "property",
          "name": "isOutsideMonth",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is outside the current month.",
          "selector": "[data-outside-month]",
          "default": null
        },
        "isUnavailable": {
          "type": "property",
          "name": "isUnavailable",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is unavailable, according to the calendar's `isDateUnavailable` prop. Unavailable dates remain\nfocusable, but cannot be selected by the user. They should be displayed with a visual affordance to indicate they\nare unavailable, such as a different color or a strikethrough.\n\nNote that because they are focusable, unavailable dates must meet a 4.5:1 color contrast ratio,\n[as defined by WCAG](https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html).",
          "selector": "[data-unavailable]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is part of an invalid selection.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isToday": {
          "type": "property",
          "name": "isToday",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is today.",
          "selector": "[data-today]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps",
      "name": "RangeCalendarRenderProps",
      "properties": {
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:RangeCalendarState"
          },
          "optional": false,
          "description": "State of the range calendar.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:RangeCalendarState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:RangeCalendarState",
      "name": "RangeCalendarState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected date range.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the currently selected date range.",
          "default": null
        },
        "highlightDate": {
          "type": "method",
          "name": "highlightDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Highlights the given date during selection, e.g. by hovering or dragging.",
          "default": null
        },
        "anchorDate": {
          "type": "property",
          "name": "anchorDate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current anchor date that the user clicked on to begin range selection.",
          "default": null
        },
        "setAnchorDate": {
          "type": "method",
          "name": "setAnchorDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the anchor date that the user clicked on to begin range selection.",
          "default": null
        },
        "highlightedRange": {
          "type": "property",
          "name": "highlightedRange",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently highlighted date range.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the user is currently dragging over the calendar.",
          "default": null
        },
        "setDragging": {
          "type": "method",
          "name": "setDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isDragging",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the user is dragging over the calendar.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is in a read only state.",
          "default": null
        },
        "visibleRange": {
          "type": "property",
          "name": "visibleRange",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              }
            ]
          },
          "optional": false,
          "description": "The date range that is currently visible in the calendar.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "timeZone": {
          "type": "property",
          "name": "timeZone",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The time zone of the dates currently being displayed.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the selected value.",
          "access": "private",
          "default": null
        },
        "isValueInvalid": {
          "type": "property",
          "name": "isValueInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "default": null
        },
        "focusedDate": {
          "type": "property",
          "name": "focusedDate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          "optional": false,
          "description": "The currently focused date.",
          "default": null
        },
        "setFocusedDate": {
          "type": "method",
          "name": "setFocusedDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused date.",
          "default": null
        },
        "focusNextDay": {
          "type": "method",
          "name": "focusNextDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next calendar date.",
          "default": null
        },
        "focusPreviousDay": {
          "type": "method",
          "name": "focusPreviousDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous calendar date.",
          "default": null
        },
        "focusNextRow": {
          "type": "method",
          "name": "focusNextRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next row of dates, e.g. the next week.",
          "default": null
        },
        "focusPreviousRow": {
          "type": "method",
          "name": "focusPreviousRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous row of dates, e.g. the previous work.",
          "default": null
        },
        "focusNextPage": {
          "type": "method",
          "name": "focusNextPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next page of dates, e.g. the next month if one month is visible.",
          "default": null
        },
        "focusPreviousPage": {
          "type": "method",
          "name": "focusPreviousPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous page of dates, e.g. the previous month if one month is visible.",
          "default": null
        },
        "focusSectionStart": {
          "type": "method",
          "name": "focusSectionStart",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the start of the current section of dates, e.g. the start of the current month.",
          "default": null
        },
        "focusSectionEnd": {
          "type": "method",
          "name": "focusSectionEnd",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the end of the current section of dates, e.g. the end of the current month month.",
          "default": null
        },
        "focusNextSection": {
          "type": "method",
          "name": "focusNextSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved forward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the next year.",
          "default": null
        },
        "focusPreviousSection": {
          "type": "method",
          "name": "focusPreviousSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved backward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the previous year.",
          "default": null
        },
        "selectFocusedDate": {
          "type": "method",
          "name": "selectFocusedDate",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the currently focused date.",
          "default": null
        },
        "selectDate": {
          "type": "method",
          "name": "selectDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the given date.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether focus is currently within the calendar.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether focus is currently within the calendar.",
          "default": null
        },
        "isInvalid": {
          "type": "method",
          "name": "isInvalid",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is invalid according to the `minValue` and `maxValue` props.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently selected.",
          "default": null
        },
        "isCellFocused": {
          "type": "method",
          "name": "isCellFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently focused.",
          "default": null
        },
        "isCellDisabled": {
          "type": "method",
          "name": "isCellDisabled",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is disabled according to the `minValue, `maxValue`, and `isDisabled` props.",
          "default": null
        },
        "isCellUnavailable": {
          "type": "method",
          "name": "isCellUnavailable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is unavailable according to the `isDateUnavailable` prop.",
          "default": null
        },
        "isPreviousVisibleRangeInvalid": {
          "type": "method",
          "name": "isPreviousVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the previous visible date range is allowed to be selected according to the `minValue` prop.",
          "default": null
        },
        "isNextVisibleRangeInvalid": {
          "type": "method",
          "name": "isNextVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the next visible date range is allowed to be selected according to the `maxValue` prop.",
          "default": null
        },
        "getDatesInWeek": {
          "type": "method",
          "name": "getDatesInWeek",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "weekIndex",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "startDate",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Array"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns an array of dates in the week index counted from the provided start date, or the first visible date if not given.\nThe returned array always has 7 elements, but may include null if the date does not exist according to the calendar system.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject",
      "name": "RefObject",
      "properties": {
        "current": {
          "type": "property",
          "name": "current",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError",
      "name": "ValidationError",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string"
          },
          {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxRenderProps",
      "name": "CheckboxRenderProps",
      "properties": {
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isIndeterminate": {
          "type": "property",
          "name": "isIndeterminate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is indeterminate.",
          "selector": "[data-indeterminate]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is required.",
          "selector": "[data-required]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Checkbox.tsx:CheckboxGroupRenderProps",
      "name": "CheckboxGroupRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is required.",
          "selector": "[data-required]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/checkbox/src/useCheckboxGroupState.ts:CheckboxGroupState"
          },
          "optional": false,
          "description": "State of the checkbox group.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/checkbox/src/useCheckboxGroupState.ts:CheckboxGroupState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/checkbox/src/useCheckboxGroupState.ts:CheckboxGroupState",
      "name": "CheckboxGroupState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "typeOperator",
            "operator": "readonly",
            "value": {
              "type": "array",
              "elementType": {
                "type": "string"
              }
            }
          },
          "optional": false,
          "description": "Current selected values.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "typeOperator",
            "operator": "readonly",
            "value": {
              "type": "array",
              "elementType": {
                "type": "string"
              }
            }
          },
          "optional": false,
          "description": "Default selected values.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is read only.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the checkbox group.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox group is invalid.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkboxes in the group are required.\nThis changes to false once at least one item is selected.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given value is selected.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "string"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected values.",
          "default": null
        },
        "addValue": {
          "type": "method",
          "name": "addValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Adds a value to the set of selected values.",
          "default": null
        },
        "removeValue": {
          "type": "method",
          "name": "removeValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Removes a value from the set of selected values.",
          "default": null
        },
        "toggleValue": {
          "type": "method",
          "name": "toggleValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles a value in the set of selected values.",
          "default": null
        },
        "setInvalid": {
          "type": "method",
          "name": "setInvalid",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "validation",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether one of the checkboxes is invalid.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult",
      "name": "ValidationResult",
      "properties": {
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validationErrors": {
          "type": "property",
          "name": "validationErrors",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          },
          "optional": false,
          "description": "The current error messages for the input if it is invalid, otherwise an empty array.",
          "default": null
        },
        "validationDetails": {
          "type": "property",
          "name": "validationDetails",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ValidityState"
          },
          "optional": false,
          "description": "The native validation details for the input.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace",
      "name": "ColorSpace",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "rgb"
          },
          {
            "type": "string",
            "value": "hsl"
          },
          {
            "type": "string",
            "value": "hsb"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel",
      "name": "ColorChannel",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "hue"
          },
          {
            "type": "string",
            "value": "saturation"
          },
          {
            "type": "string",
            "value": "brightness"
          },
          {
            "type": "string",
            "value": "lightness"
          },
          {
            "type": "string",
            "value": "red"
          },
          {
            "type": "string",
            "value": "green"
          },
          {
            "type": "string",
            "value": "blue"
          },
          {
            "type": "string",
            "value": "alpha"
          }
        ]
      },
      "typeParameters": [],
      "description": "A list of color channels."
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color",
      "name": "Color",
      "properties": {
        "toFormat": {
          "type": "method",
          "name": "toFormat",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "format",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Converts the color to the given color format, and returns a new Color object.",
          "default": null
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "format",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat"
                    },
                    {
                      "type": "string",
                      "value": "css"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the color to a string in the given format.",
          "default": null
        },
        "clone": {
          "type": "method",
          "name": "clone",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Returns a duplicate of the color value.",
          "default": null
        },
        "toHexInt": {
          "type": "method",
          "name": "toHexInt",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the color to hex, and returns an integer representation.",
          "default": null
        },
        "getChannelValue": {
          "type": "method",
          "name": "getChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the numeric value for a given channel.\nThrows an error if the channel is unsupported in the current color format.",
          "default": null
        },
        "withChannelValue": {
          "type": "method",
          "name": "withChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Sets the numeric value for a given channel, and returns a new Color object.\nThrows an error if the channel is unsupported in the current color format.",
          "default": null
        },
        "getChannelRange": {
          "type": "method",
          "name": "getChannelRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannelRange"
            },
            "typeParameters": []
          },
          "description": "Returns the minimum, maximum, and step values for a given channel.",
          "default": null
        },
        "getChannelName": {
          "type": "method",
          "name": "getChannelName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized color channel name for a given channel and locale,\nfor use in visual or accessibility labels.",
          "default": null
        },
        "getChannelFormatOptions": {
          "type": "method",
          "name": "getChannelFormatOptions",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the number formatting options for the given channel.",
          "default": null
        },
        "formatChannelValue": {
          "type": "method",
          "name": "formatChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats the numeric value for a given channel for display according to the provided locale.",
          "default": null
        },
        "getColorSpace": {
          "type": "method",
          "name": "getColorSpace",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
            },
            "typeParameters": []
          },
          "description": "Returns the color space, 'rgb', 'hsb' or 'hsl', for the current color.",
          "default": null
        },
        "getColorSpaceAxes": {
          "type": "method",
          "name": "getColorSpaceAxes",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "xyChannels",
                "value": {
                  "type": "object",
                  "properties": {
                    "xChannel": {
                      "type": "property",
                      "name": "xChannel",
                      "indexType": null,
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                      },
                      "optional": true,
                      "default": null
                    },
                    "yChannel": {
                      "type": "property",
                      "name": "yChannel",
                      "indexType": null,
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                      },
                      "optional": true,
                      "default": null
                    }
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorAxes"
            },
            "typeParameters": []
          },
          "description": "Returns the color space axes, xChannel, yChannel, zChannel.",
          "default": null
        },
        "getColorChannels": {
          "type": "method",
          "name": "getColorChannels",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "tuple",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns an array of the color channels within the current color space space.",
          "default": null
        },
        "getColorName": {
          "type": "method",
          "name": "getColorName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized name for the color, for use in visual or accessibility labels.",
          "default": null
        },
        "getHueName": {
          "type": "method",
          "name": "getHueName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized name for the hue, for use in visual or accessibility labels.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "Represents a color value."
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat",
      "name": "ColorFormat",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "hex"
          },
          {
            "type": "string",
            "value": "hexa"
          },
          {
            "type": "string",
            "value": "rgb"
          },
          {
            "type": "string",
            "value": "rgba"
          },
          {
            "type": "string",
            "value": "hsl"
          },
          {
            "type": "string",
            "value": "hsla"
          },
          {
            "type": "string",
            "value": "hsb"
          },
          {
            "type": "string",
            "value": "hsba"
          }
        ]
      },
      "typeParameters": [],
      "description": "A list of supported color formats."
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannelRange": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannelRange",
      "name": "ColorChannelRange",
      "properties": {
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The minimum value of the color channel.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The maximum value of the color channel.",
          "default": null
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step value of the color channel, used when incrementing and decrementing.",
          "default": null
        },
        "pageSize": {
          "type": "property",
          "name": "pageSize",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page step value of the color channel, used when incrementing and decrementing.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorAxes": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorAxes",
      "name": "ColorAxes",
      "value": {
        "type": "object",
        "properties": {
          "xChannel": {
            "type": "property",
            "name": "xChannel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": false,
            "default": null
          },
          "yChannel": {
            "type": "property",
            "name": "yChannel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": false,
            "default": null
          },
          "zChannel": {
            "type": "property",
            "name": "zChannel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": false,
            "default": null
          }
        }
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorArea.tsx:ColorAreaRenderProps",
      "name": "ColorAreaRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color area is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorAreaState.ts:ColorAreaState"
          },
          "optional": false,
          "description": "State of the color area.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorAreaState.ts:ColorAreaState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorAreaState.ts:ColorAreaState",
      "name": "ColorAreaState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The current color value displayed by the color area.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The default value of the color area.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current color value. If a string is passed, it will be parsed to a Color.",
          "default": null
        },
        "xValue": {
          "type": "property",
          "name": "xValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The current value of the horizontal axis channel displayed by the color area.",
          "default": null
        },
        "setXValue": {
          "type": "method",
          "name": "setXValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value for the horizontal axis channel displayed by the color area, and triggers `onChange`.",
          "default": null
        },
        "yValue": {
          "type": "property",
          "name": "yValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The current value of the vertical axis channel displayed by the color area.",
          "default": null
        },
        "setYValue": {
          "type": "method",
          "name": "setYValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value for the vertical axis channel displayed by the color area, and triggers `onChange`.",
          "default": null
        },
        "setColorFromPoint": {
          "type": "method",
          "name": "setColorFromPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the x and y channels of the current color value based on a percentage of the width and height of the color area, and triggers `onChange`.",
          "default": null
        },
        "getThumbPosition": {
          "type": "method",
          "name": "getThumbPosition",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "property",
                  "name": "x",
                  "indexType": null,
                  "value": {
                    "type": "number"
                  },
                  "optional": false,
                  "default": null
                },
                "y": {
                  "type": "property",
                  "name": "y",
                  "indexType": null,
                  "value": {
                    "type": "number"
                  },
                  "optional": false,
                  "default": null
                }
              },
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the coordinates of the thumb relative to the upper left corner of the color area as a percentage.",
          "default": null
        },
        "incrementX": {
          "type": "method",
          "name": "incrementX",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the value of the horizontal axis channel by the channel step or page amount.",
          "default": null
        },
        "decrementX": {
          "type": "method",
          "name": "decrementX",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the value of the horizontal axis channel by the channel step or page amount.",
          "default": null
        },
        "incrementY": {
          "type": "method",
          "name": "incrementY",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the value of the vertical axis channel by the channel step or page amount.",
          "default": null
        },
        "decrementY": {
          "type": "method",
          "name": "decrementY",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the value of the vertical axis channel by the channel step or page amount.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color area is currently being dragged.",
          "default": null
        },
        "setDragging": {
          "type": "method",
          "name": "setDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the color area is being dragged.",
          "default": null
        },
        "channels": {
          "type": "property",
          "name": "channels",
          "indexType": null,
          "value": {
            "type": "object",
            "properties": {
              "xChannel": {
                "type": "property",
                "name": "xChannel",
                "indexType": null,
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "optional": false,
                "default": null
              },
              "yChannel": {
                "type": "property",
                "name": "yChannel",
                "indexType": null,
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "optional": false,
                "default": null
              },
              "zChannel": {
                "type": "property",
                "name": "zChannel",
                "indexType": null,
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "optional": false,
                "default": null
              }
            }
          },
          "optional": false,
          "description": "Returns the xChannel, yChannel and zChannel names based on the color value.",
          "default": null
        },
        "xChannelStep": {
          "type": "property",
          "name": "xChannelStep",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step value of the xChannel, used when incrementing and decrementing.",
          "default": null
        },
        "yChannelStep": {
          "type": "property",
          "name": "yChannelStep",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step value of the yChannel, used when incrementing and decrementing.",
          "default": null
        },
        "xChannelPageStep": {
          "type": "property",
          "name": "xChannelPageStep",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page step value of the xChannel, used when incrementing and decrementing.",
          "default": null
        },
        "yChannelPageStep": {
          "type": "property",
          "name": "yChannelPageStep",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page step value of the yChannel, used when incrementing and decrementing.",
          "default": null
        },
        "getDisplayColor": {
          "type": "method",
          "name": "getDisplayColor",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Returns the color that should be displayed in the color area thumb instead of `value`.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorField.tsx:ColorFieldRenderProps",
      "name": "ColorFieldRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color field is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "channel": {
          "type": "property",
          "name": "channel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
              },
              {
                "type": "string",
                "value": "hex"
              }
            ]
          },
          "optional": false,
          "description": "The color channel that this field edits, or \"hex\" if no `channel` prop is set.",
          "selector": "[data-channel=\"hex | hue | saturation | ...\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorFieldState.ts:ColorFieldState"
          },
          "optional": false,
          "description": "State of the color field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorFieldState.ts:ColorFieldState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorFieldState.ts:ColorFieldState",
      "name": "ColorFieldState",
      "properties": {
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The current text value of the input. Updated as the user types,\nand formatted according to `formatOptions` on blur.",
          "default": null
        },
        "colorValue": {
          "type": "property",
          "name": "colorValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently parsed color value, or null if the field is empty.\nUpdated based on the `inputValue` as the user types.",
          "default": null
        },
        "defaultColorValue": {
          "type": "property",
          "name": "defaultColorValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default value of the color field.",
          "default": null
        },
        "setColorValue": {
          "type": "method",
          "name": "setColorValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the color value of the field.",
          "default": null
        },
        "setInputValue": {
          "type": "method",
          "name": "setInputValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current text value of the input.",
          "default": null
        },
        "commit": {
          "type": "method",
          "name": "commit",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the input value based on the currently parsed color value.\nTypically this is called when the field is blurred.",
          "default": null
        },
        "increment": {
          "type": "method",
          "name": "increment",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the current input value to the next step boundary, and fires `onChange`.",
          "default": null
        },
        "decrement": {
          "type": "method",
          "name": "decrement",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the current input value to the next step boundary, and fires `onChange`.",
          "default": null
        },
        "incrementToMax": {
          "type": "method",
          "name": "incrementToMax",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current value to the maximum color value, and fires `onChange`.",
          "default": null
        },
        "decrementToMin": {
          "type": "method",
          "name": "decrementToMin",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current value to the minimum color value, and fires `onChange`.",
          "default": null
        },
        "validate": {
          "type": "method",
          "name": "validate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Validates a user input string.\nValues can be partially entered, and may be valid even if they cannot currently be parsed to a color.\nCan be used to implement validation as a user types.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation",
      "name": "Orientation",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "horizontal"
          },
          {
            "type": "string",
            "value": "vertical"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSlider.tsx:ColorSliderRenderProps",
      "name": "ColorSliderRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the color slider.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color slider is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorSliderState.ts:ColorSliderState"
          },
          "optional": false,
          "description": "State of the color slider.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorSliderState.ts:ColorSliderState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorSliderState.ts:ColorSliderState",
      "name": "ColorSliderState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The current color value represented by the color slider.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current color value. If a string is passed, it will be parsed to a Color.",
          "default": null
        },
        "getDisplayColor": {
          "type": "method",
          "name": "getDisplayColor",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Returns the color that should be displayed in the slider instead of `value` or the optional parameter.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color slider is currently being dragged.",
          "default": null
        },
        "values": {
          "type": "property",
          "name": "values",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "number"
            }
          },
          "optional": false,
          "description": "Values managed by the slider by thumb index.",
          "default": null
        },
        "defaultValues": {
          "type": "property",
          "name": "defaultValues",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "number"
            }
          },
          "optional": false,
          "description": "The default values for each thumb.",
          "default": null
        },
        "getThumbValue": {
          "type": "method",
          "name": "getThumbValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Get the value for the specified thumb.",
          "default": null
        },
        "setThumbValue": {
          "type": "method",
          "name": "setThumbValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value for the specified thumb.\nThe actual value set will be clamped and rounded according to min/max/step.",
          "default": null
        },
        "setThumbPercent": {
          "type": "method",
          "name": "setThumbPercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "percent",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets value for the specified thumb by percent offset (between 0 and 1).",
          "default": null
        },
        "isThumbDragging": {
          "type": "method",
          "name": "isThumbDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Whether the specific thumb is being dragged.",
          "default": null
        },
        "setThumbDragging": {
          "type": "method",
          "name": "setThumbDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "dragging",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set is dragging on the specified thumb.",
          "default": null
        },
        "focusedThumb": {
          "type": "property",
          "name": "focusedThumb",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "Currently-focused thumb index.",
          "default": null
        },
        "setFocusedThumb": {
          "type": "method",
          "name": "setFocusedThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "number"
                    },
                    {
                      "type": "undefined"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set focused true on specified thumb. This will remove focus from\nany thumb that had it before.",
          "default": null
        },
        "getThumbPercent": {
          "type": "method",
          "name": "getThumbPercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the specified thumb's value as a percentage from 0 to 1.",
          "default": null
        },
        "getValuePercent": {
          "type": "method",
          "name": "getValuePercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the value as a percent between the min and max of the slider.",
          "default": null
        },
        "getThumbValueLabel": {
          "type": "method",
          "name": "getThumbValueLabel",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the string label for the specified thumb's value, per props.formatOptions.",
          "default": null
        },
        "getFormattedValue": {
          "type": "method",
          "name": "getFormattedValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the string label for the value, per props.formatOptions.",
          "default": null
        },
        "getThumbMinValue": {
          "type": "method",
          "name": "getThumbMinValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the min allowed value for the specified thumb.",
          "default": null
        },
        "getThumbMaxValue": {
          "type": "method",
          "name": "getThumbMaxValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the max allowed value for the specified thumb.",
          "default": null
        },
        "getPercentValue": {
          "type": "method",
          "name": "getPercentValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "percent",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts a percent along track (between 0 and 1) to the corresponding value.",
          "default": null
        },
        "isThumbEditable": {
          "type": "method",
          "name": "isThumbEditable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns if the specified thumb is editable.",
          "default": null
        },
        "setThumbEditable": {
          "type": "method",
          "name": "setThumbEditable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "editable",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set the specified thumb's editable state.",
          "default": null
        },
        "incrementThumb": {
          "type": "method",
          "name": "incrementThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the value of the thumb by the step or page amount.",
          "default": null
        },
        "decrementThumb": {
          "type": "method",
          "name": "decrementThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the value of the thumb by the step or page amount.",
          "default": null
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step amount for the slider.",
          "default": null
        },
        "pageSize": {
          "type": "property",
          "name": "pageSize",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page size for the slider, used to do a bigger step.",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the slider.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the slider is disabled.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatch.tsx:ColorSwatchRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatch.tsx:ColorSwatchRenderProps",
      "name": "ColorSwatchRenderProps",
      "properties": {
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The color of the swatch.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerRenderProps",
      "name": "ColorSwatchPickerRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "stack"
              },
              {
                "type": "string",
                "value": "grid"
              }
            ]
          },
          "optional": false,
          "description": "Whether the items are arranged in a stack or grid.",
          "selector": "[data-layout=\"stack | grid\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the listbox.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState",
      "name": "ListState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the list.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of items that are disabled.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection",
      "name": "Collection",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The number of items in the collection.",
          "default": null
        },
        "getKeys": {
          "type": "method",
          "name": "getKeys",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Iterate over all keys in the collection.",
          "default": null
        },
        "getItem": {
          "type": "method",
          "name": "getItem",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "T"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get an item by its key.",
          "default": null
        },
        "at": {
          "type": "method",
          "name": "at",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "idx",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "T"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get an item by the index of its key.",
          "default": null
        },
        "getKeyBefore": {
          "type": "method",
          "name": "getKeyBefore",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the key that comes before the given key in the collection.",
          "default": null
        },
        "getKeyAfter": {
          "type": "method",
          "name": "getKeyAfter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the key that comes after the given key in the collection.",
          "default": null
        },
        "getFirstKey": {
          "type": "method",
          "name": "getFirstKey",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the first key in the collection.",
          "default": null
        },
        "getLastKey": {
          "type": "method",
          "name": "getLastKey",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the last key in the collection.",
          "default": null
        },
        "getChildren": {
          "type": "method",
          "name": "getChildren",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Iterate over the child items of the given key.",
          "default": null
        },
        "getTextValue": {
          "type": "method",
          "name": "getTextValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a string representation of the item's contents.",
          "default": null
        },
        "filter": {
          "type": "method",
          "name": "filter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "filterFn",
                "value": {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "nodeValue",
                      "value": {
                        "type": "string"
                      },
                      "rest": false
                    },
                    {
                      "type": "parameter",
                      "name": "node",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Filters the collection using the given function.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": [
        {
          "type": "identifier",
          "name": "Iterable"
        }
      ],
      "description": "A generic interface to access a readonly sequential\ncollection of unique keyed items."
    },
    "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager",
      "name": "SelectionManager",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionState"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "allowsCellSelection": {
          "type": "property",
          "name": "allowsCellSelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "_isSelectAll": {
          "type": "property",
          "name": "_isSelectAll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "layoutDelegate": {
          "type": "property",
          "name": "layoutDelegate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LayoutDelegate"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "collection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
                  },
                  "typeParameters": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                      },
                      "typeParameters": [
                        {
                          "type": "unknown"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionState"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManagerOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "setSelectionBehavior": {
          "type": "method",
          "name": "setSelectionBehavior",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selectionBehavior",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selection behavior for the collection.",
          "default": null,
          "static": false
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "description": "Whether the collection is currently focused.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the collection is focused.",
          "default": null,
          "static": false
        },
        "focusedKey": {
          "type": "property",
          "name": "focusedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "description": "The current focused key in the collection.",
          "default": null
        },
        "childFocusStrategy": {
          "type": "property",
          "name": "childFocusStrategy",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              },
              {
                "type": "null"
              }
            ]
          },
          "description": "Whether the first or last child of the focused key should receive focus.",
          "default": null
        },
        "setFocusedKey": {
          "type": "method",
          "name": "setFocusedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "childFocusStrategy",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused key.",
          "default": null,
          "static": false
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "description": "The currently selected keys in the collection.",
          "default": null
        },
        "rawSelection": {
          "type": "property",
          "name": "rawSelection",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
          },
          "description": "The raw selection value for the collection.\nEither 'all' for select all, or a set of keys.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether a key is selected.",
          "default": null,
          "static": false
        },
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "description": "Whether the selection is empty.",
          "default": null
        },
        "isSelectAll": {
          "type": "property",
          "name": "isSelectAll",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "description": "Whether all items in the collection are selected.",
          "default": null
        },
        "firstSelectedKey": {
          "type": "property",
          "name": "firstSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "default": null
        },
        "lastSelectedKey": {
          "type": "property",
          "name": "lastSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "default": null
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "default": null
        },
        "extendSelection": {
          "type": "method",
          "name": "extendSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "toKey",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Extends the selection to the given key.",
          "default": null,
          "static": false
        },
        "getKeyRange": {
          "type": "method",
          "name": "getKeyRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "from",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "to",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getKeyRangeInternal": {
          "type": "method",
          "name": "getKeyRangeInternal",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "from",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "to",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getKey": {
          "type": "method",
          "name": "getKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "toggleSelection": {
          "type": "method",
          "name": "toggleSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles whether the given key is selected.",
          "default": null,
          "static": false
        },
        "replaceSelection": {
          "type": "method",
          "name": "replaceSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the selection with only the given key.",
          "default": null,
          "static": false
        },
        "setSelectedKeys": {
          "type": "method",
          "name": "setSelectedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the selection with the given keys.",
          "default": null,
          "static": false
        },
        "getSelectAllKeys": {
          "type": "method",
          "name": "getSelectAllKeys",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "selectAll": {
          "type": "method",
          "name": "selectAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects all items in the collection.",
          "default": null,
          "static": false
        },
        "clearSelection": {
          "type": "method",
          "name": "clearSelection",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Removes all keys from the selection.",
          "default": null,
          "static": false
        },
        "toggleSelectAll": {
          "type": "method",
          "name": "toggleSelectAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles between select all and an empty selection.",
          "default": null,
          "static": false
        },
        "select": {
          "type": "method",
          "name": "select",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:LongPressEvent"
                    },
                    {
                      "type": "identifier",
                      "name": "PointerEvent"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "isSelectionEqual": {
          "type": "method",
          "name": "isSelectionEqual",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the current selection is equal to the given selection.",
          "default": null,
          "static": false
        },
        "canSelectItem": {
          "type": "method",
          "name": "canSelectItem",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "isDisabled": {
          "type": "method",
          "name": "isDisabled",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "isLink": {
          "type": "method",
          "name": "isLink",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getItemProps": {
          "type": "method",
          "name": "getItemProps",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "withCollection": {
          "type": "method",
          "name": "withCollection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "collection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
                  },
                  "typeParameters": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                      },
                      "typeParameters": [
                        {
                          "type": "unknown"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "An interface for reading and updating multiple selection state."
    },
    "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionState",
      "name": "MultipleSelectionState",
      "properties": {
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "setSelectionBehavior": {
          "type": "method",
          "name": "setSelectionBehavior",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selectionBehavior",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selection behavior for the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
          },
          "optional": false,
          "description": "The currently selected keys in the collection.",
          "default": null
        },
        "setSelectedKeys": {
          "type": "method",
          "name": "setSelectedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected keys in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "The currently disabled keys in the collection.",
          "default": null
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "optional": false,
          "description": "Whether `disabledKeys` applies to selection, actions, or both.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the collection is currently focused.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the collection is focused.",
          "default": null
        },
        "focusedKey": {
          "type": "property",
          "name": "focusedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current focused key in the collection.",
          "default": null
        },
        "childFocusStrategy": {
          "type": "property",
          "name": "childFocusStrategy",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Whether the first or last child of the focused key should receive focus.",
          "default": null
        },
        "setFocusedKey": {
          "type": "method",
          "name": "setFocusedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "child",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused key, and optionally, whether the first or last child of that key should receive focus.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode",
      "name": "SelectionMode",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "none"
          },
          {
            "type": "string",
            "value": "single"
          },
          {
            "type": "string",
            "value": "multiple"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior",
      "name": "SelectionBehavior",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "toggle"
          },
          {
            "type": "string",
            "value": "replace"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection",
      "name": "Selection",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "all"
          },
          {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior",
      "name": "DisabledBehavior",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "selection"
          },
          {
            "type": "string",
            "value": "all"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy",
      "name": "FocusStrategy",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "first"
          },
          {
            "type": "string",
            "value": "last"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LayoutDelegate": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LayoutDelegate",
      "name": "LayoutDelegate",
      "properties": {
        "getItemRect": {
          "type": "method",
          "name": "getItemRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Rect"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns a rectangle for the item with the given key.",
          "default": null
        },
        "getVisibleRect": {
          "type": "method",
          "name": "getVisibleRect",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Rect"
            },
            "typeParameters": []
          },
          "description": "Returns the visible rectangle of the collection.",
          "default": null
        },
        "getContentSize": {
          "type": "method",
          "name": "getContentSize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Size"
            },
            "typeParameters": []
          },
          "description": "Returns the size of the scrollable content in the collection.",
          "default": null
        },
        "getKeyRange": {
          "type": "method",
          "name": "getKeyRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "from",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "to",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "identifier",
                "name": "Key"
              }
            },
            "typeParameters": []
          },
          "description": "Returns a list of keys between `from` and `to`.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A LayoutDelegate provides layout information for collection items."
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Rect": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Rect",
      "name": "Rect",
      "properties": {
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "height": {
          "type": "property",
          "name": "height",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Size": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Size",
      "name": "Size",
      "properties": {
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "height": {
          "type": "property",
          "name": "height",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManagerOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManagerOptions",
      "name": "SelectionManagerOptions",
      "properties": {
        "allowsCellSelection": {
          "type": "property",
          "name": "allowsCellSelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "default": null
        },
        "layoutDelegate": {
          "type": "property",
          "name": "layoutDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LayoutDelegate"
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:LongPressEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:LongPressEvent",
      "name": "LongPressEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "longpressstart"
              },
              {
                "type": "string",
                "value": "longpressend"
              },
              {
                "type": "string",
                "value": "longpress"
              }
            ]
          },
          "optional": false,
          "description": "The type of long press event being fired.",
          "default": null
        },
        "pointerType": {
          "type": "property",
          "name": "pointerType",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PointerType"
          },
          "optional": false,
          "description": "The pointer type that triggered the press event.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": false,
          "description": "The target element of the press event.",
          "default": null
        },
        "shiftKey": {
          "type": "property",
          "name": "shiftKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the shift keyboard modifier was held during the press event.",
          "default": null
        },
        "ctrlKey": {
          "type": "property",
          "name": "ctrlKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the ctrl keyboard modifier was held during the press event.",
          "default": null
        },
        "metaKey": {
          "type": "property",
          "name": "metaKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the meta keyboard modifier was held during the press event.",
          "default": null
        },
        "altKey": {
          "type": "property",
          "name": "altKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the alt keyboard modifier was held during the press event.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "X position relative to the target.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "Y position relative to the target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorSwatchPicker.tsx:ColorSwatchPickerItemRenderProps",
      "name": "ColorSwatchPickerItemRenderProps",
      "properties": {
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The color of the swatch.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorThumb.tsx:ColorThumbRenderProps",
      "name": "ColorThumbRenderProps",
      "properties": {
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The selected color, excluding the alpha channel.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether this thumb is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelRenderProps",
      "name": "ColorWheelRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color wheel is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorWheelState.ts:ColorWheelState"
          },
          "optional": false,
          "description": "State of the color wheel.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorWheelState.ts:ColorWheelState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorWheelState.ts:ColorWheelState",
      "name": "ColorWheelState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The current color value represented by the color wheel.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
          },
          "optional": false,
          "description": "The default color value.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the color value represented by the color wheel, and triggers `onChange`.",
          "default": null
        },
        "hue": {
          "type": "property",
          "name": "hue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The current value of the hue channel displayed by the color wheel.",
          "default": null
        },
        "setHue": {
          "type": "method",
          "name": "setHue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the hue channel of the current color value and triggers `onChange`.",
          "default": null
        },
        "setHueFromPoint": {
          "type": "method",
          "name": "setHueFromPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "radius",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the hue channel of the current color value based on the given coordinates and radius of the color wheel, and triggers `onChange`.",
          "default": null
        },
        "getThumbPosition": {
          "type": "method",
          "name": "getThumbPosition",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "radius",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "property",
                  "name": "x",
                  "indexType": null,
                  "value": {
                    "type": "number"
                  },
                  "optional": false,
                  "default": null
                },
                "y": {
                  "type": "property",
                  "name": "y",
                  "indexType": null,
                  "value": {
                    "type": "number"
                  },
                  "optional": false,
                  "default": null
                }
              },
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the coordinates of the thumb relative to the center point of the color wheel.",
          "default": null
        },
        "increment": {
          "type": "method",
          "name": "increment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the hue by the given amount (defaults to 1).",
          "default": null
        },
        "decrement": {
          "type": "method",
          "name": "decrement",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the hue by the given amount (defaults to 1).",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color wheel is currently being dragged.",
          "default": null
        },
        "setDragging": {
          "type": "method",
          "name": "setDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the color wheel is being dragged.",
          "default": null
        },
        "getDisplayColor": {
          "type": "method",
          "name": "getDisplayColor",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Returns the color that should be displayed in the color wheel instead of `value`.",
          "default": null
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step value of the hue channel, used when incrementing and decrementing.",
          "default": null
        },
        "pageStep": {
          "type": "property",
          "name": "pageStep",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page step value of the hue channel, used when incrementing and decrementing.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color wheel is disabled.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelTrackRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ColorWheel.tsx:ColorWheelTrackRenderProps",
      "name": "ColorWheelTrackRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the color wheel is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/useColorWheelState.ts:ColorWheelState"
          },
          "optional": false,
          "description": "State of the color wheel.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction",
      "name": "MenuTriggerAction",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "focus"
          },
          {
            "type": "string",
            "value": "input"
          },
          {
            "type": "string",
            "value": "manual"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:ComboBoxValidationValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:ComboBoxValidationValue",
      "name": "ComboBoxValidationValue",
      "properties": {
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The selected key in the ComboBox.",
          "default": null
        },
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The value of the ComboBox input.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ComboBox.tsx:ComboBoxRenderProps",
      "name": "ComboBoxRenderProps",
      "properties": {
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the combobox is currently open.",
          "selector": "[data-open]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the combobox is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the combobox is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the combobox is required.",
          "selector": "[data-required]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValues": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValues",
      "name": "ProviderValues",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              }
            ]
          },
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "B"
                  }
                ]
              }
            ]
          },
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "B"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "C"
                  }
                ]
              }
            ]
          },
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "B"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "C"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "D"
                  }
                ]
              }
            ]
          },
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "B"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "C"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "D"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "E"
                  }
                ]
              }
            ]
          },
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "B"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "C"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "D"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "E"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "F"
                  }
                ]
              }
            ]
          },
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "B"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "C"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "D"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "E"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "F"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "G"
                  }
                ]
              }
            ]
          },
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "B"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "C"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "D"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "E"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "F"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "G"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "H"
                  }
                ]
              }
            ]
          },
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "B"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "C"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "D"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "E"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "F"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "G"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "H"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "I"
                  }
                ]
              }
            ]
          },
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "B"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "C"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "D"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "E"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "F"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "G"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "H"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "I"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "J"
                  }
                ]
              }
            ]
          },
          {
            "type": "tuple",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "A"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "B"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "C"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "D"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "E"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "F"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "G"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "H"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "I"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "J"
                  }
                ]
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "K"
                  }
                ]
              }
            ]
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "A",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "B",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "C",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "D",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "E",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "F",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "G",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "H",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "I",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "J",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "K",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ProviderValue",
      "name": "ProviderValue",
      "value": {
        "type": "tuple",
        "elements": [
          {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Context"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          {
            "type": "identifier",
            "name": "T"
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlotProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlotProps",
      "name": "SlotProps",
      "properties": {
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ContextValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ContextValue",
      "name": "ContextValue",
      "value": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedContextValue"
        },
        "typeParameters": [
          {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:WithRef"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "identifier",
                "name": "E"
              }
            ]
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "E",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedContextValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedContextValue",
      "name": "SlottedContextValue",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedValue"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          {
            "type": "identifier",
            "name": "T"
          },
          {
            "type": "null"
          },
          {
            "type": "undefined"
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedValue",
      "name": "SlottedValue",
      "properties": {
        "slots": {
          "type": "property",
          "name": "slots",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Record"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "string"
                  },
                  {
                    "type": "symbol"
                  }
                ]
              },
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:WithRef": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:WithRef",
      "name": "WithRef",
      "value": {
        "type": "intersection",
        "types": [
          {
            "type": "identifier",
            "name": "T"
          },
          {
            "type": "object",
            "properties": {
              "ref": {
                "type": "property",
                "name": "ref",
                "indexType": null,
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "ForwardedRef"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "E"
                    }
                  ]
                },
                "optional": true,
                "default": null
              }
            }
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "E",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:RenderPropsHookOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:RenderPropsHookOptions",
      "name": "RenderPropsHookOptions",
      "properties": {
        "values": {
          "type": "property",
          "name": "values",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": false,
          "default": null
        },
        "defaultChildren": {
          "type": "property",
          "name": "defaultChildren",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "default": null
        },
        "defaultClassName": {
          "type": "property",
          "name": "defaultClassName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "default": null
        },
        "defaultStyle": {
          "type": "property",
          "name": "defaultStyle",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:RenderPropsHookRetVal": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:RenderPropsHookRetVal",
      "name": "RenderPropsHookRetVal",
      "properties": {
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "default": null
        },
        "data-rac": {
          "type": "property",
          "name": "data-rac",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity",
      "name": "Granularity",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "day"
          },
          {
            "type": "string",
            "value": "hour"
          },
          {
            "type": "string",
            "value": "minute"
          },
          {
            "type": "string",
            "value": "second"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue",
      "name": "MappedDateValue",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
        },
        "extendsType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "trueType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "falseType": {
          "type": "conditional",
          "checkType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "extendsType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "trueType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "falseType": {
            "type": "conditional",
            "checkType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "extendsType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "trueType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "falseType": {
              "type": "never"
            }
          }
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateFieldRenderProps",
      "name": "DateFieldRenderProps",
      "properties": {
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateFieldState"
          },
          "optional": false,
          "description": "State of the date field.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is read only.",
          "selector": "[data-readonly]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateFieldState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateFieldState",
      "name": "DateFieldState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current field value.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default field value.",
          "default": null
        },
        "dateValue": {
          "type": "property",
          "name": "dateValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Date"
          },
          "optional": false,
          "description": "The current value, converted to a native JavaScript `Date` object.",
          "default": null
        },
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
          },
          "optional": false,
          "description": "The calendar system currently in use.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the field's value.",
          "default": null
        },
        "segments": {
          "type": "property",
          "name": "segments",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateSegment"
            }
          },
          "optional": false,
          "description": "A list of segments for the current value.",
          "default": null
        },
        "dateFormatter": {
          "type": "property",
          "name": "dateFormatter",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter"
          },
          "optional": false,
          "description": "A date formatter configured for the current locale and format.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the date field, based on the `validationState`, `minValue`, and `maxValue` props.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is invalid, based on the `isInvalid`, `minValue`, and `maxValue` props.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": false,
          "description": "The granularity for the field, based on the `granularity` prop and current value.",
          "default": null
        },
        "maxGranularity": {
          "type": "property",
          "name": "maxGranularity",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "year"
              },
              {
                "type": "string",
                "value": "month"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
              }
            ]
          },
          "optional": false,
          "description": "The maximum date or time unit that is displayed in the field.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the field is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the field is read only.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the field is required.",
          "default": null
        },
        "increment": {
          "type": "method",
          "name": "increment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the given segment. Upon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "decrement": {
          "type": "method",
          "name": "decrement",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the given segment. Upon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "incrementPage": {
          "type": "method",
          "name": "incrementPage",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the given segment by a larger amount, rounding it to the nearest increment.\nThe amount to increment by depends on the field, for example 15 minutes, 7 days, and 5 years.\nUpon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "decrementPage": {
          "type": "method",
          "name": "decrementPage",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the given segment by a larger amount, rounding it to the nearest increment.\nThe amount to decrement by depends on the field, for example 15 minutes, 7 days, and 5 years.\nUpon reaching the minimum or maximum value, the value wraps around to the opposite limit.",
          "default": null
        },
        "setSegment": {
          "type": "method",
          "name": "setSegment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value of the given segment.",
          "default": null
        },
        "confirmPlaceholder": {
          "type": "method",
          "name": "confirmPlaceholder",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the remaining unfilled segments with the placeholder value.",
          "default": null
        },
        "clearSegment": {
          "type": "method",
          "name": "clearSegment",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Clears the value of the given segment, reverting it to the placeholder.",
          "default": null
        },
        "formatValue": {
          "type": "method",
          "name": "formatValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fieldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FieldOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats the current date value using the given options.",
          "default": null
        },
        "getDateFormatter": {
          "type": "method",
          "name": "getDateFormatter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "formatOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FormatterOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter"
            },
            "typeParameters": []
          },
          "description": "Gets a formatter based on state's props.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateSegment": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:DateSegment",
      "name": "DateSegment",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType"
          },
          "optional": false,
          "description": "The type of segment.",
          "default": null
        },
        "text": {
          "type": "property",
          "name": "text",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The formatted text for the segment.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The numeric value for the segment, if applicable.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum numeric value for the segment, if applicable.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum numeric value for the segment, if applicable.",
          "default": null
        },
        "isPlaceholder": {
          "type": "property",
          "name": "isPlaceholder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the value is a placeholder.",
          "default": null
        },
        "placeholder": {
          "type": "property",
          "name": "placeholder",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A placeholder string for the segment.",
          "default": null
        },
        "isEditable": {
          "type": "property",
          "name": "isEditable",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the segment is editable.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType",
      "name": "SegmentType",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "era"
          },
          {
            "type": "string",
            "value": "year"
          },
          {
            "type": "string",
            "value": "month"
          },
          {
            "type": "string",
            "value": "day"
          },
          {
            "type": "string",
            "value": "hour"
          },
          {
            "type": "string",
            "value": "minute"
          },
          {
            "type": "string",
            "value": "second"
          },
          {
            "type": "string",
            "value": "dayPeriod"
          },
          {
            "type": "string",
            "value": "literal"
          },
          {
            "type": "string",
            "value": "timeZoneName"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter",
      "name": "DateFormatter",
      "properties": {
        "formatter": {
          "type": "property",
          "name": "formatter",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Intl.DateTimeFormat"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "options": {
          "type": "property",
          "name": "options",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Intl.DateTimeFormatOptions"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "resolvedHourCycle": {
          "type": "property",
          "name": "resolvedHourCycle",
          "indexType": null,
          "value": {
            "type": "indexedAccess",
            "objectType": {
              "type": "identifier",
              "name": "Intl.DateTimeFormatOptions"
            },
            "indexType": {
              "type": "string",
              "value": "hourCycle"
            }
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "identifier",
                  "name": "Intl.DateTimeFormatOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "format": {
          "type": "method",
          "name": "format",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "Date"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats a date as a string according to the locale and format options passed to the constructor.",
          "default": null,
          "static": false
        },
        "formatToParts": {
          "type": "method",
          "name": "formatToParts",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "Date"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "identifier",
                "name": "Intl.DateTimeFormatPart"
              }
            },
            "typeParameters": []
          },
          "description": "Formats a date to an array of parts such as separators, numbers, punctuation, and more.",
          "default": null,
          "static": false
        },
        "formatRange": {
          "type": "method",
          "name": "formatRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "start",
                "value": {
                  "type": "identifier",
                  "name": "Date"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "end",
                "value": {
                  "type": "identifier",
                  "name": "Date"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats a date range as a string.",
          "default": null,
          "static": false
        },
        "formatRangeToParts": {
          "type": "method",
          "name": "formatRangeToParts",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "start",
                "value": {
                  "type": "identifier",
                  "name": "Date"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "end",
                "value": {
                  "type": "identifier",
                  "name": "Date"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateRangeFormatPart"
              }
            },
            "typeParameters": []
          },
          "description": "Formats a date range as an array of parts.",
          "default": null,
          "static": false
        },
        "resolvedOptions": {
          "type": "method",
          "name": "resolvedOptions",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "identifier",
              "name": "Intl.ResolvedDateTimeFormatOptions",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the resolved formatting options based on the values passed to the constructor.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A wrapper around Intl.DateTimeFormat that fixes various browser bugs, and polyfills new features."
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateRangeFormatPart": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateRangeFormatPart",
      "name": "DateRangeFormatPart",
      "properties": {
        "source": {
          "type": "property",
          "name": "source",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "startRange"
              },
              {
                "type": "string",
                "value": "endRange"
              },
              {
                "type": "string",
                "value": "shared"
              }
            ]
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "Intl.DateTimeFormatPart"
        }
      ]
    },
    "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FieldOptions": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FieldOptions",
      "name": "FieldOptions",
      "value": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Intl.DateTimeFormatOptions"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "Intl.DateTimeFormatOptions"
          },
          {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "year"
              },
              {
                "type": "string",
                "value": "month"
              },
              {
                "type": "string",
                "value": "day"
              },
              {
                "type": "string",
                "value": "hour"
              },
              {
                "type": "string",
                "value": "minute"
              },
              {
                "type": "string",
                "value": "second"
              }
            ]
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FormatterOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FormatterOptions",
      "name": "FormatterOptions",
      "properties": {
        "timeZone": {
          "type": "property",
          "name": "timeZone",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "default": null
        },
        "hideTimeZone": {
          "type": "property",
          "name": "hideTimeZone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "indexedAccess",
            "objectType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DatePickerProps"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "indexType": {
              "type": "string",
              "value": "granularity"
            }
          },
          "optional": true,
          "default": null
        },
        "maxGranularity": {
          "type": "property",
          "name": "maxGranularity",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "year"
              },
              {
                "type": "string",
                "value": "month"
              },
              {
                "type": "indexedAccess",
                "objectType": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DatePickerProps"
                  },
                  "typeParameters": [
                    {
                      "id": null,
                      "name": null,
                      "type": "any"
                    }
                  ]
                },
                "indexType": {
                  "type": "string",
                  "value": "granularity"
                }
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "hourCycle": {
          "type": "property",
          "name": "hourCycle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 12
              },
              {
                "type": "number",
                "value": 24
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "showEra": {
          "type": "property",
          "name": "showEra",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "default": null
        },
        "shouldForceLeadingZeros": {
          "type": "property",
          "name": "shouldForceLeadingZeros",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DatePickerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DatePickerProps",
      "name": "DatePickerProps",
      "properties": {
        "pageBehavior": {
          "type": "property",
          "name": "pageBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
          },
          "optional": true,
          "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
          "default": "visible"
        },
        "firstDayOfWeek": {
          "type": "property",
          "name": "firstDayOfWeek",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "sun"
              },
              {
                "type": "string",
                "value": "mon"
              },
              {
                "type": "string",
                "value": "tue"
              },
              {
                "type": "string",
                "value": "wed"
              },
              {
                "type": "string",
                "value": "thu"
              },
              {
                "type": "string",
                "value": "fri"
              },
              {
                "type": "string",
                "value": "sat"
              }
            ]
          },
          "optional": true,
          "description": "The day that starts the week.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "placeholderValue": {
          "type": "property",
          "name": "placeholderValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
          "default": null
        },
        "hourCycle": {
          "type": "property",
          "name": "hourCycle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 12
              },
              {
                "type": "number",
                "value": 24
              }
            ]
          },
          "optional": true,
          "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": true,
          "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
          "default": null
        },
        "hideTimeZone": {
          "type": "property",
          "name": "hideTimeZone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to hide the time zone abbreviation.",
          "default": "false"
        },
        "shouldForceLeadingZeros": {
          "type": "property",
          "name": "shouldForceLeadingZeros",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "aria"
              },
              {
                "type": "string",
                "value": "native"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'aria'"
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateInputRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateInputRenderProps",
      "name": "DateInputRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date input is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocusWithin": {
          "type": "property",
          "name": "isFocusWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date input is focused, either via a mouse or keyboard.",
          "selector": "[data-focus-within]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date input is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date input is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date input is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DateField.tsx:DateSegmentRenderProps",
      "name": "DateSegmentRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the segment is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the segment is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the segment is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isPlaceholder": {
          "type": "property",
          "name": "isPlaceholder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the value is a placeholder.",
          "selector": "[data-placeholder]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the segment is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date field is in an invalid state.",
          "selector": "[data-invalid]",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateFieldState.ts:SegmentType",
            "name": "DateSegmentType"
          },
          "optional": false,
          "description": "The type of segment. Values include `literal`, `year`, `month`, `day`, etc.",
          "selector": "[data-type=\"...\"]",
          "default": null
        },
        "text": {
          "type": "property",
          "name": "text",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The formatted text for the segment.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The numeric value for the segment, if applicable.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum numeric value for the segment, if applicable.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum numeric value for the segment, if applicable.",
          "default": null
        },
        "placeholder": {
          "type": "property",
          "name": "placeholder",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A placeholder string for the segment.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue",
      "name": "TimeValue",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time",
      "name": "Time",
      "properties": {
        "undefined": {
          "type": "any"
        },
        "hour": {
          "type": "property",
          "name": "hour",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The hour, numbered from 0 to 23.",
          "access": "public",
          "default": null
        },
        "minute": {
          "type": "property",
          "name": "minute",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The minute in the hour.",
          "access": "public",
          "default": null
        },
        "second": {
          "type": "property",
          "name": "second",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The second in the minute.",
          "access": "public",
          "default": null
        },
        "millisecond": {
          "type": "property",
          "name": "millisecond",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The millisecond in the second.",
          "access": "public",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "hour",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "minute",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "second",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "millisecond",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this time.",
          "default": null,
          "static": false
        },
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "TimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "typeParameters": []
          },
          "description": "Returns a new `Time` with the given duration added to it.",
          "default": null,
          "static": false
        },
        "subtract": {
          "type": "method",
          "name": "subtract",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "TimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "typeParameters": []
          },
          "description": "Returns a new `Time` with the given duration subtracted from it.",
          "default": null,
          "static": false
        },
        "set": {
          "type": "method",
          "name": "set",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fields",
                "value": {
                  "type": "identifier",
                  "name": "TimeFields"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "typeParameters": []
          },
          "description": "Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly.",
          "default": null,
          "static": false
        },
        "cycle": {
          "type": "method",
          "name": "cycle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "field",
                "value": {
                  "type": "identifier",
                  "name": "TimeField"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "amount",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "identifier",
                  "name": "CycleTimeOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "typeParameters": []
          },
          "description": "Returns a new `Time` with the given field adjusted by a specified amount.\nWhen the resulting value reaches the limits of the field, it wraps around.",
          "default": null,
          "static": false
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the time to an ISO 8601 formatted string.",
          "default": null,
          "static": false
        },
        "compare": {
          "type": "method",
          "name": "compare",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "b",
                "value": {
                  "type": "identifier",
                  "name": "AnyTime"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A Time represents a clock time without any date components."
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue",
      "name": "MappedTimeValue",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
        },
        "extendsType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "trueType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "falseType": {
          "type": "conditional",
          "checkType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
          },
          "extendsType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "trueType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "falseType": {
            "type": "conditional",
            "checkType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
            },
            "extendsType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "trueType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "falseType": {
              "type": "never"
            }
          }
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DatePickerRenderProps",
      "name": "DatePickerRenderProps",
      "properties": {
        "isFocusWithin": {
          "type": "property",
          "name": "isFocusWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date picker is focused, either via a mouse or keyboard.",
          "selector": "[data-focus-within]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date picker is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker's popover is currently open.",
          "selector": "[data-open]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDatePickerState.ts:DatePickerState"
          },
          "optional": false,
          "description": "State of the date picker.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDatePickerState.ts:DatePickerState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDatePickerState.ts:DatePickerState",
      "name": "DatePickerState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected date.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default date.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected date.",
          "default": null
        },
        "dateValue": {
          "type": "property",
          "name": "dateValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The date portion of the value. This may be set prior to `value` if the user has\nselected a date but has not yet selected a time.",
          "default": null
        },
        "setDateValue": {
          "type": "method",
          "name": "setDateValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the date portion of the value.",
          "default": null
        },
        "timeValue": {
          "type": "property",
          "name": "timeValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The time portion of the value. This may be set prior to `value` if the user has\nselected a time but has not yet selected a date.",
          "default": null
        },
        "setTimeValue": {
          "type": "method",
          "name": "setTimeValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the time portion of the value.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": false,
          "description": "The granularity for the field, based on the `granularity` prop and current value.",
          "default": null
        },
        "hasTime": {
          "type": "property",
          "name": "hasTime",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker supports selecting a time, according to the `granularity` prop and current value.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar popover is currently open.",
          "default": null
        },
        "setOpen": {
          "type": "method",
          "name": "setOpen",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the calendar popover is open.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the date picker, based on the `validationState`, `minValue`, and `maxValue` props.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is invalid, based on the `isInvalid`, `minValue`, and `maxValue` props.",
          "default": null
        },
        "formatValue": {
          "type": "method",
          "name": "formatValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "fieldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FieldOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats the selected value using the given options.",
          "default": null
        },
        "getDateFormatter": {
          "type": "method",
          "name": "getDateFormatter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "formatOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FormatterOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter"
            },
            "typeParameters": []
          },
          "description": "Gets a formatter based on state's props.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Opens the overlay.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes the overlay.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the overlay's visibility.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DatePicker.tsx:DateRangePickerRenderProps",
      "name": "DateRangePickerRenderProps",
      "properties": {
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateRangePickerState.ts:DateRangePickerState"
          },
          "optional": false,
          "description": "State of the date range picker.",
          "default": null
        },
        "isFocusWithin": {
          "type": "property",
          "name": "isFocusWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date picker is focused, either via a mouse or keyboard.",
          "selector": "[data-focus-within]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the date picker is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date picker's popover is currently open.",
          "selector": "[data-open]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateRangePickerState.ts:DateRangePickerState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateRangePickerState.ts:DateRangePickerState",
      "name": "DateRangePickerState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The currently selected date range.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateRange"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default selected date range.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateRange"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected date range.",
          "default": null
        },
        "dateRange": {
          "type": "property",
          "name": "dateRange",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The date portion of the selected range. This may be set prior to `value` if the user has\nselected a date range but has not yet selected a time range.",
          "default": null
        },
        "setDateRange": {
          "type": "method",
          "name": "setDateRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateRange"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the date portion of the selected range.",
          "default": null
        },
        "timeRange": {
          "type": "property",
          "name": "timeRange",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The time portion of the selected range. This may be set prior to `value` if the user has\nselected a time range but has not yet selected a date range.",
          "default": null
        },
        "setTimeRange": {
          "type": "method",
          "name": "setTimeRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateRangePickerState.ts:TimeRange"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the time portion of the selected range.",
          "default": null
        },
        "setDate": {
          "type": "method",
          "name": "setDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "part",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "start"
                    },
                    {
                      "type": "string",
                      "value": "end"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the date portion of either the start or end of the selected range.",
          "default": null
        },
        "setTime": {
          "type": "method",
          "name": "setTime",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "part",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "start"
                    },
                    {
                      "type": "string",
                      "value": "end"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the time portion of either the start or end of the selected range.",
          "default": null
        },
        "setDateTime": {
          "type": "method",
          "name": "setDateTime",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "part",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "start"
                    },
                    {
                      "type": "string",
                      "value": "end"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the date and time of either the start or end of the selected range.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": false,
          "description": "The granularity for the field, based on the `granularity` prop and current value.",
          "default": null
        },
        "hasTime": {
          "type": "property",
          "name": "hasTime",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date range picker supports selecting times, according to the `granularity` prop and current value.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar popover is currently open.",
          "default": null
        },
        "setOpen": {
          "type": "method",
          "name": "setOpen",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the calendar popover is open.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the date range picker, based on the `validationState`, `minValue`, and `maxValue` props.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the date range picker is invalid, based on the `isInvalid`, `minValue`, and `maxValue` props.",
          "default": null
        },
        "formatValue": {
          "type": "method",
          "name": "formatValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "fieldOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FieldOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "object",
                  "properties": {
                    "start": {
                      "type": "property",
                      "name": "start",
                      "indexType": null,
                      "value": {
                        "type": "string"
                      },
                      "optional": false,
                      "default": null
                    },
                    "end": {
                      "type": "property",
                      "name": "end",
                      "indexType": null,
                      "value": {
                        "type": "string"
                      },
                      "optional": false,
                      "default": null
                    }
                  }
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Formats the selected range using the given options.",
          "default": null
        },
        "getDateFormatter": {
          "type": "method",
          "name": "getDateFormatter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "formatOptions",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/utils.ts:FormatterOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/DateFormatter.ts:DateFormatter"
            },
            "typeParameters": []
          },
          "description": "Gets a formatter based on state's props.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Opens the overlay.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes the overlay.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the overlay's visibility.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateRange": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateRange",
      "name": "DateRange",
      "value": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateRangePickerState.ts:TimeRange": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/datepicker/src/useDateRangePickerState.ts:TimeRange",
      "name": "TimeRange",
      "value": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps",
      "name": "DialogRenderProps",
      "properties": {
        "close": {
          "type": "property",
          "name": "close",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureRenderProps",
      "name": "DisclosureRenderProps",
      "properties": {
        "isExpanded": {
          "type": "property",
          "name": "isExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the disclosure is expanded.",
          "selector": "[data-expanded]",
          "default": null
        },
        "isFocusVisibleWithin": {
          "type": "property",
          "name": "isFocusVisibleWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the disclosure has keyboard focus.",
          "selector": "[data-focus-visible-within]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the disclosure is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/disclosure/src/useDisclosureState.ts:DisclosureState"
          },
          "optional": false,
          "description": "State of the disclosure.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/disclosure/src/useDisclosureState.ts:DisclosureState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/disclosure/src/useDisclosureState.ts:DisclosureState",
      "name": "DisclosureState",
      "properties": {
        "isExpanded": {
          "type": "property",
          "name": "isExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the disclosure is currently expanded.",
          "default": null
        },
        "setExpanded": {
          "type": "method",
          "name": "setExpanded",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isExpanded",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the disclosure is expanded.",
          "default": null
        },
        "expand": {
          "type": "method",
          "name": "expand",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Expand the disclosure.",
          "default": null
        },
        "collapse": {
          "type": "method",
          "name": "collapse",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Collapse the disclosure.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the disclosure's visibility.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosureGroupRenderProps",
      "name": "DisclosureGroupRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the disclosure group is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/disclosure/src/useDisclosureGroupState.ts:DisclosureGroupState"
          },
          "optional": false,
          "description": "State of the disclosure group.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/disclosure/src/useDisclosureGroupState.ts:DisclosureGroupState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/disclosure/src/useDisclosureGroupState.ts:DisclosureGroupState",
      "name": "DisclosureGroupState",
      "properties": {
        "allowsMultipleExpanded": {
          "type": "property",
          "name": "allowsMultipleExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether multiple items can be expanded at the same time.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether all items are disabled.",
          "default": null
        },
        "expandedKeys": {
          "type": "property",
          "name": "expandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for items that are expanded.",
          "default": null
        },
        "toggleKey": {
          "type": "method",
          "name": "toggleKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the expanded state for an item by its key.",
          "default": null
        },
        "setExpandedKeys": {
          "type": "method",
          "name": "setExpandedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the set of expanded keys.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosurePanelRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Disclosure.tsx:DisclosurePanelRenderProps",
      "name": "DisclosurePanelRenderProps",
      "properties": {
        "isFocusVisibleWithin": {
          "type": "property",
          "name": "isFocusVisibleWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether keyboard focus is within the disclosure panel.",
          "selector": "[data-focus-visible-within]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes",
      "name": "DragTypes",
      "properties": {
        "has": {
          "type": "method",
          "name": "has",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "symbol"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the drag contains data of the given type.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation",
      "name": "DropOperation",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "copy"
          },
          {
            "type": "string",
            "value": "link"
          },
          {
            "type": "string",
            "value": "move"
          },
          {
            "type": "string",
            "value": "cancel"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEnterEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEnterEvent",
      "name": "DropEnterEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropenter"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropMoveEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropMoveEvent",
      "name": "DropMoveEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropmove"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropActivateEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropActivateEvent",
      "name": "DropActivateEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropactivate"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropExitEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropExitEvent",
      "name": "DropExitEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropexit"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEvent",
      "name": "DropEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "drop"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem",
      "name": "DropItem",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:TextDropItem"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:FileDropItem"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DirectoryDropItem"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:TextDropItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:TextDropItem",
      "name": "TextDropItem",
      "properties": {
        "kind": {
          "type": "property",
          "name": "kind",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "text"
          },
          "optional": false,
          "description": "The item kind.",
          "default": null
        },
        "types": {
          "type": "property",
          "name": "types",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "string"
              }
            ]
          },
          "optional": false,
          "description": "The drag types available for this item.\nThese are often mime types, but may be custom app-specific types.",
          "default": null
        },
        "getText": {
          "type": "method",
          "name": "getText",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Promise"
              },
              "typeParameters": [
                {
                  "type": "string"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the data for the given type as a string.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:FileDropItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:FileDropItem",
      "name": "FileDropItem",
      "properties": {
        "kind": {
          "type": "property",
          "name": "kind",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "file"
          },
          "optional": false,
          "description": "The item kind.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The file type (usually a mime type).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The file name.",
          "default": null
        },
        "getFile": {
          "type": "method",
          "name": "getFile",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Promise"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "File"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the contents of the file as a blob.",
          "default": null
        },
        "getText": {
          "type": "method",
          "name": "getText",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Promise"
              },
              "typeParameters": [
                {
                  "type": "string"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the contents of the file as a string.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DirectoryDropItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DirectoryDropItem",
      "name": "DirectoryDropItem",
      "properties": {
        "kind": {
          "type": "property",
          "name": "kind",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "directory"
          },
          "optional": false,
          "description": "The item kind.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The directory name.",
          "default": null
        },
        "getEntries": {
          "type": "method",
          "name": "getEntries",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "AsyncIterable"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:FileDropItem"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DirectoryDropItem"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the entries contained within the directory.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DropZone.tsx:DropZoneRenderProps",
      "name": "DropZoneRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the dropzone is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the dropzone is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the dropzone is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the dropzone is the drop target.",
          "selector": "[data-drop-target]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the dropzone is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FieldError.tsx:FieldErrorRenderProps",
      "name": "FieldErrorRenderProps",
      "properties": {
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validationErrors": {
          "type": "property",
          "name": "validationErrors",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          },
          "optional": false,
          "description": "The current error messages for the input if it is invalid, otherwise an empty array.",
          "default": null
        },
        "validationDetails": {
          "type": "property",
          "name": "validationDetails",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ValidityState"
          },
          "optional": false,
          "description": "The native validation details for the input.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationErrors": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationErrors",
      "name": "ValidationErrors",
      "value": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Record"
        },
        "typeParameters": [
          {
            "type": "string"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks",
      "name": "DragAndDropHooks",
      "value": {
        "type": "intersection",
        "types": [
          {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragHooks"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DropHooks"
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragHooks": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragHooks",
      "name": "DragHooks",
      "properties": {
        "useDraggableCollectionState": {
          "type": "property",
          "name": "useDraggableCollectionState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DraggableCollectionStateOpts"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDraggableCollectionState.ts:DraggableCollectionState"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "useDraggableCollection": {
          "type": "property",
          "name": "useDraggableCollection",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableCollection.ts:DraggableCollectionOptions"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDraggableCollectionState.ts:DraggableCollectionState"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "ref",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
                  },
                  "typeParameters": [
                    {
                      "type": "union",
                      "elements": [
                        {
                          "type": "identifier",
                          "name": "HTMLElement"
                        },
                        {
                          "type": "null"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "useDraggableItem": {
          "type": "property",
          "name": "useDraggableItem",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemProps"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDraggableCollectionState.ts:DraggableCollectionState"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemResult"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "DragPreview": {
          "type": "property",
          "name": "DragPreview",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": true,
          "default": null
        },
        "renderDragPreview": {
          "type": "property",
          "name": "renderDragPreview",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "items",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "JSX.Element"
                },
                {
                  "type": "object",
                  "properties": {
                    "element": {
                      "type": "property",
                      "name": "element",
                      "indexType": null,
                      "value": {
                        "type": "identifier",
                        "name": "JSX.Element"
                      },
                      "optional": false,
                      "default": null
                    },
                    "x": {
                      "type": "property",
                      "name": "x",
                      "indexType": null,
                      "value": {
                        "type": "number"
                      },
                      "optional": false,
                      "default": null
                    },
                    "y": {
                      "type": "property",
                      "name": "y",
                      "indexType": null,
                      "value": {
                        "type": "number"
                      },
                      "optional": false,
                      "default": null
                    }
                  }
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "isVirtualDragging": {
          "type": "property",
          "name": "isVirtualDragging",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DraggableCollectionStateOpts": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DraggableCollectionStateOpts",
      "name": "DraggableCollectionStateOpts",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager"
          },
          "optional": false,
          "description": "An interface for reading and updating multiple selection state.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drag events should be disabled.",
          "default": null
        },
        "onDragStart": {
          "type": "property",
          "name": "onDragStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionStartEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a drag operation is started.",
          "default": null
        },
        "onDragMove": {
          "type": "property",
          "name": "onDragMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag is moved.",
          "default": null
        },
        "onDragEnd": {
          "type": "property",
          "name": "onDragEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag operation is ended, either as a result of a drop or a cancellation.",
          "default": null
        },
        "preview": {
          "type": "property",
          "name": "preview",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref of the element that will be rendered as the drag preview while dragging.",
          "default": null
        },
        "getAllowedDropOperations": {
          "type": "property",
          "name": "getAllowedDropOperations",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
              }
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Function that returns the drop operations that are allowed for the dragged items. If not provided, all drop operations are allowed.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager",
      "name": "MultipleSelectionManager",
      "properties": {
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected keys in the collection.",
          "default": null
        },
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the selection is empty.",
          "default": null
        },
        "isSelectAll": {
          "type": "property",
          "name": "isSelectAll",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether all items in the collection are selected.",
          "default": null
        },
        "firstSelectedKey": {
          "type": "property",
          "name": "firstSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The first selected key in the collection.",
          "default": null
        },
        "lastSelectedKey": {
          "type": "property",
          "name": "lastSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The last selected key in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "The currently disabled keys in the collection.",
          "default": null
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "optional": false,
          "description": "Whether `disabledKeys` applies to selection, actions, or both.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether a key is selected.",
          "default": null
        },
        "isSelectionEqual": {
          "type": "method",
          "name": "isSelectionEqual",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the current selection is equal to the given selection.",
          "default": null
        },
        "extendSelection": {
          "type": "method",
          "name": "extendSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "toKey",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Extends the selection to the given key.",
          "default": null
        },
        "toggleSelection": {
          "type": "method",
          "name": "toggleSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles whether the given key is selected.",
          "default": null
        },
        "replaceSelection": {
          "type": "method",
          "name": "replaceSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the selection with only the given key.",
          "default": null
        },
        "setSelectedKeys": {
          "type": "method",
          "name": "setSelectedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the selection with the given keys.",
          "default": null
        },
        "selectAll": {
          "type": "method",
          "name": "selectAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects all items in the collection.",
          "default": null
        },
        "clearSelection": {
          "type": "method",
          "name": "clearSelection",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Removes all keys from the selection.",
          "default": null
        },
        "toggleSelectAll": {
          "type": "method",
          "name": "toggleSelectAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles between select all and an empty selection.",
          "default": null
        },
        "select": {
          "type": "method",
          "name": "select",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:LongPressEvent"
                    },
                    {
                      "type": "identifier",
                      "name": "PointerEvent"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles, replaces, or extends selection to the given key depending\non the pointer event and collection's selection mode.",
          "default": null
        },
        "canSelectItem": {
          "type": "method",
          "name": "canSelectItem",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given key can be selected.",
          "default": null
        },
        "isDisabled": {
          "type": "method",
          "name": "isDisabled",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given key is non-interactive, i.e. both selection and actions are disabled.",
          "default": null
        },
        "setSelectionBehavior": {
          "type": "method",
          "name": "setSelectionBehavior",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selectionBehavior",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selection behavior for the collection.",
          "default": null
        },
        "isLink": {
          "type": "method",
          "name": "isLink",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given key is a hyperlink.",
          "default": null
        },
        "getItemProps": {
          "type": "method",
          "name": "getItemProps",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the props for the given item.",
          "default": null
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The collection of nodes that the selection manager handles.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the collection is currently focused.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the collection is focused.",
          "default": null
        },
        "focusedKey": {
          "type": "property",
          "name": "focusedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current focused key in the collection.",
          "default": null
        },
        "childFocusStrategy": {
          "type": "property",
          "name": "childFocusStrategy",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Whether the first or last child of the focused key should receive focus.",
          "default": null
        },
        "setFocusedKey": {
          "type": "method",
          "name": "setFocusedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "child",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused key, and optionally, whether the first or last child of that key should receive focus.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionStartEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionStartEvent",
      "name": "DraggableCollectionStartEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were dragged.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragstart"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionMoveEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionMoveEvent",
      "name": "DraggableCollectionMoveEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were dragged.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragmove"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent",
      "name": "DraggableCollectionEndEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were dragged.",
          "default": null
        },
        "isInternal": {
          "type": "property",
          "name": "isInternal",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drop ended within the same collection as it originated.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragend"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that occurred.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer",
      "name": "DragPreviewRenderer",
      "value": {
        "type": "function",
        "parameters": [
          {
            "type": "parameter",
            "name": "items",
            "value": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
              }
            },
            "rest": false
          },
          {
            "type": "parameter",
            "name": "callback",
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "node",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "identifier",
                        "name": "HTMLElement"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false
                },
                {
                  "type": "parameter",
                  "name": "x",
                  "value": {
                    "type": "number"
                  },
                  "optional": true,
                  "rest": false
                },
                {
                  "type": "parameter",
                  "name": "y",
                  "value": {
                    "type": "number"
                  },
                  "optional": true,
                  "rest": false
                }
              ],
              "return": {
                "type": "void"
              },
              "typeParameters": []
            },
            "rest": false
          }
        ],
        "return": {
          "type": "void"
        },
        "typeParameters": []
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem",
      "name": "DragItem",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": {
            "type": "string"
          },
          "value": {
            "type": "string"
          },
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDraggableCollectionState.ts:DraggableCollectionState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDraggableCollectionState.ts:DraggableCollectionState",
      "name": "DraggableCollectionState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager"
          },
          "optional": false,
          "description": "An interface for reading and updating multiple selection state.",
          "default": null
        },
        "draggedKey": {
          "type": "property",
          "name": "draggedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The key of the item that initiated a drag.",
          "default": null
        },
        "draggingKeys": {
          "type": "property",
          "name": "draggingKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that are currently being dragged.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether drag events are disabled.",
          "default": null
        },
        "isDragging": {
          "type": "method",
          "name": "isDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given key is currently being dragged.",
          "default": null
        },
        "getKeysForDrag": {
          "type": "method",
          "name": "getKeysForDrag",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Set"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the keys of the items that will be dragged with the given key (e.g. selected items).",
          "default": null
        },
        "getItems": {
          "type": "method",
          "name": "getItems",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
              }
            },
            "typeParameters": []
          },
          "description": "Returns the items to drag for the given key.",
          "default": null
        },
        "preview": {
          "type": "property",
          "name": "preview",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref of the element that will be rendered as the drag preview while dragging.",
          "default": null
        },
        "getAllowedDropOperations": {
          "type": "property",
          "name": "getAllowedDropOperations",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
              }
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Function that returns the drop operations that are allowed for the dragged items. If not provided, all drop operations are allowed.",
          "default": null
        },
        "startDrag": {
          "type": "method",
          "name": "startDrag",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragStartEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Begins a drag for the given key. This triggers the onDragStart event.",
          "default": null
        },
        "moveDrag": {
          "type": "method",
          "name": "moveDrag",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Triggers an onDragMove event.",
          "default": null
        },
        "endDrag": {
          "type": "method",
          "name": "endDrag",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Ends the current drag, and emits an onDragEnd event.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragStartEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragStartEvent",
      "name": "DragStartEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragstart"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragMoveEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragMoveEvent",
      "name": "DragMoveEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragmove"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableCollection.ts:DraggableCollectionOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableCollection.ts:DraggableCollectionOptions",
      "name": "DraggableCollectionOptions",
      "properties": {},
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemProps",
      "name": "DraggableItemProps",
      "properties": {
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "description": "The key of the draggable item within the collection.",
          "default": null
        },
        "hasDragButton": {
          "type": "property",
          "name": "hasDragButton",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item has an explicit focusable drag affordance to initiate accessible drag and drop mode.\nIf true, the dragProps will omit these event handlers, and they will be applied to dragButtonProps instead.",
          "default": null
        },
        "hasAction": {
          "type": "property",
          "name": "hasAction",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item has a primary action (e.g. Enter key or long press) that would\nconflict with initiating accessible drag and drop. If true, the Alt key must be held to\nstart dragging with a keyboard, and long press is disabled until selection mode is entered.\nThis should be passed from the associated collection item hook (e.g. useOption, useGridListItem, etc.).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemResult",
      "name": "DraggableItemResult",
      "properties": {
        "dragProps": {
          "type": "property",
          "name": "dragProps",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "HTMLAttributes"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          },
          "optional": false,
          "description": "Props for the draggable item.",
          "default": null
        },
        "dragButtonProps": {
          "type": "property",
          "name": "dragButtonProps",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/button/src/index.d.ts:AriaButtonProps"
          },
          "optional": false,
          "description": "Props for the explicit drag button affordance, if any.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/button/src/index.d.ts:AriaButtonProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/button/src/index.d.ts:AriaButtonProps",
      "name": "AriaButtonProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is disabled.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display in the button.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A URL to link to if elementType=\"a\".",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The target window for the link.",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "elementType": {
          "type": "property",
          "name": "elementType",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ElementType"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "JSXElementConstructor"
                },
                "typeParameters": [
                  {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The HTML element or React element used to render the button, e.g. 'div', 'a', or `RouterLink`.",
          "default": "'button'"
        },
        "aria-disabled": {
          "type": "property",
          "name": "aria-disabled",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element is disabled to users of assistive technology.",
          "default": null
        },
        "aria-expanded": {
          "type": "property",
          "name": "aria-expanded",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "aria-pressed": {
          "type": "property",
          "name": "aria-pressed",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "mixed"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the current \"pressed\" state of toggle buttons.",
          "default": null
        },
        "aria-current": {
          "type": "property",
          "name": "aria-current",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "page"
              },
              {
                "type": "string",
                "value": "step"
              },
              {
                "type": "string",
                "value": "location"
              },
              {
                "type": "string",
                "value": "date"
              },
              {
                "type": "string",
                "value": "time"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether this element represents the current item within a container or set of related elements.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "button"
              },
              {
                "type": "string",
                "value": "submit"
              },
              {
                "type": "string",
                "value": "reset"
              }
            ]
          },
          "optional": true,
          "description": "The behavior of the button when used in an HTML form.",
          "default": "'button'"
        },
        "preventFocusOnPress": {
          "type": "property",
          "name": "preventFocusOnPress",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/button#form).",
          "default": null
        },
        "formAction": {
          "type": "property",
          "name": "formAction",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
          "default": null
        },
        "formEncType": {
          "type": "property",
          "name": "formEncType",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Indicates how to encode the form data that is submitted.",
          "default": null
        },
        "formMethod": {
          "type": "property",
          "name": "formMethod",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Indicates the HTTP method used to submit the form.",
          "default": null
        },
        "formNoValidate": {
          "type": "property",
          "name": "formNoValidate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Indicates that the form is not to be validated when it is submitted.",
          "default": null
        },
        "formTarget": {
          "type": "property",
          "name": "formTarget",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Overrides the target attribute of the button's form owner.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Submitted as a pair with the button's value as part of the form data.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value associated with the button's name when it's submitted with the form data.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "identifier",
            "name": "ElementType"
          },
          "default": {
            "type": "string",
            "value": "button"
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DropHooks": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DropHooks",
      "name": "DropHooks",
      "properties": {
        "useDroppableCollectionState": {
          "type": "property",
          "name": "useDroppableCollectionState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionStateOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "useDroppableCollection": {
          "type": "property",
          "name": "useDroppableCollection",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionOptions"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "ref",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
                  },
                  "typeParameters": [
                    {
                      "type": "union",
                      "elements": [
                        {
                          "type": "identifier",
                          "name": "HTMLElement"
                        },
                        {
                          "type": "null"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionResult"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "useDroppableItem": {
          "type": "property",
          "name": "useDroppableItem",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemOptions"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "ref",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
                  },
                  "typeParameters": [
                    {
                      "type": "union",
                      "elements": [
                        {
                          "type": "identifier",
                          "name": "HTMLElement"
                        },
                        {
                          "type": "null"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemResult"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "useDropIndicator": {
          "type": "property",
          "name": "useDropIndicator",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorProps"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "ref",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
                  },
                  "typeParameters": [
                    {
                      "type": "union",
                      "elements": [
                        {
                          "type": "identifier",
                          "name": "HTMLElement"
                        },
                        {
                          "type": "null"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorAria"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "renderDropIndicator": {
          "type": "property",
          "name": "renderDropIndicator",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "JSX.Element",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "dropTargetDelegate": {
          "type": "property",
          "name": "dropTargetDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate"
          },
          "optional": true,
          "default": null
        },
        "ListDropTargetDelegate": {
          "type": "property",
          "name": "ListDropTargetDelegate",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionStateOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionStateOptions",
      "name": "DroppableCollectionStateOptions",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager"
          },
          "optional": false,
          "description": "An interface for reading and updating multiple selection state.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drop events should be disabled.",
          "default": null
        },
        "acceptedDragTypes": {
          "type": "property",
          "name": "acceptedDragTypes",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Array"
                },
                "typeParameters": [
                  {
                    "type": "union",
                    "elements": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "symbol"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The drag types that the droppable collection accepts. If the collection accepts directories, include `DIRECTORY_DRAG_TYPE` in your array of allowed types.",
          "default": "'all'"
        },
        "onInsert": {
          "type": "property",
          "name": "onInsert",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped \"between\" items.",
          "default": null
        },
        "onRootDrop": {
          "type": "property",
          "name": "onRootDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped on the droppable collection's root.",
          "default": null
        },
        "onItemDrop": {
          "type": "property",
          "name": "onItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are dropped \"on\" an item.",
          "default": null
        },
        "onReorder": {
          "type": "property",
          "name": "onReorder",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are reordered within the collection.\nThis handler only allows dropping between items, not on items.\nIt does not allow moving items to a different parent item within a tree.",
          "default": null
        },
        "onMove": {
          "type": "property",
          "name": "onMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are moved within the source collection.\nThis handler allows dropping both on or between items, and items may be\nmoved to a different parent item within a tree.",
          "default": null
        },
        "shouldAcceptItemDrop": {
          "type": "property",
          "name": "shouldAcceptItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning whether a given target in the droppable collection is a valid \"on\" drop target for the current drag types.",
          "default": null
        },
        "onDropEnter": {
          "type": "property",
          "name": "onDropEnter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag enters a drop target.",
          "default": null
        },
        "onDropExit": {
          "type": "property",
          "name": "onDropExit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag exits a drop target.",
          "default": null
        },
        "onDrop": {
          "type": "property",
          "name": "onDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is dropped on a drop target. When defined, this overrides other\ndrop handlers such as `onInsert`, and `onItemDrop`.",
          "default": null
        },
        "getDropOperation": {
          "type": "property",
          "name": "getDropOperation",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "allowedOperations",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent",
      "name": "DroppableCollectionInsertDropEvent",
      "properties": {
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget",
      "name": "ItemDropTarget",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "item"
          },
          "optional": false,
          "description": "The drop target type.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": false,
          "description": "The item key.",
          "default": null
        },
        "dropPosition": {
          "type": "property",
          "name": "dropPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropPosition"
          },
          "optional": false,
          "description": "The drop position relative to the item.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropPosition": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropPosition",
      "name": "DropPosition",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "on"
          },
          {
            "type": "string",
            "value": "before"
          },
          {
            "type": "string",
            "value": "after"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent",
      "name": "DroppableCollectionRootDropEvent",
      "properties": {
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent",
      "name": "DroppableCollectionOnItemDropEvent",
      "properties": {
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "isInternal": {
          "type": "property",
          "name": "isInternal",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drag originated within the same collection as the drop.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent",
      "name": "DroppableCollectionReorderEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were reordered.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent",
      "name": "DroppableCollectionEnterEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropenter"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget",
      "name": "DropTarget",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:RootDropTarget"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:RootDropTarget": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:RootDropTarget",
      "name": "RootDropTarget",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "root"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent",
      "name": "DroppableCollectionExitEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropexit"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent",
      "name": "DroppableCollectionDropEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "drop"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState",
      "name": "DroppableCollectionState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager"
          },
          "optional": false,
          "description": "An interface for reading and updating multiple selection state.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current drop target.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether drop events are disabled.",
          "default": null
        },
        "setTarget": {
          "type": "method",
          "name": "setTarget",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current drop target.",
          "default": null
        },
        "isDropTarget": {
          "type": "method",
          "name": "isDropTarget",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given target is equivalent to the current drop target.",
          "default": null
        },
        "getDropOperation": {
          "type": "method",
          "name": "getDropOperation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DropOperationEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "description": "Returns the drop operation for the given parameters.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DropOperationEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DropOperationEvent",
      "name": "DropOperationEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "default": null
        },
        "types": {
          "type": "property",
          "name": "types",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
          },
          "optional": false,
          "default": null
        },
        "allowedOperations": {
          "type": "property",
          "name": "allowedOperations",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            }
          },
          "optional": false,
          "default": null
        },
        "isInternal": {
          "type": "property",
          "name": "isInternal",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "default": null
        },
        "draggingKeys": {
          "type": "property",
          "name": "draggingKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionOptions",
      "name": "DroppableCollectionOptions",
      "properties": {
        "keyboardDelegate": {
          "type": "property",
          "name": "keyboardDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:KeyboardDelegate"
          },
          "optional": false,
          "description": "A delegate object that implements behavior for keyboard focus movement.",
          "default": null
        },
        "dropTargetDelegate": {
          "type": "property",
          "name": "dropTargetDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate"
          },
          "optional": false,
          "description": "A delegate object that provides drop targets for pointer coordinates within the collection.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "identifier",
                  "name": "KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A custom keyboard event handler for drop targets.",
          "default": null
        },
        "acceptedDragTypes": {
          "type": "property",
          "name": "acceptedDragTypes",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Array"
                },
                "typeParameters": [
                  {
                    "type": "union",
                    "elements": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "symbol"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The drag types that the droppable collection accepts. If the collection accepts directories, include `DIRECTORY_DRAG_TYPE` in your array of allowed types.",
          "default": "'all'"
        },
        "onInsert": {
          "type": "property",
          "name": "onInsert",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped \"between\" items.",
          "default": null
        },
        "onRootDrop": {
          "type": "property",
          "name": "onRootDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped on the droppable collection's root.",
          "default": null
        },
        "onItemDrop": {
          "type": "property",
          "name": "onItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are dropped \"on\" an item.",
          "default": null
        },
        "onReorder": {
          "type": "property",
          "name": "onReorder",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are reordered within the collection.\nThis handler only allows dropping between items, not on items.\nIt does not allow moving items to a different parent item within a tree.",
          "default": null
        },
        "onMove": {
          "type": "property",
          "name": "onMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are moved within the source collection.\nThis handler allows dropping both on or between items, and items may be\nmoved to a different parent item within a tree.",
          "default": null
        },
        "shouldAcceptItemDrop": {
          "type": "property",
          "name": "shouldAcceptItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning whether a given target in the droppable collection is a valid \"on\" drop target for the current drag types.",
          "default": null
        },
        "onDropEnter": {
          "type": "property",
          "name": "onDropEnter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag enters a drop target.",
          "default": null
        },
        "onDropActivate": {
          "type": "property",
          "name": "onDropActivate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionActivateEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called after a valid drag is held over a drop target for a period of time.",
          "default": null
        },
        "onDropExit": {
          "type": "property",
          "name": "onDropExit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag exits a drop target.",
          "default": null
        },
        "onDrop": {
          "type": "property",
          "name": "onDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is dropped on a drop target. When defined, this overrides other\ndrop handlers such as `onInsert`, and `onItemDrop`.",
          "default": null
        },
        "getDropOperation": {
          "type": "property",
          "name": "getDropOperation",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "allowedOperations",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:KeyboardDelegate": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:KeyboardDelegate",
      "name": "KeyboardDelegate",
      "properties": {
        "getKeyBelow": {
          "type": "method",
          "name": "getKeyBelow",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually below the given one, or `null` for none.",
          "default": null
        },
        "getKeyAbove": {
          "type": "method",
          "name": "getKeyAbove",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually above the given one, or `null` for none.",
          "default": null
        },
        "getKeyLeftOf": {
          "type": "method",
          "name": "getKeyLeftOf",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually to the left of the given one, or `null` for none.",
          "default": null
        },
        "getKeyRightOf": {
          "type": "method",
          "name": "getKeyRightOf",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually to the right of the given one, or `null` for none.",
          "default": null
        },
        "getKeyPageBelow": {
          "type": "method",
          "name": "getKeyPageBelow",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually one page below the given one, or `null` for none.",
          "default": null
        },
        "getKeyPageAbove": {
          "type": "method",
          "name": "getKeyPageAbove",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually one page above the given one, or `null` for none.",
          "default": null
        },
        "getFirstKey": {
          "type": "method",
          "name": "getFirstKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "global",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the first key, or `null` for none.",
          "default": null
        },
        "getLastKey": {
          "type": "method",
          "name": "getLastKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "global",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the last key, or `null` for none.",
          "default": null
        },
        "getKeyForSearch": {
          "type": "method",
          "name": "getKeyForSearch",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "search",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "fromKey",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the next key after `fromKey` that matches the given search string, or `null` for none.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate",
      "name": "DropTargetDelegate",
      "properties": {
        "getDropTargetFromPoint": {
          "type": "method",
          "name": "getDropTargetFromPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "isValidDropTarget",
                "value": {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "target",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns a drop target within a collection for the given x and y coordinates.\nThe point is provided relative to the top left corner of the collection container.\nA drop target can be checked to see if it is valid using the provided `isValidDropTarget` function.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionActivateEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionActivateEvent",
      "name": "DroppableCollectionActivateEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropactivate"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionResult",
      "name": "DroppableCollectionResult",
      "properties": {
        "collectionProps": {
          "type": "property",
          "name": "collectionProps",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "HTMLAttributes"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          },
          "optional": false,
          "description": "Props for the collection element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemOptions",
      "name": "DroppableItemOptions",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target represented by the item.",
          "default": null
        },
        "activateButtonRef": {
          "type": "property",
          "name": "activateButtonRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref to the activate button.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemResult",
      "name": "DroppableItemResult",
      "properties": {
        "dropProps": {
          "type": "property",
          "name": "dropProps",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "HTMLAttributes"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          },
          "optional": false,
          "description": "Props for the droppable element.",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently the active drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorProps",
      "name": "DropIndicatorProps",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target that the drop indicator represents.",
          "default": null
        },
        "activateButtonRef": {
          "type": "property",
          "name": "activateButtonRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref to the activate button.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorAria": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorAria",
      "name": "DropIndicatorAria",
      "properties": {
        "dropIndicatorProps": {
          "type": "property",
          "name": "dropIndicatorProps",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "HTMLAttributes"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          },
          "optional": false,
          "description": "Props for the drop indicator element.",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drop indicator is currently the active drop target.",
          "default": null
        },
        "isHidden": {
          "type": "property",
          "name": "isHidden",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drop indicator is hidden, both visually and from assistive technology.\nUse this to determine whether to omit the element from the DOM entirely.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps",
      "name": "GridListRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the list has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the grid list is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the grid list is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the grid list is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "stack"
              },
              {
                "type": "string",
                "value": "grid"
              }
            ]
          },
          "optional": false,
          "description": "Whether the items are arranged in a stack or grid.",
          "selector": "[data-layout=\"stack | grid\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the grid list.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListItemRenderProps",
      "name": "GridListItemRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href",
      "name": "Href",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterConfig"
        },
        "extendsType": {
          "type": "object",
          "properties": {
            "href": {
              "type": "property",
              "name": "href",
              "indexType": null,
              "value": {
                "type": "any"
              },
              "optional": false,
              "default": null
            }
          }
        },
        "trueType": {
          "type": "identifier",
          "name": "H"
        },
        "falseType": {
          "type": "string"
        }
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterConfig": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterConfig",
      "name": "RouterConfig",
      "properties": {},
      "typeParameters": [],
      "extends": [],
      "description": "This type allows configuring link props with router options and type-safe URLs via TS module augmentation.\nBy default, this is an empty type. Extend with `href` and `routerOptions` properties to configure your router."
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions",
      "name": "RouterOptions",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterConfig"
        },
        "extendsType": {
          "type": "object",
          "properties": {
            "routerOptions": {
              "type": "property",
              "name": "routerOptions",
              "indexType": null,
              "value": {
                "type": "any"
              },
              "optional": false,
              "default": null
            }
          }
        },
        "trueType": {
          "type": "identifier",
          "name": "O"
        },
        "falseType": {
          "type": "never"
        }
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Group.tsx:GroupRenderProps",
      "name": "GroupRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the group is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocusWithin": {
          "type": "property",
          "name": "isFocusWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the group is focused, either via a mouse or keyboard.",
          "selector": "[data-focus-within]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether an element within the group is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the group is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the group is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Input.tsx:InputRenderProps",
      "name": "InputRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:BaseCollection": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:BaseCollection",
      "name": "BaseCollection",
      "properties": {
        "keyMap": {
          "type": "property",
          "name": "keyMap",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:CollectionNode"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "firstKey": {
          "type": "property",
          "name": "firstKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "lastKey": {
          "type": "property",
          "name": "lastKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "frozen": {
          "type": "property",
          "name": "frozen",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "itemCount": {
          "type": "property",
          "name": "itemCount",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "default": null
        },
        "getKeys": {
          "type": "method",
          "name": "getKeys",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "IterableIterator"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "undefined": {
          "type": "method",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "IterableIterator"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getChildren": {
          "type": "method",
          "name": "getChildren",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getKeyBefore": {
          "type": "method",
          "name": "getKeyBefore",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getKeyAfter": {
          "type": "method",
          "name": "getKeyAfter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getFirstKey": {
          "type": "method",
          "name": "getFirstKey",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getLastKey": {
          "type": "method",
          "name": "getLastKey",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getItem": {
          "type": "method",
          "name": "getItem",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "at": {
          "type": "method",
          "name": "at",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "clone": {
          "type": "method",
          "name": "clone",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "this",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "addNode": {
          "type": "method",
          "name": "addNode",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:CollectionNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "addDescendants": {
          "type": "method",
          "name": "addDescendants",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:CollectionNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldCollection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:BaseCollection"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "removeNode": {
          "type": "method",
          "name": "removeNode",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "commit": {
          "type": "method",
          "name": "commit",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "firstKey",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "lastKey",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "isSSR",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "filter": {
          "type": "method",
          "name": "filter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "filterFn",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:FilterFn"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "this",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": [],
      "description": "An immutable Collection implementation. Updates are only allowed\nwhen it is not marked as frozen. This can be subclassed to implement\ncustom collection behaviors."
    },
    "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:CollectionNode": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:CollectionNode",
      "name": "CollectionNode",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "level": {
          "type": "property",
          "name": "level",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "hasChildNodes": {
          "type": "property",
          "name": "hasChildNodes",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "default": null
        },
        "rendered": {
          "type": "property",
          "name": "rendered",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "default": null
        },
        "index": {
          "type": "property",
          "name": "index",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "parentKey": {
          "type": "property",
          "name": "parentKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "prevKey": {
          "type": "property",
          "name": "prevKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "nextKey": {
          "type": "property",
          "name": "nextKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "firstChildKey": {
          "type": "property",
          "name": "firstChildKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "lastChildKey": {
          "type": "property",
          "name": "lastChildKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "props": {
          "type": "property",
          "name": "props",
          "indexType": null,
          "value": {
            "id": null,
            "name": null,
            "type": "any"
          },
          "optional": false,
          "default": null
        },
        "render": {
          "type": "property",
          "name": "render",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "id": null,
                      "name": null,
                      "type": "any"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "colSpan": {
          "type": "property",
          "name": "colSpan",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "colIndex": {
          "type": "property",
          "name": "colIndex",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "childNodes": {
          "type": "property",
          "name": "childNodes",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "default": null
        },
        "clone": {
          "type": "method",
          "name": "clone",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "this",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "filter": {
          "type": "method",
          "name": "filter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "collection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:BaseCollection"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "newCollection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:BaseCollection"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "filterFn",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:FilterFn"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:CollectionNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": [],
      "description": "An immutable object representing a Node in a Collection."
    },
    "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:FilterFn": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/BaseCollection.ts:FilterFn",
      "name": "FilterFn",
      "value": {
        "type": "function",
        "parameters": [
          {
            "type": "parameter",
            "name": "textValue",
            "value": {
              "type": "string"
            },
            "rest": false
          },
          {
            "type": "parameter",
            "name": "node",
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "rest": false
          }
        ],
        "return": {
          "type": "boolean"
        },
        "typeParameters": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Link.tsx:LinkRenderProps",
      "name": "LinkRenderProps",
      "properties": {
        "isCurrent": {
          "type": "property",
          "name": "isCurrent",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is the current item within a list.",
          "selector": "[data-current]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the link is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxRenderProps",
      "name": "ListBoxRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the listbox is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "stack"
              },
              {
                "type": "string",
                "value": "grid"
              }
            ]
          },
          "optional": false,
          "description": "Whether the items are arranged in a stack or grid.",
          "selector": "[data-layout=\"stack | grid\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the listbox.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ListBox.tsx:ListBoxItemRenderProps",
      "name": "ListBoxItemRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuRenderProps",
      "name": "MenuRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the menu has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Menu.tsx:MenuItemRenderProps",
      "name": "MenuItemRenderProps",
      "properties": {
        "hasSubmenu": {
          "type": "property",
          "name": "hasSubmenu",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item has a submenu.",
          "selector": "[data-has-submenu]",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item's submenu is open.",
          "selector": "[data-open]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/menu/src/index.d.ts:MenuTriggerType": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/menu/src/index.d.ts:MenuTriggerType",
      "name": "MenuTriggerType",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "press"
          },
          {
            "type": "string",
            "value": "longPress"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Meter.tsx:MeterRenderProps",
      "name": "MeterRenderProps",
      "properties": {
        "percentage": {
          "type": "property",
          "name": "percentage",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The value as a percentage between the minimum and maximum.",
          "default": null
        },
        "valueText": {
          "type": "property",
          "name": "valueText",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "A formatted version of the value.",
          "selector": "[aria-valuetext]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Modal.tsx:ModalRenderProps",
      "name": "ModalRenderProps",
      "properties": {
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the modal is currently entering. Use this to apply animations.",
          "selector": "[data-entering]",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the modal is currently exiting. Use this to apply animations.",
          "selector": "[data-exiting]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/overlays/src/useOverlayTriggerState.ts:OverlayTriggerState"
          },
          "optional": false,
          "description": "State of the modal.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/overlays/src/useOverlayTriggerState.ts:OverlayTriggerState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/overlays/src/useOverlayTriggerState.ts:OverlayTriggerState",
      "name": "OverlayTriggerState",
      "properties": {
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the overlay is currently open.",
          "default": null
        },
        "setOpen": {
          "type": "method",
          "name": "setOpen",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the overlay is open.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Opens the overlay.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes the overlay.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the overlay's visibility.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/NumberField.tsx:NumberFieldRenderProps",
      "name": "NumberFieldRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the number field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the number field is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the number field is required.",
          "selector": "[data-required]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/numberfield/src/useNumberFieldState.ts:NumberFieldState"
          },
          "optional": false,
          "description": "State of the number field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/numberfield/src/useNumberFieldState.ts:NumberFieldState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/numberfield/src/useNumberFieldState.ts:NumberFieldState",
      "name": "NumberFieldState",
      "properties": {
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The current text value of the input. Updated as the user types,\nand formatted according to `formatOptions` on blur.",
          "default": null
        },
        "numberValue": {
          "type": "property",
          "name": "numberValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The currently parsed number value, or NaN if a valid number could not be parsed.\nUpdated based on the `inputValue` as the user types.",
          "default": null
        },
        "defaultNumberValue": {
          "type": "property",
          "name": "defaultNumberValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The default value of the input.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum value of the number field.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum value of the number field.",
          "default": null
        },
        "canIncrement": {
          "type": "property",
          "name": "canIncrement",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the current value can be incremented according to the maximum value and step.",
          "default": null
        },
        "canDecrement": {
          "type": "property",
          "name": "canDecrement",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the current value can be decremented according to the minimum value and step.",
          "default": null
        },
        "validate": {
          "type": "method",
          "name": "validate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Validates a user input string according to the current locale and format options.\nValues can be partially entered, and may be valid even if they cannot currently be parsed to a number.\nCan be used to implement validation as a user types.",
          "default": null
        },
        "setInputValue": {
          "type": "method",
          "name": "setInputValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "val",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current text value of the input.",
          "default": null
        },
        "setNumberValue": {
          "type": "method",
          "name": "setNumberValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "val",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the number value.",
          "default": null
        },
        "commit": {
          "type": "method",
          "name": "commit",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the current input value. The value is parsed to a number, clamped according\nto the minimum and maximum values of the field, and snapped to the nearest step value.\nThis will fire the `onChange` prop with the new value, and if uncontrolled, update the `numberValue`.\nTypically this is called when the field is blurred.",
          "default": null
        },
        "increment": {
          "type": "method",
          "name": "increment",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the current input value to the next step boundary, and fires `onChange`.",
          "default": null
        },
        "decrement": {
          "type": "method",
          "name": "decrement",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the current input value to the next step boundary, and fires `onChange`.",
          "default": null
        },
        "incrementToMax": {
          "type": "method",
          "name": "incrementToMax",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current value to the `maxValue` if any, and fires `onChange`.",
          "default": null
        },
        "decrementToMin": {
          "type": "method",
          "name": "decrementToMin",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current value to the `minValue` if any, and fires `onChange`.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/OverlayArrow.tsx:OverlayArrowRenderProps",
      "name": "OverlayArrowRenderProps",
      "properties": {
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The placement of the overlay relative to the trigger.",
          "selector": "[data-placement=\"left | right | top | bottom\"]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis",
      "name": "PlacementAxis",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Axis"
          },
          {
            "type": "string",
            "value": "center"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Axis": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Axis",
      "name": "Axis",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "top"
          },
          {
            "type": "string",
            "value": "bottom"
          },
          {
            "type": "string",
            "value": "left"
          },
          {
            "type": "string",
            "value": "right"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement",
      "name": "Placement",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "bottom"
          },
          {
            "type": "string",
            "value": "bottom left"
          },
          {
            "type": "string",
            "value": "bottom right"
          },
          {
            "type": "string",
            "value": "bottom start"
          },
          {
            "type": "string",
            "value": "bottom end"
          },
          {
            "type": "string",
            "value": "top"
          },
          {
            "type": "string",
            "value": "top left"
          },
          {
            "type": "string",
            "value": "top right"
          },
          {
            "type": "string",
            "value": "top start"
          },
          {
            "type": "string",
            "value": "top end"
          },
          {
            "type": "string",
            "value": "left"
          },
          {
            "type": "string",
            "value": "left top"
          },
          {
            "type": "string",
            "value": "left bottom"
          },
          {
            "type": "string",
            "value": "start"
          },
          {
            "type": "string",
            "value": "start top"
          },
          {
            "type": "string",
            "value": "start bottom"
          },
          {
            "type": "string",
            "value": "right"
          },
          {
            "type": "string",
            "value": "right top"
          },
          {
            "type": "string",
            "value": "right bottom"
          },
          {
            "type": "string",
            "value": "end"
          },
          {
            "type": "string",
            "value": "end top"
          },
          {
            "type": "string",
            "value": "end bottom"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps",
      "name": "PopoverRenderProps",
      "properties": {
        "trigger": {
          "type": "property",
          "name": "trigger",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The name of the component that triggered the popover, e.g. \"DialogTrigger\" or \"ComboBox\".",
          "selector": "[data-trigger=\"...\"]",
          "default": null
        },
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The placement of the popover relative to the trigger.",
          "selector": "[data-placement=\"left | right | top | bottom\"]",
          "default": null
        },
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the popover is currently entering. Use this to apply animations.",
          "selector": "[data-entering]",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the popover is currently exiting. Use this to apply animations.",
          "selector": "[data-exiting]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ProgressBar.tsx:ProgressBarRenderProps",
      "name": "ProgressBarRenderProps",
      "properties": {
        "percentage": {
          "type": "property",
          "name": "percentage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "The value as a percentage between the minimum and maximum.",
          "default": null
        },
        "valueText": {
          "type": "property",
          "name": "valueText",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "A formatted version of the value.",
          "selector": "[aria-valuetext]",
          "default": null
        },
        "isIndeterminate": {
          "type": "property",
          "name": "isIndeterminate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the progress bar is indeterminate.",
          "selector": ":not([aria-valuenow])",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioGroupRenderProps",
      "name": "RadioGroupRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the radio group.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is required.",
          "selector": "[data-required]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/radio/src/useRadioGroupState.ts:RadioGroupState"
          },
          "optional": false,
          "description": "State of the radio group.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/radio/src/useRadioGroupState.ts:RadioGroupState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/radio/src/useRadioGroupState.ts:RadioGroupState",
      "name": "RadioGroupState",
      "properties": {
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The name for the group, used for native form submission.",
          "access": "private",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is read only.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is required.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Whether the radio group is valid or invalid.",
          "access": "private",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio group is invalid.",
          "default": null
        },
        "selectedValue": {
          "type": "property",
          "name": "selectedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected value.",
          "default": null
        },
        "defaultSelectedValue": {
          "type": "property",
          "name": "defaultSelectedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default selected value.",
          "default": null
        },
        "setSelectedValue": {
          "type": "method",
          "name": "setSelectedValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected value.",
          "default": null
        },
        "lastFocusedValue": {
          "type": "property",
          "name": "lastFocusedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The value of the last focused radio.",
          "default": null
        },
        "setLastFocusedValue": {
          "type": "method",
          "name": "setLastFocusedValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the last focused value.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/RadioGroup.tsx:RadioRenderProps",
      "name": "RadioRenderProps",
      "properties": {
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the radio is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the checkbox is required.",
          "selector": "[data-required]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/SearchField.tsx:SearchFieldRenderProps",
      "name": "SearchFieldRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the search field is empty.",
          "selector": "[data-empty]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the search field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the search field is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/searchfield/src/useSearchFieldState.ts:SearchFieldState"
          },
          "optional": false,
          "description": "State of the search field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/searchfield/src/useSearchFieldState.ts:SearchFieldState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/searchfield/src/useSearchFieldState.ts:SearchFieldState",
      "name": "SearchFieldState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The current value of the search field.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value of the search field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode",
      "name": "SelectionMode",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "single"
          },
          {
            "type": "string",
            "value": "multiple"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType",
      "name": "ValueType",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
        },
        "extendsType": {
          "type": "string",
          "value": "single"
        },
        "trueType": {
          "type": "union",
          "elements": [
            {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            {
              "type": "null"
            }
          ]
        },
        "falseType": {
          "type": "array",
          "elementType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          }
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "M",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
          },
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValidationType": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValidationType",
      "name": "ValidationType",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
        },
        "extendsType": {
          "type": "string",
          "value": "single"
        },
        "trueType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
        },
        "falseType": {
          "type": "array",
          "elementType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          }
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "M",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
          },
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectRenderProps",
      "name": "SelectRenderProps",
      "properties": {
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is currently open.",
          "selector": "[data-open]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is required.",
          "selector": "[data-required]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectionMode": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectionMode",
      "name": "SelectionMode",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "single"
          },
          {
            "type": "string",
            "value": "multiple"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Select.tsx:SelectValueRenderProps",
      "name": "SelectValueRenderProps",
      "properties": {
        "isPlaceholder": {
          "type": "property",
          "name": "isPlaceholder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the value is a placeholder.",
          "selector": "[data-placeholder]",
          "default": null
        },
        "selectedItem": {
          "type": "property",
          "name": "selectedItem",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The object value of the first selected item.",
          "access": "private",
          "default": null
        },
        "selectedItems": {
          "type": "property",
          "name": "selectedItems",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "T"
                },
                {
                  "type": "null"
                }
              ]
            }
          },
          "optional": false,
          "description": "The object values of the currently selected items.",
          "default": null
        },
        "selectedText": {
          "type": "property",
          "name": "selectedText",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The textValue of the currently selected items.",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/select/src/useSelectState.ts:SelectState"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "union",
                "elements": [
                  {
                    "type": "string",
                    "value": "single"
                  },
                  {
                    "type": "string",
                    "value": "multiple"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The state of the select.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/select/src/useSelectState.ts:SelectState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/select/src/useSelectState.ts:SelectState",
      "name": "SelectState",
      "properties": {
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The key for the first selected item.",
          "access": "private",
          "default": null
        },
        "defaultSelectedKey": {
          "type": "property",
          "name": "defaultSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The default selected key.",
          "access": "private",
          "default": null
        },
        "setSelectedKey": {
          "type": "method",
          "name": "setSelectedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "description": "Sets the selected key.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
              }
            ]
          },
          "optional": false,
          "description": "The current select value.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
              }
            ]
          },
          "optional": false,
          "description": "The default select value.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "array",
                      "elementType": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      }
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the select value.",
          "default": null
        },
        "selectedItem": {
          "type": "property",
          "name": "selectedItem",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The value of the first selected item.",
          "access": "private",
          "default": null
        },
        "selectedItems": {
          "type": "property",
          "name": "selectedItems",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "The value of the selected items.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the select is currently focused.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the select is focused.",
          "default": null
        },
        "focusStrategy": {
          "type": "property",
          "name": "focusStrategy",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Controls which item will be auto focused when the menu opens.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "focusStrategy",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Opens the menu.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "focusStrategy",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the menu.",
          "default": null
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the list.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of items that are disabled.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the overlay is currently open.",
          "default": null
        },
        "setOpen": {
          "type": "method",
          "name": "setOpen",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the overlay is open.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes the overlay.",
          "default": null
        },
        "realtimeValidation": {
          "type": "property",
          "name": "realtimeValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Realtime validation results, updated as the user edits the value.",
          "default": null
        },
        "displayValidation": {
          "type": "property",
          "name": "displayValidation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
          },
          "optional": false,
          "description": "Currently displayed validation results, updated when the user commits their changes.",
          "default": null
        },
        "updateValidation": {
          "type": "method",
          "name": "updateValidation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "result",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the current validation result. Not displayed to the user until `commitValidation` is called.",
          "default": null
        },
        "resetValidation": {
          "type": "method",
          "name": "resetValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resets the displayed validation state to valid when the user resets the form.",
          "default": null
        },
        "commitValidation": {
          "type": "method",
          "name": "commitValidation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Commits the realtime validation so it is displayed to the user.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "M",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
          },
          "default": {
            "type": "string",
            "value": "single"
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderRenderProps",
      "name": "SliderRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the slider.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the slider is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/slider/src/useSliderState.ts:SliderState"
          },
          "optional": false,
          "description": "State of the slider.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/slider/src/useSliderState.ts:SliderState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/slider/src/useSliderState.ts:SliderState",
      "name": "SliderState",
      "properties": {
        "values": {
          "type": "property",
          "name": "values",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "number"
            }
          },
          "optional": false,
          "description": "Values managed by the slider by thumb index.",
          "default": null
        },
        "defaultValues": {
          "type": "property",
          "name": "defaultValues",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "number"
            }
          },
          "optional": false,
          "description": "The default values for each thumb.",
          "default": null
        },
        "getThumbValue": {
          "type": "method",
          "name": "getThumbValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Get the value for the specified thumb.",
          "default": null
        },
        "setThumbValue": {
          "type": "method",
          "name": "setThumbValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the value for the specified thumb.\nThe actual value set will be clamped and rounded according to min/max/step.",
          "default": null
        },
        "setThumbPercent": {
          "type": "method",
          "name": "setThumbPercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "percent",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets value for the specified thumb by percent offset (between 0 and 1).",
          "default": null
        },
        "isThumbDragging": {
          "type": "method",
          "name": "isThumbDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Whether the specific thumb is being dragged.",
          "default": null
        },
        "setThumbDragging": {
          "type": "method",
          "name": "setThumbDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "dragging",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set is dragging on the specified thumb.",
          "default": null
        },
        "focusedThumb": {
          "type": "property",
          "name": "focusedThumb",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "Currently-focused thumb index.",
          "default": null
        },
        "setFocusedThumb": {
          "type": "method",
          "name": "setFocusedThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "number"
                    },
                    {
                      "type": "undefined"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set focused true on specified thumb. This will remove focus from\nany thumb that had it before.",
          "default": null
        },
        "getThumbPercent": {
          "type": "method",
          "name": "getThumbPercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the specified thumb's value as a percentage from 0 to 1.",
          "default": null
        },
        "getValuePercent": {
          "type": "method",
          "name": "getValuePercent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the value as a percent between the min and max of the slider.",
          "default": null
        },
        "getThumbValueLabel": {
          "type": "method",
          "name": "getThumbValueLabel",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the string label for the specified thumb's value, per props.formatOptions.",
          "default": null
        },
        "getFormattedValue": {
          "type": "method",
          "name": "getFormattedValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the string label for the value, per props.formatOptions.",
          "default": null
        },
        "getThumbMinValue": {
          "type": "method",
          "name": "getThumbMinValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the min allowed value for the specified thumb.",
          "default": null
        },
        "getThumbMaxValue": {
          "type": "method",
          "name": "getThumbMaxValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the max allowed value for the specified thumb.",
          "default": null
        },
        "getPercentValue": {
          "type": "method",
          "name": "getPercentValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "percent",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts a percent along track (between 0 and 1) to the corresponding value.",
          "default": null
        },
        "isThumbEditable": {
          "type": "method",
          "name": "isThumbEditable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns if the specified thumb is editable.",
          "default": null
        },
        "setThumbEditable": {
          "type": "method",
          "name": "setThumbEditable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "editable",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Set the specified thumb's editable state.",
          "default": null
        },
        "incrementThumb": {
          "type": "method",
          "name": "incrementThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Increments the value of the thumb by the step or page amount.",
          "default": null
        },
        "decrementThumb": {
          "type": "method",
          "name": "decrementThumb",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "index",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "stepSize",
                "value": {
                  "type": "number"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Decrements the value of the thumb by the step or page amount.",
          "default": null
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step amount for the slider.",
          "default": null
        },
        "pageSize": {
          "type": "property",
          "name": "pageSize",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page size for the slider, used to do a bigger step.",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the slider.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the slider is disabled.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderTrackRenderProps",
      "name": "SliderTrackRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the slider track is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the slider.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the slider is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/slider/src/useSliderState.ts:SliderState"
          },
          "optional": false,
          "description": "State of the slider.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Slider.tsx:SliderThumbRenderProps",
      "name": "SliderThumbRenderProps",
      "properties": {
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/slider/src/useSliderState.ts:SliderState"
          },
          "optional": false,
          "description": "State of the slider.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether this thumb is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the thumb is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Switch.tsx:SwitchRenderProps",
      "name": "SwitchRenderProps",
      "properties": {
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the switch is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleState.ts:ToggleState"
          },
          "optional": false,
          "description": "State of the switch.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleState.ts:ToggleState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleState.ts:ToggleState",
      "name": "ToggleState",
      "properties": {
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toggle is selected.",
          "default": null
        },
        "defaultSelected": {
          "type": "property",
          "name": "defaultSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toggle is selected by default.",
          "default": null
        },
        "setSelected": {
          "type": "method",
          "name": "setSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isSelected",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates selection state.",
          "default": null
        },
        "toggle": {
          "type": "method",
          "name": "toggle",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggle the selection state.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor",
      "name": "SortDescriptor",
      "properties": {
        "column": {
          "type": "property",
          "name": "column",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": false,
          "description": "The key of the column to sort by.",
          "default": null
        },
        "direction": {
          "type": "property",
          "name": "direction",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
          },
          "optional": false,
          "description": "The direction to sort by.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection",
      "name": "SortDirection",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "ascending"
          },
          {
            "type": "string",
            "value": "descending"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableRenderProps",
      "name": "TableRenderProps",
      "properties": {
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/table/src/useTableState.ts:TableState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the table.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/table/src/useTableState.ts:TableState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/table/src/useTableState.ts:TableState",
      "name": "TableState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:TableCollection"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": false,
          "description": "A collection of rows and columns in the table.",
          "default": null
        },
        "showSelectionCheckboxes": {
          "type": "property",
          "name": "showSelectionCheckboxes",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the row selection checkboxes should be displayed.",
          "default": null
        },
        "sortDescriptor": {
          "type": "property",
          "name": "sortDescriptor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current sorted column and direction.",
          "default": null
        },
        "sort": {
          "type": "method",
          "name": "sort",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "columnKey",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "direction",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "ascending"
                    },
                    {
                      "type": "string",
                      "value": "descending"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Calls the provided onSortChange handler with the provided column key and sort direction.",
          "default": null
        },
        "isKeyboardNavigationDisabled": {
          "type": "property",
          "name": "isKeyboardNavigationDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether keyboard navigation is disabled, such as when the arrow keys should be handled by a component within a cell.",
          "default": null
        },
        "setKeyboardNavigationDisabled": {
          "type": "property",
          "name": "setKeyboardNavigationDisabled",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "val",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "Set whether keyboard navigation is disabled, such as when the arrow keys should be handled by a component within a cell.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for rows that are disabled.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update row selection state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:TableCollection": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:TableCollection",
      "name": "TableCollection",
      "properties": {
        "headerRows": {
          "type": "property",
          "name": "headerRows",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "A list of header row nodes in the table.",
          "default": null
        },
        "columns": {
          "type": "property",
          "name": "columns",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "A list of column nodes in the table.",
          "default": null
        },
        "rowHeaderColumnKeys": {
          "type": "property",
          "name": "rowHeaderColumnKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of column keys that serve as the [row header](https://www.w3.org/TR/wai-aria-1.1/#rowheader).",
          "default": null
        },
        "head": {
          "type": "property",
          "name": "head",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The node that makes up the header of the table.",
          "default": null
        },
        "body": {
          "type": "property",
          "name": "body",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": false,
          "description": "The node that makes up the body of the table.",
          "default": null
        },
        "columnCount": {
          "type": "property",
          "name": "columnCount",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The number of columns in the grid.",
          "default": null
        },
        "rows": {
          "type": "property",
          "name": "rows",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "A list of rows in the grid.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The number of items in the collection.",
          "default": null
        },
        "getKeys": {
          "type": "method",
          "name": "getKeys",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Iterate over all keys in the collection.",
          "default": null
        },
        "getItem": {
          "type": "method",
          "name": "getItem",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get an item by its key.",
          "default": null
        },
        "at": {
          "type": "method",
          "name": "at",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "idx",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get an item by the index of its key.",
          "default": null
        },
        "getKeyBefore": {
          "type": "method",
          "name": "getKeyBefore",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the key that comes before the given key in the collection.",
          "default": null
        },
        "getKeyAfter": {
          "type": "method",
          "name": "getKeyAfter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the key that comes after the given key in the collection.",
          "default": null
        },
        "getFirstKey": {
          "type": "method",
          "name": "getFirstKey",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the first key in the collection.",
          "default": null
        },
        "getLastKey": {
          "type": "method",
          "name": "getLastKey",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the last key in the collection.",
          "default": null
        },
        "getChildren": {
          "type": "method",
          "name": "getChildren",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Iterate over the child items of the given key.",
          "default": null
        },
        "getTextValue": {
          "type": "method",
          "name": "getTextValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a string representation of the item's contents.",
          "default": null
        },
        "filter": {
          "type": "method",
          "name": "filter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "filterFn",
                "value": {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "nodeValue",
                      "value": {
                        "type": "string"
                      },
                      "rest": false
                    },
                    {
                      "type": "parameter",
                      "name": "node",
                      "value": {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                        },
                        "typeParameters": [
                          {
                            "type": "identifier",
                            "name": "T"
                          }
                        ]
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Filters the collection using the given function.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode",
      "name": "GridNode",
      "properties": {
        "column": {
          "type": "property",
          "name": "column",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/grid/src/index.d.ts:GridNode"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "colspan": {
          "type": "property",
          "name": "colspan",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The number of columns spanned by this cell. Use `colSpan` instead.",
          "access": "private",
          "default": null
        },
        "colSpan": {
          "type": "property",
          "name": "colSpan",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The number of columns spanned by this cell.",
          "default": null
        },
        "colIndex": {
          "type": "property",
          "name": "colIndex",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The column index of this cell, accounting for any colSpans.",
          "default": null
        },
        "indexOfType": {
          "type": "property",
          "name": "indexOfType",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The index of this node within its parent, ignoring sibling nodes that aren't of the same type.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The type of item this node represents.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": false,
          "description": "A unique key for the node.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The object value the node was created from.",
          "default": null
        },
        "level": {
          "type": "property",
          "name": "level",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The level of depth this node is at in the hierarchy.",
          "default": null
        },
        "hasChildNodes": {
          "type": "property",
          "name": "hasChildNodes",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether this item has children, even if not loaded yet.",
          "default": null
        },
        "childNodes": {
          "type": "property",
          "name": "childNodes",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The loaded children of this node.",
          "access": "private",
          "default": null
        },
        "rendered": {
          "type": "property",
          "name": "rendered",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The rendered contents of this node (e.g. JSX).",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A string value for this node, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this node.",
          "default": null
        },
        "index": {
          "type": "property",
          "name": "index",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The index of this node within its parent.",
          "default": null
        },
        "wrapper": {
          "type": "property",
          "name": "wrapper",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "element",
                "value": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that should be called to wrap the rendered node.",
          "default": null
        },
        "parentKey": {
          "type": "property",
          "name": "parentKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The key of the parent node.",
          "default": null
        },
        "prevKey": {
          "type": "property",
          "name": "prevKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The key of the node before this node.",
          "default": null
        },
        "nextKey": {
          "type": "property",
          "name": "nextKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The key of the node after this node.",
          "default": null
        },
        "props": {
          "type": "property",
          "name": "props",
          "indexType": null,
          "value": {
            "id": null,
            "name": null,
            "type": "any"
          },
          "optional": true,
          "description": "Additional properties specific to a particular node type.",
          "default": null
        },
        "shouldInvalidate": {
          "type": "property",
          "name": "shouldInvalidate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "context",
                "value": {
                  "id": null,
                  "name": null,
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "render": {
          "type": "property",
          "name": "render",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "id": null,
                      "name": null,
                      "type": "any"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that renders this node to a React Element in the DOM.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:RowRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:RowRenderProps",
      "name": "RowRenderProps",
      "properties": {
        "isFocusVisibleWithin": {
          "type": "property",
          "name": "isFocusVisibleWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the row's children have keyboard focus.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the row.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps",
      "name": "CellRenderProps",
      "properties": {
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the cell.\n*",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize",
      "name": "ColumnSize",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnDynamicSize"
          }
        ]
      },
      "typeParameters": [],
      "description": "All possible sizes a column can be assigned."
    },
    "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize",
      "name": "ColumnStaticSize",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "number"
          },
          {
            "type": "template",
            "elements": [
              {
                "type": "number"
              }
            ]
          },
          {
            "type": "template",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "string",
                "value": "%"
              }
            ]
          }
        ]
      },
      "typeParameters": [],
      "description": "Widths that result in a constant pixel value for the same Table width."
    },
    "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnDynamicSize": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnDynamicSize",
      "name": "ColumnDynamicSize",
      "value": {
        "type": "template",
        "elements": [
          {
            "type": "number"
          },
          {
            "type": "string",
            "value": "fr"
          }
        ]
      },
      "typeParameters": [],
      "description": "Widths that change size in relation to the remaining space and in ratio to other dynamic columns.\nAll numbers must be integers and greater than 0.\nFR units take up remaining, if any, space in the table."
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps",
      "name": "ColumnRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "allowsSorting": {
          "type": "property",
          "name": "allowsSorting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the column allows sorting.",
          "selector": "[data-allows-sorting]",
          "default": null
        },
        "sortDirection": {
          "type": "property",
          "name": "sortDirection",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "The current sort direction.",
          "selector": "[data-sort-direction=\"ascending | descending\"]",
          "default": null
        },
        "isResizing": {
          "type": "property",
          "name": "isResizing",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the column is currently being resized.",
          "selector": "[data-resizing]",
          "default": null
        },
        "sort": {
          "type": "method",
          "name": "sort",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "direction",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Triggers sorting for this column in the given direction.",
          "default": null
        },
        "startResize": {
          "type": "method",
          "name": "startResize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Starts column resizing if the table is contained in a `<ResizableTableContainer>` element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnResizerRenderProps",
      "name": "ColumnResizerRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the resizer is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the resizer is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the resizer is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isResizing": {
          "type": "property",
          "name": "isResizing",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the resizer is currently being resized.",
          "selector": "[data-resizing]",
          "default": null
        },
        "resizableDirection": {
          "type": "property",
          "name": "resizableDirection",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "right"
              },
              {
                "type": "string",
                "value": "left"
              },
              {
                "type": "string",
                "value": "both"
              }
            ]
          },
          "optional": false,
          "description": "The direction that the column is currently resizable.",
          "selector": "[data-resizable-direction=\"right | left | both\"]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableHeaderRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableHeaderRenderProps",
      "name": "TableHeaderRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table header is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps",
      "name": "TableBodyRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table body has no rows and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the Table is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableOptionsContextValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableOptionsContextValue",
      "name": "TableOptionsContextValue",
      "properties": {
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the table.",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The selection behavior for the table. If selectionMode is `\"none\"`, this will be `null`.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table allows empty selection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table allows rows to be dragged.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/layout/src/TableLayout.ts:TableLayoutProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/TableLayout.ts:TableLayoutProps",
      "name": "TableLayoutProps",
      "properties": {
        "columnWidths": {
          "type": "property",
          "name": "columnWidths",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "number"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "rowHeight": {
          "type": "property",
          "name": "rowHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The fixed height of a row in px.",
          "default": "48"
        },
        "estimatedRowHeight": {
          "type": "property",
          "name": "estimatedRowHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The estimated height of a row, when row heights are variable.",
          "default": null
        },
        "headingHeight": {
          "type": "property",
          "name": "headingHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The fixed height of a section header in px.",
          "default": "48"
        },
        "estimatedHeadingHeight": {
          "type": "property",
          "name": "estimatedHeadingHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The estimated height of a section header, when the height is variable.",
          "default": null
        },
        "loaderHeight": {
          "type": "property",
          "name": "loaderHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The fixed height of a loader element in px. This loader is specifically for\n\"load more\" elements rendered when loading more rows at the root level or inside nested row/sections.",
          "default": "48"
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The thickness of the drop indicator.",
          "default": "2"
        },
        "gap": {
          "type": "property",
          "name": "gap",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The gap between items.",
          "default": "0"
        },
        "padding": {
          "type": "property",
          "name": "padding",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The padding around the list.",
          "default": "0"
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:ListLayoutOptions",
      "name": "ListLayoutOptions",
      "properties": {
        "rowHeight": {
          "type": "property",
          "name": "rowHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The fixed height of a row in px.",
          "default": "48"
        },
        "estimatedRowHeight": {
          "type": "property",
          "name": "estimatedRowHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The estimated height of a row, when row heights are variable.",
          "default": null
        },
        "headingHeight": {
          "type": "property",
          "name": "headingHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The fixed height of a section header in px.",
          "default": "48"
        },
        "estimatedHeadingHeight": {
          "type": "property",
          "name": "estimatedHeadingHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The estimated height of a section header, when the height is variable.",
          "default": null
        },
        "loaderHeight": {
          "type": "property",
          "name": "loaderHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The fixed height of a loader element in px. This loader is specifically for\n\"load more\" elements rendered when loading more rows at the root level or inside nested row/sections.",
          "default": "48"
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The thickness of the drop indicator.",
          "default": "2"
        },
        "gap": {
          "type": "property",
          "name": "gap",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The gap between items.",
          "default": "0"
        },
        "padding": {
          "type": "property",
          "name": "padding",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The padding around the list.",
          "default": "0"
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/types.ts:InvalidationContext": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/types.ts:InvalidationContext",
      "name": "InvalidationContext",
      "properties": {
        "contentChanged": {
          "type": "property",
          "name": "contentChanged",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "default": null
        },
        "offsetChanged": {
          "type": "property",
          "name": "offsetChanged",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "default": null
        },
        "sizeChanged": {
          "type": "property",
          "name": "sizeChanged",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "default": null
        },
        "itemSizeChanged": {
          "type": "property",
          "name": "itemSizeChanged",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "default": null
        },
        "layoutOptionsChanged": {
          "type": "property",
          "name": "layoutOptionsChanged",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "default": null
        },
        "layoutOptions": {
          "type": "property",
          "name": "layoutOptions",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "O"
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "O",
          "constraint": null,
          "default": {
            "id": null,
            "name": null,
            "type": "any"
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode",
      "name": "LayoutNode",
      "properties": {
        "node": {
          "type": "property",
          "name": "node",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "layoutInfo": {
          "type": "property",
          "name": "layoutInfo",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
          },
          "optional": false,
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/ListLayout.ts:LayoutNode"
            }
          },
          "optional": true,
          "default": null
        },
        "validRect": {
          "type": "property",
          "name": "validRect",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
          },
          "optional": false,
          "default": null
        },
        "index": {
          "type": "property",
          "name": "index",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo",
      "name": "LayoutInfo",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The type of element represented by this LayoutInfo. Should match the `type` of the corresponding collection node.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "description": "A unique key for this LayoutInfo. Should match the `key` of the corresponding collection node.",
          "default": null
        },
        "parentKey": {
          "type": "property",
          "name": "parentKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The key for a parent LayoutInfo, if any.",
          "default": null
        },
        "content": {
          "type": "property",
          "name": "content",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "id": null,
                "name": null,
                "type": "any"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Content for this item if it was generated by the layout rather than coming from the Collection.",
          "default": null
        },
        "rect": {
          "type": "property",
          "name": "rect",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
          },
          "optional": false,
          "description": "The rectangle describing the size and position of this element.",
          "default": null
        },
        "estimatedSize": {
          "type": "property",
          "name": "estimatedSize",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the size is estimated. `false` by default.\nItems with estimated sizes will be measured the first time they are added to the DOM.\nThe estimated size is used to calculate the size and position of the scrollbar.",
          "default": "false"
        },
        "isSticky": {
          "type": "property",
          "name": "isSticky",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the layout info sticks to the viewport when scrolling.",
          "default": "false"
        },
        "opacity": {
          "type": "property",
          "name": "opacity",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The element's opacity.",
          "default": "1"
        },
        "transform": {
          "type": "property",
          "name": "transform",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "A CSS transform string to apply to the element. `null` by default.",
          "default": null
        },
        "zIndex": {
          "type": "property",
          "name": "zIndex",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The z-index of the element. 0 by default.",
          "default": null
        },
        "allowOverflow": {
          "type": "property",
          "name": "allowOverflow",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the element allows its contents to overflow its container.",
          "default": "false"
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": "The type of element represented by this LayoutInfo. Should match the `type` of the corresponding collection node."
              },
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": "A unique key for this LayoutInfo. Should match the `key` of the corresponding collection node."
              },
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle describing the size and position of this element."
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of the LayoutInfo.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "Instances of this lightweight class are created by `Layout` subclasses\nto represent each item in the `Virtualizer`. LayoutInfo objects describe\nvarious properties of an item, such as its position and size, and style information.\nThe virtualizer uses this information when creating actual DOM elements to display."
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect",
      "name": "Rect",
      "properties": {
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x-coordinate of the rectangle.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y-coordinate of the rectangle.",
          "default": null
        },
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The width of the rectangle.",
          "default": null
        },
        "height": {
          "type": "property",
          "name": "height",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The height of the rectangle.",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "width",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "height",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "maxX": {
          "type": "property",
          "name": "maxX",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "description": "The maximum x-coordinate in the rectangle.",
          "default": null
        },
        "maxY": {
          "type": "property",
          "name": "maxY",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "description": "The maximum y-coordinate in the rectangle.",
          "default": null
        },
        "area": {
          "type": "property",
          "name": "area",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "description": "The area of the rectangle.",
          "default": null
        },
        "topLeft": {
          "type": "property",
          "name": "topLeft",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
          },
          "description": "The top left corner of the rectangle.",
          "default": null
        },
        "topRight": {
          "type": "property",
          "name": "topRight",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
          },
          "description": "The top right corner of the rectangle.",
          "default": null
        },
        "bottomLeft": {
          "type": "property",
          "name": "bottomLeft",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
          },
          "description": "The bottom left corner of the rectangle.",
          "default": null
        },
        "bottomRight": {
          "type": "property",
          "name": "bottomRight",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
          },
          "description": "The bottom right corner of the rectangle.",
          "default": null
        },
        "intersects": {
          "type": "method",
          "name": "intersects",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle to check."
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether this rectangle intersects another rectangle.",
          "default": null,
          "static": false
        },
        "containsRect": {
          "type": "method",
          "name": "containsRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle to check."
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether this rectangle fully contains another rectangle.",
          "default": null,
          "static": false
        },
        "containsPoint": {
          "type": "method",
          "name": "containsPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "point",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
                },
                "rest": false,
                "description": "The point to check."
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the rectangle contains the given point.",
          "default": null,
          "static": false
        },
        "getCornerInRect": {
          "type": "method",
          "name": "getCornerInRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle to check."
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:RectCorner"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the first corner of this rectangle (from top to bottom, left to right)\nthat is contained in the given rectangle, or null of the rectangles do not intersect.",
          "default": null,
          "static": false
        },
        "equals": {
          "type": "method",
          "name": "equals",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "pointEquals": {
          "type": "method",
          "name": "pointEquals",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "point",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "sizeEquals": {
          "type": "method",
          "name": "sizeEquals",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "size",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "union": {
          "type": "method",
          "name": "union",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "other",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "description": "Returns the union of this Rect and another.",
          "default": null,
          "static": false
        },
        "intersection": {
          "type": "method",
          "name": "intersection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "other",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "description": "Returns the intersection of this Rect with another.\nIf the rectangles do not intersect, an all zero Rect is returned.",
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this rectangle.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "Represents a rectangle."
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point",
      "name": "Point",
      "properties": {
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x-coordinate of the point.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y-coordinate of the point.",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this point.",
          "default": null,
          "static": false
        },
        "equals": {
          "type": "method",
          "name": "equals",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "point",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Checks if two points are equal.",
          "default": null,
          "static": false
        },
        "isOrigin": {
          "type": "method",
          "name": "isOrigin",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns true if this point is the origin.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:RectCorner": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:RectCorner",
      "name": "RectCorner",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "topLeft"
          },
          {
            "type": "string",
            "value": "topRight"
          },
          {
            "type": "string",
            "value": "bottomLeft"
          },
          {
            "type": "string",
            "value": "bottomRight"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size",
      "name": "Size",
      "properties": {
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "height": {
          "type": "property",
          "name": "height",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "width",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "height",
                "value": {
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this size.",
          "default": null,
          "static": false
        },
        "equals": {
          "type": "method",
          "name": "equals",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "other",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether this size is equal to another one.",
          "default": null,
          "static": false
        },
        "area": {
          "type": "property",
          "name": "area",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "description": "The total area of the Size.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:Virtualizer": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:Virtualizer",
      "name": "Virtualizer",
      "properties": {
        "delegate": {
          "type": "property",
          "name": "delegate",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "VirtualizerDelegate"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              },
              {
                "type": "identifier",
                "name": "V"
              }
            ]
          },
          "optional": false,
          "description": "The virtualizer delegate. The delegate is used by the virtualizer\nto create and configure views.",
          "default": null
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              }
            ]
          },
          "optional": false,
          "description": "The current content of the virtualizer.",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Layout"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              }
            ]
          },
          "optional": false,
          "description": "The layout object that determines the visible views.",
          "default": null
        },
        "contentSize": {
          "type": "property",
          "name": "contentSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": false,
          "description": "The size of the scrollable content.",
          "default": null
        },
        "visibleRect": {
          "type": "property",
          "name": "visibleRect",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
          },
          "optional": false,
          "description": "The currently visible rectangle.",
          "default": null
        },
        "persistedKeys": {
          "type": "property",
          "name": "persistedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "The set of persisted keys that are always present in the DOM, even if not currently in view.",
          "default": null
        },
        "_visibleViews": {
          "type": "property",
          "name": "_visibleViews",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  },
                  {
                    "type": "identifier",
                    "name": "V"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "_renderedContent": {
          "type": "property",
          "name": "_renderedContent",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "WeakMap"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              },
              {
                "type": "identifier",
                "name": "V"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "_rootView": {
          "type": "property",
          "name": "_rootView",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:RootView"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              },
              {
                "type": "identifier",
                "name": "V"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "_isScrolling": {
          "type": "property",
          "name": "_isScrolling",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "_invalidationContext": {
          "type": "property",
          "name": "_invalidationContext",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "InvalidationContext"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "_overscanManager": {
          "type": "property",
          "name": "_overscanManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/OverscanManager.ts:OverscanManager"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:VirtualizerOptions"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "isPersistedKey": {
          "type": "method",
          "name": "isPersistedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given key, or an ancestor, is persisted.",
          "default": null,
          "static": false
        },
        "getParentView": {
          "type": "method",
          "name": "getParentView",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "layoutInfo",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ReusableView"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getReusableView": {
          "type": "method",
          "name": "getReusableView",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "layoutInfo",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                },
                {
                  "type": "identifier",
                  "name": "V"
                }
              ]
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "_renderView": {
          "type": "method",
          "name": "_renderView",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "reusableView",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ReusableView"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "_renderContent": {
          "type": "method",
          "name": "_renderContent",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "content",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "keyAtPoint": {
          "type": "method",
          "name": "keyAtPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "point",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Point.ts:Point"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key for the item view currently at the given point.",
          "default": null,
          "static": false
        },
        "relayout": {
          "type": "method",
          "name": "relayout",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "context",
                "value": {
                  "type": "identifier",
                  "name": "InvalidationContext"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getVisibleLayoutInfos": {
          "type": "method",
          "name": "getVisibleLayoutInfos",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Map"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "updateSubviews": {
          "type": "method",
          "name": "updateSubviews",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "render": {
          "type": "method",
          "name": "render",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "opts",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "VirtualizerRenderOptions"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ReusableView"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  },
                  {
                    "type": "identifier",
                    "name": "V"
                  }
                ]
              }
            },
            "typeParameters": []
          },
          "description": "Performs layout and updates visible views as needed.",
          "default": null,
          "static": false
        },
        "getVisibleView": {
          "type": "method",
          "name": "getVisibleView",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ReusableView"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "invalidate": {
          "type": "method",
          "name": "invalidate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "context",
                "value": {
                  "type": "identifier",
                  "name": "InvalidationContext"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "updateItemSize": {
          "type": "method",
          "name": "updateItemSize",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "size",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "V",
          "constraint": null,
          "default": null
        }
      ],
      "extends": [],
      "description": "The Virtualizer class renders a scrollable collection of data using customizable layouts.\nIt supports very large collections by only rendering visible views to the DOM, reusing\nthem as you scroll. Virtualizer can present any type of view, including non-item views\nsuch as section headers and footers.\n\nVirtualizer uses `Layout` objects to compute what views should be visible, and how\nto position and style them. This means that virtualizer can have its items arranged in\na stack, a grid, a circle, or any other layout you can think of. The layout can be changed\ndynamically at runtime as well.\n\nLayouts produce information on what views should appear in the virtualizer, but do not create\nthe views themselves directly. It is the responsibility of the `VirtualizerDelegate` object\nto render elements for each layout info. The virtualizer manages a set of `ReusableView` objects,\nwhich are reused as the user scrolls by swapping their content with cached elements returned by the delegate."
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView",
      "name": "ChildView",
      "properties": {
        "parent": {
          "type": "property",
          "name": "parent",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ReusableView"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              },
              {
                "type": "identifier",
                "name": "V"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "virtualizer",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Virtualizer"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "parent",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ReusableView"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "viewType",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "V",
          "constraint": null,
          "default": null
        }
      ],
      "extends": [
        {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ReusableView"
        }
      ]
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ReusableView": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ReusableView",
      "name": "ReusableView",
      "properties": {
        "virtualizer": {
          "type": "property",
          "name": "virtualizer",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Virtualizer"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              },
              {
                "type": "identifier",
                "name": "V"
              }
            ]
          },
          "optional": false,
          "description": "The Virtualizer this view is a part of.",
          "default": null
        },
        "layoutInfo": {
          "type": "property",
          "name": "layoutInfo",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The LayoutInfo this view is currently representing.",
          "default": null
        },
        "content": {
          "type": "property",
          "name": "content",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "object",
                "properties": null
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The content currently being displayed by this view, set by the virtualizer.",
          "default": null
        },
        "rendered": {
          "type": "property",
          "name": "rendered",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "V"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "viewType": {
          "type": "property",
          "name": "viewType",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  },
                  {
                    "type": "identifier",
                    "name": "V"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "reusableViews": {
          "type": "property",
          "name": "reusableViews",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "string"
              },
              {
                "type": "array",
                "elementType": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                }
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "virtualizer",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Virtualizer"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "viewType",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "prepareForReuse": {
          "type": "method",
          "name": "prepareForReuse",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Prepares the view for reuse. Called just before the view is removed from the DOM.",
          "default": null,
          "static": false
        },
        "getReusableView": {
          "type": "method",
          "name": "getReusableView",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "reuseType",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                },
                {
                  "type": "identifier",
                  "name": "V"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "reuseChild": {
          "type": "method",
          "name": "reuseChild",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "child",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "V",
          "constraint": null,
          "default": null
        }
      ],
      "extends": [],
      "description": "`Virtualizer` creates instances of the `ReusableView` class to\nrepresent views currently being displayed."
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:RootView": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:RootView",
      "name": "RootView",
      "properties": {
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "virtualizer",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Virtualizer"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "virtualizer": {
          "type": "property",
          "name": "virtualizer",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Virtualizer"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              },
              {
                "type": "identifier",
                "name": "V"
              }
            ]
          },
          "optional": false,
          "description": "The Virtualizer this view is a part of.",
          "default": null
        },
        "layoutInfo": {
          "type": "property",
          "name": "layoutInfo",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The LayoutInfo this view is currently representing.",
          "default": null
        },
        "content": {
          "type": "property",
          "name": "content",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "object",
                "properties": null
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The content currently being displayed by this view, set by the virtualizer.",
          "default": null
        },
        "rendered": {
          "type": "property",
          "name": "rendered",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "V"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "viewType": {
          "type": "property",
          "name": "viewType",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  },
                  {
                    "type": "identifier",
                    "name": "V"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "reusableViews": {
          "type": "property",
          "name": "reusableViews",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Map"
            },
            "typeParameters": [
              {
                "type": "string"
              },
              {
                "type": "array",
                "elementType": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                }
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "prepareForReuse": {
          "type": "method",
          "name": "prepareForReuse",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Prepares the view for reuse. Called just before the view is removed from the DOM.",
          "default": null,
          "static": false
        },
        "getReusableView": {
          "type": "method",
          "name": "getReusableView",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "reuseType",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                },
                {
                  "type": "identifier",
                  "name": "V"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "reuseChild": {
          "type": "method",
          "name": "reuseChild",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "child",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/ReusableView.ts:ChildView"
                  },
                  "typeParameters": [
                    {
                      "type": "object",
                      "properties": null
                    },
                    {
                      "type": "identifier",
                      "name": "V"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "V",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/OverscanManager.ts:OverscanManager": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/OverscanManager.ts:OverscanManager",
      "name": "OverscanManager",
      "properties": {
        "startTime": {
          "type": "property",
          "name": "startTime",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "velocity": {
          "type": "property",
          "name": "velocity",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "visibleRect": {
          "type": "property",
          "name": "visibleRect",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "setVisibleRect": {
          "type": "method",
          "name": "setVisibleRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getOverscannedRect": {
          "type": "method",
          "name": "getOverscannedRect",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:VirtualizerOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:VirtualizerOptions",
      "name": "VirtualizerOptions",
      "properties": {
        "delegate": {
          "type": "property",
          "name": "delegate",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "VirtualizerDelegate"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              },
              {
                "type": "identifier",
                "name": "V"
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Layout"
            },
            "typeParameters": [
              {
                "type": "object",
                "properties": null
              }
            ]
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "V",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabsRenderProps",
      "name": "TabsRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the tabs.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabListRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabListRenderProps",
      "name": "TabListRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The orientation of the tab list.",
          "selector": "[data-orientation=\"horizontal | vertical\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tabs/src/useTabListState.ts:TabListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the tab list.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/tabs/src/useTabListState.ts:TabListState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/tabs/src/useTabListState.ts:TabListState",
      "name": "TabListState",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab list is disabled.",
          "default": null
        },
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The key for the currently selected item.",
          "default": null
        },
        "setSelectedKey": {
          "type": "method",
          "name": "setSelectedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected key.",
          "default": null
        },
        "selectedItem": {
          "type": "property",
          "name": "selectedItem",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The value of the currently selected item.",
          "default": null
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the list.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of items that are disabled.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabPanelRenderProps",
      "name": "TabPanelRenderProps",
      "properties": {
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab panel is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab panel is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isInert": {
          "type": "property",
          "name": "isInert",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab panel is currently non-interactive. This occurs when the\n`shouldForceMount` prop is true, and the corresponding tab is not selected.",
          "selector": "[data-inert]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tabs/src/useTabListState.ts:TabListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the tab list.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tabs.tsx:TabRenderProps",
      "name": "TabRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tab is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagListRenderProps",
      "name": "TagListRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tag list has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tag list is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tag list is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the TagGroup.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TagGroup.tsx:TagRenderProps",
      "name": "TagRenderProps",
      "properties": {
        "allowsRemoving": {
          "type": "property",
          "name": "allowsRemoving",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tag group allows items to be removed.",
          "selector": "[data-allows-removing]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/TextField.tsx:TextFieldRenderProps",
      "name": "TextFieldRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the text field is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the value is invalid.",
          "selector": "[data-invalid]",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the text field is read only.",
          "selector": "[data-readonly]",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the text field is required.",
          "selector": "[data-required]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast",
      "name": "QueuedToast",
      "properties": {
        "content": {
          "type": "property",
          "name": "content",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": false,
          "description": "The content of the toast.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A unique key for the toast.",
          "default": null
        },
        "timer": {
          "type": "property",
          "name": "timer",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:Timer"
          },
          "optional": true,
          "description": "A timer for the toast, if a timeout was set.",
          "default": null
        },
        "onClose": {
          "type": "property",
          "name": "onClose",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the toast is closed, either by the user or after a timeout.",
          "default": null
        },
        "timeout": {
          "type": "property",
          "name": "timeout",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "A timeout to automatically close the toast after, in milliseconds.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:Timer": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:Timer",
      "name": "Timer",
      "properties": {
        "timerId": {
          "type": "property",
          "name": "timerId",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "startTime": {
          "type": "property",
          "name": "startTime",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "remaining": {
          "type": "property",
          "name": "remaining",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "callback": {
          "type": "property",
          "name": "callback",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "callback",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "delay",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "reset": {
          "type": "method",
          "name": "reset",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "delay",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "pause": {
          "type": "method",
          "name": "pause",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "resume": {
          "type": "method",
          "name": "resume",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRenderProps",
      "name": "ToastRenderProps",
      "properties": {
        "toast": {
          "type": "property",
          "name": "toast",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": false,
          "description": "The toast object to display.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps",
      "name": "ToastRegionRenderProps",
      "properties": {
        "visibleToasts": {
          "type": "property",
          "name": "visibleToasts",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "A list of all currently visible toasts.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast region is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast region is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast region is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastQueue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastQueue",
      "name": "ToastQueue",
      "properties": {
        "queue": {
          "type": "property",
          "name": "queue",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "subscriptions": {
          "type": "property",
          "name": "subscriptions",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "function",
                "parameters": [],
                "return": {
                  "type": "void"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "maxVisibleToasts": {
          "type": "property",
          "name": "maxVisibleToasts",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "wrapUpdate": {
          "type": "property",
          "name": "wrapUpdate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fn",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "action",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastAction"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "visibleToasts": {
          "type": "property",
          "name": "visibleToasts",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "The currently visible toasts.",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastStateProps"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "runWithWrapUpdate": {
          "type": "method",
          "name": "runWithWrapUpdate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fn",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "action",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastAction"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "subscribe": {
          "type": "method",
          "name": "subscribe",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fn",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void"
              },
              "typeParameters": [],
              "description": null
            },
            "typeParameters": []
          },
          "description": "Subscribes to updates to the visible toasts.",
          "default": null,
          "static": false
        },
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "content",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Adds a new toast to the queue.",
          "default": null,
          "static": false
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Closes a toast.",
          "default": null,
          "static": false
        },
        "updateVisibleToasts": {
          "type": "method",
          "name": "updateVisibleToasts",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "action",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastAction"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "pauseAll": {
          "type": "method",
          "name": "pauseAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Pauses the timers for all visible toasts.",
          "default": null,
          "static": false
        },
        "resumeAll": {
          "type": "method",
          "name": "resumeAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Resumes the timers for all visible toasts.",
          "default": null,
          "static": false
        },
        "clear": {
          "type": "method",
          "name": "clear",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": [],
      "description": "A ToastQueue manages the order of toasts."
    },
    "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastAction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastAction",
      "name": "ToastAction",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "add"
          },
          {
            "type": "string",
            "value": "remove"
          },
          {
            "type": "string",
            "value": "clear"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastStateProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastStateProps",
      "name": "ToastStateProps",
      "properties": {
        "maxVisibleToasts": {
          "type": "property",
          "name": "maxVisibleToasts",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of toasts to display at a time.",
          "default": null
        },
        "wrapUpdate": {
          "type": "property",
          "name": "wrapUpdate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fn",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "action",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastAction"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Function to wrap updates in (i.e. document.startViewTransition()).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:ToastOptions",
      "name": "ToastOptions",
      "properties": {
        "onClose": {
          "type": "property",
          "name": "onClose",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the toast is closed, either by the user or after a timeout.",
          "default": null
        },
        "timeout": {
          "type": "property",
          "name": "timeout",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "A timeout to automatically close the toast after, in milliseconds.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButton.tsx:ToggleButtonRenderProps",
      "name": "ToggleButtonRenderProps",
      "properties": {
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleState.ts:ToggleState"
          },
          "optional": false,
          "description": "State of the toggle button.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is focused, either via a mouse or keyboard.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the button is disabled.",
          "selector": "[data-disabled]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/ToggleButtonGroup.tsx:ToggleButtonGroupRenderProps",
      "name": "ToggleButtonGroupRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toggle button group is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleGroupState.ts:ToggleGroupState"
          },
          "optional": false,
          "description": "State of the toggle button group.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleGroupState.ts:ToggleGroupState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toggle/src/useToggleGroupState.ts:ToggleGroupState",
      "name": "ToggleGroupState",
      "properties": {
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "single"
              },
              {
                "type": "string",
                "value": "multiple"
              }
            ]
          },
          "optional": false,
          "description": "Whether single or multiple selection is enabled.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether all items are disabled.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for items that are selected.",
          "default": null
        },
        "toggleKey": {
          "type": "method",
          "name": "toggleKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the selected state for an item by its key.",
          "default": null
        },
        "setSelected": {
          "type": "method",
          "name": "setSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "isSelected",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the given key is selected.",
          "default": null
        },
        "setSelectedKeys": {
          "type": "method",
          "name": "setSelectedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the set of selected keys.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toolbar.tsx:ToolbarRenderProps",
      "name": "ToolbarRenderProps",
      "properties": {
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": false,
          "description": "The current orientation of the toolbar.",
          "selector": "[data-orientation]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipRenderProps",
      "name": "TooltipRenderProps",
      "properties": {
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The placement of the tooltip relative to the trigger.",
          "selector": "[data-placement=\"left | right | top | bottom\"]",
          "default": null
        },
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tooltip is currently entering. Use this to apply animations.",
          "selector": "[data-entering]",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tooltip is currently exiting. Use this to apply animations.",
          "selector": "[data-exiting]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/tooltip/src/useTooltipTriggerState.ts:TooltipTriggerState"
          },
          "optional": false,
          "description": "State of the tooltip.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/tooltip/src/useTooltipTriggerState.ts:TooltipTriggerState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/tooltip/src/useTooltipTriggerState.ts:TooltipTriggerState",
      "name": "TooltipTriggerState",
      "properties": {
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tooltip is currently showing.",
          "default": null
        },
        "open": {
          "type": "method",
          "name": "open",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "immediate",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Shows the tooltip. By default, the tooltip becomes visible after a delay\ndepending on a global warmup timer. The `immediate` option shows the\ntooltip immediately instead.",
          "default": null
        },
        "close": {
          "type": "method",
          "name": "close",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "immediate",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Hides the tooltip.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeLoadMoreItemRenderProps",
      "name": "TreeLoadMoreItemRenderProps",
      "properties": {
        "level": {
          "type": "property",
          "name": "level",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "What level the tree item has within the tree.",
          "selector": "[data-level]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeEmptyStateRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeEmptyStateRenderProps",
      "name": "TreeEmptyStateRenderProps",
      "properties": {
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the tree.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState",
      "name": "TreeState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the tree.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for items that are disabled.",
          "default": null
        },
        "expandedKeys": {
          "type": "property",
          "name": "expandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for items that are expanded.",
          "default": null
        },
        "toggleKey": {
          "type": "method",
          "name": "toggleKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the expanded state for an item by its key.",
          "default": null
        },
        "setExpandedKeys": {
          "type": "method",
          "name": "setExpandedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the set of expanded keys.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeRenderProps",
      "name": "TreeRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the tree.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeItemRenderProps",
      "name": "TreeItemRenderProps",
      "properties": {
        "isExpanded": {
          "type": "property",
          "name": "isExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree item is expanded.",
          "selector": "[data-expanded]",
          "default": null
        },
        "hasChildItems": {
          "type": "property",
          "name": "hasChildItems",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree item has child tree items.",
          "selector": "[data-has-child-items]",
          "default": null
        },
        "level": {
          "type": "property",
          "name": "level",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "What level the tree item has within the tree.",
          "selector": "[data-level=\"number\"]",
          "default": null
        },
        "isFocusVisibleWithin": {
          "type": "property",
          "name": "isFocusVisibleWithin",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree item's children have keyboard focus.",
          "selector": "[data-focus-visible-within]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "The state of the tree.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "description": "The unique id of the tree row.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently selected.",
          "selector": "[data-selected]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is non-interactive, i.e. both selection and actions are disabled and the item may\nnot be focused. Dependent on `disabledKeys` and `disabledBehavior`.",
          "selector": "[data-disabled]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently being dragged.",
          "selector": "[data-dragging]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is currently an active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrag.ts:DragOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrag.ts:DragOptions",
      "name": "DragOptions",
      "properties": {
        "onDragStart": {
          "type": "property",
          "name": "onDragStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragStartEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a drag operation is started.",
          "default": null
        },
        "onDragMove": {
          "type": "property",
          "name": "onDragMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag is moved.",
          "default": null
        },
        "onDragEnd": {
          "type": "property",
          "name": "onDragEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragEndEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag operation is ended, either as a result of a drop or a cancellation.",
          "default": null
        },
        "getItems": {
          "type": "property",
          "name": "getItems",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
              }
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "A function that returns the items being dragged.",
          "default": null
        },
        "preview": {
          "type": "property",
          "name": "preview",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref of the element that will be rendered as the drag preview while dragging.",
          "default": null
        },
        "getAllowedDropOperations": {
          "type": "property",
          "name": "getAllowedDropOperations",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
              }
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Function that returns the drop operations that are allowed for the dragged items. If not provided, all drop operations are allowed.",
          "default": null
        },
        "hasDragButton": {
          "type": "property",
          "name": "hasDragButton",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item has an explicit focusable drag affordance to initiate accessible drag and drop mode.\nIf true, the dragProps will omit these event handlers, and they will be applied to dragButtonProps instead.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drag operation is disabled. If true, the element will not be draggable.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragEndEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragEndEvent",
      "name": "DragEndEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragend"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that occurred.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrag.ts:DragResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrag.ts:DragResult",
      "name": "DragResult",
      "properties": {
        "dragProps": {
          "type": "property",
          "name": "dragProps",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "HTMLAttributes"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          },
          "optional": false,
          "description": "Props for the draggable element.",
          "default": null
        },
        "dragButtonProps": {
          "type": "property",
          "name": "dragButtonProps",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/button/src/index.d.ts:AriaButtonProps"
          },
          "optional": false,
          "description": "Props for the explicit drag button affordance, if any.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the element is currently being dragged.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrop.ts:DropOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrop.ts:DropOptions",
      "name": "DropOptions",
      "properties": {
        "ref": {
          "type": "property",
          "name": "ref",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A ref for the droppable element.",
          "default": null
        },
        "getDropOperation": {
          "type": "property",
          "name": "getDropOperation",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "allowedOperations",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
          "default": null
        },
        "getDropOperationForPoint": {
          "type": "property",
          "name": "getDropOperationForPoint",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "allowedOperations",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                  }
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns the drop operation for a specific point within the target.",
          "default": null
        },
        "onDropEnter": {
          "type": "property",
          "name": "onDropEnter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEnterEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag enters the drop target.",
          "default": null
        },
        "onDropMove": {
          "type": "property",
          "name": "onDropMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is moved within the drop target.",
          "default": null
        },
        "onDropActivate": {
          "type": "property",
          "name": "onDropActivate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropActivateEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called after a valid drag is held over the drop target for a period of time.\nThis typically opens the item so that the user can drop within it.",
          "default": null
        },
        "onDropExit": {
          "type": "property",
          "name": "onDropExit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropExitEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag exits the drop target.",
          "default": null
        },
        "onDrop": {
          "type": "property",
          "name": "onDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is dropped on the drop target.",
          "default": null
        },
        "hasDropButton": {
          "type": "property",
          "name": "hasDropButton",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item has an explicit focusable drop affordance to initiate accessible drag and drop mode.\nIf true, the dropProps will omit these event handlers, and they will be applied to dropButtonProps instead.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drop target is disabled. If true, the drop target will not accept any drops.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrop.ts:DropResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDrop.ts:DropResult",
      "name": "DropResult",
      "properties": {
        "dropProps": {
          "type": "property",
          "name": "dropProps",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:DOMAttributes"
          },
          "optional": false,
          "description": "Props for the droppable element.",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drop target is currently focused or hovered.",
          "default": null
        },
        "dropButtonProps": {
          "type": "property",
          "name": "dropButtonProps",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/button/src/index.d.ts:AriaButtonProps"
          },
          "optional": true,
          "description": "Props for the explicit drop button affordance, if any.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:DOMAttributes": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:DOMAttributes",
      "name": "DOMAttributes",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "AriaRole"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "tabIndex": {
          "type": "property",
          "name": "tabIndex",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "CSSProperties"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
          }
        }
      ],
      "extends": [
        {
          "type": "identifier",
          "name": "AriaAttributes"
        },
        {
          "type": "identifier",
          "name": "ReactDOMAttributes"
        }
      ],
      "description": "All DOM attributes supported across both HTML and SVG elements."
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropOptions",
      "name": "DragAndDropOptions",
      "properties": {
        "getItems": {
          "type": "property",
          "name": "getItems",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "items",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "identifier",
                    "name": "T"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
              }
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns the items being dragged. If not specified, we assume that the collection is not draggable.",
          "default": "() => []"
        },
        "renderDragPreview": {
          "type": "property",
          "name": "renderDragPreview",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "items",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "JSX.Element"
                },
                {
                  "type": "object",
                  "properties": {
                    "element": {
                      "type": "property",
                      "name": "element",
                      "indexType": null,
                      "value": {
                        "type": "identifier",
                        "name": "JSX.Element"
                      },
                      "optional": false,
                      "default": null
                    },
                    "x": {
                      "type": "property",
                      "name": "x",
                      "indexType": null,
                      "value": {
                        "type": "number"
                      },
                      "optional": false,
                      "default": null
                    },
                    "y": {
                      "type": "property",
                      "name": "y",
                      "indexType": null,
                      "value": {
                        "type": "number"
                      },
                      "optional": false,
                      "default": null
                    }
                  }
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that renders a drag preview, which is shown under the user's cursor while dragging.\nBy default, a copy of the dragged element is rendered.",
          "default": null
        },
        "renderDropIndicator": {
          "type": "property",
          "name": "renderDropIndicator",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "JSX.Element",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that renders a drop indicator element between two items in a collection.\nThis should render a `<DropIndicator>` element. If this function is not provided, a\ndefault DropIndicator is provided.",
          "default": null
        },
        "dropTargetDelegate": {
          "type": "property",
          "name": "dropTargetDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate"
          },
          "optional": true,
          "description": "A custom delegate object that provides drop targets for pointer coordinates within the collection.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drag and drop events should be disabled.",
          "default": null
        },
        "onDragStart": {
          "type": "property",
          "name": "onDragStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionStartEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a drag operation is started.",
          "default": null
        },
        "onDragMove": {
          "type": "property",
          "name": "onDragMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag is moved.",
          "default": null
        },
        "onDragEnd": {
          "type": "property",
          "name": "onDragEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag operation is ended, either as a result of a drop or a cancellation.",
          "default": null
        },
        "getAllowedDropOperations": {
          "type": "property",
          "name": "getAllowedDropOperations",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
              }
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Function that returns the drop operations that are allowed for the dragged items. If not provided, all drop operations are allowed.",
          "default": null
        },
        "acceptedDragTypes": {
          "type": "property",
          "name": "acceptedDragTypes",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Array"
                },
                "typeParameters": [
                  {
                    "type": "union",
                    "elements": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "symbol"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The drag types that the droppable collection accepts. If the collection accepts directories, include `DIRECTORY_DRAG_TYPE` in your array of allowed types.",
          "default": "'all'"
        },
        "onInsert": {
          "type": "property",
          "name": "onInsert",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped \"between\" items.",
          "default": null
        },
        "onRootDrop": {
          "type": "property",
          "name": "onRootDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped on the droppable collection's root.",
          "default": null
        },
        "onItemDrop": {
          "type": "property",
          "name": "onItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are dropped \"on\" an item.",
          "default": null
        },
        "onReorder": {
          "type": "property",
          "name": "onReorder",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are reordered within the collection.\nThis handler only allows dropping between items, not on items.\nIt does not allow moving items to a different parent item within a tree.",
          "default": null
        },
        "onMove": {
          "type": "property",
          "name": "onMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are moved within the source collection.\nThis handler allows dropping both on or between items, and items may be\nmoved to a different parent item within a tree.",
          "default": null
        },
        "shouldAcceptItemDrop": {
          "type": "property",
          "name": "shouldAcceptItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning whether a given target in the droppable collection is a valid \"on\" drop target for the current drag types.",
          "default": null
        },
        "onDropEnter": {
          "type": "property",
          "name": "onDropEnter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag enters a drop target.",
          "default": null
        },
        "onDropActivate": {
          "type": "property",
          "name": "onDropActivate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionActivateEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called after a valid drag is held over a drop target for a period of time.",
          "default": null
        },
        "onDropExit": {
          "type": "property",
          "name": "onDropExit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag exits a drop target.",
          "default": null
        },
        "onDrop": {
          "type": "property",
          "name": "onDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is dropped on a drop target. When defined, this overrides other\ndrop handlers such as `onInsert`, and `onItemDrop`.",
          "default": null
        },
        "getDropOperation": {
          "type": "property",
          "name": "getDropOperation",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "allowedOperations",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDrop": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDrop",
      "name": "DragAndDrop",
      "properties": {
        "dragAndDropHooks": {
          "type": "property",
          "name": "dragAndDropHooks",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": false,
          "description": "Drag and drop hooks for the collection element.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/DragAndDrop.tsx:DropIndicatorRenderProps",
      "name": "DropIndicatorRenderProps",
      "properties": {
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drop indicator is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:LayoutClass": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:LayoutClass",
      "name": "LayoutClass",
      "properties": {
        "undefined": {
          "type": "any"
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "O",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:ILayout": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Virtualizer.tsx:ILayout",
      "name": "ILayout",
      "properties": {
        "virtualizer": {
          "type": "property",
          "name": "virtualizer",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Virtualizer.ts:Virtualizer"
                },
                "typeParameters": [
                  {
                    "type": "object",
                    "properties": null
                  },
                  {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The Virtualizer the layout is currently attached to.",
          "default": null
        },
        "getVisibleLayoutInfos": {
          "type": "method",
          "name": "getVisibleLayoutInfos",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle that should contain the returned LayoutInfo objects."
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
              }
            },
            "typeParameters": []
          },
          "description": "Returns an array of `LayoutInfo` objects which are inside the given rectangle.\nShould be implemented by subclasses.",
          "default": null,
          "static": false,
          "abstract": true
        },
        "getLayoutInfo": {
          "type": "method",
          "name": "getLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": "The key of the LayoutInfo to retrieve."
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns a `LayoutInfo` for the given key.\nShould be implemented by subclasses.",
          "default": null,
          "static": false,
          "abstract": true
        },
        "getContentSize": {
          "type": "method",
          "name": "getContentSize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
            },
            "typeParameters": []
          },
          "description": "Returns size of the content. By default, it returns virtualizer's size.",
          "default": null,
          "static": false,
          "abstract": true
        },
        "shouldInvalidate": {
          "type": "method",
          "name": "shouldInvalidate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldRect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the layout should invalidate in response to\nvisible rectangle changes. By default, it only invalidates\nwhen the virtualizer's size changes. Return true always\nto make the layout invalidate while scrolling (e.g. sticky headers).",
          "default": null,
          "static": false
        },
        "shouldInvalidateLayoutOptions": {
          "type": "method",
          "name": "shouldInvalidateLayoutOptions",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "newOptions",
                "value": {
                  "type": "identifier",
                  "name": "O"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "oldOptions",
                "value": {
                  "type": "identifier",
                  "name": "O"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the layout should invalidate when the layout options change.\nBy default it invalidates when the object identity changes. Override this\nmethod to optimize layout updates based on specific option changes.",
          "default": null,
          "static": false
        },
        "update": {
          "type": "method",
          "name": "update",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "invalidationContext",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "InvalidationContext"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "O"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "This method allows the layout to perform any pre-computation\nit needs to in order to prepare LayoutInfos for retrieval.\nCalled by the virtualizer before `getVisibleLayoutInfos`\nor `getLayoutInfo` are called.",
          "default": null,
          "static": false
        },
        "updateItemSize": {
          "type": "method",
          "name": "updateItemSize",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "size",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Updates the size of the given item.",
          "default": null,
          "static": false
        },
        "getDropTargetLayoutInfo": {
          "type": "method",
          "name": "getDropTargetLayoutInfo",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/LayoutInfo.ts:LayoutInfo"
            },
            "typeParameters": []
          },
          "description": "Returns a `LayoutInfo` for the given drop target.",
          "default": null,
          "static": false
        },
        "getItemRect": {
          "type": "method",
          "name": "getItemRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getVisibleRect": {
          "type": "method",
          "name": "getVisibleRect",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "useLayoutOptions": {
          "type": "method",
          "name": "useLayoutOptions",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "identifier",
              "name": "O"
            },
            "typeParameters": []
          },
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "O",
          "constraint": null,
          "default": null
        }
      ],
      "extends": [
        {
          "type": "identifier",
          "name": "Partial"
        }
      ]
    },
    "/home/circleci/react-spectrum/packages/@react-aria/i18n/src/useDefaultLocale.ts:Locale": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/i18n/src/useDefaultLocale.ts:Locale",
      "name": "Locale",
      "properties": {
        "locale": {
          "type": "property",
          "name": "locale",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The [BCP47](https://www.ietf.org/rfc/bcp/bcp47.txt) language code for the locale.",
          "default": null
        },
        "direction": {
          "type": "property",
          "name": "direction",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/locale.d.ts:Direction"
          },
          "optional": false,
          "description": "The writing direction for the locale.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/locale.d.ts:Direction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/locale.d.ts:Direction",
      "name": "Direction",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "ltr"
          },
          {
            "type": "string",
            "value": "rtl"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-aria/i18n/src/useFilter.ts:Filter": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/i18n/src/useFilter.ts:Filter",
      "name": "Filter",
      "properties": {
        "startsWith": {
          "type": "method",
          "name": "startsWith",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "string",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "substring",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether a string starts with a given substring.",
          "default": null
        },
        "endsWith": {
          "type": "method",
          "name": "endsWith",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "string",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "substring",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether a string ends with a given substring.",
          "default": null
        },
        "contains": {
          "type": "method",
          "name": "contains",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "string",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "substring",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether a string contains a given substring.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/layout/src/GridLayout.ts:GridLayoutOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/GridLayout.ts:GridLayoutOptions",
      "name": "GridLayoutOptions",
      "properties": {
        "minItemSize": {
          "type": "property",
          "name": "minItemSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The minimum item size.",
          "default": "200 x 200"
        },
        "maxItemSize": {
          "type": "property",
          "name": "maxItemSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The maximum item size.",
          "default": "Infinity"
        },
        "preserveAspectRatio": {
          "type": "property",
          "name": "preserveAspectRatio",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to preserve the aspect ratio of the `minItemSize`.\nBy default, grid rows may have variable heights. When `preserveAspectRatio`\nis true, all rows will have equal heights.",
          "default": "false"
        },
        "minSpace": {
          "type": "property",
          "name": "minSpace",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The minimum space required between items.",
          "default": "18 x 18"
        },
        "maxHorizontalSpace": {
          "type": "property",
          "name": "maxHorizontalSpace",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum allowed horizontal space between items.",
          "default": "Infinity"
        },
        "maxColumns": {
          "type": "property",
          "name": "maxColumns",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of columns.",
          "default": "Infinity"
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The thickness of the drop indicator.",
          "default": "2"
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutInfo": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutInfo",
      "name": "WaterfallLayoutInfo",
      "properties": {
        "column": {
          "type": "property",
          "name": "column",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "default": null
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutInfo"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The type of element represented by this LayoutInfo. Should match the `type` of the corresponding collection node.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "description": "A unique key for this LayoutInfo. Should match the `key` of the corresponding collection node.",
          "default": null
        },
        "parentKey": {
          "type": "property",
          "name": "parentKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The key for a parent LayoutInfo, if any.",
          "default": null
        },
        "content": {
          "type": "property",
          "name": "content",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "id": null,
                "name": null,
                "type": "any"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Content for this item if it was generated by the layout rather than coming from the Collection.",
          "default": null
        },
        "rect": {
          "type": "property",
          "name": "rect",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
          },
          "optional": false,
          "description": "The rectangle describing the size and position of this element.",
          "default": null
        },
        "estimatedSize": {
          "type": "property",
          "name": "estimatedSize",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the size is estimated. `false` by default.\nItems with estimated sizes will be measured the first time they are added to the DOM.\nThe estimated size is used to calculate the size and position of the scrollbar.",
          "default": "false"
        },
        "isSticky": {
          "type": "property",
          "name": "isSticky",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the layout info sticks to the viewport when scrolling.",
          "default": "false"
        },
        "opacity": {
          "type": "property",
          "name": "opacity",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The element's opacity.",
          "default": "1"
        },
        "transform": {
          "type": "property",
          "name": "transform",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "A CSS transform string to apply to the element. `null` by default.",
          "default": null
        },
        "zIndex": {
          "type": "property",
          "name": "zIndex",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The z-index of the element. 0 by default.",
          "default": null
        },
        "allowOverflow": {
          "type": "property",
          "name": "allowOverflow",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the element allows its contents to overflow its container.",
          "default": "false"
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": "The type of element represented by this LayoutInfo. Should match the `type` of the corresponding collection node."
              },
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": "A unique key for this LayoutInfo. Should match the `key` of the corresponding collection node."
              },
              {
                "type": "parameter",
                "name": "rect",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Rect.ts:Rect"
                },
                "rest": false,
                "description": "The rectangle describing the size and position of this element."
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/layout/src/WaterfallLayout.ts:WaterfallLayoutOptions",
      "name": "WaterfallLayoutOptions",
      "properties": {
        "minItemSize": {
          "type": "property",
          "name": "minItemSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The minimum item size.",
          "default": "200 x 200"
        },
        "maxItemSize": {
          "type": "property",
          "name": "maxItemSize",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The maximum item size.",
          "default": "Infinity"
        },
        "minSpace": {
          "type": "property",
          "name": "minSpace",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/virtualizer/src/Size.ts:Size"
          },
          "optional": true,
          "description": "The minimum space required between items.",
          "default": "18 x 18"
        },
        "maxHorizontalSpace": {
          "type": "property",
          "name": "maxHorizontalSpace",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum allowed horizontal space between items.",
          "default": "Infinity"
        },
        "maxColumns": {
          "type": "property",
          "name": "maxColumns",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of columns.",
          "default": "Infinity"
        },
        "dropIndicatorThickness": {
          "type": "property",
          "name": "dropIndicatorThickness",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The thickness of the drop indicator.",
          "default": "2"
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:CollectionRootProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:CollectionRootProps",
      "name": "CollectionRootProps",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The collection of items to render.",
          "default": null
        },
        "persistedKeys": {
          "type": "property",
          "name": "persistedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Set"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A set of keys for items that should always be persisted in the DOM.",
          "default": null
        },
        "scrollRef": {
          "type": "property",
          "name": "scrollRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref to the scroll container for the collection.",
          "default": null
        },
        "renderDropIndicator": {
          "type": "property",
          "name": "renderDropIndicator",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that renders a drop indicator between items.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "HTMLAttributes"
        }
      ]
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:CollectionBranchProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Collection.tsx:CollectionBranchProps",
      "name": "CollectionBranchProps",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The collection of items to render.",
          "default": null
        },
        "parent": {
          "type": "property",
          "name": "parent",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "The parent node of the items to render.",
          "default": null
        },
        "renderDropIndicator": {
          "type": "property",
          "name": "renderDropIndicator",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that renders a drop indicator between items.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    }
  }
};

},{}],"iQPne":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactAriaLogo", ()=>ReactAriaLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ReactAriaLogo = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 160 160",
        className: " Jy111 Gy111 Iy111 Hy111 Fv111 Zw111",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M80 136c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56Zm8.48-86.3c0 4.69-3.8 8.48-8.48 8.48s-8.48-3.8-8.48-8.48 3.8-8.48 8.48-8.48 8.48 3.8 8.48 8.48ZM51.09 61.78c.52-1.8 2.39-2.85 4.2-2.33a89.865 89.865 0 0 0 48.82.17l.64-.18c1.81-.5 3.68.55 4.18 2.36a3.39 3.39 0 0 1-2.36 4.18l-.64.18a97.139 97.139 0 0 1-15.51 2.98c-1.03.11-1.82.97-1.82 2.01v14.89c0 .18.03.37.08.55 1.37 4.83 2.94 10.39 4.32 15.27.98 3.46 1.86 6.58 2.49 8.85.32 1.14.58 2.06.76 2.71l.04.15c.13.48.27.97.31 1.16a3.38 3.38 0 0 1-2.66 3.99 3.38 3.38 0 0 1-3.99-2.66c.02.09 0 .04-.08-.27-.04-.13-.09-.31-.15-.54-.18-.65-.44-1.57-.76-2.7-.64-2.27-1.52-5.39-2.49-8.85l-3.74-13.21a1.992 1.992 0 0 0-1.92-1.45h-1.6c-.89 0-1.68.59-1.92 1.45-1.22 4.3-2.55 9.01-3.74 13.21-.98 3.46-1.85 6.58-2.49 8.85-.32 1.13-.58 2.06-.76 2.7-.06.23-.11.41-.15.54-.09.31-.1.36-.08.27a3.39 3.39 0 1 1-6.65-1.33c.04-.18.18-.68.31-1.16l.04-.15c.18-.65.44-1.58.76-2.71.64-2.27 1.52-5.39 2.49-8.85 1.38-4.88 2.95-10.44 4.32-15.27.05-.18.08-.36.08-.55V71.16c0-1.04-.79-1.9-1.82-2.01a96.504 96.504 0 0 1-16.17-3.17 3.395 3.395 0 0 1-2.33-4.2Z",
                        style: {
                            fill: 'none'
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 80,
                cy: 80,
                r: 50.83,
                style: {
                    fill: '#fff'
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                style: {
                    clipPath: 'url(#a)'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M15.79 17.64H147v126.14H15.79z",
                    style: {
                        fill: '#269ff4'
                    }
                })
            })
        ]
    });
};

},{"0":"1VYz8","react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1VYz8":[function() {},{}],"lTyTL":[function(require,module,exports,__globalThis) {
module.exports = {
  "exports": {
    "Accordion": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Accordion.tsx:Accordion",
      "name": "Accordion",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Accordion.tsx:AccordionProps",
        "name": "AccordionProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "React.ReactNode"
            },
            "optional": false,
            "description": "The disclosure elements in the accordion.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the accordion.",
            "default": "'M'"
          },
          "density": {
            "type": "property",
            "name": "density",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "compact"
                },
                {
                  "type": "string",
                  "value": "regular"
                },
                {
                  "type": "string",
                  "value": "spacious"
                }
              ]
            },
            "optional": true,
            "description": "The amount of space between the disclosure items.",
            "default": "'regular'"
          },
          "isQuiet": {
            "type": "property",
            "name": "isQuiet",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the accordion should be displayed with a quiet style.",
            "default": null
          },
          "allowsMultipleExpanded": {
            "type": "property",
            "name": "allowsMultipleExpanded",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether multiple items can be expanded at the same time.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether all items are disabled.",
            "default": null
          },
          "expandedKeys": {
            "type": "property",
            "name": "expandedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "optional": true,
            "description": "The currently expanded keys in the group (controlled).",
            "default": null
          },
          "defaultExpandedKeys": {
            "type": "property",
            "name": "defaultExpandedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "optional": true,
            "description": "The initial expanded keys in the group (uncontrolled).",
            "default": null
          },
          "onExpandedChange": {
            "type": "property",
            "name": "onExpandedChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Set"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when items are expanded or collapsed.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "An accordion is a container for multiple disclosures."
    },
    "AccordionContext": {
      "type": "any"
    },
    "ActionBar": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionBar.tsx:ActionBar",
      "name": "ActionBar",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionBar.tsx:ActionBarProps",
        "name": "ActionBarProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "A list of ActionButtons to display.",
            "default": null
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the ActionBar should be displayed with a emphasized style.",
            "default": null
          },
          "selectedItemCount": {
            "type": "property",
            "name": "selectedItemCount",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number"
                },
                {
                  "type": "string",
                  "value": "all"
                }
              ]
            },
            "optional": true,
            "description": "The number of selected items that the ActionBar is currently linked to. If 0, the ActionBar is hidden.",
            "default": null
          },
          "onClearSelection": {
            "type": "property",
            "name": "onClearSelection",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the ActionBar clear button is pressed.",
            "default": null
          },
          "scrollRef": {
            "type": "property",
            "name": "scrollRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "A ref to the scrollable element the ActionBar appears above.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "ActionBarContext": {
      "type": "any"
    },
    "ActionButton": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionButton.tsx:ActionButton",
      "name": "ActionButton",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionButton.tsx:ActionButtonProps",
        "name": "ActionButtonProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the ActionButton.",
            "default": null
          },
          "isPending": {
            "type": "property",
            "name": "isPending",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button is in a pending state. This disables press and hover events\nwhile retaining focusability, and announces the pending state to screen readers.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button is disabled.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "aria-disabled": {
            "type": "property",
            "name": "aria-disabled",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether the element is disabled to users of assistive technology.",
            "default": null
          },
          "aria-expanded": {
            "type": "property",
            "name": "aria-expanded",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
            "default": null
          },
          "aria-haspopup": {
            "type": "property",
            "name": "aria-haspopup",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "menu"
                },
                {
                  "type": "string",
                  "value": "listbox"
                },
                {
                  "type": "string",
                  "value": "tree"
                },
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "dialog"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "aria-pressed": {
            "type": "property",
            "name": "aria-pressed",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "mixed"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the current \"pressed\" state of toggle buttons.",
            "default": null
          },
          "aria-current": {
            "type": "property",
            "name": "aria-current",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "page"
                },
                {
                  "type": "string",
                  "value": "step"
                },
                {
                  "type": "string",
                  "value": "location"
                },
                {
                  "type": "string",
                  "value": "date"
                },
                {
                  "type": "string",
                  "value": "time"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether this element represents the current item within a container or set of related elements.",
            "default": null
          },
          "type": {
            "type": "property",
            "name": "type",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "button"
                },
                {
                  "type": "string",
                  "value": "submit"
                },
                {
                  "type": "string",
                  "value": "reset"
                }
              ]
            },
            "optional": true,
            "description": "The behavior of the button when used in an HTML form.",
            "default": "'button'"
          },
          "preventFocusOnPress": {
            "type": "property",
            "name": "preventFocusOnPress",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/button#form).",
            "default": null
          },
          "formAction": {
            "type": "property",
            "name": "formAction",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
            "default": null
          },
          "formEncType": {
            "type": "property",
            "name": "formEncType",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Indicates how to encode the form data that is submitted.",
            "default": null
          },
          "formMethod": {
            "type": "property",
            "name": "formMethod",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Indicates the HTTP method used to submit the form.",
            "default": null
          },
          "formNoValidate": {
            "type": "property",
            "name": "formNoValidate",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Indicates that the form is not to be validated when it is submitted.",
            "default": null
          },
          "formTarget": {
            "type": "property",
            "name": "formTarget",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Overrides the target attribute of the button's form owner.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Submitted as a pair with the button's value as part of the form data.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value associated with the button's name when it's submitted with the form data.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the ActionButton.",
            "default": "'M'"
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "The static color style to apply. Useful when the ActionButton appears over a color background.",
            "default": null
          },
          "isQuiet": {
            "type": "property",
            "name": "isQuiet",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLButtonElement"
          }
        ]
      },
      "description": "ActionButtons allow users to perform an action.\nThey're used for similar, task-based options within a workflow, and are ideal for interfaces where buttons aren't meant to draw a lot of attention."
    },
    "ActionButtonContext": {
      "type": "any"
    },
    "ActionButtonGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionButtonGroup.tsx:ActionButtonGroup",
      "name": "ActionButtonGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionButtonGroup.tsx:ActionButtonGroupProps",
        "name": "ActionButtonGroupProps",
        "properties": {
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The children of the group.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "Size of the buttons.",
            "default": "\"M\""
          },
          "density": {
            "type": "property",
            "name": "density",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "compact"
                },
                {
                  "type": "string",
                  "value": "regular"
                }
              ]
            },
            "optional": true,
            "description": "Spacing between the buttons.",
            "default": "\"regular\""
          },
          "isQuiet": {
            "type": "property",
            "name": "isQuiet",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
            "default": null
          },
          "isJustified": {
            "type": "property",
            "name": "isJustified",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the buttons should divide the container width equally.",
            "default": null
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
            "default": null
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "horizontal"
                },
                {
                  "type": "string",
                  "value": "vertical"
                }
              ]
            },
            "optional": true,
            "description": "The axis the group should align with.",
            "default": "'horizontal'"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the group is disabled.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "An ActionButtonGroup is a grouping of related ActionButtons."
    },
    "ActionButtonGroupContext": {
      "type": "any"
    },
    "ActionMenu": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionMenu.tsx:ActionMenu",
      "name": "ActionMenu",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionMenu.tsx:ActionMenuProps",
        "name": "ActionMenuProps",
        "properties": {
          "menuSize": {
            "type": "property",
            "name": "menuSize",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "default": null
          },
          "align": {
            "type": "property",
            "name": "align",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "Alignment of the menu relative to the trigger.",
            "default": "'start'"
          },
          "direction": {
            "type": "property",
            "name": "direction",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "bottom"
                },
                {
                  "type": "string",
                  "value": "top"
                },
                {
                  "type": "string",
                  "value": "left"
                },
                {
                  "type": "string",
                  "value": "right"
                },
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "Where the Menu opens relative to its trigger.",
            "default": "'bottom'"
          },
          "shouldFlip": {
            "type": "property",
            "name": "shouldFlip",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the menu should automatically flip direction when space is limited.",
            "default": "true"
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": false,
            "description": "The contents of the collection.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when an item is selected.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button is disabled.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the ActionButton.",
            "default": "'M'"
          },
          "isQuiet": {
            "type": "property",
            "name": "isQuiet",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLButtonElement"
          }
        ]
      },
      "description": "ActionMenu combines an ActionButton with a Menu for simple \"more actions\" use cases."
    },
    "ActionMenuContext": {
      "type": "any"
    },
    "AlertDialog": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/AlertDialog.tsx:AlertDialog",
      "name": "AlertDialog",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/AlertDialog.tsx:AlertDialogProps",
        "name": "AlertDialogProps",
        "properties": {
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "confirmation"
                },
                {
                  "type": "string",
                  "value": "information"
                },
                {
                  "type": "string",
                  "value": "destructive"
                },
                {
                  "type": "string",
                  "value": "error"
                },
                {
                  "type": "string",
                  "value": "warning"
                }
              ]
            },
            "optional": true,
            "description": "The [visual style](https://spectrum.adobe.com/page/alert-dialog/#Options) of the AlertDialog.",
            "default": null
          },
          "title": {
            "type": "property",
            "name": "title",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": false,
            "description": "The title of the AlertDialog.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The contents of the AlertDialog.",
            "default": null
          },
          "cancelLabel": {
            "type": "property",
            "name": "cancelLabel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The label to display within the cancel button.",
            "default": null
          },
          "primaryActionLabel": {
            "type": "property",
            "name": "primaryActionLabel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": false,
            "description": "The label to display within the confirm button.",
            "default": null
          },
          "secondaryActionLabel": {
            "type": "property",
            "name": "secondaryActionLabel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The label to display within the secondary button.",
            "default": null
          },
          "isPrimaryActionDisabled": {
            "type": "property",
            "name": "isPrimaryActionDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the primary button is disabled.",
            "default": null
          },
          "isSecondaryActionDisabled": {
            "type": "property",
            "name": "isSecondaryActionDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the secondary button is disabled.",
            "default": null
          },
          "onCancel": {
            "type": "property",
            "name": "onCancel",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the cancel button is pressed.",
            "default": null
          },
          "onPrimaryAction": {
            "type": "property",
            "name": "onPrimaryAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the primary button is pressed.",
            "default": null
          },
          "onSecondaryAction": {
            "type": "property",
            "name": "onSecondaryAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the secondary button is pressed.",
            "default": null
          },
          "autoFocusButton": {
            "type": "property",
            "name": "autoFocusButton",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "cancel"
                },
                {
                  "type": "string",
                  "value": "primary"
                },
                {
                  "type": "string",
                  "value": "secondary"
                }
              ]
            },
            "optional": true,
            "description": "Button to focus by default when the dialog opens.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Dialog.",
            "default": "'M'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
      },
      "description": "AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge."
    },
    "Avatar": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Avatar.tsx:Avatar",
      "name": "Avatar",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Avatar.tsx:AvatarProps",
        "name": "AvatarProps",
        "properties": {
          "alt": {
            "type": "property",
            "name": "alt",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Text description of the avatar.",
            "default": null
          },
          "src": {
            "type": "property",
            "name": "src",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The image URL for the avatar.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithoutWidth"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number",
                  "value": 16
                },
                {
                  "type": "number",
                  "value": 20
                },
                {
                  "type": "number",
                  "value": 24
                },
                {
                  "type": "number",
                  "value": 28
                },
                {
                  "type": "number",
                  "value": 32
                },
                {
                  "type": "number",
                  "value": 36
                },
                {
                  "type": "number",
                  "value": 40
                },
                {
                  "type": "number",
                  "value": 44
                },
                {
                  "type": "number",
                  "value": 48
                },
                {
                  "type": "number",
                  "value": 56
                },
                {
                  "type": "number",
                  "value": 64
                },
                {
                  "type": "number",
                  "value": 80
                },
                {
                  "type": "number",
                  "value": 96
                },
                {
                  "type": "number",
                  "value": 112
                },
                {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "number"
                    },
                    {
                      "type": "object",
                      "properties": {}
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The size of the avatar.",
            "default": "24"
          },
          "isOverBackground": {
            "type": "property",
            "name": "isOverBackground",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the avatar is over a color background.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLImageElement"
          }
        ]
      },
      "description": "An avatar is a thumbnail representation of an entity, such as a user or an organization."
    },
    "AvatarContext": {
      "type": "any"
    },
    "AvatarGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/AvatarGroup.tsx:AvatarGroup",
      "name": "AvatarGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/AvatarGroup.tsx:AvatarGroupProps",
        "name": "AvatarGroupProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "Avatar children of the avatar group.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The label for the avatar group.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number",
                  "value": 16
                },
                {
                  "type": "number",
                  "value": 20
                },
                {
                  "type": "number",
                  "value": 24
                },
                {
                  "type": "number",
                  "value": 28
                },
                {
                  "type": "number",
                  "value": 32
                },
                {
                  "type": "number",
                  "value": 36
                },
                {
                  "type": "number",
                  "value": 40
                }
              ]
            },
            "optional": true,
            "description": "The size of the avatar group.",
            "default": "24"
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithoutWidth"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "An avatar group is a grouping of avatars that are related to each other."
    },
    "AvatarGroupContext": {
      "type": "any"
    },
    "Badge": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Badge.tsx:Badge",
      "name": "Badge",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Badge.tsx:BadgeProps",
        "name": "BadgeProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the badge.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the badge.",
            "default": "'S'"
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "accent"
                },
                {
                  "type": "string",
                  "value": "informative"
                },
                {
                  "type": "string",
                  "value": "neutral"
                },
                {
                  "type": "string",
                  "value": "positive"
                },
                {
                  "type": "string",
                  "value": "notice"
                },
                {
                  "type": "string",
                  "value": "negative"
                },
                {
                  "type": "string",
                  "value": "gray"
                },
                {
                  "type": "string",
                  "value": "red"
                },
                {
                  "type": "string",
                  "value": "orange"
                },
                {
                  "type": "string",
                  "value": "yellow"
                },
                {
                  "type": "string",
                  "value": "chartreuse"
                },
                {
                  "type": "string",
                  "value": "celery"
                },
                {
                  "type": "string",
                  "value": "green"
                },
                {
                  "type": "string",
                  "value": "seafoam"
                },
                {
                  "type": "string",
                  "value": "cyan"
                },
                {
                  "type": "string",
                  "value": "blue"
                },
                {
                  "type": "string",
                  "value": "indigo"
                },
                {
                  "type": "string",
                  "value": "purple"
                },
                {
                  "type": "string",
                  "value": "fuchsia"
                },
                {
                  "type": "string",
                  "value": "magenta"
                },
                {
                  "type": "string",
                  "value": "pink"
                },
                {
                  "type": "string",
                  "value": "turquoise"
                },
                {
                  "type": "string",
                  "value": "brown"
                },
                {
                  "type": "string",
                  "value": "cinnamon"
                },
                {
                  "type": "string",
                  "value": "silver"
                }
              ]
            },
            "optional": true,
            "description": "The variant changes the background color of the badge. When badge has a semantic meaning, they should use the variant for semantic colors.",
            "default": "'neutral'"
          },
          "fillStyle": {
            "type": "property",
            "name": "fillStyle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "bold"
                },
                {
                  "type": "string",
                  "value": "subtle"
                },
                {
                  "type": "string",
                  "value": "outline"
                }
              ]
            },
            "optional": true,
            "description": "The fill of the badge.",
            "default": "'bold'"
          },
          "overflowMode": {
            "type": "property",
            "name": "overflowMode",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "wrap"
                },
                {
                  "type": "string",
                  "value": "truncate"
                }
              ]
            },
            "optional": true,
            "description": "Sets the text behavior for the contents.",
            "default": "'wrap'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Badges are used for showing a small amount of color-categorized metadata, ideal for getting a user's attention."
    },
    "BadgeContext": {
      "type": "any"
    },
    "Breadcrumbs": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Breadcrumbs.tsx:Breadcrumbs",
      "name": "Breadcrumbs",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Breadcrumbs.tsx:BreadcrumbsProps",
        "name": "BreadcrumbsProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The children of the Breadcrumbs.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the breadcrumbs are disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a breadcrumb is clicked.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLOListElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "Size of the Breadcrumbs including spacing and layout.",
            "default": "'M'"
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLOListElement"
          }
        ]
      },
      "description": "Breadcrumbs show hierarchy and navigational context for a user's location within an application."
    },
    "Breadcrumb": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Breadcrumbs.tsx:Breadcrumb",
      "name": "Breadcrumb",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Breadcrumbs.tsx:BreadcrumbProps",
        "name": "BreadcrumbProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The children of the breadcrumb item.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "A unique id for the breadcrumb, which will be passed to `onAction` when the breadcrumb is pressed.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLLIElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLLIElement"
          }
        ]
      },
      "description": "An individual Breadcrumb for Breadcrumbs."
    },
    "BreadcrumbsContext": {
      "type": "any"
    },
    "Button": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Button.tsx:Button",
      "name": "Button",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Button.tsx:ButtonProps",
        "name": "ButtonProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the Button.",
            "default": null
          },
          "isPending": {
            "type": "property",
            "name": "isPending",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button is in a pending state. This disables press and hover events\nwhile retaining focusability, and announces the pending state to screen readers.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button is disabled.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "aria-disabled": {
            "type": "property",
            "name": "aria-disabled",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether the element is disabled to users of assistive technology.",
            "default": null
          },
          "aria-expanded": {
            "type": "property",
            "name": "aria-expanded",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
            "default": null
          },
          "aria-haspopup": {
            "type": "property",
            "name": "aria-haspopup",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "menu"
                },
                {
                  "type": "string",
                  "value": "listbox"
                },
                {
                  "type": "string",
                  "value": "tree"
                },
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "dialog"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "aria-pressed": {
            "type": "property",
            "name": "aria-pressed",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "mixed"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the current \"pressed\" state of toggle buttons.",
            "default": null
          },
          "aria-current": {
            "type": "property",
            "name": "aria-current",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "page"
                },
                {
                  "type": "string",
                  "value": "step"
                },
                {
                  "type": "string",
                  "value": "location"
                },
                {
                  "type": "string",
                  "value": "date"
                },
                {
                  "type": "string",
                  "value": "time"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether this element represents the current item within a container or set of related elements.",
            "default": null
          },
          "type": {
            "type": "property",
            "name": "type",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "button"
                },
                {
                  "type": "string",
                  "value": "submit"
                },
                {
                  "type": "string",
                  "value": "reset"
                }
              ]
            },
            "optional": true,
            "description": "The behavior of the button when used in an HTML form.",
            "default": "'button'"
          },
          "preventFocusOnPress": {
            "type": "property",
            "name": "preventFocusOnPress",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/button#form).",
            "default": null
          },
          "formAction": {
            "type": "property",
            "name": "formAction",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
            "default": null
          },
          "formEncType": {
            "type": "property",
            "name": "formEncType",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Indicates how to encode the form data that is submitted.",
            "default": null
          },
          "formMethod": {
            "type": "property",
            "name": "formMethod",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Indicates the HTTP method used to submit the form.",
            "default": null
          },
          "formNoValidate": {
            "type": "property",
            "name": "formNoValidate",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Indicates that the form is not to be validated when it is submitted.",
            "default": null
          },
          "formTarget": {
            "type": "property",
            "name": "formTarget",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Overrides the target attribute of the button's form owner.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Submitted as a pair with the button's value as part of the form data.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value associated with the button's name when it's submitted with the form data.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "primary"
                },
                {
                  "type": "string",
                  "value": "secondary"
                },
                {
                  "type": "string",
                  "value": "accent"
                },
                {
                  "type": "string",
                  "value": "negative"
                },
                {
                  "type": "string",
                  "value": "premium"
                },
                {
                  "type": "string",
                  "value": "genai"
                }
              ]
            },
            "optional": true,
            "description": "The [visual style](https://spectrum.adobe.com/page/button/#Options) of the button.",
            "default": "'primary'"
          },
          "fillStyle": {
            "type": "property",
            "name": "fillStyle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "fill"
                },
                {
                  "type": "string",
                  "value": "outline"
                }
              ]
            },
            "optional": true,
            "description": "The background style of the Button.",
            "default": "'fill'"
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Button.",
            "default": "'M'"
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "The static color style to apply. Useful when the Button appears over a color background.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLButtonElement"
          }
        ]
      },
      "description": "Buttons allow users to perform an action.\nThey have multiple styles for various needs, and are ideal for calling attention to\nwhere a user needs to do something in order to move forward in a flow."
    },
    "LinkButton": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Button.tsx:LinkButton",
      "name": "LinkButton",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Button.tsx:LinkButtonProps",
        "name": "LinkButtonProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the Button.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the link is disabled.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "primary"
                },
                {
                  "type": "string",
                  "value": "secondary"
                },
                {
                  "type": "string",
                  "value": "accent"
                },
                {
                  "type": "string",
                  "value": "negative"
                },
                {
                  "type": "string",
                  "value": "premium"
                },
                {
                  "type": "string",
                  "value": "genai"
                }
              ]
            },
            "optional": true,
            "description": "The [visual style](https://spectrum.adobe.com/page/button/#Options) of the button.",
            "default": "'primary'"
          },
          "fillStyle": {
            "type": "property",
            "name": "fillStyle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "fill"
                },
                {
                  "type": "string",
                  "value": "outline"
                }
              ]
            },
            "optional": true,
            "description": "The background style of the Button.",
            "default": "'fill'"
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Button.",
            "default": "'M'"
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "The static color style to apply. Useful when the Button appears over a color background.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLAnchorElement"
          }
        ]
      },
      "description": "A LinkButton combines the functionality of a link with the appearance of a button. Useful for allowing users to navigate to another page."
    },
    "ButtonContext": {
      "type": "any"
    },
    "LinkButtonContext": {
      "type": "any"
    },
    "ButtonGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ButtonGroup.tsx:ButtonGroup",
      "name": "ButtonGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ButtonGroup.tsx:ButtonGroupProps",
        "name": "ButtonGroupProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The Buttons contained within the ButtonGroup.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Buttons in the ButtonGroup are all disabled.",
            "default": null
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "horizontal"
                },
                {
                  "type": "string",
                  "value": "vertical"
                }
              ]
            },
            "optional": true,
            "description": "The axis the ButtonGroup should align with. Setting this to 'vertical' will prevent\nany switching behaviors between 'vertical' and 'horizontal'.",
            "default": "'horizontal'"
          },
          "align": {
            "type": "property",
            "name": "align",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "end"
                },
                {
                  "type": "string",
                  "value": "center"
                }
              ]
            },
            "optional": true,
            "description": "The alignment of the Buttons within the ButtonGroup.",
            "default": "'start'"
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Buttons within the ButtonGroup.",
            "default": "'M'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "ButtonGroup handles overflow for a grouping of buttons whose actions are related to each other."
    },
    "ButtonGroupContext": {
      "type": "any"
    },
    "Calendar": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Calendar.tsx:Calendar",
      "name": "Calendar",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Calendar.tsx:CalendarProps",
        "name": "CalendarProps",
        "properties": {
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The error message to display when the calendar is invalid.",
            "default": null
          },
          "visibleMonths": {
            "type": "property",
            "name": "visibleMonths",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The number of months to display at once.",
            "default": "1"
          },
          "createCalendar": {
            "type": "property",
            "name": "createCalendar",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "identifier",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function to create a new [Calendar](https://react-spectrum.adobe.com/internationalized/date/Calendar.html)\nobject for a given calendar identifier. If not provided, the `createCalendar` function\nfrom `@internationalized/date` will be used.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed date that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed date that a user may select.",
            "default": null
          },
          "isDateUnavailable": {
            "type": "property",
            "name": "isDateUnavailable",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the calendar is disabled.",
            "default": "false"
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the calendar value is immutable.",
            "default": "false"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to automatically focus the calendar when it mounts.",
            "default": "false"
          },
          "focusedValue": {
            "type": "property",
            "name": "focusedValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "Controls the currently focused date within the calendar.",
            "default": null
          },
          "defaultFocusedValue": {
            "type": "property",
            "name": "defaultFocusedValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The date that is focused when the calendar first mounts (uncountrolled).",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the focused date changes.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the current selection is invalid according to application logic.",
            "default": null
          },
          "pageBehavior": {
            "type": "property",
            "name": "pageBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
            },
            "optional": true,
            "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
            "default": "visible"
          },
          "firstDayOfWeek": {
            "type": "property",
            "name": "firstDayOfWeek",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "sun"
                },
                {
                  "type": "string",
                  "value": "mon"
                },
                {
                  "type": "string",
                  "value": "tue"
                },
                {
                  "type": "string",
                  "value": "wed"
                },
                {
                  "type": "string",
                  "value": "thu"
                },
                {
                  "type": "string",
                  "value": "fri"
                },
                {
                  "type": "string",
                  "value": "sat"
                }
              ]
            },
            "optional": true,
            "description": "The day that starts the week.",
            "default": null
          },
          "selectionAlignment": {
            "type": "property",
            "name": "selectionAlignment",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "center"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "Determines the alignment of the visible months on initial render based on the current selection or current date if there is no selection.",
            "default": "'center'"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "CalendarContext": {
      "type": "any"
    },
    "Card": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:Card",
      "name": "Card",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardProps",
        "name": "CardProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "renderProps",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardRenderProps"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": false,
            "description": "The children of the Card.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Card.",
            "default": "'M'"
          },
          "density": {
            "type": "property",
            "name": "density",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "compact"
                },
                {
                  "type": "string",
                  "value": "regular"
                },
                {
                  "type": "string",
                  "value": "spacious"
                }
              ]
            },
            "optional": true,
            "description": "The amount of internal padding within the Card.",
            "default": "'regular'"
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "primary"
                },
                {
                  "type": "string",
                  "value": "secondary"
                },
                {
                  "type": "string",
                  "value": "tertiary"
                },
                {
                  "type": "string",
                  "value": "quiet"
                }
              ]
            },
            "optional": true,
            "description": "The visual style of the Card.",
            "default": "'primary'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the item.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the item's contents, used for features like typeahead.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A Card summarizes an object that a user can select or navigate to."
    },
    "CardPreview": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardPreview",
      "name": "CardPreview",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardPreviewProps",
        "name": "CardPreviewProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "CollectionCardPreview": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CollectionCardPreview",
      "name": "CollectionCardPreview",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardPreviewProps",
        "name": "CardPreviewProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "AssetCard": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:AssetCard",
      "name": "AssetCard",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:AssetCardProps",
        "name": "AssetCardProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "renderProps",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardRenderProps"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": false,
            "description": "The children of the Card.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Card.",
            "default": "'M'"
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "primary"
                },
                {
                  "type": "string",
                  "value": "secondary"
                },
                {
                  "type": "string",
                  "value": "tertiary"
                },
                {
                  "type": "string",
                  "value": "quiet"
                }
              ]
            },
            "optional": true,
            "description": "The visual style of the Card.",
            "default": "'primary'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the item.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the item's contents, used for features like typeahead.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "UserCard": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:UserCard",
      "name": "UserCard",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardProps",
        "name": "CardProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "renderProps",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardRenderProps"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": false,
            "description": "The children of the Card.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Card.",
            "default": "'M'"
          },
          "density": {
            "type": "property",
            "name": "density",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "compact"
                },
                {
                  "type": "string",
                  "value": "regular"
                },
                {
                  "type": "string",
                  "value": "spacious"
                }
              ]
            },
            "optional": true,
            "description": "The amount of internal padding within the Card.",
            "default": "'regular'"
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "primary"
                },
                {
                  "type": "string",
                  "value": "secondary"
                },
                {
                  "type": "string",
                  "value": "tertiary"
                },
                {
                  "type": "string",
                  "value": "quiet"
                }
              ]
            },
            "optional": true,
            "description": "The visual style of the Card.",
            "default": "'primary'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the item.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the item's contents, used for features like typeahead.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "ProductCard": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:ProductCard",
      "name": "ProductCard",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:ProductCardProps",
        "name": "ProductCardProps",
        "properties": {
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "primary"
                },
                {
                  "type": "string",
                  "value": "secondary"
                },
                {
                  "type": "string",
                  "value": "tertiary"
                }
              ]
            },
            "optional": true,
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "renderProps",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardRenderProps"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": false,
            "description": "The children of the Card.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Card.",
            "default": "'M'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the item.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the item's contents, used for features like typeahead.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "CardContext": {
      "type": "any"
    },
    "CardView": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CardView.tsx:CardView",
      "name": "CardView",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CardView.tsx:CardViewProps",
        "name": "CardViewProps",
        "properties": {
          "layout": {
            "type": "property",
            "name": "layout",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "waterfall"
                }
              ]
            },
            "optional": true,
            "description": "The layout of the cards.",
            "default": "'grid'"
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the cards.",
            "default": "'M'"
          },
          "density": {
            "type": "property",
            "name": "density",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "compact"
                },
                {
                  "type": "string",
                  "value": "regular"
                },
                {
                  "type": "string",
                  "value": "spacious"
                }
              ]
            },
            "optional": true,
            "description": "The amount of space between the cards.",
            "default": "'regular'"
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "primary"
                },
                {
                  "type": "string",
                  "value": "secondary"
                },
                {
                  "type": "string",
                  "value": "tertiary"
                },
                {
                  "type": "string",
                  "value": "quiet"
                }
              ]
            },
            "optional": true,
            "description": "The visual style of the cards.",
            "default": "'primary'"
          },
          "selectionStyle": {
            "type": "property",
            "name": "selectionStyle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "checkbox"
                },
                {
                  "type": "string",
                  "value": "highlight"
                }
              ]
            },
            "optional": true,
            "description": "How selection should be displayed.",
            "default": "'checkbox'"
          },
          "loadingState": {
            "type": "property",
            "name": "loadingState",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState"
            },
            "optional": true,
            "description": "The loading state of the CardView.",
            "default": null
          },
          "onLoadMore": {
            "type": "property",
            "name": "onLoadMore",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "renderActionBar": {
            "type": "property",
            "name": "renderActionBar",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "selectedKeys",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "string",
                        "value": "all"
                      },
                      {
                        "type": "application",
                        "base": {
                          "type": "identifier",
                          "name": "Set"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                          }
                        ]
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactElement"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides the ActionBar to render when cards are selected in the CardView.",
            "default": null
          },
          "disallowTypeAhead": {
            "type": "property",
            "name": "disallowTypeAhead",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether typeahead navigation is disabled.",
            "default": "false"
          },
          "dragAndDropHooks": {
            "type": "property",
            "name": "dragAndDropHooks",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "NoInfer"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the GridList.",
            "default": null
          },
          "renderEmptyState": {
            "type": "property",
            "name": "renderEmptyState",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "props",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides content to display when there are no items in the list.",
            "default": null
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the grid list or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                }
              ]
            },
            "optional": true,
            "description": "Whether to auto focus the gridlist or an option.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "disabledBehavior": {
            "type": "property",
            "name": "disabledBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
            },
            "optional": true,
            "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
            "default": "\"all\""
          },
          "shouldSelectOnPressUp": {
            "type": "property",
            "name": "shouldSelectOnPressUp",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether selection should occur on press up instead of press down.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A CardView displays a group of related objects, with support for selection and bulk actions."
    },
    "CardViewContext": {
      "type": "any"
    },
    "Checkbox": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Checkbox.tsx:Checkbox",
      "name": "Checkbox",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Checkbox.tsx:CheckboxProps",
        "name": "CheckboxProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The label for the element.",
            "default": null
          },
          "inputRef": {
            "type": "property",
            "name": "inputRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "A ref for the HTML input element.",
            "default": null
          },
          "isIndeterminate": {
            "type": "property",
            "name": "isIndeterminate",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Indeterminism is presentational only.\nThe indeterminate visual representation remains regardless of user interaction.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
            "default": null
          },
          "defaultSelected": {
            "type": "property",
            "name": "defaultSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should be selected (uncontrolled).",
            "default": null
          },
          "isSelected": {
            "type": "property",
            "name": "isSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should be selected (controlled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isSelected",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's selection state changes.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Checkbox.",
            "default": "'M'"
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Checkbox should be displayed with an emphasized style.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLLabelElement"
          }
        ]
      },
      "description": "Checkboxes allow users to select multiple items from a list of individual items,\nor to mark one individual item as selected."
    },
    "CheckboxContext": {
      "type": "any"
    },
    "CheckboxGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CheckboxGroup.tsx:CheckboxGroup",
      "name": "CheckboxGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CheckboxGroup.tsx:CheckboxGroupProps",
        "name": "CheckboxGroupProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Checkboxes in the CheckboxGroup.",
            "default": "'M'"
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The axis the checkboxes should align with.",
            "default": "'vertical'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The Checkboxes contained within the CheckboxGroup.",
            "default": null
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "By default, checkboxes are not emphasized (gray).\nThe emphasized (blue) version provides visual prominence.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "array",
              "elementType": {
                "type": "string"
              }
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "array",
              "elementType": {
                "type": "string"
              }
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "array",
                    "elementType": {
                      "type": "string"
                    }
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A CheckboxGroup allows users to select one or more items from a list of choices."
    },
    "CheckboxGroupContext": {
      "type": "any"
    },
    "CloseButton": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CloseButton.tsx:CloseButton",
      "name": "CloseButton",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CloseButton.tsx:CloseButtonProps",
        "name": "CloseButtonProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the CloseButton.",
            "default": "'M'"
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "The static color style to apply. Useful when the Button appears over a color background.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button is disabled.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLButtonElement"
          }
        ]
      },
      "description": "A CloseButton allows a user to dismiss a dialog."
    },
    "ColorArea": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorArea.tsx:ColorArea",
      "name": "ColorArea",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorArea.tsx:ColorAreaProps",
        "name": "ColorAreaProps",
        "properties": {
          "xName": {
            "type": "property",
            "name": "xName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the x channel input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "yName": {
            "type": "property",
            "name": "yName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the y channel input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the ColorArea with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "colorSpace": {
            "type": "property",
            "name": "colorSpace",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
            },
            "optional": true,
            "description": "The color space that the color area operates in. The `xChannel` and `yChannel` must be in this color space.\nIf not provided, this defaults to the color space of the `color` or `defaultColor` value.",
            "default": null
          },
          "xChannel": {
            "type": "property",
            "name": "xChannel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": true,
            "description": "Color channel for the horizontal axis.",
            "default": null
          },
          "yChannel": {
            "type": "property",
            "name": "yChannel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": true,
            "description": "Color channel for the vertical axis.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the ColorArea is disabled.",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes, as the user drags.",
            "default": null
          },
          "onChangeEnd": {
            "type": "property",
            "name": "onChangeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the user stops dragging.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ColorArea allows users to adjust two channels of an RGB, HSL or HSB color value against a two-dimensional gradient background."
    },
    "ColorAreaContext": {
      "type": "any"
    },
    "ColorField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorField.tsx:ColorField",
      "name": "ColorField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorField.tsx:ColorFieldProps",
        "name": "ColorFieldProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the color field.",
            "default": "'M'"
          },
          "channel": {
            "type": "property",
            "name": "channel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": true,
            "description": "The color channel that this field edits. If not provided, \nthe color is edited as a hex value.",
            "default": null
          },
          "colorSpace": {
            "type": "property",
            "name": "colorSpace",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
            },
            "optional": true,
            "description": "The color space that the color field operates in if a `channel` prop is provided.\nIf no `channel` is provided, the color field always displays the color as an RGB hex value.",
            "default": null
          },
          "isWheelDisabled": {
            "type": "property",
            "name": "isWheelDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Enables or disables changing the value with scroll.",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "color",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "onCopy": {
            "type": "property",
            "name": "onCopy",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
            "default": null
          },
          "onCut": {
            "type": "property",
            "name": "onCut",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
            "default": null
          },
          "onPaste": {
            "type": "property",
            "name": "onPaste",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
            "default": null
          },
          "onCompositionStart": {
            "type": "property",
            "name": "onCompositionStart",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
            "default": null
          },
          "onCompositionEnd": {
            "type": "property",
            "name": "onCompositionEnd",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
            "default": null
          },
          "onCompositionUpdate": {
            "type": "property",
            "name": "onCompositionUpdate",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
            "default": null
          },
          "onBeforeInput": {
            "type": "property",
            "name": "onBeforeInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
            "default": null
          },
          "onInput": {
            "type": "property",
            "name": "onInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/textfield/src/index.d.ts:TextFieldRef"
          }
        ]
      },
      "description": "A color field allows users to edit a hex color or individual color channel value."
    },
    "ColorFieldContext": {
      "type": "any"
    },
    "ColorSlider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorSlider.tsx:ColorSlider",
      "name": "ColorSlider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorSlider.tsx:ColorSliderProps",
        "name": "ColorSliderProps",
        "properties": {
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "default": null
          },
          "colorSpace": {
            "type": "property",
            "name": "colorSpace",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
            },
            "optional": true,
            "description": "The color space that the slider operates in. The `channel` must be in this color space.\nIf not provided, this defaults to the color space of the `color` or `defaultColor` value.",
            "default": null
          },
          "channel": {
            "type": "property",
            "name": "channel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": false,
            "description": "The color channel that the slider manipulates.",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes, as the user drags.",
            "default": null
          },
          "onChangeEnd": {
            "type": "property",
            "name": "onChangeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the user stops dragging.",
            "default": null
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The orientation of the Slider.",
            "default": "'horizontal'"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the whole Slider is disabled.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ColorSlider allows users to adjust an individual channel of a color value."
    },
    "ColorSliderContext": {
      "type": "any"
    },
    "ColorSwatch": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorSwatch.tsx:ColorSwatch",
      "name": "ColorSwatch",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorSwatch.tsx:ColorSwatchProps",
        "name": "ColorSwatchProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "The size of the ColorSwatch.",
            "default": "'M'"
          },
          "rounding": {
            "type": "property",
            "name": "rounding",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "default"
                },
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "full"
                }
              ]
            },
            "optional": true,
            "description": "The corner rounding of the ColorSwatch.",
            "default": "'default'"
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "color": {
            "type": "property",
            "name": "color",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": true,
            "description": "The color value to display in the swatch.",
            "default": null
          },
          "colorName": {
            "type": "property",
            "name": "colorName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A localized accessible name for the color.\nBy default, a description is generated from the color value,\nbut this can be overridden if you have a more specific color\nname (e.g. Pantone colors).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ColorSwatch displays a preview of a selected color."
    },
    "ColorSwatchContext": {
      "type": "any"
    },
    "ColorSwatchPicker": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorSwatchPicker.tsx:ColorSwatchPicker",
      "name": "ColorSwatchPicker",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorSwatchPicker.tsx:ColorSwatchPickerProps",
        "name": "ColorSwatchPickerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The ColorSwatches within the ColorSwatchPicker.",
            "default": null
          },
          "density": {
            "type": "property",
            "name": "density",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "compact"
                },
                {
                  "type": "string",
                  "value": "regular"
                },
                {
                  "type": "string",
                  "value": "spacious"
                }
              ]
            },
            "optional": true,
            "description": "The amount of padding between the swatches.",
            "default": "'regular'"
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "The size of the color swatches.",
            "default": "'M'"
          },
          "rounding": {
            "type": "property",
            "name": "rounding",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "default"
                },
                {
                  "type": "string",
                  "value": "full"
                }
              ]
            },
            "optional": true,
            "description": "The corner rounding of the color swatches.",
            "default": "'none'"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ColorSwatchPicker displays a list of color swatches and allows a user to select one of them."
    },
    "ColorSwatchPickerContext": {
      "type": "any"
    },
    "ColorWheel": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorWheel.tsx:ColorWheel",
      "name": "ColorWheel",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorWheel.tsx:ColorWheelProps",
        "name": "ColorWheelProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "default": "192"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the ColorWheel is disabled.",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes, as the user drags.",
            "default": null
          },
          "onChangeEnd": {
            "type": "property",
            "name": "onChangeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the user stops dragging.",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": "'hsl(0, 100%, 50%)'"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ColorWheel allows users to adjust the hue of an HSL or HSB color value on a circular track."
    },
    "ColorWheelContext": {
      "type": "any"
    },
    "ComboBox": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ComboBox.tsx:ComboBox",
      "name": "ComboBox",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ComboBox.tsx:ComboBoxProps",
        "name": "ComboBoxProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": false,
            "description": "The contents of the collection.",
            "default": null
          },
          "direction": {
            "type": "property",
            "name": "direction",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "bottom"
                },
                {
                  "type": "string",
                  "value": "top"
                }
              ]
            },
            "optional": true,
            "description": "Direction the menu will render relative to the ComboBox.",
            "default": "'bottom'"
          },
          "align": {
            "type": "property",
            "name": "align",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "Alignment of the menu relative to the input target.",
            "default": "'start'"
          },
          "menuWidth": {
            "type": "property",
            "name": "menuWidth",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "Width of the menu. By default, matches width of the trigger. Note that the minimum width of the dropdown is always equal to the trigger's width.",
            "default": null
          },
          "loadingState": {
            "type": "property",
            "name": "loadingState",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState"
            },
            "optional": true,
            "description": "The current loading state of the ComboBox. Determines whether or not the progress circle should be shown.",
            "default": null
          },
          "formValue": {
            "type": "property",
            "name": "formValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "key"
                }
              ]
            },
            "optional": true,
            "description": "Whether the text or key of the selected item is submitted as part of an HTML form.\nWhen `allowsCustomValue` is `true`, this option does not apply and the text is always submitted.",
            "default": "'key'"
          },
          "shouldFocusWrap": {
            "type": "property",
            "name": "shouldFocusWrap",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether keyboard navigation is circular.",
            "default": null
          },
          "defaultItems": {
            "type": "property",
            "name": "defaultItems",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "The list of ComboBox items (uncontrolled).",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "The list of ComboBox items (controlled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                },
                {
                  "type": "parameter",
                  "name": "menuTrigger",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction"
                  },
                  "optional": true,
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Method that is called when the open state of the menu changes. Returns the new open state and the action that caused the opening of the menu.",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "inputValue": {
            "type": "property",
            "name": "inputValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value of the ComboBox input (controlled).",
            "default": null
          },
          "defaultInputValue": {
            "type": "property",
            "name": "defaultInputValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The default value of the ComboBox input (uncontrolled).",
            "default": null
          },
          "onInputChange": {
            "type": "property",
            "name": "onInputChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the ComboBox input value changes.",
            "default": null
          },
          "allowsCustomValue": {
            "type": "property",
            "name": "allowsCustomValue",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the ComboBox allows a non-item matching input value to be set.",
            "default": null
          },
          "menuTrigger": {
            "type": "property",
            "name": "menuTrigger",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction"
            },
            "optional": true,
            "description": "The interaction required to display the ComboBox menu.",
            "default": "'input'"
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectedKey": {
            "type": "property",
            "name": "selectedKey",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The currently selected key in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKey": {
            "type": "property",
            "name": "defaultSelectedKey",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Key"
            },
            "optional": true,
            "description": "The initial selected key in the collection (uncontrolled).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:ComboBoxValidationValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLInputElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLInputElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Combobox.",
            "default": "'M'"
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "shouldFlip": {
            "type": "property",
            "name": "shouldFlip",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
            "default": "true"
          },
          "onLoadMore": {
            "type": "property",
            "name": "onLoadMore",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "object",
              "properties": null
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/textfield/src/index.d.ts:TextFieldRef"
          }
        ]
      },
      "description": "ComboBox allow users to choose a single option from a collapsible list of options when space is limited."
    },
    "ComboBoxItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ComboBox.tsx:ComboBoxItem",
      "name": "ComboBoxItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ComboBox.tsx:ComboBoxItemProps",
        "name": "ComboBoxItemProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the item.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the item's contents, used for features like typeahead.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for this item.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "ComboBoxSection": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ComboBox.tsx:ComboBoxSection",
      "name": "ComboBoxSection",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ComboBox.tsx:ComboBoxSectionProps",
        "name": "ComboBoxSectionProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the section.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Static child items or a function to render children.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for the section.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the section.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "object",
              "properties": null
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": null,
      "description": null
    },
    "ComboBoxContext": {
      "type": "any"
    },
    "ContextualHelp": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ContextualHelp.tsx:ContextualHelp",
      "name": "ContextualHelp",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ContextualHelp.tsx:ContextualHelpProps",
        "name": "ContextualHelpProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "Contents of the Contextual Help popover.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                }
              ]
            },
            "optional": true,
            "description": "The size of the ActionButton.",
            "default": "'XS'"
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "offset": {
            "type": "property",
            "name": "offset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
            "default": "8"
          },
          "placement": {
            "type": "property",
            "name": "placement",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement"
            },
            "optional": true,
            "description": "The placement of the element with respect to its anchor element.",
            "default": "'bottom'"
          },
          "containerPadding": {
            "type": "property",
            "name": "containerPadding",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
            "default": "12"
          },
          "crossOffset": {
            "type": "property",
            "name": "crossOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
            "default": "0"
          },
          "shouldFlip": {
            "type": "property",
            "name": "shouldFlip",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
            "default": "true"
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "info"
                },
                {
                  "type": "string",
                  "value": "help"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether contents are informative or provides helpful guidance.",
            "default": "'help'"
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLButtonElement"
          }
        ]
      },
      "description": "Contextual help shows a user extra information about the state of an adjacent component, or a total view."
    },
    "ContextualHelpContext": {
      "type": "any"
    },
    "DateField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DateField.tsx:DateField",
      "name": "DateField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DateField.tsx:DateFieldProps",
        "name": "DateFieldProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the DateField.",
            "default": "'M'"
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed date that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed date that a user may select.",
            "default": null
          },
          "isDateUnavailable": {
            "type": "property",
            "name": "isDateUnavailable",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
            "default": null
          },
          "placeholderValue": {
            "type": "property",
            "name": "placeholderValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
            "default": null
          },
          "hourCycle": {
            "type": "property",
            "name": "hourCycle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number",
                  "value": 12
                },
                {
                  "type": "number",
                  "value": 24
                }
              ]
            },
            "optional": true,
            "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
            "default": null
          },
          "granularity": {
            "type": "property",
            "name": "granularity",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
            },
            "optional": true,
            "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
            "default": null
          },
          "hideTimeZone": {
            "type": "property",
            "name": "hideTimeZone",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to hide the time zone abbreviation.",
            "default": "false"
          },
          "shouldForceLeadingZeros": {
            "type": "property",
            "name": "shouldForceLeadingZeros",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                          }
                        ]
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "DateFieldContext": {
      "type": "any"
    },
    "DatePicker": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DatePicker.tsx:DatePicker",
      "name": "DatePicker",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DatePicker.tsx:DatePickerProps",
        "name": "DatePickerProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the DateField.",
            "default": "'M'"
          },
          "maxVisibleMonths": {
            "type": "property",
            "name": "maxVisibleMonths",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The maximum number of months to display at once in the calendar popover, if screen space permits.",
            "default": "1"
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "pageBehavior": {
            "type": "property",
            "name": "pageBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
            },
            "optional": true,
            "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
            "default": "visible"
          },
          "firstDayOfWeek": {
            "type": "property",
            "name": "firstDayOfWeek",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "sun"
                },
                {
                  "type": "string",
                  "value": "mon"
                },
                {
                  "type": "string",
                  "value": "tue"
                },
                {
                  "type": "string",
                  "value": "wed"
                },
                {
                  "type": "string",
                  "value": "thu"
                },
                {
                  "type": "string",
                  "value": "fri"
                },
                {
                  "type": "string",
                  "value": "sat"
                }
              ]
            },
            "optional": true,
            "description": "The day that starts the week.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed date that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed date that a user may select.",
            "default": null
          },
          "isDateUnavailable": {
            "type": "property",
            "name": "isDateUnavailable",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
            "default": null
          },
          "placeholderValue": {
            "type": "property",
            "name": "placeholderValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
            "default": null
          },
          "hourCycle": {
            "type": "property",
            "name": "hourCycle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number",
                  "value": 12
                },
                {
                  "type": "number",
                  "value": 24
                }
              ]
            },
            "optional": true,
            "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
            "default": null
          },
          "granularity": {
            "type": "property",
            "name": "granularity",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
            },
            "optional": true,
            "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
            "default": null
          },
          "hideTimeZone": {
            "type": "property",
            "name": "hideTimeZone",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to hide the time zone abbreviation.",
            "default": "false"
          },
          "shouldForceLeadingZeros": {
            "type": "property",
            "name": "shouldForceLeadingZeros",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                          }
                        ]
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "shouldCloseOnSelect": {
            "type": "property",
            "name": "shouldCloseOnSelect",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Determines whether the date picker popover should close automatically when a date is selected.",
            "default": "true"
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "createCalendar": {
            "type": "property",
            "name": "createCalendar",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "identifier",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function to create a new [Calendar](https://react-spectrum.adobe.com/internationalized/date/Calendar.html)\nobject for a given calendar identifier. If not provided, the `createCalendar` function\nfrom `@internationalized/date` will be used.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "DatePickerContext": {
      "type": "any"
    },
    "DateRangePicker": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DateRangePicker.tsx:DateRangePicker",
      "name": "DateRangePicker",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DateRangePicker.tsx:DateRangePickerProps",
        "name": "DateRangePickerProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the DateField.",
            "default": "'M'"
          },
          "maxVisibleMonths": {
            "type": "property",
            "name": "maxVisibleMonths",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The maximum number of months to display at once in the calendar popover, if screen space permits.",
            "default": "1"
          },
          "pageBehavior": {
            "type": "property",
            "name": "pageBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
            },
            "optional": true,
            "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
            "default": "visible"
          },
          "firstDayOfWeek": {
            "type": "property",
            "name": "firstDayOfWeek",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "sun"
                },
                {
                  "type": "string",
                  "value": "mon"
                },
                {
                  "type": "string",
                  "value": "tue"
                },
                {
                  "type": "string",
                  "value": "wed"
                },
                {
                  "type": "string",
                  "value": "thu"
                },
                {
                  "type": "string",
                  "value": "fri"
                },
                {
                  "type": "string",
                  "value": "sat"
                }
              ]
            },
            "optional": true,
            "description": "The day that starts the week.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed date that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed date that a user may select.",
            "default": null
          },
          "isDateUnavailable": {
            "type": "property",
            "name": "isDateUnavailable",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
            "default": null
          },
          "placeholderValue": {
            "type": "property",
            "name": "placeholderValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
            "default": null
          },
          "hourCycle": {
            "type": "property",
            "name": "hourCycle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number",
                  "value": 12
                },
                {
                  "type": "number",
                  "value": 24
                }
              ]
            },
            "optional": true,
            "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
            "default": null
          },
          "granularity": {
            "type": "property",
            "name": "granularity",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
            },
            "optional": true,
            "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
            "default": null
          },
          "hideTimeZone": {
            "type": "property",
            "name": "hideTimeZone",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to hide the time zone abbreviation.",
            "default": "false"
          },
          "shouldForceLeadingZeros": {
            "type": "property",
            "name": "shouldForceLeadingZeros",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "allowsNonContiguousRanges": {
            "type": "property",
            "name": "allowsNonContiguousRanges",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "When combined with `isDateUnavailable`, determines whether non-contiguous ranges,\ni.e. ranges containing unavailable dates, may be selected.",
            "default": null
          },
          "startName": {
            "type": "property",
            "name": "startName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the start date input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "endName": {
            "type": "property",
            "name": "endName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the end date input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                    },
                    "typeParameters": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                          }
                        ]
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                        },
                        "typeParameters": [
                          {
                            "type": "application",
                            "base": {
                              "type": "link",
                              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                            },
                            "typeParameters": [
                              {
                                "type": "link",
                                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "shouldCloseOnSelect": {
            "type": "property",
            "name": "shouldCloseOnSelect",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Determines whether the date picker popover should close automatically when a date is selected.",
            "default": "true"
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "default": null
          }
        ],
        "extends": [
          {
            "type": "identifier",
            "name": "RangeCalendarProps"
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "DateRangePickerContext": {
      "type": "any"
    },
    "DisclosureHeader": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Disclosure.tsx:DisclosureHeader",
      "name": "DisclosureHeader",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Disclosure.tsx:DisclosureHeaderProps",
        "name": "DisclosureHeaderProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "React.ReactNode"
            },
            "optional": false,
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A wrapper element for the disclosure title that can contain other elements not part of the trigger."
    },
    "Disclosure": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Disclosure.tsx:Disclosure",
      "name": "Disclosure",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Disclosure.tsx:DisclosureProps",
        "name": "DisclosureProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the disclosure.",
            "default": "'M'"
          },
          "density": {
            "type": "property",
            "name": "density",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "compact"
                },
                {
                  "type": "string",
                  "value": "regular"
                },
                {
                  "type": "string",
                  "value": "spacious"
                }
              ]
            },
            "optional": true,
            "description": "The amount of space between the disclosures.",
            "default": "'regular'"
          },
          "isQuiet": {
            "type": "property",
            "name": "isQuiet",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the disclosure should be displayed with a quiet style.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The contents of the disclosure, consisting of a DisclosureTitle and DisclosurePanel.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "An id for the disclosure when used within a DisclosureGroup, matching the id used in `expandedKeys`.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the disclosure is disabled.",
            "default": null
          },
          "onExpandedChange": {
            "type": "property",
            "name": "onExpandedChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isExpanded",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the disclosure's expanded state changes.",
            "default": null
          },
          "isExpanded": {
            "type": "property",
            "name": "isExpanded",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the disclosure is expanded (controlled).",
            "default": null
          },
          "defaultExpanded": {
            "type": "property",
            "name": "defaultExpanded",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the disclosure is expanded by default (uncontrolled).",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A disclosure is a collapsible section of content. It is composed of a a header with a heading and trigger button, and a panel that contains the content."
    },
    "DisclosurePanel": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Disclosure.tsx:DisclosurePanel",
      "name": "DisclosurePanel",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Disclosure.tsx:DisclosurePanelProps",
        "name": "DisclosurePanelProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "React.ReactNode"
            },
            "optional": false,
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "group"
                },
                {
                  "type": "string",
                  "value": "region"
                }
              ]
            },
            "optional": true,
            "description": "The accessibility role for the disclosure's panel.",
            "default": "'group'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A disclosure panel is a collapsible section of content that is hidden until the disclosure is expanded."
    },
    "DisclosureContext": {
      "type": "any"
    },
    "DisclosureTitle": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Disclosure.tsx:DisclosureTitle",
      "name": "DisclosureTitle",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Disclosure.tsx:DisclosureTitleProps",
        "name": "DisclosureTitleProps",
        "properties": {
          "level": {
            "type": "property",
            "name": "level",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The heading level of the disclosure header.",
            "default": "3"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "React.ReactNode"
            },
            "optional": false,
            "description": "The contents of the disclosure header.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A disclosure title consisting of a heading and a trigger button to expand/collapse the panel."
    },
    "Heading": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:Heading",
      "name": "Heading",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:HeadingProps",
        "name": "HeadingProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "level": {
            "type": "property",
            "name": "level",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "optional": true,
            "default": null
          },
          "isHidden": {
            "type": "property",
            "name": "isHidden",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLHeadingElement"
          }
        ]
      },
      "description": null
    },
    "HeadingContext": {
      "type": "any"
    },
    "Header": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:Header",
      "name": "Header",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:ContentProps",
        "name": "ContentProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "optional": true,
            "default": null
          },
          "isHidden": {
            "type": "property",
            "name": "isHidden",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
      },
      "description": null
    },
    "HeaderContext": {
      "type": "any"
    },
    "Content": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:Content",
      "name": "Content",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:ContentProps",
        "name": "ContentProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "optional": true,
            "default": null
          },
          "isHidden": {
            "type": "property",
            "name": "isHidden",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "ContentContext": {
      "type": "any"
    },
    "Footer": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:Footer",
      "name": "Footer",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:ContentProps",
        "name": "ContentProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "optional": true,
            "default": null
          },
          "isHidden": {
            "type": "property",
            "name": "isHidden",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
      },
      "description": null
    },
    "FooterContext": {
      "type": "any"
    },
    "Text": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:Text",
      "name": "Text",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:ContentProps",
        "name": "ContentProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "optional": true,
            "default": null
          },
          "isHidden": {
            "type": "property",
            "name": "isHidden",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
      },
      "description": null
    },
    "TextContext": {
      "type": "any"
    },
    "Keyboard": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:Keyboard",
      "name": "Keyboard",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Content.tsx:ContentProps",
        "name": "ContentProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "optional": true,
            "default": null
          },
          "isHidden": {
            "type": "property",
            "name": "isHidden",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
      },
      "description": null
    },
    "KeyboardContext": {
      "type": "any"
    },
    "Dialog": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Dialog.tsx:Dialog",
      "name": "Dialog",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Dialog.tsx:DialogProps",
        "name": "DialogProps",
        "properties": {
          "isDismissible": {
            "type": "property",
            "name": "isDismissible",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Dialog is dismissible.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Dialog.",
            "default": "'M'"
          },
          "isKeyboardDismissDisabled": {
            "type": "property",
            "name": "isKeyboardDismissDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether pressing the escape key to close the dialog should be disabled.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "opts",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "dialog"
                },
                {
                  "type": "string",
                  "value": "alertdialog"
                }
              ]
            },
            "optional": true,
            "description": "The accessibility role for the dialog.",
            "default": "'dialog'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
      },
      "description": "Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.\nDepending on the kind of Dialog, further interactions may be blocked until the Dialog is acknowledged."
    },
    "CustomDialog": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CustomDialog.tsx:CustomDialog",
      "name": "CustomDialog",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CustomDialog.tsx:CustomDialogProps",
        "name": "CustomDialogProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "fullscreen"
                },
                {
                  "type": "string",
                  "value": "fullscreenTakeover"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Dialog.",
            "default": null
          },
          "isDismissible": {
            "type": "property",
            "name": "isDismissible",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Dialog is dismissible.",
            "default": null
          },
          "isKeyboardDismissDisabled": {
            "type": "property",
            "name": "isKeyboardDismissDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether pressing the escape key to close the dialog should be disabled.",
            "default": null
          },
          "padding": {
            "type": "property",
            "name": "padding",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "default"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "The amount of padding around the contents of the dialog.",
            "default": "'default'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "opts",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "dialog"
                },
                {
                  "type": "string",
                  "value": "alertdialog"
                }
              ]
            },
            "optional": true,
            "description": "The accessibility role for the dialog.",
            "default": "'dialog'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
      },
      "description": "A CustomDialog is a floating window with a custom layout."
    },
    "FullscreenDialog": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/FullscreenDialog.tsx:FullscreenDialog",
      "name": "FullscreenDialog",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/FullscreenDialog.tsx:FullscreenDialogProps",
        "name": "FullscreenDialogProps",
        "properties": {
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "fullscreen"
                },
                {
                  "type": "string",
                  "value": "fullscreenTakeover"
                }
              ]
            },
            "optional": true,
            "description": "The variant of fullscreen dialog to display.",
            "default": "\"fullscreen\""
          },
          "isKeyboardDismissDisabled": {
            "type": "property",
            "name": "isKeyboardDismissDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether pressing the escape key to close the dialog should be disabled.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "opts",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "dialog"
                },
                {
                  "type": "string",
                  "value": "alertdialog"
                }
              ]
            },
            "optional": true,
            "description": "The accessibility role for the dialog.",
            "default": "'dialog'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
      },
      "description": "Takeover dialogs are large types of dialogs. They use the totality of the screen and should be used for modal experiences with complex workflows."
    },
    "DialogTrigger": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogTrigger.tsx:DialogTrigger",
      "name": "DialogTrigger",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogTrigger.tsx:DialogTriggerProps",
        "name": "DialogTriggerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "DialogTrigger serves as a wrapper around a Dialog and its associated trigger, linking the Dialog's\nopen state with the trigger's press state. Additionally, it allows you to customize the type and\npositioning of the Dialog."
    },
    "DialogContainer": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogContainer.tsx:DialogContainer",
      "name": "DialogContainer",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogContainer.tsx:DialogContainerProps",
        "name": "DialogContainerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The Dialog to display, if any.",
            "default": null
          },
          "onDismiss": {
            "type": "property",
            "name": "onDismiss",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": false,
            "description": "Handler that is called when the 'x' button of a dismissable Dialog is clicked.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "A DialogContainer accepts a single Dialog as a child, and manages showing and hiding\nit in a modal. Useful in cases where there is no trigger element\nor when the trigger unmounts while the dialog is open."
    },
    "useDialogContainer": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogContainer.tsx:useDialogContainer",
      "name": "useDialogContainer",
      "parameters": [],
      "return": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogContainer.tsx:DialogContainerValue"
      },
      "typeParameters": []
    },
    "Divider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Divider.tsx:Divider",
      "name": "Divider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Divider.tsx:DividerProps",
        "name": "DividerProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "How thick the Divider should be.",
            "default": "'M'"
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "horizontal"
                },
                {
                  "type": "string",
                  "value": "vertical"
                }
              ]
            },
            "optional": true,
            "description": "How thick the Divider should be.",
            "default": "'horizontal'"
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "The static color style to apply. Useful when the Divider appears over a color background.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
      },
      "description": "Dividers bring clarity to a layout by grouping and dividing content in close proximity.\nThey can also be used to establish rhythm and hierarchy."
    },
    "DividerContext": {
      "type": "any"
    },
    "DropZone": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DropZone.tsx:DropZone",
      "name": "DropZone",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DropZone.tsx:DropZoneProps",
        "name": "DropZoneProps",
        "properties": {
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the drop zone.",
            "default": null
          },
          "isFilled": {
            "type": "property",
            "name": "isFilled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the drop zone has been filled.",
            "default": null
          },
          "replaceMessage": {
            "type": "property",
            "name": "replaceMessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The message to replace the default banner message that is shown when the drop zone is filled.",
            "default": "'Drop file to replace'"
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "The size of the DropZone.",
            "default": "'M'"
          },
          "getDropOperation": {
            "type": "property",
            "name": "getDropOperation",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "types",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                  },
                  "rest": false,
                  "description": null
                },
                {
                  "type": "parameter",
                  "name": "allowedOperations",
                  "value": {
                    "type": "array",
                    "elementType": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                    }
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
            "default": null
          },
          "onDropEnter": {
            "type": "property",
            "name": "onDropEnter",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEnterEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a valid drag enters the drop target.",
            "default": null
          },
          "onDropMove": {
            "type": "property",
            "name": "onDropMove",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropMoveEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a valid drag is moved within the drop target.",
            "default": null
          },
          "onDropActivate": {
            "type": "property",
            "name": "onDropActivate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropActivateEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called after a valid drag is held over the drop target for a period of time.\nThis typically opens the item so that the user can drop within it.",
            "default": null
          },
          "onDropExit": {
            "type": "property",
            "name": "onDropExit",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropExitEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a valid drag exits the drop target.",
            "default": null
          },
          "onDrop": {
            "type": "property",
            "name": "onDrop",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a valid drag is dropped on the drop target.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A drop zone is an area into which one or multiple objects can be dragged and dropped."
    },
    "DropZoneContext": {
      "type": "any"
    },
    "Form": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Form.tsx:Form",
      "name": "Form",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Form.tsx:FormProps",
        "name": "FormProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "Size of the Form elements.",
            "default": "'M'"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Form elements are disabled.",
            "default": null
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Form elements are rendered with their emphasized style.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the label is labeling a required field or group.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "aria"
                },
                {
                  "type": "string",
                  "value": "native"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen a field value is missing or invalid, or mark fields as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "validationErrors": {
            "type": "property",
            "name": "validationErrors",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationErrors"
            },
            "optional": true,
            "description": "Validation errors for the form, typically returned by a server.\nThis should be set to an object mapping from input names to errors.",
            "default": null
          },
          "action": {
            "type": "property",
            "name": "action",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "indexedAccess",
                  "objectType": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FormHTMLAttributes"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLFormElement"
                      }
                    ]
                  },
                  "indexType": {
                    "type": "string",
                    "value": "action"
                  }
                }
              ]
            },
            "optional": true,
            "description": "Where to send the form-data when the form is submitted.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#action).",
            "default": null
          },
          "encType": {
            "type": "property",
            "name": "encType",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "application/x-www-form-urlencoded"
                },
                {
                  "type": "string",
                  "value": "multipart/form-data"
                },
                {
                  "type": "string",
                  "value": "text/plain"
                }
              ]
            },
            "optional": true,
            "description": "The enctype attribute specifies how the form-data should be encoded when submitting it to the server.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#enctype).",
            "default": null
          },
          "method": {
            "type": "property",
            "name": "method",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "get"
                },
                {
                  "type": "string",
                  "value": "post"
                },
                {
                  "type": "string",
                  "value": "dialog"
                }
              ]
            },
            "optional": true,
            "description": "The HTTP method to submit the form with.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#method).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "_blank"
                },
                {
                  "type": "string",
                  "value": "_self"
                },
                {
                  "type": "string",
                  "value": "_parent"
                },
                {
                  "type": "string",
                  "value": "_top"
                }
              ]
            },
            "optional": true,
            "description": "The target attribute specifies a name or a keyword that indicates where to display the response that is received after submitting the form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#target).",
            "default": null
          },
          "onSubmit": {
            "type": "property",
            "name": "onSubmit",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "event",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FormEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLFormElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Triggered when a user submits the form.",
            "default": null
          },
          "onReset": {
            "type": "property",
            "name": "onReset",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "event",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FormEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLFormElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Triggered when a user resets the form.",
            "default": null
          },
          "onInvalid": {
            "type": "property",
            "name": "onInvalid",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "event",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FormEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "HTMLFormElement"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Triggered for each invalid field when a user submits the form.",
            "default": null
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "off"
                },
                {
                  "type": "string",
                  "value": "on"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether input elements can by default have their values automatically completed by the browser.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#autocomplete).",
            "default": null
          },
          "autoCapitalize": {
            "type": "property",
            "name": "autoCapitalize",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "off"
                },
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "on"
                },
                {
                  "type": "string",
                  "value": "sentences"
                },
                {
                  "type": "string",
                  "value": "words"
                },
                {
                  "type": "string",
                  "value": "characters"
                }
              ]
            },
            "optional": true,
            "description": "Controls whether inputted text is automatically capitalized and, if so, in what manner. \nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/autocapitalize).",
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "presentation"
                }
              ]
            },
            "optional": true,
            "description": "An ARIA role override to apply to the form element.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLFormElement"
          }
        ]
      },
      "description": "Forms allow users to enter data that can be submitted while providing alignment and styling for form fields."
    },
    "createIcon": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:createIcon",
      "name": "createIcon",
      "parameters": [
        {
          "type": "parameter",
          "name": "Component",
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ComponentType"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "SVGProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "SVGSVGElement"
                  }
                ]
              }
            ]
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "context",
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Context"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ContextValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IconContextValue"
                  },
                  {
                    "type": "identifier",
                    "name": "SVGElement"
                  }
                ]
              }
            ]
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "FunctionComponent"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IconProps"
          }
        ]
      },
      "typeParameters": []
    },
    "createIllustration": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:createIllustration",
      "name": "createIllustration",
      "parameters": [
        {
          "type": "parameter",
          "name": "Component",
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ComponentType"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "SVGProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "SVGSVGElement"
                  }
                ]
              }
            ]
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "FunctionComponent"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IllustrationProps"
          }
        ]
      },
      "typeParameters": []
    },
    "IconContext": {
      "type": "any"
    },
    "IllustrationContext": {
      "type": "any"
    },
    "IllustratedMessage": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/IllustratedMessage.tsx:IllustratedMessage",
      "name": "IllustratedMessage",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/IllustratedMessage.tsx:S2SpectrumIllustratedMessageProps",
        "name": "S2SpectrumIllustratedMessageProps",
        "properties": {
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the IllustratedMessage.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "The size of the IllustratedMessage.",
            "default": "'M'"
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "horizontal"
                },
                {
                  "type": "string",
                  "value": "vertical"
                }
              ]
            },
            "optional": true,
            "description": "The direction that the IllustratedMessage should be laid out in.",
            "default": "'vertical'"
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "An IllustratedMessage displays an illustration and a message, usually\nfor an empty state or an error page."
    },
    "IllustratedMessageContext": {
      "type": "any"
    },
    "Image": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Image.tsx:Image",
      "name": "Image",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Image.tsx:ImageProps",
        "name": "ImageProps",
        "properties": {
          "src": {
            "type": "property",
            "name": "src",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The URL of the image.",
            "default": null
          },
          "alt": {
            "type": "property",
            "name": "alt",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Accessible alt text for the image.",
            "default": null
          },
          "crossOrigin": {
            "type": "property",
            "name": "crossOrigin",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "anonymous"
                },
                {
                  "type": "string",
                  "value": "use-credentials"
                }
              ]
            },
            "optional": true,
            "description": "Indicates if the fetching of the image must be done using a CORS request.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/crossorigin).",
            "default": null
          },
          "decoding": {
            "type": "property",
            "name": "decoding",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "async"
                },
                {
                  "type": "string",
                  "value": "auto"
                },
                {
                  "type": "string",
                  "value": "sync"
                }
              ]
            },
            "optional": true,
            "description": "Whether the browser should decode images synchronously or asynchronously.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#decoding).",
            "default": null
          },
          "fetchPriority": {
            "type": "property",
            "name": "fetchPriority",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "high"
                },
                {
                  "type": "string",
                  "value": "low"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "Provides a hint of the relative priority to use when fetching the image.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#fetchpriority).",
            "default": null
          },
          "loading": {
            "type": "property",
            "name": "loading",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "eager"
                },
                {
                  "type": "string",
                  "value": "lazy"
                }
              ]
            },
            "optional": true,
            "description": "Whether the image should be loaded immediately or lazily when scrolled into view.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#loading).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "A string indicating which referrer to use when fetching the resource.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#referrerpolicy).",
            "default": null
          },
          "width": {
            "type": "property",
            "name": "width",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The intrinsic width of the image.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/img#width).",
            "default": null
          },
          "height": {
            "type": "property",
            "name": "height",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The intrinsic height of the image.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/img#height).",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "renderError": {
            "type": "property",
            "name": "renderError",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that is called to render a fallback when the image fails to load.",
            "default": null
          },
          "group": {
            "type": "property",
            "name": "group",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageGroup"
            },
            "optional": true,
            "description": "A group of images to coordinate between, matching the group passed to the `<ImageCoordinator>` component.\nIf not provided, the default image group is used.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "An image with support for skeleton loading and custom error states."
    },
    "ImageContext": {
      "type": "any"
    },
    "ImageCoordinator": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageCoordinator",
      "name": "ImageCoordinator",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageCoordinatorProps",
        "name": "ImageCoordinatorProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "Children within the ImageCoordinator.",
            "default": null
          },
          "timeout": {
            "type": "property",
            "name": "timeout",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "Time in milliseconds after which images are always displayed, even if all images are not yet loaded.",
            "default": "5000"
          },
          "group": {
            "type": "property",
            "name": "group",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageGroup"
            },
            "optional": true,
            "description": "A group of images to coordinate between, matching the group passed to the `<Image>` component.\nIf not provided, the default image group is used.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "An ImageCoordinator coordinates loading behavior for a group of images.\nImages within an ImageCoordinator are revealed together once all of them have loaded."
    },
    "InlineAlert": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/InlineAlert.tsx:InlineAlert",
      "name": "InlineAlert",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/InlineAlert.tsx:InlineAlertProps",
        "name": "InlineAlertProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The contents of the Inline Alert.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to automatically focus the Inline Alert when it first renders.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "informative"
                },
                {
                  "type": "string",
                  "value": "positive"
                },
                {
                  "type": "string",
                  "value": "notice"
                },
                {
                  "type": "string",
                  "value": "negative"
                },
                {
                  "type": "string",
                  "value": "neutral"
                }
              ]
            },
            "optional": true,
            "description": "The semantic tone of a Inline Alert.",
            "default": "neutral"
          },
          "fillStyle": {
            "type": "property",
            "name": "fillStyle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "border"
                },
                {
                  "type": "string",
                  "value": "subtleFill"
                },
                {
                  "type": "string",
                  "value": "boldFill"
                }
              ]
            },
            "optional": true,
            "description": "The visual style of the Inline Alert.",
            "default": "border"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Inline alerts display a non-modal message associated with objects in a view.\nThese are often used in form validation, providing a place to aggregate feedback related to multiple fields."
    },
    "InlineAlertContext": {
      "type": "any"
    },
    "Link": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Link.tsx:Link",
      "name": "Link",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Link.tsx:LinkProps",
        "name": "LinkProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "primary"
                },
                {
                  "type": "string",
                  "value": "secondary"
                }
              ]
            },
            "optional": true,
            "description": "The [visual style](https://spectrum.adobe.com/page/link/#Options) of the link.",
            "default": "'primary'"
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "The static color style to apply. Useful when the link appears over a color background.",
            "default": null
          },
          "isStandalone": {
            "type": "property",
            "name": "isStandalone",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the link is on its own vs inside a longer string of text.",
            "default": null
          },
          "isQuiet": {
            "type": "property",
            "name": "isQuiet",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the link should be displayed with a quiet style.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLAnchorElement"
          }
        ]
      },
      "description": "Links allow users to navigate to a different location.\nThey can be presented inline inside a paragraph or as standalone text."
    },
    "LinkContext": {
      "type": "any"
    },
    "MenuItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuItem",
      "name": "MenuItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuItemProps",
        "name": "MenuItemProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The contents of the item.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the item.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the item's contents, used for features like typeahead.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for this item.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the item is selected.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "MenuTrigger": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuTrigger",
      "name": "MenuTrigger",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuTriggerProps",
        "name": "MenuTriggerProps",
        "properties": {
          "align": {
            "type": "property",
            "name": "align",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "Alignment of the menu relative to the trigger.",
            "default": "'start'"
          },
          "direction": {
            "type": "property",
            "name": "direction",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "bottom"
                },
                {
                  "type": "string",
                  "value": "top"
                },
                {
                  "type": "string",
                  "value": "left"
                },
                {
                  "type": "string",
                  "value": "right"
                },
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "Where the Menu opens relative to its trigger.",
            "default": "'bottom'"
          },
          "shouldFlip": {
            "type": "property",
            "name": "shouldFlip",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the menu should automatically flip direction when space is limited.",
            "default": "true"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "trigger": {
            "type": "property",
            "name": "trigger",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/menu/src/index.d.ts:MenuTriggerType"
            },
            "optional": true,
            "description": "How the menu is triggered.",
            "default": "'press'"
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "The MenuTrigger serves as a wrapper around a Menu and its associated trigger,\nlinking the Menu's open state with the trigger's press state."
    },
    "Menu": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:Menu",
      "name": "Menu",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuProps",
        "name": "MenuProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Menu.",
            "default": "'M'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": false,
            "description": "The contents of the collection.",
            "default": null
          },
          "hideLinkOutIcon": {
            "type": "property",
            "name": "hideLinkOutIcon",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Hides the default link out icons on menu items that open links in a new tab.",
            "default": null
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the menu or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                }
              ]
            },
            "optional": true,
            "description": "Where the focus should be set.",
            "default": null
          },
          "shouldFocusWrap": {
            "type": "property",
            "name": "shouldFocusWrap",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether keyboard navigation is circular.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when an item is selected.",
            "default": null
          },
          "onClose": {
            "type": "property",
            "name": "onClose",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the menu should close after selecting an item.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Menus display a list of actions or options that a user can choose."
    },
    "MenuSection": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuSection",
      "name": "MenuSection",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuSectionProps",
        "name": "MenuSectionProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the section.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Static child items or a function to render children.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for the section.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the section.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The currently disabled keys in the collection (controlled).",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "object",
              "properties": null
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": null,
      "description": null
    },
    "SubmenuTrigger": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:SubmenuTrigger",
      "name": "SubmenuTrigger",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:SubmenuTriggerProps",
        "name": "SubmenuTriggerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "array",
              "elementType": {
                "type": "identifier",
                "name": "ReactElement"
              }
            },
            "optional": false,
            "description": "The contents of the SubmenuTrigger. The first child should be an Item (the trigger) and the second child should be the Popover (for the submenu).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "MenuContext": {
      "type": "any"
    },
    "Meter": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Meter.tsx:Meter",
      "name": "Meter",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Meter.tsx:MeterProps",
        "name": "MeterProps",
        "properties": {
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "formatOptions": {
            "type": "property",
            "name": "formatOptions",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions"
            },
            "optional": true,
            "description": "The display format of the value label.",
            "default": "{style: 'percent'}"
          },
          "valueLabel": {
            "type": "property",
            "name": "valueLabel",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the value's label (e.g. 1 of 4).",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": "0"
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The smallest value allowed for the input.",
            "default": "0"
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The largest value allowed for the input.",
            "default": "100"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "informative"
                },
                {
                  "type": "string",
                  "value": "positive"
                },
                {
                  "type": "string",
                  "value": "notice"
                },
                {
                  "type": "string",
                  "value": "negative"
                }
              ]
            },
            "optional": true,
            "description": "The [visual style](https://spectrum.adobe.com/page/meter/#-Options) of the Meter.",
            "default": "'informative'"
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Meter.",
            "default": "'M'"
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "The static color style to apply. Useful when the button appears over a color background.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Meters are visual representations of a quantity or an achievement.\nTheir progress is determined by user actions, rather than system actions."
    },
    "MeterContext": {
      "type": "any"
    },
    "NotificationBadge": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/NotificationBadge.tsx:NotificationBadge",
      "name": "NotificationBadge",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/NotificationBadge.tsx:NotificationBadgeProps",
        "name": "NotificationBadgeProps",
        "properties": {
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The value to be displayed in the notification badge.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the notification badge.",
            "default": "'S'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Notification badges are used to indicate new or pending activity ."
    },
    "NotificationBadgeContext": {
      "type": "any"
    },
    "NumberField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/NumberField.tsx:NumberField",
      "name": "NumberField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/NumberField.tsx:NumberFieldProps",
        "name": "NumberFieldProps",
        "properties": {
          "hideStepper": {
            "type": "property",
            "name": "hideStepper",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to hide the increment and decrement buttons.",
            "default": "false"
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the NumberField.",
            "default": "'M'"
          },
          "decrementAriaLabel": {
            "type": "property",
            "name": "decrementAriaLabel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A custom aria-label for the decrement button. If not provided, the localized string \"Decrement\" is used.",
            "default": null
          },
          "incrementAriaLabel": {
            "type": "property",
            "name": "incrementAriaLabel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A custom aria-label for the increment button. If not provided, the localized string \"Increment\" is used.",
            "default": null
          },
          "isWheelDisabled": {
            "type": "property",
            "name": "isWheelDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Enables or disables changing the value with scroll.",
            "default": null
          },
          "formatOptions": {
            "type": "property",
            "name": "formatOptions",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions"
            },
            "optional": true,
            "description": "Formatting options for the value displayed in the number field.\nThis also affects what characters are allowed to be typed by the user.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "number"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The smallest value allowed for the input.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The largest value allowed for the input.",
            "default": null
          },
          "step": {
            "type": "property",
            "name": "step",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The amount that the input value changes with each increment or decrement \"tick\".",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "onCopy": {
            "type": "property",
            "name": "onCopy",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
            "default": null
          },
          "onCut": {
            "type": "property",
            "name": "onCut",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
            "default": null
          },
          "onPaste": {
            "type": "property",
            "name": "onPaste",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
            "default": null
          },
          "onCompositionStart": {
            "type": "property",
            "name": "onCompositionStart",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
            "default": null
          },
          "onCompositionEnd": {
            "type": "property",
            "name": "onCompositionEnd",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
            "default": null
          },
          "onCompositionUpdate": {
            "type": "property",
            "name": "onCompositionUpdate",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
            "default": null
          },
          "onBeforeInput": {
            "type": "property",
            "name": "onBeforeInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
            "default": null
          },
          "onInput": {
            "type": "property",
            "name": "onInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/textfield/src/index.d.ts:TextFieldRef"
          }
        ]
      },
      "description": "NumberFields allow users to input number values with a keyboard or increment/decrement with step buttons."
    },
    "NumberFieldContext": {
      "type": "any"
    },
    "Picker": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:Picker",
      "name": "Picker",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:PickerProps",
        "name": "PickerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": false,
            "description": "The contents of the collection.",
            "default": null
          },
          "direction": {
            "type": "property",
            "name": "direction",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "bottom"
                },
                {
                  "type": "string",
                  "value": "top"
                }
              ]
            },
            "optional": true,
            "description": "Direction the menu will render relative to the Picker.",
            "default": "'bottom'"
          },
          "align": {
            "type": "property",
            "name": "align",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "Alignment of the menu relative to the input target.",
            "default": "'start'"
          },
          "menuWidth": {
            "type": "property",
            "name": "menuWidth",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "Width of the menu. By default, matches width of the trigger. Note that the minimum width of the dropdown is always equal to the trigger's width.",
            "default": null
          },
          "loadingState": {
            "type": "property",
            "name": "loadingState",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState"
            },
            "optional": true,
            "description": "The current loading state of the Picker.",
            "default": null
          },
          "placeholder": {
            "type": "property",
            "name": "placeholder",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Temporary text that occupies the select when it is empty.",
            "default": "'Select an item' (localized)"
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input, used when submitting an HTML form.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "Whether single or multiple selection is enabled.",
            "default": "'single'"
          },
          "selectedKey": {
            "type": "property",
            "name": "selectedKey",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The currently selected key in the collection (controlled).",
            "access": "private",
            "default": null
          },
          "defaultSelectedKey": {
            "type": "property",
            "name": "defaultSelectedKey",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The initial selected key in the collection (uncontrolled).",
            "access": "private",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "access": "private",
            "default": null
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Sets the open state of the menu.",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Sets the default open state of the menu.",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Method that is called when the open state of the menu changes.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValidationType"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Picker.",
            "default": "'M'"
          },
          "isQuiet": {
            "type": "property",
            "name": "isQuiet",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the picker should be displayed with a quiet style.",
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "shouldFlip": {
            "type": "property",
            "name": "shouldFlip",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
            "default": "true"
          },
          "onLoadMore": {
            "type": "property",
            "name": "onLoadMore",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "object",
              "properties": null
            },
            "default": null
          },
          {
            "type": "typeParameter",
            "name": "M",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:SelectionMode"
            },
            "default": {
              "type": "string",
              "value": "single"
            }
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "M",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:SelectionMode"
          },
          "default": {
            "type": "string",
            "value": "single"
          }
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLButtonElement"
          }
        ]
      },
      "description": "Pickers allow users to choose a single option from a collapsible list of options when space is limited."
    },
    "PickerItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:PickerItem",
      "name": "PickerItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:PickerItemProps",
        "name": "PickerItemProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the item.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the item's contents, used for features like typeahead.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for this item.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "PickerSection": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:PickerSection",
      "name": "PickerSection",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:PickerSectionProps",
        "name": "PickerSectionProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the section.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Static child items or a function to render children.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for the section.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the section.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "object",
              "properties": null
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": null,
      "description": null
    },
    "PickerContext": {
      "type": "any"
    },
    "Popover": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Popover.tsx:Popover",
      "name": "Popover",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Popover.tsx:PopoverDialogProps",
        "name": "PopoverDialogProps",
        "properties": {
          "hideArrow": {
            "type": "property",
            "name": "hideArrow",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether a popover's arrow should be hidden.",
            "default": "false"
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Popover. If not specified, the popover fits its contents.",
            "default": null
          },
          "triggerRef": {
            "type": "property",
            "name": "triggerRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Element"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The ref for the element which the popover positions itself with respect to.\n\nWhen used within a trigger component such as DialogTrigger, MenuTrigger, Select, etc.,\nthis is set automatically. It is only required when used standalone.",
            "default": null
          },
          "offset": {
            "type": "property",
            "name": "offset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
            "default": "8"
          },
          "placement": {
            "type": "property",
            "name": "placement",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement"
            },
            "optional": true,
            "description": "The placement of the element with respect to its anchor element.",
            "default": "'bottom'"
          },
          "containerPadding": {
            "type": "property",
            "name": "containerPadding",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
            "default": "12"
          },
          "crossOffset": {
            "type": "property",
            "name": "crossOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
            "default": "0"
          },
          "shouldFlip": {
            "type": "property",
            "name": "shouldFlip",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
            "default": "true"
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "opts",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "dialog"
                },
                {
                  "type": "string",
                  "value": "alertdialog"
                }
              ]
            },
            "optional": true,
            "description": "The accessibility role for the dialog.",
            "default": "'dialog'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
      },
      "description": "A popover is an overlay element positioned relative to a trigger."
    },
    "ProgressBar": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ProgressBar.tsx:ProgressBar",
      "name": "ProgressBar",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ProgressBar.tsx:ProgressBarProps",
        "name": "ProgressBarProps",
        "properties": {
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "isIndeterminate": {
            "type": "property",
            "name": "isIndeterminate",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether presentation is indeterminate when progress isn't known.",
            "default": null
          },
          "formatOptions": {
            "type": "property",
            "name": "formatOptions",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions"
            },
            "optional": true,
            "description": "The display format of the value label.",
            "default": "{style: 'percent'}"
          },
          "valueLabel": {
            "type": "property",
            "name": "valueLabel",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the value's label (e.g. 1 of 4).",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": "0"
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The smallest value allowed for the input.",
            "default": "0"
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The largest value allowed for the input.",
            "default": "100"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the ProgressBar.",
            "default": "'M'"
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "The static color style to apply. Useful when the button appears over a color background.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "ProgressBars show the progression of a system operation: downloading, uploading, processing, etc., in a visual way.\nThey can represent either determinate or indeterminate progress."
    },
    "ProgressBarContext": {
      "type": "any"
    },
    "ProgressCircle": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ProgressCircle.tsx:ProgressCircle",
      "name": "ProgressCircle",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ProgressCircle.tsx:ProgressCircleProps",
        "name": "ProgressCircleProps",
        "properties": {
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "isIndeterminate": {
            "type": "property",
            "name": "isIndeterminate",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether presentation is indeterminate when progress isn't known.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": "0"
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The smallest value allowed for the input.",
            "default": "0"
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The largest value allowed for the input.",
            "default": "100"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "The size of the ProgressCircle.",
            "default": "'M'"
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "The static color style to apply. Useful when the button appears over a color background.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "ProgressCircles show the progression of a system operation such as downloading, uploading, or processing, in a visual way.\nThey can represent determinate or indeterminate progress."
    },
    "ProgressCircleContext": {
      "type": "any"
    },
    "Provider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Provider.tsx:Provider",
      "name": "Provider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Provider.tsx:ProviderProps",
        "name": "ProviderProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content of the Provider.",
            "default": null
          },
          "locale": {
            "type": "property",
            "name": "locale",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The locale for your application as a [BCP 47](https://www.ietf.org/rfc/bcp/bcp47.txt) language code.\nDefaults to the browser/OS language setting.",
            "default": "'en-US'"
          },
          "router": {
            "type": "property",
            "name": "router",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Router"
            },
            "optional": true,
            "description": "Provides a client side router to all nested React Spectrum links to enable client side navigation.",
            "default": null
          },
          "colorScheme": {
            "type": "property",
            "name": "colorScheme",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/provider/src/index.d.ts:ColorScheme"
            },
            "optional": true,
            "description": "The color scheme for your application.\nDefaults to operating system preferences.",
            "default": null
          },
          "background": {
            "type": "property",
            "name": "background",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "base"
                },
                {
                  "type": "string",
                  "value": "layer-1"
                },
                {
                  "type": "string",
                  "value": "layer-2"
                }
              ]
            },
            "optional": true,
            "description": "The background for this provider. If not provided, the background is transparent.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "elementType": {
            "type": "property",
            "name": "elementType",
            "indexType": null,
            "value": {
              "type": "typeOperator",
              "operator": "keyof",
              "value": {
                "type": "identifier",
                "name": "JSX.IntrinsicElements"
              }
            },
            "optional": true,
            "description": "The DOM element to render.",
            "default": "div"
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "Radio": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Radio.tsx:Radio",
      "name": "Radio",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Radio.tsx:RadioProps",
        "name": "RadioProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The label for the element.",
            "default": null
          },
          "inputRef": {
            "type": "property",
            "name": "inputRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "A ref for the HTML input element.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": false,
            "description": "The value of the radio button, used when submitting an HTML form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio#Value).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the radio button is disabled or not.\nShows that a selection exists, but is not available in that circumstance.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLLabelElement"
          }
        ]
      },
      "description": "Radio buttons allow users to select a single option from a list of mutually exclusive options.\nAll possible options are exposed up front for users to compare."
    },
    "RadioGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/RadioGroup.tsx:RadioGroup",
      "name": "RadioGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/RadioGroup.tsx:RadioGroupProps",
        "name": "RadioGroupProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The Radios contained within the RadioGroup.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the RadioGroup.",
            "default": "'M'"
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The axis the radio elements should align with.",
            "default": "'vertical'"
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the RadioGroup should be displayed with an emphasized style.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Radio groups allow users to select a single option from a list of mutually exclusive options.\nAll possible options are exposed up front for users to compare."
    },
    "RadioGroupContext": {
      "type": "any"
    },
    "RangeCalendar": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/RangeCalendar.tsx:RangeCalendar",
      "name": "RangeCalendar",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/RangeCalendar.tsx:RangeCalendarProps",
        "name": "RangeCalendarProps",
        "properties": {
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The error message to display when the calendar is invalid.",
            "default": null
          },
          "visibleMonths": {
            "type": "property",
            "name": "visibleMonths",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The number of months to display at once.",
            "default": "1"
          },
          "createCalendar": {
            "type": "property",
            "name": "createCalendar",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "identifier",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function to create a new [Calendar](https://react-spectrum.adobe.com/internationalized/date/Calendar.html)\nobject for a given calendar identifier. If not provided, the `createCalendar` function\nfrom `@internationalized/date` will be used.",
            "default": null
          },
          "allowsNonContiguousRanges": {
            "type": "property",
            "name": "allowsNonContiguousRanges",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "When combined with `isDateUnavailable`, determines whether non-contiguous ranges,\ni.e. ranges containing unavailable dates, may be selected.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed date that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed date that a user may select.",
            "default": null
          },
          "isDateUnavailable": {
            "type": "property",
            "name": "isDateUnavailable",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the calendar is disabled.",
            "default": "false"
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the calendar value is immutable.",
            "default": "false"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to automatically focus the calendar when it mounts.",
            "default": "false"
          },
          "focusedValue": {
            "type": "property",
            "name": "focusedValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "Controls the currently focused date within the calendar.",
            "default": null
          },
          "defaultFocusedValue": {
            "type": "property",
            "name": "defaultFocusedValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The date that is focused when the calendar first mounts (uncountrolled).",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "date",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the focused date changes.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the current selection is invalid according to application logic.",
            "default": null
          },
          "pageBehavior": {
            "type": "property",
            "name": "pageBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
            },
            "optional": true,
            "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
            "default": "visible"
          },
          "firstDayOfWeek": {
            "type": "property",
            "name": "firstDayOfWeek",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "sun"
                },
                {
                  "type": "string",
                  "value": "mon"
                },
                {
                  "type": "string",
                  "value": "tue"
                },
                {
                  "type": "string",
                  "value": "wed"
                },
                {
                  "type": "string",
                  "value": "thu"
                },
                {
                  "type": "string",
                  "value": "fri"
                },
                {
                  "type": "string",
                  "value": "sat"
                }
              ]
            },
            "optional": true,
            "description": "The day that starts the week.",
            "default": null
          },
          "selectionAlignment": {
            "type": "property",
            "name": "selectionAlignment",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "center"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "Determines the alignment of the visible months on initial render based on the current selection or current date if there is no selection.",
            "default": "'center'"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                    },
                    "typeParameters": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                          }
                        ]
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The children of the component. A function may be provided to alter the children based on component state.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "RangeCalendarContext": {
      "type": "any"
    },
    "RangeSlider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/RangeSlider.tsx:RangeSlider",
      "name": "RangeSlider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/RangeSlider.tsx:RangeSliderProps",
        "name": "RangeSliderProps",
        "properties": {
          "startName": {
            "type": "property",
            "name": "startName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the start input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "endName": {
            "type": "property",
            "name": "endName",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the end input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Slider.",
            "default": "'M'"
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Slider should be displayed with an emphasized style.",
            "default": null
          },
          "trackStyle": {
            "type": "property",
            "name": "trackStyle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "thin"
                },
                {
                  "type": "string",
                  "value": "thick"
                }
              ]
            },
            "optional": true,
            "description": "The style of the Slider's track.",
            "default": "'thin'"
          },
          "thumbStyle": {
            "type": "property",
            "name": "thumbStyle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "default"
                },
                {
                  "type": "string",
                  "value": "precise"
                }
              ]
            },
            "optional": true,
            "description": "The style of the Slider's thumb.",
            "default": "'default'"
          },
          "formatOptions": {
            "type": "property",
            "name": "formatOptions",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions"
            },
            "optional": true,
            "description": "The display format of the value label.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the whole Slider is disabled.",
            "default": null
          },
          "onChangeEnd": {
            "type": "property",
            "name": "onChangeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Fired when the slider stops moving, due to being let go.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The slider's minimum value.",
            "default": "0"
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The slider's maximum value.",
            "default": "100"
          },
          "step": {
            "type": "property",
            "name": "step",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The slider's step value.",
            "default": "1"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "RangeSliderContext": {
      "type": "any"
    },
    "SearchField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SearchField.tsx:SearchField",
      "name": "SearchField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SearchField.tsx:SearchFieldProps",
        "name": "SearchFieldProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the SearchField.",
            "default": "'M'"
          },
          "enterKeyHint": {
            "type": "property",
            "name": "enterKeyHint",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "enter"
                },
                {
                  "type": "string",
                  "value": "done"
                },
                {
                  "type": "string",
                  "value": "go"
                },
                {
                  "type": "string",
                  "value": "next"
                },
                {
                  "type": "string",
                  "value": "previous"
                },
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "send"
                }
              ]
            },
            "optional": true,
            "description": "An enumerated attribute that defines what action label or icon to preset for the enter key on virtual keyboards. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint).",
            "default": null
          },
          "type": {
            "type": "property",
            "name": "type",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "url"
                },
                {
                  "type": "string",
                  "value": "tel"
                },
                {
                  "type": "string",
                  "value": "email"
                },
                {
                  "type": "string",
                  "value": "password"
                },
                {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "object",
                      "properties": {}
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
            "default": "'search'"
          },
          "onSubmit": {
            "type": "property",
            "name": "onSubmit",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the SearchField is submitted.",
            "default": null
          },
          "onClear": {
            "type": "property",
            "name": "onClear",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the clear button is pressed.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-activedescendant": {
            "type": "property",
            "name": "aria-activedescendant",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
            "default": null
          },
          "aria-autocomplete": {
            "type": "property",
            "name": "aria-autocomplete",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "inline"
                },
                {
                  "type": "string",
                  "value": "list"
                },
                {
                  "type": "string",
                  "value": "both"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
            "default": null
          },
          "aria-haspopup": {
            "type": "property",
            "name": "aria-haspopup",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "menu"
                },
                {
                  "type": "string",
                  "value": "listbox"
                },
                {
                  "type": "string",
                  "value": "tree"
                },
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "dialog"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "maxLength": {
            "type": "property",
            "name": "maxLength",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
            "default": null
          },
          "minLength": {
            "type": "property",
            "name": "minLength",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
            "default": null
          },
          "pattern": {
            "type": "property",
            "name": "pattern",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
            "default": null
          },
          "inputMode": {
            "type": "property",
            "name": "inputMode",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "tel"
                },
                {
                  "type": "string",
                  "value": "url"
                },
                {
                  "type": "string",
                  "value": "email"
                },
                {
                  "type": "string",
                  "value": "numeric"
                },
                {
                  "type": "string",
                  "value": "decimal"
                },
                {
                  "type": "string",
                  "value": "search"
                }
              ]
            },
            "optional": true,
            "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
            "default": null
          },
          "autoCorrect": {
            "type": "property",
            "name": "autoCorrect",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An attribute that takes as its value a space-separated string that describes what, if any, type of autocomplete functionality the input should provide. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#autocomplete).",
            "default": null
          },
          "spellCheck": {
            "type": "property",
            "name": "spellCheck",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An enumerated attribute that defines whether the element may be checked for spelling errors. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "onCopy": {
            "type": "property",
            "name": "onCopy",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
            "default": null
          },
          "onCut": {
            "type": "property",
            "name": "onCut",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
            "default": null
          },
          "onPaste": {
            "type": "property",
            "name": "onPaste",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
            "default": null
          },
          "onCompositionStart": {
            "type": "property",
            "name": "onCompositionStart",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
            "default": null
          },
          "onCompositionEnd": {
            "type": "property",
            "name": "onCompositionEnd",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
            "default": null
          },
          "onCompositionUpdate": {
            "type": "property",
            "name": "onCompositionUpdate",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
            "default": null
          },
          "onBeforeInput": {
            "type": "property",
            "name": "onBeforeInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
            "default": null
          },
          "onInput": {
            "type": "property",
            "name": "onInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/textfield/src/index.d.ts:TextFieldRef"
          }
        ]
      },
      "description": "A SearchField is a text field designed for searches."
    },
    "SearchFieldContext": {
      "type": "any"
    },
    "SegmentedControl": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SegmentedControl.tsx:SegmentedControl",
      "name": "SegmentedControl",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SegmentedControl.tsx:SegmentedControlProps",
        "name": "SegmentedControlProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the segmented control.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the segmented control is disabled.",
            "default": null
          },
          "isJustified": {
            "type": "property",
            "name": "isJustified",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the items should divide the container width equally.",
            "default": null
          },
          "selectedKey": {
            "type": "property",
            "name": "selectedKey",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The id of the currently selected item (controlled).",
            "default": null
          },
          "defaultSelectedKey": {
            "type": "property",
            "name": "defaultSelectedKey",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The id of the initial selected item (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "id",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A SegmentedControl is a mutually exclusive group of buttons used for view switching."
    },
    "SegmentedControlItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SegmentedControl.tsx:SegmentedControlItem",
      "name": "SegmentedControlItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SegmentedControl.tsx:SegmentedControlItemProps",
        "name": "SegmentedControlItemProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the segmented control item.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": false,
            "description": "The id of the item, matching the value used in SegmentedControl's `selectedKey` prop.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled or not.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLButtonElement"
          }
        ]
      },
      "description": "A SegmentedControlItem represents an option within a SegmentedControl."
    },
    "SegmentedControlContext": {
      "type": "any"
    },
    "SelectBox": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SelectBoxGroup.tsx:SelectBox",
      "name": "SelectBox",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SelectBoxGroup.tsx:SelectBoxProps",
        "name": "SelectBoxProps",
        "properties": {
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the SelectBox.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the SelectBox's contents, used for features like typeahead.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for this item.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The contents of the SelectBox.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the SelectBox is disabled.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "SelectBox is a single selectable item in a SelectBoxGroup."
    },
    "SelectBoxGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SelectBoxGroup.tsx:SelectBoxGroup",
      "name": "SelectBoxGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SelectBoxGroup.tsx:SelectBoxGroupProps",
        "name": "SelectBoxGroupProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The SelectBox elements contained within the SelectBoxGroup.",
            "default": null
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The layout direction of the content in each SelectBox.",
            "default": "'vertical'"
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "single"
                },
                {
                  "type": "string",
                  "value": "multiple"
                }
              ]
            },
            "optional": true,
            "description": "The selection mode for the SelectBoxGroup.",
            "default": "'single'"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the SelectBoxGroup is disabled.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the listbox or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                }
              ]
            },
            "optional": true,
            "description": "Whether to auto focus the listbox or an option.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "SelectBoxGroupContext": {
      "type": "any"
    },
    "Slider": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Slider.tsx:Slider",
      "name": "Slider",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Slider.tsx:SliderProps",
        "name": "SliderProps",
        "properties": {
          "fillOffset": {
            "type": "property",
            "name": "fillOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The offset from which to start the fill.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Slider.",
            "default": "'M'"
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Slider should be displayed with an emphasized style.",
            "default": null
          },
          "trackStyle": {
            "type": "property",
            "name": "trackStyle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "thin"
                },
                {
                  "type": "string",
                  "value": "thick"
                }
              ]
            },
            "optional": true,
            "description": "The style of the Slider's track.",
            "default": "'thin'"
          },
          "thumbStyle": {
            "type": "property",
            "name": "thumbStyle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "default"
                },
                {
                  "type": "string",
                  "value": "precise"
                }
              ]
            },
            "optional": true,
            "description": "The style of the Slider's thumb.",
            "default": "'default'"
          },
          "formatOptions": {
            "type": "property",
            "name": "formatOptions",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions"
            },
            "optional": true,
            "description": "The display format of the value label.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the whole Slider is disabled.",
            "default": null
          },
          "onChangeEnd": {
            "type": "property",
            "name": "onChangeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Fired when the slider stops moving, due to being let go.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The slider's minimum value.",
            "default": "0"
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The slider's maximum value.",
            "default": "100"
          },
          "step": {
            "type": "property",
            "name": "step",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The slider's step value.",
            "default": "1"
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Sliders allow users to quickly select a value within a range. They should be used when the upper and lower bounds to the range are invariable."
    },
    "SliderContext": {
      "type": "any"
    },
    "Skeleton": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Skeleton.tsx:Skeleton",
      "name": "Skeleton",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Skeleton.tsx:SkeletonProps",
        "name": "SkeletonProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "default": null
          },
          "isLoading": {
            "type": "property",
            "name": "isLoading",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": false,
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "A Skeleton wraps around content to render it as a placeholder."
    },
    "useIsSkeleton": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Skeleton.tsx:useIsSkeleton",
      "name": "useIsSkeleton",
      "parameters": [],
      "return": {
        "type": "boolean",
        "description": null
      },
      "typeParameters": []
    },
    "SkeletonCollection": {
      "type": "function",
      "id": null,
      "name": null,
      "parameters": [
        {
          "type": "parameter",
          "name": "props",
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SkeletonCollection.tsx:SkeletonCollectionProps"
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "ref",
          "value": {
            "type": "any"
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "node",
          "value": {
            "type": "any"
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "any",
        "description": null
      },
      "typeParameters": [],
      "description": "A SkeletonCollection generates placeholder content within a collection component such as CardView."
    },
    "StatusLight": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/StatusLight.tsx:StatusLight",
      "name": "StatusLight",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/StatusLight.tsx:StatusLightProps",
        "name": "StatusLightProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "role": {
            "type": "property",
            "name": "role",
            "indexType": null,
            "value": {
              "type": "string",
              "value": "status"
            },
            "optional": true,
            "description": "An accessibility role for the status light. Should be set when the status\ncan change at runtime, and no more than one status light will update simultaneously.\nFor cases where multiple statuses can change at the same time, use a Toast instead.",
            "default": null
          },
          "variant": {
            "type": "property",
            "name": "variant",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "informative"
                },
                {
                  "type": "string",
                  "value": "neutral"
                },
                {
                  "type": "string",
                  "value": "positive"
                },
                {
                  "type": "string",
                  "value": "notice"
                },
                {
                  "type": "string",
                  "value": "negative"
                },
                {
                  "type": "string",
                  "value": "celery"
                },
                {
                  "type": "string",
                  "value": "chartreuse"
                },
                {
                  "type": "string",
                  "value": "cyan"
                },
                {
                  "type": "string",
                  "value": "fuchsia"
                },
                {
                  "type": "string",
                  "value": "purple"
                },
                {
                  "type": "string",
                  "value": "magenta"
                },
                {
                  "type": "string",
                  "value": "indigo"
                },
                {
                  "type": "string",
                  "value": "seafoam"
                },
                {
                  "type": "string",
                  "value": "yellow"
                },
                {
                  "type": "string",
                  "value": "pink"
                },
                {
                  "type": "string",
                  "value": "turquoise"
                },
                {
                  "type": "string",
                  "value": "cinnamon"
                },
                {
                  "type": "string",
                  "value": "brown"
                },
                {
                  "type": "string",
                  "value": "silver"
                }
              ]
            },
            "optional": false,
            "description": "The variant changes the color of the status light.\nWhen status lights have a semantic meaning, they should use the variant for semantic colors.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the StatusLight.",
            "default": "'M'"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Status lights are used to color code categories and labels commonly found in data visualization.\nWhen status lights have a semantic meaning, they should use semantic variant colors."
    },
    "StatusLightContext": {
      "type": "any"
    },
    "Switch": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Switch.tsx:Switch",
      "name": "Switch",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Switch.tsx:SwitchProps",
        "name": "SwitchProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "default": null
          },
          "inputRef": {
            "type": "property",
            "name": "inputRef",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "A ref for the HTML input element.",
            "default": null
          },
          "defaultSelected": {
            "type": "property",
            "name": "defaultSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Switch should be selected (uncontrolled).",
            "default": null
          },
          "isSelected": {
            "type": "property",
            "name": "isSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Switch should be selected (controlled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isSelected",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the Switch's selection state changes.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the Switch.",
            "default": "'M'"
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Switch should be displayed with an emphasized style.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLLabelElement"
          }
        ]
      },
      "description": "Switches allow users to turn an individual option on or off.\nThey are usually used to activate or deactivate a specific setting."
    },
    "SwitchContext": {
      "type": "any"
    },
    "TableView": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:TableView",
      "name": "TableView",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:TableViewProps",
        "name": "TableViewProps",
        "properties": {
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The elements that make up the table. Includes the TableHeader, TableBody, Columns, and Rows.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "optional": true,
            "description": "A list of row keys to disable.",
            "default": null
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the table or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "shouldSelectOnPressUp": {
            "type": "property",
            "name": "shouldSelectOnPressUp",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether selection should occur on press up instead of press down.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "sortDescriptor": {
            "type": "property",
            "name": "sortDescriptor",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor"
            },
            "optional": true,
            "description": "The current sorted column and direction.",
            "default": null
          },
          "onSortChange": {
            "type": "property",
            "name": "onSortChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "descriptor",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the sorted column or direction changes.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "isQuiet": {
            "type": "property",
            "name": "isQuiet",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the Table should be displayed with a quiet style.",
            "default": null
          },
          "density": {
            "type": "property",
            "name": "density",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "compact"
                },
                {
                  "type": "string",
                  "value": "spacious"
                },
                {
                  "type": "string",
                  "value": "regular"
                }
              ]
            },
            "optional": true,
            "description": "Sets the amount of vertical padding within each cell.",
            "default": "'regular'"
          },
          "overflowMode": {
            "type": "property",
            "name": "overflowMode",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "wrap"
                },
                {
                  "type": "string",
                  "value": "truncate"
                }
              ]
            },
            "optional": true,
            "description": "Sets the overflow behavior for the cell contents.",
            "default": "'truncate'"
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on a row.",
            "default": null
          },
          "onResizeStart": {
            "type": "property",
            "name": "onResizeStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "widths",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Map"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      },
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user starts a column resize.",
            "default": null
          },
          "onResize": {
            "type": "property",
            "name": "onResize",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "widths",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Map"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      },
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs a column resize.\nCan be used with the width property on columns to put the column widths into\na controlled state.",
            "default": null
          },
          "onResizeEnd": {
            "type": "property",
            "name": "onResizeEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "widths",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Map"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      },
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called after a user performs a column resize.\nCan be used to store the widths of columns for another future session.",
            "default": null
          },
          "loadingState": {
            "type": "property",
            "name": "loadingState",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState"
            },
            "optional": true,
            "description": "The current loading state of the table.",
            "default": null
          },
          "onLoadMore": {
            "type": "property",
            "name": "onLoadMore",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
            "default": null
          },
          "renderActionBar": {
            "type": "property",
            "name": "renderActionBar",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "selectedKeys",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "string",
                        "value": "all"
                      },
                      {
                        "type": "application",
                        "base": {
                          "type": "identifier",
                          "name": "Set"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                          }
                        ]
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactElement"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides the ActionBar to display when rows are selected in the TableView.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Tables are containers for displaying information. They allow users to quickly scan, sort, compare, and take action on large amounts of data."
    },
    "TableHeader": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:TableHeader",
      "name": "TableHeader",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:TableHeaderProps",
        "name": "TableHeaderProps",
        "properties": {
          "columns": {
            "type": "property",
            "name": "columns",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "A list of table columns.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "A list of `Column(s)` or a function. If the latter, a list of columns must be provided using the `columns` prop.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the column cache when using dynamic collections.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A header within a `<Table>`, containing the table columns."
    },
    "TableBody": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:TableBody",
      "name": "TableBody",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:TableBodyProps",
        "name": "TableBodyProps",
        "properties": {
          "renderEmptyState": {
            "type": "property",
            "name": "renderEmptyState",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "props",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides content to display when there are no rows in the table.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableSectionElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "The body of a `<Table>`, containing the table rows."
    },
    "Row": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:Row",
      "name": "Row",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:RowProps",
        "name": "RowProps",
        "properties": {
          "columns": {
            "type": "property",
            "name": "columns",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "A list of columns used when dynamically rendering cells.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactElement"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The cells within the row. Supports static items or a function for dynamic rendering.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the cell cache when using dynamic collections.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the row's contents, used for features like typeahead.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the row.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A row within a `<Table>`."
    },
    "Cell": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:Cell",
      "name": "Cell",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:CellProps",
        "name": "CellProps",
        "properties": {
          "isSticky": {
            "type": "property",
            "name": "isSticky",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to render as the cell children.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the cell.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the cell's contents, used for features like typeahead.",
            "default": null
          },
          "colSpan": {
            "type": "property",
            "name": "colSpan",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "Indicates how many columns the data cell spans.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "showDivider": {
            "type": "property",
            "name": "showDivider",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the column should render a divider between it and the next column.",
            "default": null
          },
          "align": {
            "type": "property",
            "name": "align",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "center"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "The alignment of the column's contents relative to its allotted width.",
            "default": "'start'"
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A cell within a table row."
    },
    "Column": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:Column",
      "name": "Column",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:ColumnProps",
        "name": "ColumnProps",
        "properties": {
          "showDivider": {
            "type": "property",
            "name": "showDivider",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the column should render a divider between it and the next column.",
            "default": null
          },
          "allowsResizing": {
            "type": "property",
            "name": "allowsResizing",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the column allows resizing.",
            "default": null
          },
          "align": {
            "type": "property",
            "name": "align",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "center"
                },
                {
                  "type": "string",
                  "value": "end"
                }
              ]
            },
            "optional": true,
            "description": "The alignment of the column's contents relative to its allotted width.",
            "default": "'start'"
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to render as the column header.",
            "default": null
          },
          "menuItems": {
            "type": "property",
            "name": "menuItems",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "Menu fragment to be rendered inside the column header's menu.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the column.",
            "default": null
          },
          "allowsSorting": {
            "type": "property",
            "name": "allowsSorting",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the column allows sorting.",
            "default": null
          },
          "isRowHeader": {
            "type": "property",
            "name": "isRowHeader",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether a column is a [row header](https://www.w3.org/TR/wai-aria-1.1/#rowheader) and should be announced by assistive technology during row navigation.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the column's contents, used for accessibility announcements.",
            "default": null
          },
          "width": {
            "type": "property",
            "name": "width",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
            "default": null
          },
          "defaultWidth": {
            "type": "property",
            "name": "defaultWidth",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
            "default": null
          },
          "minWidth": {
            "type": "property",
            "name": "minWidth",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
            "default": null
          },
          "maxWidth": {
            "type": "property",
            "name": "maxWidth",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps"
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLTableHeaderCellElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A column within a `<Table>`."
    },
    "TableContext": {
      "type": "any"
    },
    "Tabs": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:Tabs",
      "name": "Tabs",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:TabsProps",
        "name": "TabsProps",
        "properties": {
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the tabs.",
            "default": null
          },
          "density": {
            "type": "property",
            "name": "density",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "compact"
                },
                {
                  "type": "string",
                  "value": "regular"
                }
              ]
            },
            "optional": true,
            "description": "The amount of space between the tabs.",
            "default": "'regular'"
          },
          "labelBehavior": {
            "type": "property",
            "name": "labelBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "show"
                },
                {
                  "type": "string",
                  "value": "hide"
                }
              ]
            },
            "optional": true,
            "description": "Defines if the text within the tabs should be hidden and only the icon should be shown.\nThe text is always visible when the item is collapsed into a picker.",
            "default": "'show'"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the TabList is disabled.\nShows that a selection exists, but is not available in that circumstance.",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectedKey": {
            "type": "property",
            "name": "selectedKey",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The currently selected key in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKey": {
            "type": "property",
            "name": "defaultSelectedKey",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "Key"
            },
            "optional": true,
            "description": "The initial selected key in the collection (uncontrolled).",
            "default": null
          },
          "keyboardActivation": {
            "type": "property",
            "name": "keyboardActivation",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "automatic"
                },
                {
                  "type": "string",
                  "value": "manual"
                }
              ]
            },
            "optional": true,
            "description": "Whether tabs are activated automatically on focus or manually.",
            "default": "'automatic'"
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
            },
            "optional": true,
            "description": "The orientation of the tabs.",
            "default": "'horizontal'"
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Tabs organize content into multiple sections and allow users to navigate between them. The content under the set of tabs should be related and form a coherent unit."
    },
    "TabList": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:TabList",
      "name": "TabList",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:TabListProps",
        "name": "TabListProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": false,
            "description": "The content to display in the tablist.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": null,
      "description": null
    },
    "Tab": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:Tab",
      "name": "Tab",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:TabProps",
        "name": "TabProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the tab.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the tab.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tab is disabled.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "TabPanel": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:TabPanel",
      "name": "TabPanel",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:TabPanelProps",
        "name": "TabPanelProps",
        "properties": {
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the tab panels.",
            "default": null
          },
          "shouldForceMount": {
            "type": "property",
            "name": "shouldForceMount",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to mount the tab panel in the DOM even when it is not currently selected.\nInactive tab panels are inert and cannot be interacted with. They must be styled appropriately so this is clear to the user visually.",
            "default": "false"
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the tab.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "TabsContext": {
      "type": "any"
    },
    "TagGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TagGroup.tsx:TagGroup",
      "name": "TagGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TagGroup.tsx:TagGroupProps",
        "name": "TagGroupProps",
        "properties": {
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the tag group.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                }
              ]
            },
            "optional": true,
            "description": "The size of the tag group.",
            "default": "'M'"
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tags are displayed in an emphasized style.",
            "default": null
          },
          "renderEmptyState": {
            "type": "property",
            "name": "renderEmptyState",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides content to display when there are no items in the tag group.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tags are displayed in a error state.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          },
          "maxRows": {
            "type": "property",
            "name": "maxRows",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "Limit the number of rows initially shown. This will render a button that allows the user to expand to show all tags.",
            "default": null
          },
          "groupActionLabel": {
            "type": "property",
            "name": "groupActionLabel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The label to display on the action button.",
            "default": null
          },
          "onGroupAction": {
            "type": "property",
            "name": "onGroupAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the action button is pressed.",
            "default": null
          },
          "selectionBehavior": {
            "type": "property",
            "name": "selectionBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
            },
            "optional": true,
            "description": "How multiple selection should behave in the collection.",
            "default": null
          },
          "shouldSelectOnPressUp": {
            "type": "property",
            "name": "shouldSelectOnPressUp",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether selection should occur on press up instead of press down.",
            "default": null
          },
          "onRemove": {
            "type": "property",
            "name": "onRemove",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Set"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user deletes a tag.",
            "default": null
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the TagGroup or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Tags allow users to categorize content. They can represent keywords or people, and are grouped to describe an item or a search request."
    },
    "Tag": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TagGroup.tsx:Tag",
      "name": "Tag",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TagGroup.tsx:TagProps",
        "name": "TagProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The children of the tag.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "A unique id for the tag.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A string representation of the tags's contents, used for accessibility.\nRequired if children is not a plain text string.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tag is disabled.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "An individual Tag for TagGroups."
    },
    "TagGroupContext": {
      "type": "any"
    },
    "TextArea": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TextField.tsx:TextArea",
      "name": "TextArea",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TextField.tsx:TextAreaProps",
        "name": "TextAreaProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the text field.",
            "default": "'M'"
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the value is invalid.",
            "default": null
          },
          "aria-activedescendant": {
            "type": "property",
            "name": "aria-activedescendant",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
            "default": null
          },
          "aria-autocomplete": {
            "type": "property",
            "name": "aria-autocomplete",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "inline"
                },
                {
                  "type": "string",
                  "value": "list"
                },
                {
                  "type": "string",
                  "value": "both"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
            "default": null
          },
          "aria-haspopup": {
            "type": "property",
            "name": "aria-haspopup",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "menu"
                },
                {
                  "type": "string",
                  "value": "listbox"
                },
                {
                  "type": "string",
                  "value": "tree"
                },
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "dialog"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "enterKeyHint": {
            "type": "property",
            "name": "enterKeyHint",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "enter"
                },
                {
                  "type": "string",
                  "value": "done"
                },
                {
                  "type": "string",
                  "value": "go"
                },
                {
                  "type": "string",
                  "value": "next"
                },
                {
                  "type": "string",
                  "value": "previous"
                },
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "send"
                }
              ]
            },
            "optional": true,
            "description": "An enumerated attribute that defines what action label or icon to preset for the enter key on virtual keyboards. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "maxLength": {
            "type": "property",
            "name": "maxLength",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
            "default": null
          },
          "minLength": {
            "type": "property",
            "name": "minLength",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
            "default": null
          },
          "inputMode": {
            "type": "property",
            "name": "inputMode",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "tel"
                },
                {
                  "type": "string",
                  "value": "url"
                },
                {
                  "type": "string",
                  "value": "email"
                },
                {
                  "type": "string",
                  "value": "numeric"
                },
                {
                  "type": "string",
                  "value": "decimal"
                },
                {
                  "type": "string",
                  "value": "search"
                }
              ]
            },
            "optional": true,
            "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
            "default": null
          },
          "autoCorrect": {
            "type": "property",
            "name": "autoCorrect",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An attribute that takes as its value a space-separated string that describes what, if any, type of autocomplete functionality the input should provide. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#autocomplete).",
            "default": null
          },
          "spellCheck": {
            "type": "property",
            "name": "spellCheck",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An enumerated attribute that defines whether the element may be checked for spelling errors. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "onCopy": {
            "type": "property",
            "name": "onCopy",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
            "default": null
          },
          "onCut": {
            "type": "property",
            "name": "onCut",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
            "default": null
          },
          "onPaste": {
            "type": "property",
            "name": "onPaste",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
            "default": null
          },
          "onCompositionStart": {
            "type": "property",
            "name": "onCompositionStart",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
            "default": null
          },
          "onCompositionEnd": {
            "type": "property",
            "name": "onCompositionEnd",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
            "default": null
          },
          "onCompositionUpdate": {
            "type": "property",
            "name": "onCompositionUpdate",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
            "default": null
          },
          "onBeforeInput": {
            "type": "property",
            "name": "onBeforeInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
            "default": null
          },
          "onInput": {
            "type": "property",
            "name": "onInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/textfield/src/index.d.ts:TextFieldRef"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLTextAreaElement"
              }
            ]
          }
        ]
      },
      "description": "TextAreas are multiline text inputs, useful for cases where users have\na sizable amount of text to enter. They allow for all customizations that\nare available to text fields."
    },
    "TextField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TextField.tsx:TextField",
      "name": "TextField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TextField.tsx:TextFieldProps",
        "name": "TextFieldProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the text field.",
            "default": "'M'"
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the value is invalid.",
            "default": null
          },
          "aria-activedescendant": {
            "type": "property",
            "name": "aria-activedescendant",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
            "default": null
          },
          "aria-autocomplete": {
            "type": "property",
            "name": "aria-autocomplete",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "inline"
                },
                {
                  "type": "string",
                  "value": "list"
                },
                {
                  "type": "string",
                  "value": "both"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
            "default": null
          },
          "aria-haspopup": {
            "type": "property",
            "name": "aria-haspopup",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "menu"
                },
                {
                  "type": "string",
                  "value": "listbox"
                },
                {
                  "type": "string",
                  "value": "tree"
                },
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "dialog"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "enterKeyHint": {
            "type": "property",
            "name": "enterKeyHint",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "enter"
                },
                {
                  "type": "string",
                  "value": "done"
                },
                {
                  "type": "string",
                  "value": "go"
                },
                {
                  "type": "string",
                  "value": "next"
                },
                {
                  "type": "string",
                  "value": "previous"
                },
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "send"
                }
              ]
            },
            "optional": true,
            "description": "An enumerated attribute that defines what action label or icon to preset for the enter key on virtual keyboards. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint).",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "T"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "identifier",
                    "name": "T"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "autoComplete": {
            "type": "property",
            "name": "autoComplete",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
            "default": null
          },
          "maxLength": {
            "type": "property",
            "name": "maxLength",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
            "default": null
          },
          "minLength": {
            "type": "property",
            "name": "minLength",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
            "default": null
          },
          "pattern": {
            "type": "property",
            "name": "pattern",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
            "default": null
          },
          "type": {
            "type": "property",
            "name": "type",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "search"
                },
                {
                  "type": "string",
                  "value": "url"
                },
                {
                  "type": "string",
                  "value": "tel"
                },
                {
                  "type": "string",
                  "value": "email"
                },
                {
                  "type": "string",
                  "value": "password"
                },
                {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "object",
                      "properties": {}
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
            "default": "'text'"
          },
          "inputMode": {
            "type": "property",
            "name": "inputMode",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "none"
                },
                {
                  "type": "string",
                  "value": "text"
                },
                {
                  "type": "string",
                  "value": "tel"
                },
                {
                  "type": "string",
                  "value": "url"
                },
                {
                  "type": "string",
                  "value": "email"
                },
                {
                  "type": "string",
                  "value": "numeric"
                },
                {
                  "type": "string",
                  "value": "decimal"
                },
                {
                  "type": "string",
                  "value": "search"
                }
              ]
            },
            "optional": true,
            "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
            "default": null
          },
          "autoCorrect": {
            "type": "property",
            "name": "autoCorrect",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An attribute that takes as its value a space-separated string that describes what, if any, type of autocomplete functionality the input should provide. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#autocomplete).",
            "default": null
          },
          "spellCheck": {
            "type": "property",
            "name": "spellCheck",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An enumerated attribute that defines whether the element may be checked for spelling errors. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "onCopy": {
            "type": "property",
            "name": "onCopy",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
            "default": null
          },
          "onCut": {
            "type": "property",
            "name": "onCut",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
            "default": null
          },
          "onPaste": {
            "type": "property",
            "name": "onPaste",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ClipboardEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
            "default": null
          },
          "onCompositionStart": {
            "type": "property",
            "name": "onCompositionStart",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
            "default": null
          },
          "onCompositionEnd": {
            "type": "property",
            "name": "onCompositionEnd",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
            "default": null
          },
          "onCompositionUpdate": {
            "type": "property",
            "name": "onCompositionUpdate",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "CompositionEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReactEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
            "default": null
          },
          "onBeforeInput": {
            "type": "property",
            "name": "onBeforeInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
            "default": null
          },
          "onInput": {
            "type": "property",
            "name": "onInput",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "FormEventHandler"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "HTMLInputElement"
                }
              ]
            },
            "optional": true,
            "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
            "default": null
          },
          "aria-errormessage": {
            "type": "property",
            "name": "aria-errormessage",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element that provides an error message for the object.",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/textfield/src/index.d.ts:TextFieldRef"
          }
        ]
      },
      "description": "TextFields are text inputs that allow users to input custom text entries\nwith a keyboard. Various decorations can be displayed around the field to\ncommunicate the entry requirements."
    },
    "TextAreaContext": {
      "type": "any"
    },
    "TextFieldContext": {
      "type": "any"
    },
    "TimeField": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TimeField.tsx:TimeField",
      "name": "TimeField",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TimeField.tsx:TimeFieldProps",
        "name": "TimeFieldProps",
        "properties": {
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the TimeField.",
            "default": "'M'"
          },
          "hourCycle": {
            "type": "property",
            "name": "hourCycle",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "number",
                  "value": 12
                },
                {
                  "type": "number",
                  "value": 24
                }
              ]
            },
            "optional": true,
            "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
            "default": null
          },
          "granularity": {
            "type": "property",
            "name": "granularity",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "hour"
                },
                {
                  "type": "string",
                  "value": "minute"
                },
                {
                  "type": "string",
                  "value": "second"
                }
              ]
            },
            "optional": true,
            "description": "Determines the smallest unit that is displayed in the time picker.",
            "default": "'minute'"
          },
          "hideTimeZone": {
            "type": "property",
            "name": "hideTimeZone",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to hide the time zone abbreviation.",
            "default": null
          },
          "shouldForceLeadingZeros": {
            "type": "property",
            "name": "shouldForceLeadingZeros",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to always show leading zeros in the hour field.\nBy default, this is determined by the user's locale.",
            "default": null
          },
          "placeholderValue": {
            "type": "property",
            "name": "placeholderValue",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
            },
            "optional": true,
            "description": "A placeholder time that influences the format of the placeholder shown when no value is selected.\nDefaults to 12:00 AM or 00:00 depending on the hour cycle.",
            "default": null
          },
          "minValue": {
            "type": "property",
            "name": "minValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The minimum allowed time that a user may select.",
            "default": null
          },
          "maxValue": {
            "type": "property",
            "name": "maxValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The maximum allowed time that a user may select.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input is disabled.",
            "default": null
          },
          "isReadOnly": {
            "type": "property",
            "name": "isReadOnly",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input can be selected but not changed by the user.",
            "default": null
          },
          "isRequired": {
            "type": "property",
            "name": "isRequired",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether user input is required on the input before form submission.",
            "default": null
          },
          "isInvalid": {
            "type": "property",
            "name": "isInvalid",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the input value is invalid.",
            "default": null
          },
          "validate": {
            "type": "property",
            "name": "validate",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                  },
                  {
                    "type": "boolean",
                    "value": true
                  },
                  {
                    "type": "null"
                  },
                  {
                    "type": "undefined"
                  }
                ]
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The current value (controlled).",
            "default": null
          },
          "defaultValue": {
            "type": "property",
            "name": "defaultValue",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "The default value (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "application",
                        "base": {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue"
                        },
                        "typeParameters": [
                          {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                          }
                        ]
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the value changes.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "name": {
            "type": "property",
            "name": "name",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
            "default": null
          },
          "form": {
            "type": "property",
            "name": "form",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
            "default": null
          },
          "validationBehavior": {
            "type": "property",
            "name": "validationBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "native"
                },
                {
                  "type": "string",
                  "value": "aria"
                }
              ]
            },
            "optional": true,
            "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
            "default": "'native'"
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "labelPosition": {
            "type": "property",
            "name": "labelPosition",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
            },
            "optional": true,
            "description": "The label's overall position relative to the element it is labeling.",
            "default": "'top'"
          },
          "labelAlign": {
            "type": "property",
            "name": "labelAlign",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
            },
            "optional": true,
            "description": "The label's horizontal alignment relative to the element it is labeling.",
            "default": "'start'"
          },
          "necessityIndicator": {
            "type": "property",
            "name": "necessityIndicator",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
            },
            "optional": true,
            "description": "Whether the required state should be shown as an icon or text.",
            "default": "'icon'"
          },
          "contextualHelp": {
            "type": "property",
            "name": "contextualHelp",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A ContextualHelp element to place next to the label.",
            "default": null
          },
          "label": {
            "type": "property",
            "name": "label",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The content to display as the label.",
            "default": null
          },
          "description": {
            "type": "property",
            "name": "description",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
            "default": null
          },
          "errorMessage": {
            "type": "property",
            "name": "errorMessage",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "v",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "An error message for the field.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
            },
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": null
    },
    "TimeFieldContext": {
      "type": "any"
    },
    "UNSTABLE_ToastContainer": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastContainer",
      "name": "UNSTABLE_ToastContainer",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastContainerProps",
        "name": "ToastContainerProps",
        "properties": {
          "placement": {
            "type": "property",
            "name": "placement",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastPlacement"
            },
            "optional": true,
            "description": "Placement of the toast container on the page.",
            "default": "\"bottom\""
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for the toast region.",
            "default": "\"Notifications\""
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "className": {
            "type": "property",
            "name": "className",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
            "default": null
          },
          "style": {
            "type": "property",
            "name": "style",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
              },
              "typeParameters": [
                {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "A ToastContainer renders the queued toasts in an application. It should be placed\nat the root of the app."
    },
    "UNSTABLE_ToastQueue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:SpectrumToastQueue",
      "name": "UNSTABLE_ToastQueue",
      "properties": {
        "neutral": {
          "type": "method",
          "name": "neutral",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "children",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:CloseFunction"
            },
            "typeParameters": []
          },
          "description": "Queues a neutral toast.",
          "default": null
        },
        "positive": {
          "type": "method",
          "name": "positive",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "children",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:CloseFunction"
            },
            "typeParameters": []
          },
          "description": "Queues a positive toast.",
          "default": null
        },
        "negative": {
          "type": "method",
          "name": "negative",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "children",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:CloseFunction"
            },
            "typeParameters": []
          },
          "description": "Queues a negative toast.",
          "default": null
        },
        "info": {
          "type": "method",
          "name": "info",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "children",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:CloseFunction"
            },
            "typeParameters": []
          },
          "description": "Queues an informational toast.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ToggleButton": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ToggleButton.tsx:ToggleButton",
      "name": "ToggleButton",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ToggleButton.tsx:ToggleButtonProps",
        "name": "ToggleButtonProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content to display in the button.",
            "default": null
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "When used in a ToggleButtonGroup, an identifier for the item in `selectedKeys`. When used standalone, a DOM id.",
            "default": null
          },
          "isSelected": {
            "type": "property",
            "name": "isSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should be selected (controlled).",
            "default": null
          },
          "defaultSelected": {
            "type": "property",
            "name": "defaultSelected",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should be selected (uncontrolled).",
            "default": null
          },
          "onChange": {
            "type": "property",
            "name": "onChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isSelected",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's selection state changes.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button is disabled.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should receive focus on render.",
            "default": null
          },
          "onFocus": {
            "type": "property",
            "name": "onFocus",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element receives focus.",
            "default": null
          },
          "onBlur": {
            "type": "property",
            "name": "onBlur",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "FocusEvent"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Target"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element loses focus.",
            "default": null
          },
          "onFocusChange": {
            "type": "property",
            "name": "onFocusChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isFocused",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the element's focus status changes.",
            "default": null
          },
          "onKeyDown": {
            "type": "property",
            "name": "onKeyDown",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is pressed.",
            "default": null
          },
          "onKeyUp": {
            "type": "property",
            "name": "onKeyUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a key is released.",
            "default": null
          },
          "aria-disabled": {
            "type": "property",
            "name": "aria-disabled",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether the element is disabled to users of assistive technology.",
            "default": null
          },
          "aria-expanded": {
            "type": "property",
            "name": "aria-expanded",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
            "default": null
          },
          "aria-haspopup": {
            "type": "property",
            "name": "aria-haspopup",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "menu"
                },
                {
                  "type": "string",
                  "value": "listbox"
                },
                {
                  "type": "string",
                  "value": "tree"
                },
                {
                  "type": "string",
                  "value": "grid"
                },
                {
                  "type": "string",
                  "value": "dialog"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
            "default": null
          },
          "aria-controls": {
            "type": "property",
            "name": "aria-controls",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
            "default": null
          },
          "aria-pressed": {
            "type": "property",
            "name": "aria-pressed",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string",
                  "value": "true"
                },
                {
                  "type": "string",
                  "value": "false"
                },
                {
                  "type": "string",
                  "value": "mixed"
                }
              ]
            },
            "optional": true,
            "description": "Indicates the current \"pressed\" state of toggle buttons.",
            "default": null
          },
          "preventFocusOnPress": {
            "type": "property",
            "name": "preventFocusOnPress",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
            "default": null
          },
          "excludeFromTabOrder": {
            "type": "property",
            "name": "excludeFromTabOrder",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "The size of the ActionButton.",
            "default": "'M'"
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "The static color style to apply. Useful when the ActionButton appears over a color background.",
            "default": null
          },
          "isQuiet": {
            "type": "property",
            "name": "isQuiet",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLButtonElement"
          }
        ]
      },
      "description": "ToggleButtons allow users to toggle a selection on or off, for example\nswitching between two states or modes."
    },
    "ToggleButtonContext": {
      "type": "any"
    },
    "ToggleButtonGroup": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ToggleButtonGroup.tsx:ToggleButtonGroup",
      "name": "ToggleButtonGroup",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ToggleButtonGroup.tsx:ToggleButtonGroupProps",
        "name": "ToggleButtonGroupProps",
        "properties": {
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
            "default": null
          },
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The children of the group.",
            "default": null
          },
          "size": {
            "type": "property",
            "name": "size",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "XS"
                },
                {
                  "type": "string",
                  "value": "S"
                },
                {
                  "type": "string",
                  "value": "M"
                },
                {
                  "type": "string",
                  "value": "L"
                },
                {
                  "type": "string",
                  "value": "XL"
                }
              ]
            },
            "optional": true,
            "description": "Size of the buttons.",
            "default": "\"M\""
          },
          "density": {
            "type": "property",
            "name": "density",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "compact"
                },
                {
                  "type": "string",
                  "value": "regular"
                }
              ]
            },
            "optional": true,
            "description": "Spacing between the buttons.",
            "default": "\"regular\""
          },
          "isQuiet": {
            "type": "property",
            "name": "isQuiet",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
            "default": null
          },
          "isJustified": {
            "type": "property",
            "name": "isJustified",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the buttons should divide the container width equally.",
            "default": null
          },
          "staticColor": {
            "type": "property",
            "name": "staticColor",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "white"
                },
                {
                  "type": "string",
                  "value": "black"
                },
                {
                  "type": "string",
                  "value": "auto"
                }
              ]
            },
            "optional": true,
            "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
            "default": null
          },
          "orientation": {
            "type": "property",
            "name": "orientation",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "horizontal"
                },
                {
                  "type": "string",
                  "value": "vertical"
                }
              ]
            },
            "optional": true,
            "description": "The axis the group should align with.",
            "default": "'horizontal'"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the group is disabled.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "single"
                },
                {
                  "type": "string",
                  "value": "multiple"
                }
              ]
            },
            "optional": true,
            "description": "Whether single or multiple selection is enabled.",
            "default": "'single'"
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Set"
                    },
                    "typeParameters": [
                      {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A ToggleButtonGroup is a grouping of related ToggleButtons, with single or multiple selection."
    },
    "ToggleButtonGroupContext": {
      "type": "any"
    },
    "Tooltip": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tooltip.tsx:Tooltip",
      "name": "Tooltip",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tooltip.tsx:TooltipProps",
        "name": "TooltipProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content of the tooltip.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "Display container for Tooltip content. Has a directional arrow dependent on its placement."
    },
    "TooltipTrigger": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tooltip.tsx:TooltipTrigger",
      "name": "TooltipTrigger",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tooltip.tsx:TooltipTriggerProps",
        "name": "TooltipTriggerProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content of the tooltip.",
            "default": null
          },
          "placement": {
            "type": "property",
            "name": "placement",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "start"
                },
                {
                  "type": "string",
                  "value": "end"
                },
                {
                  "type": "string",
                  "value": "right"
                },
                {
                  "type": "string",
                  "value": "left"
                },
                {
                  "type": "string",
                  "value": "top"
                },
                {
                  "type": "string",
                  "value": "bottom"
                }
              ]
            },
            "optional": true,
            "description": "The placement of the element with respect to its anchor element.",
            "default": "'top'"
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tooltip should be disabled, independent from the trigger.",
            "default": null
          },
          "delay": {
            "type": "property",
            "name": "delay",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The delay time for the tooltip to show up. [See guidelines](https://spectrum.adobe.com/page/tooltip/#Immediate-or-delayed-appearance).",
            "default": "1500"
          },
          "trigger": {
            "type": "property",
            "name": "trigger",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "hover"
                },
                {
                  "type": "string",
                  "value": "focus"
                }
              ]
            },
            "optional": true,
            "description": "By default, opens for both focus and hover. Can be made to open only for focus.",
            "default": "'hover'"
          },
          "isOpen": {
            "type": "property",
            "name": "isOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (controlled).",
            "default": null
          },
          "defaultOpen": {
            "type": "property",
            "name": "defaultOpen",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the overlay is open by default (uncontrolled).",
            "default": null
          },
          "onOpenChange": {
            "type": "property",
            "name": "onOpenChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isOpen",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the overlay's open state changes.",
            "default": null
          },
          "containerPadding": {
            "type": "property",
            "name": "containerPadding",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
            "default": "12"
          },
          "offset": {
            "type": "property",
            "name": "offset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
            "default": "0"
          },
          "crossOffset": {
            "type": "property",
            "name": "crossOffset",
            "indexType": null,
            "value": {
              "type": "number"
            },
            "optional": true,
            "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
            "default": "0"
          },
          "shouldFlip": {
            "type": "property",
            "name": "shouldFlip",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
            "default": "true"
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": "TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing\nthe Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip\nrelative to the trigger."
    },
    "TreeView": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeView",
      "name": "TreeView",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewProps",
        "name": "TreeViewProps",
        "properties": {
          "styles": {
            "type": "property",
            "name": "styles",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
            },
            "optional": true,
            "description": "Spectrum-defined styles, returned by the `style()` macro.",
            "default": null
          },
          "renderEmptyState": {
            "type": "property",
            "name": "renderEmptyState",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "props",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeEmptyStateRenderProps"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "identifier",
                "name": "ReactNode"
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Provides content to display when there are no items in the list.",
            "default": null
          },
          "disabledBehavior": {
            "type": "property",
            "name": "disabledBehavior",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
            },
            "optional": true,
            "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
            "default": "'all'"
          },
          "escapeKeyBehavior": {
            "type": "property",
            "name": "escapeKeyBehavior",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "clearSelection"
                },
                {
                  "type": "string",
                  "value": "none"
                }
              ]
            },
            "optional": true,
            "description": "Whether pressing the escape key should clear selection in the grid list or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
            "default": "'clearSelection'"
          },
          "autoFocus": {
            "type": "property",
            "name": "autoFocus",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                }
              ]
            },
            "optional": true,
            "description": "Whether to auto focus the gridlist or an option.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "key",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "shouldSelectOnPressUp": {
            "type": "property",
            "name": "shouldSelectOnPressUp",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether selection should occur on press up instead of press down.",
            "default": null
          },
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "disabledKeys": {
            "type": "property",
            "name": "disabledKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
            "default": null
          },
          "selectionMode": {
            "type": "property",
            "name": "selectionMode",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
            },
            "optional": true,
            "description": "The type of selection that is allowed in the collection.",
            "default": null
          },
          "disallowEmptySelection": {
            "type": "property",
            "name": "disallowEmptySelection",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the collection allows empty selection.",
            "default": null
          },
          "selectedKeys": {
            "type": "property",
            "name": "selectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The currently selected keys in the collection (controlled).",
            "default": null
          },
          "defaultSelectedKeys": {
            "type": "property",
            "name": "defaultSelectedKeys",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "all"
                },
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                }
              ]
            },
            "optional": true,
            "description": "The initial selected keys in the collection (uncontrolled).",
            "default": null
          },
          "onSelectionChange": {
            "type": "property",
            "name": "onSelectionChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the selection changes.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Defines a string value that labels the current element.",
            "default": null
          },
          "aria-labelledby": {
            "type": "property",
            "name": "aria-labelledby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that labels the current element.",
            "default": null
          },
          "aria-describedby": {
            "type": "property",
            "name": "aria-describedby",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that describes the object.",
            "default": null
          },
          "aria-details": {
            "type": "property",
            "name": "aria-details",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          },
          "expandedKeys": {
            "type": "property",
            "name": "expandedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The currently expanded keys in the collection (controlled).",
            "default": null
          },
          "defaultExpandedKeys": {
            "type": "property",
            "name": "defaultExpandedKeys",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "optional": true,
            "description": "The initial expanded keys in the collection (uncontrolled).",
            "default": null
          },
          "onExpandedChange": {
            "type": "property",
            "name": "onExpandedChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "keys",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "identifier",
                      "name": "Set"
                    },
                    "typeParameters": [
                      {
                        "type": "identifier",
                        "name": "Key"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when items are expanded or collapsed.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLDivElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "UNSAFE_className": {
            "type": "property",
            "name": "UNSAFE_className",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
            },
            "optional": true,
            "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "UNSAFE_style": {
            "type": "property",
            "name": "UNSAFE_style",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "CSSProperties"
            },
            "optional": true,
            "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
            "default": null
          },
          "isDetached": {
            "type": "property",
            "name": "isDetached",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tree should be displayed with a [detached style](https://spectrum.adobe.com/page/tree-view/#Detached).",
            "default": null
          },
          "isEmphasized": {
            "type": "property",
            "name": "isEmphasized",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the tree should be displayed with a [emphasized style](https://spectrum.adobe.com/page/tree-view/#Emphasis).",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLDivElement"
          }
        ]
      },
      "description": "A tree view provides users with a way to navigate nested hierarchical information."
    },
    "TreeViewItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewItem",
      "name": "TreeViewItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewItemProps",
        "name": "TreeViewItemProps",
        "properties": {
          "hasChildItems": {
            "type": "property",
            "name": "hasChildItems",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether this item has children, even if not loaded yet.",
            "default": null
          },
          "id": {
            "type": "property",
            "name": "id",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "The unique id of the tree row.",
            "default": null
          },
          "value": {
            "type": "property",
            "name": "value",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "T"
            },
            "optional": true,
            "description": "The object value that this tree item represents. When using dynamic collections, this is set automatically.",
            "default": null
          },
          "textValue": {
            "type": "property",
            "name": "textValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": false,
            "description": "A string representation of the tree item's contents, used for features like typeahead.",
            "default": null
          },
          "aria-label": {
            "type": "property",
            "name": "aria-label",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "An accessibility label for this tree item.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The content of the tree item along with any nested children. Supports static nested tree items or use of a Collection to dynamically render nested tree items.",
            "default": null
          },
          "isDisabled": {
            "type": "property",
            "name": "isDisabled",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the item is disabled.",
            "default": null
          },
          "onAction": {
            "type": "property",
            "name": "onAction",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a user performs an action on this tree item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
            "default": null
          },
          "href": {
            "type": "property",
            "name": "href",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
            },
            "optional": true,
            "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
            "default": null
          },
          "hrefLang": {
            "type": "property",
            "name": "hrefLang",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
            "default": null
          },
          "target": {
            "type": "property",
            "name": "target",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeAnchorTarget"
            },
            "optional": true,
            "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
            "default": null
          },
          "rel": {
            "type": "property",
            "name": "rel",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
            "default": null
          },
          "download": {
            "type": "property",
            "name": "download",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
            "default": null
          },
          "ping": {
            "type": "property",
            "name": "ping",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
            "default": null
          },
          "referrerPolicy": {
            "type": "property",
            "name": "referrerPolicy",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "HTMLAttributeReferrerPolicy"
            },
            "optional": true,
            "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
            "default": null
          },
          "routerOptions": {
            "type": "property",
            "name": "routerOptions",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
            },
            "optional": true,
            "description": "Options for the configured client side router.",
            "default": null
          },
          "onHoverStart": {
            "type": "property",
            "name": "onHoverStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction starts.",
            "default": null
          },
          "onHoverEnd": {
            "type": "property",
            "name": "onHoverEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a hover interaction ends.",
            "default": null
          },
          "onHoverChange": {
            "type": "property",
            "name": "onHoverChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isHovering",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the hover state changes.",
            "default": null
          },
          "onPress": {
            "type": "property",
            "name": "onPress",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press is released over the target.",
            "default": null
          },
          "onPressStart": {
            "type": "property",
            "name": "onPressStart",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction starts.",
            "default": null
          },
          "onPressEnd": {
            "type": "property",
            "name": "onPressEnd",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
            "default": null
          },
          "onPressChange": {
            "type": "property",
            "name": "onPressChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "isPressed",
                  "value": {
                    "type": "boolean"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the press state changes.",
            "default": null
          },
          "onPressUp": {
            "type": "property",
            "name": "onPressUp",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "e",
                  "value": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "TreeViewItemContent": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewItemContent",
      "name": "TreeViewItemContent",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewItemContentProps",
        "name": "TreeViewItemContentProps",
        "properties": {
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "Rendered contents of the tree item or child items.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "TreeViewLoadMoreItem": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewLoadMoreItem",
      "name": "TreeViewLoadMoreItem",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewLoadMoreItemProps",
        "name": "TreeViewLoadMoreItemProps",
        "properties": {
          "loadingState": {
            "type": "property",
            "name": "loadingState",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState"
            },
            "optional": true,
            "description": "The current loading state of the TreeView or TreeView row.",
            "default": null
          },
          "onLoadMore": {
            "type": "property",
            "name": "onLoadMore",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [],
              "return": {
                "id": null,
                "name": null,
                "type": "any",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": null,
      "description": null
    },
    "pressScale": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/pressScale.ts:pressScale",
      "name": "pressScale",
      "parameters": [
        {
          "type": "parameter",
          "name": "ref",
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "rest": false,
          "description": null
        },
        {
          "type": "parameter",
          "name": "style",
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "CSSProperties"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "renderProps",
                    "value": {
                      "type": "identifier",
                      "name": "R"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "CSSProperties"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "function",
        "parameters": [
          {
            "type": "parameter",
            "name": "renderProps",
            "value": {
              "type": "identifier",
              "name": "R"
            },
            "rest": false
          }
        ],
        "return": {
          "type": "identifier",
          "name": "CSSProperties"
        },
        "typeParameters": [],
        "description": null
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "R",
          "constraint": {
            "type": "object",
            "properties": {
              "isPressed": {
                "type": "property",
                "name": "isPressed",
                "indexType": null,
                "value": {
                  "type": "boolean"
                },
                "optional": false,
                "default": null
              }
            }
          },
          "default": null
        }
      ]
    },
    "Autocomplete": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Autocomplete.tsx:Autocomplete",
      "name": "Autocomplete",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Autocomplete.tsx:AutocompleteProps",
        "name": "AutocompleteProps",
        "properties": {
          "filter": {
            "type": "property",
            "name": "filter",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "textValue",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                },
                {
                  "type": "parameter",
                  "name": "inputValue",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                },
                {
                  "type": "parameter",
                  "name": "node",
                  "value": {
                    "type": "application",
                    "base": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                    },
                    "typeParameters": [
                      {
                        "type": "object",
                        "properties": null
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "boolean",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "An optional filter function used to determine if a option should be included in the autocomplete list.\nInclude this if the items you are providing to your wrapped collection aren't filtered by default.",
            "default": null
          },
          "disableAutoFocusFirst": {
            "type": "property",
            "name": "disableAutoFocusFirst",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether or not to focus the first item in the collection after a filter is performed. Note this is only applicable\nif virtual focus behavior is not turned off via `disableVirtualFocus`.",
            "default": "false"
          },
          "disableVirtualFocus": {
            "type": "property",
            "name": "disableVirtualFocus",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether the autocomplete should disable virtual focus, instead making the wrapped collection directly tabbable.",
            "default": "false"
          },
          "inputValue": {
            "type": "property",
            "name": "inputValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The value of the autocomplete input (controlled).",
            "default": null
          },
          "defaultInputValue": {
            "type": "property",
            "name": "defaultInputValue",
            "indexType": null,
            "value": {
              "type": "string"
            },
            "optional": true,
            "description": "The default value of the autocomplete input (uncontrolled).",
            "default": null
          },
          "onInputChange": {
            "type": "property",
            "name": "onInputChange",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "value",
                  "value": {
                    "type": "string"
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler that is called when the autocomplete input value changes.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": false,
            "description": "The children wrapped by the autocomplete. Consists of at least an input element and a collection element to filter.",
            "default": null
          },
          "slot": {
            "type": "property",
            "name": "slot",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "optional": true,
            "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": {
              "type": "object",
              "properties": null
            }
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": null,
      "description": "An autocomplete combines a TextField or SearchField with a Menu or ListBox, allowing users to search or filter a list of suggestions."
    },
    "Collection": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/CollectionBuilder.tsx:Collection",
      "name": "Collection",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/@react-aria/collections/src/CollectionBuilder.tsx:CollectionProps",
        "name": "CollectionProps",
        "properties": {
          "items": {
            "type": "property",
            "name": "items",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "object",
                  "properties": null
                }
              ]
            },
            "optional": true,
            "description": "Item objects in the collection.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "item",
                      "value": {
                        "type": "object",
                        "properties": null
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "identifier",
                    "name": "ReactNode"
                  },
                  "typeParameters": []
                }
              ]
            },
            "optional": true,
            "description": "The contents of the collection.",
            "default": null
          },
          "dependencies": {
            "type": "property",
            "name": "dependencies",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "id": null,
                  "name": null,
                  "type": "any"
                }
              ]
            },
            "optional": true,
            "description": "Values that should invalidate the item cache when using dynamic collections.",
            "default": null
          },
          "idScope": {
            "type": "property",
            "name": "idScope",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            "optional": true,
            "description": "A scope to prepend to all child item ids to ensure they are unique.",
            "default": null
          },
          "addIdAndValue": {
            "type": "property",
            "name": "addIdAndValue",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether to add `id` and `value` props to all child items.",
            "default": null
          }
        },
        "typeParameters": [
          {
            "type": "typeParameter",
            "name": "T",
            "constraint": null,
            "default": null
          }
        ],
        "extends": []
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "ref": null,
      "description": "A Collection renders a list of items, automatically managing caching and keys."
    },
    "FileTrigger": {
      "type": "component",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FileTrigger.tsx:FileTrigger",
      "name": "FileTrigger",
      "props": {
        "type": "interface",
        "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FileTrigger.tsx:FileTriggerProps",
        "name": "FileTriggerProps",
        "properties": {
          "acceptedFileTypes": {
            "type": "property",
            "name": "acceptedFileTypes",
            "indexType": null,
            "value": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "ReadonlyArray"
              },
              "typeParameters": [
                {
                  "type": "string"
                }
              ]
            },
            "optional": true,
            "description": "Specifies what mime type of files are allowed.",
            "default": null
          },
          "allowsMultiple": {
            "type": "property",
            "name": "allowsMultiple",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Whether multiple files can be selected.",
            "default": null
          },
          "defaultCamera": {
            "type": "property",
            "name": "defaultCamera",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "user"
                },
                {
                  "type": "string",
                  "value": "environment"
                }
              ]
            },
            "optional": true,
            "description": "Specifies the use of a media capture mechanism to capture the media on the spot.",
            "default": null
          },
          "onSelect": {
            "type": "property",
            "name": "onSelect",
            "indexType": null,
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "files",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "identifier",
                        "name": "FileList"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false,
                  "description": null
                }
              ],
              "return": {
                "type": "void",
                "description": null
              },
              "typeParameters": []
            },
            "optional": true,
            "description": "Handler when a user selects a file.",
            "default": null
          },
          "children": {
            "type": "property",
            "name": "children",
            "indexType": null,
            "value": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "optional": true,
            "description": "The children of the component.",
            "default": null
          },
          "acceptDirectory": {
            "type": "property",
            "name": "acceptDirectory",
            "indexType": null,
            "value": {
              "type": "boolean"
            },
            "optional": true,
            "description": "Enables the selection of directories instead of individual files.",
            "default": null
          },
          "dir": {
            "type": "property",
            "name": "dir",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "lang": {
            "type": "property",
            "name": "lang",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "hidden": {
            "type": "property",
            "name": "hidden",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "inert": {
            "type": "property",
            "name": "inert",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "boolean"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "translate": {
            "type": "property",
            "name": "translate",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "string",
                  "value": "yes"
                },
                {
                  "type": "string",
                  "value": "no"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClick": {
            "type": "property",
            "name": "onClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onClickCapture": {
            "type": "property",
            "name": "onClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClick": {
            "type": "property",
            "name": "onAuxClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAuxClickCapture": {
            "type": "property",
            "name": "onAuxClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenu": {
            "type": "property",
            "name": "onContextMenu",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onContextMenuCapture": {
            "type": "property",
            "name": "onContextMenuCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClick": {
            "type": "property",
            "name": "onDoubleClick",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onDoubleClickCapture": {
            "type": "property",
            "name": "onDoubleClickCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDown": {
            "type": "property",
            "name": "onMouseDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseDownCapture": {
            "type": "property",
            "name": "onMouseDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseEnter": {
            "type": "property",
            "name": "onMouseEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseLeave": {
            "type": "property",
            "name": "onMouseLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMove": {
            "type": "property",
            "name": "onMouseMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseMoveCapture": {
            "type": "property",
            "name": "onMouseMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOut": {
            "type": "property",
            "name": "onMouseOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOutCapture": {
            "type": "property",
            "name": "onMouseOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOver": {
            "type": "property",
            "name": "onMouseOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseOverCapture": {
            "type": "property",
            "name": "onMouseOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUp": {
            "type": "property",
            "name": "onMouseUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onMouseUpCapture": {
            "type": "property",
            "name": "onMouseUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancel": {
            "type": "property",
            "name": "onTouchCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchCancelCapture": {
            "type": "property",
            "name": "onTouchCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEnd": {
            "type": "property",
            "name": "onTouchEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchEndCapture": {
            "type": "property",
            "name": "onTouchEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMove": {
            "type": "property",
            "name": "onTouchMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchMoveCapture": {
            "type": "property",
            "name": "onTouchMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStart": {
            "type": "property",
            "name": "onTouchStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTouchStartCapture": {
            "type": "property",
            "name": "onTouchStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TouchEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDown": {
            "type": "property",
            "name": "onPointerDown",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerDownCapture": {
            "type": "property",
            "name": "onPointerDownCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMove": {
            "type": "property",
            "name": "onPointerMove",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerMoveCapture": {
            "type": "property",
            "name": "onPointerMoveCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUp": {
            "type": "property",
            "name": "onPointerUp",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerUpCapture": {
            "type": "property",
            "name": "onPointerUpCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancel": {
            "type": "property",
            "name": "onPointerCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerCancelCapture": {
            "type": "property",
            "name": "onPointerCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerEnter": {
            "type": "property",
            "name": "onPointerEnter",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerLeave": {
            "type": "property",
            "name": "onPointerLeave",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOver": {
            "type": "property",
            "name": "onPointerOver",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOverCapture": {
            "type": "property",
            "name": "onPointerOverCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOut": {
            "type": "property",
            "name": "onPointerOut",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onPointerOutCapture": {
            "type": "property",
            "name": "onPointerOutCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCapture": {
            "type": "property",
            "name": "onGotPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onGotPointerCaptureCapture": {
            "type": "property",
            "name": "onGotPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCapture": {
            "type": "property",
            "name": "onLostPointerCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onLostPointerCaptureCapture": {
            "type": "property",
            "name": "onLostPointerCaptureCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "PointerEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScroll": {
            "type": "property",
            "name": "onScroll",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onScrollCapture": {
            "type": "property",
            "name": "onScrollCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "UIEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheel": {
            "type": "property",
            "name": "onWheel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onWheelCapture": {
            "type": "property",
            "name": "onWheelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "WheelEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStart": {
            "type": "property",
            "name": "onAnimationStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationStartCapture": {
            "type": "property",
            "name": "onAnimationStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEnd": {
            "type": "property",
            "name": "onAnimationEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationEndCapture": {
            "type": "property",
            "name": "onAnimationEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIteration": {
            "type": "property",
            "name": "onAnimationIteration",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onAnimationIterationCapture": {
            "type": "property",
            "name": "onAnimationIterationCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "AnimationEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancel": {
            "type": "property",
            "name": "onTransitionCancel",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionCancelCapture": {
            "type": "property",
            "name": "onTransitionCancelCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEnd": {
            "type": "property",
            "name": "onTransitionEnd",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionEndCapture": {
            "type": "property",
            "name": "onTransitionEndCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRun": {
            "type": "property",
            "name": "onTransitionRun",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionRunCapture": {
            "type": "property",
            "name": "onTransitionRunCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStart": {
            "type": "property",
            "name": "onTransitionStart",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          },
          "onTransitionStartCapture": {
            "type": "property",
            "name": "onTransitionStartCapture",
            "indexType": null,
            "value": {
              "type": "union",
              "elements": [
                {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "TransitionEventHandler"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "optional": true,
            "access": "private",
            "default": null
          }
        },
        "typeParameters": [],
        "extends": []
      },
      "typeParameters": [],
      "ref": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "ForwardedRef"
        },
        "typeParameters": [
          {
            "type": "identifier",
            "name": "HTMLInputElement"
          }
        ]
      },
      "description": "A FileTrigger allows a user to access the file system with any pressable React Aria or React Spectrum component, or custom components built with usePress."
    },
    "parseColor": {
      "type": "function",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/color/src/Color.ts:parseColor",
      "name": "parseColor",
      "parameters": [
        {
          "type": "parameter",
          "name": "value",
          "value": {
            "type": "string"
          },
          "rest": false,
          "description": null
        }
      ],
      "return": {
        "type": "link",
        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
      },
      "typeParameters": [],
      "description": "Parses a color from a string value. Throws an error if the string could not be parsed."
    },
    "AccordionProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Accordion.tsx:AccordionProps",
      "name": "AccordionProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "React.ReactNode"
          },
          "optional": false,
          "description": "The disclosure elements in the accordion.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the accordion.",
          "default": "'M'"
        },
        "density": {
          "type": "property",
          "name": "density",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "compact"
              },
              {
                "type": "string",
                "value": "regular"
              },
              {
                "type": "string",
                "value": "spacious"
              }
            ]
          },
          "optional": true,
          "description": "The amount of space between the disclosure items.",
          "default": "'regular'"
        },
        "isQuiet": {
          "type": "property",
          "name": "isQuiet",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the accordion should be displayed with a quiet style.",
          "default": null
        },
        "allowsMultipleExpanded": {
          "type": "property",
          "name": "allowsMultipleExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether multiple items can be expanded at the same time.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether all items are disabled.",
          "default": null
        },
        "expandedKeys": {
          "type": "property",
          "name": "expandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": true,
          "description": "The currently expanded keys in the group (controlled).",
          "default": null
        },
        "defaultExpandedKeys": {
          "type": "property",
          "name": "defaultExpandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": true,
          "description": "The initial expanded keys in the group (uncontrolled).",
          "default": null
        },
        "onExpandedChange": {
          "type": "property",
          "name": "onExpandedChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are expanded or collapsed.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ActionBarProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionBar.tsx:ActionBarProps",
      "name": "ActionBarProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "A list of ActionButtons to display.",
          "default": null
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the ActionBar should be displayed with a emphasized style.",
          "default": null
        },
        "selectedItemCount": {
          "type": "property",
          "name": "selectedItemCount",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "string",
                "value": "all"
              }
            ]
          },
          "optional": true,
          "description": "The number of selected items that the ActionBar is currently linked to. If 0, the ActionBar is hidden.",
          "default": null
        },
        "onClearSelection": {
          "type": "property",
          "name": "onClearSelection",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the ActionBar clear button is pressed.",
          "default": null
        },
        "scrollRef": {
          "type": "property",
          "name": "scrollRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref to the scrollable element the ActionBar appears above.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ActionButtonProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionButton.tsx:ActionButtonProps",
      "name": "ActionButtonProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the ActionButton.",
          "default": null
        },
        "isPending": {
          "type": "property",
          "name": "isPending",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is in a pending state. This disables press and hover events\nwhile retaining focusability, and announces the pending state to screen readers.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is disabled.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "aria-disabled": {
          "type": "property",
          "name": "aria-disabled",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element is disabled to users of assistive technology.",
          "default": null
        },
        "aria-expanded": {
          "type": "property",
          "name": "aria-expanded",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "aria-pressed": {
          "type": "property",
          "name": "aria-pressed",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "mixed"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the current \"pressed\" state of toggle buttons.",
          "default": null
        },
        "aria-current": {
          "type": "property",
          "name": "aria-current",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "page"
              },
              {
                "type": "string",
                "value": "step"
              },
              {
                "type": "string",
                "value": "location"
              },
              {
                "type": "string",
                "value": "date"
              },
              {
                "type": "string",
                "value": "time"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether this element represents the current item within a container or set of related elements.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "button"
              },
              {
                "type": "string",
                "value": "submit"
              },
              {
                "type": "string",
                "value": "reset"
              }
            ]
          },
          "optional": true,
          "description": "The behavior of the button when used in an HTML form.",
          "default": "'button'"
        },
        "preventFocusOnPress": {
          "type": "property",
          "name": "preventFocusOnPress",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/button#form).",
          "default": null
        },
        "formAction": {
          "type": "property",
          "name": "formAction",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
          "default": null
        },
        "formEncType": {
          "type": "property",
          "name": "formEncType",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Indicates how to encode the form data that is submitted.",
          "default": null
        },
        "formMethod": {
          "type": "property",
          "name": "formMethod",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Indicates the HTTP method used to submit the form.",
          "default": null
        },
        "formNoValidate": {
          "type": "property",
          "name": "formNoValidate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Indicates that the form is not to be validated when it is submitted.",
          "default": null
        },
        "formTarget": {
          "type": "property",
          "name": "formTarget",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Overrides the target attribute of the button's form owner.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Submitted as a pair with the button's value as part of the form data.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value associated with the button's name when it's submitted with the form data.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the ActionButton.",
          "default": "'M'"
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "The static color style to apply. Useful when the ActionButton appears over a color background.",
          "default": null
        },
        "isQuiet": {
          "type": "property",
          "name": "isQuiet",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ActionButtonGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionButtonGroup.tsx:ActionButtonGroupProps",
      "name": "ActionButtonGroupProps",
      "properties": {
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The children of the group.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "Size of the buttons.",
          "default": "\"M\""
        },
        "density": {
          "type": "property",
          "name": "density",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "compact"
              },
              {
                "type": "string",
                "value": "regular"
              }
            ]
          },
          "optional": true,
          "description": "Spacing between the buttons.",
          "default": "\"regular\""
        },
        "isQuiet": {
          "type": "property",
          "name": "isQuiet",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
          "default": null
        },
        "isJustified": {
          "type": "property",
          "name": "isJustified",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the buttons should divide the container width equally.",
          "default": null
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "horizontal"
              },
              {
                "type": "string",
                "value": "vertical"
              }
            ]
          },
          "optional": true,
          "description": "The axis the group should align with.",
          "default": "'horizontal'"
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the group is disabled.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ActionMenuProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ActionMenu.tsx:ActionMenuProps",
      "name": "ActionMenuProps",
      "properties": {
        "menuSize": {
          "type": "property",
          "name": "menuSize",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "align": {
          "type": "property",
          "name": "align",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "Alignment of the menu relative to the trigger.",
          "default": "'start'"
        },
        "direction": {
          "type": "property",
          "name": "direction",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "bottom"
              },
              {
                "type": "string",
                "value": "top"
              },
              {
                "type": "string",
                "value": "left"
              },
              {
                "type": "string",
                "value": "right"
              },
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "Where the Menu opens relative to its trigger.",
          "default": "'bottom'"
        },
        "shouldFlip": {
          "type": "property",
          "name": "shouldFlip",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the menu should automatically flip direction when space is limited.",
          "default": "true"
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "description": "The contents of the collection.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when an item is selected.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is disabled.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the ActionButton.",
          "default": "'M'"
        },
        "isQuiet": {
          "type": "property",
          "name": "isQuiet",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "AlertDialogProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/AlertDialog.tsx:AlertDialogProps",
      "name": "AlertDialogProps",
      "properties": {
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "confirmation"
              },
              {
                "type": "string",
                "value": "information"
              },
              {
                "type": "string",
                "value": "destructive"
              },
              {
                "type": "string",
                "value": "error"
              },
              {
                "type": "string",
                "value": "warning"
              }
            ]
          },
          "optional": true,
          "description": "The [visual style](https://spectrum.adobe.com/page/alert-dialog/#Options) of the AlertDialog.",
          "default": null
        },
        "title": {
          "type": "property",
          "name": "title",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The title of the AlertDialog.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The contents of the AlertDialog.",
          "default": null
        },
        "cancelLabel": {
          "type": "property",
          "name": "cancelLabel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The label to display within the cancel button.",
          "default": null
        },
        "primaryActionLabel": {
          "type": "property",
          "name": "primaryActionLabel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The label to display within the confirm button.",
          "default": null
        },
        "secondaryActionLabel": {
          "type": "property",
          "name": "secondaryActionLabel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The label to display within the secondary button.",
          "default": null
        },
        "isPrimaryActionDisabled": {
          "type": "property",
          "name": "isPrimaryActionDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the primary button is disabled.",
          "default": null
        },
        "isSecondaryActionDisabled": {
          "type": "property",
          "name": "isSecondaryActionDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the secondary button is disabled.",
          "default": null
        },
        "onCancel": {
          "type": "property",
          "name": "onCancel",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the cancel button is pressed.",
          "default": null
        },
        "onPrimaryAction": {
          "type": "property",
          "name": "onPrimaryAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the primary button is pressed.",
          "default": null
        },
        "onSecondaryAction": {
          "type": "property",
          "name": "onSecondaryAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the secondary button is pressed.",
          "default": null
        },
        "autoFocusButton": {
          "type": "property",
          "name": "autoFocusButton",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "cancel"
              },
              {
                "type": "string",
                "value": "primary"
              },
              {
                "type": "string",
                "value": "secondary"
              }
            ]
          },
          "optional": true,
          "description": "Button to focus by default when the dialog opens.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Dialog.",
          "default": "'M'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "AvatarProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Avatar.tsx:AvatarProps",
      "name": "AvatarProps",
      "properties": {
        "alt": {
          "type": "property",
          "name": "alt",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Text description of the avatar.",
          "default": null
        },
        "src": {
          "type": "property",
          "name": "src",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The image URL for the avatar.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithoutWidth"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 16
              },
              {
                "type": "number",
                "value": 20
              },
              {
                "type": "number",
                "value": 24
              },
              {
                "type": "number",
                "value": 28
              },
              {
                "type": "number",
                "value": 32
              },
              {
                "type": "number",
                "value": 36
              },
              {
                "type": "number",
                "value": 40
              },
              {
                "type": "number",
                "value": 44
              },
              {
                "type": "number",
                "value": 48
              },
              {
                "type": "number",
                "value": 56
              },
              {
                "type": "number",
                "value": 64
              },
              {
                "type": "number",
                "value": 80
              },
              {
                "type": "number",
                "value": 96
              },
              {
                "type": "number",
                "value": 112
              },
              {
                "type": "intersection",
                "types": [
                  {
                    "type": "number"
                  },
                  {
                    "type": "object",
                    "properties": {}
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The size of the avatar.",
          "default": "24"
        },
        "isOverBackground": {
          "type": "property",
          "name": "isOverBackground",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the avatar is over a color background.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "AvatarGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/AvatarGroup.tsx:AvatarGroupProps",
      "name": "AvatarGroupProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "Avatar children of the avatar group.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The label for the avatar group.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 16
              },
              {
                "type": "number",
                "value": 20
              },
              {
                "type": "number",
                "value": 24
              },
              {
                "type": "number",
                "value": 28
              },
              {
                "type": "number",
                "value": 32
              },
              {
                "type": "number",
                "value": 36
              },
              {
                "type": "number",
                "value": 40
              }
            ]
          },
          "optional": true,
          "description": "The size of the avatar group.",
          "default": "24"
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithoutWidth"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "BreadcrumbsProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Breadcrumbs.tsx:BreadcrumbsProps",
      "name": "BreadcrumbsProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The children of the Breadcrumbs.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the breadcrumbs are disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a breadcrumb is clicked.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLOListElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "description": "Size of the Breadcrumbs including spacing and layout.",
          "default": "'M'"
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "BreadcrumbProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Breadcrumbs.tsx:BreadcrumbProps",
      "name": "BreadcrumbProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The children of the breadcrumb item.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "A unique id for the breadcrumb, which will be passed to `onAction` when the breadcrumb is pressed.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLLIElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "BadgeProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Badge.tsx:BadgeProps",
      "name": "BadgeProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the badge.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the badge.",
          "default": "'S'"
        },
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "accent"
              },
              {
                "type": "string",
                "value": "informative"
              },
              {
                "type": "string",
                "value": "neutral"
              },
              {
                "type": "string",
                "value": "positive"
              },
              {
                "type": "string",
                "value": "notice"
              },
              {
                "type": "string",
                "value": "negative"
              },
              {
                "type": "string",
                "value": "gray"
              },
              {
                "type": "string",
                "value": "red"
              },
              {
                "type": "string",
                "value": "orange"
              },
              {
                "type": "string",
                "value": "yellow"
              },
              {
                "type": "string",
                "value": "chartreuse"
              },
              {
                "type": "string",
                "value": "celery"
              },
              {
                "type": "string",
                "value": "green"
              },
              {
                "type": "string",
                "value": "seafoam"
              },
              {
                "type": "string",
                "value": "cyan"
              },
              {
                "type": "string",
                "value": "blue"
              },
              {
                "type": "string",
                "value": "indigo"
              },
              {
                "type": "string",
                "value": "purple"
              },
              {
                "type": "string",
                "value": "fuchsia"
              },
              {
                "type": "string",
                "value": "magenta"
              },
              {
                "type": "string",
                "value": "pink"
              },
              {
                "type": "string",
                "value": "turquoise"
              },
              {
                "type": "string",
                "value": "brown"
              },
              {
                "type": "string",
                "value": "cinnamon"
              },
              {
                "type": "string",
                "value": "silver"
              }
            ]
          },
          "optional": true,
          "description": "The variant changes the background color of the badge. When badge has a semantic meaning, they should use the variant for semantic colors.",
          "default": "'neutral'"
        },
        "fillStyle": {
          "type": "property",
          "name": "fillStyle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "bold"
              },
              {
                "type": "string",
                "value": "subtle"
              },
              {
                "type": "string",
                "value": "outline"
              }
            ]
          },
          "optional": true,
          "description": "The fill of the badge.",
          "default": "'bold'"
        },
        "overflowMode": {
          "type": "property",
          "name": "overflowMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "wrap"
              },
              {
                "type": "string",
                "value": "truncate"
              }
            ]
          },
          "optional": true,
          "description": "Sets the text behavior for the contents.",
          "default": "'wrap'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ButtonProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Button.tsx:ButtonProps",
      "name": "ButtonProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the Button.",
          "default": null
        },
        "isPending": {
          "type": "property",
          "name": "isPending",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is in a pending state. This disables press and hover events\nwhile retaining focusability, and announces the pending state to screen readers.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is disabled.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "aria-disabled": {
          "type": "property",
          "name": "aria-disabled",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element is disabled to users of assistive technology.",
          "default": null
        },
        "aria-expanded": {
          "type": "property",
          "name": "aria-expanded",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "aria-pressed": {
          "type": "property",
          "name": "aria-pressed",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "mixed"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the current \"pressed\" state of toggle buttons.",
          "default": null
        },
        "aria-current": {
          "type": "property",
          "name": "aria-current",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "page"
              },
              {
                "type": "string",
                "value": "step"
              },
              {
                "type": "string",
                "value": "location"
              },
              {
                "type": "string",
                "value": "date"
              },
              {
                "type": "string",
                "value": "time"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether this element represents the current item within a container or set of related elements.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "button"
              },
              {
                "type": "string",
                "value": "submit"
              },
              {
                "type": "string",
                "value": "reset"
              }
            ]
          },
          "optional": true,
          "description": "The behavior of the button when used in an HTML form.",
          "default": "'button'"
        },
        "preventFocusOnPress": {
          "type": "property",
          "name": "preventFocusOnPress",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/button#form).",
          "default": null
        },
        "formAction": {
          "type": "property",
          "name": "formAction",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
          "default": null
        },
        "formEncType": {
          "type": "property",
          "name": "formEncType",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Indicates how to encode the form data that is submitted.",
          "default": null
        },
        "formMethod": {
          "type": "property",
          "name": "formMethod",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Indicates the HTTP method used to submit the form.",
          "default": null
        },
        "formNoValidate": {
          "type": "property",
          "name": "formNoValidate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Indicates that the form is not to be validated when it is submitted.",
          "default": null
        },
        "formTarget": {
          "type": "property",
          "name": "formTarget",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Overrides the target attribute of the button's form owner.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Submitted as a pair with the button's value as part of the form data.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value associated with the button's name when it's submitted with the form data.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "primary"
              },
              {
                "type": "string",
                "value": "secondary"
              },
              {
                "type": "string",
                "value": "accent"
              },
              {
                "type": "string",
                "value": "negative"
              },
              {
                "type": "string",
                "value": "premium"
              },
              {
                "type": "string",
                "value": "genai"
              }
            ]
          },
          "optional": true,
          "description": "The [visual style](https://spectrum.adobe.com/page/button/#Options) of the button.",
          "default": "'primary'"
        },
        "fillStyle": {
          "type": "property",
          "name": "fillStyle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "fill"
              },
              {
                "type": "string",
                "value": "outline"
              }
            ]
          },
          "optional": true,
          "description": "The background style of the Button.",
          "default": "'fill'"
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Button.",
          "default": "'M'"
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "The static color style to apply. Useful when the Button appears over a color background.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "LinkButtonProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Button.tsx:LinkButtonProps",
      "name": "LinkButtonProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the Button.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the link is disabled.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "primary"
              },
              {
                "type": "string",
                "value": "secondary"
              },
              {
                "type": "string",
                "value": "accent"
              },
              {
                "type": "string",
                "value": "negative"
              },
              {
                "type": "string",
                "value": "premium"
              },
              {
                "type": "string",
                "value": "genai"
              }
            ]
          },
          "optional": true,
          "description": "The [visual style](https://spectrum.adobe.com/page/button/#Options) of the button.",
          "default": "'primary'"
        },
        "fillStyle": {
          "type": "property",
          "name": "fillStyle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "fill"
              },
              {
                "type": "string",
                "value": "outline"
              }
            ]
          },
          "optional": true,
          "description": "The background style of the Button.",
          "default": "'fill'"
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Button.",
          "default": "'M'"
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "The static color style to apply. Useful when the Button appears over a color background.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ButtonGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ButtonGroup.tsx:ButtonGroupProps",
      "name": "ButtonGroupProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The Buttons contained within the ButtonGroup.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Buttons in the ButtonGroup are all disabled.",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "horizontal"
              },
              {
                "type": "string",
                "value": "vertical"
              }
            ]
          },
          "optional": true,
          "description": "The axis the ButtonGroup should align with. Setting this to 'vertical' will prevent\nany switching behaviors between 'vertical' and 'horizontal'.",
          "default": "'horizontal'"
        },
        "align": {
          "type": "property",
          "name": "align",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "end"
              },
              {
                "type": "string",
                "value": "center"
              }
            ]
          },
          "optional": true,
          "description": "The alignment of the Buttons within the ButtonGroup.",
          "default": "'start'"
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Buttons within the ButtonGroup.",
          "default": "'M'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CalendarProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Calendar.tsx:CalendarProps",
      "name": "CalendarProps",
      "properties": {
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The error message to display when the calendar is invalid.",
          "default": null
        },
        "visibleMonths": {
          "type": "property",
          "name": "visibleMonths",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The number of months to display at once.",
          "default": "1"
        },
        "createCalendar": {
          "type": "property",
          "name": "createCalendar",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "identifier",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function to create a new [Calendar](https://react-spectrum.adobe.com/internationalized/date/Calendar.html)\nobject for a given calendar identifier. If not provided, the `createCalendar` function\nfrom `@internationalized/date` will be used.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the calendar is disabled.",
          "default": "false"
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the calendar value is immutable.",
          "default": "false"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to automatically focus the calendar when it mounts.",
          "default": "false"
        },
        "focusedValue": {
          "type": "property",
          "name": "focusedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "Controls the currently focused date within the calendar.",
          "default": null
        },
        "defaultFocusedValue": {
          "type": "property",
          "name": "defaultFocusedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The date that is focused when the calendar first mounts (uncountrolled).",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the focused date changes.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the current selection is invalid according to application logic.",
          "default": null
        },
        "pageBehavior": {
          "type": "property",
          "name": "pageBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
          },
          "optional": true,
          "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
          "default": "visible"
        },
        "firstDayOfWeek": {
          "type": "property",
          "name": "firstDayOfWeek",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "sun"
              },
              {
                "type": "string",
                "value": "mon"
              },
              {
                "type": "string",
                "value": "tue"
              },
              {
                "type": "string",
                "value": "wed"
              },
              {
                "type": "string",
                "value": "thu"
              },
              {
                "type": "string",
                "value": "fri"
              },
              {
                "type": "string",
                "value": "sat"
              }
            ]
          },
          "optional": true,
          "description": "The day that starts the week.",
          "default": null
        },
        "selectionAlignment": {
          "type": "property",
          "name": "selectionAlignment",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "center"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "Determines the alignment of the visible months on initial render based on the current selection or current date if there is no selection.",
          "default": "'center'"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "CardProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardProps",
      "name": "CardProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "renderProps",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardRenderProps"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "description": "The children of the Card.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Card.",
          "default": "'M'"
        },
        "density": {
          "type": "property",
          "name": "density",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "compact"
              },
              {
                "type": "string",
                "value": "regular"
              },
              {
                "type": "string",
                "value": "spacious"
              }
            ]
          },
          "optional": true,
          "description": "The amount of internal padding within the Card.",
          "default": "'regular'"
        },
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "primary"
              },
              {
                "type": "string",
                "value": "secondary"
              },
              {
                "type": "string",
                "value": "tertiary"
              },
              {
                "type": "string",
                "value": "quiet"
              }
            ]
          },
          "optional": true,
          "description": "The visual style of the Card.",
          "default": "'primary'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the item.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the item's contents, used for features like typeahead.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CardPreviewProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardPreviewProps",
      "name": "CardPreviewProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "AssetCardProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:AssetCardProps",
      "name": "AssetCardProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "renderProps",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardRenderProps"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "description": "The children of the Card.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Card.",
          "default": "'M'"
        },
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "primary"
              },
              {
                "type": "string",
                "value": "secondary"
              },
              {
                "type": "string",
                "value": "tertiary"
              },
              {
                "type": "string",
                "value": "quiet"
              }
            ]
          },
          "optional": true,
          "description": "The visual style of the Card.",
          "default": "'primary'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the item.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the item's contents, used for features like typeahead.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ProductCardProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:ProductCardProps",
      "name": "ProductCardProps",
      "properties": {
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "primary"
              },
              {
                "type": "string",
                "value": "secondary"
              },
              {
                "type": "string",
                "value": "tertiary"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "renderProps",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardRenderProps"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "description": "The children of the Card.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Card.",
          "default": "'M'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the item.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the item's contents, used for features like typeahead.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "UserCardProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:UserCardProps",
      "name": "UserCardProps",
      "properties": {
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "primary"
              },
              {
                "type": "string",
                "value": "secondary"
              },
              {
                "type": "string",
                "value": "tertiary"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "renderProps",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardRenderProps"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "description": "The children of the Card.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Card.",
          "default": "'M'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the item.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the item's contents, used for features like typeahead.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CardViewProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CardView.tsx:CardViewProps",
      "name": "CardViewProps",
      "properties": {
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "waterfall"
              }
            ]
          },
          "optional": true,
          "description": "The layout of the cards.",
          "default": "'grid'"
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the cards.",
          "default": "'M'"
        },
        "density": {
          "type": "property",
          "name": "density",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "compact"
              },
              {
                "type": "string",
                "value": "regular"
              },
              {
                "type": "string",
                "value": "spacious"
              }
            ]
          },
          "optional": true,
          "description": "The amount of space between the cards.",
          "default": "'regular'"
        },
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "primary"
              },
              {
                "type": "string",
                "value": "secondary"
              },
              {
                "type": "string",
                "value": "tertiary"
              },
              {
                "type": "string",
                "value": "quiet"
              }
            ]
          },
          "optional": true,
          "description": "The visual style of the cards.",
          "default": "'primary'"
        },
        "selectionStyle": {
          "type": "property",
          "name": "selectionStyle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "checkbox"
              },
              {
                "type": "string",
                "value": "highlight"
              }
            ]
          },
          "optional": true,
          "description": "How selection should be displayed.",
          "default": "'checkbox'"
        },
        "loadingState": {
          "type": "property",
          "name": "loadingState",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState"
          },
          "optional": true,
          "description": "The loading state of the CardView.",
          "default": null
        },
        "onLoadMore": {
          "type": "property",
          "name": "onLoadMore",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "renderActionBar": {
          "type": "property",
          "name": "renderActionBar",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selectedKeys",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "all"
                    },
                    {
                      "type": "application",
                      "base": {
                        "type": "identifier",
                        "name": "Set"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides the ActionBar to render when cards are selected in the CardView.",
          "default": null
        },
        "disallowTypeAhead": {
          "type": "property",
          "name": "disallowTypeAhead",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether typeahead navigation is disabled.",
          "default": "false"
        },
        "dragAndDropHooks": {
          "type": "property",
          "name": "dragAndDropHooks",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "NoInfer"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The drag and drop hooks returned by `useDragAndDrop` used to enable drag and drop behavior for the GridList.",
          "default": null
        },
        "renderEmptyState": {
          "type": "property",
          "name": "renderEmptyState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides content to display when there are no items in the list.",
          "default": null
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the grid list or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              }
            ]
          },
          "optional": true,
          "description": "Whether to auto focus the gridlist or an option.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "optional": true,
          "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
          "default": "\"all\""
        },
        "shouldSelectOnPressUp": {
          "type": "property",
          "name": "shouldSelectOnPressUp",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether selection should occur on press up instead of press down.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "CheckboxProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Checkbox.tsx:CheckboxProps",
      "name": "CheckboxProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The label for the element.",
          "default": null
        },
        "inputRef": {
          "type": "property",
          "name": "inputRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the HTML input element.",
          "default": null
        },
        "isIndeterminate": {
          "type": "property",
          "name": "isIndeterminate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Indeterminism is presentational only.\nThe indeterminate visual representation remains regardless of user interaction.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
          "default": null
        },
        "defaultSelected": {
          "type": "property",
          "name": "defaultSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should be selected (uncontrolled).",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should be selected (controlled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isSelected",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's selection state changes.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Checkbox.",
          "default": "'M'"
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Checkbox should be displayed with an emphasized style.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CheckboxGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CheckboxGroup.tsx:CheckboxGroupProps",
      "name": "CheckboxGroupProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Checkboxes in the CheckboxGroup.",
          "default": "'M'"
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The axis the checkboxes should align with.",
          "default": "'vertical'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The Checkboxes contained within the CheckboxGroup.",
          "default": null
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "By default, checkboxes are not emphasized (gray).\nThe emphasized (blue) version provides visual prominence.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "string"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CloseButtonProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CloseButton.tsx:CloseButtonProps",
      "name": "CloseButtonProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the CloseButton.",
          "default": "'M'"
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "The static color style to apply. Useful when the Button appears over a color background.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is disabled.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorAreaProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorArea.tsx:ColorAreaProps",
      "name": "ColorAreaProps",
      "properties": {
        "xName": {
          "type": "property",
          "name": "xName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the x channel input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "yName": {
          "type": "property",
          "name": "yName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the y channel input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the ColorArea with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "colorSpace": {
          "type": "property",
          "name": "colorSpace",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
          },
          "optional": true,
          "description": "The color space that the color area operates in. The `xChannel` and `yChannel` must be in this color space.\nIf not provided, this defaults to the color space of the `color` or `defaultColor` value.",
          "default": null
        },
        "xChannel": {
          "type": "property",
          "name": "xChannel",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          },
          "optional": true,
          "description": "Color channel for the horizontal axis.",
          "default": null
        },
        "yChannel": {
          "type": "property",
          "name": "yChannel",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          },
          "optional": true,
          "description": "Color channel for the vertical axis.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the ColorArea is disabled.",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes, as the user drags.",
          "default": null
        },
        "onChangeEnd": {
          "type": "property",
          "name": "onChangeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the user stops dragging.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorField.tsx:ColorFieldProps",
      "name": "ColorFieldProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the color field.",
          "default": "'M'"
        },
        "channel": {
          "type": "property",
          "name": "channel",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          },
          "optional": true,
          "description": "The color channel that this field edits. If not provided, \nthe color is edited as a hex value.",
          "default": null
        },
        "colorSpace": {
          "type": "property",
          "name": "colorSpace",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
          },
          "optional": true,
          "description": "The color space that the color field operates in if a `channel` prop is provided.\nIf no `channel` is provided, the color field always displays the color as an RGB hex value.",
          "default": null
        },
        "isWheelDisabled": {
          "type": "property",
          "name": "isWheelDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Enables or disables changing the value with scroll.",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "color",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "onCopy": {
          "type": "property",
          "name": "onCopy",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
          "default": null
        },
        "onCut": {
          "type": "property",
          "name": "onCut",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
          "default": null
        },
        "onPaste": {
          "type": "property",
          "name": "onPaste",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
          "default": null
        },
        "onCompositionStart": {
          "type": "property",
          "name": "onCompositionStart",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
          "default": null
        },
        "onCompositionEnd": {
          "type": "property",
          "name": "onCompositionEnd",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
          "default": null
        },
        "onCompositionUpdate": {
          "type": "property",
          "name": "onCompositionUpdate",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
          "default": null
        },
        "onSelect": {
          "type": "property",
          "name": "onSelect",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReactEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
          "default": null
        },
        "onBeforeInput": {
          "type": "property",
          "name": "onBeforeInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
          "default": null
        },
        "onInput": {
          "type": "property",
          "name": "onInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSliderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorSlider.tsx:ColorSliderProps",
      "name": "ColorSliderProps",
      "properties": {
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "default": null
        },
        "colorSpace": {
          "type": "property",
          "name": "colorSpace",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
          },
          "optional": true,
          "description": "The color space that the slider operates in. The `channel` must be in this color space.\nIf not provided, this defaults to the color space of the `color` or `defaultColor` value.",
          "default": null
        },
        "channel": {
          "type": "property",
          "name": "channel",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
          },
          "optional": false,
          "description": "The color channel that the slider manipulates.",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes, as the user drags.",
          "default": null
        },
        "onChangeEnd": {
          "type": "property",
          "name": "onChangeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the user stops dragging.",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The orientation of the Slider.",
          "default": "'horizontal'"
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the whole Slider is disabled.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSwatchProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorSwatch.tsx:ColorSwatchProps",
      "name": "ColorSwatchProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "description": "The size of the ColorSwatch.",
          "default": "'M'"
        },
        "rounding": {
          "type": "property",
          "name": "rounding",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "default"
              },
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "full"
              }
            ]
          },
          "optional": true,
          "description": "The corner rounding of the ColorSwatch.",
          "default": "'default'"
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "color": {
          "type": "property",
          "name": "color",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": true,
          "description": "The color value to display in the swatch.",
          "default": null
        },
        "colorName": {
          "type": "property",
          "name": "colorName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A localized accessible name for the color.\nBy default, a description is generated from the color value,\nbut this can be overridden if you have a more specific color\nname (e.g. Pantone colors).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorSwatchPickerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorSwatchPicker.tsx:ColorSwatchPickerProps",
      "name": "ColorSwatchPickerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The ColorSwatches within the ColorSwatchPicker.",
          "default": null
        },
        "density": {
          "type": "property",
          "name": "density",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "compact"
              },
              {
                "type": "string",
                "value": "regular"
              },
              {
                "type": "string",
                "value": "spacious"
              }
            ]
          },
          "optional": true,
          "description": "The amount of padding between the swatches.",
          "default": "'regular'"
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "description": "The size of the color swatches.",
          "default": "'M'"
        },
        "rounding": {
          "type": "property",
          "name": "rounding",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "default"
              },
              {
                "type": "string",
                "value": "full"
              }
            ]
          },
          "optional": true,
          "description": "The corner rounding of the color swatches.",
          "default": "'none'"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColorWheelProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ColorWheel.tsx:ColorWheelProps",
      "name": "ColorWheelProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "default": "192"
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the ColorWheel is disabled.",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes, as the user drags.",
          "default": null
        },
        "onChangeEnd": {
          "type": "property",
          "name": "onChangeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the user stops dragging.",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": "'hsl(0, 100%, 50%)'"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ComboBoxProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ComboBox.tsx:ComboBoxProps",
      "name": "ComboBoxProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "object",
                      "properties": null
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "description": "The contents of the collection.",
          "default": null
        },
        "direction": {
          "type": "property",
          "name": "direction",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "bottom"
              },
              {
                "type": "string",
                "value": "top"
              }
            ]
          },
          "optional": true,
          "description": "Direction the menu will render relative to the ComboBox.",
          "default": "'bottom'"
        },
        "align": {
          "type": "property",
          "name": "align",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "Alignment of the menu relative to the input target.",
          "default": "'start'"
        },
        "menuWidth": {
          "type": "property",
          "name": "menuWidth",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "Width of the menu. By default, matches width of the trigger. Note that the minimum width of the dropdown is always equal to the trigger's width.",
          "default": null
        },
        "loadingState": {
          "type": "property",
          "name": "loadingState",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState"
          },
          "optional": true,
          "description": "The current loading state of the ComboBox. Determines whether or not the progress circle should be shown.",
          "default": null
        },
        "formValue": {
          "type": "property",
          "name": "formValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "key"
              }
            ]
          },
          "optional": true,
          "description": "Whether the text or key of the selected item is submitted as part of an HTML form.\nWhen `allowsCustomValue` is `true`, this option does not apply and the text is always submitted.",
          "default": "'key'"
        },
        "shouldFocusWrap": {
          "type": "property",
          "name": "shouldFocusWrap",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether keyboard navigation is circular.",
          "default": null
        },
        "defaultItems": {
          "type": "property",
          "name": "defaultItems",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The list of ComboBox items (uncontrolled).",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "The list of ComboBox items (controlled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "menuTrigger",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Method that is called when the open state of the menu changes. Returns the new open state and the action that caused the opening of the menu.",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value of the ComboBox input (controlled).",
          "default": null
        },
        "defaultInputValue": {
          "type": "property",
          "name": "defaultInputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The default value of the ComboBox input (uncontrolled).",
          "default": null
        },
        "onInputChange": {
          "type": "property",
          "name": "onInputChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the ComboBox input value changes.",
          "default": null
        },
        "allowsCustomValue": {
          "type": "property",
          "name": "allowsCustomValue",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the ComboBox allows a non-item matching input value to be set.",
          "default": null
        },
        "menuTrigger": {
          "type": "property",
          "name": "menuTrigger",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction"
          },
          "optional": true,
          "description": "The interaction required to display the ComboBox menu.",
          "default": "'input'"
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The currently selected key in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKey": {
          "type": "property",
          "name": "defaultSelectedKey",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": true,
          "description": "The initial selected key in the collection (uncontrolled).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:ComboBoxValidationValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Combobox.",
          "default": "'M'"
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "shouldFlip": {
          "type": "property",
          "name": "shouldFlip",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
          "default": "true"
        },
        "onLoadMore": {
          "type": "property",
          "name": "onLoadMore",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "extends": []
    },
    "ComboBoxItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ComboBox.tsx:ComboBoxItemProps",
      "name": "ComboBoxItemProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the item.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the item's contents, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this item.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ComboBoxSectionProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ComboBox.tsx:ComboBoxSectionProps",
      "name": "ComboBoxSectionProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the section.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Static child items or a function to render children.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for the section.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the section.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "extends": []
    },
    "DateFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DateField.tsx:DateFieldProps",
      "name": "DateFieldProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the DateField.",
          "default": "'M'"
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "placeholderValue": {
          "type": "property",
          "name": "placeholderValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
          "default": null
        },
        "hourCycle": {
          "type": "property",
          "name": "hourCycle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 12
              },
              {
                "type": "number",
                "value": 24
              }
            ]
          },
          "optional": true,
          "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": true,
          "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
          "default": null
        },
        "hideTimeZone": {
          "type": "property",
          "name": "hideTimeZone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to hide the time zone abbreviation.",
          "default": "false"
        },
        "shouldForceLeadingZeros": {
          "type": "property",
          "name": "shouldForceLeadingZeros",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "DatePickerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DatePicker.tsx:DatePickerProps",
      "name": "DatePickerProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the DateField.",
          "default": "'M'"
        },
        "maxVisibleMonths": {
          "type": "property",
          "name": "maxVisibleMonths",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of months to display at once in the calendar popover, if screen space permits.",
          "default": "1"
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "pageBehavior": {
          "type": "property",
          "name": "pageBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
          },
          "optional": true,
          "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
          "default": "visible"
        },
        "firstDayOfWeek": {
          "type": "property",
          "name": "firstDayOfWeek",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "sun"
              },
              {
                "type": "string",
                "value": "mon"
              },
              {
                "type": "string",
                "value": "tue"
              },
              {
                "type": "string",
                "value": "wed"
              },
              {
                "type": "string",
                "value": "thu"
              },
              {
                "type": "string",
                "value": "fri"
              },
              {
                "type": "string",
                "value": "sat"
              }
            ]
          },
          "optional": true,
          "description": "The day that starts the week.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "placeholderValue": {
          "type": "property",
          "name": "placeholderValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
          "default": null
        },
        "hourCycle": {
          "type": "property",
          "name": "hourCycle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 12
              },
              {
                "type": "number",
                "value": 24
              }
            ]
          },
          "optional": true,
          "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": true,
          "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
          "default": null
        },
        "hideTimeZone": {
          "type": "property",
          "name": "hideTimeZone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to hide the time zone abbreviation.",
          "default": "false"
        },
        "shouldForceLeadingZeros": {
          "type": "property",
          "name": "shouldForceLeadingZeros",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "shouldCloseOnSelect": {
          "type": "property",
          "name": "shouldCloseOnSelect",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "function",
                "parameters": [],
                "return": {
                  "type": "boolean"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Determines whether the date picker popover should close automatically when a date is selected.",
          "default": "true"
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "createCalendar": {
          "type": "property",
          "name": "createCalendar",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "identifier",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function to create a new [Calendar](https://react-spectrum.adobe.com/internationalized/date/Calendar.html)\nobject for a given calendar identifier. If not provided, the `createCalendar` function\nfrom `@internationalized/date` will be used.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "DateRangePickerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DateRangePicker.tsx:DateRangePickerProps",
      "name": "DateRangePickerProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the DateField.",
          "default": "'M'"
        },
        "maxVisibleMonths": {
          "type": "property",
          "name": "maxVisibleMonths",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of months to display at once in the calendar popover, if screen space permits.",
          "default": "1"
        },
        "pageBehavior": {
          "type": "property",
          "name": "pageBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
          },
          "optional": true,
          "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
          "default": "visible"
        },
        "firstDayOfWeek": {
          "type": "property",
          "name": "firstDayOfWeek",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "sun"
              },
              {
                "type": "string",
                "value": "mon"
              },
              {
                "type": "string",
                "value": "tue"
              },
              {
                "type": "string",
                "value": "wed"
              },
              {
                "type": "string",
                "value": "thu"
              },
              {
                "type": "string",
                "value": "fri"
              },
              {
                "type": "string",
                "value": "sat"
              }
            ]
          },
          "optional": true,
          "description": "The day that starts the week.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "placeholderValue": {
          "type": "property",
          "name": "placeholderValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A placeholder date that influences the format of the placeholder shown when no value is selected. Defaults to today's date at midnight.",
          "default": null
        },
        "hourCycle": {
          "type": "property",
          "name": "hourCycle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 12
              },
              {
                "type": "number",
                "value": 24
              }
            ]
          },
          "optional": true,
          "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity"
          },
          "optional": true,
          "description": "Determines the smallest unit that is displayed in the date picker. By default, this is `\"day\"` for dates, and `\"minute\"` for times.",
          "default": null
        },
        "hideTimeZone": {
          "type": "property",
          "name": "hideTimeZone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to hide the time zone abbreviation.",
          "default": "false"
        },
        "shouldForceLeadingZeros": {
          "type": "property",
          "name": "shouldForceLeadingZeros",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to always show leading zeros in the month, day, and hour fields.\nBy default, this is determined by the user's locale.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "allowsNonContiguousRanges": {
          "type": "property",
          "name": "allowsNonContiguousRanges",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "When combined with `isDateUnavailable`, determines whether non-contiguous ranges,\ni.e. ranges containing unavailable dates, may be selected.",
          "default": null
        },
        "startName": {
          "type": "property",
          "name": "startName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the start date input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "endName": {
          "type": "property",
          "name": "endName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the end date input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                      },
                      "typeParameters": [
                        {
                          "type": "application",
                          "base": {
                            "type": "link",
                            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue"
                          },
                          "typeParameters": [
                            {
                              "type": "link",
                              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "shouldCloseOnSelect": {
          "type": "property",
          "name": "shouldCloseOnSelect",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "function",
                "parameters": [],
                "return": {
                  "type": "boolean"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Determines whether the date picker popover should close automatically when a date is selected.",
          "default": "true"
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": [
        {
          "type": "identifier",
          "name": "RangeCalendarProps"
        }
      ]
    },
    "DialogProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Dialog.tsx:DialogProps",
      "name": "DialogProps",
      "properties": {
        "isDismissible": {
          "type": "property",
          "name": "isDismissible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Dialog is dismissible.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Dialog.",
          "default": "'M'"
        },
        "isKeyboardDismissDisabled": {
          "type": "property",
          "name": "isKeyboardDismissDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether pressing the escape key to close the dialog should be disabled.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "opts",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
          "default": null
        },
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "alertdialog"
              }
            ]
          },
          "optional": true,
          "description": "The accessibility role for the dialog.",
          "default": "'dialog'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "CustomDialogProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/CustomDialog.tsx:CustomDialogProps",
      "name": "CustomDialogProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "fullscreen"
              },
              {
                "type": "string",
                "value": "fullscreenTakeover"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Dialog.",
          "default": null
        },
        "isDismissible": {
          "type": "property",
          "name": "isDismissible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Dialog is dismissible.",
          "default": null
        },
        "isKeyboardDismissDisabled": {
          "type": "property",
          "name": "isKeyboardDismissDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether pressing the escape key to close the dialog should be disabled.",
          "default": null
        },
        "padding": {
          "type": "property",
          "name": "padding",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "default"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "The amount of padding around the contents of the dialog.",
          "default": "'default'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "opts",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
          "default": null
        },
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "alertdialog"
              }
            ]
          },
          "optional": true,
          "description": "The accessibility role for the dialog.",
          "default": "'dialog'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "FullscreenDialogProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/FullscreenDialog.tsx:FullscreenDialogProps",
      "name": "FullscreenDialogProps",
      "properties": {
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "fullscreen"
              },
              {
                "type": "string",
                "value": "fullscreenTakeover"
              }
            ]
          },
          "optional": true,
          "description": "The variant of fullscreen dialog to display.",
          "default": "\"fullscreen\""
        },
        "isKeyboardDismissDisabled": {
          "type": "property",
          "name": "isKeyboardDismissDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether pressing the escape key to close the dialog should be disabled.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "opts",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
          "default": null
        },
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "alertdialog"
              }
            ]
          },
          "optional": true,
          "description": "The accessibility role for the dialog.",
          "default": "'dialog'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DialogContainerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogContainer.tsx:DialogContainerProps",
      "name": "DialogContainerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The Dialog to display, if any.",
          "default": null
        },
        "onDismiss": {
          "type": "property",
          "name": "onDismiss",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "description": "Handler that is called when the 'x' button of a dismissable Dialog is clicked.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DialogContainerValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogContainer.tsx:DialogContainerValue",
      "name": "DialogContainerValue",
      "properties": {
        "dismiss": {
          "type": "method",
          "name": "dismiss",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "A handler to programmatically dismiss the dialog.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "DialogTriggerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogTrigger.tsx:DialogTriggerProps",
      "name": "DialogTriggerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DisclosureProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Disclosure.tsx:DisclosureProps",
      "name": "DisclosureProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the disclosure.",
          "default": "'M'"
        },
        "density": {
          "type": "property",
          "name": "density",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "compact"
              },
              {
                "type": "string",
                "value": "regular"
              },
              {
                "type": "string",
                "value": "spacious"
              }
            ]
          },
          "optional": true,
          "description": "The amount of space between the disclosures.",
          "default": "'regular'"
        },
        "isQuiet": {
          "type": "property",
          "name": "isQuiet",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the disclosure should be displayed with a quiet style.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The contents of the disclosure, consisting of a DisclosureTitle and DisclosurePanel.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "An id for the disclosure when used within a DisclosureGroup, matching the id used in `expandedKeys`.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the disclosure is disabled.",
          "default": null
        },
        "onExpandedChange": {
          "type": "property",
          "name": "onExpandedChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isExpanded",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the disclosure's expanded state changes.",
          "default": null
        },
        "isExpanded": {
          "type": "property",
          "name": "isExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the disclosure is expanded (controlled).",
          "default": null
        },
        "defaultExpanded": {
          "type": "property",
          "name": "defaultExpanded",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the disclosure is expanded by default (uncontrolled).",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DisclosurePanelProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Disclosure.tsx:DisclosurePanelProps",
      "name": "DisclosurePanelProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "React.ReactNode"
          },
          "optional": false,
          "default": null
        },
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "group"
              },
              {
                "type": "string",
                "value": "region"
              }
            ]
          },
          "optional": true,
          "description": "The accessibility role for the disclosure's panel.",
          "default": "'group'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DividerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Divider.tsx:DividerProps",
      "name": "DividerProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "description": "How thick the Divider should be.",
          "default": "'M'"
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "horizontal"
              },
              {
                "type": "string",
                "value": "vertical"
              }
            ]
          },
          "optional": true,
          "description": "How thick the Divider should be.",
          "default": "'horizontal'"
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "The static color style to apply. Useful when the Divider appears over a color background.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "DropZoneProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DropZone.tsx:DropZoneProps",
      "name": "DropZoneProps",
      "properties": {
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the drop zone.",
          "default": null
        },
        "isFilled": {
          "type": "property",
          "name": "isFilled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drop zone has been filled.",
          "default": null
        },
        "replaceMessage": {
          "type": "property",
          "name": "replaceMessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The message to replace the default banner message that is shown when the drop zone is filled.",
          "default": "'Drop file to replace'"
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "description": "The size of the DropZone.",
          "default": "'M'"
        },
        "getDropOperation": {
          "type": "property",
          "name": "getDropOperation",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "allowedOperations",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
          "default": null
        },
        "onDropEnter": {
          "type": "property",
          "name": "onDropEnter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEnterEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag enters the drop target.",
          "default": null
        },
        "onDropMove": {
          "type": "property",
          "name": "onDropMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is moved within the drop target.",
          "default": null
        },
        "onDropActivate": {
          "type": "property",
          "name": "onDropActivate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropActivateEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called after a valid drag is held over the drop target for a period of time.\nThis typically opens the item so that the user can drop within it.",
          "default": null
        },
        "onDropExit": {
          "type": "property",
          "name": "onDropExit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropExitEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag exits the drop target.",
          "default": null
        },
        "onDrop": {
          "type": "property",
          "name": "onDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is dropped on the drop target.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "FormProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Form.tsx:FormProps",
      "name": "FormProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "Size of the Form elements.",
          "default": "'M'"
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Form elements are disabled.",
          "default": null
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Form elements are rendered with their emphasized style.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the label is labeling a required field or group.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "aria"
              },
              {
                "type": "string",
                "value": "native"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen a field value is missing or invalid, or mark fields as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "validationErrors": {
          "type": "property",
          "name": "validationErrors",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationErrors"
          },
          "optional": true,
          "description": "Validation errors for the form, typically returned by a server.\nThis should be set to an object mapping from input names to errors.",
          "default": null
        },
        "action": {
          "type": "property",
          "name": "action",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "indexedAccess",
                "objectType": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FormHTMLAttributes"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                "indexType": {
                  "type": "string",
                  "value": "action"
                }
              }
            ]
          },
          "optional": true,
          "description": "Where to send the form-data when the form is submitted.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#action).",
          "default": null
        },
        "encType": {
          "type": "property",
          "name": "encType",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "application/x-www-form-urlencoded"
              },
              {
                "type": "string",
                "value": "multipart/form-data"
              },
              {
                "type": "string",
                "value": "text/plain"
              }
            ]
          },
          "optional": true,
          "description": "The enctype attribute specifies how the form-data should be encoded when submitting it to the server.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#enctype).",
          "default": null
        },
        "method": {
          "type": "property",
          "name": "method",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "get"
              },
              {
                "type": "string",
                "value": "post"
              },
              {
                "type": "string",
                "value": "dialog"
              }
            ]
          },
          "optional": true,
          "description": "The HTTP method to submit the form with.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#method).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "_blank"
              },
              {
                "type": "string",
                "value": "_self"
              },
              {
                "type": "string",
                "value": "_parent"
              },
              {
                "type": "string",
                "value": "_top"
              }
            ]
          },
          "optional": true,
          "description": "The target attribute specifies a name or a keyword that indicates where to display the response that is received after submitting the form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#target).",
          "default": null
        },
        "onSubmit": {
          "type": "property",
          "name": "onSubmit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FormEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Triggered when a user submits the form.",
          "default": null
        },
        "onReset": {
          "type": "property",
          "name": "onReset",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FormEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Triggered when a user resets the form.",
          "default": null
        },
        "onInvalid": {
          "type": "property",
          "name": "onInvalid",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FormEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "HTMLFormElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Triggered for each invalid field when a user submits the form.",
          "default": null
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "off"
              },
              {
                "type": "string",
                "value": "on"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether input elements can by default have their values automatically completed by the browser.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#autocomplete).",
          "default": null
        },
        "autoCapitalize": {
          "type": "property",
          "name": "autoCapitalize",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "off"
              },
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "on"
              },
              {
                "type": "string",
                "value": "sentences"
              },
              {
                "type": "string",
                "value": "words"
              },
              {
                "type": "string",
                "value": "characters"
              }
            ]
          },
          "optional": true,
          "description": "Controls whether inputted text is automatically capitalized and, if so, in what manner. \nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/autocapitalize).",
          "default": null
        },
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "presentation"
              }
            ]
          },
          "optional": true,
          "description": "An ARIA role override to apply to the form element.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLFormElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "IconProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IconProps",
      "name": "IconProps",
      "properties": {
        "aria-hidden": {
          "type": "property",
          "name": "aria-hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "true"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:AllowedOverrides"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "IconContextValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IconContextValue",
      "name": "IconContextValue",
      "properties": {
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
          },
          "optional": true,
          "default": null
        },
        "render": {
          "type": "property",
          "name": "render",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "icon",
                "value": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "IllustrationProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IllustrationProps",
      "name": "IllustrationProps",
      "properties": {
        "aria-hidden": {
          "type": "property",
          "name": "aria-hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "true"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:AllowedOverrides"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "IllustrationContextValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IllustrationContextValue",
      "name": "IllustrationContextValue",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
          },
          "optional": true,
          "default": null
        },
        "render": {
          "type": "property",
          "name": "render",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "icon",
                "value": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "InlineAlertProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/InlineAlert.tsx:InlineAlertProps",
      "name": "InlineAlertProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The contents of the Inline Alert.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to automatically focus the Inline Alert when it first renders.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "informative"
              },
              {
                "type": "string",
                "value": "positive"
              },
              {
                "type": "string",
                "value": "notice"
              },
              {
                "type": "string",
                "value": "negative"
              },
              {
                "type": "string",
                "value": "neutral"
              }
            ]
          },
          "optional": true,
          "description": "The semantic tone of a Inline Alert.",
          "default": "neutral"
        },
        "fillStyle": {
          "type": "property",
          "name": "fillStyle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "border"
              },
              {
                "type": "string",
                "value": "subtleFill"
              },
              {
                "type": "string",
                "value": "boldFill"
              }
            ]
          },
          "optional": true,
          "description": "The visual style of the Inline Alert.",
          "default": "border"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ImageProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Image.tsx:ImageProps",
      "name": "ImageProps",
      "properties": {
        "src": {
          "type": "property",
          "name": "src",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The URL of the image.",
          "default": null
        },
        "alt": {
          "type": "property",
          "name": "alt",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Accessible alt text for the image.",
          "default": null
        },
        "crossOrigin": {
          "type": "property",
          "name": "crossOrigin",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "anonymous"
              },
              {
                "type": "string",
                "value": "use-credentials"
              }
            ]
          },
          "optional": true,
          "description": "Indicates if the fetching of the image must be done using a CORS request.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/crossorigin).",
          "default": null
        },
        "decoding": {
          "type": "property",
          "name": "decoding",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "async"
              },
              {
                "type": "string",
                "value": "auto"
              },
              {
                "type": "string",
                "value": "sync"
              }
            ]
          },
          "optional": true,
          "description": "Whether the browser should decode images synchronously or asynchronously.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#decoding).",
          "default": null
        },
        "fetchPriority": {
          "type": "property",
          "name": "fetchPriority",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "high"
              },
              {
                "type": "string",
                "value": "low"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "Provides a hint of the relative priority to use when fetching the image.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#fetchpriority).",
          "default": null
        },
        "loading": {
          "type": "property",
          "name": "loading",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "eager"
              },
              {
                "type": "string",
                "value": "lazy"
              }
            ]
          },
          "optional": true,
          "description": "Whether the image should be loaded immediately or lazily when scrolled into view.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#loading).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "A string indicating which referrer to use when fetching the resource.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#referrerpolicy).",
          "default": null
        },
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The intrinsic width of the image.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/img#width).",
          "default": null
        },
        "height": {
          "type": "property",
          "name": "height",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The intrinsic height of the image.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/img#height).",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "renderError": {
          "type": "property",
          "name": "renderError",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that is called to render a fallback when the image fails to load.",
          "default": null
        },
        "group": {
          "type": "property",
          "name": "group",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageGroup"
          },
          "optional": true,
          "description": "A group of images to coordinate between, matching the group passed to the `<ImageCoordinator>` component.\nIf not provided, the default image group is used.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ImageCoordinatorProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageCoordinatorProps",
      "name": "ImageCoordinatorProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "Children within the ImageCoordinator.",
          "default": null
        },
        "timeout": {
          "type": "property",
          "name": "timeout",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "Time in milliseconds after which images are always displayed, even if all images are not yet loaded.",
          "default": "5000"
        },
        "group": {
          "type": "property",
          "name": "group",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageGroup"
          },
          "optional": true,
          "description": "A group of images to coordinate between, matching the group passed to the `<Image>` component.\nIf not provided, the default image group is used.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "LinkProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Link.tsx:LinkProps",
      "name": "LinkProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "primary"
              },
              {
                "type": "string",
                "value": "secondary"
              }
            ]
          },
          "optional": true,
          "description": "The [visual style](https://spectrum.adobe.com/page/link/#Options) of the link.",
          "default": "'primary'"
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "The static color style to apply. Useful when the link appears over a color background.",
          "default": null
        },
        "isStandalone": {
          "type": "property",
          "name": "isStandalone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the link is on its own vs inside a longer string of text.",
          "default": null
        },
        "isQuiet": {
          "type": "property",
          "name": "isQuiet",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the link should be displayed with a quiet style.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "MenuTriggerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuTriggerProps",
      "name": "MenuTriggerProps",
      "properties": {
        "align": {
          "type": "property",
          "name": "align",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "Alignment of the menu relative to the trigger.",
          "default": "'start'"
        },
        "direction": {
          "type": "property",
          "name": "direction",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "bottom"
              },
              {
                "type": "string",
                "value": "top"
              },
              {
                "type": "string",
                "value": "left"
              },
              {
                "type": "string",
                "value": "right"
              },
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "Where the Menu opens relative to its trigger.",
          "default": "'bottom'"
        },
        "shouldFlip": {
          "type": "property",
          "name": "shouldFlip",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the menu should automatically flip direction when space is limited.",
          "default": "true"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "trigger": {
          "type": "property",
          "name": "trigger",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/menu/src/index.d.ts:MenuTriggerType"
          },
          "optional": true,
          "description": "How the menu is triggered.",
          "default": "'press'"
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "MenuProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuProps",
      "name": "MenuProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Menu.",
          "default": "'M'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "description": "The contents of the collection.",
          "default": null
        },
        "hideLinkOutIcon": {
          "type": "property",
          "name": "hideLinkOutIcon",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Hides the default link out icons on menu items that open links in a new tab.",
          "default": null
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the menu or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              }
            ]
          },
          "optional": true,
          "description": "Where the focus should be set.",
          "default": null
        },
        "shouldFocusWrap": {
          "type": "property",
          "name": "shouldFocusWrap",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether keyboard navigation is circular.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when an item is selected.",
          "default": null
        },
        "onClose": {
          "type": "property",
          "name": "onClose",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the menu should close after selecting an item.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "MenuItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuItemProps",
      "name": "MenuItemProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The contents of the item.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the item.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the item's contents, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this item.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the item is selected.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "MenuSectionProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:MenuSectionProps",
      "name": "MenuSectionProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the section.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Static child items or a function to render children.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for the section.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the section.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The currently disabled keys in the collection (controlled).",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "extends": []
    },
    "SubmenuTriggerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Menu.tsx:SubmenuTriggerProps",
      "name": "SubmenuTriggerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "identifier",
              "name": "ReactElement"
            }
          },
          "optional": false,
          "description": "The contents of the SubmenuTrigger. The first child should be an Item (the trigger) and the second child should be the Popover (for the submenu).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "MeterProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Meter.tsx:MeterProps",
      "name": "MeterProps",
      "properties": {
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "formatOptions": {
          "type": "property",
          "name": "formatOptions",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Intl.NumberFormatOptions"
          },
          "optional": true,
          "description": "The display format of the value label.",
          "default": "{style: 'percent'}"
        },
        "valueLabel": {
          "type": "property",
          "name": "valueLabel",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the value's label (e.g. 1 of 4).",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": "0"
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The smallest value allowed for the input.",
          "default": "0"
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The largest value allowed for the input.",
          "default": "100"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "informative"
              },
              {
                "type": "string",
                "value": "positive"
              },
              {
                "type": "string",
                "value": "notice"
              },
              {
                "type": "string",
                "value": "negative"
              }
            ]
          },
          "optional": true,
          "description": "The [visual style](https://spectrum.adobe.com/page/meter/#-Options) of the Meter.",
          "default": "'informative'"
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Meter.",
          "default": "'M'"
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "The static color style to apply. Useful when the button appears over a color background.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "NotificationBadgeProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/NotificationBadge.tsx:NotificationBadgeProps",
      "name": "NotificationBadgeProps",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The value to be displayed in the notification badge.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the notification badge.",
          "default": "'S'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "PickerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:PickerProps",
      "name": "PickerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "object",
                      "properties": null
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "description": "The contents of the collection.",
          "default": null
        },
        "direction": {
          "type": "property",
          "name": "direction",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "bottom"
              },
              {
                "type": "string",
                "value": "top"
              }
            ]
          },
          "optional": true,
          "description": "Direction the menu will render relative to the Picker.",
          "default": "'bottom'"
        },
        "align": {
          "type": "property",
          "name": "align",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "Alignment of the menu relative to the input target.",
          "default": "'start'"
        },
        "menuWidth": {
          "type": "property",
          "name": "menuWidth",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "Width of the menu. By default, matches width of the trigger. Note that the minimum width of the dropdown is always equal to the trigger's width.",
          "default": null
        },
        "loadingState": {
          "type": "property",
          "name": "loadingState",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState"
          },
          "optional": true,
          "description": "The current loading state of the Picker.",
          "default": null
        },
        "placeholder": {
          "type": "property",
          "name": "placeholder",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Temporary text that occupies the select when it is empty.",
          "default": "'Select an item' (localized)"
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input, used when submitting an HTML form.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "Whether single or multiple selection is enabled.",
          "default": "'single'"
        },
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The currently selected key in the collection (controlled).",
          "access": "private",
          "default": null
        },
        "defaultSelectedKey": {
          "type": "property",
          "name": "defaultSelectedKey",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The initial selected key in the collection (uncontrolled).",
          "access": "private",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "access": "private",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Sets the open state of the menu.",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Sets the default open state of the menu.",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Method that is called when the open state of the menu changes.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValidationType"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Picker.",
          "default": "'M'"
        },
        "isQuiet": {
          "type": "property",
          "name": "isQuiet",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the picker should be displayed with a quiet style.",
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "shouldFlip": {
          "type": "property",
          "name": "shouldFlip",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
          "default": "true"
        },
        "onLoadMore": {
          "type": "property",
          "name": "onLoadMore",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "M",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:SelectionMode"
          },
          "default": {
            "type": "string",
            "value": "single"
          }
        }
      ],
      "extends": []
    },
    "PickerItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:PickerItemProps",
      "name": "PickerItemProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the item.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the item's contents, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this item.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on the item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "PickerSectionProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:PickerSectionProps",
      "name": "PickerSectionProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the section.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this section represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "Static child items or a function to render children.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for the section.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the section.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "object",
            "properties": null
          },
          "default": null
        }
      ],
      "extends": []
    },
    "PopoverProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Popover.tsx:PopoverProps",
      "name": "PopoverProps",
      "properties": {
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
          },
          "optional": true,
          "default": null
        },
        "hideArrow": {
          "type": "property",
          "name": "hideArrow",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether a popover's arrow should be hidden.",
          "default": "false"
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Popover. If not specified, the popover fits its contents.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "trigger": {
          "type": "property",
          "name": "trigger",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the component that triggered the popover. This is reflected on the element\nas the `data-trigger` attribute, and can be used to provide specific\nstyles for the popover depending on which element triggered it.",
          "default": null
        },
        "triggerRef": {
          "type": "property",
          "name": "triggerRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "Element"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref for the element which the popover positions itself with respect to.\n\nWhen used within a trigger component such as DialogTrigger, MenuTrigger, Select, etc.,\nthis is set automatically. It is only required when used standalone.",
          "default": null
        },
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the popover is currently performing an entry animation.",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the popover is currently performing an exit animation.",
          "default": null
        },
        "UNSTABLE_portalContainer": {
          "type": "property",
          "name": "UNSTABLE_portalContainer",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": true,
          "description": "The container element in which the overlay portal will be placed. This may have unknown behavior depending on where it is portalled to.",
          "access": "private",
          "default": "document.body"
        },
        "offset": {
          "type": "property",
          "name": "offset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
          "default": "8"
        },
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement"
          },
          "optional": true,
          "description": "The placement of the element with respect to its anchor element.",
          "default": "'bottom'"
        },
        "containerPadding": {
          "type": "property",
          "name": "containerPadding",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
          "default": "12"
        },
        "crossOffset": {
          "type": "property",
          "name": "crossOffset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
          "default": "0"
        },
        "shouldFlip": {
          "type": "property",
          "name": "shouldFlip",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
          "default": "true"
        },
        "arrowRef": {
          "type": "property",
          "name": "arrowRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "Element"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the popover arrow element.",
          "default": null
        },
        "boundaryElement": {
          "type": "property",
          "name": "boundaryElement",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": true,
          "description": "Element that that serves as the positioning boundary.",
          "default": "document.body"
        },
        "scrollRef": {
          "type": "property",
          "name": "scrollRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "Element"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the scrollable region within the overlay.",
          "default": "overlayRef"
        },
        "maxHeight": {
          "type": "property",
          "name": "maxHeight",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maxHeight specified for the overlay element.\nBy default, it will take all space up to the current viewport height.",
          "default": null
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ProgressBarProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ProgressBar.tsx:ProgressBarProps",
      "name": "ProgressBarProps",
      "properties": {
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "isIndeterminate": {
          "type": "property",
          "name": "isIndeterminate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether presentation is indeterminate when progress isn't known.",
          "default": null
        },
        "formatOptions": {
          "type": "property",
          "name": "formatOptions",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Intl.NumberFormatOptions"
          },
          "optional": true,
          "description": "The display format of the value label.",
          "default": "{style: 'percent'}"
        },
        "valueLabel": {
          "type": "property",
          "name": "valueLabel",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the value's label (e.g. 1 of 4).",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": "0"
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The smallest value allowed for the input.",
          "default": "0"
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The largest value allowed for the input.",
          "default": "100"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the ProgressBar.",
          "default": "'M'"
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "The static color style to apply. Useful when the button appears over a color background.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ProgressCircleProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ProgressCircle.tsx:ProgressCircleProps",
      "name": "ProgressCircleProps",
      "properties": {
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "isIndeterminate": {
          "type": "property",
          "name": "isIndeterminate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether presentation is indeterminate when progress isn't known.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": "0"
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The smallest value allowed for the input.",
          "default": "0"
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The largest value allowed for the input.",
          "default": "100"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "description": "The size of the ProgressCircle.",
          "default": "'M'"
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "The static color style to apply. Useful when the button appears over a color background.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ProviderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Provider.tsx:ProviderProps",
      "name": "ProviderProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content of the Provider.",
          "default": null
        },
        "locale": {
          "type": "property",
          "name": "locale",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The locale for your application as a [BCP 47](https://www.ietf.org/rfc/bcp/bcp47.txt) language code.\nDefaults to the browser/OS language setting.",
          "default": "'en-US'"
        },
        "router": {
          "type": "property",
          "name": "router",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Router"
          },
          "optional": true,
          "description": "Provides a client side router to all nested React Spectrum links to enable client side navigation.",
          "default": null
        },
        "colorScheme": {
          "type": "property",
          "name": "colorScheme",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/provider/src/index.d.ts:ColorScheme"
          },
          "optional": true,
          "description": "The color scheme for your application.\nDefaults to operating system preferences.",
          "default": null
        },
        "background": {
          "type": "property",
          "name": "background",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "base"
              },
              {
                "type": "string",
                "value": "layer-1"
              },
              {
                "type": "string",
                "value": "layer-2"
              }
            ]
          },
          "optional": true,
          "description": "The background for this provider. If not provided, the background is transparent.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "elementType": {
          "type": "property",
          "name": "elementType",
          "indexType": null,
          "value": {
            "type": "typeOperator",
            "operator": "keyof",
            "value": {
              "type": "identifier",
              "name": "JSX.IntrinsicElements"
            }
          },
          "optional": true,
          "description": "The DOM element to render.",
          "default": "div"
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RadioProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Radio.tsx:RadioProps",
      "name": "RadioProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The label for the element.",
          "default": null
        },
        "inputRef": {
          "type": "property",
          "name": "inputRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the HTML input element.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The value of the radio button, used when submitting an HTML form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio#Value).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the radio button is disabled or not.\nShows that a selection exists, but is not available in that circumstance.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RadioGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/RadioGroup.tsx:RadioGroupProps",
      "name": "RadioGroupProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The Radios contained within the RadioGroup.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the RadioGroup.",
          "default": "'M'"
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The axis the radio elements should align with.",
          "default": "'vertical'"
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the RadioGroup should be displayed with an emphasized style.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SearchFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SearchField.tsx:SearchFieldProps",
      "name": "SearchFieldProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the SearchField.",
          "default": "'M'"
        },
        "enterKeyHint": {
          "type": "property",
          "name": "enterKeyHint",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "enter"
              },
              {
                "type": "string",
                "value": "done"
              },
              {
                "type": "string",
                "value": "go"
              },
              {
                "type": "string",
                "value": "next"
              },
              {
                "type": "string",
                "value": "previous"
              },
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "send"
              }
            ]
          },
          "optional": true,
          "description": "An enumerated attribute that defines what action label or icon to preset for the enter key on virtual keyboards. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint).",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "url"
              },
              {
                "type": "string",
                "value": "tel"
              },
              {
                "type": "string",
                "value": "email"
              },
              {
                "type": "string",
                "value": "password"
              },
              {
                "type": "intersection",
                "types": [
                  {
                    "type": "string"
                  },
                  {
                    "type": "object",
                    "properties": {}
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
          "default": "'search'"
        },
        "onSubmit": {
          "type": "property",
          "name": "onSubmit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the SearchField is submitted.",
          "default": null
        },
        "onClear": {
          "type": "property",
          "name": "onClear",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the clear button is pressed.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-activedescendant": {
          "type": "property",
          "name": "aria-activedescendant",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
          "default": null
        },
        "aria-autocomplete": {
          "type": "property",
          "name": "aria-autocomplete",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "inline"
              },
              {
                "type": "string",
                "value": "list"
              },
              {
                "type": "string",
                "value": "both"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "maxLength": {
          "type": "property",
          "name": "maxLength",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
          "default": null
        },
        "minLength": {
          "type": "property",
          "name": "minLength",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
          "default": null
        },
        "pattern": {
          "type": "property",
          "name": "pattern",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
          "default": null
        },
        "inputMode": {
          "type": "property",
          "name": "inputMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "tel"
              },
              {
                "type": "string",
                "value": "url"
              },
              {
                "type": "string",
                "value": "email"
              },
              {
                "type": "string",
                "value": "numeric"
              },
              {
                "type": "string",
                "value": "decimal"
              },
              {
                "type": "string",
                "value": "search"
              }
            ]
          },
          "optional": true,
          "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
          "default": null
        },
        "autoCorrect": {
          "type": "property",
          "name": "autoCorrect",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An attribute that takes as its value a space-separated string that describes what, if any, type of autocomplete functionality the input should provide. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#autocomplete).",
          "default": null
        },
        "spellCheck": {
          "type": "property",
          "name": "spellCheck",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An enumerated attribute that defines whether the element may be checked for spelling errors. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "onCopy": {
          "type": "property",
          "name": "onCopy",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
          "default": null
        },
        "onCut": {
          "type": "property",
          "name": "onCut",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
          "default": null
        },
        "onPaste": {
          "type": "property",
          "name": "onPaste",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
          "default": null
        },
        "onCompositionStart": {
          "type": "property",
          "name": "onCompositionStart",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
          "default": null
        },
        "onCompositionEnd": {
          "type": "property",
          "name": "onCompositionEnd",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
          "default": null
        },
        "onCompositionUpdate": {
          "type": "property",
          "name": "onCompositionUpdate",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
          "default": null
        },
        "onSelect": {
          "type": "property",
          "name": "onSelect",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReactEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
          "default": null
        },
        "onBeforeInput": {
          "type": "property",
          "name": "onBeforeInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
          "default": null
        },
        "onInput": {
          "type": "property",
          "name": "onInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SegmentedControlProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SegmentedControl.tsx:SegmentedControlProps",
      "name": "SegmentedControlProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the segmented control.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the segmented control is disabled.",
          "default": null
        },
        "isJustified": {
          "type": "property",
          "name": "isJustified",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the items should divide the container width equally.",
          "default": null
        },
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The id of the currently selected item (controlled).",
          "default": null
        },
        "defaultSelectedKey": {
          "type": "property",
          "name": "defaultSelectedKey",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The id of the initial selected item (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "id",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SegmentedControlItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SegmentedControl.tsx:SegmentedControlItemProps",
      "name": "SegmentedControlItemProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the segmented control item.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "description": "The id of the item, matching the value used in SegmentedControl's `selectedKey` prop.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled or not.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SelectBoxProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SelectBoxGroup.tsx:SelectBoxProps",
      "name": "SelectBoxProps",
      "properties": {
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the SelectBox.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the SelectBox's contents, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this item.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The contents of the SelectBox.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the SelectBox is disabled.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SelectBoxGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SelectBoxGroup.tsx:SelectBoxGroupProps",
      "name": "SelectBoxGroupProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The SelectBox elements contained within the SelectBoxGroup.",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The layout direction of the content in each SelectBox.",
          "default": "'vertical'"
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "single"
              },
              {
                "type": "string",
                "value": "multiple"
              }
            ]
          },
          "optional": true,
          "description": "The selection mode for the SelectBoxGroup.",
          "default": "'single'"
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the SelectBoxGroup is disabled.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the listbox or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              }
            ]
          },
          "optional": true,
          "description": "Whether to auto focus the listbox or an option.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "SliderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Slider.tsx:SliderProps",
      "name": "SliderProps",
      "properties": {
        "fillOffset": {
          "type": "property",
          "name": "fillOffset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The offset from which to start the fill.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Slider.",
          "default": "'M'"
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Slider should be displayed with an emphasized style.",
          "default": null
        },
        "trackStyle": {
          "type": "property",
          "name": "trackStyle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "thin"
              },
              {
                "type": "string",
                "value": "thick"
              }
            ]
          },
          "optional": true,
          "description": "The style of the Slider's track.",
          "default": "'thin'"
        },
        "thumbStyle": {
          "type": "property",
          "name": "thumbStyle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "default"
              },
              {
                "type": "string",
                "value": "precise"
              }
            ]
          },
          "optional": true,
          "description": "The style of the Slider's thumb.",
          "default": "'default'"
        },
        "formatOptions": {
          "type": "property",
          "name": "formatOptions",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Intl.NumberFormatOptions"
          },
          "optional": true,
          "description": "The display format of the value label.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the whole Slider is disabled.",
          "default": null
        },
        "onChangeEnd": {
          "type": "property",
          "name": "onChangeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Fired when the slider stops moving, due to being let go.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The slider's minimum value.",
          "default": "0"
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The slider's maximum value.",
          "default": "100"
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The slider's step value.",
          "default": "1"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "RangeCalendarProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/RangeCalendar.tsx:RangeCalendarProps",
      "name": "RangeCalendarProps",
      "properties": {
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The error message to display when the calendar is invalid.",
          "default": null
        },
        "visibleMonths": {
          "type": "property",
          "name": "visibleMonths",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The number of months to display at once.",
          "default": "1"
        },
        "createCalendar": {
          "type": "property",
          "name": "createCalendar",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "identifier",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function to create a new [Calendar](https://react-spectrum.adobe.com/internationalized/date/Calendar.html)\nobject for a given calendar identifier. If not provided, the `createCalendar` function\nfrom `@internationalized/date` will be used.",
          "default": null
        },
        "allowsNonContiguousRanges": {
          "type": "property",
          "name": "allowsNonContiguousRanges",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "When combined with `isDateUnavailable`, determines whether non-contiguous ranges,\ni.e. ranges containing unavailable dates, may be selected.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "isDateUnavailable": {
          "type": "property",
          "name": "isDateUnavailable",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Callback that is called for each date of the calendar. If it returns true, then the date is unavailable.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the calendar is disabled.",
          "default": "false"
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the calendar value is immutable.",
          "default": "false"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to automatically focus the calendar when it mounts.",
          "default": "false"
        },
        "focusedValue": {
          "type": "property",
          "name": "focusedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "Controls the currently focused date within the calendar.",
          "default": null
        },
        "defaultFocusedValue": {
          "type": "property",
          "name": "defaultFocusedValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The date that is focused when the calendar first mounts (uncountrolled).",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the focused date changes.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the current selection is invalid according to application logic.",
          "default": null
        },
        "pageBehavior": {
          "type": "property",
          "name": "pageBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior"
          },
          "optional": true,
          "description": "Controls the behavior of paging. Pagination either works by advancing the visible page by visibleDuration (default) or one unit of visibleDuration.",
          "default": "visible"
        },
        "firstDayOfWeek": {
          "type": "property",
          "name": "firstDayOfWeek",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "sun"
              },
              {
                "type": "string",
                "value": "mon"
              },
              {
                "type": "string",
                "value": "tue"
              },
              {
                "type": "string",
                "value": "wed"
              },
              {
                "type": "string",
                "value": "thu"
              },
              {
                "type": "string",
                "value": "fri"
              },
              {
                "type": "string",
                "value": "sat"
              }
            ]
          },
          "optional": true,
          "description": "The day that starts the week.",
          "default": null
        },
        "selectionAlignment": {
          "type": "property",
          "name": "selectionAlignment",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "center"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "Determines the alignment of the visible months on initial render based on the current selection or current date if there is no selection.",
          "default": "'center'"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The children of the component. A function may be provided to alter the children based on component state.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "RangeSliderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/RangeSlider.tsx:RangeSliderProps",
      "name": "RangeSliderProps",
      "properties": {
        "startName": {
          "type": "property",
          "name": "startName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the start input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "endName": {
          "type": "property",
          "name": "endName",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the end input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Slider.",
          "default": "'M'"
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Slider should be displayed with an emphasized style.",
          "default": null
        },
        "trackStyle": {
          "type": "property",
          "name": "trackStyle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "thin"
              },
              {
                "type": "string",
                "value": "thick"
              }
            ]
          },
          "optional": true,
          "description": "The style of the Slider's track.",
          "default": "'thin'"
        },
        "thumbStyle": {
          "type": "property",
          "name": "thumbStyle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "default"
              },
              {
                "type": "string",
                "value": "precise"
              }
            ]
          },
          "optional": true,
          "description": "The style of the Slider's thumb.",
          "default": "'default'"
        },
        "formatOptions": {
          "type": "property",
          "name": "formatOptions",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Intl.NumberFormatOptions"
          },
          "optional": true,
          "description": "The display format of the value label.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the whole Slider is disabled.",
          "default": null
        },
        "onChangeEnd": {
          "type": "property",
          "name": "onChangeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Fired when the slider stops moving, due to being let go.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The slider's minimum value.",
          "default": "0"
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The slider's maximum value.",
          "default": "100"
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The slider's step value.",
          "default": "1"
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SkeletonProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Skeleton.tsx:SkeletonProps",
      "name": "SkeletonProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "isLoading": {
          "type": "property",
          "name": "isLoading",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SkeletonCollectionProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SkeletonCollection.tsx:SkeletonCollectionProps",
      "name": "SkeletonCollectionProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "StatusLightProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/StatusLight.tsx:StatusLightProps",
      "name": "StatusLightProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "role": {
          "type": "property",
          "name": "role",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "status"
          },
          "optional": true,
          "description": "An accessibility role for the status light. Should be set when the status\ncan change at runtime, and no more than one status light will update simultaneously.\nFor cases where multiple statuses can change at the same time, use a Toast instead.",
          "default": null
        },
        "variant": {
          "type": "property",
          "name": "variant",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "informative"
              },
              {
                "type": "string",
                "value": "neutral"
              },
              {
                "type": "string",
                "value": "positive"
              },
              {
                "type": "string",
                "value": "notice"
              },
              {
                "type": "string",
                "value": "negative"
              },
              {
                "type": "string",
                "value": "celery"
              },
              {
                "type": "string",
                "value": "chartreuse"
              },
              {
                "type": "string",
                "value": "cyan"
              },
              {
                "type": "string",
                "value": "fuchsia"
              },
              {
                "type": "string",
                "value": "purple"
              },
              {
                "type": "string",
                "value": "magenta"
              },
              {
                "type": "string",
                "value": "indigo"
              },
              {
                "type": "string",
                "value": "seafoam"
              },
              {
                "type": "string",
                "value": "yellow"
              },
              {
                "type": "string",
                "value": "pink"
              },
              {
                "type": "string",
                "value": "turquoise"
              },
              {
                "type": "string",
                "value": "cinnamon"
              },
              {
                "type": "string",
                "value": "brown"
              },
              {
                "type": "string",
                "value": "silver"
              }
            ]
          },
          "optional": false,
          "description": "The variant changes the color of the status light.\nWhen status lights have a semantic meaning, they should use the variant for semantic colors.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the StatusLight.",
          "default": "'M'"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SwitchProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Switch.tsx:SwitchProps",
      "name": "SwitchProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "default": null
        },
        "inputRef": {
          "type": "property",
          "name": "inputRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "A ref for the HTML input element.",
          "default": null
        },
        "defaultSelected": {
          "type": "property",
          "name": "defaultSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Switch should be selected (uncontrolled).",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Switch should be selected (controlled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isSelected",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the Switch's selection state changes.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the Switch.",
          "default": "'M'"
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Switch should be displayed with an emphasized style.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TableViewProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:TableViewProps",
      "name": "TableViewProps",
      "properties": {
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The elements that make up the table. Includes the TableHeader, TableBody, Columns, and Rows.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": true,
          "description": "A list of row keys to disable.",
          "default": null
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the table or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "shouldSelectOnPressUp": {
          "type": "property",
          "name": "shouldSelectOnPressUp",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether selection should occur on press up instead of press down.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "sortDescriptor": {
          "type": "property",
          "name": "sortDescriptor",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor"
          },
          "optional": true,
          "description": "The current sorted column and direction.",
          "default": null
        },
        "onSortChange": {
          "type": "property",
          "name": "onSortChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "descriptor",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the sorted column or direction changes.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "isQuiet": {
          "type": "property",
          "name": "isQuiet",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the Table should be displayed with a quiet style.",
          "default": null
        },
        "density": {
          "type": "property",
          "name": "density",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "compact"
              },
              {
                "type": "string",
                "value": "spacious"
              },
              {
                "type": "string",
                "value": "regular"
              }
            ]
          },
          "optional": true,
          "description": "Sets the amount of vertical padding within each cell.",
          "default": "'regular'"
        },
        "overflowMode": {
          "type": "property",
          "name": "overflowMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "wrap"
              },
              {
                "type": "string",
                "value": "truncate"
              }
            ]
          },
          "optional": true,
          "description": "Sets the overflow behavior for the cell contents.",
          "default": "'truncate'"
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on a row.",
          "default": null
        },
        "onResizeStart": {
          "type": "property",
          "name": "onResizeStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "widths",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Map"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user starts a column resize.",
          "default": null
        },
        "onResize": {
          "type": "property",
          "name": "onResize",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "widths",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Map"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs a column resize.\nCan be used with the width property on columns to put the column widths into\na controlled state.",
          "default": null
        },
        "onResizeEnd": {
          "type": "property",
          "name": "onResizeEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "widths",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Map"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called after a user performs a column resize.\nCan be used to store the widths of columns for another future session.",
          "default": null
        },
        "loadingState": {
          "type": "property",
          "name": "loadingState",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState"
          },
          "optional": true,
          "description": "The current loading state of the table.",
          "default": null
        },
        "onLoadMore": {
          "type": "property",
          "name": "onLoadMore",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
          "default": null
        },
        "renderActionBar": {
          "type": "property",
          "name": "renderActionBar",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selectedKeys",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string",
                      "value": "all"
                    },
                    {
                      "type": "application",
                      "base": {
                        "type": "identifier",
                        "name": "Set"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides the ActionBar to display when rows are selected in the TableView.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TableHeaderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:TableHeaderProps",
      "name": "TableHeaderProps",
      "properties": {
        "columns": {
          "type": "property",
          "name": "columns",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "A list of table columns.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "A list of `Column(s)` or a function. If the latter, a list of columns must be provided using the `columns` prop.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the column cache when using dynamic collections.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TableBodyProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:TableBodyProps",
      "name": "TableBodyProps",
      "properties": {
        "renderEmptyState": {
          "type": "property",
          "name": "renderEmptyState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides content to display when there are no rows in the table.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableSectionElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "RowProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:RowProps",
      "name": "RowProps",
      "properties": {
        "columns": {
          "type": "property",
          "name": "columns",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "A list of columns used when dynamically rendering cells.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The cells within the row. Supports static items or a function for dynamic rendering.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the cell cache when using dynamic collections.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the row's contents, used for features like typeahead.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the row.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "CellProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:CellProps",
      "name": "CellProps",
      "properties": {
        "isSticky": {
          "type": "property",
          "name": "isSticky",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to render as the cell children.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the cell.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the cell's contents, used for features like typeahead.",
          "default": null
        },
        "colSpan": {
          "type": "property",
          "name": "colSpan",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "Indicates how many columns the data cell spans.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "showDivider": {
          "type": "property",
          "name": "showDivider",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the column should render a divider between it and the next column.",
          "default": null
        },
        "align": {
          "type": "property",
          "name": "align",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "center"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "The alignment of the column's contents relative to its allotted width.",
          "default": "'start'"
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ColumnProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TableView.tsx:ColumnProps",
      "name": "ColumnProps",
      "properties": {
        "showDivider": {
          "type": "property",
          "name": "showDivider",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the column should render a divider between it and the next column.",
          "default": null
        },
        "allowsResizing": {
          "type": "property",
          "name": "allowsResizing",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the column allows resizing.",
          "default": null
        },
        "align": {
          "type": "property",
          "name": "align",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "start"
              },
              {
                "type": "string",
                "value": "center"
              },
              {
                "type": "string",
                "value": "end"
              }
            ]
          },
          "optional": true,
          "description": "The alignment of the column's contents relative to its allotted width.",
          "default": "'start'"
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to render as the column header.",
          "default": null
        },
        "menuItems": {
          "type": "property",
          "name": "menuItems",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "Menu fragment to be rendered inside the column header's menu.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the column.",
          "default": null
        },
        "allowsSorting": {
          "type": "property",
          "name": "allowsSorting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the column allows sorting.",
          "default": null
        },
        "isRowHeader": {
          "type": "property",
          "name": "isRowHeader",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether a column is a [row header](https://www.w3.org/TR/wai-aria-1.1/#rowheader) and should be announced by assistive technology during row navigation.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the column's contents, used for accessibility announcements.",
          "default": null
        },
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
          "default": null
        },
        "defaultWidth": {
          "type": "property",
          "name": "defaultWidth",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
          "default": null
        },
        "minWidth": {
          "type": "property",
          "name": "minWidth",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
          "default": null
        },
        "maxWidth": {
          "type": "property",
          "name": "maxWidth",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum width of the column. This prop only applies when the `<Table>` is wrapped in a `<ResizableTableContainer>`.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps"
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLTableHeaderCellElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TabsProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:TabsProps",
      "name": "TabsProps",
      "properties": {
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the tabs.",
          "default": null
        },
        "density": {
          "type": "property",
          "name": "density",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "compact"
              },
              {
                "type": "string",
                "value": "regular"
              }
            ]
          },
          "optional": true,
          "description": "The amount of space between the tabs.",
          "default": "'regular'"
        },
        "labelBehavior": {
          "type": "property",
          "name": "labelBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "show"
              },
              {
                "type": "string",
                "value": "hide"
              }
            ]
          },
          "optional": true,
          "description": "Defines if the text within the tabs should be hidden and only the icon should be shown.\nThe text is always visible when the item is collapsed into a picker.",
          "default": "'show'"
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the TabList is disabled.\nShows that a selection exists, but is not available in that circumstance.",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The currently selected key in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKey": {
          "type": "property",
          "name": "defaultSelectedKey",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": true,
          "description": "The initial selected key in the collection (uncontrolled).",
          "default": null
        },
        "keyboardActivation": {
          "type": "property",
          "name": "keyboardActivation",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "automatic"
              },
              {
                "type": "string",
                "value": "manual"
              }
            ]
          },
          "optional": true,
          "description": "Whether tabs are activated automatically on focus or manually.",
          "default": "'automatic'"
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation"
          },
          "optional": true,
          "description": "The orientation of the tabs.",
          "default": "'horizontal'"
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TabProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:TabProps",
      "name": "TabProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the tab.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the tab.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tab is disabled.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TabListProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:TabListProps",
      "name": "TabListProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": false,
          "description": "The content to display in the tablist.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TabPanelProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tabs.tsx:TabPanelProps",
      "name": "TabPanelProps",
      "properties": {
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the tab panels.",
          "default": null
        },
        "shouldForceMount": {
          "type": "property",
          "name": "shouldForceMount",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to mount the tab panel in the DOM even when it is not currently selected.\nInactive tab panels are inert and cannot be interacted with. They must be styled appropriately so this is clear to the user visually.",
          "default": "false"
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the tab.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TagGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TagGroup.tsx:TagGroupProps",
      "name": "TagGroupProps",
      "properties": {
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the tag group.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "description": "The size of the tag group.",
          "default": "'M'"
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tags are displayed in an emphasized style.",
          "default": null
        },
        "renderEmptyState": {
          "type": "property",
          "name": "renderEmptyState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides content to display when there are no items in the tag group.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tags are displayed in a error state.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        },
        "maxRows": {
          "type": "property",
          "name": "maxRows",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "Limit the number of rows initially shown. This will render a button that allows the user to expand to show all tags.",
          "default": null
        },
        "groupActionLabel": {
          "type": "property",
          "name": "groupActionLabel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The label to display on the action button.",
          "default": null
        },
        "onGroupAction": {
          "type": "property",
          "name": "onGroupAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the action button is pressed.",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": true,
          "description": "How multiple selection should behave in the collection.",
          "default": null
        },
        "shouldSelectOnPressUp": {
          "type": "property",
          "name": "shouldSelectOnPressUp",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether selection should occur on press up instead of press down.",
          "default": null
        },
        "onRemove": {
          "type": "property",
          "name": "onRemove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user deletes a tag.",
          "default": null
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the TagGroup or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TagProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TagGroup.tsx:TagProps",
      "name": "TagProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The children of the tag.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "A unique id for the tag.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A string representation of the tags's contents, used for accessibility.\nRequired if children is not a plain text string.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tag is disabled.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TextFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TextField.tsx:TextFieldProps",
      "name": "TextFieldProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the text field.",
          "default": "'M'"
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the value is invalid.",
          "default": null
        },
        "aria-activedescendant": {
          "type": "property",
          "name": "aria-activedescendant",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
          "default": null
        },
        "aria-autocomplete": {
          "type": "property",
          "name": "aria-autocomplete",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "inline"
              },
              {
                "type": "string",
                "value": "list"
              },
              {
                "type": "string",
                "value": "both"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "enterKeyHint": {
          "type": "property",
          "name": "enterKeyHint",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "enter"
              },
              {
                "type": "string",
                "value": "done"
              },
              {
                "type": "string",
                "value": "go"
              },
              {
                "type": "string",
                "value": "next"
              },
              {
                "type": "string",
                "value": "previous"
              },
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "send"
              }
            ]
          },
          "optional": true,
          "description": "An enumerated attribute that defines what action label or icon to preset for the enter key on virtual keyboards. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "maxLength": {
          "type": "property",
          "name": "maxLength",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
          "default": null
        },
        "minLength": {
          "type": "property",
          "name": "minLength",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
          "default": null
        },
        "pattern": {
          "type": "property",
          "name": "pattern",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Regex pattern that the value of the input must match to be valid. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefpattern).",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "url"
              },
              {
                "type": "string",
                "value": "tel"
              },
              {
                "type": "string",
                "value": "email"
              },
              {
                "type": "string",
                "value": "password"
              },
              {
                "type": "intersection",
                "types": [
                  {
                    "type": "string"
                  },
                  {
                    "type": "object",
                    "properties": {}
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The type of input to render. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdeftype).",
          "default": "'text'"
        },
        "inputMode": {
          "type": "property",
          "name": "inputMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "tel"
              },
              {
                "type": "string",
                "value": "url"
              },
              {
                "type": "string",
                "value": "email"
              },
              {
                "type": "string",
                "value": "numeric"
              },
              {
                "type": "string",
                "value": "decimal"
              },
              {
                "type": "string",
                "value": "search"
              }
            ]
          },
          "optional": true,
          "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
          "default": null
        },
        "autoCorrect": {
          "type": "property",
          "name": "autoCorrect",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An attribute that takes as its value a space-separated string that describes what, if any, type of autocomplete functionality the input should provide. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#autocomplete).",
          "default": null
        },
        "spellCheck": {
          "type": "property",
          "name": "spellCheck",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An enumerated attribute that defines whether the element may be checked for spelling errors. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "onCopy": {
          "type": "property",
          "name": "onCopy",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
          "default": null
        },
        "onCut": {
          "type": "property",
          "name": "onCut",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
          "default": null
        },
        "onPaste": {
          "type": "property",
          "name": "onPaste",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
          "default": null
        },
        "onCompositionStart": {
          "type": "property",
          "name": "onCompositionStart",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
          "default": null
        },
        "onCompositionEnd": {
          "type": "property",
          "name": "onCompositionEnd",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
          "default": null
        },
        "onCompositionUpdate": {
          "type": "property",
          "name": "onCompositionUpdate",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
          "default": null
        },
        "onSelect": {
          "type": "property",
          "name": "onSelect",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReactEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
          "default": null
        },
        "onBeforeInput": {
          "type": "property",
          "name": "onBeforeInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
          "default": null
        },
        "onInput": {
          "type": "property",
          "name": "onInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TextAreaProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TextField.tsx:TextAreaProps",
      "name": "TextAreaProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the text field.",
          "default": "'M'"
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the value is invalid.",
          "default": null
        },
        "aria-activedescendant": {
          "type": "property",
          "name": "aria-activedescendant",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.",
          "default": null
        },
        "aria-autocomplete": {
          "type": "property",
          "name": "aria-autocomplete",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "inline"
              },
              {
                "type": "string",
                "value": "list"
              },
              {
                "type": "string",
                "value": "both"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "enterKeyHint": {
          "type": "property",
          "name": "enterKeyHint",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "enter"
              },
              {
                "type": "string",
                "value": "done"
              },
              {
                "type": "string",
                "value": "go"
              },
              {
                "type": "string",
                "value": "next"
              },
              {
                "type": "string",
                "value": "previous"
              },
              {
                "type": "string",
                "value": "search"
              },
              {
                "type": "string",
                "value": "send"
              }
            ]
          },
          "optional": true,
          "description": "An enumerated attribute that defines what action label or icon to preset for the enter key on virtual keyboards. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint).",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "identifier",
                  "name": "T"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "autoComplete": {
          "type": "property",
          "name": "autoComplete",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Describes the type of autocomplete functionality the input should provide if any. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefautocomplete).",
          "default": null
        },
        "maxLength": {
          "type": "property",
          "name": "maxLength",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The maximum number of characters supported by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefmaxlength).",
          "default": null
        },
        "minLength": {
          "type": "property",
          "name": "minLength",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The minimum number of characters required by the input. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefminlength).",
          "default": null
        },
        "inputMode": {
          "type": "property",
          "name": "inputMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "none"
              },
              {
                "type": "string",
                "value": "text"
              },
              {
                "type": "string",
                "value": "tel"
              },
              {
                "type": "string",
                "value": "url"
              },
              {
                "type": "string",
                "value": "email"
              },
              {
                "type": "string",
                "value": "numeric"
              },
              {
                "type": "string",
                "value": "decimal"
              },
              {
                "type": "string",
                "value": "search"
              }
            ]
          },
          "optional": true,
          "description": "Hints at the type of data that might be entered by the user while editing the element or its contents. See [MDN](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).",
          "default": null
        },
        "autoCorrect": {
          "type": "property",
          "name": "autoCorrect",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An attribute that takes as its value a space-separated string that describes what, if any, type of autocomplete functionality the input should provide. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#autocomplete).",
          "default": null
        },
        "spellCheck": {
          "type": "property",
          "name": "spellCheck",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An enumerated attribute that defines whether the element may be checked for spelling errors. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "onCopy": {
          "type": "property",
          "name": "onCopy",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user copies text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncopy).",
          "default": null
        },
        "onCut": {
          "type": "property",
          "name": "onCut",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user cuts text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/oncut).",
          "default": null
        },
        "onPaste": {
          "type": "property",
          "name": "onPaste",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ClipboardEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the user pastes text. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste).",
          "default": null
        },
        "onCompositionStart": {
          "type": "property",
          "name": "onCompositionStart",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system starts a new text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionstart_event).",
          "default": null
        },
        "onCompositionEnd": {
          "type": "property",
          "name": "onCompositionEnd",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a text composition system completes or cancels the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionend_event).",
          "default": null
        },
        "onCompositionUpdate": {
          "type": "property",
          "name": "onCompositionUpdate",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "CompositionEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when a new character is received in the current text composition session. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/compositionupdate_event).",
          "default": null
        },
        "onSelect": {
          "type": "property",
          "name": "onSelect",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReactEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when text in the input is selected. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Element/select_event).",
          "default": null
        },
        "onBeforeInput": {
          "type": "property",
          "name": "onBeforeInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is about to be modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/beforeinput_event).",
          "default": null
        },
        "onInput": {
          "type": "property",
          "name": "onInput",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "FormEventHandler"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              }
            ]
          },
          "optional": true,
          "description": "Handler that is called when the input value is modified. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/input_event).",
          "default": null
        },
        "aria-errormessage": {
          "type": "property",
          "name": "aria-errormessage",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element that provides an error message for the object.",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TimeFieldProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TimeField.tsx:TimeFieldProps",
      "name": "TimeFieldProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the TimeField.",
          "default": "'M'"
        },
        "hourCycle": {
          "type": "property",
          "name": "hourCycle",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number",
                "value": 12
              },
              {
                "type": "number",
                "value": 24
              }
            ]
          },
          "optional": true,
          "description": "Whether to display the time in 12 or 24 hour format. By default, this is determined by the user's locale.",
          "default": null
        },
        "granularity": {
          "type": "property",
          "name": "granularity",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "hour"
              },
              {
                "type": "string",
                "value": "minute"
              },
              {
                "type": "string",
                "value": "second"
              }
            ]
          },
          "optional": true,
          "description": "Determines the smallest unit that is displayed in the time picker.",
          "default": "'minute'"
        },
        "hideTimeZone": {
          "type": "property",
          "name": "hideTimeZone",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to hide the time zone abbreviation.",
          "default": null
        },
        "shouldForceLeadingZeros": {
          "type": "property",
          "name": "shouldForceLeadingZeros",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to always show leading zeros in the hour field.\nBy default, this is determined by the user's locale.",
          "default": null
        },
        "placeholderValue": {
          "type": "property",
          "name": "placeholderValue",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
          },
          "optional": true,
          "description": "A placeholder time that influences the format of the placeholder shown when no value is selected.\nDefaults to 12:00 AM or 00:00 depending on the hour cycle.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed time that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed time that a user may select.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input can be selected but not changed by the user.",
          "default": null
        },
        "isRequired": {
          "type": "property",
          "name": "isRequired",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether user input is required on the input before form submission.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validate": {
          "type": "property",
          "name": "validate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
                },
                {
                  "type": "boolean",
                  "value": true
                },
                {
                  "type": "null"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The current value (controlled).",
          "default": null
        },
        "defaultValue": {
          "type": "property",
          "name": "defaultValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The default value (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the value changes.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the input with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#form).",
          "default": null
        },
        "validationBehavior": {
          "type": "property",
          "name": "validationBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "native"
              },
              {
                "type": "string",
                "value": "aria"
              }
            ]
          },
          "optional": true,
          "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
          "default": "'native'"
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "labelPosition": {
          "type": "property",
          "name": "labelPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition"
          },
          "optional": true,
          "description": "The label's overall position relative to the element it is labeling.",
          "default": "'top'"
        },
        "labelAlign": {
          "type": "property",
          "name": "labelAlign",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment"
          },
          "optional": true,
          "description": "The label's horizontal alignment relative to the element it is labeling.",
          "default": "'start'"
        },
        "necessityIndicator": {
          "type": "property",
          "name": "necessityIndicator",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator"
          },
          "optional": true,
          "description": "Whether the required state should be shown as an icon or text.",
          "default": "'icon'"
        },
        "contextualHelp": {
          "type": "property",
          "name": "contextualHelp",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A ContextualHelp element to place next to the label.",
          "default": null
        },
        "label": {
          "type": "property",
          "name": "label",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display as the label.",
          "default": null
        },
        "description": {
          "type": "property",
          "name": "description",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "A description for the field. Provides a hint such as specific requirements for what to choose.",
          "default": null
        },
        "errorMessage": {
          "type": "property",
          "name": "errorMessage",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "v",
                    "value": {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "An error message for the field.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
          },
          "default": null
        }
      ],
      "extends": []
    },
    "ToastOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastOptions",
      "name": "ToastOptions",
      "properties": {
        "actionLabel": {
          "type": "property",
          "name": "actionLabel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A label for the action button within the toast.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the action button is pressed.",
          "default": null
        },
        "shouldCloseOnAction": {
          "type": "property",
          "name": "shouldCloseOnAction",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the toast should automatically close when an action is performed.",
          "default": null
        },
        "onClose": {
          "type": "property",
          "name": "onClose",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the toast is closed, either by the user or after a timeout.",
          "default": null
        },
        "timeout": {
          "type": "property",
          "name": "timeout",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "A timeout to automatically close the toast after, in milliseconds.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ToastContainerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastContainerProps",
      "name": "ToastContainerProps",
      "properties": {
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastPlacement"
          },
          "optional": true,
          "description": "Placement of the toast container on the page.",
          "default": "\"bottom\""
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for the toast region.",
          "default": "\"Notifications\""
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "className": {
          "type": "property",
          "name": "className",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
          "default": null
        },
        "style": {
          "type": "property",
          "name": "style",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ToggleButtonProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ToggleButton.tsx:ToggleButtonProps",
      "name": "ToggleButtonProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content to display in the button.",
          "default": null
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "When used in a ToggleButtonGroup, an identifier for the item in `selectedKeys`. When used standalone, a DOM id.",
          "default": null
        },
        "isSelected": {
          "type": "property",
          "name": "isSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should be selected (controlled).",
          "default": null
        },
        "defaultSelected": {
          "type": "property",
          "name": "defaultSelected",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should be selected (uncontrolled).",
          "default": null
        },
        "onChange": {
          "type": "property",
          "name": "onChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isSelected",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's selection state changes.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is disabled.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "aria-disabled": {
          "type": "property",
          "name": "aria-disabled",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element is disabled to users of assistive technology.",
          "default": null
        },
        "aria-expanded": {
          "type": "property",
          "name": "aria-expanded",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "aria-pressed": {
          "type": "property",
          "name": "aria-pressed",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "mixed"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the current \"pressed\" state of toggle buttons.",
          "default": null
        },
        "preventFocusOnPress": {
          "type": "property",
          "name": "preventFocusOnPress",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "The size of the ActionButton.",
          "default": "'M'"
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "The static color style to apply. Useful when the ActionButton appears over a color background.",
          "default": null
        },
        "isQuiet": {
          "type": "property",
          "name": "isQuiet",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "ToggleButtonGroupProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ToggleButtonGroup.tsx:ToggleButtonGroupProps",
      "name": "ToggleButtonGroupProps",
      "properties": {
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The children of the group.",
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": true,
          "description": "Size of the buttons.",
          "default": "\"M\""
        },
        "density": {
          "type": "property",
          "name": "density",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "compact"
              },
              {
                "type": "string",
                "value": "regular"
              }
            ]
          },
          "optional": true,
          "description": "Spacing between the buttons.",
          "default": "\"regular\""
        },
        "isQuiet": {
          "type": "property",
          "name": "isQuiet",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
          "default": null
        },
        "isJustified": {
          "type": "property",
          "name": "isJustified",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the buttons should divide the container width equally.",
          "default": null
        },
        "staticColor": {
          "type": "property",
          "name": "staticColor",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "white"
              },
              {
                "type": "string",
                "value": "black"
              },
              {
                "type": "string",
                "value": "auto"
              }
            ]
          },
          "optional": true,
          "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
          "default": null
        },
        "orientation": {
          "type": "property",
          "name": "orientation",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "horizontal"
              },
              {
                "type": "string",
                "value": "vertical"
              }
            ]
          },
          "optional": true,
          "description": "The axis the group should align with.",
          "default": "'horizontal'"
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the group is disabled.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "single"
              },
              {
                "type": "string",
                "value": "multiple"
              }
            ]
          },
          "optional": true,
          "description": "Whether single or multiple selection is enabled.",
          "default": "'single'"
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TooltipProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Tooltip.tsx:TooltipProps",
      "name": "TooltipProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content of the tooltip.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TreeViewProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewProps",
      "name": "TreeViewProps",
      "properties": {
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight"
          },
          "optional": true,
          "description": "Spectrum-defined styles, returned by the `style()` macro.",
          "default": null
        },
        "renderEmptyState": {
          "type": "property",
          "name": "renderEmptyState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeEmptyStateRenderProps"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Provides content to display when there are no items in the list.",
          "default": null
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "optional": true,
          "description": "Whether `disabledKeys` applies to all interactions, or only selection.",
          "default": "'all'"
        },
        "escapeKeyBehavior": {
          "type": "property",
          "name": "escapeKeyBehavior",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "clearSelection"
              },
              {
                "type": "string",
                "value": "none"
              }
            ]
          },
          "optional": true,
          "description": "Whether pressing the escape key should clear selection in the grid list or not.\n\nMost experiences should not modify this option as it eliminates a keyboard user's ability to\neasily clear selection. Only use if the escape key is being handled externally or should not\ntrigger selection clearing contextually.",
          "default": "'clearSelection'"
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              }
            ]
          },
          "optional": true,
          "description": "Whether to auto focus the gridlist or an option.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on an item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "shouldSelectOnPressUp": {
          "type": "property",
          "name": "shouldSelectOnPressUp",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether selection should occur on press up instead of press down.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "description": "Item objects in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The item keys that are disabled. These items cannot be selected, focused, or otherwise interacted with.",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": true,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The currently selected keys in the collection (controlled).",
          "default": null
        },
        "defaultSelectedKeys": {
          "type": "property",
          "name": "defaultSelectedKeys",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Iterable"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "Key"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The initial selected keys in the collection (uncontrolled).",
          "default": null
        },
        "onSelectionChange": {
          "type": "property",
          "name": "onSelectionChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the selection changes.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ReactNode"
              },
              {
                "type": "function",
                "parameters": [
                  {
                    "type": "parameter",
                    "name": "item",
                    "value": {
                      "type": "identifier",
                      "name": "T"
                    },
                    "rest": false
                  }
                ],
                "return": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "typeParameters": []
              }
            ]
          },
          "optional": true,
          "description": "The contents of the collection.",
          "default": null
        },
        "dependencies": {
          "type": "property",
          "name": "dependencies",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          },
          "optional": true,
          "description": "Values that should invalidate the item cache when using dynamic collections.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "expandedKeys": {
          "type": "property",
          "name": "expandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The currently expanded keys in the collection (controlled).",
          "default": null
        },
        "defaultExpandedKeys": {
          "type": "property",
          "name": "defaultExpandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": true,
          "description": "The initial expanded keys in the collection (uncontrolled).",
          "default": null
        },
        "onExpandedChange": {
          "type": "property",
          "name": "onExpandedChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are expanded or collapsed.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLDivElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "isDetached": {
          "type": "property",
          "name": "isDetached",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tree should be displayed with a [detached style](https://spectrum.adobe.com/page/tree-view/#Detached).",
          "default": null
        },
        "isEmphasized": {
          "type": "property",
          "name": "isEmphasized",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tree should be displayed with a [emphasized style](https://spectrum.adobe.com/page/tree-view/#Emphasis).",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "TreeViewItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewItemProps",
      "name": "TreeViewItemProps",
      "properties": {
        "hasChildItems": {
          "type": "property",
          "name": "hasChildItems",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether this item has children, even if not loaded yet.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the tree row.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": true,
          "description": "The object value that this tree item represents. When using dynamic collections, this is set automatically.",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A string representation of the tree item's contents, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this tree item.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The content of the tree item along with any nested children. Supports static nested tree items or use of a Collection to dynamically render nested tree items.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item is disabled.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a user performs an action on this tree item. The exact user event depends on\nthe collection's `selectionBehavior` prop and the interaction modality.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href"
          },
          "optional": true,
          "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
          "default": null
        },
        "hrefLang": {
          "type": "property",
          "name": "hrefLang",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeAnchorTarget"
          },
          "optional": true,
          "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "download": {
          "type": "property",
          "name": "download",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
          "default": null
        },
        "ping": {
          "type": "property",
          "name": "ping",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
          "default": null
        },
        "referrerPolicy": {
          "type": "property",
          "name": "referrerPolicy",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLAttributeReferrerPolicy"
          },
          "optional": true,
          "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
          "default": null
        },
        "routerOptions": {
          "type": "property",
          "name": "routerOptions",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions"
          },
          "optional": true,
          "description": "Options for the configured client side router.",
          "default": null
        },
        "onHoverStart": {
          "type": "property",
          "name": "onHoverStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction starts.",
          "default": null
        },
        "onHoverEnd": {
          "type": "property",
          "name": "onHoverEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a hover interaction ends.",
          "default": null
        },
        "onHoverChange": {
          "type": "property",
          "name": "onHoverChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isHovering",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the hover state changes.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TreeViewItemContentProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewItemContentProps",
      "name": "TreeViewItemContentProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "Rendered contents of the tree item or child items.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TreeViewLoadMoreItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/TreeView.tsx:TreeViewLoadMoreItemProps",
      "name": "TreeViewLoadMoreItemProps",
      "properties": {
        "loadingState": {
          "type": "property",
          "name": "loadingState",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState"
          },
          "optional": true,
          "description": "The current loading state of the TreeView or TreeView row.",
          "default": null
        },
        "onLoadMore": {
          "type": "property",
          "name": "onLoadMore",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when more items should be loaded, e.g. while scrolling near the bottom.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "AutocompleteProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Autocomplete.tsx:AutocompleteProps",
      "name": "AutocompleteProps",
      "properties": {
        "filter": {
          "type": "property",
          "name": "filter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "textValue",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "inputValue",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "An optional filter function used to determine if a option should be included in the autocomplete list.\nInclude this if the items you are providing to your wrapped collection aren't filtered by default.",
          "default": null
        },
        "disableAutoFocusFirst": {
          "type": "property",
          "name": "disableAutoFocusFirst",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether or not to focus the first item in the collection after a filter is performed. Note this is only applicable\nif virtual focus behavior is not turned off via `disableVirtualFocus`.",
          "default": "false"
        },
        "disableVirtualFocus": {
          "type": "property",
          "name": "disableVirtualFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the autocomplete should disable virtual focus, instead making the wrapped collection directly tabbable.",
          "default": "false"
        },
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value of the autocomplete input (controlled).",
          "default": null
        },
        "defaultInputValue": {
          "type": "property",
          "name": "defaultInputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The default value of the autocomplete input (uncontrolled).",
          "default": null
        },
        "onInputChange": {
          "type": "property",
          "name": "onInputChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the autocomplete input value changes.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The children wrapped by the autocomplete. Consists of at least an input element and a collection element to filter.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "FileTriggerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/FileTrigger.tsx:FileTriggerProps",
      "name": "FileTriggerProps",
      "properties": {
        "acceptedFileTypes": {
          "type": "property",
          "name": "acceptedFileTypes",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReadonlyArray"
            },
            "typeParameters": [
              {
                "type": "string"
              }
            ]
          },
          "optional": true,
          "description": "Specifies what mime type of files are allowed.",
          "default": null
        },
        "allowsMultiple": {
          "type": "property",
          "name": "allowsMultiple",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether multiple files can be selected.",
          "default": null
        },
        "defaultCamera": {
          "type": "property",
          "name": "defaultCamera",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "user"
              },
              {
                "type": "string",
                "value": "environment"
              }
            ]
          },
          "optional": true,
          "description": "Specifies the use of a media capture mechanism to capture the media on the spot.",
          "default": null
        },
        "onSelect": {
          "type": "property",
          "name": "onSelect",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "files",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "FileList"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler when a user selects a file.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The children of the component.",
          "default": null
        },
        "acceptDirectory": {
          "type": "property",
          "name": "acceptDirectory",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Enables the selection of directories instead of individual files.",
          "default": null
        },
        "dir": {
          "type": "property",
          "name": "dir",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "lang": {
          "type": "property",
          "name": "lang",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "hidden": {
          "type": "property",
          "name": "hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "inert": {
          "type": "property",
          "name": "inert",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "translate": {
          "type": "property",
          "name": "translate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "yes"
              },
              {
                "type": "string",
                "value": "no"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onClickCapture": {
          "type": "property",
          "name": "onClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClick": {
          "type": "property",
          "name": "onAuxClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAuxClickCapture": {
          "type": "property",
          "name": "onAuxClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenu": {
          "type": "property",
          "name": "onContextMenu",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onContextMenuCapture": {
          "type": "property",
          "name": "onContextMenuCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClick": {
          "type": "property",
          "name": "onDoubleClick",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onDoubleClickCapture": {
          "type": "property",
          "name": "onDoubleClickCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDown": {
          "type": "property",
          "name": "onMouseDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseDownCapture": {
          "type": "property",
          "name": "onMouseDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseEnter": {
          "type": "property",
          "name": "onMouseEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseLeave": {
          "type": "property",
          "name": "onMouseLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMove": {
          "type": "property",
          "name": "onMouseMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseMoveCapture": {
          "type": "property",
          "name": "onMouseMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOut": {
          "type": "property",
          "name": "onMouseOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOutCapture": {
          "type": "property",
          "name": "onMouseOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOver": {
          "type": "property",
          "name": "onMouseOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseOverCapture": {
          "type": "property",
          "name": "onMouseOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUp": {
          "type": "property",
          "name": "onMouseUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onMouseUpCapture": {
          "type": "property",
          "name": "onMouseUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "MouseEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancel": {
          "type": "property",
          "name": "onTouchCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchCancelCapture": {
          "type": "property",
          "name": "onTouchCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEnd": {
          "type": "property",
          "name": "onTouchEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchEndCapture": {
          "type": "property",
          "name": "onTouchEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMove": {
          "type": "property",
          "name": "onTouchMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchMoveCapture": {
          "type": "property",
          "name": "onTouchMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStart": {
          "type": "property",
          "name": "onTouchStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTouchStartCapture": {
          "type": "property",
          "name": "onTouchStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TouchEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDown": {
          "type": "property",
          "name": "onPointerDown",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerDownCapture": {
          "type": "property",
          "name": "onPointerDownCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMove": {
          "type": "property",
          "name": "onPointerMove",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerMoveCapture": {
          "type": "property",
          "name": "onPointerMoveCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUp": {
          "type": "property",
          "name": "onPointerUp",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerUpCapture": {
          "type": "property",
          "name": "onPointerUpCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancel": {
          "type": "property",
          "name": "onPointerCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerCancelCapture": {
          "type": "property",
          "name": "onPointerCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerEnter": {
          "type": "property",
          "name": "onPointerEnter",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerLeave": {
          "type": "property",
          "name": "onPointerLeave",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOver": {
          "type": "property",
          "name": "onPointerOver",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOverCapture": {
          "type": "property",
          "name": "onPointerOverCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOut": {
          "type": "property",
          "name": "onPointerOut",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onPointerOutCapture": {
          "type": "property",
          "name": "onPointerOutCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCapture": {
          "type": "property",
          "name": "onGotPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onGotPointerCaptureCapture": {
          "type": "property",
          "name": "onGotPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCapture": {
          "type": "property",
          "name": "onLostPointerCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onLostPointerCaptureCapture": {
          "type": "property",
          "name": "onLostPointerCaptureCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "PointerEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScroll": {
          "type": "property",
          "name": "onScroll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onScrollCapture": {
          "type": "property",
          "name": "onScrollCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "UIEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheel": {
          "type": "property",
          "name": "onWheel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onWheelCapture": {
          "type": "property",
          "name": "onWheelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "WheelEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStart": {
          "type": "property",
          "name": "onAnimationStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationStartCapture": {
          "type": "property",
          "name": "onAnimationStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEnd": {
          "type": "property",
          "name": "onAnimationEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationEndCapture": {
          "type": "property",
          "name": "onAnimationEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIteration": {
          "type": "property",
          "name": "onAnimationIteration",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onAnimationIterationCapture": {
          "type": "property",
          "name": "onAnimationIterationCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "AnimationEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancel": {
          "type": "property",
          "name": "onTransitionCancel",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionCancelCapture": {
          "type": "property",
          "name": "onTransitionCancelCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEnd": {
          "type": "property",
          "name": "onTransitionEnd",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionEndCapture": {
          "type": "property",
          "name": "onTransitionEndCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRun": {
          "type": "property",
          "name": "onTransitionRun",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionRunCapture": {
          "type": "property",
          "name": "onTransitionRunCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStart": {
          "type": "property",
          "name": "onTransitionStart",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "onTransitionStartCapture": {
          "type": "property",
          "name": "onTransitionStartCapture",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "TransitionEventHandler"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "HTMLInputElement"
                  }
                ]
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": true,
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "TooltipTriggerProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tooltip.tsx:TooltipTriggerComponentProps",
      "name": "TooltipTriggerProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the tooltip should be disabled, independent from the trigger.",
          "default": null
        },
        "delay": {
          "type": "property",
          "name": "delay",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The delay time for the tooltip to show up. [See guidelines](https://spectrum.adobe.com/page/tooltip/#Immediate-or-delayed-appearance).",
          "default": "1500"
        },
        "closeDelay": {
          "type": "property",
          "name": "closeDelay",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "The delay time for the tooltip to close. [See guidelines](https://spectrum.adobe.com/page/tooltip/#Warmup-and-cooldown).",
          "default": "500"
        },
        "trigger": {
          "type": "property",
          "name": "trigger",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "hover"
              },
              {
                "type": "string",
                "value": "focus"
              }
            ]
          },
          "optional": true,
          "description": "By default, opens for both focus and hover. Can be made to open only for focus.",
          "default": "'hover'"
        },
        "isOpen": {
          "type": "property",
          "name": "isOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (controlled).",
          "default": null
        },
        "defaultOpen": {
          "type": "property",
          "name": "defaultOpen",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the overlay is open by default (uncontrolled).",
          "default": null
        },
        "onOpenChange": {
          "type": "property",
          "name": "onOpenChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isOpen",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the overlay's open state changes.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "SortDescriptor": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor",
      "name": "SortDescriptor",
      "properties": {
        "column": {
          "type": "property",
          "name": "column",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": false,
          "description": "The key of the column to sort by.",
          "default": null
        },
        "direction": {
          "type": "property",
          "name": "direction",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
          },
          "optional": false,
          "description": "The direction to sort by.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "Color": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color",
      "name": "Color",
      "properties": {
        "toFormat": {
          "type": "method",
          "name": "toFormat",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "format",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Converts the color to the given color format, and returns a new Color object.",
          "default": null
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "format",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat"
                    },
                    {
                      "type": "string",
                      "value": "css"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the color to a string in the given format.",
          "default": null
        },
        "clone": {
          "type": "method",
          "name": "clone",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Returns a duplicate of the color value.",
          "default": null
        },
        "toHexInt": {
          "type": "method",
          "name": "toHexInt",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the color to hex, and returns an integer representation.",
          "default": null
        },
        "getChannelValue": {
          "type": "method",
          "name": "getChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the numeric value for a given channel.\nThrows an error if the channel is unsupported in the current color format.",
          "default": null
        },
        "withChannelValue": {
          "type": "method",
          "name": "withChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Sets the numeric value for a given channel, and returns a new Color object.\nThrows an error if the channel is unsupported in the current color format.",
          "default": null
        },
        "getChannelRange": {
          "type": "method",
          "name": "getChannelRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannelRange"
            },
            "typeParameters": []
          },
          "description": "Returns the minimum, maximum, and step values for a given channel.",
          "default": null
        },
        "getChannelName": {
          "type": "method",
          "name": "getChannelName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized color channel name for a given channel and locale,\nfor use in visual or accessibility labels.",
          "default": null
        },
        "getChannelFormatOptions": {
          "type": "method",
          "name": "getChannelFormatOptions",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the number formatting options for the given channel.",
          "default": null
        },
        "formatChannelValue": {
          "type": "method",
          "name": "formatChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats the numeric value for a given channel for display according to the provided locale.",
          "default": null
        },
        "getColorSpace": {
          "type": "method",
          "name": "getColorSpace",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
            },
            "typeParameters": []
          },
          "description": "Returns the color space, 'rgb', 'hsb' or 'hsl', for the current color.",
          "default": null
        },
        "getColorSpaceAxes": {
          "type": "method",
          "name": "getColorSpaceAxes",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "xyChannels",
                "value": {
                  "type": "object",
                  "properties": {
                    "xChannel": {
                      "type": "property",
                      "name": "xChannel",
                      "indexType": null,
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                      },
                      "optional": true,
                      "default": null
                    },
                    "yChannel": {
                      "type": "property",
                      "name": "yChannel",
                      "indexType": null,
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                      },
                      "optional": true,
                      "default": null
                    }
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorAxes"
            },
            "typeParameters": []
          },
          "description": "Returns the color space axes, xChannel, yChannel, zChannel.",
          "default": null
        },
        "getColorChannels": {
          "type": "method",
          "name": "getColorChannels",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "tuple",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns an array of the color channels within the current color space space.",
          "default": null
        },
        "getColorName": {
          "type": "method",
          "name": "getColorName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized name for the color, for use in visual or accessibility labels.",
          "default": null
        },
        "getHueName": {
          "type": "method",
          "name": "getHueName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized name for the hue, for use in visual or accessibility labels.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "Represents a color value."
    },
    "Key": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
    },
    "Selection": {
      "type": "link",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
    }
  },
  "links": {
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithHeight",
      "name": "StylesPropWithHeight",
      "value": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
        },
        "typeParameters": [
          {
            "type": "union",
            "elements": [
              {
                "type": "indexedAccess",
                "objectType": {
                  "type": "any"
                },
                "indexType": {
                  "type": "number"
                }
              },
              {
                "type": "indexedAccess",
                "objectType": {
                  "type": "any"
                },
                "indexType": {
                  "type": "number"
                }
              },
              {
                "type": "indexedAccess",
                "objectType": {
                  "type": "any"
                },
                "indexType": {
                  "type": "number"
                }
              }
            ]
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString",
      "name": "StyleString",
      "value": {
        "type": "intersection",
        "types": [
          {
            "type": "string"
          },
          {
            "type": "object",
            "properties": {
              "properties": {
                "type": "property",
                "name": "properties",
                "indexType": null,
                "value": {
                  "type": "identifier",
                  "name": "P"
                },
                "optional": false,
                "default": null
              }
            }
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "P",
          "constraint": null,
          "default": {
            "type": "string"
          }
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key",
      "name": "Key",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string"
          },
          {
            "type": "number"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName",
      "name": "UnsafeClassName",
      "value": {
        "type": "intersection",
        "types": [
          {
            "type": "string"
          },
          {
            "type": "object",
            "properties": {
              "properties": {
                "type": "property",
                "name": "properties",
                "indexType": null,
                "value": {
                  "type": "never"
                },
                "optional": true,
                "default": null
              }
            }
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRef",
      "name": "DOMRef",
      "value": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRefValue"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "identifier",
            "name": "HTMLElement"
          },
          "default": {
            "type": "identifier",
            "name": "HTMLElement"
          }
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRefValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:DOMRefValue",
      "name": "DOMRefValue",
      "properties": {
        "UNSAFE_getDOMNode": {
          "type": "method",
          "name": "UNSAFE_getDOMNode",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "HTMLElement"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "identifier",
            "name": "HTMLElement"
          },
          "default": {
            "type": "identifier",
            "name": "HTMLElement"
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent",
      "name": "PressEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "pressstart"
              },
              {
                "type": "string",
                "value": "pressend"
              },
              {
                "type": "string",
                "value": "pressup"
              },
              {
                "type": "string",
                "value": "press"
              }
            ]
          },
          "optional": false,
          "description": "The type of press event being fired.",
          "default": null
        },
        "pointerType": {
          "type": "property",
          "name": "pointerType",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PointerType"
          },
          "optional": false,
          "description": "The pointer type that triggered the press event.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": false,
          "description": "The target element of the press event.",
          "default": null
        },
        "shiftKey": {
          "type": "property",
          "name": "shiftKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the shift keyboard modifier was held during the press event.",
          "default": null
        },
        "ctrlKey": {
          "type": "property",
          "name": "ctrlKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the ctrl keyboard modifier was held during the press event.",
          "default": null
        },
        "metaKey": {
          "type": "property",
          "name": "metaKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the meta keyboard modifier was held during the press event.",
          "default": null
        },
        "altKey": {
          "type": "property",
          "name": "altKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the alt keyboard modifier was held during the press event.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "X position relative to the target.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "Y position relative to the target.",
          "default": null
        },
        "continuePropagation": {
          "type": "method",
          "name": "continuePropagation",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "By default, press events stop propagation to parent elements.\nIn cases where a handler decides not to handle a specific event,\nit can call `continuePropagation()` to allow a parent to handle it.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PointerType": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PointerType",
      "name": "PointerType",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "mouse"
          },
          {
            "type": "string",
            "value": "pen"
          },
          {
            "type": "string",
            "value": "touch"
          },
          {
            "type": "string",
            "value": "keyboard"
          },
          {
            "type": "string",
            "value": "virtual"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent",
      "name": "KeyboardEvent",
      "value": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:BaseEvent"
        },
        "typeParameters": [
          {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "ReactKeyboardEvent"
            },
            "typeParameters": [
              {
                "id": null,
                "name": null,
                "type": "any"
              }
            ]
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:BaseEvent": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:BaseEvent",
      "name": "BaseEvent",
      "value": {
        "type": "intersection",
        "types": [
          {
            "type": "identifier",
            "name": "SyntheticEvent"
          },
          {
            "type": "object",
            "properties": {
              "stopPropagation": {
                "type": "method",
                "name": "stopPropagation",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void",
                    "description": null
                  },
                  "typeParameters": []
                },
                "access": "private",
                "description": "Use continuePropagation.",
                "default": null
              },
              "continuePropagation": {
                "type": "method",
                "name": "continuePropagation",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void",
                    "description": null
                  },
                  "typeParameters": []
                },
                "default": null
              }
            }
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "identifier",
            "name": "SyntheticEvent"
          },
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesProp",
      "name": "StylesProp",
      "value": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
        },
        "typeParameters": [
          {
            "type": "union",
            "elements": [
              {
                "type": "indexedAccess",
                "objectType": {
                  "type": "any"
                },
                "indexType": {
                  "type": "number"
                }
              },
              {
                "type": "indexedAccess",
                "objectType": {
                  "type": "any"
                },
                "indexType": {
                  "type": "number"
                }
              }
            ]
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRef",
      "name": "FocusableRef",
      "value": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Ref"
        },
        "typeParameters": [
          {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRefValue"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "identifier",
            "name": "HTMLElement"
          },
          "default": {
            "type": "identifier",
            "name": "HTMLElement"
          }
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRefValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:FocusableRefValue",
      "name": "FocusableRefValue",
      "properties": {
        "focus": {
          "type": "method",
          "name": "focus",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null
        },
        "UNSAFE_getDOMNode": {
          "type": "method",
          "name": "UNSAFE_getDOMNode",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "HTMLElement"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "identifier",
            "name": "HTMLElement"
          },
          "default": {
            "type": "identifier",
            "name": "HTMLElement"
          }
        },
        {
          "type": "typeParameter",
          "name": "D",
          "constraint": {
            "type": "identifier",
            "name": "HTMLElement"
          },
          "default": {
            "type": "identifier",
            "name": "HTMLElement"
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithoutWidth": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:StylesPropWithoutWidth",
      "name": "StylesPropWithoutWidth",
      "value": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
        },
        "typeParameters": [
          {
            "type": "indexedAccess",
            "objectType": {
              "type": "any"
            },
            "indexType": {
              "type": "number"
            }
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:Href",
      "name": "Href",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterConfig"
        },
        "extendsType": {
          "type": "object",
          "properties": {
            "href": {
              "type": "property",
              "name": "href",
              "indexType": null,
              "value": {
                "type": "any"
              },
              "optional": false,
              "default": null
            }
          }
        },
        "trueType": {
          "type": "identifier",
          "name": "H"
        },
        "falseType": {
          "type": "string"
        }
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterConfig": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterConfig",
      "name": "RouterConfig",
      "properties": {},
      "typeParameters": [],
      "extends": [],
      "description": "This type allows configuring link props with router options and type-safe URLs via TS module augmentation.\nBy default, this is an empty type. Extend with `href` and `routerOptions` properties to configure your router."
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterOptions",
      "name": "RouterOptions",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:RouterConfig"
        },
        "extendsType": {
          "type": "object",
          "properties": {
            "routerOptions": {
              "type": "property",
              "name": "routerOptions",
              "indexType": null,
              "value": {
                "type": "any"
              },
              "optional": false,
              "default": null
            }
          }
        },
        "trueType": {
          "type": "identifier",
          "name": "O"
        },
        "falseType": {
          "type": "never"
        }
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:HoverEvent",
      "name": "HoverEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "hoverstart"
              },
              {
                "type": "string",
                "value": "hoverend"
              }
            ]
          },
          "optional": false,
          "description": "The type of hover event being fired.",
          "default": null
        },
        "pointerType": {
          "type": "property",
          "name": "pointerType",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "mouse"
              },
              {
                "type": "string",
                "value": "pen"
              }
            ]
          },
          "optional": false,
          "description": "The pointer type that triggered the hover event.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "HTMLElement"
          },
          "optional": false,
          "description": "The target element of the hover event.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier",
      "name": "CalendarIdentifier",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "gregory"
          },
          {
            "type": "string",
            "value": "buddhist"
          },
          {
            "type": "string",
            "value": "chinese"
          },
          {
            "type": "string",
            "value": "coptic"
          },
          {
            "type": "string",
            "value": "dangi"
          },
          {
            "type": "string",
            "value": "ethioaa"
          },
          {
            "type": "string",
            "value": "ethiopic"
          },
          {
            "type": "string",
            "value": "hebrew"
          },
          {
            "type": "string",
            "value": "indian"
          },
          {
            "type": "string",
            "value": "islamic"
          },
          {
            "type": "string",
            "value": "islamic-umalqura"
          },
          {
            "type": "string",
            "value": "islamic-tbla"
          },
          {
            "type": "string",
            "value": "islamic-civil"
          },
          {
            "type": "string",
            "value": "islamic-rgsa"
          },
          {
            "type": "string",
            "value": "iso8601"
          },
          {
            "type": "string",
            "value": "japanese"
          },
          {
            "type": "string",
            "value": "persian"
          },
          {
            "type": "string",
            "value": "roc"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar",
      "name": "Calendar",
      "properties": {
        "identifier": {
          "type": "property",
          "name": "identifier",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:CalendarIdentifier"
          },
          "optional": false,
          "description": "A string identifier for the calendar, as defined by Unicode CLDR.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/supportedValuesOf#supported_calendar_types).",
          "default": null
        },
        "fromJulianDay": {
          "type": "method",
          "name": "fromJulianDay",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "jd",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Creates a CalendarDate in this calendar from the given Julian day number.",
          "default": null
        },
        "toJulianDay": {
          "type": "method",
          "name": "toJulianDay",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts a date in this calendar to a Julian day number.",
          "default": null
        },
        "getDaysInMonth": {
          "type": "method",
          "name": "getDaysInMonth",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the number of days in the month of the given date.",
          "default": null
        },
        "getMonthsInYear": {
          "type": "method",
          "name": "getMonthsInYear",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the number of months in the year of the given date.",
          "default": null
        },
        "getYearsInEra": {
          "type": "method",
          "name": "getYearsInEra",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the number of years in the era of the given date.",
          "default": null
        },
        "getEras": {
          "type": "method",
          "name": "getEras",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "string"
              }
            },
            "typeParameters": []
          },
          "description": "Returns a list of era identifiers for the calendar.",
          "default": null
        },
        "getMinimumMonthInYear": {
          "type": "method",
          "name": "getMinimumMonthInYear",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the minimum month number of the given date's year.\nNormally, this is 1, but in some calendars such as the Japanese,\neras may begin in the middle of a year.",
          "default": null
        },
        "getMinimumDayInMonth": {
          "type": "method",
          "name": "getMinimumDayInMonth",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the minimum day number of the given date's month.\nNormally, this is 1, but in some calendars such as the Japanese,\neras may begin in the middle of a month.",
          "default": null
        },
        "getFormattableMonth": {
          "type": "method",
          "name": "getFormattableMonth",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a date that is the first day of the month for the given date.\nThis is used to determine the month that the given date falls in, if\nthe calendar has months that do not align with the standard calendar months \n(e.g. fiscal calendars).",
          "default": null
        },
        "isEqual": {
          "type": "method",
          "name": "isEqual",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "calendar",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given calendar is the same as this calendar.",
          "default": null
        },
        "balanceDate": {
          "type": "method",
          "name": "balanceDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null
        },
        "balanceYearMonth": {
          "type": "method",
          "name": "balanceYearMonth",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "previousDate",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null
        },
        "constrainDate": {
          "type": "method",
          "name": "constrainDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null
        },
        "isInverseEra": {
          "type": "method",
          "name": "isInverseEra",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "The Calendar interface represents a calendar system, including information\nabout how days, months, years, and eras are organized, and methods to perform\narithmetic on dates."
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate",
      "name": "CalendarDate",
      "properties": {
        "undefined": {
          "type": "any"
        },
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Calendar"
          },
          "optional": false,
          "description": "The calendar system associated with this date, e.g. Gregorian.",
          "access": "public",
          "default": null
        },
        "era": {
          "type": "property",
          "name": "era",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The calendar era for this date, e.g. \"BC\" or \"AD\".",
          "access": "public",
          "default": null
        },
        "year": {
          "type": "property",
          "name": "year",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The year of this date within the era.",
          "access": "public",
          "default": null
        },
        "month": {
          "type": "property",
          "name": "month",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The month number within the year. Note that some calendar systems such as Hebrew\nmay have a variable number of months per year. Therefore, month numbers may not\nalways correspond to the same month names in different years.",
          "access": "public",
          "default": null
        },
        "day": {
          "type": "property",
          "name": "day",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The day number within the month.",
          "access": "public",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "args",
                "value": {
                  "type": "array",
                  "elementType": {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                },
                "rest": true,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this date.",
          "default": null,
          "static": false
        },
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDate` with the given duration added to it.",
          "default": null,
          "static": false
        },
        "subtract": {
          "type": "method",
          "name": "subtract",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDate` with the given duration subtracted from it.",
          "default": null,
          "static": false
        },
        "set": {
          "type": "method",
          "name": "set",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fields",
                "value": {
                  "type": "identifier",
                  "name": "DateFields"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly.",
          "default": null,
          "static": false
        },
        "cycle": {
          "type": "method",
          "name": "cycle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "field",
                "value": {
                  "type": "identifier",
                  "name": "DateField"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "amount",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "identifier",
                  "name": "CycleOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDate` with the given field adjusted by a specified amount.\nWhen the resulting value reaches the limits of the field, it wraps around.",
          "default": null,
          "static": false
        },
        "toDate": {
          "type": "method",
          "name": "toDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "timeZone",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "Date",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone.",
          "default": null,
          "static": false
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to an ISO 8601 formatted string.",
          "default": null,
          "static": false
        },
        "compare": {
          "type": "method",
          "name": "compare",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "b",
                "value": {
                  "type": "identifier",
                  "name": "AnyCalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A CalendarDate represents a date without any time components in a specific calendar system."
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:AnyCalendarDate",
      "name": "AnyCalendarDate",
      "properties": {
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/types.ts:Calendar"
          },
          "optional": false,
          "default": null
        },
        "era": {
          "type": "property",
          "name": "era",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "default": null
        },
        "year": {
          "type": "property",
          "name": "year",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "month": {
          "type": "property",
          "name": "month",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "day": {
          "type": "property",
          "name": "day",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "this",
              "description": null
            },
            "typeParameters": []
          },
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "An interface that is compatible with any object with date fields."
    },
    "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue",
      "name": "DateValue",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime",
      "name": "CalendarDateTime",
      "properties": {
        "undefined": {
          "type": "any"
        },
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Calendar"
          },
          "optional": false,
          "description": "The calendar system associated with this date, e.g. Gregorian.",
          "access": "public",
          "default": null
        },
        "era": {
          "type": "property",
          "name": "era",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The calendar era for this date, e.g. \"BC\" or \"AD\".",
          "access": "public",
          "default": null
        },
        "year": {
          "type": "property",
          "name": "year",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The year of this date within the era.",
          "access": "public",
          "default": null
        },
        "month": {
          "type": "property",
          "name": "month",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The month number within the year. Note that some calendar systems such as Hebrew\nmay have a variable number of months per year. Therefore, month numbers may not\nalways correspond to the same month names in different years.",
          "access": "public",
          "default": null
        },
        "day": {
          "type": "property",
          "name": "day",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The day number within the month.",
          "access": "public",
          "default": null
        },
        "hour": {
          "type": "property",
          "name": "hour",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The hour in the day, numbered from 0 to 23.",
          "access": "public",
          "default": null
        },
        "minute": {
          "type": "property",
          "name": "minute",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The minute in the hour.",
          "access": "public",
          "default": null
        },
        "second": {
          "type": "property",
          "name": "second",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The second in the minute.",
          "access": "public",
          "default": null
        },
        "millisecond": {
          "type": "property",
          "name": "millisecond",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The millisecond in the second.",
          "access": "public",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "args",
                "value": {
                  "type": "array",
                  "elementType": {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                },
                "rest": true,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this date.",
          "default": null,
          "static": false
        },
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateTimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDateTime` with the given duration added to it.",
          "default": null,
          "static": false
        },
        "subtract": {
          "type": "method",
          "name": "subtract",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateTimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDateTime` with the given duration subtracted from it.",
          "default": null,
          "static": false
        },
        "set": {
          "type": "method",
          "name": "set",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fields",
                "value": {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "identifier",
                      "name": "DateFields"
                    },
                    {
                      "type": "identifier",
                      "name": "TimeFields"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly.",
          "default": null,
          "static": false
        },
        "cycle": {
          "type": "method",
          "name": "cycle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "field",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "DateField"
                    },
                    {
                      "type": "identifier",
                      "name": "TimeField"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "amount",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "identifier",
                  "name": "CycleTimeOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.\nWhen the resulting value reaches the limits of the field, it wraps around.",
          "default": null,
          "static": false
        },
        "toDate": {
          "type": "method",
          "name": "toDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "timeZone",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "disambiguation",
                "value": {
                  "type": "identifier",
                  "name": "Disambiguation"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "Date",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to a native JavaScript Date object in the given time zone.",
          "default": null,
          "static": false
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to an ISO 8601 formatted string.",
          "default": null,
          "static": false
        },
        "compare": {
          "type": "method",
          "name": "compare",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "b",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A CalendarDateTime represents a date and time without a time zone, in a specific calendar system."
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime",
      "name": "ZonedDateTime",
      "properties": {
        "undefined": {
          "type": "any"
        },
        "calendar": {
          "type": "property",
          "name": "calendar",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Calendar"
          },
          "optional": false,
          "description": "The calendar system associated with this date, e.g. Gregorian.",
          "access": "public",
          "default": null
        },
        "era": {
          "type": "property",
          "name": "era",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The calendar era for this date, e.g. \"BC\" or \"AD\".",
          "access": "public",
          "default": null
        },
        "year": {
          "type": "property",
          "name": "year",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The year of this date within the era.",
          "access": "public",
          "default": null
        },
        "month": {
          "type": "property",
          "name": "month",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The month number within the year. Note that some calendar systems such as Hebrew\nmay have a variable number of months per year. Therefore, month numbers may not\nalways correspond to the same month names in different years.",
          "access": "public",
          "default": null
        },
        "day": {
          "type": "property",
          "name": "day",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The day number within the month.",
          "access": "public",
          "default": null
        },
        "hour": {
          "type": "property",
          "name": "hour",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The hour in the day, numbered from 0 to 23.",
          "access": "public",
          "default": null
        },
        "minute": {
          "type": "property",
          "name": "minute",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The minute in the hour.",
          "access": "public",
          "default": null
        },
        "second": {
          "type": "property",
          "name": "second",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The second in the minute.",
          "access": "public",
          "default": null
        },
        "millisecond": {
          "type": "property",
          "name": "millisecond",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The millisecond in the second.",
          "access": "public",
          "default": null
        },
        "timeZone": {
          "type": "property",
          "name": "timeZone",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The IANA time zone identifier that this date and time is represented in.",
          "access": "public",
          "default": null
        },
        "offset": {
          "type": "property",
          "name": "offset",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The UTC offset for this time, in milliseconds.",
          "access": "public",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "args",
                "value": {
                  "type": "array",
                  "elementType": {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                },
                "rest": true,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this date.",
          "default": null,
          "static": false
        },
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateTimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `ZonedDateTime` with the given duration added to it.",
          "default": null,
          "static": false
        },
        "subtract": {
          "type": "method",
          "name": "subtract",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "DateTimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `ZonedDateTime` with the given duration subtracted from it.",
          "default": null,
          "static": false
        },
        "set": {
          "type": "method",
          "name": "set",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fields",
                "value": {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "identifier",
                      "name": "DateFields"
                    },
                    {
                      "type": "identifier",
                      "name": "TimeFields"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "disambiguation",
                "value": {
                  "type": "identifier",
                  "name": "Disambiguation"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly.",
          "default": null,
          "static": false
        },
        "cycle": {
          "type": "method",
          "name": "cycle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "field",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "DateField"
                    },
                    {
                      "type": "identifier",
                      "name": "TimeField"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "amount",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "identifier",
                  "name": "CycleTimeOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
            },
            "typeParameters": []
          },
          "description": "Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.\nWhen the resulting value reaches the limits of the field, it wraps around.",
          "default": null,
          "static": false
        },
        "toDate": {
          "type": "method",
          "name": "toDate",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "identifier",
              "name": "Date",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to a native JavaScript Date object.",
          "default": null,
          "static": false
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier.",
          "default": null,
          "static": false
        },
        "toAbsoluteString": {
          "type": "method",
          "name": "toAbsoluteString",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the date to an ISO 8601 formatted string in UTC.",
          "default": null,
          "static": false
        },
        "compare": {
          "type": "method",
          "name": "compare",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "b",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A ZonedDateTime represents a date and time in a specific time zone and calendar system."
    },
    "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:PageBehavior",
      "name": "PageBehavior",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "single"
          },
          {
            "type": "string",
            "value": "visible"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:MappedDateValue",
      "name": "MappedDateValue",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
        },
        "extendsType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "trueType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "falseType": {
          "type": "conditional",
          "checkType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
          },
          "extendsType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "trueType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "falseType": {
            "type": "conditional",
            "checkType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
            },
            "extendsType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "trueType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "falseType": {
              "type": "never"
            }
          }
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ChildrenOrFunction",
      "name": "ChildrenOrFunction",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "identifier",
            "name": "ReactNode"
          },
          {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "values",
                "value": {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "identifier",
                      "name": "T"
                    },
                    {
                      "type": "object",
                      "properties": {
                        "defaultChildren": {
                          "type": "property",
                          "name": "defaultChildren",
                          "indexType": null,
                          "value": {
                            "type": "union",
                            "elements": [
                              {
                                "type": "identifier",
                                "name": "ReactNode"
                              },
                              {
                                "type": "undefined"
                              }
                            ]
                          },
                          "optional": false,
                          "default": null
                        }
                      }
                    }
                  ]
                },
                "rest": false
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:CalendarRenderProps",
      "name": "CalendarRenderProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:CalendarState"
          },
          "optional": false,
          "description": "State of the calendar.",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:CalendarState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:CalendarState",
      "name": "CalendarState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected date.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the currently selected date.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is in a read only state.",
          "default": null
        },
        "visibleRange": {
          "type": "property",
          "name": "visibleRange",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              }
            ]
          },
          "optional": false,
          "description": "The date range that is currently visible in the calendar.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "timeZone": {
          "type": "property",
          "name": "timeZone",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The time zone of the dates currently being displayed.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the selected value.",
          "access": "private",
          "default": null
        },
        "isValueInvalid": {
          "type": "property",
          "name": "isValueInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "default": null
        },
        "focusedDate": {
          "type": "property",
          "name": "focusedDate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          "optional": false,
          "description": "The currently focused date.",
          "default": null
        },
        "setFocusedDate": {
          "type": "method",
          "name": "setFocusedDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused date.",
          "default": null
        },
        "focusNextDay": {
          "type": "method",
          "name": "focusNextDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next calendar date.",
          "default": null
        },
        "focusPreviousDay": {
          "type": "method",
          "name": "focusPreviousDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous calendar date.",
          "default": null
        },
        "focusNextRow": {
          "type": "method",
          "name": "focusNextRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next row of dates, e.g. the next week.",
          "default": null
        },
        "focusPreviousRow": {
          "type": "method",
          "name": "focusPreviousRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous row of dates, e.g. the previous work.",
          "default": null
        },
        "focusNextPage": {
          "type": "method",
          "name": "focusNextPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next page of dates, e.g. the next month if one month is visible.",
          "default": null
        },
        "focusPreviousPage": {
          "type": "method",
          "name": "focusPreviousPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous page of dates, e.g. the previous month if one month is visible.",
          "default": null
        },
        "focusSectionStart": {
          "type": "method",
          "name": "focusSectionStart",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the start of the current section of dates, e.g. the start of the current month.",
          "default": null
        },
        "focusSectionEnd": {
          "type": "method",
          "name": "focusSectionEnd",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the end of the current section of dates, e.g. the end of the current month month.",
          "default": null
        },
        "focusNextSection": {
          "type": "method",
          "name": "focusNextSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved forward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the next year.",
          "default": null
        },
        "focusPreviousSection": {
          "type": "method",
          "name": "focusPreviousSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved backward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the previous year.",
          "default": null
        },
        "selectFocusedDate": {
          "type": "method",
          "name": "selectFocusedDate",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the currently focused date.",
          "default": null
        },
        "selectDate": {
          "type": "method",
          "name": "selectDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the given date.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether focus is currently within the calendar.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether focus is currently within the calendar.",
          "default": null
        },
        "isInvalid": {
          "type": "method",
          "name": "isInvalid",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is invalid according to the `minValue` and `maxValue` props.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently selected.",
          "default": null
        },
        "isCellFocused": {
          "type": "method",
          "name": "isCellFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently focused.",
          "default": null
        },
        "isCellDisabled": {
          "type": "method",
          "name": "isCellDisabled",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is disabled according to the `minValue, `maxValue`, and `isDisabled` props.",
          "default": null
        },
        "isCellUnavailable": {
          "type": "method",
          "name": "isCellUnavailable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is unavailable according to the `isDateUnavailable` prop.",
          "default": null
        },
        "isPreviousVisibleRangeInvalid": {
          "type": "method",
          "name": "isPreviousVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the previous visible date range is allowed to be selected according to the `minValue` prop.",
          "default": null
        },
        "isNextVisibleRangeInvalid": {
          "type": "method",
          "name": "isNextVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the next visible date range is allowed to be selected according to the `maxValue` prop.",
          "default": null
        },
        "getDatesInWeek": {
          "type": "method",
          "name": "getDatesInWeek",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "weekIndex",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "startDate",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Array"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns an array of dates in the week index counted from the provided start date, or the first visible date if not given.\nThe returned array always has 7 elements, but may include null if the date does not exist according to the calendar system.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue",
      "name": "RangeValue",
      "properties": {
        "start": {
          "type": "property",
          "name": "start",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": false,
          "description": "The start value of the range.",
          "default": null
        },
        "end": {
          "type": "property",
          "name": "end",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": false,
          "description": "The end value of the range.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState",
      "name": "ValidationState",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "valid"
          },
          {
            "type": "string",
            "value": "invalid"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue",
      "name": "DateValue",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Card.tsx:CardRenderProps",
      "name": "CardRenderProps",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "XS"
              },
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              },
              {
                "type": "string",
                "value": "XL"
              }
            ]
          },
          "optional": false,
          "description": "The size of the Card.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LoadingState",
      "name": "LoadingState",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "loading"
          },
          {
            "type": "string",
            "value": "sorting"
          },
          {
            "type": "string",
            "value": "loadingMore"
          },
          {
            "type": "string",
            "value": "error"
          },
          {
            "type": "string",
            "value": "idle"
          },
          {
            "type": "string",
            "value": "filtering"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragAndDropHooks",
      "name": "DragAndDropHooks",
      "value": {
        "type": "intersection",
        "types": [
          {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragHooks"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DropHooks"
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragHooks": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DragHooks",
      "name": "DragHooks",
      "properties": {
        "useDraggableCollectionState": {
          "type": "property",
          "name": "useDraggableCollectionState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DraggableCollectionStateOpts"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "T"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDraggableCollectionState.ts:DraggableCollectionState"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "useDraggableCollection": {
          "type": "property",
          "name": "useDraggableCollection",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableCollection.ts:DraggableCollectionOptions"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDraggableCollectionState.ts:DraggableCollectionState"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "ref",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
                  },
                  "typeParameters": [
                    {
                      "type": "union",
                      "elements": [
                        {
                          "type": "identifier",
                          "name": "HTMLElement"
                        },
                        {
                          "type": "null"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "useDraggableItem": {
          "type": "property",
          "name": "useDraggableItem",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemProps"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDraggableCollectionState.ts:DraggableCollectionState"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemResult"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "DragPreview": {
          "type": "property",
          "name": "DragPreview",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": true,
          "default": null
        },
        "renderDragPreview": {
          "type": "property",
          "name": "renderDragPreview",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "items",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "JSX.Element"
                },
                {
                  "type": "object",
                  "properties": {
                    "element": {
                      "type": "property",
                      "name": "element",
                      "indexType": null,
                      "value": {
                        "type": "identifier",
                        "name": "JSX.Element"
                      },
                      "optional": false,
                      "default": null
                    },
                    "x": {
                      "type": "property",
                      "name": "x",
                      "indexType": null,
                      "value": {
                        "type": "number"
                      },
                      "optional": false,
                      "default": null
                    },
                    "y": {
                      "type": "property",
                      "name": "y",
                      "indexType": null,
                      "value": {
                        "type": "number"
                      },
                      "optional": false,
                      "default": null
                    }
                  }
                }
              ]
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "isVirtualDragging": {
          "type": "property",
          "name": "isVirtualDragging",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DraggableCollectionStateOpts": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DraggableCollectionStateOpts",
      "name": "DraggableCollectionStateOpts",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager"
          },
          "optional": false,
          "description": "An interface for reading and updating multiple selection state.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drag events should be disabled.",
          "default": null
        },
        "onDragStart": {
          "type": "property",
          "name": "onDragStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionStartEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a drag operation is started.",
          "default": null
        },
        "onDragMove": {
          "type": "property",
          "name": "onDragMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag is moved.",
          "default": null
        },
        "onDragEnd": {
          "type": "property",
          "name": "onDragEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the drag operation is ended, either as a result of a drop or a cancellation.",
          "default": null
        },
        "preview": {
          "type": "property",
          "name": "preview",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref of the element that will be rendered as the drag preview while dragging.",
          "default": null
        },
        "getAllowedDropOperations": {
          "type": "property",
          "name": "getAllowedDropOperations",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
              }
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Function that returns the drop operations that are allowed for the dragged items. If not provided, all drop operations are allowed.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": {
            "type": "object",
            "properties": null
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection",
      "name": "Collection",
      "properties": {
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The number of items in the collection.",
          "default": null
        },
        "getKeys": {
          "type": "method",
          "name": "getKeys",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "Key"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Iterate over all keys in the collection.",
          "default": null
        },
        "getItem": {
          "type": "method",
          "name": "getItem",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "T"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get an item by its key.",
          "default": null
        },
        "at": {
          "type": "method",
          "name": "at",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "idx",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "T"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get an item by the index of its key.",
          "default": null
        },
        "getKeyBefore": {
          "type": "method",
          "name": "getKeyBefore",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the key that comes before the given key in the collection.",
          "default": null
        },
        "getKeyAfter": {
          "type": "method",
          "name": "getKeyAfter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the key that comes after the given key in the collection.",
          "default": null
        },
        "getFirstKey": {
          "type": "method",
          "name": "getFirstKey",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the first key in the collection.",
          "default": null
        },
        "getLastKey": {
          "type": "method",
          "name": "getLastKey",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Get the last key in the collection.",
          "default": null
        },
        "getChildren": {
          "type": "method",
          "name": "getChildren",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Iterable"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Iterate over the child items of the given key.",
          "default": null
        },
        "getTextValue": {
          "type": "method",
          "name": "getTextValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a string representation of the item's contents.",
          "default": null
        },
        "filter": {
          "type": "method",
          "name": "filter",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "filterFn",
                "value": {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "nodeValue",
                      "value": {
                        "type": "string"
                      },
                      "rest": false
                    },
                    {
                      "type": "parameter",
                      "name": "node",
                      "value": {
                        "type": "identifier",
                        "name": "T"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Filters the collection using the given function.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": [
        {
          "type": "identifier",
          "name": "Iterable"
        }
      ],
      "description": "A generic interface to access a readonly sequential\ncollection of unique keyed items."
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node",
      "name": "Node",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The type of item this node represents.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": false,
          "description": "A unique key for the node.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The object value the node was created from.",
          "default": null
        },
        "level": {
          "type": "property",
          "name": "level",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The level of depth this node is at in the hierarchy.",
          "default": null
        },
        "hasChildNodes": {
          "type": "property",
          "name": "hasChildNodes",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether this item has children, even if not loaded yet.",
          "default": null
        },
        "childNodes": {
          "type": "property",
          "name": "childNodes",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Iterable"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The loaded children of this node.",
          "access": "private",
          "default": null
        },
        "rendered": {
          "type": "property",
          "name": "rendered",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": false,
          "description": "The rendered contents of this node (e.g. JSX).",
          "default": null
        },
        "textValue": {
          "type": "property",
          "name": "textValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A string value for this node, used for features like typeahead.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "An accessibility label for this node.",
          "default": null
        },
        "index": {
          "type": "property",
          "name": "index",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The index of this node within its parent.",
          "default": null
        },
        "wrapper": {
          "type": "property",
          "name": "wrapper",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "element",
                "value": {
                  "type": "identifier",
                  "name": "ReactElement"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that should be called to wrap the rendered node.",
          "default": null
        },
        "parentKey": {
          "type": "property",
          "name": "parentKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The key of the parent node.",
          "default": null
        },
        "prevKey": {
          "type": "property",
          "name": "prevKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The key of the node before this node.",
          "default": null
        },
        "nextKey": {
          "type": "property",
          "name": "nextKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The key of the node after this node.",
          "default": null
        },
        "props": {
          "type": "property",
          "name": "props",
          "indexType": null,
          "value": {
            "id": null,
            "name": null,
            "type": "any"
          },
          "optional": true,
          "description": "Additional properties specific to a particular node type.",
          "default": null
        },
        "shouldInvalidate": {
          "type": "property",
          "name": "shouldInvalidate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "context",
                "value": {
                  "id": null,
                  "name": null,
                  "type": "any"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "access": "private",
          "default": null
        },
        "render": {
          "type": "property",
          "name": "render",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "node",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                  },
                  "typeParameters": [
                    {
                      "id": null,
                      "name": null,
                      "type": "any"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactElement"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function that renders this node to a React Element in the DOM.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager",
      "name": "MultipleSelectionManager",
      "properties": {
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected keys in the collection.",
          "default": null
        },
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the selection is empty.",
          "default": null
        },
        "isSelectAll": {
          "type": "property",
          "name": "isSelectAll",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether all items in the collection are selected.",
          "default": null
        },
        "firstSelectedKey": {
          "type": "property",
          "name": "firstSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The first selected key in the collection.",
          "default": null
        },
        "lastSelectedKey": {
          "type": "property",
          "name": "lastSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The last selected key in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "The currently disabled keys in the collection.",
          "default": null
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "optional": false,
          "description": "Whether `disabledKeys` applies to selection, actions, or both.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether a key is selected.",
          "default": null
        },
        "isSelectionEqual": {
          "type": "method",
          "name": "isSelectionEqual",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the current selection is equal to the given selection.",
          "default": null
        },
        "extendSelection": {
          "type": "method",
          "name": "extendSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "toKey",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Extends the selection to the given key.",
          "default": null
        },
        "toggleSelection": {
          "type": "method",
          "name": "toggleSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles whether the given key is selected.",
          "default": null
        },
        "replaceSelection": {
          "type": "method",
          "name": "replaceSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the selection with only the given key.",
          "default": null
        },
        "setSelectedKeys": {
          "type": "method",
          "name": "setSelectedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the selection with the given keys.",
          "default": null
        },
        "selectAll": {
          "type": "method",
          "name": "selectAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects all items in the collection.",
          "default": null
        },
        "clearSelection": {
          "type": "method",
          "name": "clearSelection",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Removes all keys from the selection.",
          "default": null
        },
        "toggleSelectAll": {
          "type": "method",
          "name": "toggleSelectAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles between select all and an empty selection.",
          "default": null
        },
        "select": {
          "type": "method",
          "name": "select",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:LongPressEvent"
                    },
                    {
                      "type": "identifier",
                      "name": "PointerEvent"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles, replaces, or extends selection to the given key depending\non the pointer event and collection's selection mode.",
          "default": null
        },
        "canSelectItem": {
          "type": "method",
          "name": "canSelectItem",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given key can be selected.",
          "default": null
        },
        "isDisabled": {
          "type": "method",
          "name": "isDisabled",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given key is non-interactive, i.e. both selection and actions are disabled.",
          "default": null
        },
        "setSelectionBehavior": {
          "type": "method",
          "name": "setSelectionBehavior",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selectionBehavior",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selection behavior for the collection.",
          "default": null
        },
        "isLink": {
          "type": "method",
          "name": "isLink",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given key is a hyperlink.",
          "default": null
        },
        "getItemProps": {
          "type": "method",
          "name": "getItemProps",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the props for the given item.",
          "default": null
        },
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "The collection of nodes that the selection manager handles.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the collection is currently focused.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the collection is focused.",
          "default": null
        },
        "focusedKey": {
          "type": "property",
          "name": "focusedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current focused key in the collection.",
          "default": null
        },
        "childFocusStrategy": {
          "type": "property",
          "name": "childFocusStrategy",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Whether the first or last child of the focused key should receive focus.",
          "default": null
        },
        "setFocusedKey": {
          "type": "method",
          "name": "setFocusedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "child",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused key, and optionally, whether the first or last child of that key should receive focus.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode",
      "name": "SelectionMode",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "none"
          },
          {
            "type": "string",
            "value": "single"
          },
          {
            "type": "string",
            "value": "multiple"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior",
      "name": "SelectionBehavior",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "toggle"
          },
          {
            "type": "string",
            "value": "replace"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior",
      "name": "DisabledBehavior",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "selection"
          },
          {
            "type": "string",
            "value": "all"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:LongPressEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:LongPressEvent",
      "name": "LongPressEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "longpressstart"
              },
              {
                "type": "string",
                "value": "longpressend"
              },
              {
                "type": "string",
                "value": "longpress"
              }
            ]
          },
          "optional": false,
          "description": "The type of long press event being fired.",
          "default": null
        },
        "pointerType": {
          "type": "property",
          "name": "pointerType",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PointerType"
          },
          "optional": false,
          "description": "The pointer type that triggered the press event.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Element"
          },
          "optional": false,
          "description": "The target element of the press event.",
          "default": null
        },
        "shiftKey": {
          "type": "property",
          "name": "shiftKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the shift keyboard modifier was held during the press event.",
          "default": null
        },
        "ctrlKey": {
          "type": "property",
          "name": "ctrlKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the ctrl keyboard modifier was held during the press event.",
          "default": null
        },
        "metaKey": {
          "type": "property",
          "name": "metaKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the meta keyboard modifier was held during the press event.",
          "default": null
        },
        "altKey": {
          "type": "property",
          "name": "altKey",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the alt keyboard modifier was held during the press event.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "X position relative to the target.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "Y position relative to the target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy",
      "name": "FocusStrategy",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "first"
          },
          {
            "type": "string",
            "value": "last"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionStartEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionStartEvent",
      "name": "DraggableCollectionStartEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were dragged.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragstart"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionMoveEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionMoveEvent",
      "name": "DraggableCollectionMoveEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were dragged.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragmove"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent",
      "name": "DraggableCollectionEndEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were dragged.",
          "default": null
        },
        "isInternal": {
          "type": "property",
          "name": "isInternal",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drop ended within the same collection as it originated.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragend"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that occurred.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation",
      "name": "DropOperation",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "copy"
          },
          {
            "type": "string",
            "value": "link"
          },
          {
            "type": "string",
            "value": "move"
          },
          {
            "type": "string",
            "value": "cancel"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer",
      "name": "DragPreviewRenderer",
      "value": {
        "type": "function",
        "parameters": [
          {
            "type": "parameter",
            "name": "items",
            "value": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
              }
            },
            "rest": false
          },
          {
            "type": "parameter",
            "name": "callback",
            "value": {
              "type": "function",
              "parameters": [
                {
                  "type": "parameter",
                  "name": "node",
                  "value": {
                    "type": "union",
                    "elements": [
                      {
                        "type": "identifier",
                        "name": "HTMLElement"
                      },
                      {
                        "type": "null"
                      }
                    ]
                  },
                  "rest": false
                },
                {
                  "type": "parameter",
                  "name": "x",
                  "value": {
                    "type": "number"
                  },
                  "optional": true,
                  "rest": false
                },
                {
                  "type": "parameter",
                  "name": "y",
                  "value": {
                    "type": "number"
                  },
                  "optional": true,
                  "rest": false
                }
              ],
              "return": {
                "type": "void"
              },
              "typeParameters": []
            },
            "rest": false
          }
        ],
        "return": {
          "type": "void"
        },
        "typeParameters": []
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem",
      "name": "DragItem",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": {
            "type": "string"
          },
          "value": {
            "type": "string"
          },
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDraggableCollectionState.ts:DraggableCollectionState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDraggableCollectionState.ts:DraggableCollectionState",
      "name": "DraggableCollectionState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager"
          },
          "optional": false,
          "description": "An interface for reading and updating multiple selection state.",
          "default": null
        },
        "draggedKey": {
          "type": "property",
          "name": "draggedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The key of the item that initiated a drag.",
          "default": null
        },
        "draggingKeys": {
          "type": "property",
          "name": "draggingKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that are currently being dragged.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether drag events are disabled.",
          "default": null
        },
        "isDragging": {
          "type": "method",
          "name": "isDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given key is currently being dragged.",
          "default": null
        },
        "getKeysForDrag": {
          "type": "method",
          "name": "getKeysForDrag",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Set"
              },
              "typeParameters": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the keys of the items that will be dragged with the given key (e.g. selected items).",
          "default": null
        },
        "getItems": {
          "type": "method",
          "name": "getItems",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragItem"
              }
            },
            "typeParameters": []
          },
          "description": "Returns the items to drag for the given key.",
          "default": null
        },
        "preview": {
          "type": "property",
          "name": "preview",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragPreviewRenderer"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref of the element that will be rendered as the drag preview while dragging.",
          "default": null
        },
        "getAllowedDropOperations": {
          "type": "property",
          "name": "getAllowedDropOperations",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "array",
              "elementType": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
              }
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Function that returns the drop operations that are allowed for the dragged items. If not provided, all drop operations are allowed.",
          "default": null
        },
        "startDrag": {
          "type": "method",
          "name": "startDrag",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragStartEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Begins a drag for the given key. This triggers the onDragStart event.",
          "default": null
        },
        "moveDrag": {
          "type": "method",
          "name": "moveDrag",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragMoveEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Triggers an onDragMove event.",
          "default": null
        },
        "endDrag": {
          "type": "method",
          "name": "endDrag",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "event",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DraggableCollectionEndEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Ends the current drag, and emits an onDragEnd event.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject",
      "name": "RefObject",
      "properties": {
        "current": {
          "type": "property",
          "name": "current",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragStartEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragStartEvent",
      "name": "DragStartEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragstart"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragMoveEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragMoveEvent",
      "name": "DragMoveEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dragmove"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableCollection.ts:DraggableCollectionOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableCollection.ts:DraggableCollectionOptions",
      "name": "DraggableCollectionOptions",
      "properties": {},
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemProps",
      "name": "DraggableItemProps",
      "properties": {
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": false,
          "description": "The key of the draggable item within the collection.",
          "default": null
        },
        "hasDragButton": {
          "type": "property",
          "name": "hasDragButton",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item has an explicit focusable drag affordance to initiate accessible drag and drop mode.\nIf true, the dragProps will omit these event handlers, and they will be applied to dragButtonProps instead.",
          "default": null
        },
        "hasAction": {
          "type": "property",
          "name": "hasAction",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the item has a primary action (e.g. Enter key or long press) that would\nconflict with initiating accessible drag and drop. If true, the Alt key must be held to\nstart dragging with a keyboard, and long press is disabled until selection mode is entered.\nThis should be passed from the associated collection item hook (e.g. useOption, useGridListItem, etc.).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDraggableItem.ts:DraggableItemResult",
      "name": "DraggableItemResult",
      "properties": {
        "dragProps": {
          "type": "property",
          "name": "dragProps",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "HTMLAttributes"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          },
          "optional": false,
          "description": "Props for the draggable item.",
          "default": null
        },
        "dragButtonProps": {
          "type": "property",
          "name": "dragButtonProps",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/button/src/index.d.ts:AriaButtonProps"
          },
          "optional": false,
          "description": "Props for the explicit drag button affordance, if any.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/button/src/index.d.ts:AriaButtonProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/button/src/index.d.ts:AriaButtonProps",
      "name": "AriaButtonProps",
      "properties": {
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the button is disabled.",
          "default": null
        },
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ReactNode"
          },
          "optional": true,
          "description": "The content to display in the button.",
          "default": null
        },
        "onPress": {
          "type": "property",
          "name": "onPress",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press is released over the target.",
          "default": null
        },
        "onPressStart": {
          "type": "property",
          "name": "onPressStart",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction starts.",
          "default": null
        },
        "onPressEnd": {
          "type": "property",
          "name": "onPressEnd",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
          "default": null
        },
        "onPressChange": {
          "type": "property",
          "name": "onPressChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isPressed",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the press state changes.",
          "default": null
        },
        "onPressUp": {
          "type": "property",
          "name": "onPressUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
          "default": null
        },
        "onClick": {
          "type": "property",
          "name": "onClick",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "MouseEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "**Not recommended – use `onPress` instead.** `onClick` is an alias for `onPress`\nprovided for compatibility with other libraries. `onPress` provides \nadditional event details for non-mouse interactions.",
          "default": null
        },
        "autoFocus": {
          "type": "property",
          "name": "autoFocus",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the element should receive focus on render.",
          "default": null
        },
        "onFocus": {
          "type": "property",
          "name": "onFocus",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element receives focus.",
          "default": null
        },
        "onBlur": {
          "type": "property",
          "name": "onBlur",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "FocusEvent"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "Target"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element loses focus.",
          "default": null
        },
        "onFocusChange": {
          "type": "property",
          "name": "onFocusChange",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the element's focus status changes.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is pressed.",
          "default": null
        },
        "onKeyUp": {
          "type": "property",
          "name": "onKeyUp",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a key is released.",
          "default": null
        },
        "href": {
          "type": "property",
          "name": "href",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A URL to link to if elementType=\"a\".",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The target window for the link.",
          "default": null
        },
        "rel": {
          "type": "property",
          "name": "rel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
          "default": null
        },
        "elementType": {
          "type": "property",
          "name": "elementType",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "ElementType"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "JSXElementConstructor"
                },
                "typeParameters": [
                  {
                    "id": null,
                    "name": null,
                    "type": "any"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The HTML element or React element used to render the button, e.g. 'div', 'a', or `RouterLink`.",
          "default": "'button'"
        },
        "aria-disabled": {
          "type": "property",
          "name": "aria-disabled",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element is disabled to users of assistive technology.",
          "default": null
        },
        "aria-expanded": {
          "type": "property",
          "name": "aria-expanded",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.",
          "default": null
        },
        "aria-haspopup": {
          "type": "property",
          "name": "aria-haspopup",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "menu"
              },
              {
                "type": "string",
                "value": "listbox"
              },
              {
                "type": "string",
                "value": "tree"
              },
              {
                "type": "string",
                "value": "grid"
              },
              {
                "type": "string",
                "value": "dialog"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.",
          "default": null
        },
        "aria-controls": {
          "type": "property",
          "name": "aria-controls",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) whose contents or presence are controlled by the current element.",
          "default": null
        },
        "aria-pressed": {
          "type": "property",
          "name": "aria-pressed",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "mixed"
              }
            ]
          },
          "optional": true,
          "description": "Indicates the current \"pressed\" state of toggle buttons.",
          "default": null
        },
        "aria-current": {
          "type": "property",
          "name": "aria-current",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "true"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "page"
              },
              {
                "type": "string",
                "value": "step"
              },
              {
                "type": "string",
                "value": "location"
              },
              {
                "type": "string",
                "value": "date"
              },
              {
                "type": "string",
                "value": "time"
              }
            ]
          },
          "optional": true,
          "description": "Indicates whether this element represents the current item within a container or set of related elements.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "button"
              },
              {
                "type": "string",
                "value": "submit"
              },
              {
                "type": "string",
                "value": "reset"
              }
            ]
          },
          "optional": true,
          "description": "The behavior of the button when used in an HTML form.",
          "default": "'button'"
        },
        "preventFocusOnPress": {
          "type": "property",
          "name": "preventFocusOnPress",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
          "default": null
        },
        "form": {
          "type": "property",
          "name": "form",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/button#form).",
          "default": null
        },
        "formAction": {
          "type": "property",
          "name": "formAction",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
          "default": null
        },
        "formEncType": {
          "type": "property",
          "name": "formEncType",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Indicates how to encode the form data that is submitted.",
          "default": null
        },
        "formMethod": {
          "type": "property",
          "name": "formMethod",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Indicates the HTTP method used to submit the form.",
          "default": null
        },
        "formNoValidate": {
          "type": "property",
          "name": "formNoValidate",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Indicates that the form is not to be validated when it is submitted.",
          "default": null
        },
        "formTarget": {
          "type": "property",
          "name": "formTarget",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Overrides the target attribute of the button's form owner.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Submitted as a pair with the button's value as part of the form data.",
          "default": null
        },
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The value associated with the button's name when it's submitted with the form data.",
          "default": null
        },
        "excludeFromTabOrder": {
          "type": "property",
          "name": "excludeFromTabOrder",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "identifier",
            "name": "ElementType"
          },
          "default": {
            "type": "string",
            "value": "button"
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement",
      "name": "FocusableElement",
      "properties": {},
      "typeParameters": [],
      "extends": [
        {
          "type": "identifier",
          "name": "Element"
        },
        {
          "type": "identifier",
          "name": "HTMLOrSVGElement"
        }
      ],
      "description": "Any focusable element, including both HTML and SVG elements."
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DropHooks": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/useDragAndDrop.tsx:DropHooks",
      "name": "DropHooks",
      "properties": {
        "useDroppableCollectionState": {
          "type": "property",
          "name": "useDroppableCollectionState",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionStateOptions"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "useDroppableCollection": {
          "type": "property",
          "name": "useDroppableCollection",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionOptions"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "ref",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
                  },
                  "typeParameters": [
                    {
                      "type": "union",
                      "elements": [
                        {
                          "type": "identifier",
                          "name": "HTMLElement"
                        },
                        {
                          "type": "null"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionResult"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "useDroppableItem": {
          "type": "property",
          "name": "useDroppableItem",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemOptions"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "ref",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
                  },
                  "typeParameters": [
                    {
                      "type": "union",
                      "elements": [
                        {
                          "type": "identifier",
                          "name": "HTMLElement"
                        },
                        {
                          "type": "null"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemResult"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "useDropIndicator": {
          "type": "property",
          "name": "useDropIndicator",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "props",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorProps"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "ref",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
                  },
                  "typeParameters": [
                    {
                      "type": "union",
                      "elements": [
                        {
                          "type": "identifier",
                          "name": "HTMLElement"
                        },
                        {
                          "type": "null"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorAria"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "renderDropIndicator": {
          "type": "property",
          "name": "renderDropIndicator",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "JSX.Element",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "dropTargetDelegate": {
          "type": "property",
          "name": "dropTargetDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate"
          },
          "optional": true,
          "default": null
        },
        "ListDropTargetDelegate": {
          "type": "property",
          "name": "ListDropTargetDelegate",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionStateOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionStateOptions",
      "name": "DroppableCollectionStateOptions",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager"
          },
          "optional": false,
          "description": "An interface for reading and updating multiple selection state.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the drop events should be disabled.",
          "default": null
        },
        "acceptedDragTypes": {
          "type": "property",
          "name": "acceptedDragTypes",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Array"
                },
                "typeParameters": [
                  {
                    "type": "union",
                    "elements": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "symbol"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The drag types that the droppable collection accepts. If the collection accepts directories, include `DIRECTORY_DRAG_TYPE` in your array of allowed types.",
          "default": "'all'"
        },
        "onInsert": {
          "type": "property",
          "name": "onInsert",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped \"between\" items.",
          "default": null
        },
        "onRootDrop": {
          "type": "property",
          "name": "onRootDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped on the droppable collection's root.",
          "default": null
        },
        "onItemDrop": {
          "type": "property",
          "name": "onItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are dropped \"on\" an item.",
          "default": null
        },
        "onReorder": {
          "type": "property",
          "name": "onReorder",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are reordered within the collection.\nThis handler only allows dropping between items, not on items.\nIt does not allow moving items to a different parent item within a tree.",
          "default": null
        },
        "onMove": {
          "type": "property",
          "name": "onMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are moved within the source collection.\nThis handler allows dropping both on or between items, and items may be\nmoved to a different parent item within a tree.",
          "default": null
        },
        "shouldAcceptItemDrop": {
          "type": "property",
          "name": "shouldAcceptItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning whether a given target in the droppable collection is a valid \"on\" drop target for the current drag types.",
          "default": null
        },
        "onDropEnter": {
          "type": "property",
          "name": "onDropEnter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag enters a drop target.",
          "default": null
        },
        "onDropExit": {
          "type": "property",
          "name": "onDropExit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag exits a drop target.",
          "default": null
        },
        "onDrop": {
          "type": "property",
          "name": "onDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is dropped on a drop target. When defined, this overrides other\ndrop handlers such as `onInsert`, and `onItemDrop`.",
          "default": null
        },
        "getDropOperation": {
          "type": "property",
          "name": "getDropOperation",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "allowedOperations",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent",
      "name": "DroppableCollectionInsertDropEvent",
      "properties": {
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem",
      "name": "DropItem",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:TextDropItem"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:FileDropItem"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DirectoryDropItem"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:TextDropItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:TextDropItem",
      "name": "TextDropItem",
      "properties": {
        "kind": {
          "type": "property",
          "name": "kind",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "text"
          },
          "optional": false,
          "description": "The item kind.",
          "default": null
        },
        "types": {
          "type": "property",
          "name": "types",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "string"
              }
            ]
          },
          "optional": false,
          "description": "The drag types available for this item.\nThese are often mime types, but may be custom app-specific types.",
          "default": null
        },
        "getText": {
          "type": "method",
          "name": "getText",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Promise"
              },
              "typeParameters": [
                {
                  "type": "string"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the data for the given type as a string.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:FileDropItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:FileDropItem",
      "name": "FileDropItem",
      "properties": {
        "kind": {
          "type": "property",
          "name": "kind",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "file"
          },
          "optional": false,
          "description": "The item kind.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The file type (usually a mime type).",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The file name.",
          "default": null
        },
        "getFile": {
          "type": "method",
          "name": "getFile",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Promise"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "File"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the contents of the file as a blob.",
          "default": null
        },
        "getText": {
          "type": "method",
          "name": "getText",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Promise"
              },
              "typeParameters": [
                {
                  "type": "string"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the contents of the file as a string.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DirectoryDropItem": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DirectoryDropItem",
      "name": "DirectoryDropItem",
      "properties": {
        "kind": {
          "type": "property",
          "name": "kind",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "directory"
          },
          "optional": false,
          "description": "The item kind.",
          "default": null
        },
        "name": {
          "type": "property",
          "name": "name",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The directory name.",
          "default": null
        },
        "getEntries": {
          "type": "method",
          "name": "getEntries",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "AsyncIterable"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:FileDropItem"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DirectoryDropItem"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the entries contained within the directory.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget",
      "name": "ItemDropTarget",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "item"
          },
          "optional": false,
          "description": "The drop target type.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": false,
          "description": "The item key.",
          "default": null
        },
        "dropPosition": {
          "type": "property",
          "name": "dropPosition",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropPosition"
          },
          "optional": false,
          "description": "The drop position relative to the item.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropPosition": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropPosition",
      "name": "DropPosition",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "on"
          },
          {
            "type": "string",
            "value": "before"
          },
          {
            "type": "string",
            "value": "after"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent",
      "name": "DroppableCollectionRootDropEvent",
      "properties": {
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent",
      "name": "DroppableCollectionOnItemDropEvent",
      "properties": {
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "isInternal": {
          "type": "property",
          "name": "isInternal",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drag originated within the same collection as the drop.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent",
      "name": "DroppableCollectionReorderEvent",
      "properties": {
        "keys": {
          "type": "property",
          "name": "keys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          },
          "optional": false,
          "description": "The keys of the items that were reordered.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes",
      "name": "DragTypes",
      "properties": {
        "has": {
          "type": "method",
          "name": "has",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "type",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "string"
                    },
                    {
                      "type": "symbol"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the drag contains data of the given type.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent",
      "name": "DroppableCollectionEnterEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropenter"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget",
      "name": "DropTarget",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:RootDropTarget"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:RootDropTarget": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:RootDropTarget",
      "name": "RootDropTarget",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "root"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent",
      "name": "DroppableCollectionExitEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropexit"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent",
      "name": "DroppableCollectionDropEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "drop"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DroppableCollectionState",
      "name": "DroppableCollectionState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionManager"
          },
          "optional": false,
          "description": "An interface for reading and updating multiple selection state.",
          "default": null
        },
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current drop target.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether drop events are disabled.",
          "default": null
        },
        "setTarget": {
          "type": "method",
          "name": "setTarget",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the current drop target.",
          "default": null
        },
        "isDropTarget": {
          "type": "method",
          "name": "isDropTarget",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given target is equivalent to the current drop target.",
          "default": null
        },
        "getDropOperation": {
          "type": "method",
          "name": "getDropOperation",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DropOperationEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "description": "Returns the drop operation for the given parameters.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DropOperationEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/dnd/src/useDroppableCollectionState.ts:DropOperationEvent",
      "name": "DropOperationEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "default": null
        },
        "types": {
          "type": "property",
          "name": "types",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
          },
          "optional": false,
          "default": null
        },
        "allowedOperations": {
          "type": "property",
          "name": "allowedOperations",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            }
          },
          "optional": false,
          "default": null
        },
        "isInternal": {
          "type": "property",
          "name": "isInternal",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "default": null
        },
        "draggingKeys": {
          "type": "property",
          "name": "draggingKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionOptions",
      "name": "DroppableCollectionOptions",
      "properties": {
        "keyboardDelegate": {
          "type": "property",
          "name": "keyboardDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:KeyboardDelegate"
          },
          "optional": false,
          "description": "A delegate object that implements behavior for keyboard focus movement.",
          "default": null
        },
        "dropTargetDelegate": {
          "type": "property",
          "name": "dropTargetDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate"
          },
          "optional": false,
          "description": "A delegate object that provides drop targets for pointer coordinates within the collection.",
          "default": null
        },
        "onKeyDown": {
          "type": "property",
          "name": "onKeyDown",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "identifier",
                  "name": "KeyboardEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A custom keyboard event handler for drop targets.",
          "default": null
        },
        "acceptedDragTypes": {
          "type": "property",
          "name": "acceptedDragTypes",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "all"
              },
              {
                "type": "application",
                "base": {
                  "type": "identifier",
                  "name": "Array"
                },
                "typeParameters": [
                  {
                    "type": "union",
                    "elements": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "symbol"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The drag types that the droppable collection accepts. If the collection accepts directories, include `DIRECTORY_DRAG_TYPE` in your array of allowed types.",
          "default": "'all'"
        },
        "onInsert": {
          "type": "property",
          "name": "onInsert",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionInsertDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped \"between\" items.",
          "default": null
        },
        "onRootDrop": {
          "type": "property",
          "name": "onRootDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionRootDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when external items are dropped on the droppable collection's root.",
          "default": null
        },
        "onItemDrop": {
          "type": "property",
          "name": "onItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionOnItemDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are dropped \"on\" an item.",
          "default": null
        },
        "onReorder": {
          "type": "property",
          "name": "onReorder",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are reordered within the collection.\nThis handler only allows dropping between items, not on items.\nIt does not allow moving items to a different parent item within a tree.",
          "default": null
        },
        "onMove": {
          "type": "property",
          "name": "onMove",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionReorderEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when items are moved within the source collection.\nThis handler allows dropping both on or between items, and items may be\nmoved to a different parent item within a tree.",
          "default": null
        },
        "shouldAcceptItemDrop": {
          "type": "property",
          "name": "shouldAcceptItemDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:ItemDropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning whether a given target in the droppable collection is a valid \"on\" drop target for the current drag types.",
          "default": null
        },
        "onDropEnter": {
          "type": "property",
          "name": "onDropEnter",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionEnterEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag enters a drop target.",
          "default": null
        },
        "onDropActivate": {
          "type": "property",
          "name": "onDropActivate",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionActivateEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called after a valid drag is held over a drop target for a period of time.",
          "default": null
        },
        "onDropExit": {
          "type": "property",
          "name": "onDropExit",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionExitEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag exits a drop target.",
          "default": null
        },
        "onDrop": {
          "type": "property",
          "name": "onDrop",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionDropEvent"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when a valid drag is dropped on a drop target. When defined, this overrides other\ndrop handlers such as `onInsert`, and `onItemDrop`.",
          "default": null
        },
        "getDropOperation": {
          "type": "property",
          "name": "getDropOperation",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "target",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "types",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DragTypes"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "allowedOperations",
                "value": {
                  "type": "array",
                  "elementType": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "A function returning the drop operation to be performed when items matching the given types are dropped\non the drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:KeyboardDelegate": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:KeyboardDelegate",
      "name": "KeyboardDelegate",
      "properties": {
        "getKeyBelow": {
          "type": "method",
          "name": "getKeyBelow",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually below the given one, or `null` for none.",
          "default": null
        },
        "getKeyAbove": {
          "type": "method",
          "name": "getKeyAbove",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually above the given one, or `null` for none.",
          "default": null
        },
        "getKeyLeftOf": {
          "type": "method",
          "name": "getKeyLeftOf",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually to the left of the given one, or `null` for none.",
          "default": null
        },
        "getKeyRightOf": {
          "type": "method",
          "name": "getKeyRightOf",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually to the right of the given one, or `null` for none.",
          "default": null
        },
        "getKeyPageBelow": {
          "type": "method",
          "name": "getKeyPageBelow",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually one page below the given one, or `null` for none.",
          "default": null
        },
        "getKeyPageAbove": {
          "type": "method",
          "name": "getKeyPageAbove",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the key visually one page above the given one, or `null` for none.",
          "default": null
        },
        "getFirstKey": {
          "type": "method",
          "name": "getFirstKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "global",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the first key, or `null` for none.",
          "default": null
        },
        "getLastKey": {
          "type": "method",
          "name": "getLastKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "global",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the last key, or `null` for none.",
          "default": null
        },
        "getKeyForSearch": {
          "type": "method",
          "name": "getKeyForSearch",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "search",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "fromKey",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "Key"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns the next key after `fromKey` that matches the given search string, or `null` for none.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTargetDelegate",
      "name": "DropTargetDelegate",
      "properties": {
        "getDropTargetFromPoint": {
          "type": "method",
          "name": "getDropTargetFromPoint",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "x",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "y",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "isValidDropTarget",
                "value": {
                  "type": "function",
                  "parameters": [
                    {
                      "type": "parameter",
                      "name": "target",
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                      },
                      "rest": false
                    }
                  ],
                  "return": {
                    "type": "boolean"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns a drop target within a collection for the given x and y coordinates.\nThe point is provided relative to the top left corner of the collection container.\nA drop target can be checked to see if it is valid using the provided `isValidDropTarget` function.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionActivateEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DroppableCollectionActivateEvent",
      "name": "DroppableCollectionActivateEvent",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target.",
          "default": null
        },
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropactivate"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableCollection.ts:DroppableCollectionResult",
      "name": "DroppableCollectionResult",
      "properties": {
        "collectionProps": {
          "type": "property",
          "name": "collectionProps",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "HTMLAttributes"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          },
          "optional": false,
          "description": "Props for the collection element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemOptions",
      "name": "DroppableItemOptions",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target represented by the item.",
          "default": null
        },
        "activateButtonRef": {
          "type": "property",
          "name": "activateButtonRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref to the activate button.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDroppableItem.ts:DroppableItemResult",
      "name": "DroppableItemResult",
      "properties": {
        "dropProps": {
          "type": "property",
          "name": "dropProps",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "HTMLAttributes"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          },
          "optional": false,
          "description": "Props for the droppable element.",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently the active drop target.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorProps",
      "name": "DropIndicatorProps",
      "properties": {
        "target": {
          "type": "property",
          "name": "target",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropTarget"
          },
          "optional": false,
          "description": "The drop target that the drop indicator represents.",
          "default": null
        },
        "activateButtonRef": {
          "type": "property",
          "name": "activateButtonRef",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/refs.d.ts:RefObject"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dom.d.ts:FocusableElement"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            ]
          },
          "optional": true,
          "description": "The ref to the activate button.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorAria": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-aria/dnd/src/useDropIndicator.ts:DropIndicatorAria",
      "name": "DropIndicatorAria",
      "properties": {
        "dropIndicatorProps": {
          "type": "property",
          "name": "dropIndicatorProps",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "HTMLAttributes"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "HTMLElement"
              }
            ]
          },
          "optional": false,
          "description": "Props for the drop indicator element.",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drop indicator is currently the active drop target.",
          "default": null
        },
        "isHidden": {
          "type": "property",
          "name": "isHidden",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the drop indicator is hidden, both visually and from assistive technology.\nUse this to determine whether to omit the element from the DOM entirely.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/GridList.tsx:GridListRenderProps",
      "name": "GridListRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the list has no items and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the grid list is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the grid list is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the grid list is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        },
        "layout": {
          "type": "property",
          "name": "layout",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "stack"
              },
              {
                "type": "string",
                "value": "grid"
              }
            ]
          },
          "optional": false,
          "description": "Whether the items are arranged in a stack or grid.",
          "selector": "[data-layout=\"stack | grid\"]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the grid list.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/list/src/useListState.ts:ListState",
      "name": "ListState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the list.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of items that are disabled.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager",
      "name": "SelectionManager",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "unknown"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionState"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "allowsCellSelection": {
          "type": "property",
          "name": "allowsCellSelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "_isSelectAll": {
          "type": "property",
          "name": "_isSelectAll",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "layoutDelegate": {
          "type": "property",
          "name": "layoutDelegate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LayoutDelegate"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "collection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
                  },
                  "typeParameters": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                      },
                      "typeParameters": [
                        {
                          "type": "unknown"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "state",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionState"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManagerOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "setSelectionBehavior": {
          "type": "method",
          "name": "setSelectionBehavior",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selectionBehavior",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selection behavior for the collection.",
          "default": null,
          "static": false
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "description": "Whether the collection is currently focused.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the collection is focused.",
          "default": null,
          "static": false
        },
        "focusedKey": {
          "type": "property",
          "name": "focusedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "description": "The current focused key in the collection.",
          "default": null
        },
        "childFocusStrategy": {
          "type": "property",
          "name": "childFocusStrategy",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              },
              {
                "type": "null"
              }
            ]
          },
          "description": "Whether the first or last child of the focused key should receive focus.",
          "default": null
        },
        "setFocusedKey": {
          "type": "method",
          "name": "setFocusedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "childFocusStrategy",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused key.",
          "default": null,
          "static": false
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "description": "The currently selected keys in the collection.",
          "default": null
        },
        "rawSelection": {
          "type": "property",
          "name": "rawSelection",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
          },
          "description": "The raw selection value for the collection.\nEither 'all' for select all, or a set of keys.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether a key is selected.",
          "default": null,
          "static": false
        },
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "description": "Whether the selection is empty.",
          "default": null
        },
        "isSelectAll": {
          "type": "property",
          "name": "isSelectAll",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "description": "Whether all items in the collection are selected.",
          "default": null
        },
        "firstSelectedKey": {
          "type": "property",
          "name": "firstSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "default": null
        },
        "lastSelectedKey": {
          "type": "property",
          "name": "lastSelectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "default": null
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "default": null
        },
        "extendSelection": {
          "type": "method",
          "name": "extendSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "toKey",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Extends the selection to the given key.",
          "default": null,
          "static": false
        },
        "getKeyRange": {
          "type": "method",
          "name": "getKeyRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "from",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "to",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getKeyRangeInternal": {
          "type": "method",
          "name": "getKeyRangeInternal",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "from",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "to",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "getKey": {
          "type": "method",
          "name": "getKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "toggleSelection": {
          "type": "method",
          "name": "toggleSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles whether the given key is selected.",
          "default": null,
          "static": false
        },
        "replaceSelection": {
          "type": "method",
          "name": "replaceSelection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the selection with only the given key.",
          "default": null,
          "static": false
        },
        "setSelectedKeys": {
          "type": "method",
          "name": "setSelectedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Iterable"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the selection with the given keys.",
          "default": null,
          "static": false
        },
        "getSelectAllKeys": {
          "type": "method",
          "name": "getSelectAllKeys",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "access": "private",
          "default": null,
          "static": false
        },
        "selectAll": {
          "type": "method",
          "name": "selectAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects all items in the collection.",
          "default": null,
          "static": false
        },
        "clearSelection": {
          "type": "method",
          "name": "clearSelection",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Removes all keys from the selection.",
          "default": null,
          "static": false
        },
        "toggleSelectAll": {
          "type": "method",
          "name": "toggleSelectAll",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles between select all and an empty selection.",
          "default": null,
          "static": false
        },
        "select": {
          "type": "method",
          "name": "select",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "e",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:PressEvent"
                    },
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/events.d.ts:LongPressEvent"
                    },
                    {
                      "type": "identifier",
                      "name": "PointerEvent"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "isSelectionEqual": {
          "type": "method",
          "name": "isSelectionEqual",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the current selection is equal to the given selection.",
          "default": null,
          "static": false
        },
        "canSelectItem": {
          "type": "method",
          "name": "canSelectItem",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "isDisabled": {
          "type": "method",
          "name": "isDisabled",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "isLink": {
          "type": "method",
          "name": "isLink",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "getItemProps": {
          "type": "method",
          "name": "getItemProps",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "id": null,
              "name": null,
              "type": "any",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "withCollection": {
          "type": "method",
          "name": "withCollection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "collection",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
                  },
                  "typeParameters": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                      },
                      "typeParameters": [
                        {
                          "type": "unknown"
                        }
                      ]
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "An interface for reading and updating multiple selection state."
    },
    "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/types.ts:MultipleSelectionState",
      "name": "MultipleSelectionState",
      "properties": {
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "default": null
        },
        "selectionBehavior": {
          "type": "property",
          "name": "selectionBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
          },
          "optional": false,
          "description": "The selection behavior for the collection.",
          "default": null
        },
        "setSelectionBehavior": {
          "type": "method",
          "name": "setSelectionBehavior",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "selectionBehavior",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionBehavior"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selection behavior for the collection.",
          "default": null
        },
        "disallowEmptySelection": {
          "type": "property",
          "name": "disallowEmptySelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the collection allows empty selection.",
          "default": null
        },
        "selectedKeys": {
          "type": "property",
          "name": "selectedKeys",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
          },
          "optional": false,
          "description": "The currently selected keys in the collection.",
          "default": null
        },
        "setSelectedKeys": {
          "type": "method",
          "name": "setSelectedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the selected keys in the collection.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "The currently disabled keys in the collection.",
          "default": null
        },
        "disabledBehavior": {
          "type": "property",
          "name": "disabledBehavior",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:DisabledBehavior"
          },
          "optional": false,
          "description": "Whether `disabledKeys` applies to selection, actions, or both.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the collection is currently focused.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isFocused",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the collection is focused.",
          "default": null
        },
        "focusedKey": {
          "type": "property",
          "name": "focusedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current focused key in the collection.",
          "default": null
        },
        "childFocusStrategy": {
          "type": "property",
          "name": "childFocusStrategy",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "Whether the first or last child of the focused key should receive focus.",
          "default": null
        },
        "setFocusedKey": {
          "type": "method",
          "name": "setFocusedKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "child",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:FocusStrategy"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused key, and optionally, whether the first or last child of that key should receive focus.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:Selection",
      "name": "Selection",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "all"
          },
          {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "Key"
              }
            ]
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LayoutDelegate": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LayoutDelegate",
      "name": "LayoutDelegate",
      "properties": {
        "getItemRect": {
          "type": "method",
          "name": "getItemRect",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Rect"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns a rectangle for the item with the given key.",
          "default": null
        },
        "getVisibleRect": {
          "type": "method",
          "name": "getVisibleRect",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Rect"
            },
            "typeParameters": []
          },
          "description": "Returns the visible rectangle of the collection.",
          "default": null
        },
        "getContentSize": {
          "type": "method",
          "name": "getContentSize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Size"
            },
            "typeParameters": []
          },
          "description": "Returns the size of the scrollable content in the collection.",
          "default": null
        },
        "getKeyRange": {
          "type": "method",
          "name": "getKeyRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "from",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "to",
                "value": {
                  "type": "identifier",
                  "name": "Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "array",
              "elementType": {
                "type": "identifier",
                "name": "Key"
              }
            },
            "typeParameters": []
          },
          "description": "Returns a list of keys between `from` and `to`.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A LayoutDelegate provides layout information for collection items."
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Rect": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Rect",
      "name": "Rect",
      "properties": {
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "height": {
          "type": "property",
          "name": "height",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Size": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Size",
      "name": "Size",
      "properties": {
        "width": {
          "type": "property",
          "name": "width",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        },
        "height": {
          "type": "property",
          "name": "height",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManagerOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManagerOptions",
      "name": "SelectionManagerOptions",
      "properties": {
        "allowsCellSelection": {
          "type": "property",
          "name": "allowsCellSelection",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "default": null
        },
        "layoutDelegate": {
          "type": "property",
          "name": "layoutDelegate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:LayoutDelegate"
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError",
      "name": "ValidationError",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string"
          },
          {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/orientation.d.ts:Orientation",
      "name": "Orientation",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "horizontal"
          },
          {
            "type": "string",
            "value": "vertical"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:LabelPosition",
      "name": "LabelPosition",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "top"
          },
          {
            "type": "string",
            "value": "side"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:Alignment",
      "name": "Alignment",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "start"
          },
          {
            "type": "string",
            "value": "end"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/labelable.d.ts:NecessityIndicator",
      "name": "NecessityIndicator",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "icon"
          },
          {
            "type": "string",
            "value": "label"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationResult",
      "name": "ValidationResult",
      "properties": {
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the input value is invalid.",
          "default": null
        },
        "validationErrors": {
          "type": "property",
          "name": "validationErrors",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "string"
            }
          },
          "optional": false,
          "description": "The current error messages for the input if it is invalid, otherwise an empty array.",
          "default": null
        },
        "validationDetails": {
          "type": "property",
          "name": "validationDetails",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "ValidityState"
          },
          "optional": false,
          "description": "The native validation details for the input.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace",
      "name": "ColorSpace",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "rgb"
          },
          {
            "type": "string",
            "value": "hsl"
          },
          {
            "type": "string",
            "value": "hsb"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel",
      "name": "ColorChannel",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "hue"
          },
          {
            "type": "string",
            "value": "saturation"
          },
          {
            "type": "string",
            "value": "brightness"
          },
          {
            "type": "string",
            "value": "lightness"
          },
          {
            "type": "string",
            "value": "red"
          },
          {
            "type": "string",
            "value": "green"
          },
          {
            "type": "string",
            "value": "blue"
          },
          {
            "type": "string",
            "value": "alpha"
          }
        ]
      },
      "typeParameters": [],
      "description": "A list of color channels."
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color",
      "name": "Color",
      "properties": {
        "toFormat": {
          "type": "method",
          "name": "toFormat",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "format",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Converts the color to the given color format, and returns a new Color object.",
          "default": null
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "format",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat"
                    },
                    {
                      "type": "string",
                      "value": "css"
                    }
                  ]
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the color to a string in the given format.",
          "default": null
        },
        "clone": {
          "type": "method",
          "name": "clone",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Returns a duplicate of the color value.",
          "default": null
        },
        "toHexInt": {
          "type": "method",
          "name": "toHexInt",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the color to hex, and returns an integer representation.",
          "default": null
        },
        "getChannelValue": {
          "type": "method",
          "name": "getChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the numeric value for a given channel.\nThrows an error if the channel is unsupported in the current color format.",
          "default": null
        },
        "withChannelValue": {
          "type": "method",
          "name": "withChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:Color"
            },
            "typeParameters": []
          },
          "description": "Sets the numeric value for a given channel, and returns a new Color object.\nThrows an error if the channel is unsupported in the current color format.",
          "default": null
        },
        "getChannelRange": {
          "type": "method",
          "name": "getChannelRange",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannelRange"
            },
            "typeParameters": []
          },
          "description": "Returns the minimum, maximum, and step values for a given channel.",
          "default": null
        },
        "getChannelName": {
          "type": "method",
          "name": "getChannelName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized color channel name for a given channel and locale,\nfor use in visual or accessibility labels.",
          "default": null
        },
        "getChannelFormatOptions": {
          "type": "method",
          "name": "getChannelFormatOptions",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "Intl.NumberFormatOptions",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns the number formatting options for the given channel.",
          "default": null
        },
        "formatChannelValue": {
          "type": "method",
          "name": "formatChannelValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "channel",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Formats the numeric value for a given channel for display according to the provided locale.",
          "default": null
        },
        "getColorSpace": {
          "type": "method",
          "name": "getColorSpace",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorSpace"
            },
            "typeParameters": []
          },
          "description": "Returns the color space, 'rgb', 'hsb' or 'hsl', for the current color.",
          "default": null
        },
        "getColorSpaceAxes": {
          "type": "method",
          "name": "getColorSpaceAxes",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "xyChannels",
                "value": {
                  "type": "object",
                  "properties": {
                    "xChannel": {
                      "type": "property",
                      "name": "xChannel",
                      "indexType": null,
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                      },
                      "optional": true,
                      "default": null
                    },
                    "yChannel": {
                      "type": "property",
                      "name": "yChannel",
                      "indexType": null,
                      "value": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                      },
                      "optional": true,
                      "default": null
                    }
                  }
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorAxes"
            },
            "typeParameters": []
          },
          "description": "Returns the color space axes, xChannel, yChannel, zChannel.",
          "default": null
        },
        "getColorChannels": {
          "type": "method",
          "name": "getColorChannels",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "tuple",
              "elements": [
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                },
                {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns an array of the color channels within the current color space space.",
          "default": null
        },
        "getColorName": {
          "type": "method",
          "name": "getColorName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized name for the color, for use in visual or accessibility labels.",
          "default": null
        },
        "getHueName": {
          "type": "method",
          "name": "getHueName",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "locale",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns a localized name for the hue, for use in visual or accessibility labels.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "Represents a color value."
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorFormat",
      "name": "ColorFormat",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "hex"
          },
          {
            "type": "string",
            "value": "hexa"
          },
          {
            "type": "string",
            "value": "rgb"
          },
          {
            "type": "string",
            "value": "rgba"
          },
          {
            "type": "string",
            "value": "hsl"
          },
          {
            "type": "string",
            "value": "hsla"
          },
          {
            "type": "string",
            "value": "hsb"
          },
          {
            "type": "string",
            "value": "hsba"
          }
        ]
      },
      "typeParameters": [],
      "description": "A list of supported color formats."
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannelRange": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannelRange",
      "name": "ColorChannelRange",
      "properties": {
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The minimum value of the color channel.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The maximum value of the color channel.",
          "default": null
        },
        "step": {
          "type": "property",
          "name": "step",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The step value of the color channel, used when incrementing and decrementing.",
          "default": null
        },
        "pageSize": {
          "type": "property",
          "name": "pageSize",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The page step value of the color channel, used when incrementing and decrementing.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorAxes": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorAxes",
      "name": "ColorAxes",
      "value": {
        "type": "object",
        "properties": {
          "xChannel": {
            "type": "property",
            "name": "xChannel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": false,
            "default": null
          },
          "yChannel": {
            "type": "property",
            "name": "yChannel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": false,
            "default": null
          },
          "zChannel": {
            "type": "property",
            "name": "zChannel",
            "indexType": null,
            "value": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/color/src/index.d.ts:ColorChannel"
            },
            "optional": false,
            "default": null
          }
        }
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/textfield/src/index.d.ts:TextFieldRef": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/textfield/src/index.d.ts:TextFieldRef",
      "name": "TextFieldRef",
      "properties": {
        "select": {
          "type": "method",
          "name": "select",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null
        },
        "getInputElement": {
          "type": "method",
          "name": "getInputElement",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "identifier",
                      "name": "HTMLInputElement"
                    },
                    {
                      "type": "identifier",
                      "name": "HTMLTextAreaElement"
                    }
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null
        },
        "focus": {
          "type": "method",
          "name": "focus",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null
        },
        "UNSAFE_getDOMNode": {
          "type": "method",
          "name": "UNSAFE_getDOMNode",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "HTMLElement"
                },
                {
                  "type": "null"
                }
              ]
            },
            "typeParameters": []
          },
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": {
            "type": "union",
            "elements": [
              {
                "type": "identifier",
                "name": "HTMLInputElement"
              },
              {
                "type": "identifier",
                "name": "HTMLTextAreaElement"
              }
            ]
          },
          "default": {
            "type": "identifier",
            "name": "HTMLInputElement"
          }
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:MenuTriggerAction",
      "name": "MenuTriggerAction",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "focus"
          },
          {
            "type": "string",
            "value": "input"
          },
          {
            "type": "string",
            "value": "manual"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:ComboBoxValidationValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/combobox/src/index.d.ts:ComboBoxValidationValue",
      "name": "ComboBoxValidationValue",
      "properties": {
        "selectedKey": {
          "type": "property",
          "name": "selectedKey",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The selected key in the ComboBox.",
          "default": null
        },
        "inputValue": {
          "type": "property",
          "name": "inputValue",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The value of the ComboBox input.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Placement",
      "name": "Placement",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "bottom"
          },
          {
            "type": "string",
            "value": "bottom left"
          },
          {
            "type": "string",
            "value": "bottom right"
          },
          {
            "type": "string",
            "value": "bottom start"
          },
          {
            "type": "string",
            "value": "bottom end"
          },
          {
            "type": "string",
            "value": "top"
          },
          {
            "type": "string",
            "value": "top left"
          },
          {
            "type": "string",
            "value": "top right"
          },
          {
            "type": "string",
            "value": "top start"
          },
          {
            "type": "string",
            "value": "top end"
          },
          {
            "type": "string",
            "value": "left"
          },
          {
            "type": "string",
            "value": "left top"
          },
          {
            "type": "string",
            "value": "left bottom"
          },
          {
            "type": "string",
            "value": "start"
          },
          {
            "type": "string",
            "value": "start top"
          },
          {
            "type": "string",
            "value": "start bottom"
          },
          {
            "type": "string",
            "value": "right"
          },
          {
            "type": "string",
            "value": "right top"
          },
          {
            "type": "string",
            "value": "right bottom"
          },
          {
            "type": "string",
            "value": "end"
          },
          {
            "type": "string",
            "value": "end top"
          },
          {
            "type": "string",
            "value": "end bottom"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:Granularity",
      "name": "Granularity",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "day"
          },
          {
            "type": "string",
            "value": "hour"
          },
          {
            "type": "string",
            "value": "minute"
          },
          {
            "type": "string",
            "value": "second"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedDateValue",
      "name": "MappedDateValue",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
        },
        "extendsType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "trueType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "falseType": {
          "type": "conditional",
          "checkType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
          },
          "extendsType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "trueType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "falseType": {
            "type": "conditional",
            "checkType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:DateValue"
            },
            "extendsType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "trueType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
            },
            "falseType": {
              "type": "never"
            }
          }
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Dialog.tsx:DialogRenderProps",
      "name": "DialogRenderProps",
      "properties": {
        "close": {
          "type": "property",
          "name": "close",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogContainer.tsx:DialogContainerValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/DialogContainer.tsx:DialogContainerValue",
      "name": "DialogContainerValue",
      "properties": {
        "dismiss": {
          "type": "method",
          "name": "dismiss",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "A handler to programmatically dismiss the dialog.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEnterEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEnterEvent",
      "name": "DropEnterEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropenter"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropMoveEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropMoveEvent",
      "name": "DropMoveEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropmove"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropActivateEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropActivateEvent",
      "name": "DropActivateEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropactivate"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropExitEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropExitEvent",
      "name": "DropExitEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "dropexit"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEvent": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropEvent",
      "name": "DropEvent",
      "properties": {
        "type": {
          "type": "property",
          "name": "type",
          "indexType": null,
          "value": {
            "type": "string",
            "value": "drop"
          },
          "optional": false,
          "description": "The event type.",
          "default": null
        },
        "dropOperation": {
          "type": "property",
          "name": "dropOperation",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropOperation"
          },
          "optional": false,
          "description": "The drop operation that should occur.",
          "default": null
        },
        "items": {
          "type": "property",
          "name": "items",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/dnd.d.ts:DropItem"
            }
          },
          "optional": false,
          "description": "The dropped items.",
          "default": null
        },
        "x": {
          "type": "property",
          "name": "x",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The x coordinate of the event, relative to the target element.",
          "default": null
        },
        "y": {
          "type": "property",
          "name": "y",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The y coordinate of the event, relative to the target element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationErrors": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationErrors",
      "name": "ValidationErrors",
      "value": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Record"
        },
        "typeParameters": [
          {
            "type": "string"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationError"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ContextValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ContextValue",
      "name": "ContextValue",
      "value": {
        "type": "application",
        "base": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedContextValue"
        },
        "typeParameters": [
          {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:WithRef"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              },
              {
                "type": "identifier",
                "name": "E"
              }
            ]
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "E",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedContextValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedContextValue",
      "name": "SlottedContextValue",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedValue"
            },
            "typeParameters": [
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          {
            "type": "identifier",
            "name": "T"
          },
          {
            "type": "null"
          },
          {
            "type": "undefined"
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:SlottedValue",
      "name": "SlottedValue",
      "properties": {
        "slots": {
          "type": "property",
          "name": "slots",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Record"
            },
            "typeParameters": [
              {
                "type": "union",
                "elements": [
                  {
                    "type": "string"
                  },
                  {
                    "type": "symbol"
                  }
                ]
              },
              {
                "type": "identifier",
                "name": "T"
              }
            ]
          },
          "optional": true,
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:WithRef": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:WithRef",
      "name": "WithRef",
      "value": {
        "type": "intersection",
        "types": [
          {
            "type": "identifier",
            "name": "T"
          },
          {
            "type": "object",
            "properties": {
              "ref": {
                "type": "property",
                "name": "ref",
                "indexType": null,
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "ForwardedRef"
                  },
                  "typeParameters": [
                    {
                      "type": "identifier",
                      "name": "E"
                    }
                  ]
                },
                "optional": true,
                "default": null
              }
            }
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        },
        {
          "type": "typeParameter",
          "name": "E",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IconContextValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IconContextValue",
      "name": "IconContextValue",
      "properties": {
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
          },
          "optional": true,
          "default": null
        },
        "render": {
          "type": "property",
          "name": "render",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "icon",
                "value": {
                  "type": "identifier",
                  "name": "ReactNode"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": true,
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IconProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IconProps",
      "name": "IconProps",
      "properties": {
        "aria-hidden": {
          "type": "property",
          "name": "aria-hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "true"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:AllowedOverrides"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:AllowedOverrides": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:AllowedOverrides",
      "name": "AllowedOverrides",
      "value": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Exclude"
        },
        "typeParameters": [
          {
            "type": "indexedAccess",
            "objectType": {
              "type": "any"
            },
            "indexType": {
              "type": "number"
            }
          },
          {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "--iconPrimary"
              },
              {
                "type": "string",
                "value": "size"
              }
            ]
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IllustrationProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:IllustrationProps",
      "name": "IllustrationProps",
      "properties": {
        "aria-hidden": {
          "type": "property",
          "name": "aria-hidden",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "boolean"
              },
              {
                "type": "string",
                "value": "false"
              },
              {
                "type": "string",
                "value": "true"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "size": {
          "type": "property",
          "name": "size",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string",
                "value": "S"
              },
              {
                "type": "string",
                "value": "M"
              },
              {
                "type": "string",
                "value": "L"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "styles": {
          "type": "property",
          "name": "styles",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/style/types.ts:StyleString"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Icon.tsx:AllowedOverrides"
              }
            ]
          },
          "optional": true,
          "default": null
        },
        "UNSAFE_className": {
          "type": "property",
          "name": "UNSAFE_className",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/style-utils.ts:UnsafeClassName"
          },
          "optional": true,
          "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "UNSAFE_style": {
          "type": "property",
          "name": "UNSAFE_style",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "CSSProperties"
          },
          "optional": true,
          "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
          "default": null
        },
        "slot": {
          "type": "property",
          "name": "slot",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "A slot name for the component. Slots allow the component to receive props from a parent component.\nAn explicit `null` value indicates that the local props completely override all props received from a parent.",
          "default": null
        },
        "aria-label": {
          "type": "property",
          "name": "aria-label",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Defines a string value that labels the current element.",
          "default": null
        },
        "aria-labelledby": {
          "type": "property",
          "name": "aria-labelledby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that labels the current element.",
          "default": null
        },
        "aria-describedby": {
          "type": "property",
          "name": "aria-describedby",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that describes the object.",
          "default": null
        },
        "aria-details": {
          "type": "property",
          "name": "aria-details",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "Identifies the element (or elements) that provide a detailed, extended description for the object.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageGroup": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageGroup",
      "name": "ImageGroup",
      "value": {
        "type": "application",
        "base": {
          "type": "identifier",
          "name": "Context"
        },
        "typeParameters": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageGroupValue"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageGroupValue": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/ImageCoordinator.tsx:ImageGroupValue",
      "name": "ImageGroupValue",
      "properties": {
        "revealAll": {
          "type": "property",
          "name": "revealAll",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "default": null
        },
        "register": {
          "type": "method",
          "name": "register",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "url",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null
        },
        "unregister": {
          "type": "method",
          "name": "unregister",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "url",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null
        },
        "load": {
          "type": "method",
          "name": "load",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "url",
                "value": {
                  "type": "string"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/menu/src/index.d.ts:MenuTriggerType": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/menu/src/index.d.ts:MenuTriggerType",
      "name": "MenuTriggerType",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "press"
          },
          {
            "type": "string",
            "value": "longPress"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode",
      "name": "SelectionMode",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "single"
          },
          {
            "type": "string",
            "value": "multiple"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValueType",
      "name": "ValueType",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
        },
        "extendsType": {
          "type": "string",
          "value": "single"
        },
        "trueType": {
          "type": "union",
          "elements": [
            {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
            },
            {
              "type": "null"
            }
          ]
        },
        "falseType": {
          "type": "array",
          "elementType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          }
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "M",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
          },
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValidationType": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:ValidationType",
      "name": "ValidationType",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
        },
        "extendsType": {
          "type": "string",
          "value": "single"
        },
        "trueType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
        },
        "falseType": {
          "type": "array",
          "elementType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          }
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "M",
          "constraint": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/select/src/index.d.ts:SelectionMode"
          },
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:SelectionMode": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Picker.tsx:SelectionMode",
      "name": "SelectionMode",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "single"
          },
          {
            "type": "string",
            "value": "multiple"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/provider/src/index.d.ts:ColorScheme": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/provider/src/index.d.ts:ColorScheme",
      "name": "ColorScheme",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "light"
          },
          {
            "type": "string",
            "value": "dark"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Calendar.tsx:RangeCalendarRenderProps",
      "name": "RangeCalendarRenderProps",
      "properties": {
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:RangeCalendarState"
          },
          "optional": false,
          "description": "State of the range calendar.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "selector": "[data-disabled]",
          "default": null
        },
        "isInvalid": {
          "type": "property",
          "name": "isInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "selector": "[data-invalid]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:RangeCalendarState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/calendar/src/types.ts:RangeCalendarState",
      "name": "RangeCalendarState",
      "properties": {
        "value": {
          "type": "property",
          "name": "value",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently selected date range.",
          "default": null
        },
        "setValue": {
          "type": "method",
          "name": "setValue",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "application",
                      "base": {
                        "type": "link",
                        "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                      },
                      "typeParameters": [
                        {
                          "type": "link",
                          "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
                        }
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the currently selected date range.",
          "default": null
        },
        "highlightDate": {
          "type": "method",
          "name": "highlightDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Highlights the given date during selection, e.g. by hovering or dragging.",
          "default": null
        },
        "anchorDate": {
          "type": "property",
          "name": "anchorDate",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current anchor date that the user clicked on to begin range selection.",
          "default": null
        },
        "setAnchorDate": {
          "type": "method",
          "name": "setAnchorDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the anchor date that the user clicked on to begin range selection.",
          "default": null
        },
        "highlightedRange": {
          "type": "property",
          "name": "highlightedRange",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
                },
                "typeParameters": [
                  {
                    "type": "link",
                    "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                  }
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The currently highlighted date range.",
          "default": null
        },
        "isDragging": {
          "type": "property",
          "name": "isDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the user is currently dragging over the calendar.",
          "default": null
        },
        "setDragging": {
          "type": "method",
          "name": "setDragging",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "isDragging",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether the user is dragging over the calendar.",
          "default": null
        },
        "isDisabled": {
          "type": "property",
          "name": "isDisabled",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is disabled.",
          "default": null
        },
        "isReadOnly": {
          "type": "property",
          "name": "isReadOnly",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is in a read only state.",
          "default": null
        },
        "visibleRange": {
          "type": "property",
          "name": "visibleRange",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:RangeValue"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
              }
            ]
          },
          "optional": false,
          "description": "The date range that is currently visible in the calendar.",
          "default": null
        },
        "minValue": {
          "type": "property",
          "name": "minValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The minimum allowed date that a user may select.",
          "default": null
        },
        "maxValue": {
          "type": "property",
          "name": "maxValue",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/calendar/src/index.d.ts:DateValue"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": true,
          "description": "The maximum allowed date that a user may select.",
          "default": null
        },
        "timeZone": {
          "type": "property",
          "name": "timeZone",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "The time zone of the dates currently being displayed.",
          "default": null
        },
        "validationState": {
          "type": "property",
          "name": "validationState",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/inputs.d.ts:ValidationState"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The current validation state of the selected value.",
          "access": "private",
          "default": null
        },
        "isValueInvalid": {
          "type": "property",
          "name": "isValueInvalid",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the calendar is invalid.",
          "default": null
        },
        "focusedDate": {
          "type": "property",
          "name": "focusedDate",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
          },
          "optional": false,
          "description": "The currently focused date.",
          "default": null
        },
        "setFocusedDate": {
          "type": "method",
          "name": "setFocusedDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets the focused date.",
          "default": null
        },
        "focusNextDay": {
          "type": "method",
          "name": "focusNextDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next calendar date.",
          "default": null
        },
        "focusPreviousDay": {
          "type": "method",
          "name": "focusPreviousDay",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous calendar date.",
          "default": null
        },
        "focusNextRow": {
          "type": "method",
          "name": "focusNextRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next row of dates, e.g. the next week.",
          "default": null
        },
        "focusPreviousRow": {
          "type": "method",
          "name": "focusPreviousRow",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous row of dates, e.g. the previous work.",
          "default": null
        },
        "focusNextPage": {
          "type": "method",
          "name": "focusNextPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next page of dates, e.g. the next month if one month is visible.",
          "default": null
        },
        "focusPreviousPage": {
          "type": "method",
          "name": "focusPreviousPage",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous page of dates, e.g. the previous month if one month is visible.",
          "default": null
        },
        "focusSectionStart": {
          "type": "method",
          "name": "focusSectionStart",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the start of the current section of dates, e.g. the start of the current month.",
          "default": null
        },
        "focusSectionEnd": {
          "type": "method",
          "name": "focusSectionEnd",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the end of the current section of dates, e.g. the end of the current month month.",
          "default": null
        },
        "focusNextSection": {
          "type": "method",
          "name": "focusNextSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the next section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved forward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the next year.",
          "default": null
        },
        "focusPreviousSection": {
          "type": "method",
          "name": "focusPreviousSection",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "larger",
                "value": {
                  "type": "boolean"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Moves focus to the previous section of dates based on what is currently displayed.\nBy default, focus is moved by one of the currently displayed unit. For example, if\none or more months are displayed, then focus is moved backward by one month.\nIf the `larger` option is `true`, the focus is moved by the next larger unit than\nthe one displayed. For example, if months are displayed, then focus moves to the previous year.",
          "default": null
        },
        "selectFocusedDate": {
          "type": "method",
          "name": "selectFocusedDate",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the currently focused date.",
          "default": null
        },
        "selectDate": {
          "type": "method",
          "name": "selectDate",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Selects the given date.",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether focus is currently within the calendar.",
          "default": null
        },
        "setFocused": {
          "type": "method",
          "name": "setFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "value",
                "value": {
                  "type": "boolean"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Sets whether focus is currently within the calendar.",
          "default": null
        },
        "isInvalid": {
          "type": "method",
          "name": "isInvalid",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is invalid according to the `minValue` and `maxValue` props.",
          "default": null
        },
        "isSelected": {
          "type": "method",
          "name": "isSelected",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently selected.",
          "default": null
        },
        "isCellFocused": {
          "type": "method",
          "name": "isCellFocused",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is currently focused.",
          "default": null
        },
        "isCellDisabled": {
          "type": "method",
          "name": "isCellDisabled",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is disabled according to the `minValue, `maxValue`, and `isDisabled` props.",
          "default": null
        },
        "isCellUnavailable": {
          "type": "method",
          "name": "isCellUnavailable",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "date",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the given date is unavailable according to the `isDateUnavailable` prop.",
          "default": null
        },
        "isPreviousVisibleRangeInvalid": {
          "type": "method",
          "name": "isPreviousVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the previous visible date range is allowed to be selected according to the `minValue` prop.",
          "default": null
        },
        "isNextVisibleRangeInvalid": {
          "type": "method",
          "name": "isNextVisibleRangeInvalid",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "boolean",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Returns whether the next visible date range is allowed to be selected according to the `maxValue` prop.",
          "default": null
        },
        "getDatesInWeek": {
          "type": "method",
          "name": "getDatesInWeek",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "weekIndex",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "startDate",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "application",
              "base": {
                "type": "identifier",
                "name": "Array"
              },
              "typeParameters": [
                {
                  "type": "union",
                  "elements": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDate"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              ]
            },
            "typeParameters": []
          },
          "description": "Returns an array of dates in the week index counted from the provided start date, or the first visible date if not given.\nThe returned array always has 7 elements, but may include null if the date does not exist according to the calendar system.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SkeletonCollection.tsx:SkeletonCollectionProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/SkeletonCollection.tsx:SkeletonCollectionProps",
      "name": "SkeletonCollectionProps",
      "properties": {
        "children": {
          "type": "property",
          "name": "children",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "identifier",
              "name": "ReactNode"
            },
            "typeParameters": []
          },
          "optional": false,
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDescriptor",
      "name": "SortDescriptor",
      "properties": {
        "column": {
          "type": "property",
          "name": "column",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "Key"
          },
          "optional": false,
          "description": "The key of the column to sort by.",
          "default": null
        },
        "direction": {
          "type": "property",
          "name": "direction",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
          },
          "optional": false,
          "description": "The direction to sort by.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection",
      "name": "SortDirection",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "ascending"
          },
          {
            "type": "string",
            "value": "descending"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnSize",
      "name": "ColumnSize",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnDynamicSize"
          }
        ]
      },
      "typeParameters": [],
      "description": "All possible sizes a column can be assigned."
    },
    "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnStaticSize",
      "name": "ColumnStaticSize",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "number"
          },
          {
            "type": "template",
            "elements": [
              {
                "type": "number"
              }
            ]
          },
          {
            "type": "template",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "string",
                "value": "%"
              }
            ]
          }
        ]
      },
      "typeParameters": [],
      "description": "Widths that result in a constant pixel value for the same Table width."
    },
    "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnDynamicSize": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/table/src/index.d.ts:ColumnDynamicSize",
      "name": "ColumnDynamicSize",
      "value": {
        "type": "template",
        "elements": [
          {
            "type": "number"
          },
          {
            "type": "string",
            "value": "fr"
          }
        ]
      },
      "typeParameters": [],
      "description": "Widths that change size in relation to the remaining space and in ratio to other dynamic columns.\nAll numbers must be integers and greater than 0.\nFR units take up remaining, if any, space in the table."
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:TableBodyRenderProps",
      "name": "TableBodyRenderProps",
      "properties": {
        "isEmpty": {
          "type": "property",
          "name": "isEmpty",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the table body has no rows and should display its empty state.",
          "selector": "[data-empty]",
          "default": null
        },
        "isDropTarget": {
          "type": "property",
          "name": "isDropTarget",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the Table is currently the active drop target.",
          "selector": "[data-drop-target]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:ClassNameOrFunction",
      "name": "ClassNameOrFunction",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string"
          },
          {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "values",
                "value": {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "identifier",
                      "name": "T"
                    },
                    {
                      "type": "object",
                      "properties": {
                        "defaultClassName": {
                          "type": "property",
                          "name": "defaultClassName",
                          "indexType": null,
                          "value": {
                            "type": "union",
                            "elements": [
                              {
                                "type": "string"
                              },
                              {
                                "type": "undefined"
                              }
                            ]
                          },
                          "optional": false,
                          "default": null
                        }
                      }
                    }
                  ]
                },
                "rest": false
              }
            ],
            "return": {
              "type": "string"
            },
            "typeParameters": []
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:CellRenderProps",
      "name": "CellRenderProps",
      "properties": {
        "isPressed": {
          "type": "property",
          "name": "isPressed",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently in a pressed state.",
          "selector": "[data-pressed]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the cell is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
          },
          "optional": true,
          "description": "The unique id of the cell.\n*",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/utils.tsx:StyleOrFunction",
      "name": "StyleOrFunction",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "identifier",
            "name": "CSSProperties"
          },
          {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "values",
                "value": {
                  "type": "intersection",
                  "types": [
                    {
                      "type": "identifier",
                      "name": "T"
                    },
                    {
                      "type": "object",
                      "properties": {
                        "defaultStyle": {
                          "type": "property",
                          "name": "defaultStyle",
                          "indexType": null,
                          "value": {
                            "type": "identifier",
                            "name": "CSSProperties"
                          },
                          "optional": false,
                          "default": null
                        }
                      }
                    }
                  ]
                },
                "rest": false
              }
            ],
            "return": {
              "type": "union",
              "elements": [
                {
                  "type": "identifier",
                  "name": "CSSProperties"
                },
                {
                  "type": "undefined"
                }
              ]
            },
            "typeParameters": []
          }
        ]
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Table.tsx:ColumnRenderProps",
      "name": "ColumnRenderProps",
      "properties": {
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the item is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "allowsSorting": {
          "type": "property",
          "name": "allowsSorting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the column allows sorting.",
          "selector": "[data-allows-sorting]",
          "default": null
        },
        "sortDirection": {
          "type": "property",
          "name": "sortDirection",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
              },
              {
                "type": "undefined"
              }
            ]
          },
          "optional": false,
          "description": "The current sort direction.",
          "selector": "[data-sort-direction=\"ascending | descending\"]",
          "default": null
        },
        "isResizing": {
          "type": "property",
          "name": "isResizing",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the column is currently being resized.",
          "selector": "[data-resizing]",
          "default": null
        },
        "sort": {
          "type": "method",
          "name": "sort",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "direction",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:SortDirection"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Triggers sorting for this column in the given direction.",
          "default": null
        },
        "startResize": {
          "type": "method",
          "name": "startResize",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Starts column resizing if the table is contained in a `<ResizableTableContainer>` element.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue",
      "name": "TimeValue",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time",
      "name": "Time",
      "properties": {
        "undefined": {
          "type": "any"
        },
        "hour": {
          "type": "property",
          "name": "hour",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The hour, numbered from 0 to 23.",
          "access": "public",
          "default": null
        },
        "minute": {
          "type": "property",
          "name": "minute",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The minute in the hour.",
          "access": "public",
          "default": null
        },
        "second": {
          "type": "property",
          "name": "second",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The second in the minute.",
          "access": "public",
          "default": null
        },
        "millisecond": {
          "type": "property",
          "name": "millisecond",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "description": "The millisecond in the second.",
          "access": "public",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "hour",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "minute",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "second",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "millisecond",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "copy": {
          "type": "method",
          "name": "copy",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "typeParameters": []
          },
          "description": "Returns a copy of this time.",
          "default": null,
          "static": false
        },
        "add": {
          "type": "method",
          "name": "add",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "TimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "typeParameters": []
          },
          "description": "Returns a new `Time` with the given duration added to it.",
          "default": null,
          "static": false
        },
        "subtract": {
          "type": "method",
          "name": "subtract",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "duration",
                "value": {
                  "type": "identifier",
                  "name": "TimeDuration"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "typeParameters": []
          },
          "description": "Returns a new `Time` with the given duration subtracted from it.",
          "default": null,
          "static": false
        },
        "set": {
          "type": "method",
          "name": "set",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "fields",
                "value": {
                  "type": "identifier",
                  "name": "TimeFields"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "typeParameters": []
          },
          "description": "Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly.",
          "default": null,
          "static": false
        },
        "cycle": {
          "type": "method",
          "name": "cycle",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "field",
                "value": {
                  "type": "identifier",
                  "name": "TimeField"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "amount",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "options",
                "value": {
                  "type": "identifier",
                  "name": "CycleTimeOptions"
                },
                "optional": true,
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "typeParameters": []
          },
          "description": "Returns a new `Time` with the given field adjusted by a specified amount.\nWhen the resulting value reaches the limits of the field, it wraps around.",
          "default": null,
          "static": false
        },
        "toString": {
          "type": "method",
          "name": "toString",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "string",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Converts the time to an ISO 8601 formatted string.",
          "default": null,
          "static": false
        },
        "compare": {
          "type": "method",
          "name": "compare",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "b",
                "value": {
                  "type": "identifier",
                  "name": "AnyTime"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "number",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after.",
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": [],
      "description": "A Time represents a clock time without any date components."
    },
    "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:MappedTimeValue",
      "name": "MappedTimeValue",
      "value": {
        "type": "conditional",
        "checkType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
        },
        "extendsType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "trueType": {
          "type": "link",
          "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:ZonedDateTime"
        },
        "falseType": {
          "type": "conditional",
          "checkType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
          },
          "extendsType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "trueType": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:CalendarDateTime"
          },
          "falseType": {
            "type": "conditional",
            "checkType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/datepicker/src/index.d.ts:TimeValue"
            },
            "extendsType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "trueType": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@internationalized/date/src/CalendarDate.ts:Time"
            },
            "falseType": {
              "type": "never"
            }
          }
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastPlacement": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastPlacement",
      "name": "ToastPlacement",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "top"
          },
          {
            "type": "string",
            "value": "top end"
          },
          {
            "type": "string",
            "value": "bottom"
          },
          {
            "type": "string",
            "value": "bottom end"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Toast.tsx:ToastRegionRenderProps",
      "name": "ToastRegionRenderProps",
      "properties": {
        "visibleToasts": {
          "type": "property",
          "name": "visibleToasts",
          "indexType": null,
          "value": {
            "type": "array",
            "elementType": {
              "type": "application",
              "base": {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast"
              },
              "typeParameters": [
                {
                  "type": "identifier",
                  "name": "T"
                }
              ]
            }
          },
          "optional": false,
          "description": "A list of all currently visible toasts.",
          "default": null
        },
        "isHovered": {
          "type": "property",
          "name": "isHovered",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast region is currently hovered with a mouse.",
          "selector": "[data-hovered]",
          "default": null
        },
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast region is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the toast region is keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:QueuedToast",
      "name": "QueuedToast",
      "properties": {
        "content": {
          "type": "property",
          "name": "content",
          "indexType": null,
          "value": {
            "type": "identifier",
            "name": "T"
          },
          "optional": false,
          "description": "The content of the toast.",
          "default": null
        },
        "key": {
          "type": "property",
          "name": "key",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": false,
          "description": "A unique key for the toast.",
          "default": null
        },
        "timer": {
          "type": "property",
          "name": "timer",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:Timer"
          },
          "optional": true,
          "description": "A timer for the toast, if a timeout was set.",
          "default": null
        },
        "onClose": {
          "type": "property",
          "name": "onClose",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the toast is closed, either by the user or after a timeout.",
          "default": null
        },
        "timeout": {
          "type": "property",
          "name": "timeout",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "A timeout to automatically close the toast after, in milliseconds.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:Timer": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/toast/src/useToastState.ts:Timer",
      "name": "Timer",
      "properties": {
        "timerId": {
          "type": "property",
          "name": "timerId",
          "indexType": null,
          "value": {
            "type": "any"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "startTime": {
          "type": "property",
          "name": "startTime",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "remaining": {
          "type": "property",
          "name": "remaining",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "callback": {
          "type": "property",
          "name": "callback",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": false,
          "access": "private",
          "default": null
        },
        "constructor": {
          "type": "method",
          "name": "constructor",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "callback",
                "value": {
                  "type": "function",
                  "parameters": [],
                  "return": {
                    "type": "void"
                  },
                  "typeParameters": []
                },
                "rest": false,
                "description": null
              },
              {
                "type": "parameter",
                "name": "delay",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "reset": {
          "type": "method",
          "name": "reset",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "delay",
                "value": {
                  "type": "number"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "pause": {
          "type": "method",
          "name": "pause",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        },
        "resume": {
          "type": "method",
          "name": "resume",
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "default": null,
          "static": false
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastOptions": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:ToastOptions",
      "name": "ToastOptions",
      "properties": {
        "actionLabel": {
          "type": "property",
          "name": "actionLabel",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "A label for the action button within the toast.",
          "default": null
        },
        "onAction": {
          "type": "property",
          "name": "onAction",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the action button is pressed.",
          "default": null
        },
        "shouldCloseOnAction": {
          "type": "property",
          "name": "shouldCloseOnAction",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": true,
          "description": "Whether the toast should automatically close when an action is performed.",
          "default": null
        },
        "onClose": {
          "type": "property",
          "name": "onClose",
          "indexType": null,
          "value": {
            "type": "function",
            "parameters": [],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "optional": true,
          "description": "Handler that is called when the toast is closed, either by the user or after a timeout.",
          "default": null
        },
        "timeout": {
          "type": "property",
          "name": "timeout",
          "indexType": null,
          "value": {
            "type": "number"
          },
          "optional": true,
          "description": "A timeout to automatically close the toast after, in milliseconds.",
          "default": null
        },
        "id": {
          "type": "property",
          "name": "id",
          "indexType": null,
          "value": {
            "type": "string"
          },
          "optional": true,
          "description": "The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:CloseFunction": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-spectrum/s2/src/Toast.tsx:CloseFunction",
      "name": "CloseFunction",
      "value": {
        "type": "function",
        "parameters": [],
        "return": {
          "type": "void"
        },
        "typeParameters": []
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeEmptyStateRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Tree.tsx:TreeEmptyStateRenderProps",
      "name": "TreeEmptyStateRenderProps",
      "properties": {
        "isFocused": {
          "type": "property",
          "name": "isFocused",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree is currently focused.",
          "selector": "[data-focused]",
          "default": null
        },
        "isFocusVisible": {
          "type": "property",
          "name": "isFocusVisible",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree is currently keyboard focused.",
          "selector": "[data-focus-visible]",
          "default": null
        },
        "selectionMode": {
          "type": "property",
          "name": "selectionMode",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/selection.d.ts:SelectionMode"
          },
          "optional": false,
          "description": "The type of selection that is allowed in the collection.",
          "selector": "[data-selection-mode=\"single | multiple\"]",
          "default": null
        },
        "allowsDragging": {
          "type": "property",
          "name": "allowsDragging",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the tree allows dragging.",
          "selector": "[data-allows-dragging]",
          "default": null
        },
        "state": {
          "type": "property",
          "name": "state",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState"
            },
            "typeParameters": [
              {
                "type": "unknown"
              }
            ]
          },
          "optional": false,
          "description": "State of the tree.",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/@react-stately/tree/src/useTreeState.ts:TreeState",
      "name": "TreeState",
      "properties": {
        "collection": {
          "type": "property",
          "name": "collection",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "link",
              "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Collection"
            },
            "typeParameters": [
              {
                "type": "application",
                "base": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/collections.d.ts:Node"
                },
                "typeParameters": [
                  {
                    "type": "identifier",
                    "name": "T"
                  }
                ]
              }
            ]
          },
          "optional": false,
          "description": "A collection of items in the tree.",
          "default": null
        },
        "disabledKeys": {
          "type": "property",
          "name": "disabledKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for items that are disabled.",
          "default": null
        },
        "expandedKeys": {
          "type": "property",
          "name": "expandedKeys",
          "indexType": null,
          "value": {
            "type": "application",
            "base": {
              "type": "identifier",
              "name": "Set"
            },
            "typeParameters": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
              }
            ]
          },
          "optional": false,
          "description": "A set of keys for items that are expanded.",
          "default": null
        },
        "toggleKey": {
          "type": "method",
          "name": "toggleKey",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "key",
                "value": {
                  "type": "link",
                  "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Toggles the expanded state for an item by its key.",
          "default": null
        },
        "setExpandedKeys": {
          "type": "method",
          "name": "setExpandedKeys",
          "value": {
            "type": "function",
            "parameters": [
              {
                "type": "parameter",
                "name": "keys",
                "value": {
                  "type": "application",
                  "base": {
                    "type": "identifier",
                    "name": "Set"
                  },
                  "typeParameters": [
                    {
                      "type": "link",
                      "id": "/home/circleci/react-spectrum/packages/@react-types/shared/src/key.d.ts:Key"
                    }
                  ]
                },
                "rest": false,
                "description": null
              }
            ],
            "return": {
              "type": "void",
              "description": null
            },
            "typeParameters": []
          },
          "description": "Replaces the set of expanded keys.",
          "default": null
        },
        "selectionManager": {
          "type": "property",
          "name": "selectionManager",
          "indexType": null,
          "value": {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-stately/selection/src/SelectionManager.ts:SelectionManager"
          },
          "optional": false,
          "description": "A selection manager to read and update multiple selection state.",
          "default": null
        }
      },
      "typeParameters": [
        {
          "type": "typeParameter",
          "name": "T",
          "constraint": null,
          "default": null
        }
      ],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps": {
      "type": "interface",
      "id": "/home/circleci/react-spectrum/packages/react-aria-components/src/Popover.tsx:PopoverRenderProps",
      "name": "PopoverRenderProps",
      "properties": {
        "trigger": {
          "type": "property",
          "name": "trigger",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "string"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The name of the component that triggered the popover, e.g. \"DialogTrigger\" or \"ComboBox\".",
          "selector": "[data-trigger=\"...\"]",
          "default": null
        },
        "placement": {
          "type": "property",
          "name": "placement",
          "indexType": null,
          "value": {
            "type": "union",
            "elements": [
              {
                "type": "link",
                "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis"
              },
              {
                "type": "null"
              }
            ]
          },
          "optional": false,
          "description": "The placement of the popover relative to the trigger.",
          "selector": "[data-placement=\"left | right | top | bottom\"]",
          "default": null
        },
        "isEntering": {
          "type": "property",
          "name": "isEntering",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the popover is currently entering. Use this to apply animations.",
          "selector": "[data-entering]",
          "default": null
        },
        "isExiting": {
          "type": "property",
          "name": "isExiting",
          "indexType": null,
          "value": {
            "type": "boolean"
          },
          "optional": false,
          "description": "Whether the popover is currently exiting. Use this to apply animations.",
          "selector": "[data-exiting]",
          "default": null
        }
      },
      "typeParameters": [],
      "extends": []
    },
    "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:PlacementAxis",
      "name": "PlacementAxis",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "link",
            "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Axis"
          },
          {
            "type": "string",
            "value": "center"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    },
    "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Axis": {
      "type": "alias",
      "id": "/home/circleci/react-spectrum/packages/@react-types/overlays/src/index.d.ts:Axis",
      "name": "Axis",
      "value": {
        "type": "union",
        "elements": [
          {
            "type": "string",
            "value": "top"
          },
          {
            "type": "string",
            "value": "bottom"
          },
          {
            "type": "string",
            "value": "left"
          },
          {
            "type": "string",
            "value": "right"
          }
        ]
      },
      "typeParameters": [],
      "description": null
    }
  }
};

},{}],"cMkES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tabs", ()=>Tabs);
parcelHelpers.export(exports, "TabList", ()=>TabList);
parcelHelpers.export(exports, "Tab", ()=>Tab);
parcelHelpers.export(exports, "TabPanel", ()=>TabPanel);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _s2 = require("@react-spectrum/s2");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
'use client';
const tabs = " _Pc111 sd111 _va111 uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-c111 vx111 wb111 xb111 _xa111 _Fd111 _FezxGHba111 _FnuYUweb111 pt111 Fb111 Tt111";
const Tabs = /*#__PURE__*/ (0, _react.forwardRef)(function Tabs(props, ref) {
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: tabs,
        ref: domRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tabs), {
            ...props,
            style: {
                display: 'contents'
            },
            children: props.children
        })
    });
});
const tablist = " sd111 _ta111 Rg111 Se111 _va111 _sa111 Up111 qp111 LDvO7ld111 Fb111 Tp111 Qp111";
function TabList(props) {
    let state = (0, _react.useContext)((0, _reactAriaComponents.TabListStateContext));
    let [selectedTab, setSelectedTab] = (0, _react.useState)(undefined);
    let tablistRef = (0, _react.useRef)(null);
    (0, _utils1.useLayoutEffect)(()=>{
        if (tablistRef?.current) {
            let tab = tablistRef.current.querySelector('[role=tab][data-selected=true]');
            if (tab != null) setSelectedTab(tab);
        }
    }, [
        tablistRef,
        state?.selectedItem?.key
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " _Pc111",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabLine, {
                selectedTab: selectedTab
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TabList), {
                ...props,
                ref: tablistRef,
                className: tablist
            })
        ]
    });
}
const selectedIndicator = " _Pa111 g0111 gle111 Zf111 _je111 og111 ng111 kg111 jg111 Xa111 _2b111";
function TabLine(props) {
    let { selectedTab } = props;
    let { direction } = (0, _i18N.useLocale)();
    let state = (0, _react.useContext)((0, _reactAriaComponents.TabListStateContext));
    let [style, setStyle] = (0, _react.useState)({
        transform: undefined,
        width: undefined,
        height: undefined
    });
    let onResize = (0, _react.useCallback)(()=>{
        if (selectedTab) {
            let styleObj = {
                transform: undefined,
                width: undefined,
                height: undefined
            };
            styleObj.transform = `translateY(${selectedTab.offsetTop}px)`;
            styleObj.height = `${selectedTab.offsetHeight}px`;
            setStyle(styleObj);
        }
    }, [
        setStyle,
        selectedTab
    ]);
    (0, _utils1.useLayoutEffect)(()=>{
        onResize();
    }, [
        onResize,
        state?.selectedItem?.key,
        direction
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            ...style
        },
        className: selectedIndicator
    });
}
const tab = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf111';
    else rules += ' _Le111';
    rules += ' Oh111';
    rules += ' _Mc111';
    rules += ' _Kd111';
    rules += ' sd111';
    if (props.isSelected) {
        if (props.isPressed) rules += ' po111';
        else if (props.isFocusVisible) rules += ' po111';
        else if (props.isHovered) rules += ' po111';
        else rules += ' pt111';
    } else {
        if (props.isPressed) rules += ' pt111';
        else if (props.isFocusVisible) rules += ' pt111';
        else if (props.isHovered) rules += ' pt111';
        else rules += ' pv111';
    }
    if (props.isSelected) rules += ' pld111';
    rules += ' oa111';
    rules += ' na111';
    rules += ' ka111';
    rules += ' ja111';
    rules += ' Uc111';
    rules += ' Usd111';
    rules += ' qc111';
    rules += ' qsd111';
    rules += ' Fz111';
    rules += ' eb111';
    rules += ' _Pc111';
    rules += ' ri111';
    rules += ' _va111';
    rules += ' Yd111';
    rules += ' Xb111';
    rules += ' _2b111';
    rules += ' __ca111';
    return rules;
};
const icon = " sb111 _va111 -_8sjo0b-t5ZbAob111";
function Tab(props) {
    let contentId = (0, _utils1.useId)();
    let ariaLabelledBy = props['aria-labelledby'] || '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tab), {
        ...props,
        // @ts-ignore
        originalProps: props,
        "aria-labelledby": `${ariaLabelledBy}`,
        className: (renderProps)=>tab({
                ...renderProps
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _s2.TextContext),
                    {
                        id: contentId,
                        styles: " _Jb111"
                    }
                ],
                [
                    (0, _s2.IconContext),
                    {
                        // render: centerBaseline({slot: 'icon', styles: style({order: 0})}),
                        styles: icon
                    }
                ]
            ],
            children: props.children
        })
    });
}
const tabPanel = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf111';
    else rules += ' _Le111';
    rules += ' Oh111';
    rules += ' _Mc111';
    rules += ' _Kd111';
    rules += ' Js111';
    rules += ' pt111';
    rules += ' _ub111';
    rules += ' _sa111';
    rules += ' Ma111';
    rules += ' Na111';
    rules += ' sd111';
    rules += ' _ta111';
    return rules;
};
function TabPanel(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TabPanel), {
        ...props,
        className: (renderProps)=>tabPanel(renderProps)
    });
}

},{"0":"jT8UN","1":"1kvti","2":"6bR2o","3":"fvq17","4":"dELpb","5":"d4AvD","6":"kpyTE","7":"57Oe0","react/jsx-runtime":"2Is6Z","react-aria-components":"2Emk2","react":"a1TxN","@react-spectrum/s2":"5H6IX","@react-spectrum/utils":"iHr3t","@react-aria/utils":"sfA4q","@react-aria/i18n":"96Jdx","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jT8UN":[function() {},{}],"1kvti":[function() {},{}],"6bR2o":[function() {},{}],"fvq17":[function() {},{}],"dELpb":[function() {},{}],"d4AvD":[function() {},{}],"kpyTE":[function() {},{}],"57Oe0":[function() {},{}],"4lnNg":[function(require,module,exports,__globalThis) {
var _client = require("@parcel/rsc/client");
'use client-entry';
// Hydrate initial RSC payload embedded in the HTML.
let updateRoot = (0, _client.hydrate)({
    // Intercept HMR window reloads, and do it with RSC instead.
    onHmrReload () {
        navigate(location.pathname + location.search + location.hash);
    }
});
// A very simple router. When we navigate, we'll fetch a new RSC payload from the server,
// and in a React transition, stream in the new page. Once complete, we'll pushState to 
// update the URL in the browser.
async function navigate(pathname, push = false) {
    let res = (0, _client.fetchRSC)(pathname.replace('.html', '.rsc'));
    updateRoot(res, ()=>{
        if (push) {
            history.pushState(null, '', pathname);
            push = false;
        }
    });
}
// Intercept link clicks to perform RSC navigation.
document.addEventListener('click', (e)=>{
    let link = e.target.closest('a');
    if (link && link instanceof HTMLAnchorElement && link.href && (!link.target || link.target === '_self') && link.origin === location.origin && link.pathname !== location.pathname && !link.hasAttribute('download') && e.button === 0 && // left clicks only
    !e.metaKey && // open in new tab (mac)
    !e.ctrlKey && // open in new tab (windows)
    !e.altKey && // download
    !e.shiftKey && !e.defaultPrevented) {
        e.preventDefault();
        navigate(link.pathname + link.search + link.hash, true);
    }
});
// When the user clicks the back button, navigate with RSC.
window.addEventListener('popstate', ()=>{
    navigate(location.pathname + location.search + location.hash);
});

},{"@parcel/rsc/client":"dvyUn"}],"dvyUn":[function(require,module,exports,__globalThis) {
/* @jsxRuntime automatic */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setServerCallback", ()=>setServerCallback);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "fetchRSC", ()=>fetchRSC);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("react-server-dom-parcel/client");
var _client1 = require("rsc-html-stream/client");
var _client2 = require("react-dom/client");
function setServerCallback(cb) {
    return (0, _client.setServerCallback)(cb);
}
// Stream in initial RSC payload embedded in the HTML.
let initialRSCPayload;
function RSCRoot({ value, cb }) {
    initialRSCPayload ??= (0, _client.createFromReadableStream)((0, _client1.rscStream));
    (0, _react.useInsertionEffect)(()=>{
        cb?.();
    });
    return value === undefined ? initialRSCPayload : value;
}
function hydrate(options) {
    if (options?.callServer) setServerCallback(options.callServer);
    if (options?.onHmrReload) window.addEventListener('parcelhmrreload', (e)=>{
        e.preventDefault();
        options?.onHmrReload?.();
    });
    let root;
    (0, _react.startTransition)(()=>{
        root = (0, _client2.hydrateRoot)(document, /*#__PURE__*/ (0, _jsxRuntime.jsx)(RSCRoot, {}), options);
    });
    return (value, cb)=>{
        (0, _react.startTransition)(()=>{
            root?.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)(RSCRoot, {
                value: value,
                cb: ()=>{
                    cb?.();
                    cb = undefined;
                }
            }));
        });
    };
}
async function fetchRSC(url, options) {
    const temporaryReferences = (0, _client.createTemporaryReferenceSet)();
    const response = fetch(url, {
        ...options,
        headers: {
            Accept: 'text/x-component',
            ...options?.headers
        },
        body: options && 'body' in options ? await (0, _client.encodeReply)(options.body, {
            temporaryReferences,
            signal: options?.signal
        }) : undefined
    });
    return (0, _client.createFromFetch)(response, {
        temporaryReferences
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-server-dom-parcel/client":"8pUYL","rsc-html-stream/client":"2n5QP","react-dom/client":"fRKjd","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8pUYL":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("a3a6240ced92f943");

},{"a3a6240ced92f943":"17zd7"}],"17zd7":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-client.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var decoderOptions = {
    stream: !0
};
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var ReactDOMSharedInternals = require("da607ba755542785").__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator, isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf, ObjectPrototype = Object.prototype, knownServerReferences = new WeakMap();
function serializeNumber(number) {
    return Number.isFinite(number) ? 0 === number && -Infinity === 1 / number ? "$-0" : number : Infinity === number ? "$Infinity" : -Infinity === number ? "$-Infinity" : "$NaN";
}
function processReply(root, formFieldPrefix, temporaryReferences, resolve, reject) {
    function serializeTypedArray(tag, typedArray) {
        typedArray = new Blob([
            new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength)
        ]);
        var blobId = nextPartId++;
        null === formData && (formData = new FormData());
        formData.append(formFieldPrefix + blobId, typedArray);
        return "$" + tag + blobId.toString(16);
    }
    function serializeBinaryReader(reader) {
        function progress(entry) {
            entry.done ? (entry = nextPartId++, data.append(formFieldPrefix + entry, new Blob(buffer)), data.append(formFieldPrefix + streamId, '"$o' + entry.toString(16) + '"'), data.append(formFieldPrefix + streamId, "C"), pendingParts--, 0 === pendingParts && resolve(data)) : (buffer.push(entry.value), reader.read(new Uint8Array(1024)).then(progress, reject));
        }
        null === formData && (formData = new FormData());
        var data = formData;
        pendingParts++;
        var streamId = nextPartId++, buffer = [];
        reader.read(new Uint8Array(1024)).then(progress, reject);
        return "$r" + streamId.toString(16);
    }
    function serializeReader(reader) {
        function progress(entry) {
            if (entry.done) data.append(formFieldPrefix + streamId, "C"), pendingParts--, 0 === pendingParts && resolve(data);
            else try {
                var partJSON = JSON.stringify(entry.value, resolveToJSON);
                data.append(formFieldPrefix + streamId, partJSON);
                reader.read().then(progress, reject);
            } catch (x) {
                reject(x);
            }
        }
        null === formData && (formData = new FormData());
        var data = formData;
        pendingParts++;
        var streamId = nextPartId++;
        reader.read().then(progress, reject);
        return "$R" + streamId.toString(16);
    }
    function serializeReadableStream(stream) {
        try {
            var binaryReader = stream.getReader({
                mode: "byob"
            });
        } catch (x) {
            return serializeReader(stream.getReader());
        }
        return serializeBinaryReader(binaryReader);
    }
    function serializeAsyncIterable(iterable, iterator) {
        function progress(entry) {
            if (entry.done) {
                if (void 0 === entry.value) data.append(formFieldPrefix + streamId, "C");
                else try {
                    var partJSON = JSON.stringify(entry.value, resolveToJSON);
                    data.append(formFieldPrefix + streamId, "C" + partJSON);
                } catch (x) {
                    reject(x);
                    return;
                }
                pendingParts--;
                0 === pendingParts && resolve(data);
            } else try {
                var partJSON$21 = JSON.stringify(entry.value, resolveToJSON);
                data.append(formFieldPrefix + streamId, partJSON$21);
                iterator.next().then(progress, reject);
            } catch (x$22) {
                reject(x$22);
            }
        }
        null === formData && (formData = new FormData());
        var data = formData;
        pendingParts++;
        var streamId = nextPartId++;
        iterable = iterable === iterator;
        iterator.next().then(progress, reject);
        return "$" + (iterable ? "x" : "X") + streamId.toString(16);
    }
    function resolveToJSON(key, value) {
        if (null === value) return null;
        if ("object" === typeof value) {
            switch(value.$$typeof){
                case REACT_ELEMENT_TYPE:
                    if (void 0 !== temporaryReferences && -1 === key.indexOf(":")) {
                        var parentReference = writtenObjects.get(this);
                        if (void 0 !== parentReference) return temporaryReferences.set(parentReference + ":" + key, value), "$T";
                    }
                    throw Error("React Element cannot be passed to Server Functions from the Client without a temporary reference set. Pass a TemporaryReferenceSet to the options.");
                case REACT_LAZY_TYPE:
                    parentReference = value._payload;
                    var init = value._init;
                    null === formData && (formData = new FormData());
                    pendingParts++;
                    try {
                        var resolvedModel = init(parentReference), lazyId = nextPartId++, partJSON = serializeModel(resolvedModel, lazyId);
                        formData.append(formFieldPrefix + lazyId, partJSON);
                        return "$" + lazyId.toString(16);
                    } catch (x) {
                        if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                            pendingParts++;
                            var lazyId$23 = nextPartId++;
                            parentReference = function() {
                                try {
                                    var partJSON$24 = serializeModel(value, lazyId$23), data$25 = formData;
                                    data$25.append(formFieldPrefix + lazyId$23, partJSON$24);
                                    pendingParts--;
                                    0 === pendingParts && resolve(data$25);
                                } catch (reason) {
                                    reject(reason);
                                }
                            };
                            x.then(parentReference, parentReference);
                            return "$" + lazyId$23.toString(16);
                        }
                        reject(x);
                        return null;
                    } finally{
                        pendingParts--;
                    }
            }
            if ("function" === typeof value.then) {
                null === formData && (formData = new FormData());
                pendingParts++;
                var promiseId = nextPartId++;
                value.then(function(partValue) {
                    try {
                        var partJSON$27 = serializeModel(partValue, promiseId);
                        partValue = formData;
                        partValue.append(formFieldPrefix + promiseId, partJSON$27);
                        pendingParts--;
                        0 === pendingParts && resolve(partValue);
                    } catch (reason) {
                        reject(reason);
                    }
                }, reject);
                return "$@" + promiseId.toString(16);
            }
            parentReference = writtenObjects.get(value);
            if (void 0 !== parentReference) {
                if (modelRoot === value) modelRoot = null;
                else return parentReference;
            } else -1 === key.indexOf(":") && (parentReference = writtenObjects.get(this), void 0 !== parentReference && (key = parentReference + ":" + key, writtenObjects.set(value, key), void 0 !== temporaryReferences && temporaryReferences.set(key, value)));
            if (isArrayImpl(value)) return value;
            if (value instanceof FormData) {
                null === formData && (formData = new FormData());
                var data$31 = formData;
                key = nextPartId++;
                var prefix = formFieldPrefix + key + "_";
                value.forEach(function(originalValue, originalKey) {
                    data$31.append(prefix + originalKey, originalValue);
                });
                return "$K" + key.toString(16);
            }
            if (value instanceof Map) return key = nextPartId++, parentReference = serializeModel(Array.from(value), key), null === formData && (formData = new FormData()), formData.append(formFieldPrefix + key, parentReference), "$Q" + key.toString(16);
            if (value instanceof Set) return key = nextPartId++, parentReference = serializeModel(Array.from(value), key), null === formData && (formData = new FormData()), formData.append(formFieldPrefix + key, parentReference), "$W" + key.toString(16);
            if (value instanceof ArrayBuffer) return key = new Blob([
                value
            ]), parentReference = nextPartId++, null === formData && (formData = new FormData()), formData.append(formFieldPrefix + parentReference, key), "$A" + parentReference.toString(16);
            if (value instanceof Int8Array) return serializeTypedArray("O", value);
            if (value instanceof Uint8Array) return serializeTypedArray("o", value);
            if (value instanceof Uint8ClampedArray) return serializeTypedArray("U", value);
            if (value instanceof Int16Array) return serializeTypedArray("S", value);
            if (value instanceof Uint16Array) return serializeTypedArray("s", value);
            if (value instanceof Int32Array) return serializeTypedArray("L", value);
            if (value instanceof Uint32Array) return serializeTypedArray("l", value);
            if (value instanceof Float32Array) return serializeTypedArray("G", value);
            if (value instanceof Float64Array) return serializeTypedArray("g", value);
            if (value instanceof BigInt64Array) return serializeTypedArray("M", value);
            if (value instanceof BigUint64Array) return serializeTypedArray("m", value);
            if (value instanceof DataView) return serializeTypedArray("V", value);
            if ("function" === typeof Blob && value instanceof Blob) return null === formData && (formData = new FormData()), key = nextPartId++, formData.append(formFieldPrefix + key, value), "$B" + key.toString(16);
            if (key = getIteratorFn(value)) return parentReference = key.call(value), parentReference === value ? (key = nextPartId++, parentReference = serializeModel(Array.from(parentReference), key), null === formData && (formData = new FormData()), formData.append(formFieldPrefix + key, parentReference), "$i" + key.toString(16)) : Array.from(parentReference);
            if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(value);
            key = value[ASYNC_ITERATOR];
            if ("function" === typeof key) return serializeAsyncIterable(value, key.call(value));
            key = getPrototypeOf(value);
            if (key !== ObjectPrototype && (null === key || null !== getPrototypeOf(key))) {
                if (void 0 === temporaryReferences) throw Error("Only plain objects, and a few built-ins, can be passed to Server Functions. Classes or null prototypes are not supported.");
                return "$T";
            }
            return value;
        }
        if ("string" === typeof value) {
            if ("Z" === value[value.length - 1] && this[key] instanceof Date) return "$D" + value;
            key = "$" === value[0] ? "$" + value : value;
            return key;
        }
        if ("boolean" === typeof value) return value;
        if ("number" === typeof value) return serializeNumber(value);
        if ("undefined" === typeof value) return "$undefined";
        if ("function" === typeof value) {
            parentReference = knownServerReferences.get(value);
            if (void 0 !== parentReference) return key = JSON.stringify({
                id: parentReference.id,
                bound: parentReference.bound
            }, resolveToJSON), null === formData && (formData = new FormData()), parentReference = nextPartId++, formData.set(formFieldPrefix + parentReference, key), "$F" + parentReference.toString(16);
            if (void 0 !== temporaryReferences && -1 === key.indexOf(":") && (parentReference = writtenObjects.get(this), void 0 !== parentReference)) return temporaryReferences.set(parentReference + ":" + key, value), "$T";
            throw Error("Client Functions cannot be passed directly to Server Functions. Only Functions passed from the Server can be passed back again.");
        }
        if ("symbol" === typeof value) {
            if (void 0 !== temporaryReferences && -1 === key.indexOf(":") && (parentReference = writtenObjects.get(this), void 0 !== parentReference)) return temporaryReferences.set(parentReference + ":" + key, value), "$T";
            throw Error("Symbols cannot be passed to a Server Function without a temporary reference set. Pass a TemporaryReferenceSet to the options.");
        }
        if ("bigint" === typeof value) return "$n" + value.toString(10);
        throw Error("Type " + typeof value + " is not supported as an argument to a Server Function.");
    }
    function serializeModel(model, id) {
        "object" === typeof model && null !== model && (id = "$" + id.toString(16), writtenObjects.set(model, id), void 0 !== temporaryReferences && temporaryReferences.set(id, model));
        modelRoot = model;
        return JSON.stringify(model, resolveToJSON);
    }
    var nextPartId = 1, pendingParts = 0, formData = null, writtenObjects = new WeakMap(), modelRoot = root, json = serializeModel(root, 0);
    null === formData ? resolve(json) : (formData.set(formFieldPrefix + "0", json), 0 === pendingParts && resolve(formData));
    return function() {
        0 < pendingParts && (pendingParts = 0, null === formData ? resolve(json) : resolve(formData));
    };
}
function registerBoundServerReference(reference, id, bound) {
    knownServerReferences.has(reference) || knownServerReferences.set(reference, {
        id: id,
        originalBind: reference.bind,
        bound: bound
    });
}
function createBoundServerReference(metaData, callServer) {
    function action() {
        var args = Array.prototype.slice.call(arguments);
        return bound ? "fulfilled" === bound.status ? callServer(id, bound.value.concat(args)) : Promise.resolve(bound).then(function(boundArgs) {
            return callServer(id, boundArgs.concat(args));
        }) : callServer(id, args);
    }
    var id = metaData.id, bound = metaData.bound;
    registerBoundServerReference(action, id, bound);
    return action;
}
function createServerReference$1(id, callServer) {
    function action() {
        var args = Array.prototype.slice.call(arguments);
        return callServer(id, args);
    }
    registerBoundServerReference(action, id, null);
    return action;
}
function ReactPromise(status, value, reason) {
    this.status = status;
    this.value = value;
    this.reason = reason;
}
ReactPromise.prototype = Object.create(Promise.prototype);
ReactPromise.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
            break;
        case "resolved_module":
            initializeModuleChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            "function" === typeof resolve && resolve(this.value);
            break;
        case "pending":
        case "blocked":
            "function" === typeof resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            "function" === typeof reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        case "halted":
            break;
        default:
            "function" === typeof reject && reject(this.reason);
    }
};
function readChunk(chunk) {
    switch(chunk.status){
        case "resolved_model":
            initializeModelChunk(chunk);
            break;
        case "resolved_module":
            initializeModuleChunk(chunk);
    }
    switch(chunk.status){
        case "fulfilled":
            return chunk.value;
        case "pending":
        case "blocked":
        case "halted":
            throw chunk;
        default:
            throw chunk.reason;
    }
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++){
        var listener = listeners[i];
        "function" === typeof listener ? listener(value) : fulfillReference(listener, value);
    }
}
function rejectChunk(listeners, error) {
    for(var i = 0; i < listeners.length; i++){
        var listener = listeners[i];
        "function" === typeof listener ? listener(error) : rejectReference(listener, error);
    }
}
function resolveBlockedCycle(resolvedChunk, reference) {
    var referencedChunk = reference.handler.chunk;
    if (null === referencedChunk) return null;
    if (referencedChunk === resolvedChunk) return reference.handler;
    reference = referencedChunk.value;
    if (null !== reference) for(referencedChunk = 0; referencedChunk < reference.length; referencedChunk++){
        var listener = reference[referencedChunk];
        if ("function" !== typeof listener && (listener = resolveBlockedCycle(resolvedChunk, listener), null !== listener)) return listener;
    }
    return null;
}
function wakeChunkIfInitialized(chunk, resolveListeners, rejectListeners) {
    switch(chunk.status){
        case "fulfilled":
            wakeChunk(resolveListeners, chunk.value);
            break;
        case "blocked":
            for(var i = 0; i < resolveListeners.length; i++){
                var listener = resolveListeners[i];
                if ("function" !== typeof listener) {
                    var cyclicHandler = resolveBlockedCycle(chunk, listener);
                    null !== cyclicHandler && (fulfillReference(listener, cyclicHandler.value), resolveListeners.splice(i, 1), i--, null !== rejectListeners && (listener = rejectListeners.indexOf(listener), -1 !== listener && rejectListeners.splice(listener, 1)));
                }
            }
        case "pending":
            if (chunk.value) for(i = 0; i < resolveListeners.length; i++)chunk.value.push(resolveListeners[i]);
            else chunk.value = resolveListeners;
            if (chunk.reason) {
                if (rejectListeners) for(resolveListeners = 0; resolveListeners < rejectListeners.length; resolveListeners++)chunk.reason.push(rejectListeners[resolveListeners]);
            } else chunk.reason = rejectListeners;
            break;
        case "rejected":
            rejectListeners && rejectChunk(rejectListeners, chunk.reason);
    }
}
function triggerErrorOnChunk(response, chunk, error) {
    "pending" !== chunk.status && "blocked" !== chunk.status ? chunk.reason.error(error) : (response = chunk.reason, chunk.status = "rejected", chunk.reason = error, null !== response && rejectChunk(response, error));
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new ReactPromise("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", response);
}
function resolveIteratorResultChunk(response, chunk, value, done) {
    resolveModelChunk(response, chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}");
}
function resolveModelChunk(response, chunk, value) {
    if ("pending" !== chunk.status) chunk.reason.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = response;
        null !== resolveListeners && (initializeModelChunk(chunk), wakeChunkIfInitialized(chunk, resolveListeners, rejectListeners));
    }
}
function resolveModuleChunk(response, chunk, value) {
    if ("pending" === chunk.status || "blocked" === chunk.status) {
        response = chunk.value;
        var rejectListeners = chunk.reason;
        chunk.status = "resolved_module";
        chunk.value = value;
        null !== response && (initializeModuleChunk(chunk), wakeChunkIfInitialized(chunk, response, rejectListeners));
    }
}
var initializingHandler = null;
function initializeModelChunk(chunk) {
    var prevHandler = initializingHandler;
    initializingHandler = null;
    var resolvedModel = chunk.value, response = chunk.reason;
    chunk.status = "blocked";
    chunk.value = null;
    chunk.reason = null;
    try {
        var value = JSON.parse(resolvedModel, response._fromJSON), resolveListeners = chunk.value;
        null !== resolveListeners && (chunk.value = null, chunk.reason = null, wakeChunk(resolveListeners, value));
        if (null !== initializingHandler) {
            if (initializingHandler.errored) throw initializingHandler.reason;
            if (0 < initializingHandler.deps) {
                initializingHandler.value = value;
                initializingHandler.chunk = chunk;
                return;
            }
        }
        chunk.status = "fulfilled";
        chunk.value = value;
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingHandler = prevHandler;
    }
}
function initializeModuleChunk(chunk) {
    try {
        var value = requireModule(chunk.value);
        chunk.status = "fulfilled";
        chunk.value = value;
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    }
}
function reportGlobalError(weakResponse, error) {
    weakResponse._closed = !0;
    weakResponse._closedReason = error;
    weakResponse._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(weakResponse, chunk, error);
    });
}
function createLazyChunkWrapper(chunk) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: chunk,
        _init: readChunk
    };
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._closed ? new ReactPromise("rejected", null, response._closedReason) : new ReactPromise("pending", null, null), chunks.set(id, chunk));
    return chunk;
}
function fulfillReference(reference, value) {
    for(var response = reference.response, handler = reference.handler, parentObject = reference.parentObject, key = reference.key, map = reference.map, path = reference.path, i = 1; i < path.length; i++){
        for(; value.$$typeof === REACT_LAZY_TYPE;)if (value = value._payload, value === handler.chunk) value = handler.value;
        else {
            switch(value.status){
                case "resolved_model":
                    initializeModelChunk(value);
                    break;
                case "resolved_module":
                    initializeModuleChunk(value);
            }
            switch(value.status){
                case "fulfilled":
                    value = value.value;
                    continue;
                case "blocked":
                    var cyclicHandler = resolveBlockedCycle(value, reference);
                    if (null !== cyclicHandler) {
                        value = cyclicHandler.value;
                        continue;
                    }
                case "pending":
                    path.splice(0, i - 1);
                    null === value.value ? value.value = [
                        reference
                    ] : value.value.push(reference);
                    null === value.reason ? value.reason = [
                        reference
                    ] : value.reason.push(reference);
                    return;
                case "halted":
                    return;
                default:
                    rejectReference(reference, value.reason);
                    return;
            }
        }
        value = value[path[i]];
    }
    reference = map(response, value, parentObject, key);
    parentObject[key] = reference;
    "" === key && null === handler.value && (handler.value = reference);
    if (parentObject[0] === REACT_ELEMENT_TYPE && "object" === typeof handler.value && null !== handler.value && handler.value.$$typeof === REACT_ELEMENT_TYPE) switch(parentObject = handler.value, key){
        case "3":
            parentObject.props = reference;
    }
    handler.deps--;
    0 === handler.deps && (key = handler.chunk, null !== key && "blocked" === key.status && (parentObject = key.value, key.status = "fulfilled", key.value = handler.value, key.reason = handler.reason, null !== parentObject && wakeChunk(parentObject, handler.value)));
}
function rejectReference(reference, error) {
    var handler = reference.handler;
    reference = reference.response;
    handler.errored || (handler.errored = !0, handler.value = null, handler.reason = error, handler = handler.chunk, null !== handler && "blocked" === handler.status && triggerErrorOnChunk(reference, handler, error));
}
function waitForReference(referencedChunk, parentObject, key, response, map, path) {
    if (initializingHandler) {
        var handler = initializingHandler;
        handler.deps++;
    } else handler = initializingHandler = {
        parent: null,
        chunk: null,
        value: null,
        reason: null,
        deps: 1,
        errored: !1
    };
    parentObject = {
        response: response,
        handler: handler,
        parentObject: parentObject,
        key: key,
        map: map,
        path: path
    };
    null === referencedChunk.value ? referencedChunk.value = [
        parentObject
    ] : referencedChunk.value.push(parentObject);
    null === referencedChunk.reason ? referencedChunk.reason = [
        parentObject
    ] : referencedChunk.reason.push(parentObject);
    return null;
}
function loadServerReference(response, metaData, parentObject, key) {
    if (!response._serverReferenceConfig) return createBoundServerReference(metaData, response._callServer);
    var serverReference = resolveServerReference(response._serverReferenceConfig, metaData.id), promise = preloadModule(serverReference);
    if (promise) metaData.bound && (promise = Promise.all([
        promise,
        metaData.bound
    ]));
    else if (metaData.bound) promise = Promise.resolve(metaData.bound);
    else return promise = requireModule(serverReference), registerBoundServerReference(promise, metaData.id, metaData.bound), promise;
    if (initializingHandler) {
        var handler = initializingHandler;
        handler.deps++;
    } else handler = initializingHandler = {
        parent: null,
        chunk: null,
        value: null,
        reason: null,
        deps: 1,
        errored: !1
    };
    promise.then(function() {
        var resolvedValue = requireModule(serverReference);
        if (metaData.bound) {
            var boundArgs = metaData.bound.value.slice(0);
            boundArgs.unshift(null);
            resolvedValue = resolvedValue.bind.apply(resolvedValue, boundArgs);
        }
        registerBoundServerReference(resolvedValue, metaData.id, metaData.bound);
        parentObject[key] = resolvedValue;
        "" === key && null === handler.value && (handler.value = resolvedValue);
        if (parentObject[0] === REACT_ELEMENT_TYPE && "object" === typeof handler.value && null !== handler.value && handler.value.$$typeof === REACT_ELEMENT_TYPE) switch(boundArgs = handler.value, key){
            case "3":
                boundArgs.props = resolvedValue;
        }
        handler.deps--;
        0 === handler.deps && (resolvedValue = handler.chunk, null !== resolvedValue && "blocked" === resolvedValue.status && (boundArgs = resolvedValue.value, resolvedValue.status = "fulfilled", resolvedValue.value = handler.value, null !== boundArgs && wakeChunk(boundArgs, handler.value)));
    }, function(error) {
        if (!handler.errored) {
            handler.errored = !0;
            handler.value = null;
            handler.reason = error;
            var chunk = handler.chunk;
            null !== chunk && "blocked" === chunk.status && triggerErrorOnChunk(response, chunk, error);
        }
    });
    return null;
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
            break;
        case "resolved_module":
            initializeModuleChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            var value = id.value;
            for(id = 1; id < reference.length; id++){
                for(; value.$$typeof === REACT_LAZY_TYPE;){
                    value = value._payload;
                    switch(value.status){
                        case "resolved_model":
                            initializeModelChunk(value);
                            break;
                        case "resolved_module":
                            initializeModuleChunk(value);
                    }
                    switch(value.status){
                        case "fulfilled":
                            value = value.value;
                            break;
                        case "blocked":
                        case "pending":
                            return waitForReference(value, parentObject, key, response, map, reference.slice(id - 1));
                        case "halted":
                            return initializingHandler ? (response = initializingHandler, response.deps++) : initializingHandler = {
                                parent: null,
                                chunk: null,
                                value: null,
                                reason: null,
                                deps: 1,
                                errored: !1
                            }, null;
                        default:
                            return initializingHandler ? (initializingHandler.errored = !0, initializingHandler.value = null, initializingHandler.reason = value.reason) : initializingHandler = {
                                parent: null,
                                chunk: null,
                                value: null,
                                reason: value.reason,
                                deps: 0,
                                errored: !0
                            }, null;
                    }
                }
                value = value[reference[id]];
            }
            return map(response, value, parentObject, key);
        case "pending":
        case "blocked":
            return waitForReference(id, parentObject, key, response, map, reference);
        case "halted":
            return initializingHandler ? (response = initializingHandler, response.deps++) : initializingHandler = {
                parent: null,
                chunk: null,
                value: null,
                reason: null,
                deps: 1,
                errored: !1
            }, null;
        default:
            return initializingHandler ? (initializingHandler.errored = !0, initializingHandler.value = null, initializingHandler.reason = id.reason) : initializingHandler = {
                parent: null,
                chunk: null,
                value: null,
                reason: id.reason,
                deps: 0,
                errored: !0
            }, null;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function createBlob(response, model) {
    return new Blob(model.slice(1), {
        type: model[0]
    });
}
function createFormData(response, model) {
    response = new FormData();
    for(var i = 0; i < model.length; i++)response.append(model[i][0], model[i][1]);
    return response;
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseModelString(response, parentObject, key, value) {
    if ("$" === value[0]) {
        if ("$" === value) return null !== initializingHandler && "0" === key && (initializingHandler = {
            parent: initializingHandler,
            chunk: null,
            value: null,
            reason: null,
            deps: 0,
            errored: !1
        }), REACT_ELEMENT_TYPE;
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "L":
                return parentObject = parseInt(value.slice(2), 16), response = getChunk(response, parentObject), createLazyChunkWrapper(response);
            case "@":
                return parentObject = parseInt(value.slice(2), 16), getChunk(response, parentObject);
            case "S":
                return Symbol.for(value.slice(2));
            case "F":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, loadServerReference);
            case "T":
                parentObject = "$" + value.slice(2);
                response = response._tempRefs;
                if (null == response) throw Error("Missing a temporary reference set but the RSC response returned a temporary reference. Pass a temporaryReference option with the set that was used with the reply.");
                return response.get(parentObject);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, createSet);
            case "B":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, createBlob);
            case "K":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, createFormData);
            case "Z":
                return resolveErrorProd();
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, parentObject, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
            default:
                return value = value.slice(1), getOutlinedModel(response, value, parentObject, key, createModel);
        }
    }
    return value;
}
function missingCall() {
    throw Error('Trying to call a function from "use server" but the callServer option was not implemented in your router runtime.');
}
function ResponseInstance(bundlerConfig, serverReferenceConfig, moduleLoading, callServer, encodeFormAction, nonce, temporaryReferences) {
    var chunks = new Map();
    this._bundlerConfig = bundlerConfig;
    this._serverReferenceConfig = serverReferenceConfig;
    this._moduleLoading = moduleLoading;
    this._callServer = void 0 !== callServer ? callServer : missingCall;
    this._encodeFormAction = encodeFormAction;
    this._nonce = nonce;
    this._chunks = chunks;
    this._stringDecoder = new TextDecoder();
    this._fromJSON = null;
    this._closed = !1;
    this._closedReason = null;
    this._tempRefs = temporaryReferences;
    this._fromJSON = createFromJSONCallback(this);
}
function resolveBuffer(response, id, buffer) {
    response = response._chunks;
    var chunk = response.get(id);
    chunk && "pending" !== chunk.status ? chunk.reason.enqueueValue(buffer) : response.set(id, new ReactPromise("fulfilled", buffer, null));
}
function resolveModule(response, id, model) {
    var chunks = response._chunks, chunk = chunks.get(id), clientReference = JSON.parse(model, response._fromJSON);
    if (model = preloadModule(clientReference)) {
        if (chunk) {
            var blockedChunk = chunk;
            blockedChunk.status = "blocked";
        } else blockedChunk = new ReactPromise("blocked", null, null), chunks.set(id, blockedChunk);
        model.then(function() {
            return resolveModuleChunk(response, blockedChunk, clientReference);
        }, function(error) {
            return triggerErrorOnChunk(response, blockedChunk, error);
        });
    } else chunk ? resolveModuleChunk(response, chunk, clientReference) : chunks.set(id, new ReactPromise("resolved_module", clientReference, null));
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    response = chunks.get(id);
    response ? "pending" === response.status && (id = response.value, response.status = "fulfilled", response.value = stream, response.reason = controller, null !== id && wakeChunk(id, response.value)) : chunks.set(id, new ReactPromise("fulfilled", stream, controller));
}
function startReadableStream(response, id, type) {
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, id, type, {
        enqueueValue: function(value) {
            null === previousBlockedChunk ? controller.enqueue(value) : previousBlockedChunk.then(function() {
                controller.enqueue(value);
            });
        },
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new ReactPromise("resolved_model", json, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$52 = new ReactPromise("pending", null, null);
                chunk$52.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$52;
                chunk.then(function() {
                    previousBlockedChunk === chunk$52 && (previousBlockedChunk = null);
                    resolveModelChunk(response, chunk$52, json);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function startAsyncIterable(response, id, iterator) {
    var buffer = [], closed = !1, nextWriteIndex = 0, iterable = {};
    iterable[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new ReactPromise("fulfilled", {
                    done: !0,
                    value: void 0
                }, null);
                buffer[nextReadIndex] = new ReactPromise("pending", null, null);
            }
            return buffer[nextReadIndex++];
        });
    };
    resolveStream(response, id, iterator ? iterable[ASYNC_ITERATOR]() : iterable, {
        enqueueValue: function(value) {
            if (nextWriteIndex === buffer.length) buffer[nextWriteIndex] = new ReactPromise("fulfilled", {
                done: !1,
                value: value
            }, null);
            else {
                var chunk = buffer[nextWriteIndex], resolveListeners = chunk.value, rejectListeners = chunk.reason;
                chunk.status = "fulfilled";
                chunk.value = {
                    done: !1,
                    value: value
                };
                null !== resolveListeners && wakeChunkIfInitialized(chunk, resolveListeners, rejectListeners);
            }
            nextWriteIndex++;
        },
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(response, buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(response, buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(response, buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = new ReactPromise("pending", null, null)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(response, buffer[nextWriteIndex++], error);
        }
    });
}
function resolveErrorProd() {
    var error = Error("An error occurred in the Server Components render. The specific message is omitted in production builds to avoid leaking sensitive details. A digest property is included on this error instance which may provide additional details about the nature of the error.");
    error.stack = "Error: " + error.message;
    return error;
}
function mergeBuffer(buffer, lastChunk) {
    for(var l = buffer.length, byteLength = lastChunk.length, i = 0; i < l; i++)byteLength += buffer[i].byteLength;
    byteLength = new Uint8Array(byteLength);
    for(var i$53 = i = 0; i$53 < l; i$53++){
        var chunk = buffer[i$53];
        byteLength.set(chunk, i);
        i += chunk.byteLength;
    }
    byteLength.set(lastChunk, i);
    return byteLength;
}
function resolveTypedArray(response, id, buffer, lastChunk, constructor, bytesPerElement) {
    buffer = 0 === buffer.length && 0 === lastChunk.byteOffset % bytesPerElement ? lastChunk : mergeBuffer(buffer, lastChunk);
    constructor = new constructor(buffer.buffer, buffer.byteOffset, buffer.byteLength / bytesPerElement);
    resolveBuffer(response, id, constructor);
}
function processFullBinaryRow(response, id, tag, buffer, chunk) {
    switch(tag){
        case 65:
            resolveBuffer(response, id, mergeBuffer(buffer, chunk).buffer);
            return;
        case 79:
            resolveTypedArray(response, id, buffer, chunk, Int8Array, 1);
            return;
        case 111:
            resolveBuffer(response, id, 0 === buffer.length ? chunk : mergeBuffer(buffer, chunk));
            return;
        case 85:
            resolveTypedArray(response, id, buffer, chunk, Uint8ClampedArray, 1);
            return;
        case 83:
            resolveTypedArray(response, id, buffer, chunk, Int16Array, 2);
            return;
        case 115:
            resolveTypedArray(response, id, buffer, chunk, Uint16Array, 2);
            return;
        case 76:
            resolveTypedArray(response, id, buffer, chunk, Int32Array, 4);
            return;
        case 108:
            resolveTypedArray(response, id, buffer, chunk, Uint32Array, 4);
            return;
        case 71:
            resolveTypedArray(response, id, buffer, chunk, Float32Array, 4);
            return;
        case 103:
            resolveTypedArray(response, id, buffer, chunk, Float64Array, 8);
            return;
        case 77:
            resolveTypedArray(response, id, buffer, chunk, BigInt64Array, 8);
            return;
        case 109:
            resolveTypedArray(response, id, buffer, chunk, BigUint64Array, 8);
            return;
        case 86:
            resolveTypedArray(response, id, buffer, chunk, DataView, 1);
            return;
    }
    for(var stringDecoder = response._stringDecoder, row = "", i = 0; i < buffer.length; i++)row += stringDecoder.decode(buffer[i], decoderOptions);
    buffer = row += stringDecoder.decode(chunk);
    switch(tag){
        case 73:
            resolveModule(response, id, buffer);
            break;
        case 72:
            id = buffer[0];
            buffer = buffer.slice(1);
            response = JSON.parse(buffer, response._fromJSON);
            buffer = ReactDOMSharedInternals.d;
            switch(id){
                case "D":
                    buffer.D(response);
                    break;
                case "C":
                    "string" === typeof response ? buffer.C(response) : buffer.C(response[0], response[1]);
                    break;
                case "L":
                    id = response[0];
                    tag = response[1];
                    3 === response.length ? buffer.L(id, tag, response[2]) : buffer.L(id, tag);
                    break;
                case "m":
                    "string" === typeof response ? buffer.m(response) : buffer.m(response[0], response[1]);
                    break;
                case "X":
                    "string" === typeof response ? buffer.X(response) : buffer.X(response[0], response[1]);
                    break;
                case "S":
                    "string" === typeof response ? buffer.S(response) : buffer.S(response[0], 0 === response[1] ? void 0 : response[1], 3 === response.length ? response[2] : void 0);
                    break;
                case "M":
                    "string" === typeof response ? buffer.M(response) : buffer.M(response[0], response[1]);
            }
            break;
        case 69:
            tag = response._chunks;
            chunk = tag.get(id);
            buffer = JSON.parse(buffer);
            stringDecoder = resolveErrorProd();
            stringDecoder.digest = buffer.digest;
            chunk ? triggerErrorOnChunk(response, chunk, stringDecoder) : tag.set(id, new ReactPromise("rejected", null, stringDecoder));
            break;
        case 84:
            response = response._chunks;
            (tag = response.get(id)) && "pending" !== tag.status ? tag.reason.enqueueValue(buffer) : response.set(id, new ReactPromise("fulfilled", buffer, null));
            break;
        case 78:
        case 68:
        case 74:
        case 87:
            throw Error("Failed to read a RSC payload created by a development version of React on the server while using a production version on the client. Always use matching versions on the server and the client.");
        case 82:
            startReadableStream(response, id, void 0);
            break;
        case 114:
            startReadableStream(response, id, "bytes");
            break;
        case 88:
            startAsyncIterable(response, id, !1);
            break;
        case 120:
            startAsyncIterable(response, id, !0);
            break;
        case 67:
            (response = response._chunks.get(id)) && "fulfilled" === response.status && response.reason.close("" === buffer ? '"$undefined"' : buffer);
            break;
        default:
            tag = response._chunks, (chunk = tag.get(id)) ? resolveModelChunk(response, chunk, buffer) : tag.set(id, new ReactPromise("resolved_model", buffer, response));
    }
}
function createFromJSONCallback(response) {
    return function(key, value) {
        if ("string" === typeof value) return parseModelString(response, this, key, value);
        if ("object" === typeof value && null !== value) {
            if (value[0] === REACT_ELEMENT_TYPE) {
                if (key = {
                    $$typeof: REACT_ELEMENT_TYPE,
                    type: value[1],
                    key: value[2],
                    ref: null,
                    props: value[3]
                }, null !== initializingHandler) {
                    if (value = initializingHandler, initializingHandler = value.parent, value.errored) key = new ReactPromise("rejected", null, value.reason), key = createLazyChunkWrapper(key);
                    else if (0 < value.deps) {
                        var blockedChunk = new ReactPromise("blocked", null, null);
                        value.value = key;
                        value.chunk = blockedChunk;
                        key = createLazyChunkWrapper(blockedChunk);
                    }
                }
            } else key = value;
            return key;
        }
        return value;
    };
}
var callServer = null;
function callCurrentServerCallback(id, args) {
    if (!callServer) throw Error("No server callback has been registered. Call setServerCallback to register one.");
    return callServer(id, args);
}
function startReadingFromStream(response, stream, isSecondaryStream) {
    function progress(_ref2) {
        var value = _ref2.value;
        if (_ref2.done) isSecondaryStream || reportGlobalError(response, Error("Connection closed."));
        else {
            var i = 0, rowState = streamState._rowState;
            _ref2 = streamState._rowID;
            for(var rowTag = streamState._rowTag, rowLength = streamState._rowLength, buffer = streamState._buffer, chunkLength = value.length; i < chunkLength;){
                var lastIdx = -1;
                switch(rowState){
                    case 0:
                        lastIdx = value[i++];
                        58 === lastIdx ? rowState = 1 : _ref2 = _ref2 << 4 | (96 < lastIdx ? lastIdx - 87 : lastIdx - 48);
                        continue;
                    case 1:
                        rowState = value[i];
                        84 === rowState || 65 === rowState || 79 === rowState || 111 === rowState || 85 === rowState || 83 === rowState || 115 === rowState || 76 === rowState || 108 === rowState || 71 === rowState || 103 === rowState || 77 === rowState || 109 === rowState || 86 === rowState ? (rowTag = rowState, rowState = 2, i++) : 64 < rowState && 91 > rowState || 35 === rowState || 114 === rowState || 120 === rowState ? (rowTag = rowState, rowState = 3, i++) : (rowTag = 0, rowState = 3);
                        continue;
                    case 2:
                        lastIdx = value[i++];
                        44 === lastIdx ? rowState = 4 : rowLength = rowLength << 4 | (96 < lastIdx ? lastIdx - 87 : lastIdx - 48);
                        continue;
                    case 3:
                        lastIdx = value.indexOf(10, i);
                        break;
                    case 4:
                        lastIdx = i + rowLength, lastIdx > value.length && (lastIdx = -1);
                }
                var offset = value.byteOffset + i;
                if (-1 < lastIdx) rowLength = new Uint8Array(value.buffer, offset, lastIdx - i), processFullBinaryRow(response, _ref2, rowTag, buffer, rowLength), i = lastIdx, 3 === rowState && i++, rowLength = _ref2 = rowTag = rowState = 0, buffer.length = 0;
                else {
                    value = new Uint8Array(value.buffer, offset, value.byteLength - i);
                    buffer.push(value);
                    rowLength -= value.byteLength;
                    break;
                }
            }
            streamState._rowState = rowState;
            streamState._rowID = _ref2;
            streamState._rowTag = rowTag;
            streamState._rowLength = rowLength;
            return reader.read().then(progress).catch(error);
        }
    }
    function error(e) {
        reportGlobalError(response, e);
    }
    var streamState = {
        _rowState: 0,
        _rowID: 0,
        _rowTag: 0,
        _rowLength: 0,
        _buffer: []
    }, reader = stream.getReader();
    reader.read().then(progress).catch(error);
}
exports.createFromFetch = function(promiseForResponse, options) {
    var response = new ResponseInstance(null, null, null, callCurrentServerCallback, void 0, void 0, options && options.temporaryReferences ? options.temporaryReferences : void 0);
    promiseForResponse.then(function(r) {
        startReadingFromStream(response, r.body, !1);
    }, function(e) {
        reportGlobalError(response, e);
    });
    return getChunk(response, 0);
};
exports.createFromReadableStream = function(stream, options) {
    options = new ResponseInstance(null, null, null, callCurrentServerCallback, void 0, void 0, options && options.temporaryReferences ? options.temporaryReferences : void 0);
    startReadingFromStream(options, stream, !1);
    return getChunk(options, 0);
};
exports.createServerReference = function(id, exportName) {
    return createServerReference$1(id + "#" + exportName, callCurrentServerCallback);
};
exports.createTemporaryReferenceSet = function() {
    return new Map();
};
exports.encodeReply = function(value, options) {
    return new Promise(function(resolve, reject) {
        var abort = processReply(value, "", options && options.temporaryReferences ? options.temporaryReferences : void 0, resolve, reject);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(signal.reason);
            else {
                var listener = function() {
                    abort(signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
    });
};
exports.registerServerReference = function(reference, id) {
    registerBoundServerReference(reference, id, null);
    return reference;
};
exports.setServerCallback = function(fn) {
    callServer = fn;
};

},{"da607ba755542785":"gC2PC"}],"2n5QP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rscStream", ()=>rscStream);
let encoder = new TextEncoder();
let streamController;
let rscStream = new ReadableStream({
    start (controller) {
        if (typeof window === 'undefined') return;
        let handleChunk = (chunk)=>{
            if (typeof chunk === 'string') controller.enqueue(encoder.encode(chunk));
            else controller.enqueue(chunk);
        };
        window.__FLIGHT_DATA ||= [];
        window.__FLIGHT_DATA.forEach(handleChunk);
        window.__FLIGHT_DATA.push = (chunk)=>{
            handleChunk(chunk);
        };
        streamController = controller;
    }
});
if (typeof document !== 'undefined' && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>{
    streamController?.close();
});
else streamController?.close();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fRKjd":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9e932721f217f9f6");

},{"9e932721f217f9f6":"eIjR2"}],"eIjR2":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var Scheduler = require("934b50a50c275743"), React = require("56d30b16d84cc622"), ReactDOM = require("d42dbe4aacaa6df4");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate) throw Error(formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return assertIsMounted(parentA), fiber;
                if (parentB === b) return assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error(formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error(formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_FRAGMENT_TYPE:
            return "Fragment";
        case REACT_PROFILER_TYPE:
            return "Profiler";
        case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_PORTAL_TYPE:
            return "Portal";
        case REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, valueStack = [], index = -1;
function createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
}
function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
}
var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
}
function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
}
var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
}
var nextTransitionLane = 256, nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function claimNextTransitionLane() {
    var lane = nextTransitionLane;
    nextTransitionLane <<= 1;
    0 === (nextTransitionLane & 4194048) && (nextTransitionLane = 256);
    return lane;
}
function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
}
function createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        return ReactDOMSharedInternals.p = priority, fn();
    } finally{
        ReactDOMSharedInternals.p = previousPriority;
    }
}
var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                targetNode = getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
    var resources = root[internalRootNodeResourcesKey];
    resources || (resources = root[internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = !0;
}
var allNativeEvents = new Set(), registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
}
var VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
    illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var prefix, suffix;
function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
}
var reentry = !1;
function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return describeBuiltInComponentFrame(fiber.type);
        case 16:
            return describeBuiltInComponentFrame("Lazy");
        case 13:
            return describeBuiltInComponentFrame("Suspense");
        case 19:
            return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function trackValueOnNode(node) {
    var valueField = isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function track(node) {
    node._valueTracker || (node._valueTracker = trackValueOnNode(node));
}
function updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
        } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
}
function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error(formatProdErrorMessage(92));
            if (isArrayImpl(children)) {
                if (1 < children.length) throw Error(formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null, restoreQueue = null;
function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[internalPropsKey] || null;
                            if (!otherProps) throw Error(formatProdErrorMessage(90));
                            updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var isInsideEventHandler = !1;
function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
            if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
        }
    }
}
function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error(formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
if (canUseDOM) try {
    var options = {};
    Object.defineProperty(options, "passive", {
        get: function() {
            passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
} catch (e) {
    passiveBrowserEventsSupported = !1;
}
var root = null, startText = null, fallbackText = null;
function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
    return !0;
}
function functionThatReturnsFalse() {
    return !1;
}
function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
    view: 0,
    detail: 0
}), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
    }
}), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
    dataTransfer: 0
}), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
    relatedTarget: 0
}), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
    data: 0
}), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function getEventModifierState() {
    return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
}), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
}), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
    9,
    13,
    27,
    32
], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = !1;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var isComposing = !1;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            hasSpaceKeypress = !0;
            return SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
        target
    ] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var activeElement$1 = null, activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = !1;
if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$282;
    if (canUseDOM) {
        var isSupported$jscomp$inline_417 = "oninput" in document;
        if (!isSupported$jscomp$inline_417) {
            var element$jscomp$inline_418 = document.createElement("div");
            element$jscomp$inline_418.setAttribute("oninput", "return;");
            isSupported$jscomp$inline_417 = "function" === typeof element$jscomp$inline_418.oninput;
        }
        JSCompiler_inline_result$jscomp$282 = isSupported$jscomp$inline_417;
    } else JSCompiler_inline_result$jscomp$282 = !1;
    isInputEventSupported = JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
}
function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
}
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function getNodeForCharacterOffset(root, offset) {
    var node = getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = getLeafNode(node);
    }
}
function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
    }
    return element;
}
function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = activeElement)));
}
function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
}, prefixedEventNames = {}, style = {};
canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
simpleEventPluginEvents.push("scrollEnd");
function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: getStackByFiberInDevAndProd(source)
    };
}
var concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
    for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {};
function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case REACT_ACTIVITY_TYPE:
            return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case REACT_PROFILER_TYPE:
            return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
            return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
            return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case REACT_PROVIDER_TYPE:
                case REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress;
    treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress;
    } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
}
function pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
    for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
}
var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch(type){
        case "dialog":
            listenToNonDelegatedEvent("cancel", instance);
            listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], instance);
            break;
        case "source":
            listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            listenToNonDelegatedEvent("error", instance);
            listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            listenToNonDelegatedEvent("invalid", instance);
            initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            track(instance);
            break;
        case "select":
            listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children), track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = !0) : instance = !1;
    instance || throwOnHydrationMismatch(fiber);
}
function popToNextHostParent(fiber) {
    for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
        case 5:
        case 13:
            rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            rootOrSingletonContext = !0;
            return;
        default:
            hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return !1;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            nextHydratableInstance = getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = !1;
}
function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
    return queuedErrors;
}
function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [
        error
    ] : hydrationErrors.push(error);
}
var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error(formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function prepareToReadContext(workInProgress) {
    currentlyRenderingFiber$1 = workInProgress;
    lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
}
function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === lastContextDependency) {
        if (null === consumer) throw Error(formatProdErrorMessage(308));
        lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
}
var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function createCache() {
    return {
        controller: new AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
    });
}
var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
}
function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = {
    then: function() {}
};
function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function noop$3() {}
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$3, noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then(noop$3, noop$3);
            else {
                thenableState = workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error(formatProdErrorMessage(483));
}
var hasForceUpdate = !1;
function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = getRootForUpdatedFiber(fiber);
        markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root, lane);
    }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = !1;
function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = assign({}, newState, updateLane);
                            break a;
                        case 2:
                            hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
}
function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
}
var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
}
var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter$1 = 0, thenableState$1 = null, globalClientIdCounter = 0;
function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
    finishRenderingHooks(current);
    return nextRenderLanes;
}
function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = !1;
    thenableIndexCounter$1 = 0;
    thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState$1 = null);
        thenableIndexCounter$1 = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
        numberOfReRenders += 1;
        workInProgressHook = currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        ReactSharedInternals.H = HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
    if (didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        didScheduleRenderPhaseUpdate = !1;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = !1;
    thenableIndexCounter$1 = localIdCounter = 0;
    thenableState$1 = null;
}
function mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
}
function updateWorkInProgressHook() {
    if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === currentlyRenderingFiber.alternate) throw Error(formatProdErrorMessage(467));
            throw Error(formatProdErrorMessage(310));
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
}
function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function useThenable(thenable) {
    var index = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    thenable = trackUsedThenable(thenableState$1, thenable, index);
    index = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
}
function use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if ((renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
    hook = hook.queue;
    var create = subscribeToStore.bind(null, fiber, hook, subscribe);
    updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        pushSimpleEffect(9, createEffectInstance(), updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== (renderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function forceStoreRerender(fiber) {
    var root = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
}
function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            onActionError(actionQueue, node, error);
        } finally{
            ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        onActionError(actionQueue, node, error$38);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return onActionError(actionQueue, node, error);
    }) : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
    return newState;
}
function mountActionState(action, initialStateProp) {
    if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = currentlyRenderingFiber;
                if (isHydrating) {
                    if (nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                            for(var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            nextHydratableInstance = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(!1);
    inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = useThenable(currentStateHook);
    } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(9, createEffectInstance(), actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function updateRef() {
    return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(1 | hookFlags, createEffectInstance(), create, createDeps);
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function mountEffect(create, createDeps) {
    mountEffectImpl(8390656, 8, create, createDeps);
}
function updateEffect(create, createDeps) {
    updateEffectImpl(2048, 8, create, createDeps);
}
function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
    if (0 === (renderLanes & 42)) return didReceiveUpdate = !0, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
            dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
        } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
    } catch (error) {
        dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, requestUpdateLane());
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function noop$2() {}
function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(formFiber, queue, pendingState, sharedNotPendingObject, null === action ? noop$2 : function() {
        requestFormReset$1(formFiber);
        return action(formData);
    });
}
function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: sharedNotPendingObject,
        baseState: sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function requestFormReset$1(formFiber) {
    var resetStateQueue = ensureFormComponentIsStateful(formFiber).next.queue;
    dispatchSetStateInternal(formFiber, resetStateQueue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
}
function updateId() {
    return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = requestUpdateLane();
                fiber = createUpdate(lane);
                var root$41 = enqueueUpdate(provider, fiber, lane);
                null !== root$41 && (scheduleUpdateOnFiber(root$41, provider, lane), entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
}
function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root, lane);
    }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
}, HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            0 !== (workInProgressRootRenderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(9, createEffectInstance(), updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var JSCompiler_inline_result = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: function() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    }
}, HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
        return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
}, HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
        return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
}, thenableState = null, thenableIndexCounter = 0;
function unwrapThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    return trackUsedThenable(thenableState, thenable, index);
}
function coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
        current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case REACT_PORTAL_TYPE:
                    return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error(formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) {
                key = getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === SuspenseException || x === SuspenseActionException) throw x;
            var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
}
function pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && (shellBoundary = fiber);
        }
    } else reuseSuspenseHandlerOnStack(fiber);
}
function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
};
function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
}
function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function defaultOnUncaughtError(error) {
    reportGlobalError(error);
}
function defaultOnCaughtError(error) {
    console.error(error);
}
function defaultOnRecoverableError(error) {
    reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function createRootErrorUpdate(root, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        logUncaughtError(root, errorInfo);
    };
    return lane;
}
function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error(formatProdErrorMessage(435, sourceFiber.tag));
        }
        attachPingListener(root, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return !1;
    }
    if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error(formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
        wrapperError
    ] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress);
    nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && key && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress);
    null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && Component && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    resetHydrationState();
    workInProgress.flags |= 256;
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: getSuspendedCache()
    };
}
function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if (isHydrating) {
            showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
            if (isHydrating) {
                var nextInstance = nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== treeContextProvider ? {
                            id: treeContextId,
                            overflow: treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, hydrationParentFiber = workInProgress, nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
        pushPrimaryTreeSuspenseHandler(workInProgress);
        return mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = showFallback);
        else if (pushPrimaryTreeSuspenseHandler(workInProgress), isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error(formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
            "$?" === nextInstance.data || renderDidSuspendDelayIfPossible();
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, nextHydratableInstance = getNextHydratable(nextInstance.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && (idStack[idStackIndex++] = treeContextId, idStack[idStackIndex++] = treeContextOverflow, idStack[idStackIndex++] = treeContextProvider, treeContextId = current.id, treeContextOverflow = current.overflow, treeContextProvider = workInProgress), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = createWorkInProgress(digest, showFallback) : (showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
    pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    push(suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? !0 : !1;
}
function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
            resetHydrationState();
            break;
        case 27:
        case 5:
            pushHostContext(workInProgress);
            break;
        case 4:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                pushPrimaryTreeSuspenseHandler(workInProgress);
                current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            push(suspenseStackCursor, suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
        else {
            if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) shouldConstruct(lazyComponent) ? (current = resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error(formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error(formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                cloneUpdateQueue(current, workInProgress);
                processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                pushProvider(workInProgress, CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0);
                suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                        queueHydrationError(init);
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        nextHydratableInstance = getNextHydratable(current.firstChild);
                        hydrationParentFiber = workInProgress;
                        isHydrating = !0;
                        hydrationErrors = null;
                        rootOrSingletonContext = !0;
                        renderLanes = mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[internalInstanceKey] = workInProgress, lazyComponent[internalPropsKey] = current, setInitialProperties(lazyComponent, renderLanes, current), markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return pushHostContext(workInProgress), null === current && isHydrating && (lazyComponent = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, init = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = init, nextHydratableInstance = getNextHydratable(lazyComponent.firstChild)) : nextHydratableInstance = init), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && isHydrating) {
                if (init = lazyComponent = nextHydratableInstance) lazyComponent = canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(lazyComponent.firstChild), rootOrSingletonContext = !1, init = !0) : init = !1;
                init || throwOnHydrationMismatch(workInProgress);
            }
            pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = init);
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && isHydrating) {
                if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                current || throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, lazyComponent.value), reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), init = readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return prepareToReadContext(workInProgress), lazyComponent = readContext(CacheContext), null === current ? (init = peekCacheFromPool(), null === init && (init = workInProgressRoot, prevState = createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, init)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), pushProvider(workInProgress, CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, pushProvider(workInProgress, CacheContext, lazyComponent), lazyComponent !== init.cache && propagateContextChanges(workInProgress, [
                CacheContext
            ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
        resource = suspenseHandlerStackCursor.current;
        if (null !== resource && ((workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null !== shellBoundary : (workInProgressRootRenderLanes & 62914560) !== workInProgressRootRenderLanes && 0 === (workInProgressRootRenderLanes & 536870912) || resource !== shellBoundary)) throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return bubbleProperties(workInProgress), null;
        case 1:
            return bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            popProvider(CacheContext);
            popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
            bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? (markUpdate(workInProgress), null !== renderLanes ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            popHostContext(workInProgress);
            renderLanes = rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, markUpdate(workInProgress));
            }
            bubbleProperties(workInProgress);
            return null;
        case 5:
            popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[internalInstanceKey] = workInProgress;
                    current[internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch(setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && markUpdate(workInProgress);
                }
            }
            bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                current = rootInstanceStackCursor.current;
                if (popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || throwOnHydrationMismatch(workInProgress);
                } else current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error(formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error(formatProdErrorMessage(317));
                        type[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    type = !1;
                } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            bubbleProperties(workInProgress);
            return null;
        case 4:
            return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
        case 10:
            return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
        case 19:
            pop(suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                    } else 2 * now() - type.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = now(), workInProgress.sibling = null, current = suspenseStackCursor.current, push(suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return popHostContext(workInProgress), null;
        case 13:
            popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return pop(suspenseStackCursor), null;
        case 4:
            return popHostContainer(), null;
        case 10:
            return popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return popProvider(CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            popProvider(CacheContext);
            popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            popHostContext(interruptedWork);
            break;
        case 4:
            popHostContainer();
            break;
        case 13:
            popSuspenseHandler(interruptedWork);
            break;
        case 19:
            pop(suspenseStackCursor);
            break;
        case 10:
            popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            popSuspenseHandler(interruptedWork);
            popHiddenContext();
            null !== current && pop(resumedCache);
            break;
        case 24:
            popProvider(CacheContext);
    }
}
function commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            commitCallbacks(updateQueue, instance);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        setInitialProperties(singleton, type, props);
        singleton[internalInstanceKey] = finishedWork;
        singleton[internalPropsKey] = props;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
function commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    eventsEnabled = _enabled;
    root = getActiveElementDeep(root);
    if (hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    _enabled = !1;
    for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, nextEffect = root;
    else for(; null !== nextEffect;){
        firstChild = nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error(formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            nextEffect = root;
            break;
        }
        nextEffect = firstChild.return;
    }
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && commitClassCallbacks(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    commitCallbacks(finishedRoot, current);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && commitHostMount(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                prevProps = offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = flags;
                (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                offscreenSubtreeIsHidden = prevProps;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var hostParent = null, hostParentIsContainer = !1;
function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
            isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            releaseSingletonInstance(deletedFiber.stateNode);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = null;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            if (null !== hostParent) {
                if (hostParentIsContainer) try {
                    (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode.containerInfo;
            hostParentIsContainer = !0;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        retryIfBlockedOn(finishedRoot);
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
            throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if (isSingletonScope(parent.type)) {
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = currentHoistableRoot;
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        setInitialProperties(currentResource, flags, current);
                                        currentResource[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error(formatProdErrorMessage(468, flags));
                                }
                                currentResource[internalInstanceKey] = finishedWork;
                                markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    setTextContent(hoistableRoot, "");
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && (needsFormReset = !0);
            break;
        case 6:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            tagCaches = null;
            hoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(root.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            currentHoistableRoot = hoistableRoot;
            commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            currentHoistableRoot = flags;
            break;
        case 12:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            break;
        case 13:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            recursivelyTraverseMutationEffects(root, finishedWork);
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
    }
}
function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if (isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && (setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error(formatProdErrorMessage(161));
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
            recursivelyAccumulateSuspenseyCommit(fiber);
            currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, deletions, deletions.return);
                recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== nextEffect;){
        var fiber = nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
            cache = nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            detachFiberAfterEffects(cache);
            if (cache === fiber) {
                nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                break a;
            }
            nextEffect = returnFiber;
        }
    }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
function requestUpdateLane() {
    if (0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
    if (null !== ReactSharedInternals.T) {
        var actionScopeLane = currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : requestTransitionLane();
    }
    return resolveUpdatePriority();
}
function requestDeferredLane() {
    0 === workInProgressDeferredLane && (workInProgressDeferredLane = 0 === (workInProgressRootRenderLanes & 536870912) || isHydrating ? claimNextTransitionLane() : 536870912);
    var suspenseHandler = suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return workInProgressDeferredLane;
}
function scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    markRootUpdated$1(root, lane);
    if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = workInProgressRootRecoverableErrors;
                            workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                prepareFreshStack(root$jscomp$0, 0);
                markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error(formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error(formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
                    markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    ensureRootIsScheduled(root$jscomp$0);
}
function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if (suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: noop
        }, accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function resetWorkInProgressStack() {
    if (null !== workInProgress) {
        if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
        else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState = null, thenableIndexCounter = 0, interruptedWork = workInProgress;
        for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
    }
}
function prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    resetWorkInProgressStack();
    workInProgressRoot = root;
    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = !1;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    workInProgressRootDidAttachPingListener = !1;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function handleThrow(root, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
}
function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = workInProgressRootExitStatus;
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch(workInProgressSuspendedReason){
                case 8:
                    resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = workInProgressSuspendedReason;
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
}
function workLoopSync() {
    for(; null !== workInProgress;)performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            lanes = workInProgress;
            var thrownValue = workInProgressThrownValue;
            b: switch(workInProgressSuspendedReason){
                case 1:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if (isThenableResolved(thrownValue)) {
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root || (workInProgressSuspendedReason = 7);
                        ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : 1) {
                                workInProgressSuspendedReason = 0;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                    }
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error(formatProdErrorMessage(462));
            }
        }
        workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        handleThrow(root, thrownValue$169);
    }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
}
function workLoopConcurrentByScheduler() {
    for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
            break;
        case 11:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
            break;
        case 5:
            resetHooksOnUnwind(next);
        default:
            unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState = null;
    thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = 1;
        logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
        workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if (isHydrating || 1 === suspendedReason) root = !0;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
        else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root);
    } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
        if (null !== next) {
            workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            workInProgress = completedWork;
            return;
        }
        workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            workInProgress = unitOfWork;
            return;
        }
        workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
}
function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
            flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            transitions = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            spawnedLane = executionContext;
            executionContext |= 4;
            try {
                commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
            }
        }
        pendingEffectsStatus = 1;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
    }
}
function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                _enabled = !!eventsEnabled;
                selectionInformation = eventsEnabled = null;
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        pendingEffectsStatus = 2;
    }
}
function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        pendingEffectsStatus = 3;
    }
}
function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        requestPaint();
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
            injectedHook.onCommitFiberRoot(rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = ReactSharedInternals.T;
            remainingLanes = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
        flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
}
function flushPendingEffects(wasDelayedCommit) {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects(wasDelayedCommit);
}
function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return !1;
    var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        ReactSharedInternals.T = null;
        renderPriority = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
        pendingEffectsStatus = 0;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        commitPassiveUnmountOnFiber(root$jscomp$0.current);
        commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        executionContext = prevExecutionContext;
        flushSyncWorkAcrossRoots_impl(0, !1);
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
            injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root, remainingLanes);
    }
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                error = createClassErrorUpdate(2);
                instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
    root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
    mightHavePendingSyncWork = !0;
    didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root$174, root$174 === workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        isFlushingWork = !1;
    }
}
function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
}
function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && (shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane), currentEventTransitionLane = 0);
    for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
        root = next;
    }
    flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && cancelCallback$1(pingedLanes);
        switch(lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = IdlePriority;
                break;
            default:
                suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if (flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root, now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function performSyncWorkOnRoot(root, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root, lanes, !0);
}
function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
        0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
    });
}
function requestTransitionLane() {
    0 === currentEventTransitionLane && (currentEventTransitionLane = claimNextTransitionLane());
    return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
}
function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== currentEventTransitionLane) {
                                var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var i$jscomp$inline_1528 = 0; i$jscomp$inline_1528 < simpleEventPluginEvents.length; i$jscomp$inline_1528++){
    var eventName$jscomp$inline_1529 = simpleEventPluginEvents[i$jscomp$inline_1528], domEventName$jscomp$inline_1530 = eventName$jscomp$inline_1529.toLowerCase(), capitalizedEvent$jscomp$inline_1531 = eventName$jscomp$inline_1529[0].toUpperCase() + eventName$jscomp$inline_1529.slice(1);
    registerSimpleEvent(domEventName$jscomp$inline_1530, "on" + capitalizedEvent$jscomp$inline_1531);
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes));
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = !0;
        allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch(getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = SyntheticTouchEvent;
                        break;
                    case ANIMATION_END:
                    case ANIMATION_ITERATION:
                    case ANIMATION_START:
                        SyntheticEventCtor = SyntheticAnimationEvent;
                        break;
                    case TRANSITION_END:
                        SyntheticEventCtor = SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = getParent(inCapturePhase);
                                reactEventName = getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                else if (isTextInputElement(reactName)) {
                    if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = getTargetInstForInputEventPolyfill;
                        var handleEventFunc = handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                    break;
                case "focusout":
                    lastSelection = activeElementInst = activeElement = null;
                    break;
                case "mousedown":
                    mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    mouseDown = !1;
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if (skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if (canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function noop$1() {}
function setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
            break;
        case "className":
            setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
    }
}
function setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(formatProdErrorMessage(137, tag));
                    default:
                        setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            track(domElement);
            return;
        case "select":
            listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            listenToNonDelegatedEvent("cancel", domElement);
            listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(formatProdErrorMessage(137, tag));
                default:
                    setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, !0) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
            updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error(formatProdErrorMessage(137, tag));
                    break;
                default:
                    setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var eventsEnabled = null, selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return !1;
        currentPopstateTransitionEvent = event;
        return !0;
    }
    currentPopstateTransitionEvent = null;
    return !1;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
} : scheduleTimeout;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function isSingletonScope(type) {
    return "head" === type;
}
function clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    retryIfBlockedOn(suspenseInstance);
}
function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                clearContainerSparingly(node);
                detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var previousHydratableOnEnteringScopedSingleton = null;
function getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error(formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error(formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error(formatProdErrorMessage(454));
            return type;
        default:
            throw Error(formatProdErrorMessage(451));
    }
}
function releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
}
var preloadPropsMap = new Map(), preconnectsSet = new Set();
function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
    previousDispatcher.L(href, as, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = getStyleKey(href);
                break;
            case "script":
                key = getScriptKey(href);
        }
        preloadPropsMap.has(key) || (href = assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function preloadModule(href, options) {
    previousDispatcher.m(href, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = getScriptKey(href);
        }
        if (!preloadPropsMap.has(key) && (href = assign({
            rel: "modulepreload",
            href: href
        }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function preinitStyle(href, precedence, options) {
    previousDispatcher.S(href, precedence, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                markNodeAsHoistable(link);
                setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function preinitScript(src, options) {
    previousDispatcher.X(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function preinitModuleScript(src, options) {
    previousDispatcher.M(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = getStyleKey(pendingProps.href);
                var styles$244 = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector(getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, preloadPropsMap.set(type, pendingProps), styles$244 || preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error(formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error(formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error(formatProdErrorMessage(444, type));
    }
}
function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, markNodeAsHoistable(instance$250), instance$250;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(instance$250)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error(formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
        var cache = new Map();
        var caches = tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var suspendedState = null;
function noop() {}
function suspendResource(hoistableRoot, resource, props) {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = stylesheetPropsFromRawProps(props);
            (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function waitForCommitToBeReady() {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
};
function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
}
function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var _enabled = !0;
function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                ensureRootIsScheduled(fiber);
                                0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = findInstanceBlockingEvent(nativeEvent);
                null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    return_targetInst = targetNode;
    return null;
}
function getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch(getCurrentPriorityLevel()){
                case ImmediatePriority:
                    return 2;
                case UserBlockingPriority:
                    return 8;
                case NormalPriority$1:
                case LowPriority:
                    return 32;
                case IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = requestUpdateLane();
                            lane = getBumpedLaneForHydrationByLane(lane);
                            var root = enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && scheduleUpdateOnFiber(root, nearestMounted, lane);
                            markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            currentReplayingEvent = null;
        } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
    hasScheduledReplayAttempt = !1;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
        }
    }
}
function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
};
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        updateContainerImpl(root.current, 2, null, root, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
    }
};
function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
    }
};
var isomorphicReactPackageVersion$jscomp$inline_1785 = React.version;
if ("19.1.0" !== isomorphicReactPackageVersion$jscomp$inline_1785) throw Error(formatProdErrorMessage(527, isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error(formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2257.isDisabled && hook$jscomp$inline_2257.supportsFiber) try {
        rendererID = hook$jscomp$inline_2257.inject(internals$jscomp$inline_2256), injectedHook = hook$jscomp$inline_2257;
    } catch (err) {}
}
exports.createRoot = function(container, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[internalContainerInstanceKey] = options.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options);
};
exports.hydrateRoot = function(container, initialChildren, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    markRootUpdated$1(initialChildren, options);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
};
exports.version = "19.1.0";

},{"934b50a50c275743":"jI0VB","56d30b16d84cc622":"a1TxN","d42dbe4aacaa6df4":"gC2PC"}],"jI0VB":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1bf2b05c96b56e48");

},{"1bf2b05c96b56e48":"9V0xh"}],"9V0xh":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return needsPaint ? !0 : exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    needsPaint = !1;
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_requestPaint = function() {
    needsPaint = !0;
};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"515lj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeFold", ()=>CodeFold);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _chevron = require("../../../@react-spectrum/s2/ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _more = require("@react-spectrum/s2/icons/More");
var _moreDefault = parcelHelpers.interopDefault(_more);
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
'use client';
const trigger = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf111';
    else rules += ' _Le111';
    rules += ' Oh111';
    rules += ' _Mc111';
    rules += ' _Kd111';
    rules += ' oa111';
    rules += ' na111';
    rules += ' ka111';
    rules += ' ja111';
    rules += ' Td111';
    rules += ' Qd111';
    rules += ' Sd111';
    rules += ' Rd111';
    rules += ' Id111';
    rules += ' g9111';
    rules += ' _je111';
    rules += ' _740ub4c111';
    rules += ' u40ub4c111';
    rules += ' -_6BNtrc-cWI5gc111';
    rules += ' vx111';
    return rules;
};
const chevronStyles = function anonymous(props) {
    let rules = " ";
    if (props.isExpanded) rules += ' _Sd111';
    else if (props.isRTL) rules += ' _Sc111';
    rules += ' Yd111';
    rules += ' Xb111';
    rules += ' _2b111';
    rules += ' pt111';
    rules += ' -_8sjo0b-t5ZbAob111';
    rules += ' _va111';
    rules += ' Hs111';
    return rules;
};
const more = function anonymous(props) {
    let rules = " ";
    if (props.isPressed) rules += ' gF111';
    else if (props.isFocusVisible) rules += ' gF111';
    else if (props.isHovered) rules += ' gF111';
    else rules += ' gH111';
    rules += ' Yd111';
    rules += ' Xb111';
    rules += ' _2b111';
    rules += ' oa111';
    rules += ' na111';
    rules += ' ka111';
    rules += ' ja111';
    rules += ' Sp111';
    rules += ' Rp111';
    rules += ' Is111';
    rules += ' Hs111';
    rules += ' Ft111';
    rules += ' sh111';
    rules += ' eb111';
    rules += ' _5h111';
    rules += ' _4c111';
    rules += ' -_8sjo0b-tjQquMe111';
    return rules;
};
function CodeFold({ children }) {
    let ref = (0, _react.useRef)(null);
    let [firstLine, collapsed, lastLine] = (0, _react.useMemo)(()=>{
        let firstLine = [];
        let collapsed = [];
        let lastLine = [];
        // Iterate forward to find the first newline.
        for (let [i, child] of children.entries()){
            if (typeof child === 'string') {
                let index = child.indexOf('\n');
                if (index === 0) {
                    collapsed = children.slice(i);
                    break;
                } else if (index > 0) {
                    firstLine.push(child.slice(0, index));
                    if (index < child.length) collapsed.push(child.slice(index));
                    collapsed.push(...children.slice(i + 1));
                    break;
                }
            }
            firstLine.push(child);
        }
        // Iterate backward to find the last newline.
        for(let i = collapsed.length - 1; i >= 0; i--){
            let child = collapsed[i];
            if (typeof child === 'string') {
                let c = child;
                if (i === collapsed.length - 1) // Ignore the last newline if it is at the very end of the code.
                c = c.trimEnd();
                let index = c.lastIndexOf('\n');
                if (index === 0) break;
                else if (index > 0) {
                    lastLine.unshift(c.slice(index));
                    break;
                }
            }
            lastLine.unshift(child);
        }
        if (typeof collapsed[0] === 'string') collapsed[0] = collapsed[0].replace(/^\n/, '');
        if (typeof lastLine[0] === 'string') lastLine[0] = lastLine[0].trimStart();
        return [
            firstLine,
            collapsed,
            lastLine
        ];
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Disclosure), {
        children: ({ isExpanded })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "trigger",
                        className: trigger,
                        children: ({ isHovered, isPressed, isFocusVisible })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                        size: "S",
                                        "aria-hidden": true,
                                        className: chevronStyles({
                                            isExpanded,
                                            isHovered,
                                            isPressed,
                                            isFocusVisible
                                        })
                                    }),
                                    firstLine,
                                    !isExpanded ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                ref: ref,
                                                style: (0, _s2.pressScale)(ref)({
                                                    isPressed
                                                }),
                                                className: more({
                                                    isHovered,
                                                    isPressed,
                                                    isFocusVisible
                                                }),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreDefault.default), {
                                                    UNSAFE_style: {
                                                        width: 14
                                                    }
                                                })
                                            }),
                                            lastLine
                                        ]
                                    }) : null
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DisclosurePanel), {
                        children: collapsed
                    })
                ]
            })
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","react/jsx-runtime":"2Is6Z","react-aria-components":"2Emk2","../../../@react-spectrum/s2/ui-icons/Chevron":"1904U","@react-spectrum/s2/icons/More":"gP3id","@react-spectrum/s2":"5H6IX","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"el6b6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "getAnchorProps", ()=>getAnchorProps);
parcelHelpers.export(exports, "ColorLink", ()=>ColorLink);
parcelHelpers.export(exports, "CodeLink", ()=>CodeLink);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function Link({ href, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
        ...props,
        href: href,
        ...getAnchorProps(href)
    });
}
function getAnchorProps(href) {
    if (!/^http/.test(href) || /localhost|reactspectrum\.blob\.core\.windows\.net|react-spectrum\.(corp\.)?adobe\.com|^#/.test(href)) return {};
    if (/^\//.test(href)) return {};
    return {
        target: '_blank',
        rel: 'noreferrer'
    };
}
const colorLink = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf111';
    else rules += ' _Le111';
    rules += ' Oh111';
    rules += ' _Mc111';
    rules += ' _Kd111';
    rules += ' oa111';
    rules += ' na111';
    rules += ' ka111';
    rules += ' ja111';
    if (props.type === "variable") rules += ' p1gYRFc111';
    else if (props.type === "keyword") rules += ' pplLfSc111';
    else rules += ' p37ZLpd111';
    rules += ' plf111';
    rules += ' _Xb111';
    rules += ' __Va111';
    rules += ' __ca111';
    rules += ' ry111';
    return rules;
};
function ColorLink({ type, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        className: (r)=>colorLink({
                ...r,
                type
            })
    });
}
function CodeLink(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        style: ({ isHovered })=>({
                textDecorationStyle: isHovered ? 'solid' : 'dotted'
            })
    });
}

},{"0":"fzJz7","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","react-aria-components":"2Emk2","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fzJz7":[function() {},{}],"ayXXD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconPicker", ()=>IconPicker);
parcelHelpers.export(exports, "VisualExampleClient", ()=>VisualExampleClient);
parcelHelpers.export(exports, "Output", ()=>Output);
parcelHelpers.export(exports, "CodeOutput", ()=>CodeOutput);
parcelHelpers.export(exports, "CodeProps", ()=>CodeProps);
parcelHelpers.export(exports, "Control", ()=>Control);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _addCircle = require("@react-spectrum/s2/icons/AddCircle");
var _addCircleDefault = parcelHelpers.interopDefault(_addCircle);
var _codePlatter = require("./CodePlatter");
var _exampleOutput = require("./ExampleOutput");
var _exampleSwitcher = require("./ExampleSwitcher");
var _reactDom = require("react-dom");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _runtime = require("../../../@react-spectrum/s2/style/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _removeCircle = require("@react-spectrum/s2/icons/RemoveCircle");
var _removeCircleDefault = parcelHelpers.interopDefault(_removeCircle);
var _reactAria = require("react-aria");
'use client';
const IconPicker = /*#__PURE__*/ (0, _react.lazy)(()=>require("78276cdf15345291").then(({ IconPicker })=>({
            default: IconPicker
        })));
const Context = /*#__PURE__*/ (0, _react.createContext)({
    component: 'div',
    name: 'Button',
    controls: {},
    props: {},
    setProps: ()=>{}
});
function VisualExampleClient({ component, name, importSource, controls, children, initialProps = {}, propsObject }) {
    let [props, setProps] = (0, _react.useState)(()=>{
        let props = {
            ...initialProps
        };
        for(let name in controls){
            let defaultValue = controls[name].default;
            if (!(name in initialProps)) props[name] = defaultValue;
            if (controls[name].value.type === 'interface' && controls[name].value.name === 'Size') {
                if (typeof props[name] === 'object') props[name] = new (0, _reactAriaComponents.Size)(props[name].width, props[name].height);
                else delete props[name];
            }
        }
        return props;
    });
    let ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        // Find previous heading element.
        let node = ref.current;
        while(node && node.parentElement?.tagName !== 'ARTICLE')node = node.parentElement;
        while(node && !(node instanceof HTMLHeadingElement))node = node.previousElementSibling;
        let id = node instanceof HTMLHeadingElement ? node.id : null;
        if (id && location.hash === '#' + id) {
            let params = new URLSearchParams(location.search);
            let newProps = {
                ...props
            };
            for (let [name, value] of params)try {
                if (value) newProps[name] = JSON.parse(value);
            } catch  {
            // ignore
            }
            setProps(newProps);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Context.Provider, {
        value: {
            component,
            name,
            importSource,
            controls,
            props,
            setProps,
            propsObject
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                hidden: true,
                ref: ref
            }),
            children
        ]
    });
}
function Output({ align = 'center', acceptOrientation }) {
    let { component, props, propsObject } = (0, _react.useContext)(Context);
    if (!/*#__PURE__*/ (0, _react.isValidElement)(component)) {
        let children = props.children;
        if (children?.iconJSX || children?.avatar || children?.badge) children = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                children.avatar ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Avatar), {
                    src: "https://i.imgur.com/xIe7Wlb.png"
                }) : children.iconJSX,
                children.text && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                    children: children.text
                }),
                children.badge && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NotificationBadge), {
                    value: 12
                })
            ]
        });
        else if (children?.text != null) children = children.text;
        props = {
            ...props,
            children
        };
    }
    if (props.contextualHelp) props = {
        ...props,
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ContextualHelp), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                    children: "Heading"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Content), {
                    children: "Content"
                })
            ]
        })
    };
    if (propsObject) props = {
        [propsObject]: props
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleOutput.ExampleOutput), {
        component: component,
        props: props,
        align: align,
        orientation: acceptOrientation ? props.orientation : undefined
    });
}
function CodeOutput({ code, files, type, registryUrl }) {
    let { name, importSource, props, controls, propsObject } = (0, _react.useContext)(Context);
    let searchParams = new URLSearchParams();
    let exampleType = (0, _react.useContext)((0, _exampleSwitcher.ExampleSwitcherContext));
    if (exampleType) searchParams.set('exampleType', String(exampleType));
    for(let prop in props){
        let value = props[prop];
        if (value != null && controls[prop] != null && (controls[prop].default == null || value !== controls[prop].default)) searchParams.set(prop, JSON.stringify(value));
    }
    let url = '?' + searchParams.toString();
    if (propsObject) props = {
        [propsObject]: props
    };
    code ||= /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codePlatter.Pre), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
            children: [
                importSource ? renderImports(name, importSource, props) : null,
                renderElement(name, props, controls)
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codePlatter.CodePlatter), {
        shareUrl: url,
        files: files,
        type: type,
        registryUrl: registryUrl,
        children: code
    });
}
function CodeProps({ indent = '' }) {
    let { props, controls, propsObject } = (0, _react.useContext)(Context);
    if (propsObject) props = {
        [propsObject]: props
    };
    let renderedProps = Object.keys(props).filter((prop)=>prop !== 'children').map((prop)=>renderProp(prop, props[prop], controls[prop], indent)).filter(Boolean);
    let newlines = indent.length > 0 || countChars(renderedProps) > 40;
    let separator = newlines ? indent || '  ' : ' ';
    renderedProps = renderedProps.map((p, i)=>{
        let sep = separator;
        if (newlines) sep = (indent && i === 0 ? '' : '\n') + separator;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
            children: [
                sep,
                p
            ]
        }, i);
    });
    if (newlines && indent && renderedProps.length) renderedProps.push('\n');
    return renderedProps;
}
function renderElement(name, props, controls, indent = '') {
    let start = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            "<",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " p37ZLpd111",
                children: name
            })
        ]
    });
    let renderedProps = Object.keys(props).filter((prop)=>prop !== 'children').map((prop)=>renderProp(prop, props[prop], controls?.[prop], '  ' + indent)).filter(Boolean);
    let newlines = name.length + countChars(renderedProps) > 40;
    renderedProps = renderedProps.map((p, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
            children: [
                newlines ? '\n  ' + indent : ' ',
                p
            ]
        }, i));
    if (props.children) {
        let end = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "</",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: " p37ZLpd111",
                    children: name
                }),
                ">"
            ]
        });
        let children = renderChildren(props.children, indent);
        if (typeof children !== 'string') newlines = true;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                start,
                renderedProps,
                ">",
                newlines ? '\n  ' + indent : null,
                children,
                newlines ? '\n' + indent : null,
                end
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            start,
            renderedProps,
            " />"
        ]
    });
}
function renderChildren(children, indent = '') {
    if (children?.icon || children?.avatar || children?.badge) {
        let result = null;
        if (children.avatar) result = renderElement('Avatar', {
            src: 'https://i.imgur.com/xIe7Wlb.png'
        }, undefined, indent);
        else if (children.icon) result = renderElement(children.icon.replace(/^(\d)/, '_$1'), {}, undefined, indent);
        if (children.text) {
            let text = renderElement('Text', {
                children: children.text
            }, undefined, indent);
            result = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    result,
                    result ? '\n  ' + indent : null,
                    text
                ]
            });
        }
        if (children.badge) {
            let badge = renderElement('NotificationBadge', {
                value: 12
            }, undefined, indent);
            result = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    result,
                    result ? '\n  ' + indent : null,
                    badge
                ]
            });
        }
        return result;
    } else if (children?.text) return children.text;
    else if (Array.isArray(children)) return children.map((c, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                i > 0 ? '\n  ' + indent : null,
                c
            ]
        }, i));
    return children;
}
function countChars(element) {
    if (typeof element === 'string') return element.length;
    else if (Array.isArray(element)) return element.reduce((p, i)=>p + countChars(i), 0);
    else if (element && typeof element === 'object' && 'props' in element && element.props) return countChars(element.props.children);
    return 0;
}
function renderProp(name, value, control, indent = '') {
    if (value === control?.default) return null;
    let propName = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: " pz2bZib111",
        children: name
    });
    let propValue = null;
    if (typeof value === 'string') propValue = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: " p8wMsQe111",
        children: [
            '"',
            value,
            '"'
        ]
    });
    else if (typeof value === 'number') propValue = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            '{',
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " pG3CxWc111",
                children: String(value)
            }),
            '}'
        ]
    });
    else if (typeof value === 'boolean') {
        if (value === false && control?.optional) return null;
        if (name === 'contextualHelp') {
            let res = renderElement('ContextualHelp', {
                children: [
                    renderElement('Heading', {
                        children: 'Heading'
                    }),
                    renderElement('Content', {
                        children: 'Content'
                    })
                ]
            }, undefined, indent + '    ');
            propValue = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    `{\n    ${indent}`,
                    res,
                    `\n  ${indent}}`
                ]
            });
        } else propValue = value === false ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                '{',
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: " pplLfSc111",
                    children: String(value)
                }),
                '}'
            ]
        }) : null;
    } else if (value == null) return null;
    else if (typeof value === 'object') propValue = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            '{',
            renderValue(value, indent),
            '}'
        ]
    });
    if (propValue) propValue = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            "=",
            propValue
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            propName,
            propValue
        ]
    }, name);
}
function renderValue(value, indent = '') {
    switch(typeof value){
        case 'string':
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: " p8wMsQe111",
                children: [
                    '"',
                    value,
                    '"'
                ]
            });
        case 'number':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " pG3CxWc111",
                children: String(value)
            });
        case 'boolean':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " pplLfSc111",
                children: String(value)
            });
        case 'object':
            {
                if (value == null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: " pplLfSc111",
                    children: String(value)
                });
                if (Array.isArray(value)) {
                    let res = value.map((item, i)=>{
                        let result = renderValue(item, indent);
                        if (i < value.length - 1) result = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                result,
                                ", "
                            ]
                        });
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                            children: result
                        }, i);
                    });
                    if (countChars(res) > 40) {
                        res = res.map((p, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                children: [
                                    '\n  ' + indent,
                                    p
                                ]
                            }, i));
                        res.push('\n  ');
                    }
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            '[',
                            res,
                            ']'
                        ]
                    });
                }
                if (value instanceof (0, _reactAriaComponents.Size)) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " pplLfSc111",
                            children: "new"
                        }),
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " p37ZLpd111",
                            children: "Size"
                        }),
                        "(",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " pG3CxWc111",
                            children: value.width
                        }),
                        ", ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " pG3CxWc111",
                            children: value.height
                        }),
                        ")"
                    ]
                });
                let entries = Object.entries(value);
                let res = entries.map(([name, value], i)=>{
                    let result = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: " pz2bZib111",
                                children: name
                            }),
                            ": ",
                            renderValue(value, indent)
                        ]
                    });
                    if (i < entries.length - 1) result = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            result,
                            ", "
                        ]
                    });
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                        children: result
                    }, i);
                });
                if (countChars(res) > 40) {
                    res = res.map((p, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                            children: [
                                '\n  ' + indent,
                                p
                            ]
                        }, i));
                    res.push('\n' + indent);
                }
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        '{',
                        res,
                        '}'
                    ]
                });
            }
    }
}
function renderImports(name, importSource, props) {
    let imports = [];
    let components = [
        name
    ];
    if (props.children?.avatar) components.push('Avatar');
    if (props.children?.badge) components.push('NotificationBadge');
    if (components.length > 1 || props.children?.icon) components.push('Text');
    if (props.contextualHelp) components.push('ContextualHelp', 'Heading', 'Content');
    imports.push(renderImport(components.join(', '), importSource));
    if (props.children?.icon && !props.children?.avatar) imports.push('\n', renderImport(props.children.icon.replace(/^(\d)/, '_$1'), `@react-spectrum/s2/icons/${props.children.icon}`, true));
    imports.push('\n\n');
    return imports;
}
function renderImport(name, from, isDefault = false) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " pplLfSc111",
                children: "import"
            }),
            " ",
            isDefault ? null : '{',
            name,
            isDefault ? null : '}',
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " pplLfSc111",
                children: "from"
            }),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: " p8wMsQe111",
                children: [
                    "'",
                    from,
                    "'"
                ]
            }),
            ";"
        ]
    }, from);
}
function Control({ name }) {
    let { controls, props, setProps } = (0, _react.useContext)(Context);
    let control = controls[name];
    let value = props[name];
    let onChange = (value)=>{
        setProps((props)=>({
                ...props,
                [name]: value
            }));
    };
    switch(control.value.type){
        case 'boolean':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BooleanControl, {
                control: control,
                value: value,
                onChange: onChange
            });
        case 'union':
            if (name === 'channel' || name === 'xChannel' || name === 'yChannel') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChannelControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            if (name === 'colorSpace') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSpaceControl, {
                control: control,
                value: value
            });
            if (name === 'placement' && control.value.elements.length === 22) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnionControl, {
                control: control,
                value: value,
                onChange: onChange
            });
        case 'number':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NumberControl, {
                control: control,
                value: value,
                onChange: onChange
            });
        case 'identifier':
            if (control.value.name === 'Intl.NumberFormatOptions') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NumberFormatControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            if (name === 'contextualHelp') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BooleanControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            if (control.value.name === 'ReactNode') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChildrenControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            break;
        case 'string':
            if (name === 'locale') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LocaleControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StringControl, {
                control: control,
                value: value,
                onChange: onChange
            });
        case 'interface':
            if (control.value.name === 'DateDuration') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DurationControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            if (control.value.name === 'Size') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SizeControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            break;
        case 'array':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ArrayControl, {
                control: control,
                valueType: control.value.elementType,
                value: value,
                onChange: onChange
            });
        case 'application':
            if (control.value.base.type === 'identifier' && (control.value.base.name === 'ReadonlyArray' || control.value.base.name === 'Array')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ArrayControl, {
                control: control,
                value: value,
                valueType: control.value.typeParameters[0],
                onChange: onChange
            });
        default:
            if (name === 'children') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StringControl, {
                control: control,
                value: value,
                onChange: onChange
            });
            console.warn(control);
    }
}
function BooleanControl({ control, value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Wrapper, {
        control: control,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Switch), {
            isSelected: value || false,
            onChange: onChange,
            "aria-label": control.name
        })
    });
}
function UnionControl({ control, value, onChange, isPicker = false }) {
    let length = control.value.elements.reduce((p, v)=>p + v.value, '').length;
    if (isPicker || control.options?.control === 'picker' || length > 18) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
        label: control.name,
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
            control: control
        }),
        selectedKey: value == null && control.optional && !control.default ? '__none' : value,
        onSelectionChange: (v)=>onChange(v === '__none' ? null : v),
        styles: " ZVouohd111",
        children: [
            control.optional && !control.default ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                id: "__none",
                children: "Default"
            }) : null,
            control.value.elements.filter((e)=>e.value).map((element)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                    id: element.value,
                    children: String(element.value)
                }, element.value))
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Wrapper, {
        control: control,
        styles: function anonymous(props) {
            let rules = " ";
            rules += ' z2mU111';
            if (props.isLong) rules += ' yzZKy111';
            else rules += ' y2mU111';
            return rules;
        }({
            isLong: length > 12 || control.value.elements.length > 3
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButtonGroup), {
            "aria-label": control.name,
            disallowEmptySelection: !control.optional || !!control.default,
            selectedKeys: [
                value
            ],
            onSelectionChange: (keys)=>onChange([
                    ...keys
                ][0]),
            density: "compact",
            styles: " Js111 Gs111",
            children: control.value.elements.map((element)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                    id: element.value,
                    styles: " _ub111 _upa111",
                    children: element.value
                }, element.value))
        })
    });
}
function Wrapper({ control, children, styles, ref }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        className: (0, _runtime.mergeStyles)(" sd111 _ta111 Ub111 qb111", styles),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: " uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-c111 vx111 wb111 xb111 _xa111 _Fd111 _FezxGHba111 _FnuYUweb111 pv111 __Za111",
                children: [
                    control.name,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: " _7c111",
                        children: [
                            "\xa0",
                            control.description ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    display: 'inline-flex'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
                                    control: control
                                })
                            }) : null
                        ]
                    })
                ]
            }),
            children
        ]
    });
}
function PropContextualHelp({ control }) {
    if (!control.description) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ContextualHelp), {
        variant: "info",
        size: "XS",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                children: control.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Content), {
                children: control.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Footer), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                    className: " uj111 -_6BNtrc-b111 vx111 wb111 xb111 _xa111 _Fb111 _FnuYUwec111 pt111",
                    children: control.valueType
                })
            })
        ]
    });
}
function NumberControl({ control, value, onChange }) {
    if (control.options?.control === 'slider') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Slider), {
        label: control.name,
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
            control: control
        }),
        value: value,
        onChange: onChange,
        styles: " ZVouohd111"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
        label: control.name,
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
            control: control
        }),
        value: value,
        onChange: onChange,
        styles: " ZVouohd111",
        minValue: control.options?.minValue,
        maxValue: control.options?.maxValue,
        formatOptions: control.name === 'delay' || control.name === 'closeDelay' ? {
            style: 'unit',
            unit: 'millisecond'
        } : undefined
    });
}
function NumberFormatControl({ control, value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
                label: control.name,
                contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
                    control: control
                }),
                selectedKey: value?.style || 'decimal',
                onSelectionChange: (id)=>{
                    switch(id){
                        case 'decimal':
                            onChange({
                                style: 'decimal'
                            });
                            break;
                        case 'percent':
                            onChange({
                                style: 'percent'
                            });
                            break;
                        case 'currency':
                            onChange({
                                style: 'currency',
                                currency: 'USD'
                            });
                            break;
                        case 'unit':
                            onChange({
                                style: 'unit',
                                unit: 'inch'
                            });
                            break;
                    }
                },
                styles: " ZVouohd111",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "decimal",
                        children: "Decimal"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "percent",
                        children: "Percent"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "currency",
                        children: "Currency"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "unit",
                        children: "Unit"
                    })
                ]
            }),
            control.options?.showDetails && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.RangeSlider), {
                        label: "Decimals",
                        value: {
                            start: value?.minimumFractionDigits ?? 0,
                            end: value?.maximumFractionDigits ?? 5
                        },
                        minValue: 0,
                        maxValue: 5,
                        onChange: (v)=>onChange({
                                ...value,
                                minimumFractionDigits: v.start,
                                maximumFractionDigits: v.end
                            }),
                        styles: " ZVouohd111"
                    }),
                    value?.style === 'decimal' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
                        label: "Sign Display",
                        selectedKey: value?.signDisplay ?? 'auto',
                        onSelectionChange: (signDisplay)=>onChange({
                                ...value,
                                signDisplay
                            }),
                        styles: " ZVouohd111",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "auto",
                                children: "Auto"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "always",
                                children: "Always"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "exceptZero",
                                children: "Except zero"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "negative",
                                children: "Negative"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "never",
                                children: "Never"
                            })
                        ]
                    }),
                    value?.style === 'currency' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBox), {
                                label: "Currency",
                                selectedKey: value.currency,
                                onSelectionChange: (currency)=>onChange({
                                        ...value,
                                        currency
                                    }),
                                styles: " ZVouohd111",
                                children: Intl.supportedValuesOf('currency').map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBoxItem), {
                                        id: c,
                                        children: c
                                    }, c))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnionControl, {
                                control: {
                                    name: 'Currency Display',
                                    optional: true,
                                    default: 'symbol',
                                    value: {
                                        elements: [
                                            {
                                                value: 'code'
                                            },
                                            {
                                                value: 'symbol'
                                            },
                                            {
                                                value: 'narrowSymbol'
                                            },
                                            {
                                                value: 'name'
                                            }
                                        ]
                                    }
                                },
                                value: value.currencyDisplay ?? 'symbol',
                                onChange: (currencyDisplay)=>onChange({
                                        ...value,
                                        currencyDisplay
                                    })
                            })
                        ]
                    }),
                    value?.style === 'unit' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBox), {
                                label: "Unit",
                                selectedKey: value.unit,
                                onSelectionChange: (unit)=>onChange({
                                        ...value,
                                        unit
                                    }),
                                styles: " ZVouohd111",
                                children: Intl.supportedValuesOf('unit').map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBoxItem), {
                                        id: c,
                                        children: c
                                    }, c))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnionControl, {
                                control: {
                                    name: 'Unit Display',
                                    optional: true,
                                    default: 'short',
                                    value: {
                                        elements: [
                                            {
                                                value: 'narrow'
                                            },
                                            {
                                                value: 'short'
                                            },
                                            {
                                                value: 'long'
                                            }
                                        ]
                                    }
                                },
                                value: value.unitDisplay ?? 'short',
                                onChange: (unitDisplay)=>onChange({
                                        ...value,
                                        unitDisplay
                                    })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function StringControl({ control, value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TextField), {
        label: control.name,
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
            control: control
        }),
        value: value || '',
        onChange: onChange,
        styles: " ZVouohd111"
    });
}
function ChildrenControl({ control, value, onChange }) {
    if (control.slots) {
        let objectValue = typeof value === 'string' ? {
            text: value
        } : value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Wrapper, {
            control: control,
            styles: " z2mU111 yzZKy111",
            children: [
                control.slots.icon && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " sd111 Ub111 qb111",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TextField), {
                            "aria-label": control.name,
                            value: objectValue?.text || '',
                            onChange: (text)=>onChange({
                                    ...objectValue,
                                    text
                                }),
                            styles: " ZKniM111 _ub111"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconPicker, {
                            value: value,
                            onChange: onChange
                        })
                    ]
                }),
                (control.slots.avatar || control.slots.badge) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                    density: "compact",
                    isJustified: true,
                    children: [
                        control.slots.avatar && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                            isSelected: objectValue?.avatar ?? false,
                            onChange: (avatar)=>onChange({
                                    ...objectValue,
                                    avatar
                                }),
                            children: "Avatar"
                        }),
                        control.slots.badge && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                            isSelected: objectValue?.badge ?? false,
                            onChange: (badge)=>onChange({
                                    ...objectValue,
                                    badge
                                }),
                            children: "Badge"
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StringControl, {
        control: control,
        value: value,
        onChange: onChange
    });
}
// https://github.com/unicode-org/cldr/blob/22af90ae3bb04263f651323ce3d9a71747a75ffb/common/supplemental/supplementalData.xml#L4649-L4664
const preferences = [
    // Tier 1
    {
        value: 'fr-FR'
    },
    {
        value: 'fr-CA'
    },
    {
        value: 'de-DE'
    },
    {
        value: 'en-US'
    },
    {
        value: 'en-GB'
    },
    {
        value: 'ja-JP',
        ordering: 'gregory japanese'
    },
    // // Tier 2
    {
        value: 'da-DK'
    },
    {
        value: 'nl-NL'
    },
    {
        value: 'fi-FI'
    },
    {
        value: 'it-IT'
    },
    {
        value: 'nb-NO'
    },
    {
        value: 'es-ES'
    },
    {
        value: 'sv-SE'
    },
    {
        value: 'pt-BR'
    },
    // // Tier 3
    {
        value: 'zh-CN'
    },
    {
        value: 'zh-TW',
        ordering: 'gregory roc chinese'
    },
    {
        value: 'ko-KR'
    },
    // // Tier 4
    {
        value: 'bg-BG'
    },
    {
        value: 'hr-HR'
    },
    {
        value: 'cs-CZ'
    },
    {
        value: 'et-EE'
    },
    {
        value: 'hu-HU'
    },
    {
        value: 'lv-LV'
    },
    {
        value: 'lt-LT'
    },
    {
        value: 'pl-PL'
    },
    {
        value: 'ro-RO'
    },
    {
        value: 'ru-RU'
    },
    {
        value: 'sr-SP'
    },
    {
        value: 'sk-SK'
    },
    {
        value: 'sl-SI'
    },
    {
        value: 'tr-TR'
    },
    {
        value: 'uk-UA'
    },
    // // Tier 5
    {
        value: 'ar-AE',
        ordering: 'gregory islamic-umalqura islamic islamic-civil islamic-tbla'
    },
    {
        value: 'ar-DZ',
        ordering: 'gregory islamic islamic-civil islamic-tbla'
    },
    {
        value: 'ar-EG',
        ordering: 'gregory coptic islamic islamic-civil islamic-tbla'
    },
    {
        value: 'ar-SA',
        ordering: 'islamic-umalqura gregory islamic islamic-rgsa'
    },
    {
        value: 'el-GR'
    },
    {
        value: 'he-IL',
        ordering: 'gregory hebrew islamic islamic-civil islamic-tbla'
    },
    {
        value: 'fa-AF',
        ordering: 'persian gregory islamic islamic-civil islamic-tbla'
    },
    // {territories: 'CN CX HK MO SG', ordering: 'gregory chinese'},
    {
        value: 'am-ET',
        ordering: 'gregory ethiopic ethioaa'
    },
    {
        value: 'hi-IN',
        ordering: 'gregory indian'
    },
    // {territories: 'KR', ordering: 'gregory dangi'},
    {
        value: 'th-TH',
        ordering: 'buddhist gregory'
    }
];
const calendars = [
    {
        key: 'gregory',
        name: 'Gregorian'
    },
    {
        key: 'japanese',
        name: 'Japanese'
    },
    {
        key: 'buddhist',
        name: 'Buddhist'
    },
    {
        key: 'roc',
        name: 'Taiwan'
    },
    {
        key: 'persian',
        name: 'Persian'
    },
    {
        key: 'indian',
        name: 'Indian'
    },
    {
        key: 'islamic-umalqura',
        name: 'Islamic (Umm al-Qura)'
    },
    {
        key: 'islamic-civil',
        name: 'Islamic Civil'
    },
    {
        key: 'islamic-tbla',
        name: 'Islamic Tabular'
    },
    {
        key: 'hebrew',
        name: 'Hebrew'
    },
    {
        key: 'coptic',
        name: 'Coptic'
    },
    {
        key: 'ethiopic',
        name: 'Ethiopic'
    },
    {
        key: 'ethioaa',
        name: 'Ethiopic (Amete Alem)'
    }
];
function matchLocale(defaultLocale) {
    let parsed;
    try {
        parsed = new Intl.Locale(defaultLocale);
    } catch  {
        return 'en-US';
    }
    let locales = preferences.map((p)=>new Intl.Locale(p.value));
    // Try with both language and region first, and if that fails, try again with just language
    let p = locales.find((locale)=>locale.language === parsed.language && locale.region === parsed.region) || locales.find((locale)=>locale.language === parsed.language);
    return p?.toString() || 'en-US';
}
function LocaleControl({ control, value, onChange }) {
    let { locale: defaultLocale } = (0, _reactAria.useLocale)();
    let langDisplay = (0, _react.useMemo)(()=>new Intl.DisplayNames(defaultLocale, {
            type: 'language'
        }), [
        defaultLocale
    ]);
    let regionDisplay = (0, _react.useMemo)(()=>new Intl.DisplayNames(defaultLocale, {
            type: 'region'
        }), [
        defaultLocale
    ]);
    let locales = (0, _react.useMemo)(()=>{
        return preferences.map((item)=>{
            let locale = new Intl.Locale(item.value);
            return {
                ...item,
                label: `${langDisplay.of(locale.language)} (${regionDisplay.of(locale.region)})`
            };
        }).sort((a, b)=>a.label.localeCompare(b.label));
    }, [
        langDisplay,
        regionDisplay
    ]);
    let matched = (0, _react.useMemo)(()=>matchLocale(value), [
        value
    ]);
    let pref = preferences.find((p)=>p.value === matched);
    // @ts-ignore there cannot be any undefined values in the array
    let preferredCalendars = (0, _react.useMemo)(()=>pref ? (pref.ordering || 'gregory').split(' ').map((p)=>calendars.find((c)=>c.key === p)).filter(Boolean) : [
            calendars[0]
        ], [
        pref
    ]);
    let otherCalendars = (0, _react.useMemo)(()=>calendars.filter((c)=>!preferredCalendars.some((p)=>p?.key === c.key)), [
        preferredCalendars
    ]);
    let extension = control.options ?? 'calendar';
    let updateLocale = (locale)=>{
        let calendar, numberingSystem;
        if (extension === 'calendar') calendar = (preferences.find((p)=>p.value === locale)?.ordering || 'gregory').split(' ')[0];
        else if (extension === 'numberingSystem') {
            numberingSystem = new Intl.NumberFormat(locale).resolvedOptions().numberingSystem;
            if (numberingSystem === 'arabext') numberingSystem = 'arab';
        }
        let newLocale = new Intl.Locale(locale, {
            calendar,
            numberingSystem
        });
        onChange(newLocale.toString());
    };
    let updateCalendar = (calendar)=>{
        let newLocale = new Intl.Locale(value, {
            calendar
        });
        onChange(newLocale.toString());
    };
    let updateNumberingSystem = (numberingSystem)=>{
        let newLocale = new Intl.Locale(value, {
            numberingSystem
        });
        onChange(newLocale.toString());
    };
    let lang = null;
    let calendar = null;
    let numberingSystem = null;
    if (value) {
        let locale = new Intl.Locale(value);
        lang = locale.baseName;
        calendar = locale.calendar || null;
        numberingSystem = locale.numberingSystem || null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Picker), {
                label: "Locale",
                items: locales,
                selectedKey: lang,
                onSelectionChange: updateLocale,
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: item.value,
                        children: item.label
                    })
            }),
            extension === 'calendar' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
                label: "Calendar",
                selectedKey: calendar,
                onSelectionChange: updateCalendar,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.PickerSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Header), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                    children: "Preferred"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Collection), {
                                items: preferredCalendars,
                                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                        children: item.name
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.PickerSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Header), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                    children: "Other"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Collection), {
                                items: otherCalendars,
                                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                        children: item.name
                                    })
                            })
                        ]
                    })
                ]
            }),
            extension === 'numberingSystem' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
                label: "Numbering system",
                selectedKey: numberingSystem,
                onSelectionChange: updateNumberingSystem,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "latn",
                        children: "Latin"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "arab",
                        children: "Arabic"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "hanidec",
                        children: "Hanidec"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "deva",
                        children: "Devanagari"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                        id: "beng",
                        children: "Bengali"
                    })
                ]
            })
        ]
    });
}
function DurationControl({ control, value, onChange }) {
    // For now we only care about months.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
        label: control.name,
        contextualHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropContextualHelp, {
            control: control
        }),
        value: value.months,
        minValue: 1,
        onChange: (months)=>onChange({
                months
            }),
        styles: " ZVouohd111",
        formatOptions: {
            style: 'unit',
            unit: 'month',
            unitDisplay: 'long'
        }
    });
}
function ChannelControl({ control, value, onChange }) {
    let { props } = (0, _react.useContext)(Context);
    let colorSpace = props.colorSpace;
    if (!colorSpace && props.defaultValue) {
        let color = typeof props.defaultValue === 'string' ? (0, _reactStately.parseColor)(props.defaultValue) : props.defaultValue;
        colorSpace = color.getColorSpace();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnionControl, {
        isPicker: true,
        control: {
            ...control,
            value: {
                type: 'union',
                elements: [
                    ...(0, _reactStately.getColorChannels)(colorSpace).map((v)=>({
                            type: 'string',
                            value: v
                        })),
                    {
                        type: 'string',
                        value: 'alpha'
                    }
                ]
            }
        },
        value: value,
        onChange: onChange
    });
}
function ColorSpaceControl({ control, value }) {
    let { setProps } = (0, _react.useContext)(Context);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnionControl, {
        control: {
            ...control,
            optional: false
        },
        value: value,
        onChange: (colorSpace)=>{
            setProps((props)=>{
                props = {
                    ...props,
                    colorSpace
                };
                if (props.channel) props.channel = (0, _reactStately.getColorChannels)(colorSpace)[0];
                delete props.xChannel;
                delete props.yChannel;
                return props;
            });
        }
    });
}
function PlacementControl({ control, value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Wrapper, {
        control: control,
        styles: " z2mU111 yzZKy111",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBox), {
            "aria-label": control.name,
            layout: "grid",
            selectionMode: "single",
            disallowEmptySelection: true,
            selectedKeys: [
                value
            ],
            onSelectionChange: (keys)=>onChange([
                    ...keys
                ][0]),
            className: "",
            style: {
                display: 'grid',
                gridTemplateAreas: `
            ".  ts tc te . "
            "st .  .  .  et"
            "sc .  .  .  ec"
            "sb .  .  .  eb"
            ".  bs bc be . "
          `,
                gridTemplateColumns: '25px 24px 24px 25px 24px',
                gridTemplateRows: '25px 24px 24px 25px 24px'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "top start",
                    style: {
                        gridArea: 'ts'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "top",
                    style: {
                        gridArea: 'tc'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "top end",
                    style: {
                        gridArea: 'te'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "start top",
                    style: {
                        gridArea: 'st'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "end top",
                    style: {
                        gridArea: 'et'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "start",
                    style: {
                        gridArea: 'sc'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "end",
                    style: {
                        gridArea: 'ec'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "start bottom",
                    style: {
                        gridArea: 'sb'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "end bottom",
                    style: {
                        gridArea: 'eb'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "bottom start",
                    style: {
                        gridArea: 'bs'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "bottom",
                    style: {
                        gridArea: 'bc'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlacementControlItem, {
                    id: "bottom end",
                    style: {
                        gridArea: 'be'
                    }
                })
            ]
        })
    });
}
function PlacementControlItem(props1) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props1,
        "aria-label": props1.id,
        className: function anonymous(props) {
            let rules = " ";
            if (props.isFocusVisible) rules += ' _Lf111';
            else rules += ' _Le111';
            rules += ' Oh111';
            rules += ' _Mc111';
            rules += ' _Kd111';
            rules += ' Zo111';
            rules += ' Fp111';
            rules += ' Yd111';
            rules += ' Xb111';
            rules += ' _2b111';
            if (props.isSelected) rules += ' g0111';
            else {
                if (props.isPressed) rules += ' gF111';
                else if (props.isFocusVisible) rules += ' gF111';
                else if (props.isHovered) rules += ' gF111';
                else rules += ' gH111';
            }
            if (props.isSelected) rules += ' px111';
            else rules += ' pt111';
            if (props.isFocusVisible) rules += ' _9c111';
            else rules += ' _9b111';
            return rules;
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: " Za111 Fb111 _Lf111 OOIem5c111 _Mb111"
        })
    });
}
function ArrayControl({ control, valueType, value = [], onChange }) {
    let ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Wrapper, {
        ref: ref,
        control: control,
        styles: " z2mU111 yzZKy111 ZNqBXK111",
        children: [
            value.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                size: "S",
                "aria-label": "Add item",
                styles: " _de111",
                onPress: ()=>{
                    (0, _reactDom.flushSync)(()=>onChange([
                            ''
                        ]));
                    ref.current?.querySelector('input')?.focus();
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addCircleDefault.default), {})
            }),
            value.map((item, index)=>{
                let rendered;
                switch(valueType.type){
                    case 'string':
                        rendered = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TextField), {
                            "aria-label": `${control.name}, item ${index}`,
                            size: "S",
                            styles: " _ub111",
                            value: item,
                            onChange: (newValue)=>{
                                let arr = [
                                    ...value
                                ];
                                arr[index] = newValue;
                                onChange(arr);
                            }
                        });
                        break;
                    default:
                        console.warn('unknown array element type', valueType);
                        return null;
                }
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " sd111 Ub111 qb111",
                    children: [
                        rendered,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                            size: "S",
                            "aria-label": "Add item after",
                            onPress: ()=>{
                                let arr = [
                                    ...value
                                ];
                                arr.splice(index + 1, 0, '');
                                (0, _reactDom.flushSync)(()=>onChange(arr));
                                ref.current?.querySelectorAll('input')[index + 1]?.focus();
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addCircleDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                            size: "S",
                            "aria-label": "Remove item",
                            onPress: ()=>{
                                let arr = [
                                    ...value
                                ];
                                arr.splice(index, 1);
                                (0, _reactDom.flushSync)(()=>onChange(arr));
                                if (arr.length > 0) ref.current?.querySelectorAll('input')[Math.min(arr.length - 1, index)]?.focus();
                                else ref.current?.querySelector('button')?.focus();
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeCircleDefault.default), {})
                        })
                    ]
                }, index);
            })
        ]
    });
}
function SizeControl({ control, value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Wrapper, {
        control: control,
        styles: " z2mU111 yzZKy111",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: " sd111 Ub111 qb111 ZVouohd111",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
                    "aria-label": "Width",
                    value: value?.width,
                    onChange: (width)=>onChange(new (0, _reactAriaComponents.Size)(width, value?.height ?? 0)),
                    styles: " _vb111 _ub111",
                    hideStepper: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
                    "aria-label": "Height",
                    value: value?.height,
                    onChange: (height)=>onChange(new (0, _reactAriaComponents.Size)(value?.width ?? 0, height)),
                    styles: " _vb111 _ub111",
                    hideStepper: true
                })
            ]
        })
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","7":"4oKuc","8":"4oKuc","9":"4oKuc","10":"4oKuc","11":"4oKuc","12":"4oKuc","13":"4oKuc","14":"4oKuc","15":"4oKuc","16":"4oKuc","17":"4oKuc","18":"4oKuc","19":"4oKuc","20":"4oKuc","21":"4oKuc","22":"4oKuc","23":"4oKuc","24":"4oKuc","25":"4oKuc","26":"4oKuc","27":"4oKuc","28":"4oKuc","29":"4oKuc","30":"4oKuc","31":"4oKuc","32":"4oKuc","33":"4oKuc","34":"4oKuc","35":"4oKuc","36":"4oKuc","37":"4oKuc","38":"4oKuc","39":"4oKuc","40":"4oKuc","41":"4oKuc","42":"4oKuc","43":"4oKuc","44":"4oKuc","45":"4oKuc","46":"4oKuc","47":"4oKuc","48":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","@react-spectrum/s2/icons/AddCircle":"k8LxT","./CodePlatter":"hi4fC","./ExampleOutput":"lHe2T","./ExampleSwitcher":"kHsTJ","react-dom":"gC2PC","react-stately":"eRJVr","react-aria-components":"2Emk2","../../../@react-spectrum/s2/style/runtime":"8g9no","react":"a1TxN","@react-spectrum/s2/icons/RemoveCircle":"8rNDD","react-aria":"7txSB","78276cdf15345291":"6CgAN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hi4fC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodePlatter", ()=>CodePlatter);
parcelHelpers.export(exports, "Pre", ()=>Pre);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _copyButton = require("./CopyButton");
var _codeSandbox = require("./CodeSandbox");
var _stackBlitz = require("./StackBlitz");
var _download = require("@react-spectrum/s2/icons/Download");
var _downloadDefault = parcelHelpers.interopDefault(_download);
var _link = require("@react-spectrum/s2/icons/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _openIn = require("@react-spectrum/s2/icons/OpenIn");
var _openInDefault = parcelHelpers.interopDefault(_openIn);
var _polygon4 = require("@react-spectrum/s2/icons/Polygon4");
var _polygon4Default = parcelHelpers.interopDefault(_polygon4);
var _prompt = require("@react-spectrum/s2/icons/Prompt");
var _promptDefault = parcelHelpers.interopDefault(_prompt);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _zip = require("./zip");
'use client';
const platterStyle = " g_g111 oc111 nc111 kc111 jc111 -vBZ9ae-Tf111 -wBZ9ae-Tf111 _Pc111 K6kvVdc111 _Na111 Pa111";
function CodePlatter({ children, shareUrl, files, type, registryUrl }) {
    let codeRef = (0, _react.useRef)(null);
    let [showShadcn, setShowShadcn] = (0, _react.useState)(false);
    let getText = ()=>codeRef.current.querySelector('pre').textContent;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: platterStyle,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " sd111 _Cb111 __wa111 Tf111 Qf111 Sf111 Rf111 _Pc111 _9c111",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButtonGroup), {
                    orientation: "vertical",
                    isQuiet: true,
                    density: "regular",
                    size: "S",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyButton.CopyButton), {
                            ariaLabel: "Copy code",
                            tooltip: "Copy code",
                            getText: getText
                        }),
                        (shareUrl || files || type || registryUrl) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.TooltipTrigger), {
                                    placement: "end",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                                            "aria-label": "Open in\u2026",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Tooltip), {
                                            children: "Open in\u2026"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                                    hideLinkOutIcon: true,
                                    children: [
                                        shareUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            onAction: ()=>{
                                                // Find previous heading element to get hash.
                                                let url = new URL(shareUrl, location.href);
                                                let node = codeRef.current;
                                                while(node && node.parentElement?.tagName !== 'ARTICLE')node = node.parentElement;
                                                while(node && !(node instanceof HTMLHeadingElement))node = node.previousElementSibling;
                                                if (node instanceof HTMLHeadingElement && node.id) url.hash = '#' + node.id;
                                                navigator.clipboard.writeText(url.toString());
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    slot: "label",
                                                    children: "Copy link"
                                                })
                                            ]
                                        }),
                                        (files || type) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            onAction: ()=>{
                                                let code = codeRef.current.querySelector('pre').textContent;
                                                let filesToDownload = (0, _codeSandbox.getCodeSandboxFiles)({
                                                    ...files,
                                                    'Example.tsx': transformExampleCode(code)
                                                }, type);
                                                let filesToZip = {};
                                                for(let key in filesToDownload)if (filesToDownload[key]) filesToZip[key] = filesToDownload[key].content;
                                                let blob = (0, _zip.zip)(filesToZip);
                                                let a = document.createElement('a');
                                                a.href = URL.createObjectURL(blob);
                                                a.download = 'example.zip';
                                                a.hidden = true;
                                                document.body.appendChild(a);
                                                a.click();
                                                a.remove();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downloadDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    slot: "label",
                                                    children: "Download ZIP"
                                                })
                                            ]
                                        }),
                                        registryUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            onAction: ()=>setShowShadcn(true),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _promptDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    children: "Install with shadcn"
                                                })
                                            ]
                                        }),
                                        (files || type) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            onAction: ()=>{
                                                let code = codeRef.current.querySelector('pre').textContent;
                                                (0, _codeSandbox.createCodeSandbox)({
                                                    ...files,
                                                    'Example.tsx': transformExampleCode(code)
                                                }, type);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polygon4Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    slot: "label",
                                                    children: "Open in CodeSandbox"
                                                })
                                            ]
                                        }),
                                        (files || type) && type !== 's2' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            onAction: ()=>{
                                                let code = codeRef.current.querySelector('pre').textContent;
                                                (0, _stackBlitz.createStackBlitz)({
                                                    ...files,
                                                    'Example.tsx': transformExampleCode(code)
                                                }, type);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Flash, {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    slot: "label",
                                                    children: "Open in StackBlitz"
                                                })
                                            ]
                                        }),
                                        registryUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                            href: `https://v0.dev/chat/api/open?url=${registryUrl}`,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(V0, {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                    children: "Open in v0"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: codeRef,
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.DialogContainer), {
                onDismiss: ()=>setShowShadcn(false),
                children: showShadcn && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShadcnDialog, {
                    registryUrl: registryUrl
                })
            })
        ]
    });
}
function Pre({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
        className: " oc111 nc111 kc111 jc111 uj111 upj111 -_6BNtrc-b111 vx111 -_6BNtrc-pc111 vpx111 wb111 xb111 _xa111 wpb111 xpb111 _xpa111 _Fb111 _FnuYUwec111 _Fpb111 _FpnuYUwec111 pt111 ppt111 _7f111 Jy111 Gy111 Iy111 Hy111 Sx7Xf8d111 Rx7Xf8d111 T47Xf8d111 Q47Xf8d111",
        style: {
            overflowWrap: 'break-word'
        },
        children: children
    });
}
function transformExampleCode(code) {
    // Export the last function
    code = code.replace(/\nfunction ([^(]+)((.|\n)+\n\}\n?)$/, '\nexport function Example$2');
    // Add function wrapper around raw JSX in examples.
    return code.replace(/\n<((?:.|\n)+)/, (_, code)=>{
        let res = '\nexport function Example() {\n  return (\n    <';
        let lines = code.split('\n');
        res += lines.shift();
        for (let line of lines)res += '\n    ' + line;
        res += '\n  );\n}\n';
        return res;
    });
}
const V0 = (0, _s2.createIcon)((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 40 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M23.3919 0H32.9188C36.7819 0 39.9136 3.13165 39.9136 6.99475V16.0805H36.0006V6.99475C36.0006 6.90167 35.9969 6.80925 35.9898 6.71766L26.4628 16.079C26.4949 16.08 26.5272 16.0805 26.5595 16.0805H36.0006V19.7762H26.5595C22.6964 19.7762 19.4788 16.6139 19.4788 12.7508V3.68923H23.3919V12.7508C23.3919 12.9253 23.4054 13.0977 23.4316 13.2668L33.1682 3.6995C33.0861 3.6927 33.003 3.68923 32.9188 3.68923H23.3919V0Z",
                fill: "var(--iconPrimary)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M13.7688 19.0956L0 3.68759H5.53933L13.6231 12.7337V3.68759H17.7535V17.5746C17.7535 19.6705 15.1654 20.6584 13.7688 19.0956Z",
                fill: "var(--iconPrimary)"
            })
        ]
    }));
const Flash = (0, _s2.createIcon)((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M9.20215,18.76367c-.18262,0-.37012-.03711-.55078-.11621-.62598-.27051-.94238-.91992-.77051-1.5791l1.17383-4.50586-3.34863.06348c-.52441,0-1.00879-.28418-1.26465-.74121-.25684-.45801-.24512-1.01953.02832-1.4668L9.7002,1.88574c.35547-.58203,1.04297-.80664,1.67383-.53906.62988.26465.95312.91211.78613,1.57422l-1.20508,4.7959,3.33887-.06152c.52734,0,1.01465.28711,1.26953.74902s.23926,1.02637-.04199,1.47266l-5.19141,8.25098c-.25781.40918-.68066.63574-1.12793.63574ZM9.10254,11.12598c.45215,0,.87109.20508,1.14746.5625.27637.3584.37012.81445.25586,1.25195l-.92969,3.56836,4.62695-7.35352h-3.29688c-.4502,0-.86719-.20312-1.14355-.55859-.27637-.35449-.37207-.80859-.2627-1.24512l.96582-3.84473-4.7168,7.69434,3.35352-.0752Z",
            fill: "var(--iconPrimary, #222)",
            strokeWidth: "0"
        })
    }));
function ShadcnDialog({ registryUrl }) {
    let [packageManager, setPackageManager] = (0, _react.useState)('npm');
    let command = packageManager;
    if (packageManager === 'npx') command = 'npx';
    else if (packageManager === 'pnpm') command = 'pnpm dlx';
    let componentName = registryUrl.match(/([^/]+)\.json$/)[1];
    let preRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        let value = localStorage.getItem('packageManager');
        if (value) setPackageManager(value);
    }, []);
    let onSelectionChange = (value)=>{
        setPackageManager(value);
        localStorage.setItem('packageManager', value);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Dialog), {
        size: "L",
        children: ({ close })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                        slot: "title",
                        children: "Install with shadcn"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    "Use the ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
                                        href: "https://ui.shadcn.com/docs/cli",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "shadcn CLI"
                                    }),
                                    " to install ",
                                    componentName,
                                    " and its dependencies into your project."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: " gqlRAZb111 oe111 ne111 ke111 je111 Tf111 Qf111 Sf111 Rf111 sd111 _ta111 Ul111 ql111",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SegmentedControl), {
                                        selectedKey: packageManager,
                                        onSelectionChange: onSelectionChange,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                                                id: "npm",
                                                children: "npm"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                                                id: "yarn",
                                                children: "yarn"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                                                id: "pnpm",
                                                children: "pnpm"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: " sd111 eb111 Ug111 qg111",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _promptDefault.default), {
                                                styles: " Zn111 Fo111"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("pre", {
                                                ref: preRef,
                                                className: " uj111 upj111 -_6BNtrc-b111 vx111 -_6BNtrc-pc111 vpx111 wb111 xb111 _xa111 wpb111 xpb111 _xpa111 _Fb111 _FnuYUwec111 _Fpb111 _FpnuYUwec111 pt111 ppt111 _Na111 Td111 Qd111 Sd111 Rd111 Jy111 Gy111 Iy111 Hy111",
                                                children: [
                                                    command,
                                                    " shadcn@latest add ",
                                                    registryUrl
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ButtonGroup), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Button), {
                                variant: "secondary",
                                slot: "close",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Button), {
                                variant: "accent",
                                onPress: ()=>{
                                    navigator.clipboard.writeText(preRef.current.textContent);
                                    close();
                                },
                                children: "Copy and close"
                            })
                        ]
                    })
                ]
            })
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","./CopyButton":"e24AO","./CodeSandbox":"entcx","./StackBlitz":"kuXEC","@react-spectrum/s2/icons/Download":"jifhr","@react-spectrum/s2/icons/Link":"ivjAn","@react-spectrum/s2/icons/OpenIn":"brg0k","@react-spectrum/s2/icons/Polygon4":"iLYOX","@react-spectrum/s2/icons/Prompt":"h0Yh9","react":"a1TxN","./zip":"gkViL","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e24AO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyButton", ()=>CopyButton);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _checkmarkCircle = require("@react-spectrum/s2/icons/CheckmarkCircle");
var _checkmarkCircleDefault = parcelHelpers.interopDefault(_checkmarkCircle);
var _copy = require("@react-spectrum/s2/icons/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function CopyButton({ text, getText, ariaLabel = 'Copy', tooltip = 'Copy', isQuiet = false, size = 'S' }) {
    let [isCopied, setIsCopied] = (0, _react.useState)(false);
    let timeout = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    let handleCopy = ()=>{
        if (timeout.current) clearTimeout(timeout.current);
        let value = text ?? getText?.();
        if (!value) return;
        navigator.clipboard.writeText(value).then(()=>{
            setIsCopied(true);
            timeout.current = setTimeout(()=>setIsCopied(false), 2000);
        }).catch(()=>{
        // noop
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.TooltipTrigger), {
        placement: "end",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                "aria-label": ariaLabel,
                isQuiet: isQuiet,
                size: size,
                onPress: handleCopy,
                children: isCopied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkCircleDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Tooltip), {
                children: tooltip
            })
        ]
    });
}
exports.default = CopyButton;

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","@react-spectrum/s2/icons/CheckmarkCircle":"6hpGX","@react-spectrum/s2/icons/Copy":"6imrL","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"entcx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCodeSandbox", ()=>createCodeSandbox);
parcelHelpers.export(exports, "getCodeSandboxFiles", ()=>getCodeSandboxFiles);
var _lzString = require("lz-string");
var _lzStringDefault = parcelHelpers.interopDefault(_lzString);
function createCodeSandbox(files, type = 'vanilla') {
    let form = document.createElement('form');
    form.hidden = true;
    form.method = 'POST';
    form.action = 'https://codesandbox.io/api/v1/sandboxes/define';
    form.target = '_blank';
    let input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'query';
    input.value = 'file=src/Example.tsx';
    form.appendChild(input);
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'environment';
    input.value = 'server';
    form.appendChild(input);
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'parameters';
    input.value = (0, _lzStringDefault.default).compressToBase64(JSON.stringify({
        files: getCodeSandboxFiles(files, type)
    }));
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
    form.remove();
}
const dependencies = {
    vanilla: {
        'react-aria-components': '^1.10.0',
        react: '^19',
        'react-dom': '^19',
        'lucide-react': '^0.514.0'
    },
    tailwind: {
        'react-aria-components': '^1.10.0',
        react: '^19',
        'react-dom': '^19',
        'lucide-react': '^0.514.0',
        'tailwind-variants': '^0.3.1',
        'tailwind-merge': '^2.5.4'
    },
    s2: {
        '@react-spectrum/s2': 'latest',
        react: '^19',
        'react-dom': '^19'
    }
};
const devDependencies = {
    vanilla: {
        '@types/react': '^19',
        '@types/react-dom': '^19',
        parcel: '^2',
        typescript: '^5'
    },
    tailwind: {
        '@types/react': '^19',
        '@types/react-dom': '^19',
        parcel: '^2',
        typescript: '^5',
        'tailwindcss': '^4',
        '@tailwindcss/postcss': '^4',
        postcss: '^8',
        'tailwindcss-react-aria-components': '^2',
        'tailwindcss-animate': '^1'
    },
    s2: {
        '@types/react': '^19',
        '@types/react-dom': '^19',
        parcel: '^2',
        typescript: '^5'
    }
};
function getCodeSandboxFiles(files, type = 'vanilla') {
    return {
        '.codesandbox/tasks.json': {
            content: JSON.stringify({
                setupTasks: [
                    {
                        name: 'Installing Dependencies',
                        command: 'pnpm install'
                    }
                ],
                tasks: {
                    start: {
                        name: 'start',
                        command: 'pnpm start',
                        runAtStart: true,
                        preview: {
                            port: 5173
                        }
                    },
                    build: {
                        name: 'build',
                        command: 'pnpm build',
                        runAtStart: false
                    }
                }
            }, null, 2) + '\n'
        },
        '.devcontainer/devcontainer.json': {
            content: JSON.stringify({
                'name': 'Devcontainer',
                'image': 'ghcr.io/codesandbox/devcontainers/typescript-node:latest'
            }, null, 2) + '\n'
        },
        'package.json': {
            content: JSON.stringify({
                name: type === 's2' ? 's2-starter' : 'react-aria-starter',
                private: true,
                version: '0.0.0',
                source: 'src/index.html',
                scripts: {
                    start: 'parcel',
                    build: 'parcel build'
                },
                dependencies: dependencies[type],
                devDependencies: devDependencies[type]
            }, null, 2) + '\n'
        },
        '.postcssrc': type === 'tailwind' ? {
            content: JSON.stringify({
                plugins: {
                    '@tailwindcss/postcss': {}
                }
            }, null, 2) + '\n'
        } : undefined,
        'src/index.html': {
            content: `<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <title>Test</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<body>
  <div id="root"></div>
  <script type="module" src="index.tsx"></script>${type === 'tailwind' ? '\n  <link href="index.css" rel="stylesheet">' : ''}
</body>
</html>
`
        },
        'src/index.tsx': {
            content: `import {createRoot} from 'react-dom/client';
import {Example} from './Example';${type === 's2' ? "\nimport '@react-spectrum/s2/page.css';" : ''}

createRoot(document.getElementById('root')!).render(<Example />);
`
        },
        'tsconfig.json': {
            content: JSON.stringify({
                compilerOptions: {
                    'target': 'ES2022',
                    'lib': [
                        'ES2022',
                        'DOM',
                        'DOM.Iterable'
                    ],
                    'module': 'ESNext',
                    strict: true,
                    'moduleResolution': 'bundler',
                    'noEmit': true,
                    'jsx': 'react-jsx'
                },
                'include': [
                    'src'
                ]
            }, null, 2) + '\n'
        },
        ...Object.fromEntries(Object.entries(files).map(([name, content])=>[
                'src/' + name,
                {
                    content
                }
            ]))
    };
}

},{"lz-string":"gTdn3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gTdn3":[function(require,module,exports,__globalThis) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

},{}],"kuXEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStackBlitz", ()=>createStackBlitz);
function createStackBlitz(files, type = 'vanilla') {
    let form = document.createElement('form');
    form.hidden = true;
    form.method = 'POST';
    form.action = 'https://stackblitz.com/run?file=src/Example.tsx';
    form.target = '_blank';
    let input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'project[template]';
    input.value = 'node';
    form.appendChild(input);
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'project[title]';
    input.value = 'Project';
    form.appendChild(input);
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'project[description]';
    input.value = 'description';
    form.appendChild(input);
    let generatedFiles = getFiles(files, type);
    for(let name in generatedFiles){
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `project[files][${name}]`;
        input.value = generatedFiles[name];
        form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
    form.remove();
}
function getFiles(files, type = 'vanilla') {
    return {
        'package.json': JSON.stringify({
            name: 'react-aria-starter',
            private: true,
            version: '0.0.0',
            type: 'module',
            scripts: {
                dev: 'vite',
                build: 'vite build',
                preview: 'vite preview'
            },
            dependencies: {
                'react-aria-components': '^1.10.0',
                react: '^19',
                'react-dom': '^19',
                'lucide-react': '^0.514.0',
                ...type === 'tailwind' ? {
                    'tailwind-variants': '^0.3.1'
                } : {}
            },
            devDependencies: {
                '@types/react': '^19',
                '@types/react-dom': '^19',
                vite: '^6',
                '@vitejs/plugin-react': '^4',
                ...type === 'tailwind' ? {
                    'tailwindcss': '^4',
                    '@tailwindcss/vite': '^4',
                    'tailwindcss-react-aria-components': '^2',
                    'tailwindcss-animate': '^1'
                } : {}
            }
        }, null, 2) + '\n',
        'vite.config.ts': `import {defineConfig} from 'vite';
import react from '@vitejs/plugin-react';${type === 'tailwind' ? "\nimport tailwindcss from '@tailwindcss/vite';" : ''}

export default defineConfig({
  plugins: [react()${type === 'tailwind' ? ', tailwindcss()' : ''}],
});
`,
        'index.html': `<html lang="en">
<head>
  <meta charset="utf-8">
  <title>Test</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<body>
  <div id="root"></div>
  <script type="module" src="/src/index.tsx"></script>${type === 'tailwind' ? '\n  <link href="/src/index.css" rel="stylesheet">' : ''}
</body>
</html>
`,
        'src/index.tsx': `import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {Example} from './Example';

createRoot(document.getElementById('root')!).render(<Example />);
`,
        'tsconfig.json': JSON.stringify({
            compilerOptions: {
                'target': 'ES2022',
                'useDefineForClassFields': true,
                'lib': [
                    'ES2022',
                    'DOM',
                    'DOM.Iterable'
                ],
                'module': 'ESNext',
                'skipLibCheck': true,
                /* Bundler mode */ 'moduleResolution': 'bundler',
                'allowImportingTsExtensions': true,
                'moduleDetection': 'force',
                'noEmit': true,
                'jsx': 'react-jsx',
                /* Linting */ 'strict': true,
                'noUnusedLocals': true,
                'noUnusedParameters': true,
                'erasableSyntaxOnly': true,
                'noFallthroughCasesInSwitch': true,
                'noUncheckedSideEffectImports': true
            },
            'include': [
                'src'
            ]
        }, null, 2) + '\n',
        ...Object.fromEntries(Object.entries(files).map(([name, contents])=>[
                'src/' + name,
                contents
            ]))
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gkViL":[function(require,module,exports,__globalThis) {
// https://gist.github.com/rvaiya/4a2192df729056880a027789ae3cd4b7
// Author: Raheman Vaiya
// License: WTFPL
// Generate the crc32 table instead of hardcoding it to avoid having a giant constant
// in the minified output...
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
const CRC32_TABLE = function() {
    let tbl = new Int32Array(256);
    let c;
    for(let n = 0; n < 256; n++){
        c = n;
        for(let k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        tbl[n] = c;
    }
    return tbl;
}();
function crc32(arr) {
    let crc = -1;
    for(let i = 0; i < arr.length; i++)crc = crc >>> 8 ^ CRC32_TABLE[(crc ^ arr[i]) & 0xFF];
    return (crc ^ -1) >>> 0;
}
function putUint32s(arr, offset, ...values) {
    let dv = new DataView(arr.buffer);
    values.forEach((v, i)=>dv.setUint32(offset + i * 4, v, true));
}
function putUint16s(arr, offset, ...values) {
    let dv = new DataView(arr.buffer);
    values.forEach((v, i)=>dv.setUint16(offset + i * 2, v, true));
}
function zip(files) {
    let records = [];
    let cdrs = [];
    let te = new TextEncoder();
    let offset = 0;
    let cdSz = 0;
    for(let name in files){
        let fh = new Uint8Array(30 + name.length);
        let fname = te.encode(name);
        let data = te.encode(files[name]);
        let chksum = crc32(data);
        putUint32s(fh, 0, 0x04034b50);
        putUint32s(fh, 14, chksum, data.length, data.length);
        putUint16s(fh, 26, name.length);
        fh.set(fname, 30);
        records.push(fh);
        records.push(data);
        // Create CD records pending flush at the end...
        let cdr = new Uint8Array(46 + name.length);
        putUint32s(cdr, 0, 0x02014b50);
        putUint32s(cdr, 16, chksum, data.length, data.length);
        putUint16s(cdr, 28, name.length);
        putUint32s(cdr, 42, offset);
        cdr.set(fname, 46);
        cdrs.push(cdr);
        cdSz += cdr.length;
        offset += fh.length + data.length;
    }
    // Push all accrued CD records..
    records.push(...cdrs);
    // Add EOCD record...
    let eocd = new Uint8Array(22);
    putUint32s(eocd, 0, 0x06054b50);
    putUint16s(eocd, 8, cdrs.length, cdrs.length);
    putUint32s(eocd, 12, cdSz, offset);
    records.push(eocd);
    return new Blob(records, {
        type: 'application/zip'
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lHe2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExampleOutput", ()=>ExampleOutput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
'use client';
function ExampleOutput({ component, props = {}, align = 'center', orientation = 'horizontal' }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' sd111';
            if (props.orientation === "vertical") rules += ' _tc111';
            else if (props.orientation === "horizontal") rules += ' _ta111';
            if (props.align === "end") rules += ' _Cb111';
            else if (props.align === "start") rules += ' _Cg111';
            else if (props.align === "center") rules += ' _Ca111';
            rules += ' eb111';
            rules += ' Za111';
            rules += ' _Na111';
            rules += ' Pa111';
            rules += ' z7DIbxc111';
            rules += ' y7DIbxc111';
            rules += ' B7DIbxc111';
            rules += ' A7DIbxc111';
            rules += ' oc111';
            rules += ' nc111';
            rules += ' kc111';
            rules += ' jc111';
            rules += ' uk111';
            rules += ' uch111';
            rules += ' udi111';
            rules += ' uea111';
            rules += ' ugb111';
            rules += ' uhd111';
            rules += ' uje111';
            rules += ' u2NhKxcl111';
            rules += ' uic111';
            rules += ' -_6BNtrc-c111';
            rules += ' vx111';
            rules += ' wb111';
            rules += ' xb111';
            rules += ' _xa111';
            rules += ' _Fd111';
            rules += ' _FezxGHba111';
            rules += ' _FnuYUweb111';
            rules += ' pt111';
            rules += ' Th111';
            rules += ' Qh111';
            rules += ' Sh111';
            rules += ' Rh111';
            rules += ' _oa111';
            return rules;
        }({
            align,
            orientation
        }),
        style: {
            background: getBackgroundColor(props.staticColor || (props.isOverBackground ? 'white' : undefined))
        },
        children: /*#__PURE__*/ (0, _react.isValidElement)(component) ? /*#__PURE__*/ (0, _react.cloneElement)(component, props) : /*#__PURE__*/ (0, _react.createElement)(component, props)
    });
}
function getBackgroundColor(staticColor) {
    if (staticColor === 'black') return 'linear-gradient(to right,#ddd6fe,#fbcfe8)';
    else if (staticColor === 'white') return 'linear-gradient(to right,#0f172a,#334155)';
    return undefined;
}

},{"0":"a729t","react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a729t":[function() {},{}],"kHsTJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExampleSwitcherContext", ()=>ExampleSwitcherContext);
parcelHelpers.export(exports, "ExampleSwitcher", ()=>ExampleSwitcher);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _s2 = require("@react-spectrum/s2");
'use client';
const exampleStyle = " gqlRAZb111 Jz111 Gz111 oe111 ne111 ke111 je111 sd111 _ta111";
const switcher = " Jx111 JpA111 Ix111 IpA111";
const ExampleSwitcherContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DEFAULT_EXAMPLES = [
    'Vanilla CSS',
    'Tailwind'
];
function ExampleSwitcher({ type = 'style', examples = DEFAULT_EXAMPLES, children }) {
    let [selected, setSelected] = (0, _react.useState)(examples[0]);
    (0, _react.useEffect)(()=>{
        if (!type) return;
        let search = new URLSearchParams(location.search);
        let exampleType = search.get(type) ?? localStorage.getItem(type);
        if (exampleType && examples.includes(exampleType)) setSelected(exampleType);
        let controller = new AbortController();
        window.addEventListener('storage', (e)=>{
            if (e.key === type && e.newValue && examples.includes(e.newValue)) setSelected(e.newValue);
        }, {
            signal: controller.signal
        });
        return ()=>controller.abort();
    }, [
        type,
        examples
    ]);
    let onSelectionChange = (key)=>{
        setSelected(key);
        if (type) {
            localStorage.setItem(type, key);
            window.dispatchEvent(new StorageEvent('storage', {
                key: type,
                oldValue: String(selected),
                newValue: String(key)
            }));
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: exampleStyle,
        "data-example-switcher": true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControl), {
                selectedKey: selected,
                onSelectionChange: onSelectionChange,
                styles: switcher,
                children: examples.map((example)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                        id: example,
                        children: example
                    }, example))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExampleSwitcherContext.Provider, {
                value: selected,
                children: children[examples.indexOf(selected)]
            })
        ]
    });
}

},{"0":"9pUlJ","1":"gHFe4","react/jsx-runtime":"2Is6Z","react":"a1TxN","@react-spectrum/s2":"5H6IX","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9pUlJ":[function() {},{}],"gHFe4":[function() {},{}],"6CgAN":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
var _reactDom = require("react-dom");
(0, _reactDom.preinit)(module.bundle.resolve("lBmtU"), {
    as: 'style',
    precedence: 'default'
});
let promise = Promise.all([
    module.bundle.load("6ftc0"),
    module.bundle.load("jjO5O"),
    module.bundle.load("djdBm")
]).then(()=>{
    let originalModule = module.bundle.root("i9ilt");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("6ftc0")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("jjO5O")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "stylesheet",
                href: module.bundle.resolve("lBmtU"),
                precedence: "default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("djdBm")
            })
        ]
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ","react-dom":"gC2PC"}],"iKyDQ":[function(require,module,exports,__globalThis) {
/* eslint-env browser */ /* eslint-disable react/react-in-jsx-scope */ /* @jsxRuntime automatic */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResourcesProxy", ()=>createResourcesProxy);
parcelHelpers.export(exports, "waitForCSS", ()=>waitForCSS);
var _jsxRuntime = require("react/jsx-runtime");
function createResourcesProxy(module, esModule, resources, bootstrapScript) {
    if (typeof module === 'function') return createResourcesValueProxy(module, resources, bootstrapScript);
    return new Proxy(module, {
        get (target, prop, receiver) {
            if (prop === '__esModule' && esModule) return true;
            let value = Reflect.get(target, prop, receiver);
            return createResourcesValueProxy(value, resources, bootstrapScript);
        }
    });
}
let cache = new WeakMap();
function createResourcesValueProxy(value, resources, bootstrapScript) {
    if (typeof value === 'function') {
        let cached = cache.get(value);
        if (cached) return cached;
        // Detect reads of `Component.prototype.isReactComponent` or `Component.$$typeof`
        // prior to the function being called as an indication that this is a React component.
        // If so, inject the resources as a sibling of the return value.
        let isReactComponent = false;
        let prototypeProxy;
        if (typeof value.prototype === 'object') prototypeProxy = new Proxy(value.prototype, {
            get (target, prop, receiver) {
                if (prop === 'isReactComponent') isReactComponent = true;
                return Reflect.get(target, prop, receiver);
            }
        });
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                if (prototypeProxy && prop === 'prototype' && Object.getOwnPropertyDescriptor(target, 'prototype').configurable) return prototypeProxy;
                if (prop === '$$typeof') isReactComponent = true;
                if (bootstrapScript && prop === 'bootstrapScript') return bootstrapScript;
                return Reflect.get(target, prop, receiver);
            },
            apply (target, thisArg, args) {
                let result = Reflect.apply(target, thisArg, args);
                if (isReactComponent) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        resources,
                        result
                    ]
                });
                return result;
            }
        });
        cache.set(value, proxy);
        return proxy;
    } else if (value && typeof value === 'object') {
        let cached = cache.get(value);
        if (cached) return cached;
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                let value = Reflect.get(target, prop, receiver);
                return createResourcesValueProxy(value, resources, bootstrapScript);
            }
        });
        cache.set(value, proxy);
        return proxy;
    }
    return value;
}
function waitForCSS(url) {
    return new Promise((resolve, reject)=>{
        if (typeof document === 'undefined') return resolve();
        // Find a link element corresponding to this URL.
        let link = document.querySelector(`link[rel="stylesheet"][href="${CSS.escape(url)}"]`);
        if (!link) return resolve();
        // If the link element already has a stylesheet associated with it, then it is already loaded.
        if (link.sheet) return resolve();
        link.addEventListener('load', ()=>{
            resolve();
        });
        link.addEventListener('error', (e)=>{
            reject(e);
        });
    });
}

},{"react/jsx-runtime":"2Is6Z","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4z7tQ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    module.bundle.load("djdBm"),
    require("4bd2f34b9b18972f")(module.bundle.resolve("lBmtU")),
    module.bundle.load("jjO5O"),
    module.bundle.load("6ftc0")
]).then(()=>module.bundle.root('i9ilt'));

},{"4bd2f34b9b18972f":"819rl"}],"819rl":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"e87h6"}],"e87h6":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"gQsl5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExpandableCode", ()=>ExpandableCode);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _reactDom = require("react-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const example = function anonymous(props) {
    let rules = " ";
    rules += ' uj111';
    rules += ' -_6BNtrc-e111';
    rules += ' vx111';
    rules += ' wb111';
    rules += ' xb111';
    rules += ' _xa111';
    rules += ' _Fb111';
    rules += ' _FnuYUwec111';
    rules += ' pt111';
    if (props.isExpanded) rules += ' Ke4mUs111';
    else rules += ' KDBOfn111';
    if (props.isExpanded) rules += ' _Ne111';
    else rules += ' _Nb111';
    if (props.isExpanded) rules += ' Pe111';
    else rules += ' Pb111';
    rules += ' _Pc111';
    rules += ' Za111';
    rules += ' ke111';
    rules += ' je111';
    if (props.isExpanded) rules += ' -T8cqC-sf111';
    else rules += ' -T8cqC-sk111';
    return rules;
};
const expandWrapper = function anonymous(props) {
    let rules = " ";
    if (props.isExpanded) rules += ' _Pd111';
    else rules += ' _Pa111';
    rules += ' _lr111';
    rules += ' _Ar111';
    rules += ' _zr111';
    rules += ' sd111';
    rules += ' _Ca111';
    rules += ' Tt111';
    rules += ' Qt111';
    return rules;
};
function ExpandableCode({ children, hasHighlightedLine }) {
    let [isExpanded, setExpanded] = (0, _react.useState)(false);
    let ref = (0, _react.useRef)(null);
    let mask;
    let padding;
    if (!isExpanded) {
        if (hasHighlightedLine) {
            // mask the top, bottom, and right sides
            mask = 'linear-gradient(transparent, white 25% 50%, transparent), linear-gradient(to right, white 0% 85%, transparent)';
            padding = '0px';
        } else // only mask the bottom
        mask = 'linear-gradient(white 0% 50%, transparent)';
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        className: example({
            isExpanded
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    maskImage: mask,
                    maskComposite: 'intersect',
                    maxHeight: isExpanded ? undefined : 'inherit',
                    '--code-padding-y': padding
                },
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: expandWrapper({
                    isExpanded
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                    onPress: ()=>{
                        viewTransition(()=>{
                            setExpanded(!isExpanded);
                            ref.current?.scrollTo(0, 0);
                        });
                    },
                    children: isExpanded ? 'Collapse code' : 'Expand code'
                })
            })
        ]
    });
}
function viewTransition(cb) {
    if ('startViewTransition' in document) // @ts-ignore
    document.startViewTransition(()=>(0, _reactDom.flushSync)(()=>cb()));
    else cb();
}

},{"0":"4oKuc","1":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","react-dom":"gC2PC","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fiXwD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "TableHeader", ()=>TableHeader);
parcelHelpers.export(exports, "TableColumn", ()=>TableColumn);
parcelHelpers.export(exports, "TableBody", ()=>TableBody);
parcelHelpers.export(exports, "TableRow", ()=>TableRow);
parcelHelpers.export(exports, "TableCell", ()=>TableCell);
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("../../../@react-spectrum/s2/style/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const table = " uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-c111 vx111 wb111 xb111 _xa111 _Fd111 _FezxGHba111 _FnuYUweb111 pt111 gX111 ob111 nb111 kb111 jb111 iq111 _kb111 hb111 mb111 lb111 _jf111 _Nc111 Pc111 __oe111 Za111";
const tableHeader = " gL111 ob111 nb111 sk111 snX20njb111";
const tableBody = " gX111";
const tableColumn = " Sf111 Rf111 _Wd111 wd111 xd111 _xa111 wX0cczbc111 xX0cczbc111 _xX0cczba111 iq111 _ka111 hb111 ma111 la111 _jf111 Fx111 _oa111";
const tableCell = function anonymous(props) {
    let rules = " ";
    rules += ' Sf111';
    rules += ' Rf111';
    if (props.align === "center") rules += ' Fnv111';
    rules += ' Tp111';
    if (props.align === "bottom") rules += ' Tne111';
    else if (props.align === "center") rules += ' Tnd111';
    else if (props.align === "top") rules += ' Tnp111';
    if (props.align === "bottom") rules += ' Qd111';
    else rules += ' Qkp111';
    if (props.align === "bottom") rules += ' Qnd111';
    else if (props.align === "center") rules += ' Qnd111';
    else if (props.align === "top") rules += ' Qne111';
    rules += ' _ka111';
    if (props.isBorderHidden) rules += ' ha111';
    else {
        rules += ' ha111';
        rules += ' hkb111';
        rules += ' hnb111';
        rules += ' hEbDz5a111';
    }
    rules += ' ma111';
    rules += ' la111';
    rules += ' _jf111';
    rules += ' iq111';
    rules += ' _oa111';
    rules += ' sb111';
    rules += ' snmv8xi111';
    return rules;
};
function Table(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
        ...props,
        className: table
    });
}
function TableHeader(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
        ...props,
        className: tableHeader
    });
}
function TableColumn(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
        ...props,
        className: tableColumn
    });
}
function TableBody(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
        ...props,
        className: tableBody
    });
}
function TableRow(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
        ...props
    });
}
function TableCell({ hideBorder, styles, ...props }) {
    let align = 'center';
    if (hideBorder) align = 'bottom';
    else if (props.colSpan) align = 'top';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
        ...props,
        className: (0, _runtime.mergeStyles)(tableCell({
            isBorderHidden: hideBorder,
            align
        }), styles)
    });
}

},{"0":"hDsP8","1":"hWyIx","2":"65rv1","3":"ailAX","4":"4bn6I","react/jsx-runtime":"2Is6Z","../../../@react-spectrum/s2/style/runtime":"8g9no","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hDsP8":[function() {},{}],"hWyIx":[function() {},{}],"65rv1":[function() {},{}],"ailAX":[function() {},{}],"4bn6I":[function() {},{}],"9lkLM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Displays a link with a popover to browse a TypeScript type definition.
 */ parcelHelpers.export(exports, "TypePopover", ()=>TypePopover);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _link = require("./Link");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const TypeLinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
function TypePopover({ name, children }) {
    let [breadcrumbs, setBreadcrumbs] = (0, _react.useState)([
        {
            id: 0,
            name,
            children
        }
    ]);
    let ctx = (0, _react.useContext)(TypeLinkContext);
    // If already inside a parent TypeLink, push onto the stack within the same popover.
    if (ctx) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.ColorLink), {
        onPress: ()=>ctx.push(name, children),
        children: name
    });
    // Otherwise render the root popover with breadcrumbs for the stack of visited links.
    let cur = breadcrumbs.at(-1);
    let push = (name, children)=>{
        setBreadcrumbs((breadcrumbs)=>[
                ...breadcrumbs,
                {
                    id: breadcrumbs.length,
                    name,
                    children
                }
            ]);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.DialogTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.ColorLink), {
                className: " p37ZLpd111",
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Popover), {
                styles: " L6kvVdc111",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " Te111 Qe111 Se111 Re111",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Breadcrumbs), {
                            size: "L",
                            onAction: (id)=>setBreadcrumbs(breadcrumbs.slice(0, Number(id) + 1)),
                            styles: " GC111",
                            children: breadcrumbs.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Breadcrumb), {
                                    id: item.id,
                                    children: item.name
                                }, item.id))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(TypeLinkContext.Provider, {
                            value: {
                                push
                            },
                            children: cur.children
                        })
                    ]
                })
            })
        ]
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","./Link":"el6b6","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Gcxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "H2", ()=>H2);
parcelHelpers.export(exports, "H3", ()=>H3);
parcelHelpers.export(exports, "H4", ()=>H4);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _link = require("@react-spectrum/s2/icons/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
'use client';
function anchorId(children) {
    return children.replace(/\s/g, '-').replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase();
}
function AnchorLink({ anchorId, isHovered, level, headingText }) {
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)({
        within: true
    });
    const href = `#${anchorId}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        ...focusProps,
        className: function anonymous(props) {
            let rules = " ";
            if (props.isFocusVisible) rules += ' _Ib111';
            else if (props.isHovered) rules += ' _Ib111';
            else rules += ' _Ia111';
            if (props.level === "4") rules += ' Is111';
            else if (props.level === "3") rules += ' Is111';
            else rules += ' Iv111';
            rules += ' YK0XD1b111';
            rules += ' Xb111';
            rules += ' _2b111';
            return rules;
        }({
            isHovered,
            isFocusVisible,
            level
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
            href: href,
            "aria-label": `Link to ${headingText}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                styles: " Gs111 Zu111 Ft111",
                UNSAFE_style: {
                    marginBottom: level === 3 || level === 4 ? 0 : undefined
                }
            })
        })
    });
}
function H2({ children, ...props }) {
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let id = anchorId(children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
        ...props,
        id: id,
        className: " uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-lcY1Ce111 vx111 we111 xe111 _xa111 wX0cczbd111 xX0cczbd111 _xX0cczba111 wezxGHbd111 xezxGHbd111 _xezxGHba111 wfe111 xfe111 _xfa111 wfX0cczbd111 xfX0cczbd111 _xfX0cczba111 wfezxGHbd111 xfezxGHbd111 _xfezxGHba111 _Fd111 _FezxGHba111 _FnuYUweb111 po111 JI111 GA111",
        ...hoverProps,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnchorLink, {
                anchorId: id,
                isHovered: isHovered,
                level: 2,
                headingText: children
            })
        ]
    });
}
function H3({ children, ...props }) {
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let id = anchorId(children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
        ...props,
        id: id,
        className: " uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-g111 vx111 we111 xe111 _xa111 wX0cczbd111 xX0cczbd111 _xX0cczba111 wezxGHbd111 xezxGHbd111 _xezxGHba111 wfe111 xfe111 _xfa111 wfX0cczbd111 xfX0cczbd111 _xfX0cczba111 wfezxGHbd111 xfezxGHbd111 _xfezxGHba111 _Fd111 _FezxGHba111 _FnuYUweb111 po111 JG111 GA111",
        ...hoverProps,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnchorLink, {
                anchorId: id,
                isHovered: isHovered,
                level: 3,
                headingText: children
            })
        ]
    });
}
function H4({ children, ...props }) {
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let id = anchorId(children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
        ...props,
        id: id,
        className: " uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-f111 vx111 we111 xe111 _xa111 wX0cczbd111 xX0cczbd111 _xX0cczba111 wezxGHbd111 xezxGHbd111 _xezxGHba111 wfe111 xfe111 _xfa111 wfX0cczbd111 xfX0cczbd111 _xfX0cczba111 wfezxGHbd111 xfezxGHbd111 _xfezxGHba111 _Fd111 _FezxGHba111 _FnuYUweb111 po111",
        ...hoverProps,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnchorLink, {
                anchorId: id,
                isHovered: isHovered,
                level: 4,
                headingText: children
            })
        ]
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","@react-spectrum/s2/icons/Link":"ivjAn","react":"a1TxN","@react-aria/focus":"3CsF4","@react-aria/interactions":"5IMN1","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b3IWk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Header);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _adobeLogo = require("./icons/AdobeLogo");
var _alertTriangle = require("@react-spectrum/s2/icons/AlertTriangle");
var _alertTriangleDefault = parcelHelpers.interopDefault(_alertTriangle);
var _reactDom = require("react-dom");
var _githubLogo = require("./icons/GithubLogo");
var _githubLogoDefault = parcelHelpers.interopDefault(_githubLogo);
var _internationalizedLogo = require("./icons/InternationalizedLogo");
var _markdownMenu = require("./MarkdownMenu");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaLogo = require("./icons/ReactAriaLogo");
var _searchMenu = require("./SearchMenu");
var _searchMenuDefault = parcelHelpers.interopDefault(_searchMenu);
'use client';
function getButtonText(currentPage) {
    if (currentPage.url.includes('react-aria')) return 'React Aria';
    else if (currentPage.url.includes('react-internationalized')) return 'React Internationalized';
    return 'React Spectrum';
}
function getButtonIcon(currentPage) {
    if (currentPage.url.includes('react-aria')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {});
    else if (currentPage.url.includes('react-internationalized')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _internationalizedLogo.InternationalizedLogo), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {});
}
function Header(props) {
    const { pages, currentPage } = props;
    const [searchOpen, setSearchOpen] = (0, _react.useState)(false);
    const searchMenuId = (0, _react.useId)();
    let toggleShowSearchMenu = ()=>{
        if (!document.startViewTransition) {
            setSearchOpen((prev)=>!prev);
            return;
        }
        document.startViewTransition(()=>{
            (0, _reactDom.flushSync)(()=>{
                setSearchOpen((prev)=>!prev);
            });
        });
    };
    let closeSearchMenu = ()=>{
        if (!document.startViewTransition) {
            setSearchOpen(false);
            return;
        }
        document.startViewTransition(()=>{
            (0, _reactDom.flushSync)(()=>{
                setSearchOpen(false);
            });
        });
    };
    let handleActionButtonKeyDown = (e)=>{
        if (e.key === 'ArrowDown' && !searchOpen) {
            e.preventDefault();
            toggleShowSearchMenu();
        }
    };
    const ChevronDownIcon = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 20,
            height: 20,
            ...props,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, #222)",
                d: "M3.755 7.243a.748.748 0 0 1 1.06-.02l5.183 4.986 5.197-4.999a.749.749 0 1 1 1.04 1.08l-5.717 5.5a.747.747 0 0 1-1.04 0L3.776 8.303a.746.746 0 0 1-.02-1.06Z"
            })
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
            className: " Za111 sk111 spd111 _Ca111",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " Za111 se111 Duowq111 eb111",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " __Ad111",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButton), {
                            "aria-label": "Open menu and search",
                            "aria-expanded": searchOpen,
                            "aria-controls": searchOpen ? searchMenuId : undefined,
                            size: "XL",
                            isQuiet: true,
                            onPress: toggleShowSearchMenu,
                            onKeyDown: handleActionButtonKeyDown,
                            UNSAFE_style: {
                                paddingInlineStart: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: " sd111 eb111",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: " Js111",
                                            style: {
                                                viewTransitionName: !searchOpen ? 'search-menu-icon' : 'none'
                                            },
                                            children: getButtonIcon(currentPage)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: " uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-f111 vx111 wb111 xb111 _xa111 _Fd111 _FezxGHba111 _FnuYUweb111 pt111 Iv111",
                                            style: {
                                                viewTransitionName: !searchOpen ? 'search-menu-label' : 'none'
                                            },
                                            children: getButtonText(currentPage)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChevronDownIcon, {
                                    className: " Zl111"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchMenuDefault.default), {
                        pages: pages,
                        currentPage: currentPage,
                        toggleShowSearchMenu: toggleShowSearchMenu,
                        closeSearchMenu: closeSearchMenu,
                        isSearchOpen: searchOpen,
                        overlayId: searchMenuId
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " sd111 eb111 Ub111 qb111 __Ac111",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Badge), {
                                variant: "informative",
                                size: "M",
                                styles: " Hv111",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertTriangleDefault.default), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        children: "Beta Preview"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownMenu.MarkdownMenu), {
                                url: currentPage.url
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                                "aria-label": "React Spectrum GitHub repo",
                                size: "L",
                                isQuiet: true,
                                onPress: ()=>window.open('https://github.com/adobe/react-spectrum', '_blank', 'noopener,noreferrer'),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _githubLogoDefault.default), {})
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","7":"4oKuc","8":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","./icons/AdobeLogo":"5Bj5G","@react-spectrum/s2/icons/AlertTriangle":"jyuVv","react-dom":"gC2PC","./icons/GithubLogo":"dcOQ5","./icons/InternationalizedLogo":"ge2ja","./MarkdownMenu":"8BIYE","react":"a1TxN","./icons/ReactAriaLogo":"iQPne","./SearchMenu":"7ohac","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dcOQ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: " pm111",
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 19",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M9.969 0C4.457 0 0 4.355 0 9.742c0 4.305 2.855 7.95 6.816 9.238.497.098.676-.207.676-.464 0-.227-.015-1-.015-1.809-2.774.582-3.352-1.16-3.352-1.16-.445-1.129-1.105-1.418-1.105-1.418-.907-.598.066-.598.066-.598 1.008.063 1.535 1 1.535 1 .89 1.485 2.328 1.063 2.906.805.082-.629.348-1.063.63-1.305-2.216-.226-4.544-1.066-4.544-4.804 0-1.067.399-1.938 1.024-2.614-.098-.242-.446-1.242.101-2.582 0 0 .84-.258 2.739 1 .812-.21 1.652-.32 2.492-.32.844 0 1.703.11 2.492.32 1.898-1.258 2.742-1 2.742-1 .543 1.34.2 2.34.098 2.582.644.676 1.023 1.547 1.023 2.614 0 3.738-2.328 4.562-4.554 4.804.363.305.675.887.675 1.805 0 1.309-.015 2.355-.015 2.68 0 .257.183.562.675.464 3.961-1.289 6.82-4.933 6.82-9.238C19.942 4.355 15.47 0 9.97 0m0 0",
            className: " Vh3TDrc111 tloq9qb111",
            style: {
                stroke: 'none',
                fillRule: 'evenodd',
                fillOpacity: 1
            }
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _s2.createIcon)(ForwardRef);

},{"0":"kqkjD","1":"bCkQx","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kqkjD":[function() {},{}],"bCkQx":[function() {},{}],"8BIYE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkdownMenu", ()=>MarkdownMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _copy = require("@react-spectrum/s2/icons/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function MarkdownMenu({ url }) {
    let mdUrl = (url ?? '').replace(/\.html?$/i, '') + '.md';
    let onAction = (0, _react.useCallback)(async (key)=>{
        let action = String(key);
        switch(action){
            case 'copy':
                if (typeof navigator !== 'undefined' && navigator.clipboard) try {
                    let response = await fetch(mdUrl);
                    // Fallback to copying the URL if the request fails or isn't ok.
                    if (!response.ok) throw new Error('Failed to fetch markdown');
                    let markdown = await response.text();
                    await navigator.clipboard.writeText(markdown);
                } catch  {
                // ignore failures (e.g., insecure context, network errors)
                }
                break;
            case 'view':
                if (typeof window !== 'undefined') window.open(mdUrl, '_blank');
                break;
        }
    }, [
        mdUrl
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                size: "L",
                isQuiet: true,
                "aria-label": "Markdown options",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                onAction: onAction,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                        id: "copy",
                        children: "Copy Page as Markdown"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                        id: "view",
                        children: "View Page as Markdown"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","@react-spectrum/s2/icons/Copy":"6imrL","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fM2eg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileHeader", ()=>MobileHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _adobeLogo = require("./AdobeLogo");
var _reactAriaComponents = require("react-aria-components");
var _menuHamburger = require("@react-spectrum/s2/icons/MenuHamburger");
var _menuHamburgerDefault = parcelHelpers.interopDefault(_menuHamburger);
var _modal = require("../../../@react-spectrum/s2/src/Modal");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
let fadeOut = "_2av0mc";
let shadow = "XYaG5b";
let fadeIn = "nToi3b";
const animation = {
    animationDuration: '1s',
    animationPlayState: {
        default: 'paused',
        '@supports (animation-timeline: scroll())': 'running'
    },
    animationFillMode: 'both',
    transitionTimingFunction: 'linear'
};
const animationRange = '24px 64px';
const dialogStyle = function anonymous(props) {
    let rules = " ";
    if (props.padding === "none") rules += ' Td111';
    else if (props.padding === "default") {
        rules += ' Th111';
        rules += ' Tnk111';
    }
    if (props.padding === "none") rules += ' Qd111';
    else if (props.padding === "default") {
        rules += ' Qh111';
        rules += ' Qnk111';
    }
    if (props.padding === "none") rules += ' Sd111';
    else if (props.padding === "default") {
        rules += ' Sh111';
        rules += ' Snk111';
    }
    if (props.padding === "none") rules += ' Rd111';
    else if (props.padding === "default") {
        rules += ' Rh111';
        rules += ' Rnk111';
    }
    rules += ' _oa111';
    rules += ' _Le111';
    rules += ' oi111';
    rules += ' ni111';
    rules += ' ki111';
    rules += ' ji111';
    rules += ' _Na111';
    rules += ' Pa111';
    rules += ' _Pc111';
    rules += ' Za111';
    rules += ' Fb111';
    rules += ' L40ub4c111';
    rules += ' K40ub4c111';
    return rules;
};
const MobileCustomDialog = /*#__PURE__*/ (0, _react.forwardRef)(function MobileCustomDialog(props, ref) {
    let { size, isDismissible, isKeyboardDismissDisabled, padding = 'default' } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
        size: size,
        isDismissable: isDismissible,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        style: {
            zIndex: 100
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Dialog), {
            ...props,
            ref: ref,
            className: dialogStyle({
                padding
            }),
            children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayTriggerStateContext).Provider, {
                    value: null,
                    children: children
                }))
        })
    });
});
function MobileHeader({ toc, nav }) {
    let ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        // Tiny polyfill for scroll driven animations.
        // Element must have animationDuration: 1s and animationPlayState: paused.
        if (!CSS.supports('(animation-timeline: scroll())') && ref.current) {
            let [start, end] = animationRange.split(' ').map((v)=>parseInt(v, 10));
            let animations = ref.current.getAnimations({
                subtree: true
            });
            let onScroll = ()=>{
                // Calculate animation time based on percentage of animationRange * duration.
                let time = Math.max(0, Math.min(end, window.scrollY - start) / (end - start)) * 1000;
                for (let animation of animations)animation.currentTime = time;
            };
            window.addEventListener('scroll', onScroll, {
                passive: true
            });
            return ()=>window.removeEventListener('scroll', onScroll);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        className: " _Pe111 Wr111 Za111 Te111 Qe111 Se111 Re111 _oa111 sd111 spk111 eb111 Ug111 qg111 _9c111 _Nb111 Pb111 -SQSLJb-gX111 -z0sPGb-g_g111 -_5sGM4c-_nb111 _eL2Ky111 -aGzJ7c-1Za9w111 -aGzJ7c-Qlsn9mNcQZb111 _fb111 _2d111",
        style: {
            animationName: shadow,
            animationTimeline: 'scroll()',
            animationRange
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " sd111 Ug111 qg111 eb111 _ub111",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: " uk111 uch111 udi111 uea111 ugb111 uhd111 uje111 u2NhKxcl111 uic111 -_6BNtrc-f111 vx111 we111 xe111 _xa111 wX0cczbd111 xX0cczbd111 _xX0cczba111 wezxGHbd111 xezxGHbd111 _xezxGHba111 wfe111 xfe111 _xfa111 wfX0cczbd111 xfX0cczbd111 _xfX0cczba111 wfezxGHbd111 xfezxGHbd111 _xfezxGHba111 _Fd111 _FezxGHba111 _FnuYUweb111 po111 Jy111 Gy111 _eL2Ky111 -aGzJ7c-1Za9w111 -aGzJ7c-Qlsn9mNcQZb111 _fb111 _2d111",
                        style: {
                            animationName: fadeOut,
                            animationTimeline: 'scroll()',
                            animationRange
                        },
                        children: "React Aria"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " _eL2Ky111 -aGzJ7c-1Za9w111 -aGzJ7c-Qlsn9mNcQZb111 _fb111 _2d111 _Pa111 _EF111 -_7PloMd-CoPtrc111 __Ya111",
                style: {
                    animationName: fadeIn,
                    animationTimeline: 'scroll()',
                    animationRange
                },
                children: toc
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.DialogTrigger), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                        "aria-label": "Navigation",
                        isQuiet: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuHamburgerDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(MobileCustomDialog, {
                        size: "fullscreenTakeover",
                        padding: "none",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CloseButton), {
                                styles: " _Pb111 Wt111 _zt111 _9ZEMfn111"
                            }),
                            nav
                        ]
                    })
                ]
            })
        ]
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","7":"4oKuc","8":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"5H6IX","./AdobeLogo":"eQj1e","react-aria-components":"2Emk2","@react-spectrum/s2/icons/MenuHamburger":"bneuv","../../../@react-spectrum/s2/src/Modal":"iUTZq","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eQj1e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdobeLogo", ()=>AdobeLogo);
var _jsxRuntime = require("react/jsx-runtime");
const AdobeLogo = ({ className = '', size = 32 })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: className,
        style: {
            width: size,
            height: size
        },
        viewBox: "0 0 501.71 444.05",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m297.58 444.05-36.45-101.4h-91.46l76.87-193.53 116.65 294.93h138.52L316.8 0H186.23L0 444.05h297.58z",
            fill: "#eb1000"
        })
    });
};

},{"react/jsx-runtime":"2Is6Z","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dNwuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisclosureRow", ()=>DisclosureRow);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _chevronRight = require("@react-spectrum/s2/icons/ChevronRight");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _table = require("./Table");
var _reactAria = require("react-aria");
var _reactStately = require("react-stately");
var _react = require("react");
'use client';
const tableCell = " Td111 Qd111 Sd111 Rd111 _ka111 hb111 hEbDz5a111 ma111 la111 _jf111 iq111 _oa111 sb111 snmv8xi111";
const buttonStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf111';
    else rules += ' _Le111';
    rules += ' Oh111';
    rules += ' _Mc111';
    rules += ' _Kb111';
    rules += ' uk111';
    rules += ' uch111';
    rules += ' udi111';
    rules += ' uea111';
    rules += ' ugb111';
    rules += ' uhd111';
    rules += ' uje111';
    rules += ' u2NhKxcl111';
    rules += ' uic111';
    rules += ' -_6BNtrc-c111';
    rules += ' vx111';
    rules += ' wd111';
    rules += ' xd111';
    rules += ' _xa111';
    rules += ' wX0cczbc111';
    rules += ' xX0cczbc111';
    rules += ' _xX0cczba111';
    rules += ' wfd111';
    rules += ' xfd111';
    rules += ' _xfa111';
    rules += ' wfX0cczbc111';
    rules += ' xfX0cczbc111';
    rules += ' _xfX0cczba111';
    rules += ' _Fd111';
    rules += ' _FezxGHba111';
    rules += ' _FnuYUweb111';
    rules += ' pt111';
    rules += ' Za111';
    rules += ' Fb111';
    if (props.isExpanded) {
        if (props.isPressed) rules += ' gE111';
        else if (props.isFocusVisible) rules += ' gF111';
        else if (props.isHovered) rules += ' gF111';
        else rules += ' gH111';
    } else if (props.isPressed) rules += ' gE111';
    else if (props.isFocusVisible) rules += ' gH111';
    else if (props.isHovered) rules += ' gH111';
    else rules += ' g9111';
    rules += ' _ka111';
    rules += ' ha111';
    rules += ' ma111';
    rules += ' la111';
    rules += ' Sf111';
    rules += ' Rf111';
    rules += ' Tt111';
    rules += ' Qt111';
    rules += ' sd111';
    rules += ' eb111';
    rules += ' Ub111';
    rules += ' qb111';
    rules += ' Yd111';
    rules += ' Xb111';
    rules += ' _2b111';
    rules += ' _Wd111';
    rules += ' __ca111';
    return rules;
};
const chevronStyles = function anonymous(props) {
    let rules = " ";
    if (props.isExpanded) rules += ' _Sd111';
    else if (props.isRTL) rules += ' _Sc111';
    rules += ' Yd111';
    rules += ' Xb111';
    rules += ' _2b111';
    rules += ' _va111';
    rules += ' -_8sjo0b-tf111';
    rules += ' Zu111';
    rules += ' Ft111';
    return rules;
};
function DisclosureRow({ title, children, defaultExpanded }) {
    let state = (0, _reactStately.useDisclosureState)({
        defaultExpanded
    });
    let ref = (0, _react.useRef)(null);
    let { buttonProps } = (0, _reactAria.useDisclosure)({}, state, ref);
    delete buttonProps['aria-controls']; // there is no panel element in this implementation
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableBody), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    colSpan: 3,
                    className: tableCell,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
                        ...buttonProps,
                        className: (p)=>buttonStyles({
                                ...p,
                                isExpanded: state.isExpanded
                            }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronRightDefault.default), {
                                styles: chevronStyles({
                                    isExpanded: state.isExpanded
                                })
                            }),
                            title
                        ]
                    })
                })
            }),
            state.isExpanded && children
        ]
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","react/jsx-runtime":"2Is6Z","react-aria-components":"2Emk2","@react-spectrum/s2/icons/ChevronRight":"kmqkh","./Table":"fiXwD","react-aria":"7txSB","react-stately":"eRJVr","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {}, "./", "/reactspectrum/099b69a95ef0b5e82636845f8184400c7e838a88/s2-docs/")

//# sourceMappingURL=pages.129cce0c.js.map
